export const mergedData = [
  {
    "base_pwsid": "MI0000011",
    "resolved_pwsid": "MI0000011",
    "system_name": "ACME TOWNSHIP - HOPE VILLAGE",
    "display_name": "ACME TOWNSHIP - HOPE VILLAGE",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000011",
    "resolved_pwsid": "MI0000011",
    "system_name": "ACME TOWNSHIP - HOPE VILLAGE",
    "display_name": "ACME TOWNSHIP - HOPE VILLAGE",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000011",
    "resolved_pwsid": "MI0000011",
    "system_name": "ACME TOWNSHIP - HOPE VILLAGE",
    "display_name": "ACME TOWNSHIP - HOPE VILLAGE",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000012",
    "resolved_pwsid": "MI0000012",
    "system_name": "ADA TOWNSHIP",
    "display_name": "ADA TOWNSHIP",
    "county": "KENT",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000012",
    "resolved_pwsid": "MI0000012",
    "system_name": "ADA TOWNSHIP",
    "display_name": "ADA TOWNSHIP",
    "county": "KENT",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000012",
    "resolved_pwsid": "MI0000012",
    "system_name": "ADA TOWNSHIP",
    "display_name": "ADA TOWNSHIP",
    "county": "KENT",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000012",
    "resolved_pwsid": "MI0000012",
    "system_name": "ADA TOWNSHIP",
    "display_name": "ADA TOWNSHIP",
    "county": "KENT",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000012",
    "resolved_pwsid": "MI0000012",
    "system_name": "ADA TOWNSHIP",
    "display_name": "ADA TOWNSHIP",
    "county": "KENT",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000012",
    "resolved_pwsid": "MI0000012",
    "system_name": "ADA TOWNSHIP",
    "display_name": "ADA TOWNSHIP",
    "county": "KENT",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000012",
    "resolved_pwsid": "MI0000012",
    "system_name": "ADA TOWNSHIP",
    "display_name": "ADA TOWNSHIP",
    "county": "KENT",
    "monitoring_end_date": "2024-06-30",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000012",
    "resolved_pwsid": "MI0000012",
    "system_name": "ADA TOWNSHIP",
    "display_name": "ADA TOWNSHIP",
    "county": "KENT",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000012",
    "resolved_pwsid": "MI0000012",
    "system_name": "ADA TOWNSHIP",
    "display_name": "ADA TOWNSHIP",
    "county": "KENT",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0000013",
    "resolved_pwsid": "MI0000013",
    "system_name": "LOCHENHEATH",
    "display_name": "LOCHENHEATH",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2026-06-30",
    "year": 2026,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000020",
    "resolved_pwsid": "MI0000020",
    "system_name": "ADAMS TOWNSHIP",
    "display_name": "ADAMS TOWNSHIP",
    "county": "HOUGHTON",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000020",
    "resolved_pwsid": "MI0000020",
    "system_name": "ADAMS TOWNSHIP",
    "display_name": "ADAMS TOWNSHIP",
    "county": "HOUGHTON",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000020",
    "resolved_pwsid": "MI0000020",
    "system_name": "ADAMS TOWNSHIP",
    "display_name": "ADAMS TOWNSHIP",
    "county": "HOUGHTON",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000020",
    "resolved_pwsid": "MI0000020",
    "system_name": "ADAMS TOWNSHIP",
    "display_name": "ADAMS TOWNSHIP",
    "county": "HOUGHTON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000020",
    "resolved_pwsid": "MI0000020",
    "system_name": "ADAMS TOWNSHIP",
    "display_name": "ADAMS TOWNSHIP",
    "county": "HOUGHTON",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 154,
    "total_to_identify_or_replace": 154,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0000030",
    "resolved_pwsid": "MI0000030",
    "system_name": "ADDISON",
    "display_name": "ADDISON",
    "county": "LENAWEE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000030",
    "resolved_pwsid": "MI0000030",
    "system_name": "ADDISON",
    "display_name": "ADDISON",
    "county": "LENAWEE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000030",
    "resolved_pwsid": "MI0000030",
    "system_name": "ADDISON",
    "display_name": "ADDISON",
    "county": "LENAWEE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000030",
    "resolved_pwsid": "MI0000030",
    "system_name": "ADDISON",
    "display_name": "ADDISON",
    "county": "LENAWEE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000030",
    "resolved_pwsid": "MI0000030",
    "system_name": "ADDISON",
    "display_name": "ADDISON",
    "county": "LENAWEE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000040",
    "resolved_pwsid": "MI0000040",
    "system_name": "ADRIAN",
    "display_name": "ADRIAN",
    "county": "LENAWEE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000040",
    "resolved_pwsid": "MI0000040",
    "system_name": "ADRIAN",
    "display_name": "ADRIAN",
    "county": "LENAWEE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000040",
    "resolved_pwsid": "MI0000040",
    "system_name": "ADRIAN",
    "display_name": "ADRIAN",
    "county": "LENAWEE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 58,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000040",
    "resolved_pwsid": "MI0000040",
    "system_name": "ADRIAN",
    "display_name": "ADRIAN",
    "county": "LENAWEE",
    "monitoring_end_date": "",
    "year": 2021,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 57,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000040",
    "resolved_pwsid": "MI0000040",
    "system_name": "ADRIAN",
    "display_name": "ADRIAN",
    "county": "LENAWEE",
    "monitoring_end_date": "",
    "year": 2022,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 124,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000040",
    "resolved_pwsid": "MI0000040",
    "system_name": "ADRIAN",
    "display_name": "ADRIAN",
    "county": "LENAWEE",
    "monitoring_end_date": "",
    "year": 2024,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 88,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000040",
    "resolved_pwsid": "MI0000040",
    "system_name": "ADRIAN",
    "display_name": "ADRIAN",
    "county": "LENAWEE",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 190,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000045",
    "resolved_pwsid": "MI0000045",
    "system_name": "BROOKDALE ADRIAN",
    "display_name": "BROOKDALE ADRIAN",
    "county": "LENAWEE",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 13,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000045",
    "resolved_pwsid": "MI0000045",
    "system_name": "BROOKDALE ADRIAN",
    "display_name": "BROOKDALE ADRIAN",
    "county": "LENAWEE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000045",
    "resolved_pwsid": "MI0000045",
    "system_name": "BROOKDALE ADRIAN",
    "display_name": "BROOKDALE ADRIAN",
    "county": "LENAWEE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000045",
    "resolved_pwsid": "MI0000045",
    "system_name": "BROOKDALE ADRIAN",
    "display_name": "BROOKDALE ADRIAN",
    "county": "LENAWEE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0000048",
    "resolved_pwsid": "MI0000048",
    "system_name": "RICHLYN MANOR",
    "display_name": "RICHLYN MANOR",
    "county": "LENAWEE",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000048",
    "resolved_pwsid": "MI0000048",
    "system_name": "RICHLYN MANOR",
    "display_name": "RICHLYN MANOR",
    "county": "LENAWEE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000048",
    "resolved_pwsid": "MI0000048",
    "system_name": "RICHLYN MANOR",
    "display_name": "RICHLYN MANOR",
    "county": "LENAWEE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000048",
    "resolved_pwsid": "MI0000048",
    "system_name": "RICHLYN MANOR",
    "display_name": "RICHLYN MANOR",
    "county": "LENAWEE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0000050",
    "resolved_pwsid": "MI0000050",
    "system_name": "AHMEEK",
    "display_name": "AHMEEK",
    "county": "KEWEENAW",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000050",
    "resolved_pwsid": "MI0000050",
    "system_name": "AHMEEK",
    "display_name": "AHMEEK",
    "county": "KEWEENAW",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000050",
    "resolved_pwsid": "MI0000050",
    "system_name": "AHMEEK",
    "display_name": "AHMEEK",
    "county": "KEWEENAW",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000050",
    "resolved_pwsid": "MI0000050",
    "system_name": "AHMEEK",
    "display_name": "AHMEEK",
    "county": "KEWEENAW",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 9,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 9,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0000070",
    "resolved_pwsid": "MI0000070",
    "system_name": "AKRON",
    "display_name": "AKRON",
    "county": "TUSCOLA",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000070",
    "resolved_pwsid": "MI0000070",
    "system_name": "AKRON",
    "display_name": "AKRON",
    "county": "TUSCOLA",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000070",
    "resolved_pwsid": "MI0000070",
    "system_name": "AKRON",
    "display_name": "AKRON",
    "county": "TUSCOLA",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000070",
    "resolved_pwsid": "MI0000070",
    "system_name": "AKRON",
    "display_name": "AKRON",
    "county": "TUSCOLA",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0000072",
    "resolved_pwsid": "MI0000072",
    "system_name": "AKRON TOWNSHIP",
    "display_name": "AKRON TOWNSHIP",
    "county": "TUSCOLA",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000072",
    "resolved_pwsid": "MI0000072",
    "system_name": "AKRON TOWNSHIP",
    "display_name": "AKRON TOWNSHIP",
    "county": "TUSCOLA",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000072",
    "resolved_pwsid": "MI0000072",
    "system_name": "AKRON TOWNSHIP",
    "display_name": "AKRON TOWNSHIP",
    "county": "TUSCOLA",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000072",
    "resolved_pwsid": "MI0000072",
    "system_name": "AKRON TOWNSHIP",
    "display_name": "AKRON TOWNSHIP",
    "county": "TUSCOLA",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000072",
    "resolved_pwsid": "MI0000072",
    "system_name": "AKRON TOWNSHIP",
    "display_name": "AKRON TOWNSHIP",
    "county": "TUSCOLA",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000072",
    "resolved_pwsid": "MI0000072",
    "system_name": "AKRON TOWNSHIP",
    "display_name": "AKRON TOWNSHIP",
    "county": "TUSCOLA",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000072",
    "resolved_pwsid": "MI0000072",
    "system_name": "AKRON TOWNSHIP",
    "display_name": "AKRON TOWNSHIP",
    "county": "TUSCOLA",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000082",
    "resolved_pwsid": "MI0000082",
    "system_name": "ALABASTER TOWNSHIP",
    "display_name": "ALABASTER TOWNSHIP",
    "county": "IOSCO",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000082",
    "resolved_pwsid": "MI0000082",
    "system_name": "ALABASTER TOWNSHIP",
    "display_name": "ALABASTER TOWNSHIP",
    "county": "IOSCO",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000082",
    "resolved_pwsid": "MI0000082",
    "system_name": "ALABASTER TOWNSHIP",
    "display_name": "ALABASTER TOWNSHIP",
    "county": "IOSCO",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000082",
    "resolved_pwsid": "MI0000082",
    "system_name": "ALABASTER TOWNSHIP",
    "display_name": "ALABASTER TOWNSHIP",
    "county": "IOSCO",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0000088",
    "resolved_pwsid": "MI0000088",
    "system_name": "ALBEE TOWNSHIP",
    "display_name": "ALBEE TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000088",
    "resolved_pwsid": "MI0000088",
    "system_name": "ALBEE TOWNSHIP",
    "display_name": "ALBEE TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000088",
    "resolved_pwsid": "MI0000088",
    "system_name": "ALBEE TOWNSHIP",
    "display_name": "ALBEE TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000088",
    "resolved_pwsid": "MI0000088",
    "system_name": "ALBEE TOWNSHIP",
    "display_name": "ALBEE TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000088",
    "resolved_pwsid": "MI0000088",
    "system_name": "ALBEE TOWNSHIP",
    "display_name": "ALBEE TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000088",
    "resolved_pwsid": "MI0000088",
    "system_name": "ALBEE TOWNSHIP",
    "display_name": "ALBEE TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000088",
    "resolved_pwsid": "MI0000088",
    "system_name": "ALBEE TOWNSHIP",
    "display_name": "ALBEE TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000090",
    "resolved_pwsid": "MI0000090",
    "system_name": "FORD FORESTRY CENTER",
    "display_name": "FORD FORESTRY CENTER",
    "county": "BARAGA",
    "monitoring_end_date": "2023-06-30",
    "year": 2023,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000090",
    "resolved_pwsid": "MI0000090",
    "system_name": "FORD FORESTRY CENTER",
    "display_name": "FORD FORESTRY CENTER",
    "county": "BARAGA",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000090",
    "resolved_pwsid": "MI0000090",
    "system_name": "FORD FORESTRY CENTER",
    "display_name": "FORD FORESTRY CENTER",
    "county": "BARAGA",
    "monitoring_end_date": "2024-06-30",
    "year": 2024,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000100",
    "resolved_pwsid": "MI0000100",
    "system_name": "ALBION",
    "display_name": "ALBION",
    "county": "CALHOUN",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000100",
    "resolved_pwsid": "MI0000100",
    "system_name": "ALBION",
    "display_name": "ALBION",
    "county": "CALHOUN",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000100",
    "resolved_pwsid": "MI0000100",
    "system_name": "ALBION",
    "display_name": "ALBION",
    "county": "CALHOUN",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000100",
    "resolved_pwsid": "MI0000100",
    "system_name": "ALBION",
    "display_name": "ALBION",
    "county": "CALHOUN",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000100",
    "resolved_pwsid": "MI0000100",
    "system_name": "ALBION",
    "display_name": "ALBION",
    "county": "CALHOUN",
    "monitoring_end_date": "2021-06-30",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000100",
    "resolved_pwsid": "MI0000100",
    "system_name": "ALBION",
    "display_name": "ALBION",
    "county": "CALHOUN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000100",
    "resolved_pwsid": "MI0000100",
    "system_name": "ALBION",
    "display_name": "ALBION",
    "county": "CALHOUN",
    "monitoring_end_date": "2022-06-30",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000100",
    "resolved_pwsid": "MI0000100",
    "system_name": "ALBION",
    "display_name": "ALBION",
    "county": "CALHOUN",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000100",
    "resolved_pwsid": "MI0000100",
    "system_name": "ALBION",
    "display_name": "ALBION",
    "county": "CALHOUN",
    "monitoring_end_date": "2023-06-30",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 4,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000100",
    "resolved_pwsid": "MI0000100",
    "system_name": "ALBION",
    "display_name": "ALBION",
    "county": "CALHOUN",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000100",
    "resolved_pwsid": "MI0000100",
    "system_name": "ALBION",
    "display_name": "ALBION",
    "county": "CALHOUN",
    "monitoring_end_date": "2024-06-30",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 3,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000100",
    "resolved_pwsid": "MI0000100",
    "system_name": "ALBION",
    "display_name": "ALBION",
    "county": "CALHOUN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000100",
    "resolved_pwsid": "MI0000100",
    "system_name": "ALBION",
    "display_name": "ALBION",
    "county": "CALHOUN",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 75,
    "inventory_lead": 609,
    "inventory_gpcl": 18,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 627,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0000110",
    "resolved_pwsid": "MI0000110",
    "system_name": "ALGONAC, CITY OF",
    "display_name": "ALGONAC, CITY OF",
    "county": "ST CLAIR",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000110",
    "resolved_pwsid": "MI0000110",
    "system_name": "ALGONAC, CITY OF",
    "display_name": "ALGONAC, CITY OF",
    "county": "ST. CLAIR",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000110",
    "resolved_pwsid": "MI0000110",
    "system_name": "ALGONAC, CITY OF",
    "display_name": "ALGONAC, CITY OF",
    "county": "ST. CLAIR",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 2,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000110",
    "resolved_pwsid": "MI0000110",
    "system_name": "ALGONAC, CITY OF",
    "display_name": "ALGONAC, CITY OF",
    "county": "ST CLAIR",
    "monitoring_end_date": "",
    "year": 2022,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000120",
    "resolved_pwsid": "MI0000120",
    "system_name": "ALLEGAN",
    "display_name": "ALLEGAN",
    "county": "ALLEGAN",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000120",
    "resolved_pwsid": "MI0000120",
    "system_name": "ALLEGAN",
    "display_name": "ALLEGAN",
    "county": "ALLEGAN",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000120",
    "resolved_pwsid": "MI0000120",
    "system_name": "ALLEGAN",
    "display_name": "ALLEGAN",
    "county": "ALLEGAN",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000120",
    "resolved_pwsid": "MI0000120",
    "system_name": "ALLEGAN",
    "display_name": "ALLEGAN",
    "county": "ALLEGAN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": 12,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000120",
    "resolved_pwsid": "MI0000120",
    "system_name": "ALLEGAN",
    "display_name": "ALLEGAN",
    "county": "ALLEGAN",
    "monitoring_end_date": "2022-06-30",
    "year": 2022,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": 17,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000120",
    "resolved_pwsid": "MI0000120",
    "system_name": "ALLEGAN",
    "display_name": "ALLEGAN",
    "county": "ALLEGAN",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 243,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000120",
    "resolved_pwsid": "MI0000120",
    "system_name": "ALLEGAN",
    "display_name": "ALLEGAN",
    "county": "ALLEGAN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 124,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000120",
    "resolved_pwsid": "MI0000120",
    "system_name": "ALLEGAN",
    "display_name": "ALLEGAN",
    "county": "ALLEGAN",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 106,
    "inventory_lead": 631,
    "inventory_gpcl": 433,
    "inventory_unknown": 1,
    "total_to_identify_or_replace": 1065,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0000125",
    "resolved_pwsid": "MI0000125",
    "system_name": "ALLEGAN COUNTY SERVICES CENTER",
    "display_name": "ALLEGAN COUNTY SERVICES CENTER",
    "county": "ALLEGAN",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000125",
    "resolved_pwsid": "MI0000125",
    "system_name": "ALLEGAN COUNTY SERVICES CENTER",
    "display_name": "ALLEGAN COUNTY SERVICES CENTER",
    "county": "ALLEGAN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000125",
    "resolved_pwsid": "MI0000125",
    "system_name": "ALLEGAN COUNTY SERVICES CENTER",
    "display_name": "ALLEGAN COUNTY SERVICES CENTER",
    "county": "ALLEGAN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000127",
    "resolved_pwsid": "MI0000127",
    "system_name": "ALLENDALE TOWNSHIP",
    "display_name": "ALLENDALE TOWNSHIP",
    "county": "OTTAWA",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000127",
    "resolved_pwsid": "MI0000127",
    "system_name": "ALLENDALE TOWNSHIP",
    "display_name": "ALLENDALE TOWNSHIP",
    "county": "OTTAWA",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000127",
    "resolved_pwsid": "MI0000127",
    "system_name": "ALLENDALE TOWNSHIP",
    "display_name": "ALLENDALE TOWNSHIP",
    "county": "OTTAWA",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000127",
    "resolved_pwsid": "MI0000127",
    "system_name": "ALLENDALE TOWNSHIP",
    "display_name": "ALLENDALE TOWNSHIP",
    "county": "OTTAWA",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000127",
    "resolved_pwsid": "MI0000127",
    "system_name": "ALLENDALE TOWNSHIP",
    "display_name": "ALLENDALE TOWNSHIP",
    "county": "OTTAWA",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000127",
    "resolved_pwsid": "MI0000127",
    "system_name": "ALLENDALE TOWNSHIP",
    "display_name": "ALLENDALE TOWNSHIP",
    "county": "OTTAWA",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000127",
    "resolved_pwsid": "MI0000127",
    "system_name": "ALLENDALE TOWNSHIP",
    "display_name": "ALLENDALE TOWNSHIP",
    "county": "OTTAWA",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000130",
    "resolved_pwsid": "MI0000130",
    "system_name": "ALLEN PARK",
    "display_name": "ALLEN PARK",
    "county": "WAYNE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000130",
    "resolved_pwsid": "MI0000130",
    "system_name": "ALLEN PARK",
    "display_name": "ALLEN PARK",
    "county": "WAYNE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 12,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000130",
    "resolved_pwsid": "MI0000130",
    "system_name": "ALLEN PARK",
    "display_name": "ALLEN PARK",
    "county": "WAYNE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000130",
    "resolved_pwsid": "MI0000130",
    "system_name": "ALLEN PARK",
    "display_name": "ALLEN PARK",
    "county": "WAYNE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 11,
    "above_action_level": false,
    "lines_replaced": 8,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000130",
    "resolved_pwsid": "MI0000130",
    "system_name": "ALLEN PARK",
    "display_name": "ALLEN PARK",
    "county": "WAYNE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 14,
    "above_action_level": true,
    "lines_replaced": 55,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000130",
    "resolved_pwsid": "MI0000130",
    "system_name": "ALLEN PARK",
    "display_name": "ALLEN PARK",
    "county": "WAYNE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 11,
    "above_action_level": false,
    "lines_replaced": 15,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000130",
    "resolved_pwsid": "MI0000130",
    "system_name": "ALLEN PARK",
    "display_name": "ALLEN PARK",
    "county": "WAYNE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 11,
    "above_action_level": false,
    "lines_replaced": 43,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000130",
    "resolved_pwsid": "MI0000130",
    "system_name": "ALLEN PARK",
    "display_name": "ALLEN PARK",
    "county": "WAYNE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 9,
    "above_action_level": false,
    "lines_replaced": 74,
    "inventory_lead": 236,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 236,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0000140",
    "resolved_pwsid": "MI0000140",
    "system_name": "ALMA, CITY OF",
    "display_name": "ALMA, CITY OF",
    "county": "GRATIOT",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000140",
    "resolved_pwsid": "MI0000140",
    "system_name": "ALMA, CITY OF",
    "display_name": "ALMA, CITY OF",
    "county": "GRATIOT",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000140",
    "resolved_pwsid": "MI0000140",
    "system_name": "ALMA, CITY OF",
    "display_name": "ALMA, CITY OF",
    "county": "GRATIOT",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 6,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000140",
    "resolved_pwsid": "MI0000140",
    "system_name": "ALMA, CITY OF",
    "display_name": "ALMA, CITY OF",
    "county": "GRATIOT",
    "monitoring_end_date": "",
    "year": 2022,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 7,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000140",
    "resolved_pwsid": "MI0000140",
    "system_name": "ALMA, CITY OF",
    "display_name": "ALMA, CITY OF",
    "county": "GRATIOT",
    "monitoring_end_date": "",
    "year": 2024,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 6,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000140",
    "resolved_pwsid": "MI0000140",
    "system_name": "ALMA, CITY OF",
    "display_name": "ALMA, CITY OF",
    "county": "GRATIOT",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 49,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000150",
    "resolved_pwsid": "MI0000150",
    "system_name": "ALMONT, VILLAGE OF",
    "display_name": "ALMONT, VILLAGE OF",
    "county": "LAPEER",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000150",
    "resolved_pwsid": "MI0000150",
    "system_name": "ALMONT, VILLAGE OF",
    "display_name": "ALMONT, VILLAGE OF",
    "county": "LAPEER",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000150",
    "resolved_pwsid": "MI0000150",
    "system_name": "ALMONT, VILLAGE OF",
    "display_name": "ALMONT, VILLAGE OF",
    "county": "LAPEER",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000150",
    "resolved_pwsid": "MI0000150",
    "system_name": "ALMONT, VILLAGE OF",
    "display_name": "ALMONT, VILLAGE OF",
    "county": "LAPEER",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 7,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000150",
    "resolved_pwsid": "MI0000150",
    "system_name": "ALMONT, VILLAGE OF",
    "display_name": "ALMONT, VILLAGE OF",
    "county": "LAPEER",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 20,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000150",
    "resolved_pwsid": "MI0000150",
    "system_name": "ALMONT, VILLAGE OF",
    "display_name": "ALMONT, VILLAGE OF",
    "county": "LAPEER",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000150",
    "resolved_pwsid": "MI0000150",
    "system_name": "ALMONT, VILLAGE OF",
    "display_name": "ALMONT, VILLAGE OF",
    "county": "LAPEER",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 3,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000150",
    "resolved_pwsid": "MI0000150",
    "system_name": "ALMONT, VILLAGE OF",
    "display_name": "ALMONT, VILLAGE OF",
    "county": "LAPEER",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 16,
    "total_to_identify_or_replace": 16,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0000160",
    "resolved_pwsid": "MI0000160",
    "system_name": "ALPENA, CITY OF",
    "display_name": "ALPENA, CITY OF",
    "county": "ALPENA",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000160",
    "resolved_pwsid": "MI0000160",
    "system_name": "ALPENA, CITY OF",
    "display_name": "ALPENA, CITY OF",
    "county": "ALPENA",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000160",
    "resolved_pwsid": "MI0000160",
    "system_name": "ALPENA, CITY OF",
    "display_name": "ALPENA, CITY OF",
    "county": "ALPENA",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 14,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000160",
    "resolved_pwsid": "MI0000160",
    "system_name": "ALPENA, CITY OF",
    "display_name": "ALPENA, CITY OF",
    "county": "ALPENA",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000160",
    "resolved_pwsid": "MI0000160",
    "system_name": "ALPENA, CITY OF",
    "display_name": "ALPENA, CITY OF",
    "county": "ALPENA",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": 24,
    "inventory_lead": 7,
    "inventory_gpcl": 76,
    "inventory_unknown": 4022,
    "total_to_identify_or_replace": 4105,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0000160",
    "resolved_pwsid": "MI0000160",
    "system_name": "ALPENA, CITY OF",
    "display_name": "ALPENA, CITY OF",
    "county": "ALPENA",
    "monitoring_end_date": "",
    "year": 2021,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 25,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000160",
    "resolved_pwsid": "MI0000160",
    "system_name": "ALPENA, CITY OF",
    "display_name": "ALPENA, CITY OF",
    "county": "ALPENA",
    "monitoring_end_date": "",
    "year": 2023,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 18,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000160",
    "resolved_pwsid": "MI0000160",
    "system_name": "ALPENA, CITY OF",
    "display_name": "ALPENA, CITY OF",
    "county": "ALPENA",
    "monitoring_end_date": "",
    "year": 2024,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 51,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000170",
    "resolved_pwsid": "MI0000170-a",
    "system_name": "ALPENA TOWNSHIP",
    "display_name": "ALPENA TOWNSHIP",
    "county": "ALPENA",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000170",
    "resolved_pwsid": "MI0000170-a",
    "system_name": "ALPENA TOWNSHIP",
    "display_name": "ALPENA TOWNSHIP",
    "county": "ALPENA",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000170",
    "resolved_pwsid": "MI0000170-a",
    "system_name": "ALPENA TOWNSHIP",
    "display_name": "ALPENA TOWNSHIP",
    "county": "ALPENA",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000170",
    "resolved_pwsid": "MI0000170-b",
    "system_name": "CHARTER TOWNSHIP OF ALPENA",
    "display_name": "CHARTER TOWNSHIP OF ALPENA",
    "county": "ALPENA",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000170",
    "resolved_pwsid": "MI0000170-b",
    "system_name": "CHARTER TOWNSHIP OF ALPENA",
    "display_name": "CHARTER TOWNSHIP OF ALPENA",
    "county": "ALPENA",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0000180",
    "resolved_pwsid": "MI0000180",
    "system_name": "ALPHA",
    "display_name": "ALPHA",
    "county": "IRON",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000180",
    "resolved_pwsid": "MI0000180",
    "system_name": "ALPHA",
    "display_name": "ALPHA",
    "county": "IRON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000180",
    "resolved_pwsid": "MI0000180",
    "system_name": "ALPHA",
    "display_name": "ALPHA",
    "county": "IRON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000180",
    "resolved_pwsid": "MI0000180",
    "system_name": "ALPHA",
    "display_name": "ALPHA",
    "county": "IRON",
    "monitoring_end_date": "",
    "year": 2022,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 4,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000180",
    "resolved_pwsid": "MI0000180",
    "system_name": "ALPHA",
    "display_name": "ALPHA",
    "county": "IRON",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000200",
    "resolved_pwsid": "MI0000200",
    "system_name": "HEMATITE TOWNSHIP",
    "display_name": "HEMATITE TOWNSHIP",
    "county": "IRON",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000200",
    "resolved_pwsid": "MI0000200",
    "system_name": "HEMATITE TOWNSHIP",
    "display_name": "HEMATITE TOWNSHIP",
    "county": "IRON",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000200",
    "resolved_pwsid": "MI0000200",
    "system_name": "HEMATITE TOWNSHIP",
    "display_name": "HEMATITE TOWNSHIP",
    "county": "IRON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000200",
    "resolved_pwsid": "MI0000200",
    "system_name": "HEMATITE TOWNSHIP",
    "display_name": "HEMATITE TOWNSHIP",
    "county": "IRON",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000210",
    "resolved_pwsid": "MI0000210",
    "system_name": "ANDREWS UNIVERSITY",
    "display_name": "ANDREWS UNIVERSITY",
    "county": "BERRIEN",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000210",
    "resolved_pwsid": "MI0000210",
    "system_name": "ANDREWS UNIVERSITY",
    "display_name": "ANDREWS UNIVERSITY",
    "county": "BERRIEN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000210",
    "resolved_pwsid": "MI0000210",
    "system_name": "ANDREWS UNIVERSITY",
    "display_name": "ANDREWS UNIVERSITY",
    "county": "BERRIEN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000215",
    "resolved_pwsid": "MI0000215",
    "system_name": "ANDELINA FARMS",
    "display_name": "ANDELINA FARMS",
    "county": "WASHTENAW",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 11,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000215",
    "resolved_pwsid": "MI0000215",
    "system_name": "ANDELINA FARMS",
    "display_name": "ANDELINA FARMS",
    "county": "WASHTENAW",
    "monitoring_end_date": "2023-06-30",
    "year": 2023,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000215",
    "resolved_pwsid": "MI0000215",
    "system_name": "ANDELINA FARMS",
    "display_name": "ANDELINA FARMS",
    "county": "WASHTENAW",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000215",
    "resolved_pwsid": "MI0000215",
    "system_name": "ANDELINA FARMS",
    "display_name": "ANDELINA FARMS",
    "county": "WASHTENAW",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000220",
    "resolved_pwsid": "MI0000220",
    "system_name": "ANN ARBOR",
    "display_name": "ANN ARBOR",
    "county": "WASHTENAW",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000220",
    "resolved_pwsid": "MI0000220",
    "system_name": "ANN ARBOR",
    "display_name": "ANN ARBOR",
    "county": "WASHTENAW",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000220",
    "resolved_pwsid": "MI0000220",
    "system_name": "ANN ARBOR",
    "display_name": "ANN ARBOR",
    "county": "WASHTENAW",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 103,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000220",
    "resolved_pwsid": "MI0000220",
    "system_name": "ANN ARBOR",
    "display_name": "ANN ARBOR",
    "county": "WASHTENAW",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000220",
    "resolved_pwsid": "MI0000220",
    "system_name": "ANN ARBOR",
    "display_name": "ANN ARBOR",
    "county": "WASHTENAW",
    "monitoring_end_date": "",
    "year": 2021,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 112,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000220",
    "resolved_pwsid": "MI0000220",
    "system_name": "ANN ARBOR",
    "display_name": "ANN ARBOR",
    "county": "WASHTENAW",
    "monitoring_end_date": "",
    "year": 2022,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 137,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000220",
    "resolved_pwsid": "MI0000220",
    "system_name": "ANN ARBOR",
    "display_name": "ANN ARBOR",
    "county": "WASHTENAW",
    "monitoring_end_date": "",
    "year": 2024,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 63,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000220",
    "resolved_pwsid": "MI0000220",
    "system_name": "ANN ARBOR",
    "display_name": "ANN ARBOR",
    "county": "WASHTENAW",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 77,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000221",
    "resolved_pwsid": "MI0000221",
    "system_name": "ANN ARBOR TOWNSHIP",
    "display_name": "ANN ARBOR TOWNSHIP",
    "county": "WASHTENAW",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000221",
    "resolved_pwsid": "MI0000221",
    "system_name": "ANN ARBOR TOWNSHIP",
    "display_name": "ANN ARBOR TOWNSHIP",
    "county": "WASHTENAW",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000221",
    "resolved_pwsid": "MI0000221",
    "system_name": "ANN ARBOR TOWNSHIP",
    "display_name": "ANN ARBOR TOWNSHIP",
    "county": "WASHTENAW",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000221",
    "resolved_pwsid": "MI0000221",
    "system_name": "ANN ARBOR TOWNSHIP",
    "display_name": "ANN ARBOR TOWNSHIP",
    "county": "WASHTENAW",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000221",
    "resolved_pwsid": "MI0000221",
    "system_name": "ANN ARBOR TOWNSHIP",
    "display_name": "ANN ARBOR TOWNSHIP",
    "county": "WASHTENAW",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000221",
    "resolved_pwsid": "MI0000221",
    "system_name": "ANN ARBOR TOWNSHIP",
    "display_name": "ANN ARBOR TOWNSHIP",
    "county": "WASHTENAW",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000221",
    "resolved_pwsid": "MI0000221",
    "system_name": "ANN ARBOR TOWNSHIP",
    "display_name": "ANN ARBOR TOWNSHIP",
    "county": "WASHTENAW",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000221",
    "resolved_pwsid": "MI0000221",
    "system_name": "ANN ARBOR TOWNSHIP",
    "display_name": "ANN ARBOR TOWNSHIP",
    "county": "WASHTENAW",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0000236",
    "resolved_pwsid": "MI0000236",
    "system_name": "ARBOR RIDGE CONDOMINIUMS",
    "display_name": "ARBOR RIDGE CONDOMINIUMS",
    "county": "JACKSON",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000236",
    "resolved_pwsid": "MI0000236",
    "system_name": "ARBOR RIDGE CONDOMINIUMS",
    "display_name": "ARBOR RIDGE CONDOMINIUMS",
    "county": "JACKSON",
    "monitoring_end_date": "2019-09-30",
    "year": 2019,
    "lead_90th_ppb": 44,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000236",
    "resolved_pwsid": "MI0000236",
    "system_name": "ARBOR RIDGE CONDOMINIUMS",
    "display_name": "ARBOR RIDGE CONDOMINIUMS",
    "county": "JACKSON",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 44,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000236",
    "resolved_pwsid": "MI0000236",
    "system_name": "ARBOR RIDGE CONDOMINIUMS",
    "display_name": "ARBOR RIDGE CONDOMINIUMS",
    "county": "JACKSON",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000236",
    "resolved_pwsid": "MI0000236",
    "system_name": "ARBOR RIDGE CONDOMINIUMS",
    "display_name": "ARBOR RIDGE CONDOMINIUMS",
    "county": "JACKSON",
    "monitoring_end_date": "2021-06-30",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000236",
    "resolved_pwsid": "MI0000236",
    "system_name": "ARBOR RIDGE CONDOMINIUMS",
    "display_name": "ARBOR RIDGE CONDOMINIUMS",
    "county": "JACKSON",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000236",
    "resolved_pwsid": "MI0000236",
    "system_name": "ARBOR RIDGE CONDOMINIUMS",
    "display_name": "ARBOR RIDGE CONDOMINIUMS",
    "county": "JACKSON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000240",
    "resolved_pwsid": "MI0000240",
    "system_name": "ARMADA, VILLAGE OF",
    "display_name": "ARMADA, VILLAGE OF",
    "county": "MACOMB",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000240",
    "resolved_pwsid": "MI0000240",
    "system_name": "ARMADA, VILLAGE OF",
    "display_name": "ARMADA, VILLAGE OF",
    "county": "MACOMB",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000240",
    "resolved_pwsid": "MI0000240",
    "system_name": "ARMADA, VILLAGE OF",
    "display_name": "ARMADA, VILLAGE OF",
    "county": "MACOMB",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000240",
    "resolved_pwsid": "MI0000240",
    "system_name": "ARMADA, VILLAGE OF",
    "display_name": "ARMADA, VILLAGE OF",
    "county": "MACOMB",
    "monitoring_end_date": "",
    "year": 2022,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 4,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000242",
    "resolved_pwsid": "MI0000242",
    "system_name": "ARTESIAN SPRINGS RV RESORT",
    "display_name": "ARTESIAN SPRINGS RV RESORT",
    "county": "EMMET",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000242",
    "resolved_pwsid": "MI0000242",
    "system_name": "ARTESIAN SPRINGS RV RESORT",
    "display_name": "ARTESIAN SPRINGS RV RESORT",
    "county": "EMMET",
    "monitoring_end_date": "2024-06-30",
    "year": 2024,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000242",
    "resolved_pwsid": "MI0000242",
    "system_name": "ARTESIAN SPRINGS RV RESORT",
    "display_name": "ARTESIAN SPRINGS RV RESORT",
    "county": "EMMET",
    "monitoring_end_date": "2024-06-30",
    "year": 2024,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000245",
    "resolved_pwsid": "MI0000245",
    "system_name": "ASH TOWNSHIP",
    "display_name": "ASH TOWNSHIP",
    "county": "MONROE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000245",
    "resolved_pwsid": "MI0000245",
    "system_name": "ASH TOWNSHIP",
    "display_name": "ASH TOWNSHIP",
    "county": "MONROE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 14,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000245",
    "resolved_pwsid": "MI0000245",
    "system_name": "ASH TOWNSHIP",
    "display_name": "ASH TOWNSHIP",
    "county": "MONROE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000245",
    "resolved_pwsid": "MI0000245",
    "system_name": "ASH TOWNSHIP",
    "display_name": "ASH TOWNSHIP",
    "county": "MONROE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 2,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000245",
    "resolved_pwsid": "MI0000245",
    "system_name": "ASH TOWNSHIP",
    "display_name": "ASH TOWNSHIP",
    "county": "MONROE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000245",
    "resolved_pwsid": "MI0000245",
    "system_name": "ASH TOWNSHIP",
    "display_name": "ASH TOWNSHIP",
    "county": "MONROE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 2,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000245",
    "resolved_pwsid": "MI0000245",
    "system_name": "ASH TOWNSHIP",
    "display_name": "ASH TOWNSHIP",
    "county": "MONROE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000245",
    "resolved_pwsid": "MI0000245",
    "system_name": "ASH TOWNSHIP",
    "display_name": "ASH TOWNSHIP",
    "county": "MONROE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": 5,
    "inventory_lead": 49,
    "inventory_gpcl": 3,
    "inventory_unknown": 905,
    "total_to_identify_or_replace": 957,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0000250",
    "resolved_pwsid": "MI0000250",
    "system_name": "ASHLEY, VILLAGE OF",
    "display_name": "ASHLEY, VILLAGE OF",
    "county": "GRATIOT",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000250",
    "resolved_pwsid": "MI0000250",
    "system_name": "ASHLEY, VILLAGE OF",
    "display_name": "ASHLEY, VILLAGE OF",
    "county": "GRATIOT",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000250",
    "resolved_pwsid": "MI0000250",
    "system_name": "ASHLEY, VILLAGE OF",
    "display_name": "ASHLEY, VILLAGE OF",
    "county": "GRATIOT",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000260",
    "resolved_pwsid": "MI0000260",
    "system_name": "ATHENS",
    "display_name": "ATHENS",
    "county": "CALHOUN",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000260",
    "resolved_pwsid": "MI0000260",
    "system_name": "ATHENS",
    "display_name": "ATHENS",
    "county": "CALHOUN",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000260",
    "resolved_pwsid": "MI0000260",
    "system_name": "ATHENS",
    "display_name": "ATHENS",
    "county": "CALHOUN",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000260",
    "resolved_pwsid": "MI0000260",
    "system_name": "ATHENS",
    "display_name": "ATHENS",
    "county": "CALHOUN",
    "monitoring_end_date": "2021-06-30",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000260",
    "resolved_pwsid": "MI0000260",
    "system_name": "ATHENS",
    "display_name": "ATHENS",
    "county": "CALHOUN",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 5,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000260",
    "resolved_pwsid": "MI0000260",
    "system_name": "ATHENS",
    "display_name": "ATHENS",
    "county": "CALHOUN",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 13,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000260",
    "resolved_pwsid": "MI0000260",
    "system_name": "ATHENS",
    "display_name": "ATHENS",
    "county": "CALHOUN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 10,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000260",
    "resolved_pwsid": "MI0000260",
    "system_name": "ATHENS",
    "display_name": "ATHENS",
    "county": "CALHOUN",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 18,
    "inventory_lead": 0,
    "inventory_gpcl": 127,
    "inventory_unknown": 7,
    "total_to_identify_or_replace": 134,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0000280",
    "resolved_pwsid": "MI0000280",
    "system_name": "AU GRES, CITY OF",
    "display_name": "AU GRES, CITY OF",
    "county": "ARENAC",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000280",
    "resolved_pwsid": "MI0000280",
    "system_name": "AU GRES, CITY OF",
    "display_name": "AU GRES, CITY OF",
    "county": "ARENAC",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 10,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000280",
    "resolved_pwsid": "MI0000280",
    "system_name": "AU GRES, CITY OF",
    "display_name": "AU GRES, CITY OF",
    "county": "ARENAC",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000280",
    "resolved_pwsid": "MI0000280",
    "system_name": "AU GRES, CITY OF",
    "display_name": "AU GRES, CITY OF",
    "county": "ARENAC",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000285",
    "resolved_pwsid": "MI0000285",
    "system_name": "AU GRES TOWNSHIP",
    "display_name": "AU GRES TOWNSHIP",
    "county": "ARENAC",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000285",
    "resolved_pwsid": "MI0000285",
    "system_name": "AU GRES TOWNSHIP",
    "display_name": "AU GRES TOWNSHIP",
    "county": "ARENAC",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000285",
    "resolved_pwsid": "MI0000285",
    "system_name": "AU GRES TOWNSHIP",
    "display_name": "AU GRES TOWNSHIP",
    "county": "ARENAC",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000285",
    "resolved_pwsid": "MI0000285",
    "system_name": "AU GRES TOWNSHIP",
    "display_name": "AU GRES TOWNSHIP",
    "county": "ARENAC",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000290",
    "resolved_pwsid": "MI0000290",
    "system_name": "AU SABLE TOWNSHIP",
    "display_name": "AU SABLE TOWNSHIP",
    "county": "IOSCO",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000290",
    "resolved_pwsid": "MI0000290",
    "system_name": "AU SABLE TOWNSHIP",
    "display_name": "AU SABLE TOWNSHIP",
    "county": "IOSCO",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000290",
    "resolved_pwsid": "MI0000290",
    "system_name": "AU SABLE TOWNSHIP",
    "display_name": "AU SABLE TOWNSHIP",
    "county": "IOSCO",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000290",
    "resolved_pwsid": "MI0000290",
    "system_name": "AU SABLE TOWNSHIP",
    "display_name": "AU SABLE TOWNSHIP",
    "county": "IOSCO",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000290",
    "resolved_pwsid": "MI0000290",
    "system_name": "AU SABLE TOWNSHIP",
    "display_name": "AU SABLE TOWNSHIP",
    "county": "IOSCO",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0000300",
    "resolved_pwsid": "MI0000300",
    "system_name": "AUBURN",
    "display_name": "AUBURN",
    "county": "BAY",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000300",
    "resolved_pwsid": "MI0000300",
    "system_name": "AUBURN",
    "display_name": "AUBURN",
    "county": "BAY",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 13,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000300",
    "resolved_pwsid": "MI0000300",
    "system_name": "AUBURN",
    "display_name": "AUBURN",
    "county": "BAY",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000300",
    "resolved_pwsid": "MI0000300",
    "system_name": "AUBURN",
    "display_name": "AUBURN",
    "county": "BAY",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000300",
    "resolved_pwsid": "MI0000300",
    "system_name": "AUBURN",
    "display_name": "AUBURN",
    "county": "BAY",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000300",
    "resolved_pwsid": "MI0000300",
    "system_name": "AUBURN",
    "display_name": "AUBURN",
    "county": "BAY",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000300",
    "resolved_pwsid": "MI0000300",
    "system_name": "AUBURN",
    "display_name": "AUBURN",
    "county": "BAY",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000300",
    "resolved_pwsid": "MI0000300",
    "system_name": "AUBURN",
    "display_name": "AUBURN",
    "county": "BAY",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 757,
    "total_to_identify_or_replace": 757,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0000320",
    "resolved_pwsid": "MI0000320",
    "system_name": "AUGUSTA",
    "display_name": "AUGUSTA",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000320",
    "resolved_pwsid": "MI0000320",
    "system_name": "AUGUSTA",
    "display_name": "AUGUSTA",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 7,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000320",
    "resolved_pwsid": "MI0000320",
    "system_name": "AUGUSTA",
    "display_name": "AUGUSTA",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 10,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000320",
    "resolved_pwsid": "MI0000320",
    "system_name": "AUGUSTA",
    "display_name": "AUGUSTA",
    "county": "KALAMAZOO",
    "monitoring_end_date": "",
    "year": 2023,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 5,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000320",
    "resolved_pwsid": "MI0000320",
    "system_name": "AUGUSTA",
    "display_name": "AUGUSTA",
    "county": "KALAMAZOO",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000321",
    "resolved_pwsid": "MI0000321",
    "system_name": "AUGUSTA TOWNSHIP",
    "display_name": "AUGUSTA TOWNSHIP",
    "county": "WASHTENAW",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000321",
    "resolved_pwsid": "MI0000321",
    "system_name": "AUGUSTA TOWNSHIP",
    "display_name": "AUGUSTA TOWNSHIP",
    "county": "WASHTENAW",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000321",
    "resolved_pwsid": "MI0000321",
    "system_name": "AUGUSTA TOWNSHIP",
    "display_name": "AUGUSTA TOWNSHIP",
    "county": "WASHTENAW",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000321",
    "resolved_pwsid": "MI0000321",
    "system_name": "AUGUSTA TOWNSHIP",
    "display_name": "AUGUSTA TOWNSHIP",
    "county": "WASHTENAW",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000321",
    "resolved_pwsid": "MI0000321",
    "system_name": "AUGUSTA TOWNSHIP",
    "display_name": "AUGUSTA TOWNSHIP",
    "county": "WASHTENAW",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000321",
    "resolved_pwsid": "MI0000321",
    "system_name": "AUGUSTA TOWNSHIP",
    "display_name": "AUGUSTA TOWNSHIP",
    "county": "WASHTENAW",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000321",
    "resolved_pwsid": "MI0000321",
    "system_name": "AUGUSTA TOWNSHIP",
    "display_name": "AUGUSTA TOWNSHIP",
    "county": "WASHTENAW",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000321",
    "resolved_pwsid": "MI0000321",
    "system_name": "AUGUSTA TOWNSHIP",
    "display_name": "AUGUSTA TOWNSHIP",
    "county": "WASHTENAW",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0000322",
    "resolved_pwsid": "MI0000322",
    "system_name": "AUSTIN COMMONS II",
    "display_name": "AUSTIN COMMONS II",
    "county": "WASHTENAW",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000322",
    "resolved_pwsid": "MI0000322",
    "system_name": "AUSTIN COMMONS II",
    "display_name": "AUSTIN COMMONS II",
    "county": "WASHTENAW",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000322",
    "resolved_pwsid": "MI0000322",
    "system_name": "AUSTIN COMMONS II",
    "display_name": "AUSTIN COMMONS II",
    "county": "WASHTENAW",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000324",
    "resolved_pwsid": "MI0000324-a",
    "system_name": "AUSABLE VALLEY COMMUNITY",
    "display_name": "AUSABLE VALLEY COMMUNITY",
    "county": "OSCODA",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000324",
    "resolved_pwsid": "MI0000324-a",
    "system_name": "AUSABLE VALLEY COMMUNITY",
    "display_name": "AUSABLE VALLEY COMMUNITY",
    "county": "OSCODA",
    "monitoring_end_date": "2019-09-30",
    "year": 2019,
    "lead_90th_ppb": 48,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000324",
    "resolved_pwsid": "MI0000324-b",
    "system_name": "AUSABLE VALLEY COMMUNITY (APARTMENTS)",
    "display_name": "AUSABLE VALLEY COMMUNITY (APARTMENTS)",
    "county": "OSCODA",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000324",
    "resolved_pwsid": "MI0000324-c",
    "system_name": "AUSABLE VALLEY COMMUNITY (HOME)",
    "display_name": "AUSABLE VALLEY COMMUNITY (HOME)",
    "county": "OSCODA",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 48,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000324",
    "resolved_pwsid": "MI0000324-d",
    "system_name": "AUSABLE VALLEY COMMUNITY (VILLAGE)",
    "display_name": "AUSABLE VALLEY COMMUNITY (VILLAGE)",
    "county": "OSCODA",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000324",
    "resolved_pwsid": "MI0000324-c",
    "system_name": "AUSABLE VALLEY COMMUNITY (HOME)",
    "display_name": "AUSABLE VALLEY COMMUNITY (HOME)",
    "county": "OSCODA",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000324",
    "resolved_pwsid": "MI0000324-b",
    "system_name": "AUSABLE VALLEY COMMUNITY (APARTMENTS)",
    "display_name": "AUSABLE VALLEY COMMUNITY (APARTMENTS)",
    "county": "OSCODA",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000324",
    "resolved_pwsid": "MI0000324-c",
    "system_name": "AUSABLE VALLEY COMMUNITY (HOME)",
    "display_name": "AUSABLE VALLEY COMMUNITY (HOME)",
    "county": "OSCODA",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000324",
    "resolved_pwsid": "MI0000324-d",
    "system_name": "AUSABLE VALLEY COMMUNITY (VILLAGE)",
    "display_name": "AUSABLE VALLEY COMMUNITY (VILLAGE)",
    "county": "OSCODA",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000324",
    "resolved_pwsid": "MI0000324-b",
    "system_name": "AUSABLE VALLEY COMMUNITY (APARTMENTS)",
    "display_name": "AUSABLE VALLEY COMMUNITY (APARTMENTS)",
    "county": "OSCODA",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000324",
    "resolved_pwsid": "MI0000324-c",
    "system_name": "AUSABLE VALLEY COMMUNITY (HOME)",
    "display_name": "AUSABLE VALLEY COMMUNITY (HOME)",
    "county": "OSCODA",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000324",
    "resolved_pwsid": "MI0000324-b",
    "system_name": "AUSABLE VALLEY COMMUNITY (APARTMENTS)",
    "display_name": "AUSABLE VALLEY COMMUNITY (APARTMENTS)",
    "county": "OSCODA",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000324",
    "resolved_pwsid": "MI0000324-c",
    "system_name": "AUSABLE VALLEY COMMUNITY (HOME)",
    "display_name": "AUSABLE VALLEY COMMUNITY (HOME)",
    "county": "OSCODA",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000324",
    "resolved_pwsid": "MI0000324-d",
    "system_name": "AUSABLE VALLEY COMMUNITY (VILLAGE)",
    "display_name": "AUSABLE VALLEY COMMUNITY (VILLAGE)",
    "county": "OSCODA",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000324",
    "resolved_pwsid": "MI0000324-b",
    "system_name": "AUSABLE VALLEY COMMUNITY (APARTMENTS)",
    "display_name": "AUSABLE VALLEY COMMUNITY (APARTMENTS)",
    "county": "OSCODA",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000324",
    "resolved_pwsid": "MI0000324-c",
    "system_name": "AUSABLE VALLEY COMMUNITY (HOME)",
    "display_name": "AUSABLE VALLEY COMMUNITY (HOME)",
    "county": "OSCODA",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000324",
    "resolved_pwsid": "MI0000324-d",
    "system_name": "AUSABLE VALLEY COMMUNITY (VILLAGE)",
    "display_name": "AUSABLE VALLEY COMMUNITY (VILLAGE)",
    "county": "OSCODA",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000324",
    "resolved_pwsid": "MI0000324-e",
    "system_name": "AUSABLE VALLEY COMMUNITY (DS002)",
    "display_name": "AUSABLE VALLEY COMMUNITY (DS002)",
    "county": "OSCODA",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000324",
    "resolved_pwsid": "MI0000324-b",
    "system_name": "AUSABLE VALLEY COMMUNITY (APARTMENTS)",
    "display_name": "AUSABLE VALLEY COMMUNITY",
    "county": "OSCODA",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0000324",
    "resolved_pwsid": "MI0000324-d",
    "system_name": "AUSABLE VALLEY COMMUNITY (VILLAGE)",
    "display_name": "AUSABLE VALLEY COMMUNITY",
    "county": "OSCODA",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0000324",
    "resolved_pwsid": "MI0000324-f",
    "system_name": "AUSABLE VALLEY COMMUNITY (DS001)",
    "display_name": "AUSABLE VALLEY COMMUNITY",
    "county": "OSCODA",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0000324",
    "resolved_pwsid": "MI0000324-g",
    "system_name": "AUSABLE VALLEY COMMUNITY (DS003)",
    "display_name": "AUSABLE VALLEY COMMUNITY",
    "county": "OSCODA",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0000325",
    "resolved_pwsid": "MI0000325",
    "system_name": "ROCHESTER HILLS",
    "display_name": "ROCHESTER HILLS",
    "county": "OAKLAND",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000325",
    "resolved_pwsid": "MI0000325",
    "system_name": "ROCHESTER HILLS",
    "display_name": "ROCHESTER HILLS",
    "county": "OAKLAND",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000325",
    "resolved_pwsid": "MI0000325",
    "system_name": "ROCHESTER HILLS",
    "display_name": "ROCHESTER HILLS",
    "county": "OAKLAND",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000325",
    "resolved_pwsid": "MI0000325",
    "system_name": "ROCHESTER HILLS",
    "display_name": "ROCHESTER HILLS",
    "county": "OAKLAND",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000325",
    "resolved_pwsid": "MI0000325",
    "system_name": "ROCHESTER HILLS",
    "display_name": "ROCHESTER HILLS",
    "county": "OAKLAND",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000325",
    "resolved_pwsid": "MI0000325",
    "system_name": "ROCHESTER HILLS",
    "display_name": "ROCHESTER HILLS",
    "county": "OAKLAND",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000325",
    "resolved_pwsid": "MI0000325",
    "system_name": "ROCHESTER HILLS",
    "display_name": "ROCHESTER HILLS",
    "county": "OAKLAND",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000325",
    "resolved_pwsid": "MI0000325",
    "system_name": "ROCHESTER HILLS",
    "display_name": "ROCHESTER HILLS",
    "county": "OAKLAND",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0000340",
    "resolved_pwsid": "MI0000340",
    "system_name": "BAD AXE",
    "display_name": "BAD AXE",
    "county": "HURON",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000340",
    "resolved_pwsid": "MI0000340",
    "system_name": "BAD AXE",
    "display_name": "BAD AXE",
    "county": "HURON",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000340",
    "resolved_pwsid": "MI0000340",
    "system_name": "BAD AXE",
    "display_name": "BAD AXE",
    "county": "HURON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000340",
    "resolved_pwsid": "MI0000340",
    "system_name": "BAD AXE",
    "display_name": "BAD AXE",
    "county": "HURON",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 2,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000347",
    "resolved_pwsid": "MI0000347-a",
    "system_name": "BAIR LAKE BIBLE CAMP  (LODGE, WC, RVS)",
    "display_name": "BAIR LAKE BIBLE CAMP  (LODGE, WC, RVS)",
    "county": "CASS",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000347",
    "resolved_pwsid": "MI0000347-h",
    "system_name": "BAIR LAKE BIBLE CAMP (LYDIA'S HOUSE)",
    "display_name": "BAIR LAKE BIBLE CAMP (LYDIA'S HOUSE)",
    "county": "CASS",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000347",
    "resolved_pwsid": "MI0000347-i",
    "system_name": "BAIR LAKE BIBLE CAMP (PAC, CAPE COD)",
    "display_name": "BAIR LAKE BIBLE CAMP (PAC, CAPE COD)",
    "county": "CASS",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000347",
    "resolved_pwsid": "MI0000347-j",
    "system_name": "BAIR LAKE BIBLE CAMP (PV, CHALET)",
    "display_name": "BAIR LAKE BIBLE CAMP (PV, CHALET)",
    "county": "CASS",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000347",
    "resolved_pwsid": "MI0000347-k",
    "system_name": "BAIR LAKE BIBLE CAMP (SUNRISE, CABINS)",
    "display_name": "BAIR LAKE BIBLE CAMP (SUNRISE, CABINS)",
    "county": "CASS",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000347",
    "resolved_pwsid": "MI0000347-b",
    "system_name": "BAIR LAKE BIBLE CAMP (DIST2)",
    "display_name": "BAIR LAKE BIBLE CAMP (DIST2)",
    "county": "CASS",
    "monitoring_end_date": "2024-06-30",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000347",
    "resolved_pwsid": "MI0000347-c",
    "system_name": "BAIR LAKE BIBLE CAMP (DIST3)",
    "display_name": "BAIR LAKE BIBLE CAMP (DIST3)",
    "county": "CASS",
    "monitoring_end_date": "2024-06-30",
    "year": 2024,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000347",
    "resolved_pwsid": "MI0000347-d",
    "system_name": "BAIR LAKE BIBLE CAMP (DIST4)",
    "display_name": "BAIR LAKE BIBLE CAMP (DIST4)",
    "county": "CASS",
    "monitoring_end_date": "2024-06-30",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000347",
    "resolved_pwsid": "MI0000347-e",
    "system_name": "BAIR LAKE BIBLE CAMP (DIST5)",
    "display_name": "BAIR LAKE BIBLE CAMP (DIST5)",
    "county": "CASS",
    "monitoring_end_date": "2024-06-30",
    "year": 2024,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000347",
    "resolved_pwsid": "MI0000347-f",
    "system_name": "BAIR LAKE BIBLE CAMP (DIST6)",
    "display_name": "BAIR LAKE BIBLE CAMP (DIST6)",
    "county": "CASS",
    "monitoring_end_date": "2024-06-30",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000347",
    "resolved_pwsid": "MI0000347-g",
    "system_name": "BAIR LAKE BIBLE CAMP (LODGE, WC, RVS)",
    "display_name": "BAIR LAKE BIBLE CAMP (LODGE, WC, RVS)",
    "county": "CASS",
    "monitoring_end_date": "2024-06-30",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000347",
    "resolved_pwsid": "MI0000347-h",
    "system_name": "BAIR LAKE BIBLE CAMP (LYDIA'S HOUSE)",
    "display_name": "BAIR LAKE BIBLE CAMP (LYDIA'S HOUSE)",
    "county": "CASS",
    "monitoring_end_date": "2024-06-30",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000347",
    "resolved_pwsid": "MI0000347-i",
    "system_name": "BAIR LAKE BIBLE CAMP (PAC, CAPE COD)",
    "display_name": "BAIR LAKE BIBLE CAMP (PAC, CAPE COD)",
    "county": "CASS",
    "monitoring_end_date": "2024-06-30",
    "year": 2024,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000347",
    "resolved_pwsid": "MI0000347-j",
    "system_name": "BAIR LAKE BIBLE CAMP (PV, CHALET)",
    "display_name": "BAIR LAKE BIBLE CAMP (PV, CHALET)",
    "county": "CASS",
    "monitoring_end_date": "2024-06-30",
    "year": 2024,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000347",
    "resolved_pwsid": "MI0000347-k",
    "system_name": "BAIR LAKE BIBLE CAMP (SUNRISE, CABINS)",
    "display_name": "BAIR LAKE BIBLE CAMP (SUNRISE, CABINS)",
    "county": "CASS",
    "monitoring_end_date": "2024-06-30",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000347",
    "resolved_pwsid": "MI0000347-l",
    "system_name": "BAIR LAKE BIBLE CAMP (DS003)",
    "display_name": "BAIR LAKE BIBLE CAMP",
    "county": "CASS",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 2,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 2,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0000347",
    "resolved_pwsid": "MI0000347-m",
    "system_name": "BAIR LAKE BIBLE CAMP (DS004)",
    "display_name": "BAIR LAKE BIBLE CAMP",
    "county": "CASS",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 2,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 2,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0000347",
    "resolved_pwsid": "MI0000347-n",
    "system_name": "BAIR LAKE BIBLE CAMP (DS002)",
    "display_name": "BAIR LAKE BIBLE CAMP",
    "county": "CASS",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 2,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 2,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0000347",
    "resolved_pwsid": "MI0000347-o",
    "system_name": "BAIR LAKE BIBLE CAMP (DS006)",
    "display_name": "BAIR LAKE BIBLE CAMP",
    "county": "CASS",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 2,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 2,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0000347",
    "resolved_pwsid": "MI0000347-p",
    "system_name": "BAIR LAKE BIBLE CAMP (DS005)",
    "display_name": "BAIR LAKE BIBLE CAMP",
    "county": "CASS",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 2,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 2,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0000350",
    "resolved_pwsid": "MI0000350",
    "system_name": "BALDWIN, VILLAGE OF",
    "display_name": "BALDWIN, VILLAGE OF",
    "county": "LAKE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000350",
    "resolved_pwsid": "MI0000350",
    "system_name": "BALDWIN, VILLAGE OF",
    "display_name": "BALDWIN, VILLAGE OF",
    "county": "LAKE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000350",
    "resolved_pwsid": "MI0000350",
    "system_name": "BALDWIN, VILLAGE OF",
    "display_name": "BALDWIN, VILLAGE OF",
    "county": "LAKE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": 10,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000350",
    "resolved_pwsid": "MI0000350",
    "system_name": "BALDWIN, VILLAGE OF",
    "display_name": "BALDWIN, VILLAGE OF",
    "county": "LAKE",
    "monitoring_end_date": "",
    "year": 2023,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 116,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000350",
    "resolved_pwsid": "MI0000350",
    "system_name": "BALDWIN, VILLAGE OF",
    "display_name": "BALDWIN, VILLAGE OF",
    "county": "LAKE",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 53,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000355",
    "resolved_pwsid": "MI0000355",
    "system_name": "BALDWIN TOWNSHIP",
    "display_name": "BALDWIN TOWNSHIP",
    "county": "IOSCO",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000355",
    "resolved_pwsid": "MI0000355",
    "system_name": "BALDWIN TOWNSHIP",
    "display_name": "BALDWIN TOWNSHIP",
    "county": "IOSCO",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000355",
    "resolved_pwsid": "MI0000355",
    "system_name": "BALDWIN TOWNSHIP",
    "display_name": "BALDWIN TOWNSHIP",
    "county": "IOSCO",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000370",
    "resolved_pwsid": "MI0000370",
    "system_name": "BANCROFT, VILLAGE OF",
    "display_name": "BANCROFT, VILLAGE OF",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000370",
    "resolved_pwsid": "MI0000370",
    "system_name": "BANCROFT, VILLAGE OF",
    "display_name": "BANCROFT, VILLAGE OF",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000370",
    "resolved_pwsid": "MI0000370",
    "system_name": "BANCROFT, VILLAGE OF",
    "display_name": "BANCROFT, VILLAGE OF",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000370",
    "resolved_pwsid": "MI0000370",
    "system_name": "BANCROFT, VILLAGE OF",
    "display_name": "BANCROFT, VILLAGE OF",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000380",
    "resolved_pwsid": "MI0000380",
    "system_name": "BANGOR",
    "display_name": "BANGOR",
    "county": "VAN BUREN",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000380",
    "resolved_pwsid": "MI0000380",
    "system_name": "BANGOR",
    "display_name": "BANGOR",
    "county": "VAN BUREN",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000380",
    "resolved_pwsid": "MI0000380",
    "system_name": "BANGOR",
    "display_name": "BANGOR",
    "county": "VAN BUREN",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000380",
    "resolved_pwsid": "MI0000380",
    "system_name": "BANGOR",
    "display_name": "BANGOR",
    "county": "VAN BUREN",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000380",
    "resolved_pwsid": "MI0000380",
    "system_name": "BANGOR",
    "display_name": "BANGOR",
    "county": "VAN BUREN",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000390",
    "resolved_pwsid": "MI0000390",
    "system_name": "BANGOR TOWNSHIP",
    "display_name": "BANGOR TOWNSHIP",
    "county": "BAY",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000390",
    "resolved_pwsid": "MI0000390",
    "system_name": "BANGOR TOWNSHIP",
    "display_name": "BANGOR TOWNSHIP",
    "county": "BAY",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000390",
    "resolved_pwsid": "MI0000390",
    "system_name": "BANGOR TOWNSHIP",
    "display_name": "BANGOR TOWNSHIP",
    "county": "BAY",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000390",
    "resolved_pwsid": "MI0000390",
    "system_name": "BANGOR TOWNSHIP",
    "display_name": "BANGOR TOWNSHIP",
    "county": "BAY",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000390",
    "resolved_pwsid": "MI0000390",
    "system_name": "BANGOR TOWNSHIP",
    "display_name": "BANGOR TOWNSHIP",
    "county": "BAY",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": 5,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000390",
    "resolved_pwsid": "MI0000390",
    "system_name": "BANGOR TOWNSHIP",
    "display_name": "BANGOR TOWNSHIP",
    "county": "BAY",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000390",
    "resolved_pwsid": "MI0000390",
    "system_name": "BANGOR TOWNSHIP",
    "display_name": "BANGOR TOWNSHIP",
    "county": "BAY",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000390",
    "resolved_pwsid": "MI0000390",
    "system_name": "BANGOR TOWNSHIP",
    "display_name": "BANGOR TOWNSHIP",
    "county": "BAY",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 12,
    "inventory_gpcl": 12,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 24,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0000400",
    "resolved_pwsid": "MI0000400",
    "system_name": "BANGOR-MONITOR METRO DISTRICT",
    "display_name": "BANGOR-MONITOR METRO DISTRICT",
    "county": "BAY",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000400",
    "resolved_pwsid": "MI0000400",
    "system_name": "BANGOR-MONITOR METRO DISTRICT",
    "display_name": "BANGOR-MONITOR METRO DISTRICT",
    "county": "BAY",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000400",
    "resolved_pwsid": "MI0000400",
    "system_name": "BANGOR-MONITOR METRO DISTRICT",
    "display_name": "BANGOR-MONITOR METRO DISTRICT",
    "county": "BAY",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000400",
    "resolved_pwsid": "MI0000400",
    "system_name": "BANGOR-MONITOR METRO DISTRICT",
    "display_name": "BANGOR-MONITOR METRO DISTRICT",
    "county": "BAY",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000400",
    "resolved_pwsid": "MI0000400",
    "system_name": "BANGOR-MONITOR METRO DISTRICT",
    "display_name": "BANGOR-MONITOR METRO DISTRICT",
    "county": "BAY",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000400",
    "resolved_pwsid": "MI0000400",
    "system_name": "BANGOR-MONITOR METRO DISTRICT",
    "display_name": "BANGOR-MONITOR METRO DISTRICT",
    "county": "BAY",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000400",
    "resolved_pwsid": "MI0000400",
    "system_name": "BANGOR-MONITOR METRO DISTRICT",
    "display_name": "BANGOR-MONITOR METRO DISTRICT",
    "county": "BAY",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000410",
    "resolved_pwsid": "MI0000410",
    "system_name": "BARAGA",
    "display_name": "BARAGA",
    "county": "BARAGA",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000410",
    "resolved_pwsid": "MI0000410",
    "system_name": "BARAGA",
    "display_name": "BARAGA",
    "county": "BARAGA",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000410",
    "resolved_pwsid": "MI0000410",
    "system_name": "BARAGA",
    "display_name": "BARAGA",
    "county": "BARAGA",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000410",
    "resolved_pwsid": "MI0000410",
    "system_name": "BARAGA",
    "display_name": "BARAGA",
    "county": "BARAGA",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000410",
    "resolved_pwsid": "MI0000410",
    "system_name": "BARAGA",
    "display_name": "BARAGA",
    "county": "BARAGA",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000410",
    "resolved_pwsid": "MI0000410",
    "system_name": "BARAGA",
    "display_name": "BARAGA",
    "county": "BARAGA",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000410",
    "resolved_pwsid": "MI0000410",
    "system_name": "BARAGA",
    "display_name": "BARAGA",
    "county": "BARAGA",
    "monitoring_end_date": "2024-06-30",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000410",
    "resolved_pwsid": "MI0000410",
    "system_name": "BARAGA",
    "display_name": "BARAGA",
    "county": "BARAGA",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 92,
    "total_to_identify_or_replace": 92,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0000418",
    "resolved_pwsid": "MI0000418",
    "system_name": "BARN SWALLOW APARTMENTS",
    "display_name": "BARN SWALLOW APARTMENTS",
    "county": "CASS",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000418",
    "resolved_pwsid": "MI0000418",
    "system_name": "BARN SWALLOW APARTMENTS",
    "display_name": "BARN SWALLOW APARTMENTS",
    "county": "CASS",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000418",
    "resolved_pwsid": "MI0000418",
    "system_name": "BARN SWALLOW APARTMENTS",
    "display_name": "BARN SWALLOW APARTMENTS",
    "county": "CASS",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000418",
    "resolved_pwsid": "MI0000418",
    "system_name": "BARN SWALLOW APARTMENTS",
    "display_name": "BARN SWALLOW APARTMENTS",
    "county": "CASS",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0000420",
    "resolved_pwsid": "MI0000420",
    "system_name": "BARODA",
    "display_name": "BARODA",
    "county": "BERRIEN",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000420",
    "resolved_pwsid": "MI0000420",
    "system_name": "BARODA",
    "display_name": "BARODA",
    "county": "BERRIEN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000420",
    "resolved_pwsid": "MI0000420",
    "system_name": "BARODA",
    "display_name": "BARODA",
    "county": "BERRIEN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 2,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000426",
    "resolved_pwsid": "MI0000426",
    "system_name": "BARRY TOWNSHIP",
    "display_name": "BARRY TOWNSHIP",
    "county": "BARRY",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000426",
    "resolved_pwsid": "MI0000426",
    "system_name": "BARRY TOWNSHIP",
    "display_name": "BARRY TOWNSHIP",
    "county": "BARRY",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000426",
    "resolved_pwsid": "MI0000426",
    "system_name": "BARRY TOWNSHIP",
    "display_name": "BARRY TOWNSHIP",
    "county": "BARRY",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000430",
    "resolved_pwsid": "MI0000430",
    "system_name": "BARTON HILLS",
    "display_name": "BARTON HILLS",
    "county": "WASHTENAW",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000430",
    "resolved_pwsid": "MI0000430",
    "system_name": "BARTON HILLS",
    "display_name": "BARTON HILLS",
    "county": "WASHTENAW",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 2,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000430",
    "resolved_pwsid": "MI0000430",
    "system_name": "BARTON HILLS",
    "display_name": "BARTON HILLS",
    "county": "WASHTENAW",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000430",
    "resolved_pwsid": "MI0000430",
    "system_name": "BARTON HILLS",
    "display_name": "BARTON HILLS",
    "county": "WASHTENAW",
    "monitoring_end_date": "",
    "year": 2022,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000430",
    "resolved_pwsid": "MI0000430",
    "system_name": "BARTON HILLS",
    "display_name": "BARTON HILLS",
    "county": "WASHTENAW",
    "monitoring_end_date": "",
    "year": 2023,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 3,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000430",
    "resolved_pwsid": "MI0000430",
    "system_name": "BARTON HILLS",
    "display_name": "BARTON HILLS",
    "county": "WASHTENAW",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 3,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000440",
    "resolved_pwsid": "MI0000440",
    "system_name": "BATES TOWNSHIP",
    "display_name": "BATES TOWNSHIP",
    "county": "IRON",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000440",
    "resolved_pwsid": "MI0000440",
    "system_name": "BATES TOWNSHIP",
    "display_name": "BATES TOWNSHIP",
    "county": "IRON",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000440",
    "resolved_pwsid": "MI0000440",
    "system_name": "BATES TOWNSHIP",
    "display_name": "BATES TOWNSHIP",
    "county": "IRON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000440",
    "resolved_pwsid": "MI0000440",
    "system_name": "BATES TOWNSHIP",
    "display_name": "BATES TOWNSHIP",
    "county": "IRON",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0000450",
    "resolved_pwsid": "MI0000450",
    "system_name": "BATTLE CREEK - VERONA SYSTEM",
    "display_name": "BATTLE CREEK - VERONA SYSTEM",
    "county": "CALHOUN",
    "monitoring_end_date": "2017-06-30",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000450",
    "resolved_pwsid": "MI0000450",
    "system_name": "BATTLE CREEK - VERONA SYSTEM",
    "display_name": "BATTLE CREEK - VERONA SYSTEM",
    "county": "CALHOUN",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000450",
    "resolved_pwsid": "MI0000450",
    "system_name": "BATTLE CREEK - VERONA SYSTEM",
    "display_name": "BATTLE CREEK - VERONA SYSTEM",
    "county": "CALHOUN",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000450",
    "resolved_pwsid": "MI0000450",
    "system_name": "BATTLE CREEK - VERONA SYSTEM",
    "display_name": "BATTLE CREEK - VERONA SYSTEM",
    "county": "CALHOUN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": 227,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000450",
    "resolved_pwsid": "MI0000450",
    "system_name": "BATTLE CREEK - VERONA SYSTEM",
    "display_name": "BATTLE CREEK - VERONA SYSTEM",
    "county": "CALHOUN",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 194,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000450",
    "resolved_pwsid": "MI0000450",
    "system_name": "BATTLE CREEK - VERONA SYSTEM",
    "display_name": "BATTLE CREEK - VERONA SYSTEM",
    "county": "CALHOUN",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": 330,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000450",
    "resolved_pwsid": "MI0000450",
    "system_name": "BATTLE CREEK - VERONA SYSTEM",
    "display_name": "BATTLE CREEK - VERONA SYSTEM",
    "county": "CALHOUN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 254,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000450",
    "resolved_pwsid": "MI0000450",
    "system_name": "BATTLE CREEK - VERONA SYSTEM",
    "display_name": "BATTLE CREEK - VERONA SYSTEM",
    "county": "CALHOUN",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 425,
    "inventory_lead": 3614,
    "inventory_gpcl": 167,
    "inventory_unknown": 7066,
    "total_to_identify_or_replace": 10847,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0000465",
    "resolved_pwsid": "MI0000465",
    "system_name": "BAY AREA WATER SYSTEM",
    "display_name": "BAY AREA WATER SYSTEM",
    "county": "BAY",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000470",
    "resolved_pwsid": "MI0000470",
    "system_name": "BAY CITY, CITY OF",
    "display_name": "BAY CITY, CITY OF",
    "county": "BAY",
    "monitoring_end_date": "2015-12-31",
    "year": 2015,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000470",
    "resolved_pwsid": "MI0000470",
    "system_name": "BAY CITY, CITY OF",
    "display_name": "BAY CITY, CITY OF",
    "county": "BAY",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 10,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000470",
    "resolved_pwsid": "MI0000470",
    "system_name": "BAY CITY, CITY OF",
    "display_name": "BAY CITY, CITY OF",
    "county": "BAY",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 12,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000470",
    "resolved_pwsid": "MI0000470",
    "system_name": "BAY CITY, CITY OF",
    "display_name": "BAY CITY, CITY OF",
    "county": "BAY",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000470",
    "resolved_pwsid": "MI0000470",
    "system_name": "BAY CITY, CITY OF",
    "display_name": "BAY CITY, CITY OF",
    "county": "BAY",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 9,
    "above_action_level": false,
    "lines_replaced": 278,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000470",
    "resolved_pwsid": "MI0000470",
    "system_name": "BAY CITY, CITY OF",
    "display_name": "BAY CITY, CITY OF",
    "county": "BAY",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": 523,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000470",
    "resolved_pwsid": "MI0000470",
    "system_name": "BAY CITY, CITY OF",
    "display_name": "BAY CITY, CITY OF",
    "county": "BAY",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": 475,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000470",
    "resolved_pwsid": "MI0000470",
    "system_name": "BAY CITY, CITY OF",
    "display_name": "BAY CITY, CITY OF",
    "county": "BAY",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 11,
    "above_action_level": false,
    "lines_replaced": 628,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000470",
    "resolved_pwsid": "MI0000470",
    "system_name": "BAY CITY, CITY OF",
    "display_name": "BAY CITY, CITY OF",
    "county": "BAY",
    "monitoring_end_date": "2025-06-30",
    "year": 2025,
    "lead_90th_ppb": 10,
    "above_action_level": false,
    "lines_replaced": 689,
    "inventory_lead": 3323,
    "inventory_gpcl": 879,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 4202,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0000485",
    "resolved_pwsid": "MI0000485",
    "system_name": "BAY CO. DEPT OF WATER & SEWER",
    "display_name": "BAY CO. DEPT OF WATER & SEWER",
    "county": "BAY",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000485",
    "resolved_pwsid": "MI0000485",
    "system_name": "BAY CO. DEPT OF WATER & SEWER",
    "display_name": "BAY CO. DEPT OF WATER & SEWER",
    "county": "BAY",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000485",
    "resolved_pwsid": "MI0000485",
    "system_name": "BAY CO. DEPT OF WATER & SEWER",
    "display_name": "BAY CO. DEPT OF WATER & SEWER",
    "county": "BAY",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000485",
    "resolved_pwsid": "MI0000485",
    "system_name": "BAY CO. DEPT OF WATER & SEWER",
    "display_name": "BAY CO. DEPT OF WATER & SEWER",
    "county": "BAY",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000485",
    "resolved_pwsid": "MI0000485",
    "system_name": "BAY CO. DEPT OF WATER & SEWER",
    "display_name": "BAY CO. DEPT OF WATER & SEWER",
    "county": "BAY",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": 4,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000485",
    "resolved_pwsid": "MI0000485",
    "system_name": "BAY CO. DEPT OF WATER & SEWER",
    "display_name": "BAY CO. DEPT OF WATER & SEWER",
    "county": "BAY",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": 4,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000485",
    "resolved_pwsid": "MI0000485",
    "system_name": "BAY CO. DEPT OF WATER & SEWER",
    "display_name": "BAY CO. DEPT OF WATER & SEWER",
    "county": "BAY",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000485",
    "resolved_pwsid": "MI0000485",
    "system_name": "BAY CO. DEPT OF WATER & SEWER",
    "display_name": "BAY CO. DEPT OF WATER & SEWER",
    "county": "BAY",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 9,
    "inventory_gpcl": 7,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 16,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0000487",
    "resolved_pwsid": "MI0000487",
    "system_name": "BAY HARBOR CLUB",
    "display_name": "BAY HARBOR CLUB",
    "county": "ANTRIM",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000487",
    "resolved_pwsid": "MI0000487",
    "system_name": "BAY HARBOR CLUB",
    "display_name": "BAY HARBOR CLUB",
    "county": "ANTRIM",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000487",
    "resolved_pwsid": "MI0000487",
    "system_name": "BAY HARBOR CLUB",
    "display_name": "BAY HARBOR CLUB",
    "county": "ANTRIM",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000487",
    "resolved_pwsid": "MI0000487",
    "system_name": "BAY HARBOR CLUB",
    "display_name": "BAY HARBOR CLUB",
    "county": "ANTRIM",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0000490",
    "resolved_pwsid": "MI0000490",
    "system_name": "BAY VIEW ASSOCIATION",
    "display_name": "BAY VIEW ASSOCIATION",
    "county": "EMMET",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000490",
    "resolved_pwsid": "MI0000490",
    "system_name": "BAY VIEW ASSOCIATION",
    "display_name": "BAY VIEW ASSOCIATION",
    "county": "EMMET",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 12,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000490",
    "resolved_pwsid": "MI0000490",
    "system_name": "BAY VIEW ASSOCIATION",
    "display_name": "BAY VIEW ASSOCIATION",
    "county": "EMMET",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000490",
    "resolved_pwsid": "MI0000490",
    "system_name": "BAY VIEW ASSOCIATION",
    "display_name": "BAY VIEW ASSOCIATION",
    "county": "EMMET",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0000501",
    "resolved_pwsid": "MI0000501",
    "system_name": "BEACH HOUSE APARTMENTS",
    "display_name": "BEACH HOUSE APARTMENTS",
    "county": "OAKLAND",
    "monitoring_end_date": "2021-06-30",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000501",
    "resolved_pwsid": "MI0000501",
    "system_name": "BEACH HOUSE APARTMENTS",
    "display_name": "BEACH HOUSE APARTMENTS",
    "county": "OAKLAND",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000501",
    "resolved_pwsid": "MI0000501",
    "system_name": "BEACH HOUSE APARTMENTS",
    "display_name": "BEACH HOUSE APARTMENTS",
    "county": "OAKLAND",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000503",
    "resolved_pwsid": "MI0000503",
    "system_name": "BEACON HOME AT COLBY",
    "display_name": "BEACON HOME AT COLBY",
    "county": "MONTCALM",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000503",
    "resolved_pwsid": "MI0000503",
    "system_name": "BEACON HOME AT COLBY",
    "display_name": "BEACON HOME AT COLBY",
    "county": "MONTCALM",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000503",
    "resolved_pwsid": "MI0000503",
    "system_name": "BEACON HOME AT COLBY",
    "display_name": "BEACON HOME AT COLBY",
    "county": "MONTCALM",
    "monitoring_end_date": "2021-06-30",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000503",
    "resolved_pwsid": "MI0000503",
    "system_name": "BEACON HOME AT COLBY",
    "display_name": "BEACON HOME AT COLBY",
    "county": "MONTCALM",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000503",
    "resolved_pwsid": "MI0000503",
    "system_name": "BEACON HOME AT COLBY",
    "display_name": "BEACON HOME AT COLBY",
    "county": "MONTCALM",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000505",
    "resolved_pwsid": "MI0000505",
    "system_name": "BEAR CREEK ESTATES CONDOMINIUM",
    "display_name": "BEAR CREEK ESTATES CONDOMINIUM",
    "county": "EMMET",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000505",
    "resolved_pwsid": "MI0000505",
    "system_name": "BEAR CREEK ESTATES CONDOMINIUM",
    "display_name": "BEAR CREEK ESTATES CONDOMINIUM",
    "county": "EMMET",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000505",
    "resolved_pwsid": "MI0000505",
    "system_name": "BEAR CREEK ESTATES CONDOMINIUM",
    "display_name": "BEAR CREEK ESTATES CONDOMINIUM",
    "county": "EMMET",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000505",
    "resolved_pwsid": "MI0000505",
    "system_name": "BEAR CREEK ESTATES CONDOMINIUM",
    "display_name": "BEAR CREEK ESTATES CONDOMINIUM",
    "county": "EMMET",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0000508",
    "resolved_pwsid": "MI0000508",
    "system_name": "BEAR CREEK VILLA",
    "display_name": "BEAR CREEK VILLA",
    "county": "IONIA",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 12,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000508",
    "resolved_pwsid": "MI0000508",
    "system_name": "BEAR CREEK VILLA",
    "display_name": "BEAR CREEK VILLA",
    "county": "IONIA",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000508",
    "resolved_pwsid": "MI0000508",
    "system_name": "BEAR CREEK VILLA",
    "display_name": "BEAR CREEK VILLA",
    "county": "IONIA",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000508",
    "resolved_pwsid": "MI0000508",
    "system_name": "BEAR CREEK VILLA",
    "display_name": "BEAR CREEK VILLA",
    "county": "IONIA",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000508",
    "resolved_pwsid": "MI0000508",
    "system_name": "BEAR CREEK VILLA",
    "display_name": "BEAR CREEK VILLA",
    "county": "IONIA",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000508",
    "resolved_pwsid": "MI0000508",
    "system_name": "BEAR CREEK VILLA",
    "display_name": "BEAR CREEK VILLA",
    "county": "IONIA",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000510",
    "resolved_pwsid": "MI0000510",
    "system_name": "BEAR LAKE, VILLAGE OF",
    "display_name": "BEAR LAKE, VILLAGE OF",
    "county": "MANISTEE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000510",
    "resolved_pwsid": "MI0000510",
    "system_name": "BEAR LAKE, VILLAGE OF",
    "display_name": "BEAR LAKE, VILLAGE OF",
    "county": "MANISTEE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000510",
    "resolved_pwsid": "MI0000510",
    "system_name": "BEAR LAKE, VILLAGE OF",
    "display_name": "BEAR LAKE, VILLAGE OF",
    "county": "MANISTEE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 2,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000510",
    "resolved_pwsid": "MI0000510",
    "system_name": "BEAR LAKE, VILLAGE OF",
    "display_name": "BEAR LAKE, VILLAGE OF",
    "county": "MANISTEE",
    "monitoring_end_date": "",
    "year": 2022,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000513",
    "resolved_pwsid": "MI0000513",
    "system_name": "BEAVER CREEK-GRAYLING TOWNSHIPS UA",
    "display_name": "BEAVER CREEK-GRAYLING TOWNSHIPS UA",
    "county": "CRAWFORD",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000514",
    "resolved_pwsid": "MI0000514",
    "system_name": "BEAVER CREEK RESORT",
    "display_name": "BEAVER CREEK RESORT",
    "county": "OTSEGO",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000514",
    "resolved_pwsid": "MI0000514",
    "system_name": "BEAVER CREEK RESORT",
    "display_name": "BEAVER CREEK RESORT",
    "county": "OTSEGO",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000514",
    "resolved_pwsid": "MI0000514",
    "system_name": "BEAVER CREEK RESORT",
    "display_name": "BEAVER CREEK RESORT",
    "county": "OTSEGO",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000517",
    "resolved_pwsid": "MI0000517",
    "system_name": "BEAVER ROAD AREA WATER ASSOC.",
    "display_name": "BEAVER ROAD AREA WATER ASSOC.",
    "county": "BAY",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000517",
    "resolved_pwsid": "MI0000517",
    "system_name": "BEAVER ROAD AREA WATER ASSOC.",
    "display_name": "BEAVER ROAD AREA WATER ASSOC.",
    "county": "BAY",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000517",
    "resolved_pwsid": "MI0000517",
    "system_name": "BEAVER ROAD AREA WATER ASSOC.",
    "display_name": "BEAVER ROAD AREA WATER ASSOC.",
    "county": "BAY",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000517",
    "resolved_pwsid": "MI0000517",
    "system_name": "BEAVER ROAD AREA WATER ASSOC.",
    "display_name": "BEAVER ROAD AREA WATER ASSOC.",
    "county": "BAY",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000517",
    "resolved_pwsid": "MI0000517",
    "system_name": "BEAVER ROAD AREA WATER ASSOC.",
    "display_name": "BEAVER ROAD AREA WATER ASSOC.",
    "county": "BAY",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000517",
    "resolved_pwsid": "MI0000517",
    "system_name": "BEAVER ROAD AREA WATER ASSOC.",
    "display_name": "BEAVER ROAD AREA WATER ASSOC.",
    "county": "BAY",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000517",
    "resolved_pwsid": "MI0000517",
    "system_name": "BEAVER ROAD AREA WATER ASSOC.",
    "display_name": "BEAVER ROAD AREA WATER ASSOC.",
    "county": "BAY",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000518",
    "resolved_pwsid": "MI0000518",
    "system_name": "BEAVER TOWNSHIP",
    "display_name": "BEAVER TOWNSHIP",
    "county": "BAY",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000518",
    "resolved_pwsid": "MI0000518",
    "system_name": "BEAVER TOWNSHIP",
    "display_name": "BEAVER TOWNSHIP",
    "county": "BAY",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000518",
    "resolved_pwsid": "MI0000518",
    "system_name": "BEAVER TOWNSHIP",
    "display_name": "BEAVER TOWNSHIP",
    "county": "BAY",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000518",
    "resolved_pwsid": "MI0000518",
    "system_name": "BEAVER TOWNSHIP",
    "display_name": "BEAVER TOWNSHIP",
    "county": "BAY",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000518",
    "resolved_pwsid": "MI0000518",
    "system_name": "BEAVER TOWNSHIP",
    "display_name": "BEAVER TOWNSHIP",
    "county": "BAY",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000518",
    "resolved_pwsid": "MI0000518",
    "system_name": "BEAVER TOWNSHIP",
    "display_name": "BEAVER TOWNSHIP",
    "county": "BAY",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000518",
    "resolved_pwsid": "MI0000518",
    "system_name": "BEAVER TOWNSHIP",
    "display_name": "BEAVER TOWNSHIP",
    "county": "BAY",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000520",
    "resolved_pwsid": "MI0000520",
    "system_name": "BEAVERTON",
    "display_name": "BEAVERTON",
    "county": "GLADWIN",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000520",
    "resolved_pwsid": "MI0000520",
    "system_name": "BEAVERTON",
    "display_name": "BEAVERTON",
    "county": "GLADWIN",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 13,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000520",
    "resolved_pwsid": "MI0000520",
    "system_name": "BEAVERTON",
    "display_name": "BEAVERTON",
    "county": "GLADWIN",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000520",
    "resolved_pwsid": "MI0000520",
    "system_name": "BEAVERTON",
    "display_name": "BEAVERTON",
    "county": "GLADWIN",
    "monitoring_end_date": "2024-06-30",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000520",
    "resolved_pwsid": "MI0000520",
    "system_name": "BEAVERTON",
    "display_name": "BEAVERTON",
    "county": "GLADWIN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000520",
    "resolved_pwsid": "MI0000520",
    "system_name": "BEAVERTON",
    "display_name": "BEAVERTON",
    "county": "GLADWIN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000540",
    "resolved_pwsid": "MI0000540",
    "system_name": "BEECHER METROPOLITAN DISTRICT",
    "display_name": "BEECHER METROPOLITAN DISTRICT",
    "county": "GENESEE",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000540",
    "resolved_pwsid": "MI0000540",
    "system_name": "BEECHER METROPOLITAN DISTRICT",
    "display_name": "BEECHER METROPOLITAN DISTRICT",
    "county": "GENESEE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000540",
    "resolved_pwsid": "MI0000540",
    "system_name": "BEECHER METROPOLITAN DISTRICT",
    "display_name": "BEECHER METROPOLITAN DISTRICT",
    "county": "GENESEE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000540",
    "resolved_pwsid": "MI0000540",
    "system_name": "BEECHER METROPOLITAN DISTRICT",
    "display_name": "BEECHER METROPOLITAN DISTRICT",
    "county": "GENESEE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0000550",
    "resolved_pwsid": "MI0000550",
    "system_name": "IRON RIVER TOWNSHIP-BEECHWOOD",
    "display_name": "IRON RIVER TOWNSHIP-BEECHWOOD",
    "county": "IRON",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000550",
    "resolved_pwsid": "MI0000550",
    "system_name": "IRON RIVER TOWNSHIP-BEECHWOOD",
    "display_name": "IRON RIVER TOWNSHIP-BEECHWOOD",
    "county": "IRON",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000550",
    "resolved_pwsid": "MI0000550",
    "system_name": "IRON RIVER TOWNSHIP-BEECHWOOD",
    "display_name": "IRON RIVER TOWNSHIP-BEECHWOOD",
    "county": "IRON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000560",
    "resolved_pwsid": "MI0000560",
    "system_name": "BELDING",
    "display_name": "BELDING",
    "county": "IONIA",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000560",
    "resolved_pwsid": "MI0000560",
    "system_name": "BELDING",
    "display_name": "BELDING",
    "county": "IONIA",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000560",
    "resolved_pwsid": "MI0000560",
    "system_name": "BELDING",
    "display_name": "BELDING",
    "county": "IONIA",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 91,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000560",
    "resolved_pwsid": "MI0000560",
    "system_name": "BELDING",
    "display_name": "BELDING",
    "county": "IONIA",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 189,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000560",
    "resolved_pwsid": "MI0000560",
    "system_name": "BELDING",
    "display_name": "BELDING",
    "county": "IONIA",
    "monitoring_end_date": "",
    "year": 2021,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 84,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000560",
    "resolved_pwsid": "MI0000560",
    "system_name": "BELDING",
    "display_name": "BELDING",
    "county": "IONIA",
    "monitoring_end_date": "",
    "year": 2022,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 94,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000560",
    "resolved_pwsid": "MI0000560",
    "system_name": "BELDING",
    "display_name": "BELDING",
    "county": "IONIA",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 265,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000570",
    "resolved_pwsid": "MI0000570",
    "system_name": "BELLAIRE, VILLAGE OF",
    "display_name": "BELLAIRE, VILLAGE OF",
    "county": "ANTRIM",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000570",
    "resolved_pwsid": "MI0000570",
    "system_name": "BELLAIRE, VILLAGE OF",
    "display_name": "BELLAIRE, VILLAGE OF",
    "county": "ANTRIM",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": 16,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000570",
    "resolved_pwsid": "MI0000570",
    "system_name": "BELLAIRE, VILLAGE OF",
    "display_name": "BELLAIRE, VILLAGE OF",
    "county": "ANTRIM",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 16,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000570",
    "resolved_pwsid": "MI0000570",
    "system_name": "BELLAIRE, VILLAGE OF",
    "display_name": "BELLAIRE, VILLAGE OF",
    "county": "ANTRIM",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 4,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000570",
    "resolved_pwsid": "MI0000570",
    "system_name": "BELLAIRE, VILLAGE OF",
    "display_name": "BELLAIRE, VILLAGE OF",
    "county": "ANTRIM",
    "monitoring_end_date": "",
    "year": 2023,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 6,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000575",
    "resolved_pwsid": "MI0000575",
    "system_name": "WHISPERING PINES SENIOR LIVING",
    "display_name": "WHISPERING PINES SENIOR LIVING",
    "county": "MISSAUKEE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000575",
    "resolved_pwsid": "MI0000575",
    "system_name": "WHISPERING PINES SENIOR LIVING",
    "display_name": "WHISPERING PINES SENIOR LIVING",
    "county": "MISSAUKEE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000575",
    "resolved_pwsid": "MI0000575",
    "system_name": "WHISPERING PINES SENIOR LIVING",
    "display_name": "WHISPERING PINES SENIOR LIVING",
    "county": "MISSAUKEE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000580",
    "resolved_pwsid": "MI0000580",
    "system_name": "BELLEVILLE",
    "display_name": "BELLEVILLE",
    "county": "WAYNE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000580",
    "resolved_pwsid": "MI0000580",
    "system_name": "BELLEVILLE",
    "display_name": "BELLEVILLE",
    "county": "WAYNE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000580",
    "resolved_pwsid": "MI0000580",
    "system_name": "BELLEVILLE",
    "display_name": "BELLEVILLE",
    "county": "WAYNE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000580",
    "resolved_pwsid": "MI0000580",
    "system_name": "BELLEVILLE",
    "display_name": "BELLEVILLE",
    "county": "WAYNE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000580",
    "resolved_pwsid": "MI0000580",
    "system_name": "BELLEVILLE",
    "display_name": "BELLEVILLE",
    "county": "WAYNE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000580",
    "resolved_pwsid": "MI0000580",
    "system_name": "BELLEVILLE",
    "display_name": "BELLEVILLE",
    "county": "WAYNE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000580",
    "resolved_pwsid": "MI0000580",
    "system_name": "BELLEVILLE",
    "display_name": "BELLEVILLE",
    "county": "WAYNE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000580",
    "resolved_pwsid": "MI0000580",
    "system_name": "BELLEVILLE",
    "display_name": "BELLEVILLE",
    "county": "WAYNE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000590",
    "resolved_pwsid": "MI0000590",
    "system_name": "BELLEVUE, VILLAGE OF",
    "display_name": "BELLEVUE, VILLAGE OF",
    "county": "EATON",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000590",
    "resolved_pwsid": "MI0000590",
    "system_name": "BELLEVUE, VILLAGE OF",
    "display_name": "BELLEVUE, VILLAGE OF",
    "county": "EATON",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": 2,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000590",
    "resolved_pwsid": "MI0000590",
    "system_name": "BELLEVUE, VILLAGE OF",
    "display_name": "BELLEVUE, VILLAGE OF",
    "county": "EATON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": 2,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000590",
    "resolved_pwsid": "MI0000590",
    "system_name": "BELLEVUE, VILLAGE OF",
    "display_name": "BELLEVUE, VILLAGE OF",
    "county": "EATON",
    "monitoring_end_date": "",
    "year": 2023,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000590",
    "resolved_pwsid": "MI0000590",
    "system_name": "BELLEVUE, VILLAGE OF",
    "display_name": "BELLEVUE, VILLAGE OF",
    "county": "EATON",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 3,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000600",
    "resolved_pwsid": "MI0000600",
    "system_name": "BENTON HARBOR",
    "display_name": "BENTON HARBOR",
    "county": "BERRIEN",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 22,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000600",
    "resolved_pwsid": "MI0000600",
    "system_name": "BENTON HARBOR",
    "display_name": "BENTON HARBOR",
    "county": "BERRIEN",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 27,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000600",
    "resolved_pwsid": "MI0000600",
    "system_name": "BENTON HARBOR",
    "display_name": "BENTON HARBOR",
    "county": "BERRIEN",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 32,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000600",
    "resolved_pwsid": "MI0000600",
    "system_name": "BENTON HARBOR",
    "display_name": "BENTON HARBOR",
    "county": "BERRIEN",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 23,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000600",
    "resolved_pwsid": "MI0000600",
    "system_name": "BENTON HARBOR",
    "display_name": "BENTON HARBOR",
    "county": "BERRIEN",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 24,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000600",
    "resolved_pwsid": "MI0000600",
    "system_name": "BENTON HARBOR",
    "display_name": "BENTON HARBOR",
    "county": "BERRIEN",
    "monitoring_end_date": "2021-06-30",
    "year": 2021,
    "lead_90th_ppb": 24,
    "above_action_level": true,
    "lines_replaced": 191,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000600",
    "resolved_pwsid": "MI0000600",
    "system_name": "BENTON HARBOR",
    "display_name": "BENTON HARBOR",
    "county": "BERRIEN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 15,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000600",
    "resolved_pwsid": "MI0000600",
    "system_name": "BENTON HARBOR",
    "display_name": "BENTON HARBOR",
    "county": "BERRIEN",
    "monitoring_end_date": "2022-06-30",
    "year": 2022,
    "lead_90th_ppb": 14,
    "above_action_level": true,
    "lines_replaced": 3056,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000600",
    "resolved_pwsid": "MI0000600",
    "system_name": "BENTON HARBOR",
    "display_name": "BENTON HARBOR",
    "county": "BERRIEN",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 9,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000600",
    "resolved_pwsid": "MI0000600",
    "system_name": "BENTON HARBOR",
    "display_name": "BENTON HARBOR",
    "county": "BERRIEN",
    "monitoring_end_date": "2023-06-30",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 24,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000600",
    "resolved_pwsid": "MI0000600",
    "system_name": "BENTON HARBOR",
    "display_name": "BENTON HARBOR",
    "county": "BERRIEN",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000600",
    "resolved_pwsid": "MI0000600",
    "system_name": "BENTON HARBOR",
    "display_name": "BENTON HARBOR",
    "county": "BERRIEN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000600",
    "resolved_pwsid": "MI0000600",
    "system_name": "BENTON HARBOR",
    "display_name": "BENTON HARBOR",
    "county": "BERRIEN",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0000605",
    "resolved_pwsid": "MI0000605",
    "system_name": "BENTON CHARTER TOWNSHIP",
    "display_name": "BENTON CHARTER TOWNSHIP",
    "county": "BERRIEN",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000605",
    "resolved_pwsid": "MI0000605",
    "system_name": "BENTON CHARTER TOWNSHIP",
    "display_name": "BENTON CHARTER TOWNSHIP",
    "county": "BERRIEN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 9,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000605",
    "resolved_pwsid": "MI0000605",
    "system_name": "BENTON CHARTER TOWNSHIP",
    "display_name": "BENTON CHARTER TOWNSHIP",
    "county": "BERRIEN",
    "monitoring_end_date": "2024-09-30",
    "year": 2024,
    "lead_90th_ppb": 16,
    "above_action_level": true,
    "lines_replaced": 5,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000605",
    "resolved_pwsid": "MI0000605",
    "system_name": "BENTON CHARTER TOWNSHIP",
    "display_name": "BENTON CHARTER TOWNSHIP",
    "county": "BERRIEN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 16,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000605",
    "resolved_pwsid": "MI0000605",
    "system_name": "BENTON CHARTER TOWNSHIP",
    "display_name": "BENTON CHARTER TOWNSHIP",
    "county": "BERRIEN",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 59,
    "inventory_lead": 33,
    "inventory_gpcl": 7,
    "inventory_unknown": 71,
    "total_to_identify_or_replace": 111,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0000605",
    "resolved_pwsid": "MI0000605",
    "system_name": "BENTON CHARTER TOWNSHIP",
    "display_name": "BENTON CHARTER TOWNSHIP",
    "county": "BERRIEN",
    "monitoring_end_date": "2026-06-30",
    "year": 2026,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000605",
    "resolved_pwsid": "MI0000605",
    "system_name": "BENTON CHARTER TOWNSHIP",
    "display_name": "BENTON CHARTER TOWNSHIP",
    "county": "BERRIEN",
    "monitoring_end_date": "",
    "year": 2022,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 2,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000605",
    "resolved_pwsid": "MI0000605",
    "system_name": "BENTON CHARTER TOWNSHIP",
    "display_name": "BENTON CHARTER TOWNSHIP",
    "county": "BERRIEN",
    "monitoring_end_date": "",
    "year": 2023,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000610",
    "resolved_pwsid": "MI0000610",
    "system_name": "BENZONIA VILLAGE OF",
    "display_name": "BENZONIA VILLAGE OF",
    "county": "BENZIE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000610",
    "resolved_pwsid": "MI0000610",
    "system_name": "BENZONIA VILLAGE OF",
    "display_name": "BENZONIA VILLAGE OF",
    "county": "BENZIE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000610",
    "resolved_pwsid": "MI0000610",
    "system_name": "BENZONIA VILLAGE OF",
    "display_name": "BENZONIA VILLAGE OF",
    "county": "BENZIE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 5,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000610",
    "resolved_pwsid": "MI0000610",
    "system_name": "BENZONIA VILLAGE OF",
    "display_name": "BENZONIA VILLAGE OF",
    "county": "BENZIE",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000620",
    "resolved_pwsid": "MI0000620",
    "system_name": "BERGLAND TOWNSHIP",
    "display_name": "BERGLAND TOWNSHIP",
    "county": "ONTONAGON",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000620",
    "resolved_pwsid": "MI0000620",
    "system_name": "BERGLAND TOWNSHIP",
    "display_name": "BERGLAND TOWNSHIP",
    "county": "ONTONAGON",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000620",
    "resolved_pwsid": "MI0000620",
    "system_name": "BERGLAND TOWNSHIP",
    "display_name": "BERGLAND TOWNSHIP",
    "county": "ONTONAGON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000630",
    "resolved_pwsid": "MI0000630",
    "system_name": "BERKLEY",
    "display_name": "BERKLEY",
    "county": "OAKLAND",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000630",
    "resolved_pwsid": "MI0000630",
    "system_name": "BERKLEY",
    "display_name": "BERKLEY",
    "county": "OAKLAND",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 14,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000630",
    "resolved_pwsid": "MI0000630",
    "system_name": "BERKLEY",
    "display_name": "BERKLEY",
    "county": "OAKLAND",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000630",
    "resolved_pwsid": "MI0000630",
    "system_name": "BERKLEY",
    "display_name": "BERKLEY",
    "county": "OAKLAND",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": 35,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000630",
    "resolved_pwsid": "MI0000630",
    "system_name": "BERKLEY",
    "display_name": "BERKLEY",
    "county": "OAKLAND",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 9,
    "above_action_level": false,
    "lines_replaced": 111,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000630",
    "resolved_pwsid": "MI0000630",
    "system_name": "BERKLEY",
    "display_name": "BERKLEY",
    "county": "OAKLAND",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 10,
    "above_action_level": false,
    "lines_replaced": 77,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000630",
    "resolved_pwsid": "MI0000630",
    "system_name": "BERKLEY",
    "display_name": "BERKLEY",
    "county": "OAKLAND",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": 54,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000630",
    "resolved_pwsid": "MI0000630",
    "system_name": "BERKLEY",
    "display_name": "BERKLEY",
    "county": "OAKLAND",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": 83,
    "inventory_lead": 97,
    "inventory_gpcl": 2,
    "inventory_unknown": 5684,
    "total_to_identify_or_replace": 5783,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0000635",
    "resolved_pwsid": "MI0000635",
    "system_name": "BERLIN TOWNSHIP",
    "display_name": "BERLIN TOWNSHIP",
    "county": "MONROE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000635",
    "resolved_pwsid": "MI0000635",
    "system_name": "BERLIN TOWNSHIP",
    "display_name": "BERLIN TOWNSHIP",
    "county": "MONROE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000635",
    "resolved_pwsid": "MI0000635",
    "system_name": "BERLIN TOWNSHIP",
    "display_name": "BERLIN TOWNSHIP",
    "county": "MONROE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000635",
    "resolved_pwsid": "MI0000635",
    "system_name": "BERLIN TOWNSHIP",
    "display_name": "BERLIN TOWNSHIP",
    "county": "MONROE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000635",
    "resolved_pwsid": "MI0000635",
    "system_name": "BERLIN TOWNSHIP",
    "display_name": "BERLIN TOWNSHIP",
    "county": "MONROE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000635",
    "resolved_pwsid": "MI0000635",
    "system_name": "BERLIN TOWNSHIP",
    "display_name": "BERLIN TOWNSHIP",
    "county": "MONROE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000635",
    "resolved_pwsid": "MI0000635",
    "system_name": "BERLIN TOWNSHIP",
    "display_name": "BERLIN TOWNSHIP",
    "county": "MONROE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000635",
    "resolved_pwsid": "MI0000635",
    "system_name": "BERLIN TOWNSHIP",
    "display_name": "BERLIN TOWNSHIP",
    "county": "MONROE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000650",
    "resolved_pwsid": "MI0000650",
    "system_name": "BERRIEN SPRINGS",
    "display_name": "BERRIEN SPRINGS",
    "county": "BERRIEN",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000650",
    "resolved_pwsid": "MI0000650",
    "system_name": "BERRIEN SPRINGS",
    "display_name": "BERRIEN SPRINGS",
    "county": "BERRIEN",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000650",
    "resolved_pwsid": "MI0000650",
    "system_name": "BERRIEN SPRINGS",
    "display_name": "BERRIEN SPRINGS",
    "county": "BERRIEN",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 17,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000650",
    "resolved_pwsid": "MI0000650",
    "system_name": "BERRIEN SPRINGS",
    "display_name": "BERRIEN SPRINGS",
    "county": "BERRIEN",
    "monitoring_end_date": "",
    "year": 2021,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 5,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000650",
    "resolved_pwsid": "MI0000650",
    "system_name": "BERRIEN SPRINGS",
    "display_name": "BERRIEN SPRINGS",
    "county": "BERRIEN",
    "monitoring_end_date": "",
    "year": 2024,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 12,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000650",
    "resolved_pwsid": "MI0000650",
    "system_name": "BERRIEN SPRINGS",
    "display_name": "BERRIEN SPRINGS",
    "county": "BERRIEN",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 46,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000660",
    "resolved_pwsid": "MI0000660",
    "system_name": "BESSEMER",
    "display_name": "BESSEMER",
    "county": "GOGEBIC",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000660",
    "resolved_pwsid": "MI0000660",
    "system_name": "BESSEMER",
    "display_name": "BESSEMER",
    "county": "GOGEBIC",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 17,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000660",
    "resolved_pwsid": "MI0000660",
    "system_name": "BESSEMER",
    "display_name": "BESSEMER",
    "county": "GOGEBIC",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 20,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000660",
    "resolved_pwsid": "MI0000660",
    "system_name": "BESSEMER",
    "display_name": "BESSEMER",
    "county": "GOGEBIC",
    "monitoring_end_date": "",
    "year": 2022,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 25,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000660",
    "resolved_pwsid": "MI0000660",
    "system_name": "BESSEMER",
    "display_name": "BESSEMER",
    "county": "GOGEBIC",
    "monitoring_end_date": "",
    "year": 2023,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 48,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000680",
    "resolved_pwsid": "MI0000680",
    "system_name": "BEULAH, VILLAGE OF",
    "display_name": "BEULAH, VILLAGE OF",
    "county": "BENZIE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000680",
    "resolved_pwsid": "MI0000680",
    "system_name": "BEULAH, VILLAGE OF",
    "display_name": "BEULAH, VILLAGE OF",
    "county": "BENZIE",
    "monitoring_end_date": "2021-09-30",
    "year": 2021,
    "lead_90th_ppb": 30,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000680",
    "resolved_pwsid": "MI0000680",
    "system_name": "BEULAH, VILLAGE OF",
    "display_name": "BEULAH, VILLAGE OF",
    "county": "BENZIE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 30,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000680",
    "resolved_pwsid": "MI0000680",
    "system_name": "BEULAH, VILLAGE OF",
    "display_name": "BEULAH, VILLAGE OF",
    "county": "BENZIE",
    "monitoring_end_date": "2022-06-30",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000680",
    "resolved_pwsid": "MI0000680",
    "system_name": "BEULAH, VILLAGE OF",
    "display_name": "BEULAH, VILLAGE OF",
    "county": "BENZIE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000680",
    "resolved_pwsid": "MI0000680",
    "system_name": "BEULAH, VILLAGE OF",
    "display_name": "BEULAH, VILLAGE OF",
    "county": "BENZIE",
    "monitoring_end_date": "2023-06-30",
    "year": 2023,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000680",
    "resolved_pwsid": "MI0000680",
    "system_name": "BEULAH, VILLAGE OF",
    "display_name": "BEULAH, VILLAGE OF",
    "county": "BENZIE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000680",
    "resolved_pwsid": "MI0000680",
    "system_name": "BEULAH, VILLAGE OF",
    "display_name": "BEULAH, VILLAGE OF",
    "county": "BENZIE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0000690",
    "resolved_pwsid": "MI0000690",
    "system_name": "BEVERLY HILLS",
    "display_name": "BEVERLY HILLS",
    "county": "OAKLAND",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000690",
    "resolved_pwsid": "MI0000690",
    "system_name": "BEVERLY HILLS",
    "display_name": "BEVERLY HILLS",
    "county": "OAKLAND",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000690",
    "resolved_pwsid": "MI0000690",
    "system_name": "BEVERLY HILLS",
    "display_name": "BEVERLY HILLS",
    "county": "OAKLAND",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000690",
    "resolved_pwsid": "MI0000690",
    "system_name": "BEVERLY HILLS",
    "display_name": "BEVERLY HILLS",
    "county": "OAKLAND",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000690",
    "resolved_pwsid": "MI0000690",
    "system_name": "BEVERLY HILLS",
    "display_name": "BEVERLY HILLS",
    "county": "OAKLAND",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000690",
    "resolved_pwsid": "MI0000690",
    "system_name": "BEVERLY HILLS",
    "display_name": "BEVERLY HILLS",
    "county": "OAKLAND",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000690",
    "resolved_pwsid": "MI0000690",
    "system_name": "BEVERLY HILLS",
    "display_name": "BEVERLY HILLS",
    "county": "OAKLAND",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 2,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000690",
    "resolved_pwsid": "MI0000690",
    "system_name": "BEVERLY HILLS",
    "display_name": "BEVERLY HILLS",
    "county": "OAKLAND",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 2,
    "inventory_lead": 0,
    "inventory_gpcl": 2,
    "inventory_unknown": 125,
    "total_to_identify_or_replace": 127,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0000700",
    "resolved_pwsid": "MI0000700",
    "system_name": "POWELL TOWNSHIP",
    "display_name": "POWELL TOWNSHIP",
    "county": "MARQUETTE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000700",
    "resolved_pwsid": "MI0000700",
    "system_name": "POWELL TOWNSHIP",
    "display_name": "POWELL TOWNSHIP",
    "county": "MARQUETTE",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000700",
    "resolved_pwsid": "MI0000700",
    "system_name": "POWELL TOWNSHIP",
    "display_name": "POWELL TOWNSHIP",
    "county": "MARQUETTE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000700",
    "resolved_pwsid": "MI0000700",
    "system_name": "POWELL TOWNSHIP",
    "display_name": "POWELL TOWNSHIP",
    "county": "MARQUETTE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 27,
    "total_to_identify_or_replace": 27,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0000705",
    "resolved_pwsid": "MI0000705",
    "system_name": "BIG CREEK/MENTOR UTILITY AUTHORITY",
    "display_name": "BIG CREEK/MENTOR UTILITY AUTHORITY",
    "county": "OSCODA",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000705",
    "resolved_pwsid": "MI0000705",
    "system_name": "BIG CREEK/MENTOR UTILITY AUTHORITY",
    "display_name": "BIG CREEK/MENTOR UTILITY AUTHORITY",
    "county": "OSCODA",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000705",
    "resolved_pwsid": "MI0000705",
    "system_name": "BIG CREEK/MENTOR UTILITY AUTHORITY",
    "display_name": "BIG CREEK/MENTOR UTILITY AUTHORITY",
    "county": "OSCODA",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000705",
    "resolved_pwsid": "MI0000705",
    "system_name": "BIG CREEK/MENTOR UTILITY AUTHORITY",
    "display_name": "BIG CREEK/MENTOR UTILITY AUTHORITY",
    "county": "OSCODA",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0000710",
    "resolved_pwsid": "MI0000710",
    "system_name": "BIG RAPIDS",
    "display_name": "BIG RAPIDS",
    "county": "MECOSTA",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000710",
    "resolved_pwsid": "MI0000710",
    "system_name": "BIG RAPIDS",
    "display_name": "BIG RAPIDS",
    "county": "MECOSTA",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000710",
    "resolved_pwsid": "MI0000710",
    "system_name": "BIG RAPIDS",
    "display_name": "BIG RAPIDS",
    "county": "MECOSTA",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000710",
    "resolved_pwsid": "MI0000710",
    "system_name": "BIG RAPIDS",
    "display_name": "BIG RAPIDS",
    "county": "MECOSTA",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 49,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000710",
    "resolved_pwsid": "MI0000710",
    "system_name": "BIG RAPIDS",
    "display_name": "BIG RAPIDS",
    "county": "MECOSTA",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000710",
    "resolved_pwsid": "MI0000710",
    "system_name": "BIG RAPIDS",
    "display_name": "BIG RAPIDS",
    "county": "MECOSTA",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 135,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000710",
    "resolved_pwsid": "MI0000710",
    "system_name": "BIG RAPIDS",
    "display_name": "BIG RAPIDS",
    "county": "MECOSTA",
    "monitoring_end_date": "2024-06-30",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000710",
    "resolved_pwsid": "MI0000710",
    "system_name": "BIG RAPIDS",
    "display_name": "BIG RAPIDS",
    "county": "MECOSTA",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000710",
    "resolved_pwsid": "MI0000710",
    "system_name": "BIG RAPIDS",
    "display_name": "BIG RAPIDS",
    "county": "MECOSTA",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 6,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 64,
    "total_to_identify_or_replace": 64,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0000715",
    "resolved_pwsid": "MI0000715",
    "system_name": "BINGHAM FARMS",
    "display_name": "BINGHAM FARMS",
    "county": "OAKLAND",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000715",
    "resolved_pwsid": "MI0000715",
    "system_name": "BINGHAM FARMS",
    "display_name": "BINGHAM FARMS",
    "county": "OAKLAND",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000715",
    "resolved_pwsid": "MI0000715",
    "system_name": "BINGHAM FARMS",
    "display_name": "BINGHAM FARMS",
    "county": "OAKLAND",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000715",
    "resolved_pwsid": "MI0000715",
    "system_name": "BINGHAM FARMS",
    "display_name": "BINGHAM FARMS",
    "county": "OAKLAND",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000715",
    "resolved_pwsid": "MI0000715",
    "system_name": "BINGHAM FARMS",
    "display_name": "BINGHAM FARMS",
    "county": "OAKLAND",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000715",
    "resolved_pwsid": "MI0000715",
    "system_name": "BINGHAM FARMS",
    "display_name": "BINGHAM FARMS",
    "county": "OAKLAND",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000715",
    "resolved_pwsid": "MI0000715",
    "system_name": "BINGHAM FARMS",
    "display_name": "BINGHAM FARMS",
    "county": "OAKLAND",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000715",
    "resolved_pwsid": "MI0000715",
    "system_name": "BINGHAM FARMS",
    "display_name": "BINGHAM FARMS",
    "county": "OAKLAND",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0000716",
    "resolved_pwsid": "MI0000716",
    "system_name": "BINGHAM TOWNSHIP",
    "display_name": "BINGHAM TOWNSHIP",
    "county": "CLINTON",
    "monitoring_end_date": "2022-06-30",
    "year": 2022,
    "lead_90th_ppb": 10,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000716",
    "resolved_pwsid": "MI0000716",
    "system_name": "BINGHAM TOWNSHIP",
    "display_name": "BINGHAM TOWNSHIP",
    "county": "CLINTON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000716",
    "resolved_pwsid": "MI0000716",
    "system_name": "BINGHAM TOWNSHIP",
    "display_name": "BINGHAM TOWNSHIP",
    "county": "CLINTON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000716",
    "resolved_pwsid": "MI0000716",
    "system_name": "BINGHAM TOWNSHIP",
    "display_name": "BINGHAM TOWNSHIP",
    "county": "CLINTON",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000720",
    "resolved_pwsid": "MI0000720",
    "system_name": "BIRCH RUN, VILLAGE OF",
    "display_name": "BIRCH RUN, VILLAGE OF",
    "county": "SAGINAW",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000720",
    "resolved_pwsid": "MI0000720",
    "system_name": "BIRCH RUN, VILLAGE OF",
    "display_name": "BIRCH RUN, VILLAGE OF",
    "county": "SAGINAW",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000720",
    "resolved_pwsid": "MI0000720",
    "system_name": "BIRCH RUN, VILLAGE OF",
    "display_name": "BIRCH RUN, VILLAGE OF",
    "county": "SAGINAW",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000720",
    "resolved_pwsid": "MI0000720",
    "system_name": "BIRCH RUN, VILLAGE OF",
    "display_name": "BIRCH RUN, VILLAGE OF",
    "county": "SAGINAW",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000720",
    "resolved_pwsid": "MI0000720",
    "system_name": "BIRCH RUN, VILLAGE OF",
    "display_name": "BIRCH RUN, VILLAGE OF",
    "county": "SAGINAW",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000720",
    "resolved_pwsid": "MI0000720",
    "system_name": "BIRCH RUN, VILLAGE OF",
    "display_name": "BIRCH RUN, VILLAGE OF",
    "county": "SAGINAW",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000720",
    "resolved_pwsid": "MI0000720",
    "system_name": "BIRCH RUN, VILLAGE OF",
    "display_name": "BIRCH RUN, VILLAGE OF",
    "county": "SAGINAW",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000722",
    "resolved_pwsid": "MI0000722",
    "system_name": "BIRCH RUN TOWNSHIP",
    "display_name": "BIRCH RUN TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000722",
    "resolved_pwsid": "MI0000722",
    "system_name": "BIRCH RUN TOWNSHIP",
    "display_name": "BIRCH RUN TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000722",
    "resolved_pwsid": "MI0000722",
    "system_name": "BIRCH RUN TOWNSHIP",
    "display_name": "BIRCH RUN TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000722",
    "resolved_pwsid": "MI0000722",
    "system_name": "BIRCH RUN TOWNSHIP",
    "display_name": "BIRCH RUN TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000722",
    "resolved_pwsid": "MI0000722",
    "system_name": "BIRCH RUN TOWNSHIP",
    "display_name": "BIRCH RUN TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000722",
    "resolved_pwsid": "MI0000722",
    "system_name": "BIRCH RUN TOWNSHIP",
    "display_name": "BIRCH RUN TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000722",
    "resolved_pwsid": "MI0000722",
    "system_name": "BIRCH RUN TOWNSHIP",
    "display_name": "BIRCH RUN TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000725",
    "resolved_pwsid": "MI0000725",
    "system_name": "BIRCHWOOD FARMS",
    "display_name": "BIRCHWOOD FARMS",
    "county": "EMMET",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000725",
    "resolved_pwsid": "MI0000725",
    "system_name": "BIRCHWOOD FARMS",
    "display_name": "BIRCHWOOD FARMS",
    "county": "EMMET",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000725",
    "resolved_pwsid": "MI0000725",
    "system_name": "BIRCHWOOD FARMS",
    "display_name": "BIRCHWOOD FARMS",
    "county": "EMMET",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000730",
    "resolved_pwsid": "MI0000730",
    "system_name": "BIRMINGHAM",
    "display_name": "BIRMINGHAM",
    "county": "OAKLAND",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000730",
    "resolved_pwsid": "MI0000730",
    "system_name": "BIRMINGHAM",
    "display_name": "BIRMINGHAM",
    "county": "OAKLAND",
    "monitoring_end_date": "2019-09-30",
    "year": 2019,
    "lead_90th_ppb": 17,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000730",
    "resolved_pwsid": "MI0000730",
    "system_name": "BIRMINGHAM",
    "display_name": "BIRMINGHAM",
    "county": "OAKLAND",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 17,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000730",
    "resolved_pwsid": "MI0000730",
    "system_name": "BIRMINGHAM",
    "display_name": "BIRMINGHAM",
    "county": "OAKLAND",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000730",
    "resolved_pwsid": "MI0000730",
    "system_name": "BIRMINGHAM",
    "display_name": "BIRMINGHAM",
    "county": "OAKLAND",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000730",
    "resolved_pwsid": "MI0000730",
    "system_name": "BIRMINGHAM",
    "display_name": "BIRMINGHAM",
    "county": "OAKLAND",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 11,
    "above_action_level": false,
    "lines_replaced": 216,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000730",
    "resolved_pwsid": "MI0000730",
    "system_name": "BIRMINGHAM",
    "display_name": "BIRMINGHAM",
    "county": "OAKLAND",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": 204,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000730",
    "resolved_pwsid": "MI0000730",
    "system_name": "BIRMINGHAM",
    "display_name": "BIRMINGHAM",
    "county": "OAKLAND",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": 83,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000730",
    "resolved_pwsid": "MI0000730",
    "system_name": "BIRMINGHAM",
    "display_name": "BIRMINGHAM",
    "county": "OAKLAND",
    "monitoring_end_date": "2024-06-30",
    "year": 2024,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": 27,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000730",
    "resolved_pwsid": "MI0000730",
    "system_name": "BIRMINGHAM",
    "display_name": "BIRMINGHAM",
    "county": "OAKLAND",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000730",
    "resolved_pwsid": "MI0000730",
    "system_name": "BIRMINGHAM",
    "display_name": "BIRMINGHAM",
    "county": "OAKLAND",
    "monitoring_end_date": "2025-06-30",
    "year": 2025,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": 35,
    "inventory_lead": 153,
    "inventory_gpcl": 2,
    "inventory_unknown": 33,
    "total_to_identify_or_replace": 188,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0000731",
    "resolved_pwsid": "MI0000731",
    "system_name": "BISHOP LAKE APARTMENTS",
    "display_name": "BISHOP LAKE APARTMENTS",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000731",
    "resolved_pwsid": "MI0000731",
    "system_name": "BISHOP LAKE APARTMENTS",
    "display_name": "BISHOP LAKE APARTMENTS",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000731",
    "resolved_pwsid": "MI0000731",
    "system_name": "BISHOP LAKE APARTMENTS",
    "display_name": "BISHOP LAKE APARTMENTS",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000733",
    "resolved_pwsid": "MI0000733",
    "system_name": "BLACK BEAR FARMS",
    "display_name": "BLACK BEAR FARMS",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 11,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000733",
    "resolved_pwsid": "MI0000733",
    "system_name": "BLACK BEAR FARMS",
    "display_name": "BLACK BEAR FARMS",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000733",
    "resolved_pwsid": "MI0000733",
    "system_name": "BLACK BEAR FARMS",
    "display_name": "BLACK BEAR FARMS",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000733",
    "resolved_pwsid": "MI0000733",
    "system_name": "BLACK BEAR FARMS",
    "display_name": "BLACK BEAR FARMS",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000733",
    "resolved_pwsid": "MI0000733",
    "system_name": "BLACK BEAR FARMS",
    "display_name": "BLACK BEAR FARMS",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2024-06-30",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000733",
    "resolved_pwsid": "MI0000733",
    "system_name": "BLACK BEAR FARMS",
    "display_name": "BLACK BEAR FARMS",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000740",
    "resolved_pwsid": "MI0000740",
    "system_name": "BLACKMAN TOWNSHIP",
    "display_name": "BLACKMAN TOWNSHIP",
    "county": "JACKSON",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000740",
    "resolved_pwsid": "MI0000740",
    "system_name": "BLACKMAN TOWNSHIP",
    "display_name": "BLACKMAN TOWNSHIP",
    "county": "JACKSON",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000740",
    "resolved_pwsid": "MI0000740",
    "system_name": "BLACKMAN TOWNSHIP",
    "display_name": "BLACKMAN TOWNSHIP",
    "county": "JACKSON",
    "monitoring_end_date": "2020-09-30",
    "year": 2020,
    "lead_90th_ppb": 132,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000740",
    "resolved_pwsid": "MI0000740",
    "system_name": "BLACKMAN TOWNSHIP",
    "display_name": "BLACKMAN TOWNSHIP",
    "county": "JACKSON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 132,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000740",
    "resolved_pwsid": "MI0000740",
    "system_name": "BLACKMAN TOWNSHIP",
    "display_name": "BLACKMAN TOWNSHIP",
    "county": "JACKSON",
    "monitoring_end_date": "2021-06-30",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000740",
    "resolved_pwsid": "MI0000740",
    "system_name": "BLACKMAN TOWNSHIP",
    "display_name": "BLACKMAN TOWNSHIP",
    "county": "JACKSON",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000740",
    "resolved_pwsid": "MI0000740",
    "system_name": "BLACKMAN TOWNSHIP",
    "display_name": "BLACKMAN TOWNSHIP",
    "county": "JACKSON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000740",
    "resolved_pwsid": "MI0000740",
    "system_name": "BLACKMAN TOWNSHIP",
    "display_name": "BLACKMAN TOWNSHIP",
    "county": "JACKSON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000740",
    "resolved_pwsid": "MI0000740",
    "system_name": "BLACKMAN TOWNSHIP",
    "display_name": "BLACKMAN TOWNSHIP",
    "county": "JACKSON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000740",
    "resolved_pwsid": "MI0000740",
    "system_name": "BLACKMAN TOWNSHIP",
    "display_name": "BLACKMAN TOWNSHIP",
    "county": "JACKSON",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0000743",
    "resolved_pwsid": "MI0000743",
    "system_name": "BLAIR TOWNSHIP",
    "display_name": "BLAIR TOWNSHIP",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000743",
    "resolved_pwsid": "MI0000743",
    "system_name": "BLAIR TOWNSHIP",
    "display_name": "BLAIR TOWNSHIP",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000743",
    "resolved_pwsid": "MI0000743",
    "system_name": "BLAIR TOWNSHIP",
    "display_name": "BLAIR TOWNSHIP",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000743",
    "resolved_pwsid": "MI0000743",
    "system_name": "BLAIR TOWNSHIP",
    "display_name": "BLAIR TOWNSHIP",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2021-06-30",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000743",
    "resolved_pwsid": "MI0000743",
    "system_name": "BLAIR TOWNSHIP",
    "display_name": "BLAIR TOWNSHIP",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000743",
    "resolved_pwsid": "MI0000743",
    "system_name": "BLAIR TOWNSHIP",
    "display_name": "BLAIR TOWNSHIP",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000750",
    "resolved_pwsid": "MI0000750",
    "system_name": "BLISSFIELD",
    "display_name": "BLISSFIELD",
    "county": "LENAWEE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000750",
    "resolved_pwsid": "MI0000750",
    "system_name": "BLISSFIELD",
    "display_name": "BLISSFIELD",
    "county": "LENAWEE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000750",
    "resolved_pwsid": "MI0000750",
    "system_name": "BLISSFIELD",
    "display_name": "BLISSFIELD",
    "county": "LENAWEE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000750",
    "resolved_pwsid": "MI0000750",
    "system_name": "BLISSFIELD",
    "display_name": "BLISSFIELD",
    "county": "LENAWEE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 10,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000750",
    "resolved_pwsid": "MI0000750",
    "system_name": "BLISSFIELD",
    "display_name": "BLISSFIELD",
    "county": "LENAWEE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 23,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000750",
    "resolved_pwsid": "MI0000750",
    "system_name": "BLISSFIELD",
    "display_name": "BLISSFIELD",
    "county": "LENAWEE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 11,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000750",
    "resolved_pwsid": "MI0000750",
    "system_name": "BLISSFIELD",
    "display_name": "BLISSFIELD",
    "county": "LENAWEE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 7,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000750",
    "resolved_pwsid": "MI0000750",
    "system_name": "BLISSFIELD",
    "display_name": "BLISSFIELD",
    "county": "LENAWEE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 14,
    "inventory_lead": 718,
    "inventory_gpcl": 0,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000775",
    "resolved_pwsid": "MI0000775",
    "system_name": "BLOOMFIELD HILLS",
    "display_name": "BLOOMFIELD HILLS",
    "county": "OAKLAND",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000775",
    "resolved_pwsid": "MI0000775",
    "system_name": "BLOOMFIELD HILLS",
    "display_name": "BLOOMFIELD HILLS",
    "county": "OAKLAND",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000775",
    "resolved_pwsid": "MI0000775",
    "system_name": "BLOOMFIELD HILLS",
    "display_name": "BLOOMFIELD HILLS",
    "county": "OAKLAND",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000775",
    "resolved_pwsid": "MI0000775",
    "system_name": "BLOOMFIELD HILLS",
    "display_name": "BLOOMFIELD HILLS",
    "county": "OAKLAND",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000775",
    "resolved_pwsid": "MI0000775",
    "system_name": "BLOOMFIELD HILLS",
    "display_name": "BLOOMFIELD HILLS",
    "county": "OAKLAND",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000775",
    "resolved_pwsid": "MI0000775",
    "system_name": "BLOOMFIELD HILLS",
    "display_name": "BLOOMFIELD HILLS",
    "county": "OAKLAND",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000775",
    "resolved_pwsid": "MI0000775",
    "system_name": "BLOOMFIELD HILLS",
    "display_name": "BLOOMFIELD HILLS",
    "county": "OAKLAND",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000775",
    "resolved_pwsid": "MI0000775",
    "system_name": "BLOOMFIELD HILLS",
    "display_name": "BLOOMFIELD HILLS",
    "county": "OAKLAND",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0000790",
    "resolved_pwsid": "MI0000790",
    "system_name": "BLOOMFIELD TOWNSHIP",
    "display_name": "BLOOMFIELD TOWNSHIP",
    "county": "OAKLAND",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000790",
    "resolved_pwsid": "MI0000790",
    "system_name": "BLOOMFIELD TOWNSHIP",
    "display_name": "BLOOMFIELD TOWNSHIP",
    "county": "OAKLAND",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000790",
    "resolved_pwsid": "MI0000790",
    "system_name": "BLOOMFIELD TOWNSHIP",
    "display_name": "BLOOMFIELD TOWNSHIP",
    "county": "OAKLAND",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000790",
    "resolved_pwsid": "MI0000790",
    "system_name": "BLOOMFIELD TOWNSHIP",
    "display_name": "BLOOMFIELD TOWNSHIP",
    "county": "OAKLAND",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 9,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000790",
    "resolved_pwsid": "MI0000790",
    "system_name": "BLOOMFIELD TOWNSHIP",
    "display_name": "BLOOMFIELD TOWNSHIP",
    "county": "OAKLAND",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000790",
    "resolved_pwsid": "MI0000790",
    "system_name": "BLOOMFIELD TOWNSHIP",
    "display_name": "BLOOMFIELD TOWNSHIP",
    "county": "OAKLAND",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000790",
    "resolved_pwsid": "MI0000790",
    "system_name": "BLOOMFIELD TOWNSHIP",
    "display_name": "BLOOMFIELD TOWNSHIP",
    "county": "OAKLAND",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000790",
    "resolved_pwsid": "MI0000790",
    "system_name": "BLOOMFIELD TOWNSHIP",
    "display_name": "BLOOMFIELD TOWNSHIP",
    "county": "OAKLAND",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0000794",
    "resolved_pwsid": "MI0000794",
    "system_name": "BLUE SPRUCE APARTMENTS",
    "display_name": "BLUE SPRUCE APARTMENTS",
    "county": "IONIA",
    "monitoring_end_date": "2018-06-30",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000794",
    "resolved_pwsid": "MI0000794",
    "system_name": "BLUE SPRUCE APARTMENTS",
    "display_name": "BLUE SPRUCE APARTMENTS",
    "county": "IONIA",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000794",
    "resolved_pwsid": "MI0000794",
    "system_name": "BLUE SPRUCE APARTMENTS",
    "display_name": "BLUE SPRUCE APARTMENTS",
    "county": "IONIA",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000795",
    "resolved_pwsid": "MI0000795",
    "system_name": "BLUE WATER VILLAGE WELL SITE, LLC",
    "display_name": "BLUE WATER VILLAGE WELL SITE, LLC",
    "county": "EATON",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000795",
    "resolved_pwsid": "MI0000795",
    "system_name": "BLUE WATER VILLAGE WELL SITE, LLC",
    "display_name": "BLUE WATER VILLAGE WELL SITE, LLC",
    "county": "EATON",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000795",
    "resolved_pwsid": "MI0000795",
    "system_name": "BLUE WATER VILLAGE WELL SITE, LLC",
    "display_name": "BLUE WATER VILLAGE WELL SITE, LLC",
    "county": "EATON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000795",
    "resolved_pwsid": "MI0000795",
    "system_name": "BLUE WATER VILLAGE WELL SITE, LLC",
    "display_name": "BLUE WATER VILLAGE WELL SITE, LLC",
    "county": "EATON",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0000796",
    "resolved_pwsid": "MI0000796",
    "system_name": "GENERAL WHITE APARTMENTS",
    "display_name": "GENERAL WHITE APARTMENTS",
    "county": "VAN BUREN",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000796",
    "resolved_pwsid": "MI0000796",
    "system_name": "GENERAL WHITE APARTMENTS",
    "display_name": "GENERAL WHITE APARTMENTS",
    "county": "VAN BUREN",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000796",
    "resolved_pwsid": "MI0000796",
    "system_name": "GENERAL WHITE APARTMENTS",
    "display_name": "GENERAL WHITE APARTMENTS",
    "county": "VAN BUREN",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000796",
    "resolved_pwsid": "MI0000796",
    "system_name": "GENERAL WHITE APARTMENTS",
    "display_name": "GENERAL WHITE APARTMENTS",
    "county": "VAN BUREN",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000796",
    "resolved_pwsid": "MI0000796",
    "system_name": "GENERAL WHITE APARTMENTS",
    "display_name": "GENERAL WHITE APARTMENTS",
    "county": "VAN BUREN",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0000798",
    "resolved_pwsid": "MI0000798",
    "system_name": "BLUMFIELD-REESE WATER AUTH.",
    "display_name": "BLUMFIELD-REESE WATER AUTH.",
    "county": "SAGINAW",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000798",
    "resolved_pwsid": "MI0000798",
    "system_name": "BLUMFIELD-REESE WATER AUTH.",
    "display_name": "BLUMFIELD-REESE WATER AUTH.",
    "county": "SAGINAW",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000798",
    "resolved_pwsid": "MI0000798",
    "system_name": "BLUMFIELD-REESE WATER AUTH.",
    "display_name": "BLUMFIELD-REESE WATER AUTH.",
    "county": "SAGINAW",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000798",
    "resolved_pwsid": "MI0000798",
    "system_name": "BLUMFIELD-REESE WATER AUTH.",
    "display_name": "BLUMFIELD-REESE WATER AUTH.",
    "county": "SAGINAW",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000798",
    "resolved_pwsid": "MI0000798",
    "system_name": "BLUMFIELD-REESE WATER AUTH.",
    "display_name": "BLUMFIELD-REESE WATER AUTH.",
    "county": "SAGINAW",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000798",
    "resolved_pwsid": "MI0000798",
    "system_name": "BLUMFIELD-REESE WATER AUTH.",
    "display_name": "BLUMFIELD-REESE WATER AUTH.",
    "county": "SAGINAW",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000798",
    "resolved_pwsid": "MI0000798",
    "system_name": "BLUMFIELD-REESE WATER AUTH.",
    "display_name": "BLUMFIELD-REESE WATER AUTH.",
    "county": "SAGINAW",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000799",
    "resolved_pwsid": "MI0000799",
    "system_name": "BOYNAIRE LANDOWNERS ASSOCIATION",
    "display_name": "BOYNAIRE LANDOWNERS ASSOCIATION",
    "county": "EMMET",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000799",
    "resolved_pwsid": "MI0000799",
    "system_name": "BOYNAIRE LANDOWNERS ASSOCIATION",
    "display_name": "BOYNAIRE LANDOWNERS ASSOCIATION",
    "county": "EMMET",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000799",
    "resolved_pwsid": "MI0000799",
    "system_name": "BOYNAIRE LANDOWNERS ASSOCIATION",
    "display_name": "BOYNAIRE LANDOWNERS ASSOCIATION",
    "county": "EMMET",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000800",
    "resolved_pwsid": "MI0000800",
    "system_name": "BOYNE CITY, CITY OF",
    "display_name": "BOYNE CITY, CITY OF",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000800",
    "resolved_pwsid": "MI0000800",
    "system_name": "BOYNE CITY, CITY OF",
    "display_name": "BOYNE CITY, CITY OF",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000800",
    "resolved_pwsid": "MI0000800",
    "system_name": "BOYNE CITY, CITY OF",
    "display_name": "BOYNE CITY, CITY OF",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000800",
    "resolved_pwsid": "MI0000800",
    "system_name": "BOYNE CITY, CITY OF",
    "display_name": "BOYNE CITY, CITY OF",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 64,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000810",
    "resolved_pwsid": "MI0000810",
    "system_name": "BOYNE FALLS, VILLAGE OF",
    "display_name": "BOYNE FALLS, VILLAGE OF",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000810",
    "resolved_pwsid": "MI0000810",
    "system_name": "BOYNE FALLS, VILLAGE OF",
    "display_name": "BOYNE FALLS, VILLAGE OF",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000810",
    "resolved_pwsid": "MI0000810",
    "system_name": "BOYNE FALLS, VILLAGE OF",
    "display_name": "BOYNE FALLS, VILLAGE OF",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000810",
    "resolved_pwsid": "MI0000810",
    "system_name": "BOYNE FALLS, VILLAGE OF",
    "display_name": "BOYNE FALLS, VILLAGE OF",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0000813",
    "resolved_pwsid": "MI0000813-a",
    "system_name": "BOYNE HIGHLANDS RESORT",
    "display_name": "BOYNE HIGHLANDS RESORT",
    "county": "EMMET",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 10,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000813",
    "resolved_pwsid": "MI0000813-a",
    "system_name": "BOYNE HIGHLANDS RESORT",
    "display_name": "BOYNE HIGHLANDS RESORT",
    "county": "EMMET",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 9,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000813",
    "resolved_pwsid": "MI0000813-b",
    "system_name": "HIGHLANDS AT HARBOR SPRINGS",
    "display_name": "HIGHLANDS AT HARBOR SPRINGS",
    "county": "EMMET",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000815",
    "resolved_pwsid": "MI0000815",
    "system_name": "BOYNE MOUNTAIN RESORT",
    "display_name": "BOYNE MOUNTAIN RESORT",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000815",
    "resolved_pwsid": "MI0000815",
    "system_name": "BOYNE MOUNTAIN RESORT",
    "display_name": "BOYNE MOUNTAIN RESORT",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000815",
    "resolved_pwsid": "MI0000815",
    "system_name": "BOYNE MOUNTAIN RESORT",
    "display_name": "BOYNE MOUNTAIN RESORT",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 26,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000815",
    "resolved_pwsid": "MI0000815",
    "system_name": "BOYNE MOUNTAIN RESORT",
    "display_name": "BOYNE MOUNTAIN RESORT",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "2024-06-30",
    "year": 2024,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000815",
    "resolved_pwsid": "MI0000815",
    "system_name": "BOYNE MOUNTAIN RESORT",
    "display_name": "BOYNE MOUNTAIN RESORT",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000815",
    "resolved_pwsid": "MI0000815",
    "system_name": "BOYNE MOUNTAIN RESORT",
    "display_name": "BOYNE MOUNTAIN RESORT",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0000820",
    "resolved_pwsid": "MI0000820",
    "system_name": "BRECKENRIDGE, VILLAGE OF",
    "display_name": "BRECKENRIDGE, VILLAGE OF",
    "county": "GRATIOT",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000820",
    "resolved_pwsid": "MI0000820",
    "system_name": "BRECKENRIDGE, VILLAGE OF",
    "display_name": "BRECKENRIDGE, VILLAGE OF",
    "county": "GRATIOT",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000820",
    "resolved_pwsid": "MI0000820",
    "system_name": "BRECKENRIDGE, VILLAGE OF",
    "display_name": "BRECKENRIDGE, VILLAGE OF",
    "county": "GRATIOT",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000838",
    "resolved_pwsid": "MI0000838",
    "system_name": "RIDGE VALLEY OF MILFORD",
    "display_name": "RIDGE VALLEY OF MILFORD",
    "county": "OAKLAND",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000838",
    "resolved_pwsid": "MI0000838",
    "system_name": "RIDGE VALLEY OF MILFORD",
    "display_name": "RIDGE VALLEY OF MILFORD",
    "county": "OAKLAND",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 15,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000838",
    "resolved_pwsid": "MI0000838",
    "system_name": "RIDGE VALLEY OF MILFORD",
    "display_name": "RIDGE VALLEY OF MILFORD",
    "county": "OAKLAND",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000838",
    "resolved_pwsid": "MI0000838",
    "system_name": "RIDGE VALLEY OF MILFORD",
    "display_name": "RIDGE VALLEY OF MILFORD",
    "county": "OAKLAND",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0000840",
    "resolved_pwsid": "MI0000840",
    "system_name": "BRIDGEPORT TOWNSHIP",
    "display_name": "BRIDGEPORT TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000840",
    "resolved_pwsid": "MI0000840",
    "system_name": "BRIDGEPORT TOWNSHIP",
    "display_name": "BRIDGEPORT TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000840",
    "resolved_pwsid": "MI0000840",
    "system_name": "BRIDGEPORT TOWNSHIP",
    "display_name": "BRIDGEPORT TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000840",
    "resolved_pwsid": "MI0000840",
    "system_name": "BRIDGEPORT TOWNSHIP",
    "display_name": "BRIDGEPORT TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000840",
    "resolved_pwsid": "MI0000840",
    "system_name": "BRIDGEPORT TOWNSHIP",
    "display_name": "BRIDGEPORT TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000840",
    "resolved_pwsid": "MI0000840",
    "system_name": "BRIDGEPORT TOWNSHIP",
    "display_name": "BRIDGEPORT TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000840",
    "resolved_pwsid": "MI0000840",
    "system_name": "BRIDGEPORT TOWNSHIP",
    "display_name": "BRIDGEPORT TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000850",
    "resolved_pwsid": "MI0000850",
    "system_name": "BRIDGMAN",
    "display_name": "BRIDGMAN",
    "county": "BERRIEN",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000850",
    "resolved_pwsid": "MI0000850",
    "system_name": "BRIDGMAN",
    "display_name": "BRIDGMAN",
    "county": "BERRIEN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000850",
    "resolved_pwsid": "MI0000850",
    "system_name": "BRIDGMAN",
    "display_name": "BRIDGMAN",
    "county": "BERRIEN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000850",
    "resolved_pwsid": "MI0000850",
    "system_name": "BRIDGMAN",
    "display_name": "BRIDGMAN",
    "county": "BERRIEN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000860",
    "resolved_pwsid": "MI0000860",
    "system_name": "BRIGHTON, CITY OF",
    "display_name": "BRIGHTON, CITY OF",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000860",
    "resolved_pwsid": "MI0000860",
    "system_name": "BRIGHTON, CITY OF",
    "display_name": "BRIGHTON, CITY OF",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000860",
    "resolved_pwsid": "MI0000860",
    "system_name": "BRIGHTON, CITY OF",
    "display_name": "BRIGHTON, CITY OF",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000860",
    "resolved_pwsid": "MI0000860",
    "system_name": "BRIGHTON, CITY OF",
    "display_name": "BRIGHTON, CITY OF",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000860",
    "resolved_pwsid": "MI0000860",
    "system_name": "BRIGHTON, CITY OF",
    "display_name": "BRIGHTON, CITY OF",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2022-06-30",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000860",
    "resolved_pwsid": "MI0000860",
    "system_name": "BRIGHTON, CITY OF",
    "display_name": "BRIGHTON, CITY OF",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000860",
    "resolved_pwsid": "MI0000860",
    "system_name": "BRIGHTON, CITY OF",
    "display_name": "BRIGHTON, CITY OF",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2023-06-30",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000860",
    "resolved_pwsid": "MI0000860",
    "system_name": "BRIGHTON, CITY OF",
    "display_name": "BRIGHTON, CITY OF",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000860",
    "resolved_pwsid": "MI0000860",
    "system_name": "BRIGHTON, CITY OF",
    "display_name": "BRIGHTON, CITY OF",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000860",
    "resolved_pwsid": "MI0000860",
    "system_name": "BRIGHTON, CITY OF",
    "display_name": "BRIGHTON, CITY OF",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0000877",
    "resolved_pwsid": "MI0000877",
    "system_name": "BRILEY TOWNSHIP",
    "display_name": "BRILEY TOWNSHIP",
    "county": "MONTMORENCY",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 17,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000877",
    "resolved_pwsid": "MI0000877",
    "system_name": "BRILEY TOWNSHIP",
    "display_name": "BRILEY TOWNSHIP",
    "county": "MONTMORENCY",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000877",
    "resolved_pwsid": "MI0000877",
    "system_name": "BRILEY TOWNSHIP",
    "display_name": "BRILEY TOWNSHIP",
    "county": "MONTMORENCY",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000877",
    "resolved_pwsid": "MI0000877",
    "system_name": "BRILEY TOWNSHIP",
    "display_name": "BRILEY TOWNSHIP",
    "county": "MONTMORENCY",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000877",
    "resolved_pwsid": "MI0000877",
    "system_name": "BRILEY TOWNSHIP",
    "display_name": "BRILEY TOWNSHIP",
    "county": "MONTMORENCY",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000877",
    "resolved_pwsid": "MI0000877",
    "system_name": "BRILEY TOWNSHIP",
    "display_name": "BRILEY TOWNSHIP",
    "county": "MONTMORENCY",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000877",
    "resolved_pwsid": "MI0000877",
    "system_name": "BRILEY TOWNSHIP",
    "display_name": "BRILEY TOWNSHIP",
    "county": "MONTMORENCY",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000877",
    "resolved_pwsid": "MI0000877",
    "system_name": "BRILEY TOWNSHIP",
    "display_name": "BRILEY TOWNSHIP",
    "county": "MONTMORENCY",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000877",
    "resolved_pwsid": "MI0000877",
    "system_name": "BRILEY TOWNSHIP",
    "display_name": "BRILEY TOWNSHIP",
    "county": "MONTMORENCY",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0000880",
    "resolved_pwsid": "MI0000880",
    "system_name": "SUPERIOR TOWNSHIP",
    "display_name": "SUPERIOR TOWNSHIP",
    "county": "CHIPPEWA",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000880",
    "resolved_pwsid": "MI0000880",
    "system_name": "SUPERIOR TOWNSHIP",
    "display_name": "SUPERIOR TOWNSHIP",
    "county": "CHIPPEWA",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000880",
    "resolved_pwsid": "MI0000880",
    "system_name": "SUPERIOR TOWNSHIP",
    "display_name": "SUPERIOR TOWNSHIP",
    "county": "CHIPPEWA",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000880",
    "resolved_pwsid": "MI0000880",
    "system_name": "SUPERIOR TOWNSHIP",
    "display_name": "SUPERIOR TOWNSHIP",
    "county": "CHIPPEWA",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0000890",
    "resolved_pwsid": "MI0000890",
    "system_name": "BRITTON",
    "display_name": "BRITTON",
    "county": "LENAWEE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000890",
    "resolved_pwsid": "MI0000890",
    "system_name": "BRITTON",
    "display_name": "BRITTON",
    "county": "LENAWEE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000890",
    "resolved_pwsid": "MI0000890",
    "system_name": "BRITTON",
    "display_name": "BRITTON",
    "county": "LENAWEE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000890",
    "resolved_pwsid": "MI0000890",
    "system_name": "BRITTON",
    "display_name": "BRITTON",
    "county": "LENAWEE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000894",
    "resolved_pwsid": "MI0000894",
    "system_name": "BROOK OF HOUGHTON LAKE",
    "display_name": "BROOK OF HOUGHTON LAKE",
    "county": "ROSCOMMON",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000894",
    "resolved_pwsid": "MI0000894",
    "system_name": "BROOK OF HOUGHTON LAKE",
    "display_name": "BROOK OF HOUGHTON LAKE",
    "county": "ROSCOMMON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000894",
    "resolved_pwsid": "MI0000894",
    "system_name": "BROOK OF HOUGHTON LAKE",
    "display_name": "BROOK OF HOUGHTON LAKE",
    "county": "ROSCOMMON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000910",
    "resolved_pwsid": "MI0000910",
    "system_name": "BRONSON",
    "display_name": "BRONSON",
    "county": "BRANCH",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000910",
    "resolved_pwsid": "MI0000910",
    "system_name": "BRONSON",
    "display_name": "BRONSON",
    "county": "BRANCH",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000910",
    "resolved_pwsid": "MI0000910",
    "system_name": "BRONSON",
    "display_name": "BRONSON",
    "county": "BRANCH",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 13,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000910",
    "resolved_pwsid": "MI0000910",
    "system_name": "BRONSON",
    "display_name": "BRONSON",
    "county": "BRANCH",
    "monitoring_end_date": "",
    "year": 2022,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 4,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000910",
    "resolved_pwsid": "MI0000910",
    "system_name": "BRONSON",
    "display_name": "BRONSON",
    "county": "BRANCH",
    "monitoring_end_date": "",
    "year": 2023,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 4,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000910",
    "resolved_pwsid": "MI0000910",
    "system_name": "BRONSON",
    "display_name": "BRONSON",
    "county": "BRANCH",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 12,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000920",
    "resolved_pwsid": "MI0000920",
    "system_name": "BROOKLYN",
    "display_name": "BROOKLYN",
    "county": "JACKSON",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000920",
    "resolved_pwsid": "MI0000920",
    "system_name": "BROOKLYN",
    "display_name": "BROOKLYN",
    "county": "JACKSON",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000920",
    "resolved_pwsid": "MI0000920",
    "system_name": "BROOKLYN",
    "display_name": "BROOKLYN",
    "county": "JACKSON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000930",
    "resolved_pwsid": "MI0000930",
    "system_name": "BROWN CITY",
    "display_name": "BROWN CITY",
    "county": "SANILAC",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000930",
    "resolved_pwsid": "MI0000930",
    "system_name": "BROWN CITY",
    "display_name": "BROWN CITY",
    "county": "SANILAC",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": 5,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000930",
    "resolved_pwsid": "MI0000930",
    "system_name": "BROWN CITY",
    "display_name": "BROWN CITY",
    "county": "SANILAC",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000930",
    "resolved_pwsid": "MI0000930",
    "system_name": "BROWN CITY",
    "display_name": "BROWN CITY",
    "county": "SANILAC",
    "monitoring_end_date": "",
    "year": 2023,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000940",
    "resolved_pwsid": "MI0000940",
    "system_name": "BROWNSTOWN TOWNSHIP",
    "display_name": "BROWNSTOWN TOWNSHIP",
    "county": "WAYNE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000940",
    "resolved_pwsid": "MI0000940",
    "system_name": "BROWNSTOWN TOWNSHIP",
    "display_name": "BROWNSTOWN TOWNSHIP",
    "county": "WAYNE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000940",
    "resolved_pwsid": "MI0000940",
    "system_name": "BROWNSTOWN TOWNSHIP",
    "display_name": "BROWNSTOWN TOWNSHIP",
    "county": "WAYNE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000940",
    "resolved_pwsid": "MI0000940",
    "system_name": "BROWNSTOWN TOWNSHIP",
    "display_name": "BROWNSTOWN TOWNSHIP",
    "county": "WAYNE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000940",
    "resolved_pwsid": "MI0000940",
    "system_name": "BROWNSTOWN TOWNSHIP",
    "display_name": "BROWNSTOWN TOWNSHIP",
    "county": "WAYNE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000940",
    "resolved_pwsid": "MI0000940",
    "system_name": "BROWNSTOWN TOWNSHIP",
    "display_name": "BROWNSTOWN TOWNSHIP",
    "county": "WAYNE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000940",
    "resolved_pwsid": "MI0000940",
    "system_name": "BROWNSTOWN TOWNSHIP",
    "display_name": "BROWNSTOWN TOWNSHIP",
    "county": "WAYNE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 8,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000940",
    "resolved_pwsid": "MI0000940",
    "system_name": "BROWNSTOWN TOWNSHIP",
    "display_name": "BROWNSTOWN TOWNSHIP",
    "county": "WAYNE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 11,
    "inventory_lead": 7,
    "inventory_gpcl": 6,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000951",
    "resolved_pwsid": "MI0000951",
    "system_name": "BRUCE TOWNSHIP",
    "display_name": "BRUCE TOWNSHIP",
    "county": "MACOMB",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000951",
    "resolved_pwsid": "MI0000951",
    "system_name": "BRUCE TOWNSHIP",
    "display_name": "BRUCE TOWNSHIP",
    "county": "MACOMB",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000951",
    "resolved_pwsid": "MI0000951",
    "system_name": "BRUCE TOWNSHIP",
    "display_name": "BRUCE TOWNSHIP",
    "county": "MACOMB",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000951",
    "resolved_pwsid": "MI0000951",
    "system_name": "BRUCE TOWNSHIP",
    "display_name": "BRUCE TOWNSHIP",
    "county": "MACOMB",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000951",
    "resolved_pwsid": "MI0000951",
    "system_name": "BRUCE TOWNSHIP",
    "display_name": "BRUCE TOWNSHIP",
    "county": "MACOMB",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000951",
    "resolved_pwsid": "MI0000951",
    "system_name": "BRUCE TOWNSHIP",
    "display_name": "BRUCE TOWNSHIP",
    "county": "MACOMB",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0000960",
    "resolved_pwsid": "MI0000960",
    "system_name": "BUCHANAN",
    "display_name": "BUCHANAN",
    "county": "BERRIEN",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000960",
    "resolved_pwsid": "MI0000960",
    "system_name": "BUCHANAN",
    "display_name": "BUCHANAN",
    "county": "BERRIEN",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000960",
    "resolved_pwsid": "MI0000960",
    "system_name": "BUCHANAN",
    "display_name": "BUCHANAN",
    "county": "BERRIEN",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 2,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000960",
    "resolved_pwsid": "MI0000960",
    "system_name": "BUCHANAN",
    "display_name": "BUCHANAN",
    "county": "BERRIEN",
    "monitoring_end_date": "",
    "year": 2022,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000960",
    "resolved_pwsid": "MI0000960",
    "system_name": "BUCHANAN",
    "display_name": "BUCHANAN",
    "county": "BERRIEN",
    "monitoring_end_date": "",
    "year": 2024,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 10,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000960",
    "resolved_pwsid": "MI0000960",
    "system_name": "BUCHANAN",
    "display_name": "BUCHANAN",
    "county": "BERRIEN",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 85,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000970",
    "resolved_pwsid": "MI0000970",
    "system_name": "BUCKLEY, VILLAGE OF",
    "display_name": "BUCKLEY, VILLAGE OF",
    "county": "WEXFORD",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 10,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000970",
    "resolved_pwsid": "MI0000970",
    "system_name": "BUCKLEY, VILLAGE OF",
    "display_name": "BUCKLEY, VILLAGE OF",
    "county": "WEXFORD",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000970",
    "resolved_pwsid": "MI0000970",
    "system_name": "BUCKLEY, VILLAGE OF",
    "display_name": "BUCKLEY, VILLAGE OF",
    "county": "WEXFORD",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000980",
    "resolved_pwsid": "MI0000980",
    "system_name": "BUENA VISTA TOWNSHIP",
    "display_name": "BUENA VISTA TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000980",
    "resolved_pwsid": "MI0000980",
    "system_name": "BUENA VISTA TOWNSHIP",
    "display_name": "BUENA VISTA TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000980",
    "resolved_pwsid": "MI0000980",
    "system_name": "BUENA VISTA TOWNSHIP",
    "display_name": "BUENA VISTA TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000980",
    "resolved_pwsid": "MI0000980",
    "system_name": "BUENA VISTA TOWNSHIP",
    "display_name": "BUENA VISTA TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000980",
    "resolved_pwsid": "MI0000980",
    "system_name": "BUENA VISTA TOWNSHIP",
    "display_name": "BUENA VISTA TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000980",
    "resolved_pwsid": "MI0000980",
    "system_name": "BUENA VISTA TOWNSHIP",
    "display_name": "BUENA VISTA TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000980",
    "resolved_pwsid": "MI0000980",
    "system_name": "BUENA VISTA TOWNSHIP",
    "display_name": "BUENA VISTA TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0000980",
    "resolved_pwsid": "MI0000980",
    "system_name": "BUENA VISTA TOWNSHIP",
    "display_name": "BUENA VISTA TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 1637,
    "total_to_identify_or_replace": 1637,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0001000",
    "resolved_pwsid": "MI0001000",
    "system_name": "BURR OAK",
    "display_name": "BURR OAK",
    "county": "ST JOSEPH",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001000",
    "resolved_pwsid": "MI0001000",
    "system_name": "BURR OAK",
    "display_name": "BURR OAK",
    "county": "ST JOSEPH",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001000",
    "resolved_pwsid": "MI0001000",
    "system_name": "BURR OAK",
    "display_name": "BURR OAK",
    "county": "ST JOSEPH",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001000",
    "resolved_pwsid": "MI0001000",
    "system_name": "BURR OAK",
    "display_name": "BURR OAK",
    "county": "ST JOSEPH",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001000",
    "resolved_pwsid": "MI0001000",
    "system_name": "BURR OAK",
    "display_name": "BURR OAK",
    "county": "ST. JOSEPH",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001000",
    "resolved_pwsid": "MI0001000",
    "system_name": "BURR OAK",
    "display_name": "BURR OAK",
    "county": "ST. JOSEPH",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001000",
    "resolved_pwsid": "MI0001000",
    "system_name": "BURR OAK",
    "display_name": "BURR OAK",
    "county": "ST. JOSEPH",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001000",
    "resolved_pwsid": "MI0001000",
    "system_name": "BURR OAK",
    "display_name": "BURR OAK",
    "county": "ST. JOSEPH",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 272,
    "total_to_identify_or_replace": 272,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0001002",
    "resolved_pwsid": "MI0001002",
    "system_name": "OAK POINTE",
    "display_name": "OAK POINTE",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001002",
    "resolved_pwsid": "MI0001002",
    "system_name": "OAK POINTE",
    "display_name": "OAK POINTE",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001002",
    "resolved_pwsid": "MI0001002",
    "system_name": "OAK POINTE",
    "display_name": "OAK POINTE",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001002",
    "resolved_pwsid": "MI0001002",
    "system_name": "OAK POINTE",
    "display_name": "OAK POINTE",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001002",
    "resolved_pwsid": "MI0001002",
    "system_name": "OAK POINTE",
    "display_name": "OAK POINTE",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001002",
    "resolved_pwsid": "MI0001002",
    "system_name": "OAK POINTE",
    "display_name": "OAK POINTE",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001002",
    "resolved_pwsid": "MI0001002",
    "system_name": "OAK POINTE",
    "display_name": "OAK POINTE",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2024-06-30",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001002",
    "resolved_pwsid": "MI0001002",
    "system_name": "OAK POINTE",
    "display_name": "OAK POINTE",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0001005",
    "resolved_pwsid": "MI0001005",
    "system_name": "BURT VIEW ASSOCIATION",
    "display_name": "BURT VIEW ASSOCIATION",
    "county": "CHEBOYGAN",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001005",
    "resolved_pwsid": "MI0001005",
    "system_name": "BURT VIEW ASSOCIATION",
    "display_name": "BURT VIEW ASSOCIATION",
    "county": "CHEBOYGAN",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001005",
    "resolved_pwsid": "MI0001005",
    "system_name": "BURT VIEW ASSOCIATION",
    "display_name": "BURT VIEW ASSOCIATION",
    "county": "CHEBOYGAN",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001005",
    "resolved_pwsid": "MI0001005",
    "system_name": "BURT VIEW ASSOCIATION",
    "display_name": "BURT VIEW ASSOCIATION",
    "county": "CHEBOYGAN",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0001008",
    "resolved_pwsid": "MI0001008",
    "system_name": "BURTCHVILLE TOWNSHIP",
    "display_name": "BURTCHVILLE TOWNSHIP",
    "county": "ST CLAIR",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001008",
    "resolved_pwsid": "MI0001008",
    "system_name": "BURTCHVILLE TOWNSHIP",
    "display_name": "BURTCHVILLE TOWNSHIP",
    "county": "ST CLAIR",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001008",
    "resolved_pwsid": "MI0001008",
    "system_name": "BURTCHVILLE TOWNSHIP",
    "display_name": "BURTCHVILLE TOWNSHIP",
    "county": "ST CLAIR",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001008",
    "resolved_pwsid": "MI0001008",
    "system_name": "BURTCHVILLE TOWNSHIP",
    "display_name": "BURTCHVILLE TOWNSHIP",
    "county": "ST CLAIR",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001008",
    "resolved_pwsid": "MI0001008",
    "system_name": "BURTCHVILLE TOWNSHIP",
    "display_name": "BURTCHVILLE TOWNSHIP",
    "county": "ST. CLAIR",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001008",
    "resolved_pwsid": "MI0001008",
    "system_name": "BURTCHVILLE TOWNSHIP",
    "display_name": "BURTCHVILLE TOWNSHIP",
    "county": "ST. CLAIR",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001008",
    "resolved_pwsid": "MI0001008",
    "system_name": "BURTCHVILLE TOWNSHIP",
    "display_name": "BURTCHVILLE TOWNSHIP",
    "county": "ST. CLAIR",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001008",
    "resolved_pwsid": "MI0001008",
    "system_name": "BURTCHVILLE TOWNSHIP",
    "display_name": "BURTCHVILLE TOWNSHIP",
    "county": "ST. CLAIR",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0001010",
    "resolved_pwsid": "MI0001010",
    "system_name": "BURTON, CITY OF",
    "display_name": "BURTON, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001010",
    "resolved_pwsid": "MI0001010",
    "system_name": "BURTON, CITY OF",
    "display_name": "BURTON, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001010",
    "resolved_pwsid": "MI0001010",
    "system_name": "BURTON, CITY OF",
    "display_name": "BURTON, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001010",
    "resolved_pwsid": "MI0001010",
    "system_name": "BURTON, CITY OF",
    "display_name": "BURTON, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001010",
    "resolved_pwsid": "MI0001010",
    "system_name": "BURTON, CITY OF",
    "display_name": "BURTON, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2021-06-30",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001010",
    "resolved_pwsid": "MI0001010",
    "system_name": "BURTON, CITY OF",
    "display_name": "BURTON, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001010",
    "resolved_pwsid": "MI0001010",
    "system_name": "BURTON, CITY OF",
    "display_name": "BURTON, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001010",
    "resolved_pwsid": "MI0001010",
    "system_name": "BURTON, CITY OF",
    "display_name": "BURTON, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001010",
    "resolved_pwsid": "MI0001010",
    "system_name": "BURTON, CITY OF",
    "display_name": "BURTON, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001015",
    "resolved_pwsid": "MI0001015",
    "system_name": "BUTTERCUP SHORES",
    "display_name": "BUTTERCUP SHORES",
    "county": "BENZIE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001015",
    "resolved_pwsid": "MI0001015",
    "system_name": "BUTTERCUP SHORES",
    "display_name": "BUTTERCUP SHORES",
    "county": "BENZIE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001015",
    "resolved_pwsid": "MI0001015",
    "system_name": "BUTTERCUP SHORES",
    "display_name": "BUTTERCUP SHORES",
    "county": "BENZIE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001018",
    "resolved_pwsid": "MI0001018",
    "system_name": "BUTTERFIELD WOODS SUBDIVISION",
    "display_name": "BUTTERFIELD WOODS SUBDIVISION",
    "county": "MUSKEGON",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001018",
    "resolved_pwsid": "MI0001018",
    "system_name": "BUTTERFIELD WOODS SUBDIVISION",
    "display_name": "BUTTERFIELD WOODS SUBDIVISION",
    "county": "MUSKEGON",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001018",
    "resolved_pwsid": "MI0001018",
    "system_name": "BUTTERFIELD WOODS SUBDIVISION",
    "display_name": "BUTTERFIELD WOODS SUBDIVISION",
    "county": "MUSKEGON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001018",
    "resolved_pwsid": "MI0001018",
    "system_name": "BUTTERFIELD WOODS SUBDIVISION",
    "display_name": "BUTTERFIELD WOODS SUBDIVISION",
    "county": "MUSKEGON",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0001019",
    "resolved_pwsid": "MI0001019",
    "system_name": "BYRAM RIDGE",
    "display_name": "BYRAM RIDGE",
    "county": "GENESEE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001019",
    "resolved_pwsid": "MI0001019",
    "system_name": "BYRAM RIDGE",
    "display_name": "BYRAM RIDGE",
    "county": "GENESEE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001019",
    "resolved_pwsid": "MI0001019",
    "system_name": "BYRAM RIDGE",
    "display_name": "BYRAM RIDGE",
    "county": "GENESEE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001019",
    "resolved_pwsid": "MI0001019",
    "system_name": "BYRAM RIDGE",
    "display_name": "BYRAM RIDGE",
    "county": "GENESEE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001020",
    "resolved_pwsid": "MI0001020",
    "system_name": "BYRON, VILLAGE OF",
    "display_name": "BYRON, VILLAGE OF",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001020",
    "resolved_pwsid": "MI0001020",
    "system_name": "BYRON, VILLAGE OF",
    "display_name": "BYRON, VILLAGE OF",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001020",
    "resolved_pwsid": "MI0001020",
    "system_name": "BYRON, VILLAGE OF",
    "display_name": "BYRON, VILLAGE OF",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001023",
    "resolved_pwsid": "MI0001023",
    "system_name": "BYRON-GAINES UTILITY AUTHORITY",
    "display_name": "BYRON-GAINES UTILITY AUTHORITY",
    "county": "KENT",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001023",
    "resolved_pwsid": "MI0001023",
    "system_name": "BYRON-GAINES UTILITY AUTHORITY",
    "display_name": "BYRON-GAINES UTILITY AUTHORITY",
    "county": "KENT",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001023",
    "resolved_pwsid": "MI0001023",
    "system_name": "BYRON-GAINES UTILITY AUTHORITY",
    "display_name": "BYRON-GAINES UTILITY AUTHORITY",
    "county": "KENT",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001023",
    "resolved_pwsid": "MI0001023",
    "system_name": "BYRON-GAINES UTILITY AUTHORITY",
    "display_name": "BYRON-GAINES UTILITY AUTHORITY",
    "county": "KENT",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0001030",
    "resolved_pwsid": "MI0001030",
    "system_name": "CADILLAC, CITY OF",
    "display_name": "CADILLAC, CITY OF",
    "county": "WEXFORD",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001030",
    "resolved_pwsid": "MI0001030",
    "system_name": "CADILLAC, CITY OF",
    "display_name": "CADILLAC, CITY OF",
    "county": "WEXFORD",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001030",
    "resolved_pwsid": "MI0001030",
    "system_name": "CADILLAC, CITY OF",
    "display_name": "CADILLAC, CITY OF",
    "county": "WEXFORD",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001030",
    "resolved_pwsid": "MI0001030",
    "system_name": "CADILLAC, CITY OF",
    "display_name": "CADILLAC, CITY OF",
    "county": "WEXFORD",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": 0,
    "inventory_gpcl": 98,
    "inventory_unknown": 333,
    "total_to_identify_or_replace": 431,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0001037",
    "resolved_pwsid": "MI0001037",
    "system_name": "CALEDONIA ESTATES",
    "display_name": "CALEDONIA ESTATES",
    "county": "KENT",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001037",
    "resolved_pwsid": "MI0001037",
    "system_name": "CALEDONIA ESTATES",
    "display_name": "CALEDONIA ESTATES",
    "county": "KENT",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001037",
    "resolved_pwsid": "MI0001037",
    "system_name": "CALEDONIA ESTATES",
    "display_name": "CALEDONIA ESTATES",
    "county": "KENT",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001037",
    "resolved_pwsid": "MI0001037",
    "system_name": "CALEDONIA ESTATES",
    "display_name": "CALEDONIA ESTATES",
    "county": "KENT",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001037",
    "resolved_pwsid": "MI0001037",
    "system_name": "CALEDONIA ESTATES",
    "display_name": "CALEDONIA ESTATES",
    "county": "KENT",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001037",
    "resolved_pwsid": "MI0001037",
    "system_name": "CALEDONIA ESTATES",
    "display_name": "CALEDONIA ESTATES",
    "county": "KENT",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0001039",
    "resolved_pwsid": "MI0001039",
    "system_name": "CALEDONIA TOWNSHIP",
    "display_name": "CALEDONIA TOWNSHIP",
    "county": "KENT",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001039",
    "resolved_pwsid": "MI0001039",
    "system_name": "CALEDONIA TOWNSHIP",
    "display_name": "CALEDONIA TOWNSHIP",
    "county": "KENT",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001039",
    "resolved_pwsid": "MI0001039",
    "system_name": "CALEDONIA TOWNSHIP",
    "display_name": "CALEDONIA TOWNSHIP",
    "county": "KENT",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001039",
    "resolved_pwsid": "MI0001039",
    "system_name": "CALEDONIA TOWNSHIP",
    "display_name": "CALEDONIA TOWNSHIP",
    "county": "KENT",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001039",
    "resolved_pwsid": "MI0001039",
    "system_name": "CALEDONIA TOWNSHIP",
    "display_name": "CALEDONIA TOWNSHIP",
    "county": "KENT",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001039",
    "resolved_pwsid": "MI0001039",
    "system_name": "CALEDONIA TOWNSHIP",
    "display_name": "CALEDONIA TOWNSHIP",
    "county": "KENT",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001039",
    "resolved_pwsid": "MI0001039",
    "system_name": "CALEDONIA TOWNSHIP",
    "display_name": "CALEDONIA TOWNSHIP",
    "county": "KENT",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001039",
    "resolved_pwsid": "MI0001039",
    "system_name": "CALEDONIA TOWNSHIP",
    "display_name": "CALEDONIA TOWNSHIP",
    "county": "KENT",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001039",
    "resolved_pwsid": "MI0001039",
    "system_name": "CALEDONIA TOWNSHIP",
    "display_name": "CALEDONIA TOWNSHIP",
    "county": "KENT",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0001039",
    "resolved_pwsid": "MI0001039-a",
    "system_name": "CALEDONIA TOWNSHIP (DS002)",
    "display_name": "CALEDONIA TOWNSHIP (DS002)",
    "county": "KENT",
    "monitoring_end_date": "2026-06-30",
    "year": 2026,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001039",
    "resolved_pwsid": "MI0001039-b",
    "system_name": "CALEDONIA TOWNSHIP (DS003)",
    "display_name": "CALEDONIA TOWNSHIP (DS003)",
    "county": "KENT",
    "monitoring_end_date": "2026-06-30",
    "year": 2026,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001040",
    "resolved_pwsid": "MI0001040",
    "system_name": "CALUMET",
    "display_name": "CALUMET",
    "county": "HOUGHTON",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001040",
    "resolved_pwsid": "MI0001040",
    "system_name": "CALUMET",
    "display_name": "CALUMET",
    "county": "HOUGHTON",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001040",
    "resolved_pwsid": "MI0001040",
    "system_name": "CALUMET",
    "display_name": "CALUMET",
    "county": "HOUGHTON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001040",
    "resolved_pwsid": "MI0001040",
    "system_name": "CALUMET",
    "display_name": "CALUMET",
    "county": "HOUGHTON",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 15,
    "total_to_identify_or_replace": 15,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0001046",
    "resolved_pwsid": "MI0001046",
    "system_name": "CALUMET TOWNSHIP",
    "display_name": "CALUMET TOWNSHIP",
    "county": "HOUGHTON",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001046",
    "resolved_pwsid": "MI0001046",
    "system_name": "CALUMET TOWNSHIP",
    "display_name": "CALUMET TOWNSHIP",
    "county": "HOUGHTON",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001046",
    "resolved_pwsid": "MI0001046",
    "system_name": "CALUMET TOWNSHIP",
    "display_name": "CALUMET TOWNSHIP",
    "county": "HOUGHTON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001046",
    "resolved_pwsid": "MI0001046",
    "system_name": "CALUMET TOWNSHIP",
    "display_name": "CALUMET TOWNSHIP",
    "county": "HOUGHTON",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 6,
    "total_to_identify_or_replace": 6,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0001050",
    "resolved_pwsid": "MI0001050",
    "system_name": "CAMDEN",
    "display_name": "CAMDEN",
    "county": "HILLSDALE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001050",
    "resolved_pwsid": "MI0001050",
    "system_name": "CAMDEN",
    "display_name": "CAMDEN",
    "county": "HILLSDALE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001050",
    "resolved_pwsid": "MI0001050",
    "system_name": "CAMDEN",
    "display_name": "CAMDEN",
    "county": "HILLSDALE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001052",
    "resolved_pwsid": "MI0001052",
    "system_name": "CAMP ARCADIA / LCA",
    "display_name": "CAMP ARCADIA / LCA",
    "county": "MANISTEE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001052",
    "resolved_pwsid": "MI0001052",
    "system_name": "CAMP ARCADIA / LCA",
    "display_name": "CAMP ARCADIA / LCA",
    "county": "MANISTEE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001052",
    "resolved_pwsid": "MI0001052",
    "system_name": "CAMP ARCADIA / LCA",
    "display_name": "CAMP ARCADIA / LCA",
    "county": "MANISTEE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001067",
    "resolved_pwsid": "MI0001067",
    "system_name": "CROSSROADS FOR YOUTH",
    "display_name": "CROSSROADS FOR YOUTH",
    "county": "OAKLAND",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001067",
    "resolved_pwsid": "MI0001067",
    "system_name": "CROSSROADS FOR YOUTH",
    "display_name": "CROSSROADS FOR YOUTH",
    "county": "OAKLAND",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001067",
    "resolved_pwsid": "MI0001067",
    "system_name": "CROSSROADS FOR YOUTH",
    "display_name": "CROSSROADS FOR YOUTH",
    "county": "OAKLAND",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001067",
    "resolved_pwsid": "MI0001067",
    "system_name": "CROSSROADS FOR YOUTH",
    "display_name": "CROSSROADS FOR YOUTH",
    "county": "OAKLAND",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0001073",
    "resolved_pwsid": "MI0001073",
    "system_name": "SHAWONO CENTER - DHS",
    "display_name": "SHAWONO CENTER - DHS",
    "county": "CRAWFORD",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001073",
    "resolved_pwsid": "MI0001073",
    "system_name": "SHAWONO CENTER - DHS",
    "display_name": "SHAWONO CENTER - DHS",
    "county": "CRAWFORD",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001073",
    "resolved_pwsid": "MI0001073",
    "system_name": "SHAWONO CENTER - DHS",
    "display_name": "SHAWONO CENTER - DHS",
    "county": "CRAWFORD",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001100",
    "resolved_pwsid": "MI0001100",
    "system_name": "CANTON TOWNSHIP",
    "display_name": "CANTON TOWNSHIP",
    "county": "WAYNE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001100",
    "resolved_pwsid": "MI0001100",
    "system_name": "CANTON TOWNSHIP",
    "display_name": "CANTON TOWNSHIP",
    "county": "WAYNE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001100",
    "resolved_pwsid": "MI0001100",
    "system_name": "CANTON TOWNSHIP",
    "display_name": "CANTON TOWNSHIP",
    "county": "WAYNE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001100",
    "resolved_pwsid": "MI0001100",
    "system_name": "CANTON TOWNSHIP",
    "display_name": "CANTON TOWNSHIP",
    "county": "WAYNE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001100",
    "resolved_pwsid": "MI0001100",
    "system_name": "CANTON TOWNSHIP",
    "display_name": "CANTON TOWNSHIP",
    "county": "WAYNE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001100",
    "resolved_pwsid": "MI0001100",
    "system_name": "CANTON TOWNSHIP",
    "display_name": "CANTON TOWNSHIP",
    "county": "WAYNE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001100",
    "resolved_pwsid": "MI0001100",
    "system_name": "CANTON TOWNSHIP",
    "display_name": "CANTON TOWNSHIP",
    "county": "WAYNE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001100",
    "resolved_pwsid": "MI0001100",
    "system_name": "CANTON TOWNSHIP",
    "display_name": "CANTON TOWNSHIP",
    "county": "WAYNE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 2,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0001110",
    "resolved_pwsid": "MI0001110",
    "system_name": "CAPAC, VILLAGE OF",
    "display_name": "CAPAC, VILLAGE OF",
    "county": "ST CLAIR",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001110",
    "resolved_pwsid": "MI0001110",
    "system_name": "CAPAC, VILLAGE OF",
    "display_name": "CAPAC, VILLAGE OF",
    "county": "ST CLAIR",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001110",
    "resolved_pwsid": "MI0001110",
    "system_name": "CAPAC, VILLAGE OF",
    "display_name": "CAPAC, VILLAGE OF",
    "county": "ST. CLAIR",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001110",
    "resolved_pwsid": "MI0001110",
    "system_name": "CAPAC, VILLAGE OF",
    "display_name": "CAPAC, VILLAGE OF",
    "county": "ST. CLAIR",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 2,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0001125",
    "resolved_pwsid": "MI0001125",
    "system_name": "CARNEY-NADEAU WATER & SEWER AUTHORITY",
    "display_name": "CARNEY-NADEAU WATER & SEWER AUTHORITY",
    "county": "MENOMINEE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001125",
    "resolved_pwsid": "MI0001125",
    "system_name": "CARNEY-NADEAU WATER & SEWER AUTHORITY",
    "display_name": "CARNEY-NADEAU WATER & SEWER AUTHORITY",
    "county": "MENOMINEE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001125",
    "resolved_pwsid": "MI0001125",
    "system_name": "CARNEY-NADEAU WATER & SEWER AUTHORITY",
    "display_name": "CARNEY-NADEAU WATER & SEWER AUTHORITY",
    "county": "MENOMINEE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001130",
    "resolved_pwsid": "MI0001130",
    "system_name": "CARO, CITY OF",
    "display_name": "CARO, CITY OF",
    "county": "TUSCOLA",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001130",
    "resolved_pwsid": "MI0001130",
    "system_name": "CARO, CITY OF",
    "display_name": "CARO, CITY OF",
    "county": "TUSCOLA",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001130",
    "resolved_pwsid": "MI0001130",
    "system_name": "CARO, CITY OF",
    "display_name": "CARO, CITY OF",
    "county": "TUSCOLA",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": 6,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001130",
    "resolved_pwsid": "MI0001130",
    "system_name": "CARO, CITY OF",
    "display_name": "CARO, CITY OF",
    "county": "TUSCOLA",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001130",
    "resolved_pwsid": "MI0001130",
    "system_name": "CARO, CITY OF",
    "display_name": "CARO, CITY OF",
    "county": "TUSCOLA",
    "monitoring_end_date": "",
    "year": 2022,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 2,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001130",
    "resolved_pwsid": "MI0001130",
    "system_name": "CARO, CITY OF",
    "display_name": "CARO, CITY OF",
    "county": "TUSCOLA",
    "monitoring_end_date": "",
    "year": 2024,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 7,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001130",
    "resolved_pwsid": "MI0001130",
    "system_name": "CARO, CITY OF",
    "display_name": "CARO, CITY OF",
    "county": "TUSCOLA",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 6,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001140",
    "resolved_pwsid": "MI0001140",
    "system_name": "CARO CENTER",
    "display_name": "CARO CENTER",
    "county": "TUSCOLA",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001140",
    "resolved_pwsid": "MI0001140",
    "system_name": "CARO CENTER",
    "display_name": "CARO CENTER",
    "county": "TUSCOLA",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001140",
    "resolved_pwsid": "MI0001140",
    "system_name": "CARO CENTER",
    "display_name": "CARO CENTER",
    "county": "TUSCOLA",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001160",
    "resolved_pwsid": "MI0001160",
    "system_name": "CARROLLTON TOWNSHIP",
    "display_name": "CARROLLTON TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001160",
    "resolved_pwsid": "MI0001160",
    "system_name": "CARROLLTON TOWNSHIP",
    "display_name": "CARROLLTON TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001160",
    "resolved_pwsid": "MI0001160",
    "system_name": "CARROLLTON TOWNSHIP",
    "display_name": "CARROLLTON TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001160",
    "resolved_pwsid": "MI0001160",
    "system_name": "CARROLLTON TOWNSHIP",
    "display_name": "CARROLLTON TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001160",
    "resolved_pwsid": "MI0001160",
    "system_name": "CARROLLTON TOWNSHIP",
    "display_name": "CARROLLTON TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001160",
    "resolved_pwsid": "MI0001160",
    "system_name": "CARROLLTON TOWNSHIP",
    "display_name": "CARROLLTON TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001160",
    "resolved_pwsid": "MI0001160",
    "system_name": "CARROLLTON TOWNSHIP",
    "display_name": "CARROLLTON TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001170",
    "resolved_pwsid": "MI0001170",
    "system_name": "CARSON CITY",
    "display_name": "CARSON CITY",
    "county": "MONTCALM",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001170",
    "resolved_pwsid": "MI0001170",
    "system_name": "CARSON CITY",
    "display_name": "CARSON CITY",
    "county": "MONTCALM",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001170",
    "resolved_pwsid": "MI0001170",
    "system_name": "CARSON CITY",
    "display_name": "CARSON CITY",
    "county": "MONTCALM",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001170",
    "resolved_pwsid": "MI0001170",
    "system_name": "CARSON CITY",
    "display_name": "CARSON CITY",
    "county": "MONTCALM",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 34,
    "inventory_lead": 33,
    "inventory_gpcl": 85,
    "inventory_unknown": 213,
    "total_to_identify_or_replace": 331,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0001170",
    "resolved_pwsid": "MI0001170",
    "system_name": "CARSON CITY",
    "display_name": "CARSON CITY",
    "county": "MONTCALM",
    "monitoring_end_date": "",
    "year": 2024,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001180",
    "resolved_pwsid": "MI0001180",
    "system_name": "CARSONVILLE, VILLAGE OF",
    "display_name": "CARSONVILLE, VILLAGE OF",
    "county": "SANILAC",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001180",
    "resolved_pwsid": "MI0001180",
    "system_name": "CARSONVILLE, VILLAGE OF",
    "display_name": "CARSONVILLE, VILLAGE OF",
    "county": "SANILAC",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001180",
    "resolved_pwsid": "MI0001180",
    "system_name": "CARSONVILLE, VILLAGE OF",
    "display_name": "CARSONVILLE, VILLAGE OF",
    "county": "SANILAC",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001190",
    "resolved_pwsid": "MI0001190",
    "system_name": "CASEVILLE, CITY OF",
    "display_name": "CASEVILLE, CITY OF",
    "county": "HURON",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001190",
    "resolved_pwsid": "MI0001190",
    "system_name": "CASEVILLE, CITY OF",
    "display_name": "CASEVILLE, CITY OF",
    "county": "HURON",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001190",
    "resolved_pwsid": "MI0001190",
    "system_name": "CASEVILLE, CITY OF",
    "display_name": "CASEVILLE, CITY OF",
    "county": "HURON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001190",
    "resolved_pwsid": "MI0001190",
    "system_name": "CASEVILLE, CITY OF",
    "display_name": "CASEVILLE, CITY OF",
    "county": "HURON",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0001195",
    "resolved_pwsid": "MI0001195",
    "system_name": "CASEVILLE TOWNSHIP",
    "display_name": "CASEVILLE TOWNSHIP",
    "county": "HURON",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001195",
    "resolved_pwsid": "MI0001195",
    "system_name": "CASEVILLE TOWNSHIP",
    "display_name": "CASEVILLE TOWNSHIP",
    "county": "HURON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001195",
    "resolved_pwsid": "MI0001195",
    "system_name": "CASEVILLE TOWNSHIP",
    "display_name": "CASEVILLE TOWNSHIP",
    "county": "HURON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001210",
    "resolved_pwsid": "MI0001210",
    "system_name": "CASPIAN",
    "display_name": "CASPIAN",
    "county": "IRON",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001210",
    "resolved_pwsid": "MI0001210",
    "system_name": "CASPIAN",
    "display_name": "CASPIAN",
    "county": "IRON",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001210",
    "resolved_pwsid": "MI0001210",
    "system_name": "CASPIAN",
    "display_name": "CASPIAN",
    "county": "IRON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001210",
    "resolved_pwsid": "MI0001210",
    "system_name": "CASPIAN",
    "display_name": "CASPIAN",
    "county": "IRON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001210",
    "resolved_pwsid": "MI0001210",
    "system_name": "CASPIAN",
    "display_name": "CASPIAN",
    "county": "IRON",
    "monitoring_end_date": "",
    "year": 2021,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001220",
    "resolved_pwsid": "MI0001220",
    "system_name": "CASS CITY, VILLAGE OF",
    "display_name": "CASS CITY, VILLAGE OF",
    "county": "TUSCOLA",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001220",
    "resolved_pwsid": "MI0001220",
    "system_name": "CASS CITY, VILLAGE OF",
    "display_name": "CASS CITY, VILLAGE OF",
    "county": "TUSCOLA",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001220",
    "resolved_pwsid": "MI0001220",
    "system_name": "CASS CITY, VILLAGE OF",
    "display_name": "CASS CITY, VILLAGE OF",
    "county": "TUSCOLA",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 6,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001220",
    "resolved_pwsid": "MI0001220",
    "system_name": "CASS CITY, VILLAGE OF",
    "display_name": "CASS CITY, VILLAGE OF",
    "county": "TUSCOLA",
    "monitoring_end_date": "",
    "year": 2021,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 20,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001220",
    "resolved_pwsid": "MI0001220",
    "system_name": "CASS CITY, VILLAGE OF",
    "display_name": "CASS CITY, VILLAGE OF",
    "county": "TUSCOLA",
    "monitoring_end_date": "",
    "year": 2022,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 19,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001220",
    "resolved_pwsid": "MI0001220",
    "system_name": "CASS CITY, VILLAGE OF",
    "display_name": "CASS CITY, VILLAGE OF",
    "county": "TUSCOLA",
    "monitoring_end_date": "",
    "year": 2024,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 5,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001220",
    "resolved_pwsid": "MI0001220",
    "system_name": "CASS CITY, VILLAGE OF",
    "display_name": "CASS CITY, VILLAGE OF",
    "county": "TUSCOLA",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 11,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001230",
    "resolved_pwsid": "MI0001230",
    "system_name": "CASS LAKESIDE SUBDIVISION",
    "display_name": "CASS LAKESIDE SUBDIVISION",
    "county": "OAKLAND",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001230",
    "resolved_pwsid": "MI0001230",
    "system_name": "CASS LAKESIDE SUBDIVISION",
    "display_name": "CASS LAKESIDE SUBDIVISION",
    "county": "OAKLAND",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001230",
    "resolved_pwsid": "MI0001230",
    "system_name": "CASS LAKESIDE SUBDIVISION",
    "display_name": "CASS LAKESIDE SUBDIVISION",
    "county": "OAKLAND",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001230",
    "resolved_pwsid": "MI0001230",
    "system_name": "CASS LAKESIDE SUBDIVISION",
    "display_name": "CASS LAKESIDE SUBDIVISION",
    "county": "OAKLAND",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 15,
    "inventory_gpcl": 0,
    "inventory_unknown": 48,
    "total_to_identify_or_replace": 63,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0001230",
    "resolved_pwsid": "MI0001230",
    "system_name": "CASS LAKESIDE SUBDIVISION",
    "display_name": "CASS LAKESIDE SUBDIVISION",
    "county": "OAKLAND",
    "monitoring_end_date": "2026-06-30",
    "year": 2026,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001250",
    "resolved_pwsid": "MI0001250",
    "system_name": "CASSOPOLIS",
    "display_name": "CASSOPOLIS",
    "county": "CASS",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001250",
    "resolved_pwsid": "MI0001250",
    "system_name": "CASSOPOLIS",
    "display_name": "CASSOPOLIS",
    "county": "CASS",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 2,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001250",
    "resolved_pwsid": "MI0001250",
    "system_name": "CASSOPOLIS",
    "display_name": "CASSOPOLIS",
    "county": "CASS",
    "monitoring_end_date": "2022-06-30",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001250",
    "resolved_pwsid": "MI0001250",
    "system_name": "CASSOPOLIS",
    "display_name": "CASSOPOLIS",
    "county": "CASS",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001250",
    "resolved_pwsid": "MI0001250",
    "system_name": "CASSOPOLIS",
    "display_name": "CASSOPOLIS",
    "county": "CASS",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 274,
    "inventory_gpcl": 286,
    "inventory_unknown": 1,
    "total_to_identify_or_replace": 561,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0001252",
    "resolved_pwsid": "MI0001252",
    "system_name": "CEDAR CREEK WATER COMPANY",
    "display_name": "CEDAR CREEK WATER COMPANY",
    "county": "LEELANAU",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001252",
    "resolved_pwsid": "MI0001252",
    "system_name": "CEDAR CREEK WATER COMPANY",
    "display_name": "CEDAR CREEK WATER COMPANY",
    "county": "LEELANAU",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001252",
    "resolved_pwsid": "MI0001252",
    "system_name": "CEDAR CREEK WATER COMPANY",
    "display_name": "CEDAR CREEK WATER COMPANY",
    "county": "LEELANAU",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001252",
    "resolved_pwsid": "MI0001252",
    "system_name": "CEDAR CREEK WATER COMPANY",
    "display_name": "CEDAR CREEK WATER COMPANY",
    "county": "LEELANAU",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0001253",
    "resolved_pwsid": "MI0001253",
    "system_name": "CEDAR HILL ASSISTED LIVING",
    "display_name": "CEDAR HILL ASSISTED LIVING",
    "county": "DELTA",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001253",
    "resolved_pwsid": "MI0001253",
    "system_name": "CEDAR HILL ASSISTED LIVING",
    "display_name": "CEDAR HILL ASSISTED LIVING",
    "county": "DELTA",
    "monitoring_end_date": "2021-09-30",
    "year": 2021,
    "lead_90th_ppb": 49,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001253",
    "resolved_pwsid": "MI0001253",
    "system_name": "CEDAR HILL ASSISTED LIVING",
    "display_name": "CEDAR HILL ASSISTED LIVING",
    "county": "DELTA",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 49,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001253",
    "resolved_pwsid": "MI0001253",
    "system_name": "CEDAR HILL ASSISTED LIVING",
    "display_name": "CEDAR HILL ASSISTED LIVING",
    "county": "DELTA",
    "monitoring_end_date": "2022-06-30",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001253",
    "resolved_pwsid": "MI0001253",
    "system_name": "CEDAR HILL ASSISTED LIVING",
    "display_name": "CEDAR HILL ASSISTED LIVING",
    "county": "DELTA",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001253",
    "resolved_pwsid": "MI0001253",
    "system_name": "CEDAR HILL ASSISTED LIVING",
    "display_name": "CEDAR HILL ASSISTED LIVING",
    "county": "DELTA",
    "monitoring_end_date": "2023-06-30",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001253",
    "resolved_pwsid": "MI0001253",
    "system_name": "CEDAR HILL ASSISTED LIVING",
    "display_name": "CEDAR HILL ASSISTED LIVING",
    "county": "DELTA",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001256",
    "resolved_pwsid": "MI0001256",
    "system_name": "CECIL FARMS",
    "display_name": "CECIL FARMS",
    "county": "EMMET",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001256",
    "resolved_pwsid": "MI0001256",
    "system_name": "CECIL FARMS",
    "display_name": "CECIL FARMS",
    "county": "EMMET",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001256",
    "resolved_pwsid": "MI0001256",
    "system_name": "CECIL FARMS",
    "display_name": "CECIL FARMS",
    "county": "EMMET",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001256",
    "resolved_pwsid": "MI0001256",
    "system_name": "CECIL FARMS",
    "display_name": "CECIL FARMS",
    "county": "EMMET",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0001258",
    "resolved_pwsid": "MI0001258",
    "system_name": "CEDAR CREEK TOWNSHIP",
    "display_name": "CEDAR CREEK TOWNSHIP",
    "county": "WEXFORD",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001258",
    "resolved_pwsid": "MI0001258",
    "system_name": "CEDAR CREEK TOWNSHIP",
    "display_name": "CEDAR CREEK TOWNSHIP",
    "county": "WEXFORD",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001258",
    "resolved_pwsid": "MI0001258",
    "system_name": "CEDAR CREEK TOWNSHIP",
    "display_name": "CEDAR CREEK TOWNSHIP",
    "county": "WEXFORD",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001260",
    "resolved_pwsid": "MI0001260",
    "system_name": "CEDAR SPRINGS",
    "display_name": "CEDAR SPRINGS",
    "county": "KENT",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001260",
    "resolved_pwsid": "MI0001260",
    "system_name": "CEDAR SPRINGS",
    "display_name": "CEDAR SPRINGS",
    "county": "KENT",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001260",
    "resolved_pwsid": "MI0001260",
    "system_name": "CEDAR SPRINGS",
    "display_name": "CEDAR SPRINGS",
    "county": "KENT",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001260",
    "resolved_pwsid": "MI0001260",
    "system_name": "CEDAR SPRINGS",
    "display_name": "CEDAR SPRINGS",
    "county": "KENT",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001260",
    "resolved_pwsid": "MI0001260",
    "system_name": "CEDAR SPRINGS",
    "display_name": "CEDAR SPRINGS",
    "county": "KENT",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0001290",
    "resolved_pwsid": "MI0001290",
    "system_name": "CENTER LINE, CITY OF",
    "display_name": "CENTER LINE, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001290",
    "resolved_pwsid": "MI0001290",
    "system_name": "CENTER LINE, CITY OF",
    "display_name": "CENTER LINE, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001290",
    "resolved_pwsid": "MI0001290",
    "system_name": "CENTER LINE, CITY OF",
    "display_name": "CENTER LINE, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001290",
    "resolved_pwsid": "MI0001290",
    "system_name": "CENTER LINE, CITY OF",
    "display_name": "CENTER LINE, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": 2,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001290",
    "resolved_pwsid": "MI0001290",
    "system_name": "CENTER LINE, CITY OF",
    "display_name": "CENTER LINE, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": 5,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001290",
    "resolved_pwsid": "MI0001290",
    "system_name": "CENTER LINE, CITY OF",
    "display_name": "CENTER LINE, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": 47,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001290",
    "resolved_pwsid": "MI0001290",
    "system_name": "CENTER LINE, CITY OF",
    "display_name": "CENTER LINE, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001290",
    "resolved_pwsid": "MI0001290",
    "system_name": "CENTER LINE, CITY OF",
    "display_name": "CENTER LINE, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": 2,
    "inventory_lead": 298,
    "inventory_gpcl": 9,
    "inventory_unknown": 1617,
    "total_to_identify_or_replace": 1924,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0001300",
    "resolved_pwsid": "MI0001300",
    "system_name": "CENTRAL LAKE, VILLAGE OF",
    "display_name": "CENTRAL LAKE, VILLAGE OF",
    "county": "ANTRIM",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001300",
    "resolved_pwsid": "MI0001300",
    "system_name": "CENTRAL LAKE, VILLAGE OF",
    "display_name": "CENTRAL LAKE, VILLAGE OF",
    "county": "ANTRIM",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001300",
    "resolved_pwsid": "MI0001300",
    "system_name": "CENTRAL LAKE, VILLAGE OF",
    "display_name": "CENTRAL LAKE, VILLAGE OF",
    "county": "ANTRIM",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001300",
    "resolved_pwsid": "MI0001300",
    "system_name": "CENTRAL LAKE, VILLAGE OF",
    "display_name": "CENTRAL LAKE, VILLAGE OF",
    "county": "ANTRIM",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001300",
    "resolved_pwsid": "MI0001300",
    "system_name": "CENTRAL LAKE, VILLAGE OF",
    "display_name": "CENTRAL LAKE, VILLAGE OF",
    "county": "ANTRIM",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 2,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001300",
    "resolved_pwsid": "MI0001300",
    "system_name": "CENTRAL LAKE, VILLAGE OF",
    "display_name": "CENTRAL LAKE, VILLAGE OF",
    "county": "ANTRIM",
    "monitoring_end_date": "",
    "year": 2021,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 2,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001300",
    "resolved_pwsid": "MI0001300",
    "system_name": "CENTRAL LAKE, VILLAGE OF",
    "display_name": "CENTRAL LAKE, VILLAGE OF",
    "county": "ANTRIM",
    "monitoring_end_date": "",
    "year": 2022,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 5,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001300",
    "resolved_pwsid": "MI0001300",
    "system_name": "CENTRAL LAKE, VILLAGE OF",
    "display_name": "CENTRAL LAKE, VILLAGE OF",
    "county": "ANTRIM",
    "monitoring_end_date": "",
    "year": 2024,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 2,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001300",
    "resolved_pwsid": "MI0001300",
    "system_name": "CENTRAL LAKE, VILLAGE OF",
    "display_name": "CENTRAL LAKE, VILLAGE OF",
    "county": "ANTRIM",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 8,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001310",
    "resolved_pwsid": "MI0001310",
    "system_name": "CENTREVILLE",
    "display_name": "CENTREVILLE",
    "county": "ST JOSEPH",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001310",
    "resolved_pwsid": "MI0001310",
    "system_name": "CENTREVILLE",
    "display_name": "CENTREVILLE",
    "county": "ST JOSEPH",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001310",
    "resolved_pwsid": "MI0001310",
    "system_name": "CENTREVILLE",
    "display_name": "CENTREVILLE",
    "county": "ST. JOSEPH",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001325",
    "resolved_pwsid": "MI0001325",
    "system_name": "CHALET DU PAW PAW CONDOMINIUMS",
    "display_name": "CHALET DU PAW PAW CONDOMINIUMS",
    "county": "BERRIEN",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001325",
    "resolved_pwsid": "MI0001325",
    "system_name": "CHALET DU PAW PAW CONDOMINIUMS",
    "display_name": "CHALET DU PAW PAW CONDOMINIUMS",
    "county": "BERRIEN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001325",
    "resolved_pwsid": "MI0001325",
    "system_name": "CHALET DU PAW PAW CONDOMINIUMS",
    "display_name": "CHALET DU PAW PAW CONDOMINIUMS",
    "county": "BERRIEN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001327",
    "resolved_pwsid": "MI0001327",
    "system_name": "CHARLESTON TOWNSHIP",
    "display_name": "CHARLESTON TOWNSHIP",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001327",
    "resolved_pwsid": "MI0001327",
    "system_name": "CHARLESTON TOWNSHIP",
    "display_name": "CHARLESTON TOWNSHIP",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001327",
    "resolved_pwsid": "MI0001327",
    "system_name": "CHARLESTON TOWNSHIP",
    "display_name": "CHARLESTON TOWNSHIP",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001330",
    "resolved_pwsid": "MI0001330-b",
    "system_name": "CHARLEVOIX, CITY OF",
    "display_name": "CHARLEVOIX, CITY OF",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001330",
    "resolved_pwsid": "MI0001330-a",
    "system_name": "CHARLEVOIX",
    "display_name": "CHARLEVOIX",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001330",
    "resolved_pwsid": "MI0001330-b",
    "system_name": "CHARLEVOIX, CITY OF",
    "display_name": "CHARLEVOIX, CITY OF",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001330",
    "resolved_pwsid": "MI0001330-a",
    "system_name": "CHARLEVOIX",
    "display_name": "CHARLEVOIX",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 5,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001330",
    "resolved_pwsid": "MI0001330-a",
    "system_name": "CHARLEVOIX",
    "display_name": "CHARLEVOIX",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 13,
    "inventory_lead": 76,
    "inventory_gpcl": 164,
    "inventory_unknown": 979,
    "total_to_identify_or_replace": 1219,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0001330",
    "resolved_pwsid": "MI0001330",
    "system_name": "CHARLEVOIX, CITY OF",
    "display_name": "CHARLEVOIX, CITY OF",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "",
    "year": 2021,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001330",
    "resolved_pwsid": "MI0001330",
    "system_name": "CHARLEVOIX, CITY OF",
    "display_name": "CHARLEVOIX, CITY OF",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "",
    "year": 2023,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 9,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001330",
    "resolved_pwsid": "MI0001330",
    "system_name": "CHARLEVOIX, CITY OF",
    "display_name": "CHARLEVOIX, CITY OF",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "",
    "year": 2024,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 19,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001335",
    "resolved_pwsid": "MI0001335-a",
    "system_name": "CHARLEVOIX TOWNSHIP",
    "display_name": "CHARLEVOIX TOWNSHIP",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001335",
    "resolved_pwsid": "MI0001335-a",
    "system_name": "CHARLEVOIX TOWNSHIP",
    "display_name": "CHARLEVOIX TOWNSHIP",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001335",
    "resolved_pwsid": "MI0001335-b",
    "system_name": "CHARLEVOIX TOWNSHIP (DIST)",
    "display_name": "CHARLEVOIX TOWNSHIP (DIST)",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001335",
    "resolved_pwsid": "MI0001335-c",
    "system_name": "CHARLEVOIX TOWNSHIP (DIST2)",
    "display_name": "CHARLEVOIX TOWNSHIP (DIST2)",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001335",
    "resolved_pwsid": "MI0001335-d",
    "system_name": "CHARLEVOIX TOWNSHIP (DS001)",
    "display_name": "CHARLEVOIX TOWNSHIP (DS001)",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001335",
    "resolved_pwsid": "MI0001335-e",
    "system_name": "CHARLEVOIX TOWNSHIP (DS002)",
    "display_name": "CHARLEVOIX TOWNSHIP (DS002)",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001340",
    "resolved_pwsid": "MI0001340",
    "system_name": "CHARLOTTE, CITY OF",
    "display_name": "CHARLOTTE, CITY OF",
    "county": "EATON",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001340",
    "resolved_pwsid": "MI0001340",
    "system_name": "CHARLOTTE, CITY OF",
    "display_name": "CHARLOTTE, CITY OF",
    "county": "EATON",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001340",
    "resolved_pwsid": "MI0001340",
    "system_name": "CHARLOTTE, CITY OF",
    "display_name": "CHARLOTTE, CITY OF",
    "county": "EATON",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001340",
    "resolved_pwsid": "MI0001340",
    "system_name": "CHARLOTTE, CITY OF",
    "display_name": "CHARLOTTE, CITY OF",
    "county": "EATON",
    "monitoring_end_date": "2021-06-30",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 34,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001340",
    "resolved_pwsid": "MI0001340",
    "system_name": "CHARLOTTE, CITY OF",
    "display_name": "CHARLOTTE, CITY OF",
    "county": "EATON",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001340",
    "resolved_pwsid": "MI0001340",
    "system_name": "CHARLOTTE, CITY OF",
    "display_name": "CHARLOTTE, CITY OF",
    "county": "EATON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 25,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001340",
    "resolved_pwsid": "MI0001340",
    "system_name": "CHARLOTTE, CITY OF",
    "display_name": "CHARLOTTE, CITY OF",
    "county": "EATON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 75,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001340",
    "resolved_pwsid": "MI0001340",
    "system_name": "CHARLOTTE, CITY OF",
    "display_name": "CHARLOTTE, CITY OF",
    "county": "EATON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 28,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001340",
    "resolved_pwsid": "MI0001340",
    "system_name": "CHARLOTTE, CITY OF",
    "display_name": "CHARLOTTE, CITY OF",
    "county": "EATON",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 26,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001350",
    "resolved_pwsid": "MI0001350",
    "system_name": "CHASSELL TOWNSHIP",
    "display_name": "CHASSELL TOWNSHIP",
    "county": "HOUGHTON",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001350",
    "resolved_pwsid": "MI0001350",
    "system_name": "CHASSELL TOWNSHIP",
    "display_name": "CHASSELL TOWNSHIP",
    "county": "HOUGHTON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001350",
    "resolved_pwsid": "MI0001350",
    "system_name": "CHASSELL TOWNSHIP",
    "display_name": "CHASSELL TOWNSHIP",
    "county": "HOUGHTON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001352",
    "resolved_pwsid": "MI0001352-b",
    "system_name": "CHATEAU VIEW APARTMENTS",
    "display_name": "CHATEAU VIEW APARTMENTS",
    "county": "OAKLAND",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 12,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001352",
    "resolved_pwsid": "MI0001352-b",
    "system_name": "CHATEAU VIEW APARTMENTS",
    "display_name": "CHATEAU VIEW APARTMENTS",
    "county": "OAKLAND",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001352",
    "resolved_pwsid": "MI0001352-a",
    "system_name": "ADVENTURE ACRES",
    "display_name": "ADVENTURE ACRES",
    "county": "OAKLAND",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001352",
    "resolved_pwsid": "MI0001352-b",
    "system_name": "CHATEAU VIEW APARTMENTS",
    "display_name": "CHATEAU VIEW APARTMENTS",
    "county": "OAKLAND",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001352",
    "resolved_pwsid": "MI0001352-a",
    "system_name": "ADVENTURE ACRES",
    "display_name": "ADVENTURE ACRES",
    "county": "OAKLAND",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0001353",
    "resolved_pwsid": "MI0001353",
    "system_name": "CHATEAUX DU LAC CONDOMINIUMS",
    "display_name": "CHATEAUX DU LAC CONDOMINIUMS",
    "county": "GENESEE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001353",
    "resolved_pwsid": "MI0001353",
    "system_name": "CHATEAUX DU LAC CONDOMINIUMS",
    "display_name": "CHATEAUX DU LAC CONDOMINIUMS",
    "county": "GENESEE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001353",
    "resolved_pwsid": "MI0001353",
    "system_name": "CHATEAUX DU LAC CONDOMINIUMS",
    "display_name": "CHATEAUX DU LAC CONDOMINIUMS",
    "county": "GENESEE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001353",
    "resolved_pwsid": "MI0001353",
    "system_name": "CHATEAUX DU LAC CONDOMINIUMS",
    "display_name": "CHATEAUX DU LAC CONDOMINIUMS",
    "county": "GENESEE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 39,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001353",
    "resolved_pwsid": "MI0001353",
    "system_name": "CHATEAUX DU LAC CONDOMINIUMS",
    "display_name": "CHATEAUX DU LAC CONDOMINIUMS",
    "county": "GENESEE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 102,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001353",
    "resolved_pwsid": "MI0001353",
    "system_name": "CHATEAUX DU LAC CONDOMINIUMS",
    "display_name": "CHATEAUX DU LAC CONDOMINIUMS",
    "county": "GENESEE",
    "monitoring_end_date": "2025-06-30",
    "year": 2025,
    "lead_90th_ppb": 14,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0001353",
    "resolved_pwsid": "MI0001353",
    "system_name": "CHATEAUX DU LAC CONDOMINIUMS",
    "display_name": "CHATEAUX DU LAC CONDOMINIUMS",
    "county": "GENESEE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 25,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0001353",
    "resolved_pwsid": "MI0001353",
    "system_name": "CHATEAUX DU LAC CONDOMINIUMS",
    "display_name": "CHATEAUX DU LAC CONDOMINIUMS",
    "county": "GENESEE",
    "monitoring_end_date": "2026-06-30",
    "year": 2026,
    "lead_90th_ppb": 16,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001355",
    "resolved_pwsid": "MI0001355",
    "system_name": "CHATHAM",
    "display_name": "CHATHAM",
    "county": "ALGER",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001355",
    "resolved_pwsid": "MI0001355",
    "system_name": "CHATHAM",
    "display_name": "CHATHAM",
    "county": "ALGER",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001355",
    "resolved_pwsid": "MI0001355",
    "system_name": "CHATHAM",
    "display_name": "CHATHAM",
    "county": "ALGER",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001355",
    "resolved_pwsid": "MI0001355",
    "system_name": "CHATHAM",
    "display_name": "CHATHAM",
    "county": "ALGER",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001360",
    "resolved_pwsid": "MI0001360",
    "system_name": "CHEBOYGAN, CITY OF",
    "display_name": "CHEBOYGAN, CITY OF",
    "county": "CHEBOYGAN",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001360",
    "resolved_pwsid": "MI0001360",
    "system_name": "CHEBOYGAN, CITY OF",
    "display_name": "CHEBOYGAN, CITY OF",
    "county": "CHEBOYGAN",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001360",
    "resolved_pwsid": "MI0001360",
    "system_name": "CHEBOYGAN, CITY OF",
    "display_name": "CHEBOYGAN, CITY OF",
    "county": "CHEBOYGAN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 12,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001360",
    "resolved_pwsid": "MI0001360",
    "system_name": "CHEBOYGAN, CITY OF",
    "display_name": "CHEBOYGAN, CITY OF",
    "county": "CHEBOYGAN",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 98,
    "inventory_lead": 23,
    "inventory_gpcl": 52,
    "inventory_unknown": 1547,
    "total_to_identify_or_replace": 1622,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0001360",
    "resolved_pwsid": "MI0001360",
    "system_name": "CHEBOYGAN, CITY OF",
    "display_name": "CHEBOYGAN, CITY OF",
    "county": "CHEBOYGAN",
    "monitoring_end_date": "",
    "year": 2021,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 3,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001370",
    "resolved_pwsid": "MI0001370",
    "system_name": "CHELSEA",
    "display_name": "CHELSEA",
    "county": "WASHTENAW",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001370",
    "resolved_pwsid": "MI0001370",
    "system_name": "CHELSEA",
    "display_name": "CHELSEA",
    "county": "WASHTENAW",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001370",
    "resolved_pwsid": "MI0001370",
    "system_name": "CHELSEA",
    "display_name": "CHELSEA",
    "county": "WASHTENAW",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001370",
    "resolved_pwsid": "MI0001370",
    "system_name": "CHELSEA",
    "display_name": "CHELSEA",
    "county": "WASHTENAW",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001370",
    "resolved_pwsid": "MI0001370",
    "system_name": "CHELSEA",
    "display_name": "CHELSEA",
    "county": "WASHTENAW",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001370",
    "resolved_pwsid": "MI0001370",
    "system_name": "CHELSEA",
    "display_name": "CHELSEA",
    "county": "WASHTENAW",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001370",
    "resolved_pwsid": "MI0001370",
    "system_name": "CHELSEA",
    "display_name": "CHELSEA",
    "county": "WASHTENAW",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001371",
    "resolved_pwsid": "MI0001371",
    "system_name": "CHERRY CREEK VILLAGE",
    "display_name": "CHERRY CREEK VILLAGE",
    "county": "MARQUETTE",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001371",
    "resolved_pwsid": "MI0001371",
    "system_name": "CHERRY CREEK VILLAGE",
    "display_name": "CHERRY CREEK VILLAGE",
    "county": "MARQUETTE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001371",
    "resolved_pwsid": "MI0001371",
    "system_name": "CHERRY CREEK VILLAGE",
    "display_name": "CHERRY CREEK VILLAGE",
    "county": "MARQUETTE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001371",
    "resolved_pwsid": "MI0001371",
    "system_name": "CHERRY CREEK VILLAGE",
    "display_name": "CHERRY CREEK VILLAGE",
    "county": "MARQUETTE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0001380",
    "resolved_pwsid": "MI0001380",
    "system_name": "CHESANING, VILLAGE OF",
    "display_name": "CHESANING, VILLAGE OF",
    "county": "SAGINAW",
    "monitoring_end_date": "2017-06-30",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001380",
    "resolved_pwsid": "MI0001380",
    "system_name": "CHESANING, VILLAGE OF",
    "display_name": "CHESANING, VILLAGE OF",
    "county": "SAGINAW",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001380",
    "resolved_pwsid": "MI0001380",
    "system_name": "CHESANING, VILLAGE OF",
    "display_name": "CHESANING, VILLAGE OF",
    "county": "SAGINAW",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001380",
    "resolved_pwsid": "MI0001380",
    "system_name": "CHESANING, VILLAGE OF",
    "display_name": "CHESANING, VILLAGE OF",
    "county": "SAGINAW",
    "monitoring_end_date": "",
    "year": 2021,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 2,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001380",
    "resolved_pwsid": "MI0001380",
    "system_name": "CHESANING, VILLAGE OF",
    "display_name": "CHESANING, VILLAGE OF",
    "county": "SAGINAW",
    "monitoring_end_date": "",
    "year": 2022,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001390",
    "resolved_pwsid": "MI0001390",
    "system_name": "CHESTERFIELD TOWNSHIP",
    "display_name": "CHESTERFIELD TOWNSHIP",
    "county": "MACOMB",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001390",
    "resolved_pwsid": "MI0001390",
    "system_name": "CHESTERFIELD TOWNSHIP",
    "display_name": "CHESTERFIELD TOWNSHIP",
    "county": "MACOMB",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001390",
    "resolved_pwsid": "MI0001390",
    "system_name": "CHESTERFIELD TOWNSHIP",
    "display_name": "CHESTERFIELD TOWNSHIP",
    "county": "MACOMB",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001390",
    "resolved_pwsid": "MI0001390",
    "system_name": "CHESTERFIELD TOWNSHIP",
    "display_name": "CHESTERFIELD TOWNSHIP",
    "county": "MACOMB",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001390",
    "resolved_pwsid": "MI0001390",
    "system_name": "CHESTERFIELD TOWNSHIP",
    "display_name": "CHESTERFIELD TOWNSHIP",
    "county": "MACOMB",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001390",
    "resolved_pwsid": "MI0001390",
    "system_name": "CHESTERFIELD TOWNSHIP",
    "display_name": "CHESTERFIELD TOWNSHIP",
    "county": "MACOMB",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001390",
    "resolved_pwsid": "MI0001390",
    "system_name": "CHESTERFIELD TOWNSHIP",
    "display_name": "CHESTERFIELD TOWNSHIP",
    "county": "MACOMB",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001390",
    "resolved_pwsid": "MI0001390",
    "system_name": "CHESTERFIELD TOWNSHIP",
    "display_name": "CHESTERFIELD TOWNSHIP",
    "county": "MACOMB",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0001397",
    "resolved_pwsid": "MI0001397",
    "system_name": "CHESTNUT HILLS",
    "display_name": "CHESTNUT HILLS",
    "county": "MACOMB",
    "monitoring_end_date": "2024-06-30",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001397",
    "resolved_pwsid": "MI0001397",
    "system_name": "CHESTNUT HILLS",
    "display_name": "CHESTNUT HILLS",
    "county": "WASHTENAW",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001397",
    "resolved_pwsid": "MI0001397",
    "system_name": "CHESTNUT HILLS",
    "display_name": "CHESTNUT HILLS",
    "county": "WASHTENAW",
    "monitoring_end_date": "2025-06-30",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001400",
    "resolved_pwsid": "MI0001400",
    "system_name": "CHIKAMING TOWNSHIP",
    "display_name": "CHIKAMING TOWNSHIP",
    "county": "BERRIEN",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001400",
    "resolved_pwsid": "MI0001400",
    "system_name": "CHIKAMING TOWNSHIP",
    "display_name": "CHIKAMING TOWNSHIP",
    "county": "BERRIEN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001400",
    "resolved_pwsid": "MI0001400",
    "system_name": "CHIKAMING TOWNSHIP",
    "display_name": "CHIKAMING TOWNSHIP",
    "county": "BERRIEN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001416",
    "resolved_pwsid": "MI0001416-b",
    "system_name": "CHOCOLAY SHORES APARTMENTS",
    "display_name": "CHOCOLAY SHORES APARTMENTS",
    "county": "MARQUETTE",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001416",
    "resolved_pwsid": "MI0001416-b",
    "system_name": "CHOCOLAY SHORES APARTMENTS",
    "display_name": "CHOCOLAY SHORES APARTMENTS",
    "county": "MARQUETTE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001416",
    "resolved_pwsid": "MI0001416-a",
    "system_name": "CHOCOLAY BUNGALOWS",
    "display_name": "CHOCOLAY BUNGALOWS",
    "county": "MARQUETTE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001416",
    "resolved_pwsid": "MI0001416-b",
    "system_name": "CHOCOLAY SHORES APARTMENTS",
    "display_name": "CHOCOLAY SHORES APARTMENTS",
    "county": "MARQUETTE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001416",
    "resolved_pwsid": "MI0001416-a",
    "system_name": "CHOCOLAY BUNGALOWS",
    "display_name": "CHOCOLAY BUNGALOWS",
    "county": "MARQUETTE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001420",
    "resolved_pwsid": "MI0001420",
    "system_name": "CLARE, CITY OF",
    "display_name": "CLARE, CITY OF",
    "county": "CLARE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 9,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001420",
    "resolved_pwsid": "MI0001420",
    "system_name": "CLARE, CITY OF",
    "display_name": "CLARE, CITY OF",
    "county": "CLARE",
    "monitoring_end_date": "2019-09-30",
    "year": 2019,
    "lead_90th_ppb": 27,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001420",
    "resolved_pwsid": "MI0001420",
    "system_name": "CLARE, CITY OF",
    "display_name": "CLARE, CITY OF",
    "county": "CLARE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 27,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001420",
    "resolved_pwsid": "MI0001420",
    "system_name": "CLARE, CITY OF",
    "display_name": "CLARE, CITY OF",
    "county": "CLARE",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 24,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001420",
    "resolved_pwsid": "MI0001420",
    "system_name": "CLARE, CITY OF",
    "display_name": "CLARE, CITY OF",
    "county": "CLARE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001420",
    "resolved_pwsid": "MI0001420",
    "system_name": "CLARE, CITY OF",
    "display_name": "CLARE, CITY OF",
    "county": "CLARE",
    "monitoring_end_date": "2021-06-30",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 60,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001420",
    "resolved_pwsid": "MI0001420",
    "system_name": "CLARE, CITY OF",
    "display_name": "CLARE, CITY OF",
    "county": "CLARE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001420",
    "resolved_pwsid": "MI0001420",
    "system_name": "CLARE, CITY OF",
    "display_name": "CLARE, CITY OF",
    "county": "CLARE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001420",
    "resolved_pwsid": "MI0001420",
    "system_name": "CLARE, CITY OF",
    "display_name": "CLARE, CITY OF",
    "county": "CLARE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 7,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001420",
    "resolved_pwsid": "MI0001420",
    "system_name": "CLARE, CITY OF",
    "display_name": "CLARE, CITY OF",
    "county": "CLARE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001440",
    "resolved_pwsid": "MI0001440",
    "system_name": "CLAWSON",
    "display_name": "CLAWSON",
    "county": "OAKLAND",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001440",
    "resolved_pwsid": "MI0001440",
    "system_name": "CLAWSON",
    "display_name": "CLAWSON",
    "county": "OAKLAND",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001440",
    "resolved_pwsid": "MI0001440",
    "system_name": "CLAWSON",
    "display_name": "CLAWSON",
    "county": "OAKLAND",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 13,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001440",
    "resolved_pwsid": "MI0001440",
    "system_name": "CLAWSON",
    "display_name": "CLAWSON",
    "county": "OAKLAND",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": 5,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001440",
    "resolved_pwsid": "MI0001440",
    "system_name": "CLAWSON",
    "display_name": "CLAWSON",
    "county": "OAKLAND",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 9,
    "above_action_level": false,
    "lines_replaced": 4,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001440",
    "resolved_pwsid": "MI0001440",
    "system_name": "CLAWSON",
    "display_name": "CLAWSON",
    "county": "OAKLAND",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": 4,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001440",
    "resolved_pwsid": "MI0001440",
    "system_name": "CLAWSON",
    "display_name": "CLAWSON",
    "county": "OAKLAND",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": 7,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001440",
    "resolved_pwsid": "MI0001440",
    "system_name": "CLAWSON",
    "display_name": "CLAWSON",
    "county": "OAKLAND",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": 5,
    "inventory_lead": 561,
    "inventory_gpcl": 0,
    "inventory_unknown": 165,
    "total_to_identify_or_replace": 726,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0001450",
    "resolved_pwsid": "MI0001450",
    "system_name": "CLAY TOWNSHIP",
    "display_name": "CLAY TOWNSHIP",
    "county": "ST CLAIR",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001450",
    "resolved_pwsid": "MI0001450",
    "system_name": "CLAY TOWNSHIP",
    "display_name": "CLAY TOWNSHIP",
    "county": "ST CLAIR",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001450",
    "resolved_pwsid": "MI0001450",
    "system_name": "CLAY TOWNSHIP",
    "display_name": "CLAY TOWNSHIP",
    "county": "ST. CLAIR",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001460",
    "resolved_pwsid": "MI0001460",
    "system_name": "CLIFFORD, VILLAGE OF",
    "display_name": "CLIFFORD, VILLAGE OF",
    "county": "LAPEER",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001460",
    "resolved_pwsid": "MI0001460",
    "system_name": "CLIFFORD, VILLAGE OF",
    "display_name": "CLIFFORD, VILLAGE OF",
    "county": "LAPEER",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001460",
    "resolved_pwsid": "MI0001460",
    "system_name": "CLIFFORD, VILLAGE OF",
    "display_name": "CLIFFORD, VILLAGE OF",
    "county": "LAPEER",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001465",
    "resolved_pwsid": "MI0001465",
    "system_name": "CLIMAX",
    "display_name": "CLIMAX",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001465",
    "resolved_pwsid": "MI0001465",
    "system_name": "CLIMAX",
    "display_name": "CLIMAX",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001465",
    "resolved_pwsid": "MI0001465",
    "system_name": "CLIMAX",
    "display_name": "CLIMAX",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001470",
    "resolved_pwsid": "MI0001470",
    "system_name": "CLINTON",
    "display_name": "CLINTON",
    "county": "LENAWEE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001470",
    "resolved_pwsid": "MI0001470",
    "system_name": "CLINTON",
    "display_name": "CLINTON",
    "county": "LENAWEE",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001470",
    "resolved_pwsid": "MI0001470",
    "system_name": "CLINTON",
    "display_name": "CLINTON",
    "county": "LENAWEE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001470",
    "resolved_pwsid": "MI0001470",
    "system_name": "CLINTON",
    "display_name": "CLINTON",
    "county": "LENAWEE",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001470",
    "resolved_pwsid": "MI0001470",
    "system_name": "CLINTON",
    "display_name": "CLINTON",
    "county": "LENAWEE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001470",
    "resolved_pwsid": "MI0001470",
    "system_name": "CLINTON",
    "display_name": "CLINTON",
    "county": "LENAWEE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 5,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001470",
    "resolved_pwsid": "MI0001470",
    "system_name": "CLINTON",
    "display_name": "CLINTON",
    "county": "LENAWEE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 8,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001470",
    "resolved_pwsid": "MI0001470",
    "system_name": "CLINTON",
    "display_name": "CLINTON",
    "county": "LENAWEE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 44,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001470",
    "resolved_pwsid": "MI0001470",
    "system_name": "CLINTON",
    "display_name": "CLINTON",
    "county": "LENAWEE",
    "monitoring_end_date": "2024-06-30",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 30,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001470",
    "resolved_pwsid": "MI0001470",
    "system_name": "CLINTON",
    "display_name": "CLINTON",
    "county": "LENAWEE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 19,
    "inventory_lead": 159,
    "inventory_gpcl": 30,
    "inventory_unknown": 44,
    "total_to_identify_or_replace": 233,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0001480",
    "resolved_pwsid": "MI0001480",
    "system_name": "CLINTON TOWNSHIP",
    "display_name": "CLINTON TOWNSHIP",
    "county": "MACOMB",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001480",
    "resolved_pwsid": "MI0001480",
    "system_name": "CLINTON TOWNSHIP",
    "display_name": "CLINTON TOWNSHIP",
    "county": "MACOMB",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001480",
    "resolved_pwsid": "MI0001480",
    "system_name": "CLINTON TOWNSHIP",
    "display_name": "CLINTON TOWNSHIP",
    "county": "MACOMB",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001480",
    "resolved_pwsid": "MI0001480",
    "system_name": "CLINTON TOWNSHIP",
    "display_name": "CLINTON TOWNSHIP",
    "county": "MACOMB",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001480",
    "resolved_pwsid": "MI0001480",
    "system_name": "CLINTON TOWNSHIP",
    "display_name": "CLINTON TOWNSHIP",
    "county": "MACOMB",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001480",
    "resolved_pwsid": "MI0001480",
    "system_name": "CLINTON TOWNSHIP",
    "display_name": "CLINTON TOWNSHIP",
    "county": "MACOMB",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 10,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001480",
    "resolved_pwsid": "MI0001480",
    "system_name": "CLINTON TOWNSHIP",
    "display_name": "CLINTON TOWNSHIP",
    "county": "MACOMB",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 4,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001480",
    "resolved_pwsid": "MI0001480",
    "system_name": "CLINTON TOWNSHIP",
    "display_name": "CLINTON TOWNSHIP",
    "county": "MACOMB",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 6,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 1724,
    "total_to_identify_or_replace": 1724,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0001490",
    "resolved_pwsid": "MI0001490",
    "system_name": "CLIO, CITY OF",
    "display_name": "CLIO, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001490",
    "resolved_pwsid": "MI0001490",
    "system_name": "CLIO, CITY OF",
    "display_name": "CLIO, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001490",
    "resolved_pwsid": "MI0001490",
    "system_name": "CLIO, CITY OF",
    "display_name": "CLIO, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001490",
    "resolved_pwsid": "MI0001490",
    "system_name": "CLIO, CITY OF",
    "display_name": "CLIO, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001490",
    "resolved_pwsid": "MI0001490",
    "system_name": "CLIO, CITY OF",
    "display_name": "CLIO, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2021-06-30",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001490",
    "resolved_pwsid": "MI0001490",
    "system_name": "CLIO, CITY OF",
    "display_name": "CLIO, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001490",
    "resolved_pwsid": "MI0001490",
    "system_name": "CLIO, CITY OF",
    "display_name": "CLIO, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001493",
    "resolved_pwsid": "MI0001493",
    "system_name": "CLYDE TOWNSHIP",
    "display_name": "CLYDE TOWNSHIP",
    "county": "ST CLAIR",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001493",
    "resolved_pwsid": "MI0001493",
    "system_name": "CLYDE TOWNSHIP",
    "display_name": "CLYDE TOWNSHIP",
    "county": "ST CLAIR",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001493",
    "resolved_pwsid": "MI0001493",
    "system_name": "CLYDE TOWNSHIP",
    "display_name": "CLYDE TOWNSHIP",
    "county": "ST. CLAIR",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001493",
    "resolved_pwsid": "MI0001493",
    "system_name": "CLYDE TOWNSHIP",
    "display_name": "CLYDE TOWNSHIP",
    "county": "ST. CLAIR",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0001500",
    "resolved_pwsid": "MI0001500",
    "system_name": "COLDWATER",
    "display_name": "COLDWATER",
    "county": "BRANCH",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001500",
    "resolved_pwsid": "MI0001500",
    "system_name": "COLDWATER",
    "display_name": "COLDWATER",
    "county": "BRANCH",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001500",
    "resolved_pwsid": "MI0001500",
    "system_name": "COLDWATER",
    "display_name": "COLDWATER",
    "county": "BRANCH",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001500",
    "resolved_pwsid": "MI0001500",
    "system_name": "COLDWATER",
    "display_name": "COLDWATER",
    "county": "BRANCH",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": 23,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001500",
    "resolved_pwsid": "MI0001500",
    "system_name": "COLDWATER",
    "display_name": "COLDWATER",
    "county": "BRANCH",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": 62,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001500",
    "resolved_pwsid": "MI0001500",
    "system_name": "COLDWATER",
    "display_name": "COLDWATER",
    "county": "BRANCH",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": 86,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001500",
    "resolved_pwsid": "MI0001500",
    "system_name": "COLDWATER",
    "display_name": "COLDWATER",
    "county": "BRANCH",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": 170,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001500",
    "resolved_pwsid": "MI0001500",
    "system_name": "COLDWATER",
    "display_name": "COLDWATER",
    "county": "BRANCH",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": 255,
    "inventory_lead": 972,
    "inventory_gpcl": 97,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 1069,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0001510",
    "resolved_pwsid": "MI0001510",
    "system_name": "LAKELAND CORRECTIONAL FACILITY",
    "display_name": "LAKELAND CORRECTIONAL FACILITY",
    "county": "BRANCH",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001510",
    "resolved_pwsid": "MI0001510",
    "system_name": "LAKELAND CORRECTIONAL FACILITY",
    "display_name": "LAKELAND CORRECTIONAL FACILITY",
    "county": "BRANCH",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001510",
    "resolved_pwsid": "MI0001510",
    "system_name": "LAKELAND CORRECTIONAL FACILITY",
    "display_name": "LAKELAND CORRECTIONAL FACILITY",
    "county": "BRANCH",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001520",
    "resolved_pwsid": "MI0001520",
    "system_name": "COLEMAN, CITY OF",
    "display_name": "COLEMAN, CITY OF",
    "county": "MIDLAND",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001520",
    "resolved_pwsid": "MI0001520",
    "system_name": "COLEMAN, CITY OF",
    "display_name": "COLEMAN, CITY OF",
    "county": "MIDLAND",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001520",
    "resolved_pwsid": "MI0001520",
    "system_name": "COLEMAN, CITY OF",
    "display_name": "COLEMAN, CITY OF",
    "county": "MIDLAND",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 4,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001520",
    "resolved_pwsid": "MI0001520",
    "system_name": "COLEMAN, CITY OF",
    "display_name": "COLEMAN, CITY OF",
    "county": "MIDLAND",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001530",
    "resolved_pwsid": "MI0001530",
    "system_name": "COLOMA",
    "display_name": "COLOMA",
    "county": "BERRIEN",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001530",
    "resolved_pwsid": "MI0001530",
    "system_name": "COLOMA",
    "display_name": "COLOMA",
    "county": "BERRIEN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 6,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001530",
    "resolved_pwsid": "MI0001530",
    "system_name": "COLOMA",
    "display_name": "COLOMA",
    "county": "BERRIEN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001530",
    "resolved_pwsid": "MI0001530",
    "system_name": "COLOMA",
    "display_name": "COLOMA",
    "county": "BERRIEN",
    "monitoring_end_date": "",
    "year": 2022,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 3,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001530",
    "resolved_pwsid": "MI0001530",
    "system_name": "COLOMA",
    "display_name": "COLOMA",
    "county": "BERRIEN",
    "monitoring_end_date": "",
    "year": 2023,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 3,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001535",
    "resolved_pwsid": "MI0001535",
    "system_name": "COLOMA TOWNSHIP",
    "display_name": "COLOMA TOWNSHIP",
    "county": "BERRIEN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001535",
    "resolved_pwsid": "MI0001535",
    "system_name": "COLOMA TOWNSHIP",
    "display_name": "COLOMA TOWNSHIP",
    "county": "BERRIEN",
    "monitoring_end_date": "2022-06-30",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001535",
    "resolved_pwsid": "MI0001535",
    "system_name": "COLOMA TOWNSHIP",
    "display_name": "COLOMA TOWNSHIP",
    "county": "BERRIEN",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001535",
    "resolved_pwsid": "MI0001535",
    "system_name": "COLOMA TOWNSHIP",
    "display_name": "COLOMA TOWNSHIP",
    "county": "BERRIEN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001535",
    "resolved_pwsid": "MI0001535-a",
    "system_name": "COLOMA CHARTER TOWNSHIP",
    "display_name": "COLOMA TOWNSHIP",
    "county": "BERRIEN",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001540",
    "resolved_pwsid": "MI0001540",
    "system_name": "COLON",
    "display_name": "COLON",
    "county": "ST JOSEPH",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001540",
    "resolved_pwsid": "MI0001540",
    "system_name": "COLON",
    "display_name": "COLON",
    "county": "ST JOSEPH",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001540",
    "resolved_pwsid": "MI0001540",
    "system_name": "COLON",
    "display_name": "COLON",
    "county": "ST. JOSEPH",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001543",
    "resolved_pwsid": "MI0001543",
    "system_name": "GREEN OAK TWP - CENTENNIAL FARMS",
    "display_name": "GREEN OAK TWP - CENTENNIAL FARMS",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 11,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001543",
    "resolved_pwsid": "MI0001543",
    "system_name": "GREEN OAK TWP - CENTENNIAL FARMS",
    "display_name": "GREEN OAK TWP - CENTENNIAL FARMS",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001543",
    "resolved_pwsid": "MI0001543",
    "system_name": "GREEN OAK TWP - CENTENNIAL FARMS",
    "display_name": "GREEN OAK TWP - CENTENNIAL FARMS",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 10,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001545",
    "resolved_pwsid": "MI0001545",
    "system_name": "MAIN STREET APARTMENTS",
    "display_name": "MAIN STREET APARTMENTS",
    "county": "MACOMB",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 13,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001545",
    "resolved_pwsid": "MI0001545",
    "system_name": "MAIN STREET APARTMENTS",
    "display_name": "MAIN STREET APARTMENTS",
    "county": "MACOMB",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001545",
    "resolved_pwsid": "MI0001545",
    "system_name": "MAIN STREET APARTMENTS",
    "display_name": "MAIN STREET APARTMENTS",
    "county": "MACOMB",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001545",
    "resolved_pwsid": "MI0001545",
    "system_name": "MAIN STREET APARTMENTS",
    "display_name": "MAIN STREET APARTMENTS",
    "county": "MACOMB",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 10,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0001552",
    "resolved_pwsid": "MI0001552",
    "system_name": "COLONY BAY CONDOMINIUMS",
    "display_name": "COLONY BAY CONDOMINIUMS",
    "county": "CASS",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001552",
    "resolved_pwsid": "MI0001552",
    "system_name": "COLONY BAY CONDOMINIUMS",
    "display_name": "COLONY BAY CONDOMINIUMS",
    "county": "CASS",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001552",
    "resolved_pwsid": "MI0001552",
    "system_name": "COLONY BAY CONDOMINIUMS",
    "display_name": "COLONY BAY CONDOMINIUMS",
    "county": "CASS",
    "monitoring_end_date": "2022-09-30",
    "year": 2022,
    "lead_90th_ppb": 16,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001552",
    "resolved_pwsid": "MI0001552",
    "system_name": "COLONY BAY CONDOMINIUMS",
    "display_name": "COLONY BAY CONDOMINIUMS",
    "county": "CASS",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 16,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001552",
    "resolved_pwsid": "MI0001552",
    "system_name": "COLONY BAY CONDOMINIUMS",
    "display_name": "COLONY BAY CONDOMINIUMS",
    "county": "CASS",
    "monitoring_end_date": "2023-06-30",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001552",
    "resolved_pwsid": "MI0001552",
    "system_name": "COLONY BAY CONDOMINIUMS",
    "display_name": "COLONY BAY CONDOMINIUMS",
    "county": "CASS",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001552",
    "resolved_pwsid": "MI0001552",
    "system_name": "COLONY BAY CONDOMINIUMS",
    "display_name": "COLONY BAY CONDOMINIUMS",
    "county": "CASS",
    "monitoring_end_date": "2024-06-30",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001552",
    "resolved_pwsid": "MI0001552",
    "system_name": "COLONY BAY CONDOMINIUMS",
    "display_name": "COLONY BAY CONDOMINIUMS",
    "county": "CASS",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001552",
    "resolved_pwsid": "MI0001552",
    "system_name": "COLONY BAY CONDOMINIUMS",
    "display_name": "COLONY BAY CONDOMINIUMS",
    "county": "CASS",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0001552",
    "resolved_pwsid": "MI0001552",
    "system_name": "COLONY BAY CONDOMINIUMS",
    "display_name": "COLONY BAY CONDOMINIUMS",
    "county": "CASS",
    "monitoring_end_date": "2026-06-30",
    "year": 2026,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001565",
    "resolved_pwsid": "MI0001565",
    "system_name": "COLUMBIA LAKES ESTATES",
    "display_name": "COLUMBIA LAKES ESTATES",
    "county": "INGHAM",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001565",
    "resolved_pwsid": "MI0001565",
    "system_name": "COLUMBIA LAKES ESTATES",
    "display_name": "COLUMBIA LAKES ESTATES",
    "county": "INGHAM",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001565",
    "resolved_pwsid": "MI0001565",
    "system_name": "COLUMBIA LAKES ESTATES",
    "display_name": "COLUMBIA LAKES ESTATES",
    "county": "INGHAM",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001570",
    "resolved_pwsid": "MI0001570",
    "system_name": "COLUMBIAVILLE, VILLAGE OF",
    "display_name": "COLUMBIAVILLE, VILLAGE OF",
    "county": "LAPEER",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001570",
    "resolved_pwsid": "MI0001570",
    "system_name": "COLUMBIAVILLE, VILLAGE OF",
    "display_name": "COLUMBIAVILLE, VILLAGE OF",
    "county": "LAPEER",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001570",
    "resolved_pwsid": "MI0001570",
    "system_name": "COLUMBIAVILLE, VILLAGE OF",
    "display_name": "COLUMBIAVILLE, VILLAGE OF",
    "county": "LAPEER",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001572",
    "resolved_pwsid": "MI0001572",
    "system_name": "COLOMBIERE CENTER",
    "display_name": "COLOMBIERE CENTER",
    "county": "OAKLAND",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001572",
    "resolved_pwsid": "MI0001572",
    "system_name": "COLOMBIERE CENTER",
    "display_name": "COLOMBIERE CENTER",
    "county": "OAKLAND",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001572",
    "resolved_pwsid": "MI0001572",
    "system_name": "COLOMBIERE CENTER",
    "display_name": "COLOMBIERE CENTER",
    "county": "OAKLAND",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001572",
    "resolved_pwsid": "MI0001572",
    "system_name": "COLOMBIERE CENTER",
    "display_name": "COLOMBIERE CENTER",
    "county": "OAKLAND",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0001573",
    "resolved_pwsid": "MI0001573",
    "system_name": "COMMERCE TOWNSHIP",
    "display_name": "COMMERCE TOWNSHIP",
    "county": "OAKLAND",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001573",
    "resolved_pwsid": "MI0001573",
    "system_name": "COMMERCE TOWNSHIP",
    "display_name": "COMMERCE TOWNSHIP",
    "county": "OAKLAND",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001573",
    "resolved_pwsid": "MI0001573",
    "system_name": "COMMERCE TOWNSHIP",
    "display_name": "COMMERCE TOWNSHIP",
    "county": "OAKLAND",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001573",
    "resolved_pwsid": "MI0001573",
    "system_name": "COMMERCE TOWNSHIP",
    "display_name": "COMMERCE TOWNSHIP",
    "county": "OAKLAND",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001573",
    "resolved_pwsid": "MI0001573",
    "system_name": "COMMERCE TOWNSHIP",
    "display_name": "COMMERCE TOWNSHIP",
    "county": "OAKLAND",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001573",
    "resolved_pwsid": "MI0001573",
    "system_name": "COMMERCE TOWNSHIP",
    "display_name": "COMMERCE TOWNSHIP",
    "county": "OAKLAND",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001573",
    "resolved_pwsid": "MI0001573",
    "system_name": "COMMERCE TOWNSHIP",
    "display_name": "COMMERCE TOWNSHIP",
    "county": "OAKLAND",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001573",
    "resolved_pwsid": "MI0001573",
    "system_name": "COMMERCE TOWNSHIP",
    "display_name": "COMMERCE TOWNSHIP",
    "county": "OAKLAND",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0001580",
    "resolved_pwsid": "MI0001580",
    "system_name": "CONCORD",
    "display_name": "CONCORD",
    "county": "JACKSON",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001580",
    "resolved_pwsid": "MI0001580",
    "system_name": "CONCORD",
    "display_name": "CONCORD",
    "county": "JACKSON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001580",
    "resolved_pwsid": "MI0001580",
    "system_name": "CONCORD",
    "display_name": "CONCORD",
    "county": "JACKSON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001600",
    "resolved_pwsid": "MI0001600",
    "system_name": "CONSTANTINE",
    "display_name": "CONSTANTINE",
    "county": "ST JOSEPH",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001600",
    "resolved_pwsid": "MI0001600",
    "system_name": "CONSTANTINE",
    "display_name": "CONSTANTINE",
    "county": "ST JOSEPH",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001600",
    "resolved_pwsid": "MI0001600",
    "system_name": "CONSTANTINE",
    "display_name": "CONSTANTINE",
    "county": "ST. JOSEPH",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001610",
    "resolved_pwsid": "MI0001610",
    "system_name": "COOPERSVILLE",
    "display_name": "COOPERSVILLE",
    "county": "OTTAWA",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001610",
    "resolved_pwsid": "MI0001610",
    "system_name": "COOPERSVILLE",
    "display_name": "COOPERSVILLE",
    "county": "OTTAWA",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001610",
    "resolved_pwsid": "MI0001610",
    "system_name": "COOPERSVILLE",
    "display_name": "COOPERSVILLE",
    "county": "OTTAWA",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001610",
    "resolved_pwsid": "MI0001610",
    "system_name": "COOPERSVILLE",
    "display_name": "COOPERSVILLE",
    "county": "OTTAWA",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 5,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001610",
    "resolved_pwsid": "MI0001610",
    "system_name": "COOPERSVILLE",
    "display_name": "COOPERSVILLE",
    "county": "OTTAWA",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 14,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001610",
    "resolved_pwsid": "MI0001610",
    "system_name": "COOPERSVILLE",
    "display_name": "COOPERSVILLE",
    "county": "OTTAWA",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 33,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001610",
    "resolved_pwsid": "MI0001610",
    "system_name": "COOPERSVILLE",
    "display_name": "COOPERSVILLE",
    "county": "OTTAWA",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 18,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001610",
    "resolved_pwsid": "MI0001610",
    "system_name": "COOPERSVILLE",
    "display_name": "COOPERSVILLE",
    "county": "OTTAWA",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 7,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001620",
    "resolved_pwsid": "MI0001620",
    "system_name": "COPPER CITY",
    "display_name": "COPPER CITY",
    "county": "HOUGHTON",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001620",
    "resolved_pwsid": "MI0001620",
    "system_name": "COPPER CITY",
    "display_name": "COPPER CITY",
    "county": "HOUGHTON",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001620",
    "resolved_pwsid": "MI0001620",
    "system_name": "COPPER CITY",
    "display_name": "COPPER CITY",
    "county": "HOUGHTON",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001620",
    "resolved_pwsid": "MI0001620",
    "system_name": "COPPER CITY",
    "display_name": "COPPER CITY",
    "county": "HOUGHTON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001620",
    "resolved_pwsid": "MI0001620",
    "system_name": "COPPER CITY",
    "display_name": "COPPER CITY",
    "county": "HOUGHTON",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001620",
    "resolved_pwsid": "MI0001620",
    "system_name": "COPPER CITY",
    "display_name": "COPPER CITY",
    "county": "HOUGHTON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001630",
    "resolved_pwsid": "MI0001630",
    "system_name": "GRANT TOWNSHIP - COPPER HARBOR",
    "display_name": "GRANT TOWNSHIP - COPPER HARBOR",
    "county": "KEWEENAW",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001630",
    "resolved_pwsid": "MI0001630",
    "system_name": "GRANT TOWNSHIP - COPPER HARBOR",
    "display_name": "GRANT TOWNSHIP - COPPER HARBOR",
    "county": "KEWEENAW",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001630",
    "resolved_pwsid": "MI0001630",
    "system_name": "GRANT TOWNSHIP - COPPER HARBOR",
    "display_name": "GRANT TOWNSHIP - COPPER HARBOR",
    "county": "KEWEENAW",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001630",
    "resolved_pwsid": "MI0001630",
    "system_name": "GRANT TOWNSHIP - COPPER HARBOR",
    "display_name": "GRANT TOWNSHIP - COPPER HARBOR",
    "county": "KEWEENAW",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001630",
    "resolved_pwsid": "MI0001630",
    "system_name": "GRANT TOWNSHIP - COPPER HARBOR",
    "display_name": "GRANT TOWNSHIP - COPPER HARBOR",
    "county": "KEWEENAW",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001630",
    "resolved_pwsid": "MI0001630",
    "system_name": "GRANT TOWNSHIP - COPPER HARBOR",
    "display_name": "GRANT TOWNSHIP - COPPER HARBOR",
    "county": "KEWEENAW",
    "monitoring_end_date": "2021-06-30",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001630",
    "resolved_pwsid": "MI0001630",
    "system_name": "GRANT TOWNSHIP - COPPER HARBOR",
    "display_name": "GRANT TOWNSHIP - COPPER HARBOR",
    "county": "KEWEENAW",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001630",
    "resolved_pwsid": "MI0001630",
    "system_name": "GRANT TOWNSHIP - COPPER HARBOR",
    "display_name": "GRANT TOWNSHIP - COPPER HARBOR",
    "county": "KEWEENAW",
    "monitoring_end_date": "2022-06-30",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001630",
    "resolved_pwsid": "MI0001630",
    "system_name": "GRANT TOWNSHIP - COPPER HARBOR",
    "display_name": "GRANT TOWNSHIP - COPPER HARBOR",
    "county": "KEWEENAW",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001630",
    "resolved_pwsid": "MI0001630",
    "system_name": "GRANT TOWNSHIP - COPPER HARBOR",
    "display_name": "GRANT TOWNSHIP - COPPER HARBOR",
    "county": "KEWEENAW",
    "monitoring_end_date": "2023-06-30",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001630",
    "resolved_pwsid": "MI0001630",
    "system_name": "GRANT TOWNSHIP - COPPER HARBOR",
    "display_name": "GRANT TOWNSHIP - COPPER HARBOR",
    "county": "KEWEENAW",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001630",
    "resolved_pwsid": "MI0001630",
    "system_name": "GRANT TOWNSHIP - COPPER HARBOR",
    "display_name": "GRANT TOWNSHIP - COPPER HARBOR",
    "county": "KEWEENAW",
    "monitoring_end_date": "2024-06-30",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001630",
    "resolved_pwsid": "MI0001630",
    "system_name": "GRANT TOWNSHIP - COPPER HARBOR",
    "display_name": "GRANT TOWNSHIP - COPPER HARBOR",
    "county": "KEWEENAW",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001630",
    "resolved_pwsid": "MI0001630",
    "system_name": "GRANT TOWNSHIP - COPPER HARBOR",
    "display_name": "GRANT TOWNSHIP - COPPER HARBOR",
    "county": "KEWEENAW",
    "monitoring_end_date": "2025-06-30",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0001631",
    "resolved_pwsid": "MI0001631",
    "system_name": "COPPER MEADOWS",
    "display_name": "COPPER MEADOWS",
    "county": "WASHTENAW",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001631",
    "resolved_pwsid": "MI0001631",
    "system_name": "COPPER MEADOWS",
    "display_name": "COPPER MEADOWS",
    "county": "WASHTENAW",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001631",
    "resolved_pwsid": "MI0001631",
    "system_name": "COPPER MEADOWS",
    "display_name": "COPPER MEADOWS",
    "county": "WASHTENAW",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001631",
    "resolved_pwsid": "MI0001631",
    "system_name": "COPPER MEADOWS",
    "display_name": "COPPER MEADOWS",
    "county": "WASHTENAW",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0001640",
    "resolved_pwsid": "MI0001640",
    "system_name": "CORUNNA, CITY OF",
    "display_name": "CORUNNA, CITY OF",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001640",
    "resolved_pwsid": "MI0001640",
    "system_name": "CORUNNA, CITY OF",
    "display_name": "CORUNNA, CITY OF",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 2,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001640",
    "resolved_pwsid": "MI0001640",
    "system_name": "CORUNNA, CITY OF",
    "display_name": "CORUNNA, CITY OF",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001643",
    "resolved_pwsid": "MI0001643",
    "system_name": "COTTAGE COVE ON ELK LAKE",
    "display_name": "COTTAGE COVE ON ELK LAKE",
    "county": "ANTRIM",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001643",
    "resolved_pwsid": "MI0001643",
    "system_name": "COTTAGE COVE ON ELK LAKE",
    "display_name": "COTTAGE COVE ON ELK LAKE",
    "county": "ANTRIM",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001643",
    "resolved_pwsid": "MI0001643",
    "system_name": "COTTAGE COVE ON ELK LAKE",
    "display_name": "COTTAGE COVE ON ELK LAKE",
    "county": "ANTRIM",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001648",
    "resolved_pwsid": "MI0001648",
    "system_name": "COUNTRY LIVING ADULT FOSTER CARE",
    "display_name": "COUNTRY LIVING ADULT FOSTER CARE",
    "county": "HILLSDALE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 16,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001648",
    "resolved_pwsid": "MI0001648",
    "system_name": "COUNTRY LIVING ADULT FOSTER CARE",
    "display_name": "COUNTRY LIVING ADULT FOSTER CARE",
    "county": "HILLSDALE",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001648",
    "resolved_pwsid": "MI0001648",
    "system_name": "COUNTRY LIVING ADULT FOSTER CARE",
    "display_name": "COUNTRY LIVING ADULT FOSTER CARE",
    "county": "HILLSDALE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001648",
    "resolved_pwsid": "MI0001648",
    "system_name": "COUNTRY LIVING ADULT FOSTER CARE",
    "display_name": "COUNTRY LIVING ADULT FOSTER CARE",
    "county": "HILLSDALE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001648",
    "resolved_pwsid": "MI0001648",
    "system_name": "COUNTRY LIVING ADULT FOSTER CARE",
    "display_name": "COUNTRY LIVING ADULT FOSTER CARE",
    "county": "HILLSDALE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0001649",
    "resolved_pwsid": "MI0001649",
    "system_name": "COUNTRY PLACE SENIOR CARE CENTER",
    "display_name": "COUNTRY PLACE SENIOR CARE CENTER",
    "county": "ISABELLA",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001649",
    "resolved_pwsid": "MI0001649",
    "system_name": "COUNTRY PLACE SENIOR CARE CENTER",
    "display_name": "COUNTRY PLACE SENIOR CARE CENTER",
    "county": "ISABELLA",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001649",
    "resolved_pwsid": "MI0001649",
    "system_name": "COUNTRY PLACE SENIOR CARE CENTER",
    "display_name": "COUNTRY PLACE SENIOR CARE CENTER",
    "county": "ISABELLA",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001649",
    "resolved_pwsid": "MI0001649",
    "system_name": "COUNTRY PLACE SENIOR CARE CENTER",
    "display_name": "COUNTRY PLACE SENIOR CARE CENTER",
    "county": "ISABELLA",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0001650",
    "resolved_pwsid": "MI0001650-a",
    "system_name": "COTTRELLVILLE TOWNSHIP",
    "display_name": "COTTRELLVILLE TOWNSHIP",
    "county": "ST CLAIR",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001650",
    "resolved_pwsid": "MI0001650-a",
    "system_name": "COTTRELLVILLE TOWNSHIP",
    "display_name": "COTTRELLVILLE TOWNSHIP",
    "county": "ST CLAIR",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001650",
    "resolved_pwsid": "MI0001650-e",
    "system_name": "COTTRELLVILLE TOWNSHIP (MARINE CITY)",
    "display_name": "COTTRELLVILLE TOWNSHIP (MARINE CITY)",
    "county": "ST. CLAIR",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001650",
    "resolved_pwsid": "MI0001650-d",
    "system_name": "COTTRELLVILLE TOWNSHIP (IRA TWP)",
    "display_name": "COTTRELLVILLE TOWNSHIP (IRA TWP)",
    "county": "ST. CLAIR",
    "monitoring_end_date": "2022-06-30",
    "year": 2022,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001650",
    "resolved_pwsid": "MI0001650-e",
    "system_name": "COTTRELLVILLE TOWNSHIP (MARINE CITY)",
    "display_name": "COTTRELLVILLE TOWNSHIP (MARINE CITY)",
    "county": "ST. CLAIR",
    "monitoring_end_date": "2022-06-30",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001650",
    "resolved_pwsid": "MI0001650-b",
    "system_name": "COTTRELLVILLE TOWNSHIP (DIST)",
    "display_name": "COTTRELLVILLE TOWNSHIP (DIST)",
    "county": "ST. CLAIR",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001650",
    "resolved_pwsid": "MI0001650-d",
    "system_name": "COTTRELLVILLE TOWNSHIP (IRA TWP)",
    "display_name": "COTTRELLVILLE TOWNSHIP (IRA TWP)",
    "county": "ST. CLAIR",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001650",
    "resolved_pwsid": "MI0001650-e",
    "system_name": "COTTRELLVILLE TOWNSHIP (MARINE CITY)",
    "display_name": "COTTRELLVILLE TOWNSHIP (MARINE CITY)",
    "county": "ST. CLAIR",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001650",
    "resolved_pwsid": "MI0001650-f",
    "system_name": "COTTRELLVILLE TOWNSHIP (DS001)",
    "display_name": "COTTRELLVILLE TOWNSHIP (DS001)",
    "county": "ST. CLAIR",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001650",
    "resolved_pwsid": "MI0001650-c",
    "system_name": "COTTRELLVILLE TOWNSHIP (DIST2)",
    "display_name": "COTTRELLVILLE TOWNSHIP",
    "county": "ST. CLAIR",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0001650",
    "resolved_pwsid": "MI0001650-g",
    "system_name": "COTTRELLVILLE TOWNSHIP (DS002)",
    "display_name": "COTTRELLVILLE TOWNSHIP",
    "county": "ST. CLAIR",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0001652",
    "resolved_pwsid": "MI0001652",
    "system_name": "COUNTRY VILLAGE APARTMENTS",
    "display_name": "COUNTRY VILLAGE APARTMENTS",
    "county": "ROSCOMMON",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001652",
    "resolved_pwsid": "MI0001652",
    "system_name": "COUNTRY VILLAGE APARTMENTS",
    "display_name": "COUNTRY VILLAGE APARTMENTS",
    "county": "ROSCOMMON",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001652",
    "resolved_pwsid": "MI0001652",
    "system_name": "COUNTRY VILLAGE APARTMENTS",
    "display_name": "COUNTRY VILLAGE APARTMENTS",
    "county": "ROSCOMMON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001653",
    "resolved_pwsid": "MI0001653",
    "system_name": "COUNTRY LOG APTS",
    "display_name": "COUNTRY LOG APTS",
    "county": "MARQUETTE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001653",
    "resolved_pwsid": "MI0001653",
    "system_name": "COUNTRY LOG APTS",
    "display_name": "COUNTRY LOG APTS",
    "county": "MARQUETTE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001653",
    "resolved_pwsid": "MI0001653",
    "system_name": "COUNTRY LOG APTS",
    "display_name": "COUNTRY LOG APTS",
    "county": "MARQUETTE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001655",
    "resolved_pwsid": "MI0001655",
    "system_name": "COUNTRY ACRES HOMEOWNERS ASSOCIATION",
    "display_name": "COUNTRY ACRES HOMEOWNERS ASSOCIATION",
    "county": "BERRIEN",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001655",
    "resolved_pwsid": "MI0001655",
    "system_name": "COUNTRY ACRES HOMEOWNERS ASSOCIATION",
    "display_name": "COUNTRY ACRES HOMEOWNERS ASSOCIATION",
    "county": "BERRIEN",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001655",
    "resolved_pwsid": "MI0001655",
    "system_name": "COUNTRY ACRES HOMEOWNERS ASSOCIATION",
    "display_name": "COUNTRY ACRES HOMEOWNERS ASSOCIATION",
    "county": "BERRIEN",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001655",
    "resolved_pwsid": "MI0001655",
    "system_name": "COUNTRY ACRES HOMEOWNERS ASSOCIATION",
    "display_name": "COUNTRY ACRES HOMEOWNERS ASSOCIATION",
    "county": "BERRIEN",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0001657",
    "resolved_pwsid": "MI0001657",
    "system_name": "COUNTRY VIEW MANOR CONDOS",
    "display_name": "COUNTRY VIEW MANOR CONDOS",
    "county": "BERRIEN",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001657",
    "resolved_pwsid": "MI0001657",
    "system_name": "COUNTRY VIEW MANOR CONDOS",
    "display_name": "COUNTRY VIEW MANOR CONDOS",
    "county": "BERRIEN",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001657",
    "resolved_pwsid": "MI0001657",
    "system_name": "COUNTRY VIEW MANOR CONDOS",
    "display_name": "COUNTRY VIEW MANOR CONDOS",
    "county": "BERRIEN",
    "monitoring_end_date": "2022-09-30",
    "year": 2022,
    "lead_90th_ppb": 21,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001657",
    "resolved_pwsid": "MI0001657",
    "system_name": "COUNTRY VIEW MANOR CONDOS",
    "display_name": "COUNTRY VIEW MANOR CONDOS",
    "county": "BERRIEN",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 21,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001657",
    "resolved_pwsid": "MI0001657",
    "system_name": "COUNTRY VIEW MANOR CONDOS",
    "display_name": "COUNTRY VIEW MANOR CONDOS",
    "county": "BERRIEN",
    "monitoring_end_date": "2023-06-30",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001657",
    "resolved_pwsid": "MI0001657",
    "system_name": "COUNTRY VIEW MANOR CONDOS",
    "display_name": "COUNTRY VIEW MANOR CONDOS",
    "county": "BERRIEN",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001657",
    "resolved_pwsid": "MI0001657",
    "system_name": "COUNTRY VIEW MANOR CONDOS",
    "display_name": "COUNTRY VIEW MANOR CONDOS",
    "county": "BERRIEN",
    "monitoring_end_date": "2024-06-30",
    "year": 2024,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001657",
    "resolved_pwsid": "MI0001657",
    "system_name": "COUNTRY VIEW MANOR CONDOS",
    "display_name": "COUNTRY VIEW MANOR CONDOS",
    "county": "BERRIEN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001658",
    "resolved_pwsid": "MI0001658",
    "system_name": "WILLOWS ON TWIN PONDS",
    "display_name": "WILLOWS ON TWIN PONDS",
    "county": "JACKSON",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001658",
    "resolved_pwsid": "MI0001658",
    "system_name": "WILLOWS ON TWIN PONDS",
    "display_name": "WILLOWS ON TWIN PONDS",
    "county": "JACKSON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001658",
    "resolved_pwsid": "MI0001658",
    "system_name": "WILLOWS ON TWIN PONDS",
    "display_name": "WILLOWS ON TWIN PONDS",
    "county": "JACKSON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001661",
    "resolved_pwsid": "MI0001661",
    "system_name": "COVERT TOWNSHIP",
    "display_name": "COVERT TOWNSHIP",
    "county": "VAN BUREN",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001661",
    "resolved_pwsid": "MI0001661",
    "system_name": "COVERT TOWNSHIP",
    "display_name": "COVERT TOWNSHIP",
    "county": "VAN BUREN",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001661",
    "resolved_pwsid": "MI0001661",
    "system_name": "COVERT TOWNSHIP",
    "display_name": "COVERT TOWNSHIP",
    "county": "VAN BUREN",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001661",
    "resolved_pwsid": "MI0001661",
    "system_name": "COVERT TOWNSHIP",
    "display_name": "COVERT TOWNSHIP",
    "county": "VAN BUREN",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0001663",
    "resolved_pwsid": "MI0001663",
    "system_name": "LANDINGS AT CRANES COVE",
    "display_name": "LANDINGS AT CRANES COVE",
    "county": "GENESEE",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001663",
    "resolved_pwsid": "MI0001663",
    "system_name": "LANDINGS AT CRANES COVE",
    "display_name": "LANDINGS AT CRANES COVE",
    "county": "GENESEE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001663",
    "resolved_pwsid": "MI0001663",
    "system_name": "LANDINGS AT CRANES COVE",
    "display_name": "LANDINGS AT CRANES COVE",
    "county": "GENESEE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001663",
    "resolved_pwsid": "MI0001663",
    "system_name": "LANDINGS AT CRANES COVE",
    "display_name": "LANDINGS AT CRANES COVE",
    "county": "GENESEE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0001664",
    "resolved_pwsid": "MI0001664",
    "system_name": "CROCKERY TOWNSHIP",
    "display_name": "CROCKERY TOWNSHIP",
    "county": "OTTAWA",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001664",
    "resolved_pwsid": "MI0001664",
    "system_name": "CROCKERY TOWNSHIP",
    "display_name": "CROCKERY TOWNSHIP",
    "county": "OTTAWA",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001664",
    "resolved_pwsid": "MI0001664",
    "system_name": "CROCKERY TOWNSHIP",
    "display_name": "CROCKERY TOWNSHIP",
    "county": "OTTAWA",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001664",
    "resolved_pwsid": "MI0001664",
    "system_name": "CROCKERY TOWNSHIP",
    "display_name": "CROCKERY TOWNSHIP",
    "county": "OTTAWA",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001664",
    "resolved_pwsid": "MI0001664",
    "system_name": "CROCKERY TOWNSHIP",
    "display_name": "CROCKERY TOWNSHIP",
    "county": "OTTAWA",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 508,
    "total_to_identify_or_replace": 508,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0001666",
    "resolved_pwsid": "MI0001666",
    "system_name": "CROOKED RIVER APARTMENTS",
    "display_name": "CROOKED RIVER APARTMENTS",
    "county": "EMMET",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001666",
    "resolved_pwsid": "MI0001666",
    "system_name": "CROOKED RIVER APARTMENTS",
    "display_name": "CROOKED RIVER APARTMENTS",
    "county": "EMMET",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001666",
    "resolved_pwsid": "MI0001666",
    "system_name": "CROOKED RIVER APARTMENTS",
    "display_name": "CROOKED RIVER APARTMENTS",
    "county": "EMMET",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001666",
    "resolved_pwsid": "MI0001666",
    "system_name": "CROOKED RIVER APARTMENTS",
    "display_name": "CROOKED RIVER APARTMENTS",
    "county": "EMMET",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0001669",
    "resolved_pwsid": "MI0001669",
    "system_name": "LAKESIDE APARTMENTS",
    "display_name": "LAKESIDE APARTMENTS",
    "county": "OAKLAND",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 11,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001669",
    "resolved_pwsid": "MI0001669",
    "system_name": "LAKESIDE APARTMENTS",
    "display_name": "LAKESIDE APARTMENTS",
    "county": "OAKLAND",
    "monitoring_end_date": "2021-09-30",
    "year": 2021,
    "lead_90th_ppb": 18,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001669",
    "resolved_pwsid": "MI0001669",
    "system_name": "LAKESIDE APARTMENTS",
    "display_name": "LAKESIDE APARTMENTS",
    "county": "OAKLAND",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 18,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001669",
    "resolved_pwsid": "MI0001669",
    "system_name": "LAKESIDE APARTMENTS",
    "display_name": "LAKESIDE APARTMENTS",
    "county": "OAKLAND",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001669",
    "resolved_pwsid": "MI0001669",
    "system_name": "LAKESIDE APARTMENTS",
    "display_name": "LAKESIDE APARTMENTS",
    "county": "OAKLAND",
    "monitoring_end_date": "2023-06-30",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001669",
    "resolved_pwsid": "MI0001669",
    "system_name": "LAKESIDE APARTMENTS",
    "display_name": "LAKESIDE APARTMENTS",
    "county": "OAKLAND",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001669",
    "resolved_pwsid": "MI0001669",
    "system_name": "LAKESIDE APARTMENTS",
    "display_name": "LAKESIDE APARTMENTS",
    "county": "OAKLAND",
    "monitoring_end_date": "2024-06-30",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001690",
    "resolved_pwsid": "MI0001690",
    "system_name": "CROSWELL, CITY OF",
    "display_name": "CROSWELL, CITY OF",
    "county": "SANILAC",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001690",
    "resolved_pwsid": "MI0001690",
    "system_name": "CROSWELL, CITY OF",
    "display_name": "CROSWELL, CITY OF",
    "county": "SANILAC",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001690",
    "resolved_pwsid": "MI0001690",
    "system_name": "CROSWELL, CITY OF",
    "display_name": "CROSWELL, CITY OF",
    "county": "SANILAC",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001690",
    "resolved_pwsid": "MI0001690",
    "system_name": "CROSWELL, CITY OF",
    "display_name": "CROSWELL, CITY OF",
    "county": "SANILAC",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001690",
    "resolved_pwsid": "MI0001690",
    "system_name": "CROSWELL, CITY OF",
    "display_name": "CROSWELL, CITY OF",
    "county": "SANILAC",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001690",
    "resolved_pwsid": "MI0001690",
    "system_name": "CROSWELL, CITY OF",
    "display_name": "CROSWELL, CITY OF",
    "county": "SANILAC",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001690",
    "resolved_pwsid": "MI0001690",
    "system_name": "CROSWELL, CITY OF",
    "display_name": "CROSWELL, CITY OF",
    "county": "SANILAC",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 9,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001690",
    "resolved_pwsid": "MI0001690",
    "system_name": "CROSWELL, CITY OF",
    "display_name": "CROSWELL, CITY OF",
    "county": "SANILAC",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 465,
    "inventory_lead": 5,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 5,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0001692",
    "resolved_pwsid": "MI0001692",
    "system_name": "MACK. CO. HOUSING-CURTIS",
    "display_name": "MACK. CO. HOUSING-CURTIS",
    "county": "MACKINAC",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001692",
    "resolved_pwsid": "MI0001692",
    "system_name": "MACK. CO. HOUSING-CURTIS",
    "display_name": "MACK. CO. HOUSING-CURTIS",
    "county": "MACKINAC",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001692",
    "resolved_pwsid": "MI0001692",
    "system_name": "MACK. CO. HOUSING-CURTIS",
    "display_name": "MACK. CO. HOUSING-CURTIS",
    "county": "MACKINAC",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001694",
    "resolved_pwsid": "MI0001694",
    "system_name": "CRYSTAL RIDGE CONDOMINIUM ASSOCIATION",
    "display_name": "CRYSTAL RIDGE CONDOMINIUM ASSOCIATION",
    "county": "BENZIE",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001694",
    "resolved_pwsid": "MI0001694",
    "system_name": "CRYSTAL RIDGE CONDOMINIUM ASSOCIATION",
    "display_name": "CRYSTAL RIDGE CONDOMINIUM ASSOCIATION",
    "county": "BENZIE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001694",
    "resolved_pwsid": "MI0001694",
    "system_name": "CRYSTAL RIDGE CONDOMINIUM ASSOCIATION",
    "display_name": "CRYSTAL RIDGE CONDOMINIUM ASSOCIATION",
    "county": "BENZIE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001694",
    "resolved_pwsid": "MI0001694",
    "system_name": "CRYSTAL RIDGE CONDOMINIUM ASSOCIATION",
    "display_name": "CRYSTAL RIDGE CONDOMINIUM ASSOCIATION",
    "county": "BENZIE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0001700",
    "resolved_pwsid": "MI0001700",
    "system_name": "CRYSTAL FALLS",
    "display_name": "CRYSTAL FALLS",
    "county": "IRON",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001700",
    "resolved_pwsid": "MI0001700",
    "system_name": "CRYSTAL FALLS",
    "display_name": "CRYSTAL FALLS",
    "county": "IRON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001700",
    "resolved_pwsid": "MI0001700",
    "system_name": "CRYSTAL FALLS",
    "display_name": "CRYSTAL FALLS",
    "county": "IRON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001715",
    "resolved_pwsid": "MI0001715",
    "system_name": "CRYSTAL HIGHLANDS SUBDIVISION",
    "display_name": "CRYSTAL HIGHLANDS SUBDIVISION",
    "county": "BENZIE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001715",
    "resolved_pwsid": "MI0001715",
    "system_name": "CRYSTAL HIGHLANDS SUBDIVISION",
    "display_name": "CRYSTAL HIGHLANDS SUBDIVISION",
    "county": "BENZIE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001715",
    "resolved_pwsid": "MI0001715",
    "system_name": "CRYSTAL HIGHLANDS SUBDIVISION",
    "display_name": "CRYSTAL HIGHLANDS SUBDIVISION",
    "county": "BENZIE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001716",
    "resolved_pwsid": "MI0001716",
    "system_name": "CRYSTAL MOUNTAIN RESORT & SPA",
    "display_name": "CRYSTAL MOUNTAIN RESORT & SPA",
    "county": "BENZIE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001716",
    "resolved_pwsid": "MI0001716",
    "system_name": "CRYSTAL MOUNTAIN RESORT & SPA",
    "display_name": "CRYSTAL MOUNTAIN RESORT & SPA",
    "county": "BENZIE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001716",
    "resolved_pwsid": "MI0001716",
    "system_name": "CRYSTAL MOUNTAIN RESORT & SPA",
    "display_name": "CRYSTAL MOUNTAIN RESORT & SPA",
    "county": "BENZIE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001718",
    "resolved_pwsid": "MI0001718",
    "system_name": "DANSVILLE, VILLAGE OF",
    "display_name": "DANSVILLE, VILLAGE OF",
    "county": "INGHAM",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001718",
    "resolved_pwsid": "MI0001718",
    "system_name": "DANSVILLE, VILLAGE OF",
    "display_name": "DANSVILLE, VILLAGE OF",
    "county": "INGHAM",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001718",
    "resolved_pwsid": "MI0001718",
    "system_name": "DANSVILLE, VILLAGE OF",
    "display_name": "DANSVILLE, VILLAGE OF",
    "county": "INGHAM",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001720",
    "resolved_pwsid": "MI0001720",
    "system_name": "DAVISON, CITY OF",
    "display_name": "DAVISON, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001720",
    "resolved_pwsid": "MI0001720",
    "system_name": "DAVISON, CITY OF",
    "display_name": "DAVISON, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001720",
    "resolved_pwsid": "MI0001720",
    "system_name": "DAVISON, CITY OF",
    "display_name": "DAVISON, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001720",
    "resolved_pwsid": "MI0001720",
    "system_name": "DAVISON, CITY OF",
    "display_name": "DAVISON, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001720",
    "resolved_pwsid": "MI0001720",
    "system_name": "DAVISON, CITY OF",
    "display_name": "DAVISON, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001720",
    "resolved_pwsid": "MI0001720",
    "system_name": "DAVISON, CITY OF",
    "display_name": "DAVISON, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001720",
    "resolved_pwsid": "MI0001720",
    "system_name": "DAVISON, CITY OF",
    "display_name": "DAVISON, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001720",
    "resolved_pwsid": "MI0001720",
    "system_name": "DAVISON, CITY OF",
    "display_name": "DAVISON, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0001730",
    "resolved_pwsid": "MI0001730",
    "system_name": "DEARBORN",
    "display_name": "DEARBORN",
    "county": "WAYNE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001730",
    "resolved_pwsid": "MI0001730",
    "system_name": "DEARBORN",
    "display_name": "DEARBORN",
    "county": "WAYNE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 9,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001730",
    "resolved_pwsid": "MI0001730",
    "system_name": "DEARBORN",
    "display_name": "DEARBORN",
    "county": "WAYNE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001730",
    "resolved_pwsid": "MI0001730",
    "system_name": "DEARBORN",
    "display_name": "DEARBORN",
    "county": "WAYNE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": 328,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001730",
    "resolved_pwsid": "MI0001730",
    "system_name": "DEARBORN",
    "display_name": "DEARBORN",
    "county": "WAYNE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 9,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001730",
    "resolved_pwsid": "MI0001730",
    "system_name": "DEARBORN",
    "display_name": "DEARBORN",
    "county": "WAYNE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 9,
    "above_action_level": false,
    "lines_replaced": 389,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001730",
    "resolved_pwsid": "MI0001730",
    "system_name": "DEARBORN",
    "display_name": "DEARBORN",
    "county": "WAYNE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 13,
    "above_action_level": true,
    "lines_replaced": 358,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001730",
    "resolved_pwsid": "MI0001730",
    "system_name": "DEARBORN",
    "display_name": "DEARBORN",
    "county": "WAYNE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": 556,
    "inventory_lead": 7306,
    "inventory_gpcl": 0,
    "inventory_unknown": 2420,
    "total_to_identify_or_replace": 9726,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0001740",
    "resolved_pwsid": "MI0001740",
    "system_name": "DEARBORN HEIGHTS",
    "display_name": "DEARBORN HEIGHTS",
    "county": "WAYNE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001740",
    "resolved_pwsid": "MI0001740",
    "system_name": "DEARBORN HEIGHTS",
    "display_name": "DEARBORN HEIGHTS",
    "county": "WAYNE",
    "monitoring_end_date": "2019-09-30",
    "year": 2019,
    "lead_90th_ppb": 34,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001740",
    "resolved_pwsid": "MI0001740",
    "system_name": "DEARBORN HEIGHTS",
    "display_name": "DEARBORN HEIGHTS",
    "county": "WAYNE",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 17,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001740",
    "resolved_pwsid": "MI0001740",
    "system_name": "DEARBORN HEIGHTS",
    "display_name": "DEARBORN HEIGHTS",
    "county": "WAYNE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001740",
    "resolved_pwsid": "MI0001740",
    "system_name": "DEARBORN HEIGHTS",
    "display_name": "DEARBORN HEIGHTS",
    "county": "WAYNE",
    "monitoring_end_date": "2021-06-30",
    "year": 2021,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001740",
    "resolved_pwsid": "MI0001740",
    "system_name": "DEARBORN HEIGHTS",
    "display_name": "DEARBORN HEIGHTS",
    "county": "WAYNE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 5,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001740",
    "resolved_pwsid": "MI0001740",
    "system_name": "DEARBORN HEIGHTS",
    "display_name": "DEARBORN HEIGHTS",
    "county": "WAYNE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 9,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001740",
    "resolved_pwsid": "MI0001740",
    "system_name": "DEARBORN HEIGHTS",
    "display_name": "DEARBORN HEIGHTS",
    "county": "WAYNE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001740",
    "resolved_pwsid": "MI0001740",
    "system_name": "DEARBORN HEIGHTS",
    "display_name": "DEARBORN HEIGHTS",
    "county": "WAYNE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 64,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001750",
    "resolved_pwsid": "MI0001750",
    "system_name": "DECATUR",
    "display_name": "DECATUR",
    "county": "VAN BUREN",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001750",
    "resolved_pwsid": "MI0001750",
    "system_name": "DECATUR",
    "display_name": "DECATUR",
    "county": "VAN BUREN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 6,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001750",
    "resolved_pwsid": "MI0001750",
    "system_name": "DECATUR",
    "display_name": "DECATUR",
    "county": "VAN BUREN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 57,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001750",
    "resolved_pwsid": "MI0001750",
    "system_name": "DECATUR",
    "display_name": "DECATUR",
    "county": "VAN BUREN",
    "monitoring_end_date": "",
    "year": 2022,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 5,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001750",
    "resolved_pwsid": "MI0001750",
    "system_name": "DECATUR",
    "display_name": "DECATUR",
    "county": "VAN BUREN",
    "monitoring_end_date": "",
    "year": 2023,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 5,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001750",
    "resolved_pwsid": "MI0001750",
    "system_name": "DECATUR",
    "display_name": "DECATUR",
    "county": "VAN BUREN",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 19,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001760",
    "resolved_pwsid": "MI0001760",
    "system_name": "DECKERVILLE, VILLAGE OF",
    "display_name": "DECKERVILLE, VILLAGE OF",
    "county": "SANILAC",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001760",
    "resolved_pwsid": "MI0001760",
    "system_name": "DECKERVILLE, VILLAGE OF",
    "display_name": "DECKERVILLE, VILLAGE OF",
    "county": "SANILAC",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001760",
    "resolved_pwsid": "MI0001760",
    "system_name": "DECKERVILLE, VILLAGE OF",
    "display_name": "DECKERVILLE, VILLAGE OF",
    "county": "SANILAC",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001765",
    "resolved_pwsid": "MI0001765",
    "system_name": "DEEPWATER POINTE ASSOCIATION",
    "display_name": "DEEPWATER POINTE ASSOCIATION",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001765",
    "resolved_pwsid": "MI0001765",
    "system_name": "DEEPWATER POINTE ASSOCIATION",
    "display_name": "DEEPWATER POINTE ASSOCIATION",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001765",
    "resolved_pwsid": "MI0001765",
    "system_name": "DEEPWATER POINTE ASSOCIATION",
    "display_name": "DEEPWATER POINTE ASSOCIATION",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001765",
    "resolved_pwsid": "MI0001765-a",
    "system_name": "DEEPWATER POINTE MASTER ASSOCIATION",
    "display_name": "DEEPWATER POINTE ASSOCIATION",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0001768",
    "resolved_pwsid": "MI0001768",
    "system_name": "DEERFIELD VILLA",
    "display_name": "DEERFIELD VILLA",
    "county": "ROSCOMMON",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001768",
    "resolved_pwsid": "MI0001768",
    "system_name": "DEERFIELD VILLA",
    "display_name": "DEERFIELD VILLA",
    "county": "ROSCOMMON",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001768",
    "resolved_pwsid": "MI0001768",
    "system_name": "DEERFIELD VILLA",
    "display_name": "DEERFIELD VILLA",
    "county": "ROSCOMMON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001768",
    "resolved_pwsid": "MI0001768",
    "system_name": "DEERFIELD VILLA",
    "display_name": "DEERFIELD VILLA",
    "county": "ROSCOMMON",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0001770",
    "resolved_pwsid": "MI0001770",
    "system_name": "DEERFIELD",
    "display_name": "DEERFIELD",
    "county": "LENAWEE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001770",
    "resolved_pwsid": "MI0001770",
    "system_name": "DEERFIELD",
    "display_name": "DEERFIELD",
    "county": "LENAWEE",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001770",
    "resolved_pwsid": "MI0001770",
    "system_name": "DEERFIELD",
    "display_name": "DEERFIELD",
    "county": "LENAWEE",
    "monitoring_end_date": "2021-06-30",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001770",
    "resolved_pwsid": "MI0001770",
    "system_name": "DEERFIELD",
    "display_name": "DEERFIELD",
    "county": "LENAWEE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001770",
    "resolved_pwsid": "MI0001770",
    "system_name": "DEERFIELD",
    "display_name": "DEERFIELD",
    "county": "LENAWEE",
    "monitoring_end_date": "2022-06-30",
    "year": 2022,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001770",
    "resolved_pwsid": "MI0001770",
    "system_name": "DEERFIELD",
    "display_name": "DEERFIELD",
    "county": "LENAWEE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001770",
    "resolved_pwsid": "MI0001770",
    "system_name": "DEERFIELD",
    "display_name": "DEERFIELD",
    "county": "LENAWEE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": 2,
    "inventory_lead": 0,
    "inventory_gpcl": 37,
    "inventory_unknown": 216,
    "total_to_identify_or_replace": 253,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0001770",
    "resolved_pwsid": "MI0001770",
    "system_name": "DEERFIELD",
    "display_name": "DEERFIELD",
    "county": "LENAWEE",
    "monitoring_end_date": "",
    "year": 2024,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 3,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001773",
    "resolved_pwsid": "MI0001773",
    "system_name": "DEERWOOD SUBDIVISION",
    "display_name": "DEERWOOD SUBDIVISION",
    "county": "OAKLAND",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001773",
    "resolved_pwsid": "MI0001773",
    "system_name": "DEERWOOD SUBDIVISION",
    "display_name": "DEERWOOD SUBDIVISION",
    "county": "OAKLAND",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001773",
    "resolved_pwsid": "MI0001773",
    "system_name": "DEERWOOD SUBDIVISION",
    "display_name": "DEERWOOD SUBDIVISION",
    "county": "OAKLAND",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001774",
    "resolved_pwsid": "MI0001774",
    "system_name": "DEER PARK CONDOMINIUMS",
    "display_name": "DEER PARK CONDOMINIUMS",
    "county": "MACOMB",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001774",
    "resolved_pwsid": "MI0001774",
    "system_name": "DEER PARK CONDOMINIUMS",
    "display_name": "DEER PARK CONDOMINIUMS",
    "county": "MACOMB",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001774",
    "resolved_pwsid": "MI0001774",
    "system_name": "DEER PARK CONDOMINIUMS",
    "display_name": "DEER PARK CONDOMINIUMS",
    "county": "MACOMB",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001774",
    "resolved_pwsid": "MI0001774",
    "system_name": "DEER PARK CONDOMINIUMS",
    "display_name": "DEER PARK CONDOMINIUMS",
    "county": "MACOMB",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0001790",
    "resolved_pwsid": "MI0001790",
    "system_name": "CHARTER TOWNSHIP OF DELTA",
    "display_name": "CHARTER TOWNSHIP OF DELTA",
    "county": "EATON",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001790",
    "resolved_pwsid": "MI0001790",
    "system_name": "CHARTER TOWNSHIP OF DELTA",
    "display_name": "CHARTER TOWNSHIP OF DELTA",
    "county": "EATON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001790",
    "resolved_pwsid": "MI0001790",
    "system_name": "CHARTER TOWNSHIP OF DELTA",
    "display_name": "CHARTER TOWNSHIP OF DELTA",
    "county": "EATON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001790",
    "resolved_pwsid": "MI0001790",
    "system_name": "CHARTER TOWNSHIP OF DELTA",
    "display_name": "CHARTER TOWNSHIP OF DELTA",
    "county": "EATON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001790",
    "resolved_pwsid": "MI0001790",
    "system_name": "CHARTER TOWNSHIP OF DELTA",
    "display_name": "CHARTER TOWNSHIP OF DELTA",
    "county": "EATON",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0001795",
    "resolved_pwsid": "MI0001795",
    "system_name": "DETOUR",
    "display_name": "DETOUR",
    "county": "CHIPPEWA",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001795",
    "resolved_pwsid": "MI0001795",
    "system_name": "DETOUR",
    "display_name": "DETOUR",
    "county": "CHIPPEWA",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001795",
    "resolved_pwsid": "MI0001795",
    "system_name": "DETOUR",
    "display_name": "DETOUR",
    "county": "CHIPPEWA",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001798",
    "resolved_pwsid": "MI0001798",
    "system_name": "DETROIT METROPOLITAN WAYNE CO. AIRPORT",
    "display_name": "DETROIT METROPOLITAN WAYNE CO. AIRPORT",
    "county": "WAYNE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001798",
    "resolved_pwsid": "MI0001798",
    "system_name": "DETROIT METROPOLITAN WAYNE CO. AIRPORT",
    "display_name": "DETROIT METROPOLITAN WAYNE CO. AIRPORT",
    "county": "WAYNE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001798",
    "resolved_pwsid": "MI0001798",
    "system_name": "DETROIT METROPOLITAN WAYNE CO. AIRPORT",
    "display_name": "DETROIT METROPOLITAN WAYNE CO. AIRPORT",
    "county": "WAYNE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001798",
    "resolved_pwsid": "MI0001798",
    "system_name": "DETROIT METROPOLITAN WAYNE CO. AIRPORT",
    "display_name": "DETROIT METROPOLITAN WAYNE CO. AIRPORT",
    "county": "WAYNE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001798",
    "resolved_pwsid": "MI0001798",
    "system_name": "DETROIT METROPOLITAN WAYNE CO. AIRPORT",
    "display_name": "DETROIT METROPOLITAN WAYNE CO. AIRPORT",
    "county": "WAYNE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001798",
    "resolved_pwsid": "MI0001798",
    "system_name": "DETROIT METROPOLITAN WAYNE CO. AIRPORT",
    "display_name": "DETROIT METROPOLITAN WAYNE CO. AIRPORT",
    "county": "WAYNE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001798",
    "resolved_pwsid": "MI0001798",
    "system_name": "DETROIT METROPOLITAN WAYNE CO. AIRPORT",
    "display_name": "DETROIT METROPOLITAN WAYNE CO. AIRPORT",
    "county": "WAYNE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001798",
    "resolved_pwsid": "MI0001798",
    "system_name": "DETROIT METROPOLITAN WAYNE CO. AIRPORT",
    "display_name": "DETROIT METROPOLITAN WAYNE CO. AIRPORT",
    "county": "WAYNE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0001800",
    "resolved_pwsid": "MI0001800",
    "system_name": "DETROIT CITY OF",
    "display_name": "DETROIT CITY OF",
    "county": "WAYNE",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001800",
    "resolved_pwsid": "MI0001800",
    "system_name": "DETROIT CITY OF",
    "display_name": "DETROIT CITY OF",
    "county": "WAYNE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 10,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001800",
    "resolved_pwsid": "MI0001800",
    "system_name": "DETROIT CITY OF",
    "display_name": "DETROIT CITY OF",
    "county": "WAYNE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 9,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001800",
    "resolved_pwsid": "MI0001800",
    "system_name": "DETROIT CITY OF",
    "display_name": "DETROIT CITY OF",
    "county": "WAYNE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 12,
    "above_action_level": false,
    "lines_replaced": 204,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001800",
    "resolved_pwsid": "MI0001800",
    "system_name": "DETROIT CITY OF",
    "display_name": "DETROIT CITY OF",
    "county": "WAYNE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 12,
    "above_action_level": false,
    "lines_replaced": 2122,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001800",
    "resolved_pwsid": "MI0001800",
    "system_name": "DETROIT CITY OF",
    "display_name": "DETROIT CITY OF",
    "county": "WAYNE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 9,
    "above_action_level": false,
    "lines_replaced": 2827,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001800",
    "resolved_pwsid": "MI0001800",
    "system_name": "DETROIT CITY OF",
    "display_name": "DETROIT CITY OF",
    "county": "WAYNE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 13,
    "above_action_level": true,
    "lines_replaced": 7468,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001800",
    "resolved_pwsid": "MI0001800",
    "system_name": "DETROIT CITY OF",
    "display_name": "DETROIT CITY OF",
    "county": "WAYNE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": 4680,
    "inventory_lead": 80595,
    "inventory_gpcl": 120,
    "inventory_unknown": 39073,
    "total_to_identify_or_replace": 119788,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0001810",
    "resolved_pwsid": "MI0001810",
    "system_name": "DEXTER",
    "display_name": "DEXTER",
    "county": "WASHTENAW",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001810",
    "resolved_pwsid": "MI0001810",
    "system_name": "DEXTER",
    "display_name": "DEXTER",
    "county": "WASHTENAW",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001810",
    "resolved_pwsid": "MI0001810",
    "system_name": "DEXTER",
    "display_name": "DEXTER",
    "county": "WASHTENAW",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001810",
    "resolved_pwsid": "MI0001810",
    "system_name": "DEXTER",
    "display_name": "DEXTER",
    "county": "WASHTENAW",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001810",
    "resolved_pwsid": "MI0001810",
    "system_name": "DEXTER",
    "display_name": "DEXTER",
    "county": "WASHTENAW",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 7,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001810",
    "resolved_pwsid": "MI0001810",
    "system_name": "DEXTER",
    "display_name": "DEXTER",
    "county": "WASHTENAW",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 2,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001810",
    "resolved_pwsid": "MI0001810",
    "system_name": "DEXTER",
    "display_name": "DEXTER",
    "county": "WASHTENAW",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001810",
    "resolved_pwsid": "MI0001810",
    "system_name": "DEXTER",
    "display_name": "DEXTER",
    "county": "WASHTENAW",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 6,
    "inventory_lead": 0,
    "inventory_gpcl": 42,
    "inventory_unknown": 328,
    "total_to_identify_or_replace": 370,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0001820",
    "resolved_pwsid": "MI0001820",
    "system_name": "ELY TOWNSHIP-DIORITE",
    "display_name": "ELY TOWNSHIP-DIORITE",
    "county": "MARQUETTE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001820",
    "resolved_pwsid": "MI0001820",
    "system_name": "ELY TOWNSHIP-DIORITE",
    "display_name": "ELY TOWNSHIP-DIORITE",
    "county": "MARQUETTE",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001820",
    "resolved_pwsid": "MI0001820",
    "system_name": "ELY TOWNSHIP-DIORITE",
    "display_name": "ELY TOWNSHIP-DIORITE",
    "county": "MARQUETTE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001820",
    "resolved_pwsid": "MI0001820",
    "system_name": "ELY TOWNSHIP-DIORITE",
    "display_name": "ELY TOWNSHIP-DIORITE",
    "county": "MARQUETTE",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001820",
    "resolved_pwsid": "MI0001820",
    "system_name": "ELY TOWNSHIP-DIORITE",
    "display_name": "ELY TOWNSHIP-DIORITE",
    "county": "MARQUETTE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001820",
    "resolved_pwsid": "MI0001820",
    "system_name": "ELY TOWNSHIP-DIORITE",
    "display_name": "ELY TOWNSHIP-DIORITE",
    "county": "MARQUETTE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001820",
    "resolved_pwsid": "MI0001820",
    "system_name": "ELY TOWNSHIP-DIORITE",
    "display_name": "ELY TOWNSHIP-DIORITE",
    "county": "MARQUETTE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001820",
    "resolved_pwsid": "MI0001820",
    "system_name": "ELY TOWNSHIP-DIORITE",
    "display_name": "ELY TOWNSHIP-DIORITE",
    "county": "MARQUETTE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001820",
    "resolved_pwsid": "MI0001820",
    "system_name": "ELY TOWNSHIP-DIORITE",
    "display_name": "ELY TOWNSHIP-DIORITE",
    "county": "MARQUETTE",
    "monitoring_end_date": "2024-06-30",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001820",
    "resolved_pwsid": "MI0001820",
    "system_name": "ELY TOWNSHIP-DIORITE",
    "display_name": "ELY TOWNSHIP-DIORITE",
    "county": "MARQUETTE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001820",
    "resolved_pwsid": "MI0001820",
    "system_name": "ELY TOWNSHIP-DIORITE",
    "display_name": "ELY TOWNSHIP-DIORITE",
    "county": "MARQUETTE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0001820",
    "resolved_pwsid": "MI0001820",
    "system_name": "ELY TOWNSHIP-DIORITE",
    "display_name": "ELY TOWNSHIP-DIORITE",
    "county": "MARQUETTE",
    "monitoring_end_date": "2026-06-30",
    "year": 2026,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001825",
    "resolved_pwsid": "MI0001825",
    "system_name": "DJW PROPERTIES MI LLC",
    "display_name": "DJW PROPERTIES MI LLC",
    "county": "LENAWEE",
    "monitoring_end_date": "2026-06-30",
    "year": 2026,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001840",
    "resolved_pwsid": "MI0001840-a",
    "system_name": "OSCEOLA TOWNSHIP",
    "display_name": "OSCEOLA TOWNSHIP",
    "county": "HOUGHTON",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001840",
    "resolved_pwsid": "MI0001840-d",
    "system_name": "OSCEOLA TOWNSHIP (DOLLAR BAY)",
    "display_name": "OSCEOLA TOWNSHIP (DOLLAR BAY)",
    "county": "HOUGHTON",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001840",
    "resolved_pwsid": "MI0001840-a",
    "system_name": "OSCEOLA TOWNSHIP",
    "display_name": "OSCEOLA TOWNSHIP",
    "county": "HOUGHTON",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001840",
    "resolved_pwsid": "MI0001840-e",
    "system_name": "OSCEOLA TOWNSHIP (TAMARACK)",
    "display_name": "OSCEOLA TOWNSHIP (TAMARACK)",
    "county": "HOUGHTON",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001840",
    "resolved_pwsid": "MI0001840-e",
    "system_name": "OSCEOLA TOWNSHIP (TAMARACK)",
    "display_name": "OSCEOLA TOWNSHIP (TAMARACK)",
    "county": "HOUGHTON",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001840",
    "resolved_pwsid": "MI0001840-d",
    "system_name": "OSCEOLA TOWNSHIP (DOLLAR BAY)",
    "display_name": "OSCEOLA TOWNSHIP (DOLLAR BAY)",
    "county": "HOUGHTON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001840",
    "resolved_pwsid": "MI0001840-d",
    "system_name": "OSCEOLA TOWNSHIP (DOLLAR BAY)",
    "display_name": "OSCEOLA TOWNSHIP (DOLLAR BAY)",
    "county": "HOUGHTON",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": 8,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001840",
    "resolved_pwsid": "MI0001840-c",
    "system_name": "OSCEOLA TOWNSHIP (DIST2)",
    "display_name": "OSCEOLA TOWNSHIP (DIST2)",
    "county": "HOUGHTON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 3,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001840",
    "resolved_pwsid": "MI0001840-e",
    "system_name": "OSCEOLA TOWNSHIP (TAMARACK)",
    "display_name": "OSCEOLA TOWNSHIP (TAMARACK)",
    "county": "HOUGHTON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001840",
    "resolved_pwsid": "MI0001840-b",
    "system_name": "OSCEOLA TOWNSHIP (DIST)",
    "display_name": "OSCEOLA TOWNSHIP (DIST)",
    "county": "HOUGHTON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": 3,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001840",
    "resolved_pwsid": "MI0001840-d",
    "system_name": "OSCEOLA TOWNSHIP (DOLLAR BAY)",
    "display_name": "OSCEOLA TOWNSHIP (DOLLAR BAY)",
    "county": "HOUGHTON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001840",
    "resolved_pwsid": "MI0001840-f",
    "system_name": "OSCEOLA TOWNSHIP (DS001)",
    "display_name": "OSCEOLA TOWNSHIP (DS001)",
    "county": "HOUGHTON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001840",
    "resolved_pwsid": "MI0001840-g",
    "system_name": "OSCEOLA TOWNSHIP (DS002)",
    "display_name": "OSCEOLA TOWNSHIP",
    "county": "HOUGHTON",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 12,
    "inventory_lead": 71,
    "inventory_gpcl": 11,
    "inventory_unknown": 146,
    "total_to_identify_or_replace": 228,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0001840",
    "resolved_pwsid": "MI0001840",
    "system_name": "OSCEOLA TOWNSHIP",
    "display_name": "OSCEOLA TOWNSHIP",
    "county": "HOUGHTON",
    "monitoring_end_date": "",
    "year": 2024,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 3,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001845",
    "resolved_pwsid": "MI0001845",
    "system_name": "DORR-LEIGHTON",
    "display_name": "DORR-LEIGHTON",
    "county": "ALLEGAN",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001845",
    "resolved_pwsid": "MI0001845",
    "system_name": "DORR-LEIGHTON",
    "display_name": "DORR-LEIGHTON",
    "county": "ALLEGAN",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001845",
    "resolved_pwsid": "MI0001845",
    "system_name": "DORR-LEIGHTON",
    "display_name": "DORR-LEIGHTON",
    "county": "ALLEGAN",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001845",
    "resolved_pwsid": "MI0001845",
    "system_name": "DORR-LEIGHTON",
    "display_name": "DORR-LEIGHTON",
    "county": "ALLEGAN",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001860",
    "resolved_pwsid": "MI0001860",
    "system_name": "DOWAGIAC",
    "display_name": "DOWAGIAC",
    "county": "CASS",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001860",
    "resolved_pwsid": "MI0001860",
    "system_name": "DOWAGIAC",
    "display_name": "DOWAGIAC",
    "county": "CASS",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001860",
    "resolved_pwsid": "MI0001860",
    "system_name": "DOWAGIAC",
    "display_name": "DOWAGIAC",
    "county": "CASS",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001860",
    "resolved_pwsid": "MI0001860",
    "system_name": "DOWAGIAC",
    "display_name": "DOWAGIAC",
    "county": "CASS",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 12,
    "above_action_level": false,
    "lines_replaced": 3,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001860",
    "resolved_pwsid": "MI0001860",
    "system_name": "DOWAGIAC",
    "display_name": "DOWAGIAC",
    "county": "CASS",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 15,
    "above_action_level": true,
    "lines_replaced": 3,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001860",
    "resolved_pwsid": "MI0001860",
    "system_name": "DOWAGIAC",
    "display_name": "DOWAGIAC",
    "county": "CASS",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 11,
    "above_action_level": false,
    "lines_replaced": 6,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001860",
    "resolved_pwsid": "MI0001860",
    "system_name": "DOWAGIAC",
    "display_name": "DOWAGIAC",
    "county": "CASS",
    "monitoring_end_date": "2024-06-30",
    "year": 2024,
    "lead_90th_ppb": 18,
    "above_action_level": true,
    "lines_replaced": 47,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001860",
    "resolved_pwsid": "MI0001860",
    "system_name": "DOWAGIAC",
    "display_name": "DOWAGIAC",
    "county": "CASS",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 14,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001860",
    "resolved_pwsid": "MI0001860",
    "system_name": "DOWAGIAC",
    "display_name": "DOWAGIAC",
    "county": "CASS",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 12,
    "above_action_level": false,
    "lines_replaced": 26,
    "inventory_lead": 1068,
    "inventory_gpcl": 388,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 1456,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0001860",
    "resolved_pwsid": "MI0001860",
    "system_name": "DOWAGIAC",
    "display_name": "DOWAGIAC",
    "county": "CASS",
    "monitoring_end_date": "2026-06-30",
    "year": 2026,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001865",
    "resolved_pwsid": "MI0001865",
    "system_name": "DRUMMOND ISLAND APARTMENTS",
    "display_name": "DRUMMOND ISLAND APARTMENTS",
    "county": "CHIPPEWA",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001865",
    "resolved_pwsid": "MI0001865",
    "system_name": "DRUMMOND ISLAND APARTMENTS",
    "display_name": "DRUMMOND ISLAND APARTMENTS",
    "county": "CHIPPEWA",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001865",
    "resolved_pwsid": "MI0001865",
    "system_name": "DRUMMOND ISLAND APARTMENTS",
    "display_name": "DRUMMOND ISLAND APARTMENTS",
    "county": "CHIPPEWA",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001870",
    "resolved_pwsid": "MI0001870",
    "system_name": "DRYDEN, VILLAGE OF",
    "display_name": "DRYDEN, VILLAGE OF",
    "county": "LAPEER",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001870",
    "resolved_pwsid": "MI0001870",
    "system_name": "DRYDEN, VILLAGE OF",
    "display_name": "DRYDEN, VILLAGE OF",
    "county": "LAPEER",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001870",
    "resolved_pwsid": "MI0001870",
    "system_name": "DRYDEN, VILLAGE OF",
    "display_name": "DRYDEN, VILLAGE OF",
    "county": "LAPEER",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001880",
    "resolved_pwsid": "MI0001880",
    "system_name": "DUNDEE",
    "display_name": "DUNDEE",
    "county": "MONROE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001880",
    "resolved_pwsid": "MI0001880",
    "system_name": "DUNDEE",
    "display_name": "DUNDEE",
    "county": "MONROE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001880",
    "resolved_pwsid": "MI0001880",
    "system_name": "DUNDEE",
    "display_name": "DUNDEE",
    "county": "MONROE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001880",
    "resolved_pwsid": "MI0001880",
    "system_name": "DUNDEE",
    "display_name": "DUNDEE",
    "county": "MONROE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001880",
    "resolved_pwsid": "MI0001880",
    "system_name": "DUNDEE",
    "display_name": "DUNDEE",
    "county": "MONROE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001880",
    "resolved_pwsid": "MI0001880",
    "system_name": "DUNDEE",
    "display_name": "DUNDEE",
    "county": "MONROE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 6,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001880",
    "resolved_pwsid": "MI0001880",
    "system_name": "DUNDEE",
    "display_name": "DUNDEE",
    "county": "MONROE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 3,
    "inventory_lead": 5,
    "inventory_gpcl": 170,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001880",
    "resolved_pwsid": "MI0001880",
    "system_name": "DUNDEE",
    "display_name": "DUNDEE",
    "county": "MONROE",
    "monitoring_end_date": "",
    "year": 2022,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 2,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001900",
    "resolved_pwsid": "MI0001900",
    "system_name": "DURAND, CITY OF",
    "display_name": "DURAND, CITY OF",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001900",
    "resolved_pwsid": "MI0001900",
    "system_name": "DURAND, CITY OF",
    "display_name": "DURAND, CITY OF",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001900",
    "resolved_pwsid": "MI0001900",
    "system_name": "DURAND, CITY OF",
    "display_name": "DURAND, CITY OF",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001900",
    "resolved_pwsid": "MI0001900",
    "system_name": "DURAND, CITY OF",
    "display_name": "DURAND, CITY OF",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": 27,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001900",
    "resolved_pwsid": "MI0001900",
    "system_name": "DURAND, CITY OF",
    "display_name": "DURAND, CITY OF",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": 6,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001900",
    "resolved_pwsid": "MI0001900",
    "system_name": "DURAND, CITY OF",
    "display_name": "DURAND, CITY OF",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": 2,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001900",
    "resolved_pwsid": "MI0001900",
    "system_name": "DURAND, CITY OF",
    "display_name": "DURAND, CITY OF",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": 11,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001900",
    "resolved_pwsid": "MI0001900",
    "system_name": "DURAND, CITY OF",
    "display_name": "DURAND, CITY OF",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": 12,
    "inventory_lead": 302,
    "inventory_gpcl": 3,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001905",
    "resolved_pwsid": "MI0001905",
    "system_name": "DUNRENTIN HEIGHTS SUBDIVISION",
    "display_name": "DUNRENTIN HEIGHTS SUBDIVISION",
    "county": "ST CLAIR",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001905",
    "resolved_pwsid": "MI0001905",
    "system_name": "DUNRENTIN HEIGHTS SUBDIVISION",
    "display_name": "DUNRENTIN HEIGHTS SUBDIVISION",
    "county": "ST CLAIR",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001905",
    "resolved_pwsid": "MI0001905",
    "system_name": "DUNRENTIN HEIGHTS SUBDIVISION",
    "display_name": "DUNRENTIN HEIGHTS SUBDIVISION",
    "county": "ST. CLAIR",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001905",
    "resolved_pwsid": "MI0001905",
    "system_name": "DUNRENTIN HEIGHTS SUBDIVISION",
    "display_name": "DUNRENTIN HEIGHTS SUBDIVISION",
    "county": "ST. CLAIR",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001910",
    "resolved_pwsid": "MI0001910",
    "system_name": "AUTUMN HILLS",
    "display_name": "AUTUMN HILLS",
    "county": "CASS",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001910",
    "resolved_pwsid": "MI0001910",
    "system_name": "AUTUMN HILLS",
    "display_name": "AUTUMN HILLS",
    "county": "CASS",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001910",
    "resolved_pwsid": "MI0001910",
    "system_name": "AUTUMN HILLS",
    "display_name": "AUTUMN HILLS",
    "county": "CASS",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001910",
    "resolved_pwsid": "MI0001910",
    "system_name": "AUTUMN HILLS",
    "display_name": "AUTUMN HILLS",
    "county": "CASS",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0001915",
    "resolved_pwsid": "MI0001915",
    "system_name": "DUVERNAY PARK APARTMENTS",
    "display_name": "DUVERNAY PARK APARTMENTS",
    "county": "LAKE",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001915",
    "resolved_pwsid": "MI0001915",
    "system_name": "DUVERNAY PARK APARTMENTS",
    "display_name": "DUVERNAY PARK APARTMENTS",
    "county": "LAKE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001915",
    "resolved_pwsid": "MI0001915",
    "system_name": "DUVERNAY PARK APARTMENTS",
    "display_name": "DUVERNAY PARK APARTMENTS",
    "county": "LAKE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001915",
    "resolved_pwsid": "MI0001915",
    "system_name": "DUVERNAY PARK APARTMENTS",
    "display_name": "DUVERNAY PARK APARTMENTS",
    "county": "LAKE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0001920",
    "resolved_pwsid": "MI0001920",
    "system_name": "EAGLE HARBOR TOWNSHIP",
    "display_name": "EAGLE HARBOR TOWNSHIP",
    "county": "KEWEENAW",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001920",
    "resolved_pwsid": "MI0001920",
    "system_name": "EAGLE HARBOR TOWNSHIP",
    "display_name": "EAGLE HARBOR TOWNSHIP",
    "county": "KEWEENAW",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001920",
    "resolved_pwsid": "MI0001920",
    "system_name": "EAGLE HARBOR TOWNSHIP",
    "display_name": "EAGLE HARBOR TOWNSHIP",
    "county": "KEWEENAW",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001920",
    "resolved_pwsid": "MI0001920",
    "system_name": "EAGLE HARBOR TOWNSHIP",
    "display_name": "EAGLE HARBOR TOWNSHIP",
    "county": "KEWEENAW",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0001925",
    "resolved_pwsid": "MI0001925",
    "system_name": "EAGLE LAKE CONDOMINIUMS",
    "display_name": "EAGLE LAKE CONDOMINIUMS",
    "county": "CASS",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001925",
    "resolved_pwsid": "MI0001925",
    "system_name": "EAGLE LAKE CONDOMINIUMS",
    "display_name": "EAGLE LAKE CONDOMINIUMS",
    "county": "CASS",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001925",
    "resolved_pwsid": "MI0001925",
    "system_name": "EAGLE LAKE CONDOMINIUMS",
    "display_name": "EAGLE LAKE CONDOMINIUMS",
    "county": "CASS",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 10,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001925",
    "resolved_pwsid": "MI0001925",
    "system_name": "EAGLE LAKE CONDOMINIUMS",
    "display_name": "EAGLE LAKE CONDOMINIUMS",
    "county": "CASS",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": 0,
    "inventory_unknown": 16,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001930",
    "resolved_pwsid": "MI0001930",
    "system_name": "HOUGHTON TOWNSHIP",
    "display_name": "HOUGHTON TOWNSHIP",
    "county": "KEWEENAW",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001930",
    "resolved_pwsid": "MI0001930",
    "system_name": "HOUGHTON TOWNSHIP",
    "display_name": "HOUGHTON TOWNSHIP",
    "county": "KEWEENAW",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001930",
    "resolved_pwsid": "MI0001930",
    "system_name": "HOUGHTON TOWNSHIP",
    "display_name": "HOUGHTON TOWNSHIP",
    "county": "KEWEENAW",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001930",
    "resolved_pwsid": "MI0001930",
    "system_name": "HOUGHTON TOWNSHIP",
    "display_name": "HOUGHTON TOWNSHIP",
    "county": "KEWEENAW",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0001932",
    "resolved_pwsid": "MI0001932",
    "system_name": "EAGLE VILLAGE, INC.",
    "display_name": "EAGLE VILLAGE, INC.",
    "county": "OSCEOLA",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001932",
    "resolved_pwsid": "MI0001932",
    "system_name": "EAGLE VILLAGE, INC.",
    "display_name": "EAGLE VILLAGE, INC.",
    "county": "OSCEOLA",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001932",
    "resolved_pwsid": "MI0001932",
    "system_name": "EAGLE VILLAGE, INC.",
    "display_name": "EAGLE VILLAGE, INC.",
    "county": "OSCEOLA",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001932",
    "resolved_pwsid": "MI0001932",
    "system_name": "EAGLE VILLAGE, INC.",
    "display_name": "EAGLE VILLAGE, INC.",
    "county": "OSCEOLA",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0001932",
    "resolved_pwsid": "MI0001932",
    "system_name": "EAGLE VILLAGE, INC.",
    "display_name": "EAGLE VILLAGE, INC.",
    "county": "OSCEOLA",
    "monitoring_end_date": "2026-06-30",
    "year": 2026,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001935",
    "resolved_pwsid": "MI0001935",
    "system_name": "EAST BAY CHARTER TOWNSHIP",
    "display_name": "EAST BAY CHARTER TOWNSHIP",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001935",
    "resolved_pwsid": "MI0001935",
    "system_name": "EAST BAY CHARTER TOWNSHIP",
    "display_name": "EAST BAY CHARTER TOWNSHIP",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001935",
    "resolved_pwsid": "MI0001935",
    "system_name": "EAST BAY CHARTER TOWNSHIP",
    "display_name": "EAST BAY CHARTER TOWNSHIP",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001935",
    "resolved_pwsid": "MI0001935",
    "system_name": "EAST BAY CHARTER TOWNSHIP",
    "display_name": "EAST BAY CHARTER TOWNSHIP",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001935",
    "resolved_pwsid": "MI0001935",
    "system_name": "EAST BAY CHARTER TOWNSHIP",
    "display_name": "EAST BAY CHARTER TOWNSHIP",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001935",
    "resolved_pwsid": "MI0001935",
    "system_name": "EAST BAY CHARTER TOWNSHIP",
    "display_name": "EAST BAY CHARTER TOWNSHIP",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001935",
    "resolved_pwsid": "MI0001935",
    "system_name": "EAST BAY CHARTER TOWNSHIP",
    "display_name": "EAST BAY CHARTER TOWNSHIP",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001935",
    "resolved_pwsid": "MI0001935",
    "system_name": "EAST BAY CHARTER TOWNSHIP",
    "display_name": "EAST BAY CHARTER TOWNSHIP",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001935",
    "resolved_pwsid": "MI0001935",
    "system_name": "EAST BAY CHARTER TOWNSHIP",
    "display_name": "EAST BAY CHARTER TOWNSHIP",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001935",
    "resolved_pwsid": "MI0001935",
    "system_name": "EAST BAY CHARTER TOWNSHIP",
    "display_name": "EAST BAY CHARTER TOWNSHIP",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001950",
    "resolved_pwsid": "MI0001950",
    "system_name": "EASTPOINTE, CITY OF",
    "display_name": "EASTPOINTE, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001950",
    "resolved_pwsid": "MI0001950",
    "system_name": "EASTPOINTE, CITY OF",
    "display_name": "EASTPOINTE, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 15,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001950",
    "resolved_pwsid": "MI0001950",
    "system_name": "EASTPOINTE, CITY OF",
    "display_name": "EASTPOINTE, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001950",
    "resolved_pwsid": "MI0001950",
    "system_name": "EASTPOINTE, CITY OF",
    "display_name": "EASTPOINTE, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 9,
    "above_action_level": false,
    "lines_replaced": 182,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001950",
    "resolved_pwsid": "MI0001950",
    "system_name": "EASTPOINTE, CITY OF",
    "display_name": "EASTPOINTE, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2022-09-30",
    "year": 2022,
    "lead_90th_ppb": 18,
    "above_action_level": true,
    "lines_replaced": 50,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001950",
    "resolved_pwsid": "MI0001950",
    "system_name": "EASTPOINTE, CITY OF",
    "display_name": "EASTPOINTE, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 18,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001950",
    "resolved_pwsid": "MI0001950",
    "system_name": "EASTPOINTE, CITY OF",
    "display_name": "EASTPOINTE, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2023-06-30",
    "year": 2023,
    "lead_90th_ppb": 22,
    "above_action_level": true,
    "lines_replaced": 513,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001950",
    "resolved_pwsid": "MI0001950",
    "system_name": "EASTPOINTE, CITY OF",
    "display_name": "EASTPOINTE, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 25,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001950",
    "resolved_pwsid": "MI0001950",
    "system_name": "EASTPOINTE, CITY OF",
    "display_name": "EASTPOINTE, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2024-06-30",
    "year": 2024,
    "lead_90th_ppb": 9,
    "above_action_level": false,
    "lines_replaced": 1084,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001950",
    "resolved_pwsid": "MI0001950",
    "system_name": "EASTPOINTE, CITY OF",
    "display_name": "EASTPOINTE, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001950",
    "resolved_pwsid": "MI0001950",
    "system_name": "EASTPOINTE, CITY OF",
    "display_name": "EASTPOINTE, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 158,
    "inventory_lead": 779,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 779,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0001960",
    "resolved_pwsid": "MI0001960",
    "system_name": "EAST GRAND RAPIDS",
    "display_name": "EAST GRAND RAPIDS",
    "county": "KENT",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001960",
    "resolved_pwsid": "MI0001960",
    "system_name": "EAST GRAND RAPIDS",
    "display_name": "EAST GRAND RAPIDS",
    "county": "KENT",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001960",
    "resolved_pwsid": "MI0001960",
    "system_name": "EAST GRAND RAPIDS",
    "display_name": "EAST GRAND RAPIDS",
    "county": "KENT",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001960",
    "resolved_pwsid": "MI0001960",
    "system_name": "EAST GRAND RAPIDS",
    "display_name": "EAST GRAND RAPIDS",
    "county": "KENT",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": 65,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001960",
    "resolved_pwsid": "MI0001960",
    "system_name": "EAST GRAND RAPIDS",
    "display_name": "EAST GRAND RAPIDS",
    "county": "KENT",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 9,
    "above_action_level": false,
    "lines_replaced": 47,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001960",
    "resolved_pwsid": "MI0001960",
    "system_name": "EAST GRAND RAPIDS",
    "display_name": "EAST GRAND RAPIDS",
    "county": "KENT",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 10,
    "above_action_level": false,
    "lines_replaced": 86,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001960",
    "resolved_pwsid": "MI0001960",
    "system_name": "EAST GRAND RAPIDS",
    "display_name": "EAST GRAND RAPIDS",
    "county": "KENT",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": 180,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001960",
    "resolved_pwsid": "MI0001960",
    "system_name": "EAST GRAND RAPIDS",
    "display_name": "EAST GRAND RAPIDS",
    "county": "KENT",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 10,
    "above_action_level": false,
    "lines_replaced": 235,
    "inventory_lead": 375,
    "inventory_gpcl": 58,
    "inventory_unknown": 1285,
    "total_to_identify_or_replace": 1718,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0001970",
    "resolved_pwsid": "MI0001970-a",
    "system_name": "EAST JORDAN, CITY OF",
    "display_name": "EAST JORDAN, CITY OF",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001970",
    "resolved_pwsid": "MI0001970-a",
    "system_name": "EAST JORDAN, CITY OF",
    "display_name": "EAST JORDAN, CITY OF",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": 9,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001970",
    "resolved_pwsid": "MI0001970-d",
    "system_name": "EAST JORDAN, CITY OF (INDUSTRIAL PARK)",
    "display_name": "EAST JORDAN, CITY OF (INDUSTRIAL PARK)",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001970",
    "resolved_pwsid": "MI0001970-b",
    "system_name": "EAST JORDAN, CITY OF (DIST)",
    "display_name": "EAST JORDAN, CITY OF (DIST)",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001970",
    "resolved_pwsid": "MI0001970-c",
    "system_name": "EAST JORDAN, CITY OF (DIST2)",
    "display_name": "EAST JORDAN, CITY OF (DIST2)",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001970",
    "resolved_pwsid": "MI0001970-e",
    "system_name": "EAST JORDAN, CITY OF (DS001)",
    "display_name": "EAST JORDAN, CITY OF (DS001)",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001970",
    "resolved_pwsid": "MI0001970-f",
    "system_name": "EAST JORDAN, CITY OF (DS002)",
    "display_name": "EAST JORDAN, CITY OF (DS002)",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001970",
    "resolved_pwsid": "MI0001970",
    "system_name": "EAST JORDAN, CITY OF",
    "display_name": "EAST JORDAN, CITY OF",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "",
    "year": 2023,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 9,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001980",
    "resolved_pwsid": "MI0001980",
    "system_name": "BREITUNG TWP.-EAST KINGSFORD",
    "display_name": "BREITUNG TWP.-EAST KINGSFORD",
    "county": "DICKINSON",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001980",
    "resolved_pwsid": "MI0001980",
    "system_name": "BREITUNG TWP.-EAST KINGSFORD",
    "display_name": "BREITUNG TWP.-EAST KINGSFORD",
    "county": "DICKINSON",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001980",
    "resolved_pwsid": "MI0001980",
    "system_name": "BREITUNG TWP.-EAST KINGSFORD",
    "display_name": "BREITUNG TWP.-EAST KINGSFORD",
    "county": "DICKINSON",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001980",
    "resolved_pwsid": "MI0001980",
    "system_name": "BREITUNG TWP.-EAST KINGSFORD",
    "display_name": "BREITUNG TWP.-EAST KINGSFORD",
    "county": "DICKINSON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 2,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001980",
    "resolved_pwsid": "MI0001980",
    "system_name": "BREITUNG TWP.-EAST KINGSFORD",
    "display_name": "BREITUNG TWP.-EAST KINGSFORD",
    "county": "DICKINSON",
    "monitoring_end_date": "",
    "year": 2021,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 4,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001980",
    "resolved_pwsid": "MI0001980",
    "system_name": "BREITUNG TWP.-EAST KINGSFORD",
    "display_name": "BREITUNG TWP.-EAST KINGSFORD",
    "county": "DICKINSON",
    "monitoring_end_date": "",
    "year": 2022,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 12,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001980",
    "resolved_pwsid": "MI0001980",
    "system_name": "BREITUNG TWP.-EAST KINGSFORD",
    "display_name": "BREITUNG TWP.-EAST KINGSFORD",
    "county": "DICKINSON",
    "monitoring_end_date": "",
    "year": 2024,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 8,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001980",
    "resolved_pwsid": "MI0001980",
    "system_name": "BREITUNG TWP.-EAST KINGSFORD",
    "display_name": "BREITUNG TWP.-EAST KINGSFORD",
    "county": "DICKINSON",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 13,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001990",
    "resolved_pwsid": "MI0001990",
    "system_name": "EAST LANSING, CITY OF",
    "display_name": "EAST LANSING, CITY OF",
    "county": "INGHAM",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001990",
    "resolved_pwsid": "MI0001990",
    "system_name": "EAST LANSING, CITY OF",
    "display_name": "EAST LANSING, CITY OF",
    "county": "INGHAM",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001990",
    "resolved_pwsid": "MI0001990",
    "system_name": "EAST LANSING, CITY OF",
    "display_name": "EAST LANSING, CITY OF",
    "county": "INGHAM",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001990",
    "resolved_pwsid": "MI0001990",
    "system_name": "EAST LANSING, CITY OF",
    "display_name": "EAST LANSING, CITY OF",
    "county": "INGHAM",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 38,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001990",
    "resolved_pwsid": "MI0001990",
    "system_name": "EAST LANSING, CITY OF",
    "display_name": "EAST LANSING, CITY OF",
    "county": "INGHAM",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 35,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001990",
    "resolved_pwsid": "MI0001990",
    "system_name": "EAST LANSING, CITY OF",
    "display_name": "EAST LANSING, CITY OF",
    "county": "INGHAM",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 67,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001990",
    "resolved_pwsid": "MI0001990",
    "system_name": "EAST LANSING, CITY OF",
    "display_name": "EAST LANSING, CITY OF",
    "county": "INGHAM",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 30,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0001990",
    "resolved_pwsid": "MI0001990",
    "system_name": "EAST LANSING, CITY OF",
    "display_name": "EAST LANSING, CITY OF",
    "county": "INGHAM",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 27,
    "inventory_lead": 105,
    "inventory_gpcl": 63,
    "inventory_unknown": 4971,
    "total_to_identify_or_replace": 5139,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0001995",
    "resolved_pwsid": "MI0001995",
    "system_name": "EAST LANSING MERIDIAN WATER AUTHORITY",
    "display_name": "EAST LANSING MERIDIAN WATER AUTHORITY",
    "county": "INGHAM",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002000",
    "resolved_pwsid": "MI0002000-a",
    "system_name": "PINE KNOLL APARTMENTS, LLC",
    "display_name": "PINE KNOLL APARTMENTS, LLC",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002000",
    "resolved_pwsid": "MI0002000-a",
    "system_name": "PINE KNOLL APARTMENTS, LLC",
    "display_name": "PINE KNOLL APARTMENTS, LLC",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002000",
    "resolved_pwsid": "MI0002000-a",
    "system_name": "PINE KNOLL APARTMENTS, LLC",
    "display_name": "PINE KNOLL APARTMENTS, LLC",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002000",
    "resolved_pwsid": "MI0002000-b",
    "system_name": "PINE KNOLL APARTMENTS, LLC (DIST)",
    "display_name": "PINE KNOLL APARTMENTS, LLC (DIST)",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002000",
    "resolved_pwsid": "MI0002000-d",
    "system_name": "PINE KNOLL APARTMENTS, LLC (Dist2)",
    "display_name": "PINE KNOLL APARTMENTS, LLC (Dist2)",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2024-06-30",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002000",
    "resolved_pwsid": "MI0002000-c",
    "system_name": "PINE KNOLL APARTMENTS, LLC (DIST002)",
    "display_name": "PINE KNOLL APARTMENTS, LLC (DIST002)",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002000",
    "resolved_pwsid": "MI0002000-f",
    "system_name": "PINE KNOLL APARTMENTS, LLC (DS001)",
    "display_name": "PINE KNOLL APARTMENTS, LLC",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002000",
    "resolved_pwsid": "MI0002000-e",
    "system_name": "PINE KNOLL APARTMENTS, LLC (DS002)",
    "display_name": "PINE KNOLL APARTMENTS, LLC (DS002)",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2027-12-31",
    "year": 2027,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002000",
    "resolved_pwsid": "MI0002000-e",
    "system_name": "PINE KNOLL APARTMENTS, LLC (DS002)",
    "display_name": "PINE KNOLL APARTMENTS, LLC (DS002)",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2025-09-30",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002010",
    "resolved_pwsid": "MI0002010",
    "system_name": "EAST TAWAS, CITY OF",
    "display_name": "EAST TAWAS, CITY OF",
    "county": "IOSCO",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002010",
    "resolved_pwsid": "MI0002010",
    "system_name": "EAST TAWAS, CITY OF",
    "display_name": "EAST TAWAS, CITY OF",
    "county": "IOSCO",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002010",
    "resolved_pwsid": "MI0002010",
    "system_name": "EAST TAWAS, CITY OF",
    "display_name": "EAST TAWAS, CITY OF",
    "county": "IOSCO",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002020",
    "resolved_pwsid": "MI0002020",
    "system_name": "EATON RAPIDS, CITY OF",
    "display_name": "EATON RAPIDS, CITY OF",
    "county": "EATON",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002020",
    "resolved_pwsid": "MI0002020",
    "system_name": "EATON RAPIDS, CITY OF",
    "display_name": "EATON RAPIDS, CITY OF",
    "county": "EATON",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002020",
    "resolved_pwsid": "MI0002020",
    "system_name": "EATON RAPIDS, CITY OF",
    "display_name": "EATON RAPIDS, CITY OF",
    "county": "EATON",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002020",
    "resolved_pwsid": "MI0002020",
    "system_name": "EATON RAPIDS, CITY OF",
    "display_name": "EATON RAPIDS, CITY OF",
    "county": "EATON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002020",
    "resolved_pwsid": "MI0002020",
    "system_name": "EATON RAPIDS, CITY OF",
    "display_name": "EATON RAPIDS, CITY OF",
    "county": "EATON",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": 7,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002020",
    "resolved_pwsid": "MI0002020",
    "system_name": "EATON RAPIDS, CITY OF",
    "display_name": "EATON RAPIDS, CITY OF",
    "county": "EATON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": 6,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002020",
    "resolved_pwsid": "MI0002020",
    "system_name": "EATON RAPIDS, CITY OF",
    "display_name": "EATON RAPIDS, CITY OF",
    "county": "EATON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": 7,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002020",
    "resolved_pwsid": "MI0002020",
    "system_name": "EATON RAPIDS, CITY OF",
    "display_name": "EATON RAPIDS, CITY OF",
    "county": "EATON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 11,
    "above_action_level": false,
    "lines_replaced": 7,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002020",
    "resolved_pwsid": "MI0002020",
    "system_name": "EATON RAPIDS, CITY OF",
    "display_name": "EATON RAPIDS, CITY OF",
    "county": "EATON",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": 6,
    "inventory_lead": 1469,
    "inventory_gpcl": 0,
    "inventory_unknown": 446,
    "total_to_identify_or_replace": 1915,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0002025",
    "resolved_pwsid": "MI0002025",
    "system_name": "EATON GREEN ESTATES SUBDIVISION",
    "display_name": "EATON GREEN ESTATES SUBDIVISION",
    "county": "EATON",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002025",
    "resolved_pwsid": "MI0002025",
    "system_name": "EATON GREEN ESTATES SUBDIVISION",
    "display_name": "EATON GREEN ESTATES SUBDIVISION",
    "county": "EATON",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002025",
    "resolved_pwsid": "MI0002025",
    "system_name": "EATON GREEN ESTATES SUBDIVISION",
    "display_name": "EATON GREEN ESTATES SUBDIVISION",
    "county": "EATON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002030",
    "resolved_pwsid": "MI0002030",
    "system_name": "EAU CLAIRE",
    "display_name": "EAU CLAIRE",
    "county": "BERRIEN",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002030",
    "resolved_pwsid": "MI0002030",
    "system_name": "EAU CLAIRE",
    "display_name": "EAU CLAIRE",
    "county": "BERRIEN",
    "monitoring_end_date": "2019-09-30",
    "year": 2019,
    "lead_90th_ppb": 71,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002030",
    "resolved_pwsid": "MI0002030",
    "system_name": "EAU CLAIRE",
    "display_name": "EAU CLAIRE",
    "county": "BERRIEN",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 71,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002030",
    "resolved_pwsid": "MI0002030",
    "system_name": "EAU CLAIRE",
    "display_name": "EAU CLAIRE",
    "county": "BERRIEN",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002030",
    "resolved_pwsid": "MI0002030",
    "system_name": "EAU CLAIRE",
    "display_name": "EAU CLAIRE",
    "county": "BERRIEN",
    "monitoring_end_date": "2021-06-30",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002030",
    "resolved_pwsid": "MI0002030",
    "system_name": "EAU CLAIRE",
    "display_name": "EAU CLAIRE",
    "county": "BERRIEN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002030",
    "resolved_pwsid": "MI0002030",
    "system_name": "EAU CLAIRE",
    "display_name": "EAU CLAIRE",
    "county": "BERRIEN",
    "monitoring_end_date": "2022-06-30",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002030",
    "resolved_pwsid": "MI0002030",
    "system_name": "EAU CLAIRE",
    "display_name": "EAU CLAIRE",
    "county": "BERRIEN",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002030",
    "resolved_pwsid": "MI0002030",
    "system_name": "EAU CLAIRE",
    "display_name": "EAU CLAIRE",
    "county": "BERRIEN",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0002050",
    "resolved_pwsid": "MI0002050",
    "system_name": "ECORSE",
    "display_name": "ECORSE",
    "county": "WAYNE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002050",
    "resolved_pwsid": "MI0002050",
    "system_name": "ECORSE",
    "display_name": "ECORSE",
    "county": "WAYNE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002050",
    "resolved_pwsid": "MI0002050",
    "system_name": "ECORSE",
    "display_name": "ECORSE",
    "county": "WAYNE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 13,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002050",
    "resolved_pwsid": "MI0002050",
    "system_name": "ECORSE",
    "display_name": "ECORSE",
    "county": "WAYNE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": 54,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002050",
    "resolved_pwsid": "MI0002050",
    "system_name": "ECORSE",
    "display_name": "ECORSE",
    "county": "WAYNE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": 196,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002050",
    "resolved_pwsid": "MI0002050",
    "system_name": "ECORSE",
    "display_name": "ECORSE",
    "county": "WAYNE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 166,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002050",
    "resolved_pwsid": "MI0002050",
    "system_name": "ECORSE",
    "display_name": "ECORSE",
    "county": "WAYNE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002050",
    "resolved_pwsid": "MI0002050",
    "system_name": "ECORSE",
    "display_name": "ECORSE",
    "county": "WAYNE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": 142,
    "inventory_lead": 1815,
    "inventory_gpcl": 3,
    "inventory_unknown": 403,
    "total_to_identify_or_replace": 2221,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0002055",
    "resolved_pwsid": "MI0002055",
    "system_name": "EDGE 72",
    "display_name": "EDGE 72",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002055",
    "resolved_pwsid": "MI0002055",
    "system_name": "EDGE 72",
    "display_name": "EDGE 72",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2024-06-30",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002070",
    "resolved_pwsid": "MI0002070",
    "system_name": "EDMORE",
    "display_name": "EDMORE",
    "county": "MONTCALM",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002070",
    "resolved_pwsid": "MI0002070",
    "system_name": "EDMORE",
    "display_name": "EDMORE",
    "county": "MONTCALM",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002070",
    "resolved_pwsid": "MI0002070",
    "system_name": "EDMORE",
    "display_name": "EDMORE",
    "county": "MONTCALM",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002070",
    "resolved_pwsid": "MI0002070",
    "system_name": "EDMORE",
    "display_name": "EDMORE",
    "county": "MONTCALM",
    "monitoring_end_date": "",
    "year": 2021,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002070",
    "resolved_pwsid": "MI0002070",
    "system_name": "EDMORE",
    "display_name": "EDMORE",
    "county": "MONTCALM",
    "monitoring_end_date": "",
    "year": 2024,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002077",
    "resolved_pwsid": "MI0002077",
    "system_name": "EDWARDSBURG",
    "display_name": "EDWARDSBURG",
    "county": "CASS",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 14,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002077",
    "resolved_pwsid": "MI0002077",
    "system_name": "EDWARDSBURG",
    "display_name": "EDWARDSBURG",
    "county": "CASS",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002077",
    "resolved_pwsid": "MI0002077",
    "system_name": "EDWARDSBURG",
    "display_name": "EDWARDSBURG",
    "county": "CASS",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002077",
    "resolved_pwsid": "MI0002077",
    "system_name": "EDWARDSBURG",
    "display_name": "EDWARDSBURG",
    "county": "CASS",
    "monitoring_end_date": "2025-06-30",
    "year": 2025,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0002079",
    "resolved_pwsid": "MI0002079",
    "system_name": "EL RANCHO ALANSON",
    "display_name": "EL RANCHO ALANSON",
    "county": "EMMET",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 18,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002079",
    "resolved_pwsid": "MI0002079",
    "system_name": "EL RANCHO ALANSON",
    "display_name": "EL RANCHO ALANSON",
    "county": "EMMET",
    "monitoring_end_date": "2024-06-30",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002079",
    "resolved_pwsid": "MI0002079",
    "system_name": "EL RANCHO ALANSON",
    "display_name": "EL RANCHO ALANSON",
    "county": "EMMET",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002080",
    "resolved_pwsid": "MI0002080",
    "system_name": "ELBERTA, VILLAGE OF",
    "display_name": "ELBERTA, VILLAGE OF",
    "county": "BENZIE",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002080",
    "resolved_pwsid": "MI0002080",
    "system_name": "ELBERTA, VILLAGE OF",
    "display_name": "ELBERTA, VILLAGE OF",
    "county": "BENZIE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002080",
    "resolved_pwsid": "MI0002080",
    "system_name": "ELBERTA, VILLAGE OF",
    "display_name": "ELBERTA, VILLAGE OF",
    "county": "BENZIE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002080",
    "resolved_pwsid": "MI0002080",
    "system_name": "ELBERTA, VILLAGE OF",
    "display_name": "ELBERTA, VILLAGE OF",
    "county": "BENZIE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": 0,
    "inventory_gpcl": 35,
    "inventory_unknown": 44,
    "total_to_identify_or_replace": 79,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0002080",
    "resolved_pwsid": "MI0002080",
    "system_name": "ELBERTA, VILLAGE OF",
    "display_name": "ELBERTA, VILLAGE OF",
    "county": "BENZIE",
    "monitoring_end_date": "",
    "year": 2023,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 36,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002080",
    "resolved_pwsid": "MI0002080",
    "system_name": "ELBERTA, VILLAGE OF",
    "display_name": "ELBERTA, VILLAGE OF",
    "county": "BENZIE",
    "monitoring_end_date": "",
    "year": 2024,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 58,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002090",
    "resolved_pwsid": "MI0002090",
    "system_name": "ELK RAPIDS, VILLAGE OF",
    "display_name": "ELK RAPIDS, VILLAGE OF",
    "county": "ANTRIM",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002090",
    "resolved_pwsid": "MI0002090",
    "system_name": "ELK RAPIDS, VILLAGE OF",
    "display_name": "ELK RAPIDS, VILLAGE OF",
    "county": "ANTRIM",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002090",
    "resolved_pwsid": "MI0002090",
    "system_name": "ELK RAPIDS, VILLAGE OF",
    "display_name": "ELK RAPIDS, VILLAGE OF",
    "county": "ANTRIM",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002100",
    "resolved_pwsid": "MI0002100",
    "system_name": "ELKTON, VILLAGE OF",
    "display_name": "ELKTON, VILLAGE OF",
    "county": "HURON",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002100",
    "resolved_pwsid": "MI0002100",
    "system_name": "ELKTON, VILLAGE OF",
    "display_name": "ELKTON, VILLAGE OF",
    "county": "HURON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002100",
    "resolved_pwsid": "MI0002100",
    "system_name": "ELKTON, VILLAGE OF",
    "display_name": "ELKTON, VILLAGE OF",
    "county": "HURON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002110",
    "resolved_pwsid": "MI0002110",
    "system_name": "ELLSWORTH, VILLAGE OF",
    "display_name": "ELLSWORTH, VILLAGE OF",
    "county": "ANTRIM",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002110",
    "resolved_pwsid": "MI0002110",
    "system_name": "ELLSWORTH, VILLAGE OF",
    "display_name": "ELLSWORTH, VILLAGE OF",
    "county": "ANTRIM",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002110",
    "resolved_pwsid": "MI0002110",
    "system_name": "ELLSWORTH, VILLAGE OF",
    "display_name": "ELLSWORTH, VILLAGE OF",
    "county": "ANTRIM",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002115",
    "resolved_pwsid": "MI0002115",
    "system_name": "ELMWOOD TOWNSHIP",
    "display_name": "ELMWOOD TOWNSHIP",
    "county": "LEELANAU",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002115",
    "resolved_pwsid": "MI0002115",
    "system_name": "ELMWOOD TOWNSHIP",
    "display_name": "ELMWOOD TOWNSHIP",
    "county": "LEELANAU",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002115",
    "resolved_pwsid": "MI0002115",
    "system_name": "ELMWOOD TOWNSHIP",
    "display_name": "ELMWOOD TOWNSHIP",
    "county": "LEELANAU",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002115",
    "resolved_pwsid": "MI0002115",
    "system_name": "ELMWOOD TOWNSHIP",
    "display_name": "ELMWOOD TOWNSHIP",
    "county": "LEELANAU",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002115",
    "resolved_pwsid": "MI0002115",
    "system_name": "ELMWOOD TOWNSHIP",
    "display_name": "ELMWOOD TOWNSHIP",
    "county": "LEELANAU",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002120",
    "resolved_pwsid": "MI0002120",
    "system_name": "ELSIE, VILLAGE OF",
    "display_name": "ELSIE, VILLAGE OF",
    "county": "CLINTON",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002120",
    "resolved_pwsid": "MI0002120",
    "system_name": "ELSIE, VILLAGE OF",
    "display_name": "ELSIE, VILLAGE OF",
    "county": "CLINTON",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002120",
    "resolved_pwsid": "MI0002120",
    "system_name": "ELSIE, VILLAGE OF",
    "display_name": "ELSIE, VILLAGE OF",
    "county": "CLINTON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002120",
    "resolved_pwsid": "MI0002120",
    "system_name": "ELSIE, VILLAGE OF",
    "display_name": "ELSIE, VILLAGE OF",
    "county": "CLINTON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002120",
    "resolved_pwsid": "MI0002120",
    "system_name": "ELSIE, VILLAGE OF",
    "display_name": "ELSIE, VILLAGE OF",
    "county": "CLINTON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002124",
    "resolved_pwsid": "MI0002124",
    "system_name": "EMERY PINES",
    "display_name": "EMERY PINES",
    "county": "ROSCOMMON",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002124",
    "resolved_pwsid": "MI0002124",
    "system_name": "EMERY PINES",
    "display_name": "EMERY PINES",
    "county": "ROSCOMMON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002124",
    "resolved_pwsid": "MI0002124",
    "system_name": "EMERY PINES",
    "display_name": "EMERY PINES",
    "county": "ROSCOMMON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002125",
    "resolved_pwsid": "MI0002125",
    "system_name": "EMMETT TOWNSHIP",
    "display_name": "EMMETT TOWNSHIP",
    "county": "CALHOUN",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002125",
    "resolved_pwsid": "MI0002125",
    "system_name": "EMMETT TOWNSHIP",
    "display_name": "EMMETT TOWNSHIP",
    "county": "CALHOUN",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002125",
    "resolved_pwsid": "MI0002125",
    "system_name": "EMMETT TOWNSHIP",
    "display_name": "EMMETT TOWNSHIP",
    "county": "CALHOUN",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002125",
    "resolved_pwsid": "MI0002125",
    "system_name": "EMMETT TOWNSHIP",
    "display_name": "EMMETT TOWNSHIP",
    "county": "CALHOUN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 39,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002125",
    "resolved_pwsid": "MI0002125",
    "system_name": "EMMETT TOWNSHIP",
    "display_name": "EMMETT TOWNSHIP",
    "county": "CALHOUN",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002125",
    "resolved_pwsid": "MI0002125",
    "system_name": "EMMETT TOWNSHIP",
    "display_name": "EMMETT TOWNSHIP",
    "county": "CALHOUN",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002125",
    "resolved_pwsid": "MI0002125",
    "system_name": "EMMETT TOWNSHIP",
    "display_name": "EMMETT TOWNSHIP",
    "county": "CALHOUN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002125",
    "resolved_pwsid": "MI0002125",
    "system_name": "EMMETT TOWNSHIP",
    "display_name": "EMMETT TOWNSHIP",
    "county": "CALHOUN",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 7,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 7,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0002130",
    "resolved_pwsid": "MI0002130",
    "system_name": "EMPIRE, VILLAGE OF",
    "display_name": "EMPIRE, VILLAGE OF",
    "county": "LEELANAU",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002130",
    "resolved_pwsid": "MI0002130",
    "system_name": "EMPIRE, VILLAGE OF",
    "display_name": "EMPIRE, VILLAGE OF",
    "county": "LEELANAU",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002130",
    "resolved_pwsid": "MI0002130",
    "system_name": "EMPIRE, VILLAGE OF",
    "display_name": "EMPIRE, VILLAGE OF",
    "county": "LEELANAU",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002145",
    "resolved_pwsid": "MI0002145",
    "system_name": "MACK. CO. HOUSING-ENGADINE",
    "display_name": "MACK. CO. HOUSING-ENGADINE",
    "county": "MACKINAC",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002145",
    "resolved_pwsid": "MI0002145",
    "system_name": "MACK. CO. HOUSING-ENGADINE",
    "display_name": "MACK. CO. HOUSING-ENGADINE",
    "county": "MACKINAC",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002145",
    "resolved_pwsid": "MI0002145",
    "system_name": "MACK. CO. HOUSING-ENGADINE",
    "display_name": "MACK. CO. HOUSING-ENGADINE",
    "county": "MACKINAC",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002145",
    "resolved_pwsid": "MI0002145",
    "system_name": "MACK. CO. HOUSING-ENGADINE",
    "display_name": "MACK. CO. HOUSING-ENGADINE",
    "county": "MACKINAC",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002170",
    "resolved_pwsid": "MI0002170",
    "system_name": "ESCANABA",
    "display_name": "ESCANABA",
    "county": "DELTA",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002170",
    "resolved_pwsid": "MI0002170",
    "system_name": "ESCANABA",
    "display_name": "ESCANABA",
    "county": "DELTA",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002170",
    "resolved_pwsid": "MI0002170",
    "system_name": "ESCANABA",
    "display_name": "ESCANABA",
    "county": "DELTA",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002170",
    "resolved_pwsid": "MI0002170",
    "system_name": "ESCANABA",
    "display_name": "ESCANABA",
    "county": "DELTA",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 87,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002170",
    "resolved_pwsid": "MI0002170",
    "system_name": "ESCANABA",
    "display_name": "ESCANABA",
    "county": "DELTA",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": 240,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002170",
    "resolved_pwsid": "MI0002170",
    "system_name": "ESCANABA",
    "display_name": "ESCANABA",
    "county": "DELTA",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 240,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002170",
    "resolved_pwsid": "MI0002170",
    "system_name": "ESCANABA",
    "display_name": "ESCANABA",
    "county": "DELTA",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 655,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002170",
    "resolved_pwsid": "MI0002170",
    "system_name": "ESCANABA",
    "display_name": "ESCANABA",
    "county": "DELTA",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 701,
    "inventory_lead": 3572,
    "inventory_gpcl": 322,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 3894,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0002180",
    "resolved_pwsid": "MI0002180",
    "system_name": "ESSEXVILLE, CITY OF",
    "display_name": "ESSEXVILLE, CITY OF",
    "county": "BAY",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 14,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002180",
    "resolved_pwsid": "MI0002180",
    "system_name": "ESSEXVILLE, CITY OF",
    "display_name": "ESSEXVILLE, CITY OF",
    "county": "BAY",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 19,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002180",
    "resolved_pwsid": "MI0002180",
    "system_name": "ESSEXVILLE, CITY OF",
    "display_name": "ESSEXVILLE, CITY OF",
    "county": "BAY",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 14,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002180",
    "resolved_pwsid": "MI0002180",
    "system_name": "ESSEXVILLE, CITY OF",
    "display_name": "ESSEXVILLE, CITY OF",
    "county": "BAY",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002180",
    "resolved_pwsid": "MI0002180",
    "system_name": "ESSEXVILLE, CITY OF",
    "display_name": "ESSEXVILLE, CITY OF",
    "county": "BAY",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": 103,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002180",
    "resolved_pwsid": "MI0002180",
    "system_name": "ESSEXVILLE, CITY OF",
    "display_name": "ESSEXVILLE, CITY OF",
    "county": "BAY",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": 65,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002180",
    "resolved_pwsid": "MI0002180",
    "system_name": "ESSEXVILLE, CITY OF",
    "display_name": "ESSEXVILLE, CITY OF",
    "county": "BAY",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 14,
    "above_action_level": true,
    "lines_replaced": 74,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002180",
    "resolved_pwsid": "MI0002180",
    "system_name": "ESSEXVILLE, CITY OF",
    "display_name": "ESSEXVILLE, CITY OF",
    "county": "BAY",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002180",
    "resolved_pwsid": "MI0002180",
    "system_name": "ESSEXVILLE, CITY OF",
    "display_name": "ESSEXVILLE, CITY OF",
    "county": "BAY",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 125,
    "total_to_identify_or_replace": 125,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0002190",
    "resolved_pwsid": "MI0002190",
    "system_name": "EVART, CITY OF",
    "display_name": "EVART, CITY OF",
    "county": "OSCEOLA",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002190",
    "resolved_pwsid": "MI0002190",
    "system_name": "EVART, CITY OF",
    "display_name": "EVART, CITY OF",
    "county": "OSCEOLA",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 12,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002190",
    "resolved_pwsid": "MI0002190",
    "system_name": "EVART, CITY OF",
    "display_name": "EVART, CITY OF",
    "county": "OSCEOLA",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002190",
    "resolved_pwsid": "MI0002190",
    "system_name": "EVART, CITY OF",
    "display_name": "EVART, CITY OF",
    "county": "OSCEOLA",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 42,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002190",
    "resolved_pwsid": "MI0002190",
    "system_name": "EVART, CITY OF",
    "display_name": "EVART, CITY OF",
    "county": "OSCEOLA",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002190",
    "resolved_pwsid": "MI0002190",
    "system_name": "EVART, CITY OF",
    "display_name": "EVART, CITY OF",
    "county": "OSCEOLA",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 2,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002190",
    "resolved_pwsid": "MI0002190",
    "system_name": "EVART, CITY OF",
    "display_name": "EVART, CITY OF",
    "county": "OSCEOLA",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002190",
    "resolved_pwsid": "MI0002190",
    "system_name": "EVART, CITY OF",
    "display_name": "EVART, CITY OF",
    "county": "OSCEOLA",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 14,
    "inventory_lead": 156,
    "inventory_gpcl": 286,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 442,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0002195",
    "resolved_pwsid": "MI0002195",
    "system_name": "LANTERN BAY TREATMENT CENTER",
    "display_name": "LANTERN BAY TREATMENT CENTER",
    "county": "VAN BUREN",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002195",
    "resolved_pwsid": "MI0002195",
    "system_name": "LANTERN BAY TREATMENT CENTER",
    "display_name": "LANTERN BAY TREATMENT CENTER",
    "county": "VAN BUREN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002195",
    "resolved_pwsid": "MI0002195",
    "system_name": "LANTERN BAY TREATMENT CENTER",
    "display_name": "LANTERN BAY TREATMENT CENTER",
    "county": "VAN BUREN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002200",
    "resolved_pwsid": "MI0002200",
    "system_name": "MCMILLAN TOWNSHIP",
    "display_name": "MCMILLAN TOWNSHIP",
    "county": "ONTONAGON",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002200",
    "resolved_pwsid": "MI0002200",
    "system_name": "MCMILLAN TOWNSHIP",
    "display_name": "MCMILLAN TOWNSHIP",
    "county": "ONTONAGON",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002200",
    "resolved_pwsid": "MI0002200",
    "system_name": "MCMILLAN TOWNSHIP",
    "display_name": "MCMILLAN TOWNSHIP",
    "county": "ONTONAGON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002200",
    "resolved_pwsid": "MI0002200",
    "system_name": "MCMILLAN TOWNSHIP",
    "display_name": "MCMILLAN TOWNSHIP",
    "county": "ONTONAGON",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 28,
    "total_to_identify_or_replace": 28,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0002212",
    "resolved_pwsid": "MI0002212",
    "system_name": "FAIRFIELD TOWNSHIP",
    "display_name": "FAIRFIELD TOWNSHIP",
    "county": "LENAWEE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002212",
    "resolved_pwsid": "MI0002212",
    "system_name": "FAIRFIELD TOWNSHIP",
    "display_name": "FAIRFIELD TOWNSHIP",
    "county": "LENAWEE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002212",
    "resolved_pwsid": "MI0002212",
    "system_name": "FAIRFIELD TOWNSHIP",
    "display_name": "FAIRFIELD TOWNSHIP",
    "county": "LENAWEE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002215",
    "resolved_pwsid": "MI0002215",
    "system_name": "FAIRWAY LAKE CONDOMINIUMS",
    "display_name": "FAIRWAY LAKE CONDOMINIUMS",
    "county": "OTSEGO",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002215",
    "resolved_pwsid": "MI0002215",
    "system_name": "FAIRWAY LAKE CONDOMINIUMS",
    "display_name": "FAIRWAY LAKE CONDOMINIUMS",
    "county": "OTSEGO",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002215",
    "resolved_pwsid": "MI0002215",
    "system_name": "FAIRWAY LAKE CONDOMINIUMS",
    "display_name": "FAIRWAY LAKE CONDOMINIUMS",
    "county": "OTSEGO",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002215",
    "resolved_pwsid": "MI0002215",
    "system_name": "FAIRWAY LAKE CONDOMINIUMS",
    "display_name": "FAIRWAY LAKE CONDOMINIUMS",
    "county": "OTSEGO",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0002230",
    "resolved_pwsid": "MI0002230",
    "system_name": "FARMINGTON, CITY OF",
    "display_name": "FARMINGTON, CITY OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002230",
    "resolved_pwsid": "MI0002230",
    "system_name": "FARMINGTON, CITY OF",
    "display_name": "FARMINGTON, CITY OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002230",
    "resolved_pwsid": "MI0002230",
    "system_name": "FARMINGTON, CITY OF",
    "display_name": "FARMINGTON, CITY OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002230",
    "resolved_pwsid": "MI0002230",
    "system_name": "FARMINGTON, CITY OF",
    "display_name": "FARMINGTON, CITY OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 10,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002230",
    "resolved_pwsid": "MI0002230",
    "system_name": "FARMINGTON, CITY OF",
    "display_name": "FARMINGTON, CITY OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 3,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002230",
    "resolved_pwsid": "MI0002230",
    "system_name": "FARMINGTON, CITY OF",
    "display_name": "FARMINGTON, CITY OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 6,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002230",
    "resolved_pwsid": "MI0002230",
    "system_name": "FARMINGTON, CITY OF",
    "display_name": "FARMINGTON, CITY OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 7,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002230",
    "resolved_pwsid": "MI0002230",
    "system_name": "FARMINGTON, CITY OF",
    "display_name": "FARMINGTON, CITY OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": 0,
    "inventory_gpcl": 20,
    "inventory_unknown": 31,
    "total_to_identify_or_replace": 51,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0002240",
    "resolved_pwsid": "MI0002240",
    "system_name": "FARMINGTON HILLS, CITY OF",
    "display_name": "FARMINGTON HILLS, CITY OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002240",
    "resolved_pwsid": "MI0002240",
    "system_name": "FARMINGTON HILLS, CITY OF",
    "display_name": "FARMINGTON HILLS, CITY OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002240",
    "resolved_pwsid": "MI0002240",
    "system_name": "FARMINGTON HILLS, CITY OF",
    "display_name": "FARMINGTON HILLS, CITY OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002240",
    "resolved_pwsid": "MI0002240",
    "system_name": "FARMINGTON HILLS, CITY OF",
    "display_name": "FARMINGTON HILLS, CITY OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002240",
    "resolved_pwsid": "MI0002240",
    "system_name": "FARMINGTON HILLS, CITY OF",
    "display_name": "FARMINGTON HILLS, CITY OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002240",
    "resolved_pwsid": "MI0002240",
    "system_name": "FARMINGTON HILLS, CITY OF",
    "display_name": "FARMINGTON HILLS, CITY OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002240",
    "resolved_pwsid": "MI0002240",
    "system_name": "FARMINGTON HILLS, CITY OF",
    "display_name": "FARMINGTON HILLS, CITY OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002240",
    "resolved_pwsid": "MI0002240",
    "system_name": "FARMINGTON HILLS, CITY OF",
    "display_name": "FARMINGTON HILLS, CITY OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0002250",
    "resolved_pwsid": "MI0002250",
    "system_name": "FARWELL, VILLAGE OF",
    "display_name": "FARWELL, VILLAGE OF",
    "county": "CLARE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002250",
    "resolved_pwsid": "MI0002250",
    "system_name": "FARWELL, VILLAGE OF",
    "display_name": "FARWELL, VILLAGE OF",
    "county": "CLARE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002250",
    "resolved_pwsid": "MI0002250",
    "system_name": "FARWELL, VILLAGE OF",
    "display_name": "FARWELL, VILLAGE OF",
    "county": "CLARE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 4,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002250",
    "resolved_pwsid": "MI0002250",
    "system_name": "FARWELL, VILLAGE OF",
    "display_name": "FARWELL, VILLAGE OF",
    "county": "CLARE",
    "monitoring_end_date": "",
    "year": 2023,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 3,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002250",
    "resolved_pwsid": "MI0002250",
    "system_name": "FARWELL, VILLAGE OF",
    "display_name": "FARWELL, VILLAGE OF",
    "county": "CLARE",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002260",
    "resolved_pwsid": "MI0002260",
    "system_name": "FENNVILLE",
    "display_name": "FENNVILLE",
    "county": "ALLEGAN",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002260",
    "resolved_pwsid": "MI0002260",
    "system_name": "FENNVILLE",
    "display_name": "FENNVILLE",
    "county": "ALLEGAN",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002260",
    "resolved_pwsid": "MI0002260",
    "system_name": "FENNVILLE",
    "display_name": "FENNVILLE",
    "county": "ALLEGAN",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": 11,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002260",
    "resolved_pwsid": "MI0002260",
    "system_name": "FENNVILLE",
    "display_name": "FENNVILLE",
    "county": "ALLEGAN",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": 20,
    "inventory_lead": 53,
    "inventory_gpcl": 39,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 92,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0002260",
    "resolved_pwsid": "MI0002260",
    "system_name": "FENNVILLE",
    "display_name": "FENNVILLE",
    "county": "ALLEGAN",
    "monitoring_end_date": "2026-06-30",
    "year": 2026,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002260",
    "resolved_pwsid": "MI0002260",
    "system_name": "FENNVILLE",
    "display_name": "FENNVILLE",
    "county": "ALLEGAN",
    "monitoring_end_date": "",
    "year": 2021,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 10,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002260",
    "resolved_pwsid": "MI0002260",
    "system_name": "FENNVILLE",
    "display_name": "FENNVILLE",
    "county": "ALLEGAN",
    "monitoring_end_date": "",
    "year": 2023,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 5,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002270",
    "resolved_pwsid": "MI0002270",
    "system_name": "FENTON, CITY OF",
    "display_name": "FENTON, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002270",
    "resolved_pwsid": "MI0002270",
    "system_name": "FENTON, CITY OF",
    "display_name": "FENTON, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002270",
    "resolved_pwsid": "MI0002270",
    "system_name": "FENTON, CITY OF",
    "display_name": "FENTON, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 90,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002270",
    "resolved_pwsid": "MI0002270",
    "system_name": "FENTON, CITY OF",
    "display_name": "FENTON, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 24,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002270",
    "resolved_pwsid": "MI0002270",
    "system_name": "FENTON, CITY OF",
    "display_name": "FENTON, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 45,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002270",
    "resolved_pwsid": "MI0002270",
    "system_name": "FENTON, CITY OF",
    "display_name": "FENTON, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 18,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002270",
    "resolved_pwsid": "MI0002270",
    "system_name": "FENTON, CITY OF",
    "display_name": "FENTON, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 79,
    "inventory_lead": 0,
    "inventory_gpcl": 302,
    "inventory_unknown": 183,
    "total_to_identify_or_replace": 485,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0002273",
    "resolved_pwsid": "MI0002273",
    "system_name": "FENTON HARBOR CONDOMINIUMS",
    "display_name": "FENTON HARBOR CONDOMINIUMS",
    "county": "GENESEE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002273",
    "resolved_pwsid": "MI0002273",
    "system_name": "FENTON HARBOR CONDOMINIUMS",
    "display_name": "FENTON HARBOR CONDOMINIUMS",
    "county": "GENESEE",
    "monitoring_end_date": "2020-09-30",
    "year": 2020,
    "lead_90th_ppb": 40,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002273",
    "resolved_pwsid": "MI0002273",
    "system_name": "FENTON HARBOR CONDOMINIUMS",
    "display_name": "FENTON HARBOR CONDOMINIUMS",
    "county": "GENESEE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 40,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002273",
    "resolved_pwsid": "MI0002273",
    "system_name": "FENTON HARBOR CONDOMINIUMS",
    "display_name": "FENTON HARBOR CONDOMINIUMS",
    "county": "GENESEE",
    "monitoring_end_date": "2021-06-30",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002273",
    "resolved_pwsid": "MI0002273",
    "system_name": "FENTON HARBOR CONDOMINIUMS",
    "display_name": "FENTON HARBOR CONDOMINIUMS",
    "county": "GENESEE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002273",
    "resolved_pwsid": "MI0002273",
    "system_name": "FENTON HARBOR CONDOMINIUMS",
    "display_name": "FENTON HARBOR CONDOMINIUMS",
    "county": "GENESEE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002274",
    "resolved_pwsid": "MI0002274",
    "system_name": "CREEKSIDE AT FENTON HEIGHTS",
    "display_name": "CREEKSIDE AT FENTON HEIGHTS",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002274",
    "resolved_pwsid": "MI0002274",
    "system_name": "CREEKSIDE AT FENTON HEIGHTS",
    "display_name": "CREEKSIDE AT FENTON HEIGHTS",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002274",
    "resolved_pwsid": "MI0002274",
    "system_name": "CREEKSIDE AT FENTON HEIGHTS",
    "display_name": "CREEKSIDE AT FENTON HEIGHTS",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002277",
    "resolved_pwsid": "MI0002277",
    "system_name": "LAKE PARK VILLAGE CONDOMINIUMS",
    "display_name": "LAKE PARK VILLAGE CONDOMINIUMS",
    "county": "GENESEE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002277",
    "resolved_pwsid": "MI0002277",
    "system_name": "LAKE PARK VILLAGE CONDOMINIUMS",
    "display_name": "LAKE PARK VILLAGE CONDOMINIUMS",
    "county": "GENESEE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002277",
    "resolved_pwsid": "MI0002277",
    "system_name": "LAKE PARK VILLAGE CONDOMINIUMS",
    "display_name": "LAKE PARK VILLAGE CONDOMINIUMS",
    "county": "GENESEE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002277",
    "resolved_pwsid": "MI0002277",
    "system_name": "LAKE PARK VILLAGE CONDOMINIUMS",
    "display_name": "LAKE PARK VILLAGE CONDOMINIUMS",
    "county": "GENESEE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002277",
    "resolved_pwsid": "MI0002277",
    "system_name": "LAKE PARK VILLAGE CONDOMINIUMS",
    "display_name": "LAKE PARK VILLAGE CONDOMINIUMS",
    "county": "GENESEE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0002280",
    "resolved_pwsid": "MI0002280",
    "system_name": "FERNDALE",
    "display_name": "FERNDALE",
    "county": "OAKLAND",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002280",
    "resolved_pwsid": "MI0002280",
    "system_name": "FERNDALE",
    "display_name": "FERNDALE",
    "county": "OAKLAND",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 15,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002280",
    "resolved_pwsid": "MI0002280",
    "system_name": "FERNDALE",
    "display_name": "FERNDALE",
    "county": "OAKLAND",
    "monitoring_end_date": "2020-09-30",
    "year": 2020,
    "lead_90th_ppb": 28,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002280",
    "resolved_pwsid": "MI0002280",
    "system_name": "FERNDALE",
    "display_name": "FERNDALE",
    "county": "OAKLAND",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 28,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002280",
    "resolved_pwsid": "MI0002280",
    "system_name": "FERNDALE",
    "display_name": "FERNDALE",
    "county": "OAKLAND",
    "monitoring_end_date": "2021-06-30",
    "year": 2021,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": 555,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002280",
    "resolved_pwsid": "MI0002280",
    "system_name": "FERNDALE",
    "display_name": "FERNDALE",
    "county": "OAKLAND",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 11,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002280",
    "resolved_pwsid": "MI0002280",
    "system_name": "FERNDALE",
    "display_name": "FERNDALE",
    "county": "OAKLAND",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 11,
    "above_action_level": false,
    "lines_replaced": 611,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002280",
    "resolved_pwsid": "MI0002280",
    "system_name": "FERNDALE",
    "display_name": "FERNDALE",
    "county": "OAKLAND",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 11,
    "above_action_level": false,
    "lines_replaced": 501,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002280",
    "resolved_pwsid": "MI0002280",
    "system_name": "FERNDALE",
    "display_name": "FERNDALE",
    "county": "OAKLAND",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": 516,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002280",
    "resolved_pwsid": "MI0002280",
    "system_name": "FERNDALE",
    "display_name": "FERNDALE",
    "county": "OAKLAND",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 9,
    "above_action_level": false,
    "lines_replaced": 148,
    "inventory_lead": 595,
    "inventory_gpcl": 72,
    "inventory_unknown": 6143,
    "total_to_identify_or_replace": 6810,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0002285",
    "resolved_pwsid": "MI0002285",
    "system_name": "FERRYSBURG",
    "display_name": "FERRYSBURG",
    "county": "OTTAWA",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002285",
    "resolved_pwsid": "MI0002285",
    "system_name": "FERRYSBURG",
    "display_name": "FERRYSBURG",
    "county": "OTTAWA",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002285",
    "resolved_pwsid": "MI0002285",
    "system_name": "FERRYSBURG",
    "display_name": "FERRYSBURG",
    "county": "OTTAWA",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002285",
    "resolved_pwsid": "MI0002285",
    "system_name": "FERRYSBURG",
    "display_name": "FERRYSBURG",
    "county": "OTTAWA",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0002287",
    "resolved_pwsid": "MI0002287",
    "system_name": "FIFE LAKE TOWNHOUSES",
    "display_name": "FIFE LAKE TOWNHOUSES",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002287",
    "resolved_pwsid": "MI0002287",
    "system_name": "FIFE LAKE TOWNHOUSES",
    "display_name": "FIFE LAKE TOWNHOUSES",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002287",
    "resolved_pwsid": "MI0002287",
    "system_name": "FIFE LAKE TOWNHOUSES",
    "display_name": "FIFE LAKE TOWNHOUSES",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002290",
    "resolved_pwsid": "MI0002290",
    "system_name": "FILER CHARTER TOWNSHIP",
    "display_name": "FILER CHARTER TOWNSHIP",
    "county": "MANISTEE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002290",
    "resolved_pwsid": "MI0002290",
    "system_name": "FILER CHARTER TOWNSHIP",
    "display_name": "FILER CHARTER TOWNSHIP",
    "county": "MANISTEE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002290",
    "resolved_pwsid": "MI0002290",
    "system_name": "FILER CHARTER TOWNSHIP",
    "display_name": "FILER CHARTER TOWNSHIP",
    "county": "MANISTEE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002291",
    "resolved_pwsid": "MI0002291",
    "system_name": "FILLMORE TOWNSHIP",
    "display_name": "FILLMORE TOWNSHIP",
    "county": "ALLEGAN",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002291",
    "resolved_pwsid": "MI0002291",
    "system_name": "FILLMORE TOWNSHIP",
    "display_name": "FILLMORE TOWNSHIP",
    "county": "ALLEGAN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002291",
    "resolved_pwsid": "MI0002291",
    "system_name": "FILLMORE TOWNSHIP",
    "display_name": "FILLMORE TOWNSHIP",
    "county": "ALLEGAN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002292",
    "resolved_pwsid": "MI0002292",
    "system_name": "EASTERN MICHIGAN NAZARENE DISTRICT CENTE",
    "display_name": "EASTERN MICHIGAN NAZARENE DISTRICT CENTE",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002292",
    "resolved_pwsid": "MI0002292",
    "system_name": "EASTERN MICHIGAN NAZARENE DISTRICT CENTE",
    "display_name": "EASTERN MICHIGAN NAZARENE DISTRICT CENTE",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002292",
    "resolved_pwsid": "MI0002292",
    "system_name": "EASTERN MICHIGAN NAZARENE DISTRICT CENTE",
    "display_name": "EASTERN MICHIGAN NAZARENE DISTRICT CENTE",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002292",
    "resolved_pwsid": "MI0002292-a",
    "system_name": "EASTERN MI DISTRICT CHURCH OF NAZARENE",
    "display_name": "EASTERN MICHIGAN NAZARENE DISTRICT CENTE",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002300",
    "resolved_pwsid": "MI0002300",
    "system_name": "FLAT ROCK",
    "display_name": "FLAT ROCK",
    "county": "WAYNE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002300",
    "resolved_pwsid": "MI0002300",
    "system_name": "FLAT ROCK",
    "display_name": "FLAT ROCK",
    "county": "WAYNE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002300",
    "resolved_pwsid": "MI0002300",
    "system_name": "FLAT ROCK",
    "display_name": "FLAT ROCK",
    "county": "WAYNE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002300",
    "resolved_pwsid": "MI0002300",
    "system_name": "FLAT ROCK",
    "display_name": "FLAT ROCK",
    "county": "WAYNE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002300",
    "resolved_pwsid": "MI0002300",
    "system_name": "FLAT ROCK",
    "display_name": "FLAT ROCK",
    "county": "WAYNE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002300",
    "resolved_pwsid": "MI0002300",
    "system_name": "FLAT ROCK",
    "display_name": "FLAT ROCK",
    "county": "WAYNE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 32,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002300",
    "resolved_pwsid": "MI0002300",
    "system_name": "FLAT ROCK",
    "display_name": "FLAT ROCK",
    "county": "WAYNE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": 44,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002300",
    "resolved_pwsid": "MI0002300",
    "system_name": "FLAT ROCK",
    "display_name": "FLAT ROCK",
    "county": "WAYNE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": 34,
    "inventory_lead": 178,
    "inventory_gpcl": 0,
    "inventory_unknown": 12,
    "total_to_identify_or_replace": 190,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0002310",
    "resolved_pwsid": "MI0002310",
    "system_name": "FLINT, CITY OF",
    "display_name": "FLINT, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002310",
    "resolved_pwsid": "MI0002310",
    "system_name": "FLINT, CITY OF",
    "display_name": "FLINT, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002310",
    "resolved_pwsid": "MI0002310",
    "system_name": "FLINT, CITY OF",
    "display_name": "FLINT, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002310",
    "resolved_pwsid": "MI0002310",
    "system_name": "FLINT, CITY OF",
    "display_name": "FLINT, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002310",
    "resolved_pwsid": "MI0002310",
    "system_name": "FLINT, CITY OF",
    "display_name": "FLINT, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002310",
    "resolved_pwsid": "MI0002310",
    "system_name": "FLINT, CITY OF",
    "display_name": "FLINT, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2021-06-30",
    "year": 2021,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": 214,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002310",
    "resolved_pwsid": "MI0002310",
    "system_name": "FLINT, CITY OF",
    "display_name": "FLINT, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002310",
    "resolved_pwsid": "MI0002310",
    "system_name": "FLINT, CITY OF",
    "display_name": "FLINT, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2022-06-30",
    "year": 2022,
    "lead_90th_ppb": 10,
    "above_action_level": false,
    "lines_replaced": 122,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002310",
    "resolved_pwsid": "MI0002310",
    "system_name": "FLINT, CITY OF",
    "display_name": "FLINT, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 9,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002310",
    "resolved_pwsid": "MI0002310",
    "system_name": "FLINT, CITY OF",
    "display_name": "FLINT, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2023-06-30",
    "year": 2023,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": 247,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002310",
    "resolved_pwsid": "MI0002310",
    "system_name": "FLINT, CITY OF",
    "display_name": "FLINT, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 10,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002310",
    "resolved_pwsid": "MI0002310",
    "system_name": "FLINT, CITY OF",
    "display_name": "FLINT, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2024-06-30",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 62,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002310",
    "resolved_pwsid": "MI0002310",
    "system_name": "FLINT, CITY OF",
    "display_name": "FLINT, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002310",
    "resolved_pwsid": "MI0002310",
    "system_name": "FLINT, CITY OF",
    "display_name": "FLINT, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": 382,
    "inventory_lead": 722,
    "inventory_gpcl": 120,
    "inventory_unknown": 3283,
    "total_to_identify_or_replace": 4125,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0002310",
    "resolved_pwsid": "MI0002310",
    "system_name": "FLINT, CITY OF",
    "display_name": "FLINT, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2026-06-30",
    "year": 2026,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002340",
    "resolved_pwsid": "MI0002340",
    "system_name": "FLUSHING, CITY OF",
    "display_name": "FLUSHING, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002340",
    "resolved_pwsid": "MI0002340",
    "system_name": "FLUSHING, CITY OF",
    "display_name": "FLUSHING, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002340",
    "resolved_pwsid": "MI0002340",
    "system_name": "FLUSHING, CITY OF",
    "display_name": "FLUSHING, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002340",
    "resolved_pwsid": "MI0002340",
    "system_name": "FLUSHING, CITY OF",
    "display_name": "FLUSHING, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002340",
    "resolved_pwsid": "MI0002340",
    "system_name": "FLUSHING, CITY OF",
    "display_name": "FLUSHING, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2021-06-30",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002340",
    "resolved_pwsid": "MI0002340",
    "system_name": "FLUSHING, CITY OF",
    "display_name": "FLUSHING, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002340",
    "resolved_pwsid": "MI0002340",
    "system_name": "FLUSHING, CITY OF",
    "display_name": "FLUSHING, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002340",
    "resolved_pwsid": "MI0002340",
    "system_name": "FLUSHING, CITY OF",
    "display_name": "FLUSHING, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 4,
    "inventory_lead": 0,
    "inventory_gpcl": 5,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 5,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0002347",
    "resolved_pwsid": "MI0002347",
    "system_name": "FONDA LAKE WATER AUTHORITY",
    "display_name": "FONDA LAKE WATER AUTHORITY",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002347",
    "resolved_pwsid": "MI0002347",
    "system_name": "FONDA LAKE WATER AUTHORITY",
    "display_name": "FONDA LAKE WATER AUTHORITY",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002347",
    "resolved_pwsid": "MI0002347",
    "system_name": "FONDA LAKE WATER AUTHORITY",
    "display_name": "FONDA LAKE WATER AUTHORITY",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002350",
    "resolved_pwsid": "MI0002350",
    "system_name": "FORD RIVER TOWNSHIP",
    "display_name": "FORD RIVER TOWNSHIP",
    "county": "DELTA",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002350",
    "resolved_pwsid": "MI0002350",
    "system_name": "FORD RIVER TOWNSHIP",
    "display_name": "FORD RIVER TOWNSHIP",
    "county": "DELTA",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002350",
    "resolved_pwsid": "MI0002350",
    "system_name": "FORD RIVER TOWNSHIP",
    "display_name": "FORD RIVER TOWNSHIP",
    "county": "DELTA",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002350",
    "resolved_pwsid": "MI0002350",
    "system_name": "FORD RIVER TOWNSHIP",
    "display_name": "FORD RIVER TOWNSHIP",
    "county": "DELTA",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002350",
    "resolved_pwsid": "MI0002350",
    "system_name": "FORD RIVER TOWNSHIP",
    "display_name": "FORD RIVER TOWNSHIP",
    "county": "DELTA",
    "monitoring_end_date": "",
    "year": 2021,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002350",
    "resolved_pwsid": "MI0002350",
    "system_name": "FORD RIVER TOWNSHIP",
    "display_name": "FORD RIVER TOWNSHIP",
    "county": "DELTA",
    "monitoring_end_date": "",
    "year": 2022,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002350",
    "resolved_pwsid": "MI0002350",
    "system_name": "FORD RIVER TOWNSHIP",
    "display_name": "FORD RIVER TOWNSHIP",
    "county": "DELTA",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 4,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002356",
    "resolved_pwsid": "MI0002356",
    "system_name": "FORESTER TOWNSHIP",
    "display_name": "FORESTER TOWNSHIP",
    "county": "SANILAC",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002356",
    "resolved_pwsid": "MI0002356",
    "system_name": "FORESTER TOWNSHIP",
    "display_name": "FORESTER TOWNSHIP",
    "county": "SANILAC",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002356",
    "resolved_pwsid": "MI0002356",
    "system_name": "FORESTER TOWNSHIP",
    "display_name": "FORESTER TOWNSHIP",
    "county": "SANILAC",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002356",
    "resolved_pwsid": "MI0002356",
    "system_name": "FORESTER TOWNSHIP",
    "display_name": "FORESTER TOWNSHIP",
    "county": "SANILAC",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0002360",
    "resolved_pwsid": "MI0002360",
    "system_name": "FORESTVILLE VILLAGE OF",
    "display_name": "FORESTVILLE VILLAGE OF",
    "county": "SANILAC",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002360",
    "resolved_pwsid": "MI0002360",
    "system_name": "FORESTVILLE VILLAGE OF",
    "display_name": "FORESTVILLE VILLAGE OF",
    "county": "SANILAC",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002360",
    "resolved_pwsid": "MI0002360",
    "system_name": "FORESTVILLE VILLAGE OF",
    "display_name": "FORESTVILLE VILLAGE OF",
    "county": "SANILAC",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002370",
    "resolved_pwsid": "MI0002370",
    "system_name": "FORSYTH TOWNSHIP",
    "display_name": "FORSYTH TOWNSHIP",
    "county": "MARQUETTE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002370",
    "resolved_pwsid": "MI0002370",
    "system_name": "FORSYTH TOWNSHIP",
    "display_name": "FORSYTH TOWNSHIP",
    "county": "MARQUETTE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002370",
    "resolved_pwsid": "MI0002370",
    "system_name": "FORSYTH TOWNSHIP",
    "display_name": "FORSYTH TOWNSHIP",
    "county": "MARQUETTE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002385",
    "resolved_pwsid": "MI0002385",
    "system_name": "FORT GRATIOT TOWNSHIP",
    "display_name": "FORT GRATIOT TOWNSHIP",
    "county": "ST CLAIR",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002385",
    "resolved_pwsid": "MI0002385",
    "system_name": "FORT GRATIOT TOWNSHIP",
    "display_name": "FORT GRATIOT TOWNSHIP",
    "county": "ST CLAIR",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002385",
    "resolved_pwsid": "MI0002385",
    "system_name": "FORT GRATIOT TOWNSHIP",
    "display_name": "FORT GRATIOT TOWNSHIP",
    "county": "ST. CLAIR",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002390",
    "resolved_pwsid": "MI0002390",
    "system_name": "FOWLER, VILLAGE OF",
    "display_name": "FOWLER, VILLAGE OF",
    "county": "CLINTON",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002390",
    "resolved_pwsid": "MI0002390",
    "system_name": "FOWLER, VILLAGE OF",
    "display_name": "FOWLER, VILLAGE OF",
    "county": "CLINTON",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002390",
    "resolved_pwsid": "MI0002390",
    "system_name": "FOWLER, VILLAGE OF",
    "display_name": "FOWLER, VILLAGE OF",
    "county": "CLINTON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002400",
    "resolved_pwsid": "MI0002400",
    "system_name": "FOWLERVILLE, VILLAGE OF",
    "display_name": "FOWLERVILLE, VILLAGE OF",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002400",
    "resolved_pwsid": "MI0002400",
    "system_name": "FOWLERVILLE, VILLAGE OF",
    "display_name": "FOWLERVILLE, VILLAGE OF",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002400",
    "resolved_pwsid": "MI0002400",
    "system_name": "FOWLERVILLE, VILLAGE OF",
    "display_name": "FOWLERVILLE, VILLAGE OF",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002403",
    "resolved_pwsid": "MI0002403",
    "system_name": "FOXFIELD APARTMENTS",
    "display_name": "FOXFIELD APARTMENTS",
    "county": "EMMET",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002403",
    "resolved_pwsid": "MI0002403",
    "system_name": "FOXFIELD APARTMENTS",
    "display_name": "FOXFIELD APARTMENTS",
    "county": "EMMET",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002403",
    "resolved_pwsid": "MI0002403",
    "system_name": "FOXFIELD APARTMENTS",
    "display_name": "FOXFIELD APARTMENTS",
    "county": "EMMET",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002410",
    "resolved_pwsid": "MI0002410",
    "system_name": "FRANKENLUST TOWNSHIP",
    "display_name": "FRANKENLUST TOWNSHIP",
    "county": "BAY",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002410",
    "resolved_pwsid": "MI0002410",
    "system_name": "FRANKENLUST TOWNSHIP",
    "display_name": "FRANKENLUST TOWNSHIP",
    "county": "BAY",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002410",
    "resolved_pwsid": "MI0002410",
    "system_name": "FRANKENLUST TOWNSHIP",
    "display_name": "FRANKENLUST TOWNSHIP",
    "county": "BAY",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002410",
    "resolved_pwsid": "MI0002410",
    "system_name": "FRANKENLUST TOWNSHIP",
    "display_name": "FRANKENLUST TOWNSHIP",
    "county": "BAY",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002410",
    "resolved_pwsid": "MI0002410",
    "system_name": "FRANKENLUST TOWNSHIP",
    "display_name": "FRANKENLUST TOWNSHIP",
    "county": "BAY",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002410",
    "resolved_pwsid": "MI0002410",
    "system_name": "FRANKENLUST TOWNSHIP",
    "display_name": "FRANKENLUST TOWNSHIP",
    "county": "BAY",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002410",
    "resolved_pwsid": "MI0002410",
    "system_name": "FRANKENLUST TOWNSHIP",
    "display_name": "FRANKENLUST TOWNSHIP",
    "county": "BAY",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002420",
    "resolved_pwsid": "MI0002420",
    "system_name": "FRANKENMUTH, CITY OF",
    "display_name": "FRANKENMUTH, CITY OF",
    "county": "SAGINAW",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002420",
    "resolved_pwsid": "MI0002420",
    "system_name": "FRANKENMUTH, CITY OF",
    "display_name": "FRANKENMUTH, CITY OF",
    "county": "SAGINAW",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002420",
    "resolved_pwsid": "MI0002420",
    "system_name": "FRANKENMUTH, CITY OF",
    "display_name": "FRANKENMUTH, CITY OF",
    "county": "SAGINAW",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002420",
    "resolved_pwsid": "MI0002420",
    "system_name": "FRANKENMUTH, CITY OF",
    "display_name": "FRANKENMUTH, CITY OF",
    "county": "SAGINAW",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002420",
    "resolved_pwsid": "MI0002420",
    "system_name": "FRANKENMUTH, CITY OF",
    "display_name": "FRANKENMUTH, CITY OF",
    "county": "SAGINAW",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002420",
    "resolved_pwsid": "MI0002420",
    "system_name": "FRANKENMUTH, CITY OF",
    "display_name": "FRANKENMUTH, CITY OF",
    "county": "SAGINAW",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002420",
    "resolved_pwsid": "MI0002420",
    "system_name": "FRANKENMUTH, CITY OF",
    "display_name": "FRANKENMUTH, CITY OF",
    "county": "SAGINAW",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002425",
    "resolved_pwsid": "MI0002425",
    "system_name": "FRANKENMUTH TOWNSHIP",
    "display_name": "FRANKENMUTH TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002425",
    "resolved_pwsid": "MI0002425",
    "system_name": "FRANKENMUTH TOWNSHIP",
    "display_name": "FRANKENMUTH TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002425",
    "resolved_pwsid": "MI0002425",
    "system_name": "FRANKENMUTH TOWNSHIP",
    "display_name": "FRANKENMUTH TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002425",
    "resolved_pwsid": "MI0002425",
    "system_name": "FRANKENMUTH TOWNSHIP",
    "display_name": "FRANKENMUTH TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002425",
    "resolved_pwsid": "MI0002425",
    "system_name": "FRANKENMUTH TOWNSHIP",
    "display_name": "FRANKENMUTH TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002425",
    "resolved_pwsid": "MI0002425",
    "system_name": "FRANKENMUTH TOWNSHIP",
    "display_name": "FRANKENMUTH TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002425",
    "resolved_pwsid": "MI0002425",
    "system_name": "FRANKENMUTH TOWNSHIP",
    "display_name": "FRANKENMUTH TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002430",
    "resolved_pwsid": "MI0002430",
    "system_name": "FRANKFORT, CITY OF",
    "display_name": "FRANKFORT, CITY OF",
    "county": "BENZIE",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002430",
    "resolved_pwsid": "MI0002430",
    "system_name": "FRANKFORT, CITY OF",
    "display_name": "FRANKFORT, CITY OF",
    "county": "BENZIE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002430",
    "resolved_pwsid": "MI0002430",
    "system_name": "FRANKFORT, CITY OF",
    "display_name": "FRANKFORT, CITY OF",
    "county": "BENZIE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002430",
    "resolved_pwsid": "MI0002430",
    "system_name": "FRANKFORT, CITY OF",
    "display_name": "FRANKFORT, CITY OF",
    "county": "BENZIE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 10,
    "inventory_lead": 273,
    "inventory_gpcl": 3,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 276,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0002430",
    "resolved_pwsid": "MI0002430",
    "system_name": "FRANKFORT, CITY OF",
    "display_name": "FRANKFORT, CITY OF",
    "county": "BENZIE",
    "monitoring_end_date": "",
    "year": 2021,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 38,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002430",
    "resolved_pwsid": "MI0002430",
    "system_name": "FRANKFORT, CITY OF",
    "display_name": "FRANKFORT, CITY OF",
    "county": "BENZIE",
    "monitoring_end_date": "",
    "year": 2023,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 9,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002430",
    "resolved_pwsid": "MI0002430",
    "system_name": "FRANKFORT, CITY OF",
    "display_name": "FRANKFORT, CITY OF",
    "county": "BENZIE",
    "monitoring_end_date": "",
    "year": 2024,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 8,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002440",
    "resolved_pwsid": "MI0002440",
    "system_name": "FRANKLIN KNOLLS SUBDIVISION",
    "display_name": "FRANKLIN KNOLLS SUBDIVISION",
    "county": "OAKLAND",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002440",
    "resolved_pwsid": "MI0002440",
    "system_name": "FRANKLIN KNOLLS SUBDIVISION",
    "display_name": "FRANKLIN KNOLLS SUBDIVISION",
    "county": "OAKLAND",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002440",
    "resolved_pwsid": "MI0002440",
    "system_name": "FRANKLIN KNOLLS SUBDIVISION",
    "display_name": "FRANKLIN KNOLLS SUBDIVISION",
    "county": "OAKLAND",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002440",
    "resolved_pwsid": "MI0002440",
    "system_name": "FRANKLIN KNOLLS SUBDIVISION",
    "display_name": "FRANKLIN KNOLLS SUBDIVISION",
    "county": "OAKLAND",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0002450",
    "resolved_pwsid": "MI0002450",
    "system_name": "BRIARCLIFF HOMEOWNERS ASSN",
    "display_name": "BRIARCLIFF HOMEOWNERS ASSN",
    "county": "OAKLAND",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002450",
    "resolved_pwsid": "MI0002450",
    "system_name": "BRIARCLIFF HOMEOWNERS ASSN",
    "display_name": "BRIARCLIFF HOMEOWNERS ASSN",
    "county": "OAKLAND",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002450",
    "resolved_pwsid": "MI0002450",
    "system_name": "BRIARCLIFF HOMEOWNERS ASSN",
    "display_name": "BRIARCLIFF HOMEOWNERS ASSN",
    "county": "OAKLAND",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002460",
    "resolved_pwsid": "MI0002460",
    "system_name": "FRASER, CITY OF",
    "display_name": "FRASER, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002460",
    "resolved_pwsid": "MI0002460",
    "system_name": "FRASER, CITY OF",
    "display_name": "FRASER, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002460",
    "resolved_pwsid": "MI0002460",
    "system_name": "FRASER, CITY OF",
    "display_name": "FRASER, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002460",
    "resolved_pwsid": "MI0002460",
    "system_name": "FRASER, CITY OF",
    "display_name": "FRASER, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002460",
    "resolved_pwsid": "MI0002460",
    "system_name": "FRASER, CITY OF",
    "display_name": "FRASER, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002460",
    "resolved_pwsid": "MI0002460",
    "system_name": "FRASER, CITY OF",
    "display_name": "FRASER, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002460",
    "resolved_pwsid": "MI0002460",
    "system_name": "FRASER, CITY OF",
    "display_name": "FRASER, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002460",
    "resolved_pwsid": "MI0002460",
    "system_name": "FRASER, CITY OF",
    "display_name": "FRASER, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 159,
    "total_to_identify_or_replace": 159,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0002465",
    "resolved_pwsid": "MI0002465",
    "system_name": "FRASER TOWNSHIP",
    "display_name": "FRASER TOWNSHIP",
    "county": "BAY",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002465",
    "resolved_pwsid": "MI0002465",
    "system_name": "FRASER TOWNSHIP",
    "display_name": "FRASER TOWNSHIP",
    "county": "BAY",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002465",
    "resolved_pwsid": "MI0002465",
    "system_name": "FRASER TOWNSHIP",
    "display_name": "FRASER TOWNSHIP",
    "county": "BAY",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002465",
    "resolved_pwsid": "MI0002465",
    "system_name": "FRASER TOWNSHIP",
    "display_name": "FRASER TOWNSHIP",
    "county": "BAY",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002465",
    "resolved_pwsid": "MI0002465",
    "system_name": "FRASER TOWNSHIP",
    "display_name": "FRASER TOWNSHIP",
    "county": "BAY",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002465",
    "resolved_pwsid": "MI0002465",
    "system_name": "FRASER TOWNSHIP",
    "display_name": "FRASER TOWNSHIP",
    "county": "BAY",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002465",
    "resolved_pwsid": "MI0002465",
    "system_name": "FRASER TOWNSHIP",
    "display_name": "FRASER TOWNSHIP",
    "county": "BAY",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002470",
    "resolved_pwsid": "MI0002470",
    "system_name": "TITTABAWASSEE TOWNSHIP",
    "display_name": "TITTABAWASSEE TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002470",
    "resolved_pwsid": "MI0002470",
    "system_name": "TITTABAWASSEE TOWNSHIP",
    "display_name": "TITTABAWASSEE TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002470",
    "resolved_pwsid": "MI0002470",
    "system_name": "TITTABAWASSEE TOWNSHIP",
    "display_name": "TITTABAWASSEE TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002470",
    "resolved_pwsid": "MI0002470",
    "system_name": "TITTABAWASSEE TOWNSHIP",
    "display_name": "TITTABAWASSEE TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002470",
    "resolved_pwsid": "MI0002470",
    "system_name": "TITTABAWASSEE TOWNSHIP",
    "display_name": "TITTABAWASSEE TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002470",
    "resolved_pwsid": "MI0002470",
    "system_name": "TITTABAWASSEE TOWNSHIP",
    "display_name": "TITTABAWASSEE TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002470",
    "resolved_pwsid": "MI0002470",
    "system_name": "TITTABAWASSEE TOWNSHIP",
    "display_name": "TITTABAWASSEE TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002480",
    "resolved_pwsid": "MI0002480",
    "system_name": "FREEPORT",
    "display_name": "FREEPORT",
    "county": "BARRY",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002480",
    "resolved_pwsid": "MI0002480",
    "system_name": "FREEPORT",
    "display_name": "FREEPORT",
    "county": "BARRY",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 11,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002480",
    "resolved_pwsid": "MI0002480",
    "system_name": "FREEPORT",
    "display_name": "FREEPORT",
    "county": "BARRY",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 8,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002480",
    "resolved_pwsid": "MI0002480",
    "system_name": "FREEPORT",
    "display_name": "FREEPORT",
    "county": "BARRY",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": 24,
    "inventory_lead": 0,
    "inventory_gpcl": 51,
    "inventory_unknown": 5,
    "total_to_identify_or_replace": 56,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0002480",
    "resolved_pwsid": "MI0002480",
    "system_name": "FREEPORT",
    "display_name": "FREEPORT",
    "county": "BARRY",
    "monitoring_end_date": "",
    "year": 2021,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002480",
    "resolved_pwsid": "MI0002480",
    "system_name": "FREEPORT",
    "display_name": "FREEPORT",
    "county": "BARRY",
    "monitoring_end_date": "",
    "year": 2023,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 3,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002480",
    "resolved_pwsid": "MI0002480",
    "system_name": "FREEPORT",
    "display_name": "FREEPORT",
    "county": "BARRY",
    "monitoring_end_date": "",
    "year": 2024,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 2,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002490",
    "resolved_pwsid": "MI0002490",
    "system_name": "FREMONT",
    "display_name": "FREMONT",
    "county": "NEWAYGO",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002490",
    "resolved_pwsid": "MI0002490",
    "system_name": "FREMONT",
    "display_name": "FREMONT",
    "county": "NEWAYGO",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002490",
    "resolved_pwsid": "MI0002490",
    "system_name": "FREMONT",
    "display_name": "FREMONT",
    "county": "NEWAYGO",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 16,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002490",
    "resolved_pwsid": "MI0002490",
    "system_name": "FREMONT",
    "display_name": "FREMONT",
    "county": "NEWAYGO",
    "monitoring_end_date": "",
    "year": 2021,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 10,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002490",
    "resolved_pwsid": "MI0002490",
    "system_name": "FREMONT",
    "display_name": "FREMONT",
    "county": "NEWAYGO",
    "monitoring_end_date": "",
    "year": 2022,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 14,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002490",
    "resolved_pwsid": "MI0002490",
    "system_name": "FREMONT",
    "display_name": "FREMONT",
    "county": "NEWAYGO",
    "monitoring_end_date": "",
    "year": 2024,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 5,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002490",
    "resolved_pwsid": "MI0002490",
    "system_name": "FREMONT",
    "display_name": "FREMONT",
    "county": "NEWAYGO",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 2,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002500",
    "resolved_pwsid": "MI0002500",
    "system_name": "FRENCHTOWN TOWNSHIP",
    "display_name": "FRENCHTOWN TOWNSHIP",
    "county": "MONROE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002500",
    "resolved_pwsid": "MI0002500",
    "system_name": "FRENCHTOWN TOWNSHIP",
    "display_name": "FRENCHTOWN TOWNSHIP",
    "county": "MONROE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002500",
    "resolved_pwsid": "MI0002500",
    "system_name": "FRENCHTOWN TOWNSHIP",
    "display_name": "FRENCHTOWN TOWNSHIP",
    "county": "MONROE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002507",
    "resolved_pwsid": "MI0002507",
    "system_name": "FRUITPORT TOWNSHIP",
    "display_name": "FRUITPORT TOWNSHIP",
    "county": "MUSKEGON",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002507",
    "resolved_pwsid": "MI0002507",
    "system_name": "FRUITPORT TOWNSHIP",
    "display_name": "FRUITPORT TOWNSHIP",
    "county": "MUSKEGON",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002507",
    "resolved_pwsid": "MI0002507",
    "system_name": "FRUITPORT TOWNSHIP",
    "display_name": "FRUITPORT TOWNSHIP",
    "county": "MUSKEGON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002507",
    "resolved_pwsid": "MI0002507",
    "system_name": "FRUITPORT TOWNSHIP",
    "display_name": "FRUITPORT TOWNSHIP",
    "county": "MUSKEGON",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 12,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0002510",
    "resolved_pwsid": "MI0002510",
    "system_name": "GAASTRA",
    "display_name": "GAASTRA",
    "county": "IRON",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002510",
    "resolved_pwsid": "MI0002510",
    "system_name": "GAASTRA",
    "display_name": "GAASTRA",
    "county": "IRON",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002510",
    "resolved_pwsid": "MI0002510",
    "system_name": "GAASTRA",
    "display_name": "GAASTRA",
    "county": "IRON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002510",
    "resolved_pwsid": "MI0002510",
    "system_name": "GAASTRA",
    "display_name": "GAASTRA",
    "county": "IRON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002510",
    "resolved_pwsid": "MI0002510",
    "system_name": "GAASTRA",
    "display_name": "GAASTRA",
    "county": "IRON",
    "monitoring_end_date": "2024-06-30",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 7,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002510",
    "resolved_pwsid": "MI0002510",
    "system_name": "GAASTRA",
    "display_name": "GAASTRA",
    "county": "IRON",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 7,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002520",
    "resolved_pwsid": "MI0002520",
    "system_name": "GAGETOWN, VILLAGE OF",
    "display_name": "GAGETOWN, VILLAGE OF",
    "county": "TUSCOLA",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002520",
    "resolved_pwsid": "MI0002520",
    "system_name": "GAGETOWN, VILLAGE OF",
    "display_name": "GAGETOWN, VILLAGE OF",
    "county": "TUSCOLA",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002520",
    "resolved_pwsid": "MI0002520",
    "system_name": "GAGETOWN, VILLAGE OF",
    "display_name": "GAGETOWN, VILLAGE OF",
    "county": "TUSCOLA",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": 5,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002530",
    "resolved_pwsid": "MI0002530",
    "system_name": "GALESBURG",
    "display_name": "GALESBURG",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002530",
    "resolved_pwsid": "MI0002530",
    "system_name": "GALESBURG",
    "display_name": "GALESBURG",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002530",
    "resolved_pwsid": "MI0002530",
    "system_name": "GALESBURG",
    "display_name": "GALESBURG",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002530",
    "resolved_pwsid": "MI0002530",
    "system_name": "GALESBURG",
    "display_name": "GALESBURG",
    "county": "KALAMAZOO",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 4,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002540",
    "resolved_pwsid": "MI0002540",
    "system_name": "GARDEN",
    "display_name": "GARDEN",
    "county": "DELTA",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002540",
    "resolved_pwsid": "MI0002540",
    "system_name": "GARDEN",
    "display_name": "GARDEN",
    "county": "DELTA",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002540",
    "resolved_pwsid": "MI0002540",
    "system_name": "GARDEN",
    "display_name": "GARDEN",
    "county": "DELTA",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002550",
    "resolved_pwsid": "MI0002550",
    "system_name": "GARDEN CITY",
    "display_name": "GARDEN CITY",
    "county": "WAYNE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002550",
    "resolved_pwsid": "MI0002550",
    "system_name": "GARDEN CITY",
    "display_name": "GARDEN CITY",
    "county": "WAYNE",
    "monitoring_end_date": "2019-09-30",
    "year": 2019,
    "lead_90th_ppb": 26,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002550",
    "resolved_pwsid": "MI0002550",
    "system_name": "GARDEN CITY",
    "display_name": "GARDEN CITY",
    "county": "WAYNE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 26,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002550",
    "resolved_pwsid": "MI0002550",
    "system_name": "GARDEN CITY",
    "display_name": "GARDEN CITY",
    "county": "WAYNE",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002550",
    "resolved_pwsid": "MI0002550",
    "system_name": "GARDEN CITY",
    "display_name": "GARDEN CITY",
    "county": "WAYNE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002550",
    "resolved_pwsid": "MI0002550",
    "system_name": "GARDEN CITY",
    "display_name": "GARDEN CITY",
    "county": "WAYNE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": 7,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002550",
    "resolved_pwsid": "MI0002550",
    "system_name": "GARDEN CITY",
    "display_name": "GARDEN CITY",
    "county": "WAYNE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 13,
    "above_action_level": true,
    "lines_replaced": 37,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002550",
    "resolved_pwsid": "MI0002550",
    "system_name": "GARDEN CITY",
    "display_name": "GARDEN CITY",
    "county": "WAYNE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 14,
    "above_action_level": true,
    "lines_replaced": 68,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002550",
    "resolved_pwsid": "MI0002550",
    "system_name": "GARDEN CITY",
    "display_name": "GARDEN CITY",
    "county": "WAYNE",
    "monitoring_end_date": "2024-09-30",
    "year": 2024,
    "lead_90th_ppb": 18,
    "above_action_level": true,
    "lines_replaced": 29,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002550",
    "resolved_pwsid": "MI0002550",
    "system_name": "GARDEN CITY",
    "display_name": "GARDEN CITY",
    "county": "WAYNE",
    "monitoring_end_date": "2025-06-30",
    "year": 2025,
    "lead_90th_ppb": 18,
    "above_action_level": true,
    "lines_replaced": 60,
    "inventory_lead": 315,
    "inventory_gpcl": 0,
    "inventory_unknown": 577,
    "total_to_identify_or_replace": 892,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0002550",
    "resolved_pwsid": "MI0002550",
    "system_name": "GARDEN CITY",
    "display_name": "GARDEN CITY",
    "county": "WAYNE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 15,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": 315,
    "inventory_gpcl": 0,
    "inventory_unknown": 577,
    "total_to_identify_or_replace": 892,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0002550",
    "resolved_pwsid": "MI0002550",
    "system_name": "GARDEN CITY",
    "display_name": "GARDEN CITY",
    "county": "WAYNE",
    "monitoring_end_date": "2026-06-30",
    "year": 2026,
    "lead_90th_ppb": 16,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002565",
    "resolved_pwsid": "MI0002565",
    "system_name": "GARFIELD CHARTER TOWNSHIP",
    "display_name": "GARFIELD CHARTER TOWNSHIP",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002565",
    "resolved_pwsid": "MI0002565",
    "system_name": "GARFIELD CHARTER TOWNSHIP",
    "display_name": "GARFIELD CHARTER TOWNSHIP",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002565",
    "resolved_pwsid": "MI0002565",
    "system_name": "GARFIELD CHARTER TOWNSHIP",
    "display_name": "GARFIELD CHARTER TOWNSHIP",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002565",
    "resolved_pwsid": "MI0002565",
    "system_name": "GARFIELD CHARTER TOWNSHIP",
    "display_name": "GARFIELD CHARTER TOWNSHIP",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002568",
    "resolved_pwsid": "MI0002568",
    "system_name": "GARLAND RESORT",
    "display_name": "GARLAND RESORT",
    "county": "OSCODA",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002568",
    "resolved_pwsid": "MI0002568",
    "system_name": "GARLAND RESORT",
    "display_name": "GARLAND RESORT",
    "county": "OSCODA",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002568",
    "resolved_pwsid": "MI0002568",
    "system_name": "GARLAND RESORT",
    "display_name": "GARLAND RESORT",
    "county": "OSCODA",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002568",
    "resolved_pwsid": "MI0002568",
    "system_name": "GARLAND RESORT",
    "display_name": "GARLAND RESORT",
    "county": "OSCODA",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0002590",
    "resolved_pwsid": "MI0002590",
    "system_name": "SHERMAN TOWNSHIP",
    "display_name": "SHERMAN TOWNSHIP",
    "county": "KEWEENAW",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002590",
    "resolved_pwsid": "MI0002590",
    "system_name": "SHERMAN TOWNSHIP",
    "display_name": "SHERMAN TOWNSHIP",
    "county": "KEWEENAW",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002590",
    "resolved_pwsid": "MI0002590",
    "system_name": "SHERMAN TOWNSHIP",
    "display_name": "SHERMAN TOWNSHIP",
    "county": "KEWEENAW",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002590",
    "resolved_pwsid": "MI0002590",
    "system_name": "SHERMAN TOWNSHIP",
    "display_name": "SHERMAN TOWNSHIP",
    "county": "KEWEENAW",
    "monitoring_end_date": "2021-06-30",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002590",
    "resolved_pwsid": "MI0002590",
    "system_name": "SHERMAN TOWNSHIP",
    "display_name": "SHERMAN TOWNSHIP",
    "county": "KEWEENAW",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002590",
    "resolved_pwsid": "MI0002590",
    "system_name": "SHERMAN TOWNSHIP",
    "display_name": "SHERMAN TOWNSHIP",
    "county": "KEWEENAW",
    "monitoring_end_date": "2022-06-30",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002590",
    "resolved_pwsid": "MI0002590",
    "system_name": "SHERMAN TOWNSHIP",
    "display_name": "SHERMAN TOWNSHIP",
    "county": "KEWEENAW",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002590",
    "resolved_pwsid": "MI0002590",
    "system_name": "SHERMAN TOWNSHIP",
    "display_name": "SHERMAN TOWNSHIP",
    "county": "KEWEENAW",
    "monitoring_end_date": "2023-06-30",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002590",
    "resolved_pwsid": "MI0002590",
    "system_name": "SHERMAN TOWNSHIP",
    "display_name": "SHERMAN TOWNSHIP",
    "county": "KEWEENAW",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002590",
    "resolved_pwsid": "MI0002590",
    "system_name": "SHERMAN TOWNSHIP",
    "display_name": "SHERMAN TOWNSHIP",
    "county": "KEWEENAW",
    "monitoring_end_date": "2024-06-30",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002590",
    "resolved_pwsid": "MI0002590",
    "system_name": "SHERMAN TOWNSHIP",
    "display_name": "SHERMAN TOWNSHIP",
    "county": "KEWEENAW",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002590",
    "resolved_pwsid": "MI0002590",
    "system_name": "SHERMAN TOWNSHIP",
    "display_name": "SHERMAN TOWNSHIP",
    "county": "KEWEENAW",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 60,
    "total_to_identify_or_replace": 60,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0002590",
    "resolved_pwsid": "MI0002590",
    "system_name": "SHERMAN TOWNSHIP",
    "display_name": "SHERMAN TOWNSHIP",
    "county": "KEWEENAW",
    "monitoring_end_date": "2026-06-30",
    "year": 2026,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002600",
    "resolved_pwsid": "MI0002600",
    "system_name": "GAYLORD, CITY OF",
    "display_name": "GAYLORD, CITY OF",
    "county": "OTSEGO",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002600",
    "resolved_pwsid": "MI0002600",
    "system_name": "GAYLORD, CITY OF",
    "display_name": "GAYLORD, CITY OF",
    "county": "OTSEGO",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 5,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002600",
    "resolved_pwsid": "MI0002600",
    "system_name": "GAYLORD, CITY OF",
    "display_name": "GAYLORD, CITY OF",
    "county": "OTSEGO",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002600",
    "resolved_pwsid": "MI0002600",
    "system_name": "GAYLORD, CITY OF",
    "display_name": "GAYLORD, CITY OF",
    "county": "OTSEGO",
    "monitoring_end_date": "",
    "year": 2023,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 4,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002600",
    "resolved_pwsid": "MI0002600",
    "system_name": "GAYLORD, CITY OF",
    "display_name": "GAYLORD, CITY OF",
    "county": "OTSEGO",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 4,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002615",
    "resolved_pwsid": "MI0002615",
    "system_name": "GENESEE COUNTY WATER SYSTEM",
    "display_name": "GENESEE COUNTY WATER SYSTEM",
    "county": "GENESEE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002615",
    "resolved_pwsid": "MI0002615",
    "system_name": "GENESEE COUNTY WATER SYSTEM",
    "display_name": "GENESEE COUNTY WATER SYSTEM",
    "county": "GENESEE",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002615",
    "resolved_pwsid": "MI0002615",
    "system_name": "GENESEE COUNTY WATER SYSTEM",
    "display_name": "GENESEE COUNTY WATER SYSTEM",
    "county": "GENESEE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002615",
    "resolved_pwsid": "MI0002615",
    "system_name": "GENESEE COUNTY WATER SYSTEM",
    "display_name": "GENESEE COUNTY WATER SYSTEM",
    "county": "GENESEE",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002615",
    "resolved_pwsid": "MI0002615",
    "system_name": "GENESEE COUNTY WATER SYSTEM",
    "display_name": "GENESEE COUNTY WATER SYSTEM",
    "county": "GENESEE",
    "monitoring_end_date": "2021-06-30",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002615",
    "resolved_pwsid": "MI0002615",
    "system_name": "GENESEE COUNTY WATER SYSTEM",
    "display_name": "GENESEE COUNTY WATER SYSTEM",
    "county": "GENESEE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002615",
    "resolved_pwsid": "MI0002615",
    "system_name": "GENESEE COUNTY WATER SYSTEM",
    "display_name": "GENESEE COUNTY WATER SYSTEM",
    "county": "GENESEE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002615",
    "resolved_pwsid": "MI0002615",
    "system_name": "GENESEE COUNTY WATER SYSTEM",
    "display_name": "GENESEE COUNTY WATER SYSTEM",
    "county": "GENESEE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002615",
    "resolved_pwsid": "MI0002615",
    "system_name": "GENESEE COUNTY WATER SYSTEM",
    "display_name": "GENESEE COUNTY WATER SYSTEM",
    "county": "GENESEE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002617",
    "resolved_pwsid": "MI0002617",
    "system_name": "GENESEE TOWNSHIP",
    "display_name": "GENESEE TOWNSHIP",
    "county": "GENESEE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002617",
    "resolved_pwsid": "MI0002617",
    "system_name": "GENESEE TOWNSHIP",
    "display_name": "GENESEE TOWNSHIP",
    "county": "GENESEE",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002617",
    "resolved_pwsid": "MI0002617",
    "system_name": "GENESEE TOWNSHIP",
    "display_name": "GENESEE TOWNSHIP",
    "county": "GENESEE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002617",
    "resolved_pwsid": "MI0002617",
    "system_name": "GENESEE TOWNSHIP",
    "display_name": "GENESEE TOWNSHIP",
    "county": "GENESEE",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002617",
    "resolved_pwsid": "MI0002617",
    "system_name": "GENESEE TOWNSHIP",
    "display_name": "GENESEE TOWNSHIP",
    "county": "GENESEE",
    "monitoring_end_date": "2021-06-30",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002617",
    "resolved_pwsid": "MI0002617",
    "system_name": "GENESEE TOWNSHIP",
    "display_name": "GENESEE TOWNSHIP",
    "county": "GENESEE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002617",
    "resolved_pwsid": "MI0002617",
    "system_name": "GENESEE TOWNSHIP",
    "display_name": "GENESEE TOWNSHIP",
    "county": "GENESEE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002619",
    "resolved_pwsid": "MI0002619",
    "system_name": "PRENTIS ESTATES APARTMENTS",
    "display_name": "PRENTIS ESTATES APARTMENTS",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002619",
    "resolved_pwsid": "MI0002619",
    "system_name": "PRENTIS ESTATES APARTMENTS",
    "display_name": "PRENTIS ESTATES APARTMENTS",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002619",
    "resolved_pwsid": "MI0002619",
    "system_name": "PRENTIS ESTATES APARTMENTS",
    "display_name": "PRENTIS ESTATES APARTMENTS",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002620",
    "resolved_pwsid": "MI0002620",
    "system_name": "GEORGETOWN TOWNSHIP",
    "display_name": "GEORGETOWN TOWNSHIP",
    "county": "OTTAWA",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002620",
    "resolved_pwsid": "MI0002620",
    "system_name": "GEORGETOWN TOWNSHIP",
    "display_name": "GEORGETOWN TOWNSHIP",
    "county": "OTTAWA",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002620",
    "resolved_pwsid": "MI0002620",
    "system_name": "GEORGETOWN TOWNSHIP",
    "display_name": "GEORGETOWN TOWNSHIP",
    "county": "OTTAWA",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002620",
    "resolved_pwsid": "MI0002620",
    "system_name": "GEORGETOWN TOWNSHIP",
    "display_name": "GEORGETOWN TOWNSHIP",
    "county": "OTTAWA",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0002625",
    "resolved_pwsid": "MI0002625",
    "system_name": "GERMFASK TOWNSHIP",
    "display_name": "GERMFASK TOWNSHIP",
    "county": "SCHOOLCRAFT",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002625",
    "resolved_pwsid": "MI0002625",
    "system_name": "GERMFASK TOWNSHIP",
    "display_name": "GERMFASK TOWNSHIP",
    "county": "SCHOOLCRAFT",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002625",
    "resolved_pwsid": "MI0002625",
    "system_name": "GERMFASK TOWNSHIP",
    "display_name": "GERMFASK TOWNSHIP",
    "county": "SCHOOLCRAFT",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002630",
    "resolved_pwsid": "MI0002630",
    "system_name": "GIBRALTAR",
    "display_name": "GIBRALTAR",
    "county": "WAYNE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002630",
    "resolved_pwsid": "MI0002630",
    "system_name": "GIBRALTAR",
    "display_name": "GIBRALTAR",
    "county": "WAYNE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002630",
    "resolved_pwsid": "MI0002630",
    "system_name": "GIBRALTAR",
    "display_name": "GIBRALTAR",
    "county": "WAYNE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002630",
    "resolved_pwsid": "MI0002630",
    "system_name": "GIBRALTAR",
    "display_name": "GIBRALTAR",
    "county": "WAYNE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002630",
    "resolved_pwsid": "MI0002630",
    "system_name": "GIBRALTAR",
    "display_name": "GIBRALTAR",
    "county": "WAYNE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 11,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002630",
    "resolved_pwsid": "MI0002630",
    "system_name": "GIBRALTAR",
    "display_name": "GIBRALTAR",
    "county": "WAYNE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002630",
    "resolved_pwsid": "MI0002630",
    "system_name": "GIBRALTAR",
    "display_name": "GIBRALTAR",
    "county": "WAYNE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002630",
    "resolved_pwsid": "MI0002630",
    "system_name": "GIBRALTAR",
    "display_name": "GIBRALTAR",
    "county": "WAYNE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": 34,
    "inventory_lead": 23,
    "inventory_gpcl": 2,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 25,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0002640",
    "resolved_pwsid": "MI0002640",
    "system_name": "GLADSTONE",
    "display_name": "GLADSTONE",
    "county": "DELTA",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002640",
    "resolved_pwsid": "MI0002640",
    "system_name": "GLADSTONE",
    "display_name": "GLADSTONE",
    "county": "DELTA",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002640",
    "resolved_pwsid": "MI0002640",
    "system_name": "GLADSTONE",
    "display_name": "GLADSTONE",
    "county": "DELTA",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002640",
    "resolved_pwsid": "MI0002640",
    "system_name": "GLADSTONE",
    "display_name": "GLADSTONE",
    "county": "DELTA",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 11,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002640",
    "resolved_pwsid": "MI0002640",
    "system_name": "GLADSTONE",
    "display_name": "GLADSTONE",
    "county": "DELTA",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 7,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002640",
    "resolved_pwsid": "MI0002640",
    "system_name": "GLADSTONE",
    "display_name": "GLADSTONE",
    "county": "DELTA",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 11,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002640",
    "resolved_pwsid": "MI0002640",
    "system_name": "GLADSTONE",
    "display_name": "GLADSTONE",
    "county": "DELTA",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 20,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002640",
    "resolved_pwsid": "MI0002640",
    "system_name": "GLADSTONE",
    "display_name": "GLADSTONE",
    "county": "DELTA",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 3,
    "inventory_lead": 318,
    "inventory_gpcl": 15,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 333,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0002650",
    "resolved_pwsid": "MI0002650",
    "system_name": "GLADWIN, CITY OF",
    "display_name": "GLADWIN, CITY OF",
    "county": "GLADWIN",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002650",
    "resolved_pwsid": "MI0002650",
    "system_name": "GLADWIN, CITY OF",
    "display_name": "GLADWIN, CITY OF",
    "county": "GLADWIN",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002650",
    "resolved_pwsid": "MI0002650",
    "system_name": "GLADWIN, CITY OF",
    "display_name": "GLADWIN, CITY OF",
    "county": "GLADWIN",
    "monitoring_end_date": "2021-06-30",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002650",
    "resolved_pwsid": "MI0002650",
    "system_name": "GLADWIN, CITY OF",
    "display_name": "GLADWIN, CITY OF",
    "county": "GLADWIN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002650",
    "resolved_pwsid": "MI0002650",
    "system_name": "GLADWIN, CITY OF",
    "display_name": "GLADWIN, CITY OF",
    "county": "GLADWIN",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002650",
    "resolved_pwsid": "MI0002650",
    "system_name": "GLADWIN, CITY OF",
    "display_name": "GLADWIN, CITY OF",
    "county": "GLADWIN",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002650",
    "resolved_pwsid": "MI0002650",
    "system_name": "GLADWIN, CITY OF",
    "display_name": "GLADWIN, CITY OF",
    "county": "GLADWIN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002650",
    "resolved_pwsid": "MI0002650",
    "system_name": "GLADWIN, CITY OF",
    "display_name": "GLADWIN, CITY OF",
    "county": "GLADWIN",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 8,
    "total_to_identify_or_replace": 8,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0002654",
    "resolved_pwsid": "MI0002654",
    "system_name": "GLEN DEVON CONDOMINIUMS",
    "display_name": "GLEN DEVON CONDOMINIUMS",
    "county": "GENESEE",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002654",
    "resolved_pwsid": "MI0002654",
    "system_name": "GLEN DEVON CONDOMINIUMS",
    "display_name": "GLEN DEVON CONDOMINIUMS",
    "county": "GENESEE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002654",
    "resolved_pwsid": "MI0002654",
    "system_name": "GLEN DEVON CONDOMINIUMS",
    "display_name": "GLEN DEVON CONDOMINIUMS",
    "county": "GENESEE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002655",
    "resolved_pwsid": "MI0002655",
    "system_name": "GLENN HAVEN SHORES",
    "display_name": "GLENN HAVEN SHORES",
    "county": "ALLEGAN",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002655",
    "resolved_pwsid": "MI0002655",
    "system_name": "GLENN HAVEN SHORES",
    "display_name": "GLENN HAVEN SHORES",
    "county": "ALLEGAN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002655",
    "resolved_pwsid": "MI0002655",
    "system_name": "GLENN HAVEN SHORES",
    "display_name": "GLENN HAVEN SHORES",
    "county": "ALLEGAN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 9,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002656",
    "resolved_pwsid": "MI0002656",
    "system_name": "GLEN MEADOWS CONDOMINIUMS",
    "display_name": "GLEN MEADOWS CONDOMINIUMS",
    "county": "OTSEGO",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002656",
    "resolved_pwsid": "MI0002656",
    "system_name": "GLEN MEADOWS CONDOMINIUMS",
    "display_name": "GLEN MEADOWS CONDOMINIUMS",
    "county": "OTSEGO",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002656",
    "resolved_pwsid": "MI0002656",
    "system_name": "GLEN MEADOWS CONDOMINIUMS",
    "display_name": "GLEN MEADOWS CONDOMINIUMS",
    "county": "OTSEGO",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002656",
    "resolved_pwsid": "MI0002656",
    "system_name": "GLEN MEADOWS CONDOMINIUMS",
    "display_name": "GLEN MEADOWS CONDOMINIUMS",
    "county": "OTSEGO",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002657",
    "resolved_pwsid": "MI0002657-e",
    "system_name": "GLEN OAKS COMMUNITY COLLEGE DORM",
    "display_name": "GLEN OAKS COMMUNITY COLLEGE DORM",
    "county": "ST JOSEPH",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002657",
    "resolved_pwsid": "MI0002657-a",
    "system_name": "GLEN OAKS COMMUNITY COLLEGE",
    "display_name": "GLEN OAKS COMMUNITY COLLEGE",
    "county": "ST JOSEPH",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002657",
    "resolved_pwsid": "MI0002657-e",
    "system_name": "GLEN OAKS COMMUNITY COLLEGE DORM",
    "display_name": "GLEN OAKS COMMUNITY COLLEGE DORM",
    "county": "ST JOSEPH",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002657",
    "resolved_pwsid": "MI0002657-a",
    "system_name": "GLEN OAKS COMMUNITY COLLEGE",
    "display_name": "GLEN OAKS COMMUNITY COLLEGE",
    "county": "ST JOSEPH",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002657",
    "resolved_pwsid": "MI0002657-a",
    "system_name": "GLEN OAKS COMMUNITY COLLEGE",
    "display_name": "GLEN OAKS COMMUNITY COLLEGE",
    "county": "ST JOSEPH",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002657",
    "resolved_pwsid": "MI0002657-b",
    "system_name": "GLEN OAKS COMMUNITY COLLEGE (ADMIN/SCHOOL BLDG)",
    "display_name": "GLEN OAKS COMMUNITY COLLEGE (ADMIN/SCHOOL BLDG)",
    "county": "ST JOSEPH",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002657",
    "resolved_pwsid": "MI0002657-a",
    "system_name": "GLEN OAKS COMMUNITY COLLEGE",
    "display_name": "GLEN OAKS COMMUNITY COLLEGE",
    "county": "ST JOSEPH",
    "monitoring_end_date": "2021-06-30",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002657",
    "resolved_pwsid": "MI0002657-a",
    "system_name": "GLEN OAKS COMMUNITY COLLEGE",
    "display_name": "GLEN OAKS COMMUNITY COLLEGE",
    "county": "ST JOSEPH",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002657",
    "resolved_pwsid": "MI0002657-b",
    "system_name": "GLEN OAKS COMMUNITY COLLEGE (ADMIN/SCHOOL BLDG)",
    "display_name": "GLEN OAKS COMMUNITY COLLEGE (ADMIN/SCHOOL BLDG)",
    "county": "ST JOSEPH",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002657",
    "resolved_pwsid": "MI0002657-a",
    "system_name": "GLEN OAKS COMMUNITY COLLEGE",
    "display_name": "GLEN OAKS COMMUNITY COLLEGE",
    "county": "ST. JOSEPH",
    "monitoring_end_date": "2022-06-30",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002657",
    "resolved_pwsid": "MI0002657-d",
    "system_name": "GLEN OAKS COMMUNITY COLLEGE (DIST2)",
    "display_name": "GLEN OAKS COMMUNITY COLLEGE (DIST2)",
    "county": "ST. JOSEPH",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002657",
    "resolved_pwsid": "MI0002657-g",
    "system_name": "GLEN OAKS COMMUNITY COLLEGE (DS002)",
    "display_name": "GLEN OAKS COMMUNITY COLLEGE (DS002)",
    "county": "ST. JOSEPH",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002657",
    "resolved_pwsid": "MI0002657-c",
    "system_name": "GLEN OAKS COMMUNITY COLLEGE (DIST)",
    "display_name": "GLEN OAKS COMMUNITY COLLEGE (DIST)",
    "county": "ST. JOSEPH",
    "monitoring_end_date": "2026-12-31",
    "year": 2026,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002657",
    "resolved_pwsid": "MI0002657-f",
    "system_name": "GLEN OAKS COMMUNITY COLLEGE (DS001)",
    "display_name": "GLEN OAKS COMMUNITY COLLEGE (DS001)",
    "county": "ST. JOSEPH",
    "monitoring_end_date": "2026-12-31",
    "year": 2026,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002657",
    "resolved_pwsid": "MI0002657-f",
    "system_name": "GLEN OAKS COMMUNITY COLLEGE (DS001)",
    "display_name": "GLEN OAKS COMMUNITY COLLEGE (DS001)",
    "county": "ST. JOSEPH",
    "monitoring_end_date": "2024-09-30",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002659",
    "resolved_pwsid": "MI0002659",
    "system_name": "GLENNWOODS SUBDIVISION",
    "display_name": "GLENNWOODS SUBDIVISION",
    "county": "ALLEGAN",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002659",
    "resolved_pwsid": "MI0002659",
    "system_name": "GLENNWOODS SUBDIVISION",
    "display_name": "GLENNWOODS SUBDIVISION",
    "county": "ALLEGAN",
    "monitoring_end_date": "2019-09-30",
    "year": 2019,
    "lead_90th_ppb": 23,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002659",
    "resolved_pwsid": "MI0002659",
    "system_name": "GLENNWOODS SUBDIVISION",
    "display_name": "GLENNWOODS SUBDIVISION",
    "county": "ALLEGAN",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 23,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002659",
    "resolved_pwsid": "MI0002659",
    "system_name": "GLENNWOODS SUBDIVISION",
    "display_name": "GLENNWOODS SUBDIVISION",
    "county": "ALLEGAN",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002659",
    "resolved_pwsid": "MI0002659",
    "system_name": "GLENNWOODS SUBDIVISION",
    "display_name": "GLENNWOODS SUBDIVISION",
    "county": "ALLEGAN",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002659",
    "resolved_pwsid": "MI0002659",
    "system_name": "GLENNWOODS SUBDIVISION",
    "display_name": "GLENNWOODS SUBDIVISION",
    "county": "ALLEGAN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002659",
    "resolved_pwsid": "MI0002659",
    "system_name": "GLENNWOODS SUBDIVISION",
    "display_name": "GLENNWOODS SUBDIVISION",
    "county": "ALLEGAN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002680",
    "resolved_pwsid": "MI0002680",
    "system_name": "GOBLES",
    "display_name": "GOBLES",
    "county": "VAN BUREN",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002680",
    "resolved_pwsid": "MI0002680",
    "system_name": "GOBLES",
    "display_name": "GOBLES",
    "county": "VAN BUREN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 2,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002680",
    "resolved_pwsid": "MI0002680",
    "system_name": "GOBLES",
    "display_name": "GOBLES",
    "county": "VAN BUREN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002680",
    "resolved_pwsid": "MI0002680",
    "system_name": "GOBLES",
    "display_name": "GOBLES",
    "county": "VAN BUREN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002685",
    "resolved_pwsid": "MI0002685",
    "system_name": "GOGEBIC RANGE WATER AUTH",
    "display_name": "GOGEBIC RANGE WATER AUTH",
    "county": "GOGEBIC",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 10,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002685",
    "resolved_pwsid": "MI0002685",
    "system_name": "GOGEBIC RANGE WATER AUTH",
    "display_name": "GOGEBIC RANGE WATER AUTH",
    "county": "GOGEBIC",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002685",
    "resolved_pwsid": "MI0002685",
    "system_name": "GOGEBIC RANGE WATER AUTH",
    "display_name": "GOGEBIC RANGE WATER AUTH",
    "county": "GOGEBIC",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 12,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002685",
    "resolved_pwsid": "MI0002685",
    "system_name": "GOGEBIC RANGE WATER AUTH",
    "display_name": "GOGEBIC RANGE WATER AUTH",
    "county": "GOGEBIC",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002685",
    "resolved_pwsid": "MI0002685",
    "system_name": "GOGEBIC RANGE WATER AUTH",
    "display_name": "GOGEBIC RANGE WATER AUTH",
    "county": "GOGEBIC",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002685",
    "resolved_pwsid": "MI0002685",
    "system_name": "GOGEBIC RANGE WATER AUTH",
    "display_name": "GOGEBIC RANGE WATER AUTH",
    "county": "GOGEBIC",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0002730",
    "resolved_pwsid": "MI0002730",
    "system_name": "GRAND BEACH",
    "display_name": "GRAND BEACH",
    "county": "BERRIEN",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002730",
    "resolved_pwsid": "MI0002730",
    "system_name": "GRAND BEACH",
    "display_name": "GRAND BEACH",
    "county": "BERRIEN",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002730",
    "resolved_pwsid": "MI0002730",
    "system_name": "GRAND BEACH",
    "display_name": "GRAND BEACH",
    "county": "BERRIEN",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002730",
    "resolved_pwsid": "MI0002730",
    "system_name": "GRAND BEACH",
    "display_name": "GRAND BEACH",
    "county": "BERRIEN",
    "monitoring_end_date": "2021-06-30",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002730",
    "resolved_pwsid": "MI0002730",
    "system_name": "GRAND BEACH",
    "display_name": "GRAND BEACH",
    "county": "BERRIEN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002730",
    "resolved_pwsid": "MI0002730",
    "system_name": "GRAND BEACH",
    "display_name": "GRAND BEACH",
    "county": "BERRIEN",
    "monitoring_end_date": "2022-06-30",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002730",
    "resolved_pwsid": "MI0002730",
    "system_name": "GRAND BEACH",
    "display_name": "GRAND BEACH",
    "county": "BERRIEN",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002730",
    "resolved_pwsid": "MI0002730",
    "system_name": "GRAND BEACH",
    "display_name": "GRAND BEACH",
    "county": "BERRIEN",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002730",
    "resolved_pwsid": "MI0002730",
    "system_name": "GRAND BEACH",
    "display_name": "GRAND BEACH",
    "county": "BERRIEN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002730",
    "resolved_pwsid": "MI0002730",
    "system_name": "GRAND BEACH",
    "display_name": "GRAND BEACH",
    "county": "BERRIEN",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0002740",
    "resolved_pwsid": "MI0002740",
    "system_name": "GRAND BLANC, CITY OF",
    "display_name": "GRAND BLANC, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002740",
    "resolved_pwsid": "MI0002740",
    "system_name": "GRAND BLANC, CITY OF",
    "display_name": "GRAND BLANC, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002740",
    "resolved_pwsid": "MI0002740",
    "system_name": "GRAND BLANC, CITY OF",
    "display_name": "GRAND BLANC, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002740",
    "resolved_pwsid": "MI0002740",
    "system_name": "GRAND BLANC, CITY OF",
    "display_name": "GRAND BLANC, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0002745",
    "resolved_pwsid": "MI0002745",
    "system_name": "CHARTER TOWNSHIP OF GRAND BLANC",
    "display_name": "CHARTER TOWNSHIP OF GRAND BLANC",
    "county": "GENESEE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002745",
    "resolved_pwsid": "MI0002745",
    "system_name": "CHARTER TOWNSHIP OF GRAND BLANC",
    "display_name": "CHARTER TOWNSHIP OF GRAND BLANC",
    "county": "GENESEE",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002745",
    "resolved_pwsid": "MI0002745",
    "system_name": "CHARTER TOWNSHIP OF GRAND BLANC",
    "display_name": "CHARTER TOWNSHIP OF GRAND BLANC",
    "county": "GENESEE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002745",
    "resolved_pwsid": "MI0002745",
    "system_name": "CHARTER TOWNSHIP OF GRAND BLANC",
    "display_name": "CHARTER TOWNSHIP OF GRAND BLANC",
    "county": "GENESEE",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002745",
    "resolved_pwsid": "MI0002745",
    "system_name": "CHARTER TOWNSHIP OF GRAND BLANC",
    "display_name": "CHARTER TOWNSHIP OF GRAND BLANC",
    "county": "GENESEE",
    "monitoring_end_date": "2021-06-30",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002745",
    "resolved_pwsid": "MI0002745",
    "system_name": "CHARTER TOWNSHIP OF GRAND BLANC",
    "display_name": "CHARTER TOWNSHIP OF GRAND BLANC",
    "county": "GENESEE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002745",
    "resolved_pwsid": "MI0002745",
    "system_name": "CHARTER TOWNSHIP OF GRAND BLANC",
    "display_name": "CHARTER TOWNSHIP OF GRAND BLANC",
    "county": "GENESEE",
    "monitoring_end_date": "2022-06-30",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002745",
    "resolved_pwsid": "MI0002745",
    "system_name": "CHARTER TOWNSHIP OF GRAND BLANC",
    "display_name": "CHARTER TOWNSHIP OF GRAND BLANC",
    "county": "GENESEE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002745",
    "resolved_pwsid": "MI0002745",
    "system_name": "CHARTER TOWNSHIP OF GRAND BLANC",
    "display_name": "CHARTER TOWNSHIP OF GRAND BLANC",
    "county": "GENESEE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002745",
    "resolved_pwsid": "MI0002745",
    "system_name": "CHARTER TOWNSHIP OF GRAND BLANC",
    "display_name": "CHARTER TOWNSHIP OF GRAND BLANC",
    "county": "GENESEE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": 2216,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002750",
    "resolved_pwsid": "MI0002750",
    "system_name": "GRAND HAVEN",
    "display_name": "GRAND HAVEN",
    "county": "OTTAWA",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002750",
    "resolved_pwsid": "MI0002750",
    "system_name": "GRAND HAVEN",
    "display_name": "GRAND HAVEN",
    "county": "OTTAWA",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002750",
    "resolved_pwsid": "MI0002750",
    "system_name": "GRAND HAVEN",
    "display_name": "GRAND HAVEN",
    "county": "OTTAWA",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 26,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002750",
    "resolved_pwsid": "MI0002750",
    "system_name": "GRAND HAVEN",
    "display_name": "GRAND HAVEN",
    "county": "OTTAWA",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 48,
    "inventory_lead": 1223,
    "inventory_gpcl": 130,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 1353,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0002750",
    "resolved_pwsid": "MI0002750",
    "system_name": "GRAND HAVEN",
    "display_name": "GRAND HAVEN",
    "county": "OTTAWA",
    "monitoring_end_date": "",
    "year": 2021,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 10,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002750",
    "resolved_pwsid": "MI0002750",
    "system_name": "GRAND HAVEN",
    "display_name": "GRAND HAVEN",
    "county": "OTTAWA",
    "monitoring_end_date": "",
    "year": 2023,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 191,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002750",
    "resolved_pwsid": "MI0002750",
    "system_name": "GRAND HAVEN",
    "display_name": "GRAND HAVEN",
    "county": "OTTAWA",
    "monitoring_end_date": "",
    "year": 2024,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 12,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002760",
    "resolved_pwsid": "MI0002760",
    "system_name": "GRAND HAVEN TOWNSHIP",
    "display_name": "GRAND HAVEN TOWNSHIP",
    "county": "OTTAWA",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002760",
    "resolved_pwsid": "MI0002760",
    "system_name": "GRAND HAVEN TOWNSHIP",
    "display_name": "GRAND HAVEN TOWNSHIP",
    "county": "OTTAWA",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002760",
    "resolved_pwsid": "MI0002760",
    "system_name": "GRAND HAVEN TOWNSHIP",
    "display_name": "GRAND HAVEN TOWNSHIP",
    "county": "OTTAWA",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002760",
    "resolved_pwsid": "MI0002760",
    "system_name": "GRAND HAVEN TOWNSHIP",
    "display_name": "GRAND HAVEN TOWNSHIP",
    "county": "OTTAWA",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002760",
    "resolved_pwsid": "MI0002760",
    "system_name": "GRAND HAVEN TOWNSHIP",
    "display_name": "GRAND HAVEN TOWNSHIP",
    "county": "OTTAWA",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002760",
    "resolved_pwsid": "MI0002760",
    "system_name": "GRAND HAVEN TOWNSHIP",
    "display_name": "GRAND HAVEN TOWNSHIP",
    "county": "OTTAWA",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002760",
    "resolved_pwsid": "MI0002760",
    "system_name": "GRAND HAVEN TOWNSHIP",
    "display_name": "GRAND HAVEN TOWNSHIP",
    "county": "OTTAWA",
    "monitoring_end_date": "2024-06-30",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002760",
    "resolved_pwsid": "MI0002760",
    "system_name": "GRAND HAVEN TOWNSHIP",
    "display_name": "GRAND HAVEN TOWNSHIP",
    "county": "OTTAWA",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002760",
    "resolved_pwsid": "MI0002760",
    "system_name": "GRAND HAVEN TOWNSHIP",
    "display_name": "GRAND HAVEN TOWNSHIP",
    "county": "OTTAWA",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 1422,
    "inventory_gpcl": 116,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 1538,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0002770",
    "resolved_pwsid": "MI0002770",
    "system_name": "GRAND LEDGE, CITY OF",
    "display_name": "GRAND LEDGE, CITY OF",
    "county": "EATON",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002770",
    "resolved_pwsid": "MI0002770",
    "system_name": "GRAND LEDGE, CITY OF",
    "display_name": "GRAND LEDGE, CITY OF",
    "county": "EATON",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002770",
    "resolved_pwsid": "MI0002770",
    "system_name": "GRAND LEDGE, CITY OF",
    "display_name": "GRAND LEDGE, CITY OF",
    "county": "EATON",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002770",
    "resolved_pwsid": "MI0002770",
    "system_name": "GRAND LEDGE, CITY OF",
    "display_name": "GRAND LEDGE, CITY OF",
    "county": "EATON",
    "monitoring_end_date": "2021-06-30",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 7,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002770",
    "resolved_pwsid": "MI0002770",
    "system_name": "GRAND LEDGE, CITY OF",
    "display_name": "GRAND LEDGE, CITY OF",
    "county": "EATON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 10,
    "above_action_level": false,
    "lines_replaced": 16,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002770",
    "resolved_pwsid": "MI0002770",
    "system_name": "GRAND LEDGE, CITY OF",
    "display_name": "GRAND LEDGE, CITY OF",
    "county": "EATON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002770",
    "resolved_pwsid": "MI0002770",
    "system_name": "GRAND LEDGE, CITY OF",
    "display_name": "GRAND LEDGE, CITY OF",
    "county": "EATON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002770",
    "resolved_pwsid": "MI0002770",
    "system_name": "GRAND LEDGE, CITY OF",
    "display_name": "GRAND LEDGE, CITY OF",
    "county": "EATON",
    "monitoring_end_date": "",
    "year": 2024,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 11,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002770",
    "resolved_pwsid": "MI0002770",
    "system_name": "GRAND LEDGE, CITY OF",
    "display_name": "GRAND LEDGE, CITY OF",
    "county": "EATON",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 12,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002780",
    "resolved_pwsid": "MI0002780",
    "system_name": "BURT TOWNSHIP",
    "display_name": "BURT TOWNSHIP",
    "county": "ALGER",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002780",
    "resolved_pwsid": "MI0002780",
    "system_name": "BURT TOWNSHIP",
    "display_name": "BURT TOWNSHIP",
    "county": "ALGER",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002780",
    "resolved_pwsid": "MI0002780",
    "system_name": "BURT TOWNSHIP",
    "display_name": "BURT TOWNSHIP",
    "county": "ALGER",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002780",
    "resolved_pwsid": "MI0002780",
    "system_name": "BURT TOWNSHIP",
    "display_name": "BURT TOWNSHIP",
    "county": "ALGER",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0002785",
    "resolved_pwsid": "MI0002785",
    "system_name": "GRAND POINTE SUBDIVISION",
    "display_name": "GRAND POINTE SUBDIVISION",
    "county": "EATON",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002785",
    "resolved_pwsid": "MI0002785",
    "system_name": "GRAND POINTE SUBDIVISION",
    "display_name": "GRAND POINTE SUBDIVISION",
    "county": "EATON",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002785",
    "resolved_pwsid": "MI0002785",
    "system_name": "GRAND POINTE SUBDIVISION",
    "display_name": "GRAND POINTE SUBDIVISION",
    "county": "EATON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002785",
    "resolved_pwsid": "MI0002785",
    "system_name": "GRAND POINTE SUBDIVISION",
    "display_name": "GRAND POINTE SUBDIVISION",
    "county": "EATON",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 34,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0002785",
    "resolved_pwsid": "MI0002785",
    "system_name": "GRAND POINTE SUBDIVISION",
    "display_name": "GRAND POINTE SUBDIVISION",
    "county": "EATON",
    "monitoring_end_date": "2026-06-30",
    "year": 2026,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002790",
    "resolved_pwsid": "MI0002790",
    "system_name": "GRAND RAPIDS",
    "display_name": "GRAND RAPIDS",
    "county": "KENT",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002790",
    "resolved_pwsid": "MI0002790",
    "system_name": "GRAND RAPIDS",
    "display_name": "GRAND RAPIDS",
    "county": "KENT",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002790",
    "resolved_pwsid": "MI0002790",
    "system_name": "GRAND RAPIDS",
    "display_name": "GRAND RAPIDS",
    "county": "KENT",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 9,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002790",
    "resolved_pwsid": "MI0002790",
    "system_name": "GRAND RAPIDS",
    "display_name": "GRAND RAPIDS",
    "county": "KENT",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 10,
    "above_action_level": false,
    "lines_replaced": 640,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002790",
    "resolved_pwsid": "MI0002790",
    "system_name": "GRAND RAPIDS",
    "display_name": "GRAND RAPIDS",
    "county": "KENT",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 14,
    "above_action_level": true,
    "lines_replaced": 946,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002790",
    "resolved_pwsid": "MI0002790",
    "system_name": "GRAND RAPIDS",
    "display_name": "GRAND RAPIDS",
    "county": "KENT",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": 2478,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002790",
    "resolved_pwsid": "MI0002790",
    "system_name": "GRAND RAPIDS",
    "display_name": "GRAND RAPIDS",
    "county": "KENT",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": 1419,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002790",
    "resolved_pwsid": "MI0002790",
    "system_name": "GRAND RAPIDS",
    "display_name": "GRAND RAPIDS",
    "county": "KENT",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": 1667,
    "inventory_lead": 19430,
    "inventory_gpcl": 0,
    "inventory_unknown": 394,
    "total_to_identify_or_replace": 19824,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002805",
    "resolved_pwsid": "MI0002805",
    "system_name": "GRAND TRAVERSE CONDOMINIUMS",
    "display_name": "GRAND TRAVERSE CONDOMINIUMS",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 10,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002805",
    "resolved_pwsid": "MI0002805",
    "system_name": "GRAND TRAVERSE CONDOMINIUMS",
    "display_name": "GRAND TRAVERSE CONDOMINIUMS",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002805",
    "resolved_pwsid": "MI0002805",
    "system_name": "GRAND TRAVERSE CONDOMINIUMS",
    "display_name": "GRAND TRAVERSE CONDOMINIUMS",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002805",
    "resolved_pwsid": "MI0002805",
    "system_name": "GRAND TRAVERSE CONDOMINIUMS",
    "display_name": "GRAND TRAVERSE CONDOMINIUMS",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0002809",
    "resolved_pwsid": "MI0002809",
    "system_name": "GRAND VALLEY ESTATES",
    "display_name": "GRAND VALLEY ESTATES",
    "county": "KENT",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002809",
    "resolved_pwsid": "MI0002809",
    "system_name": "GRAND VALLEY ESTATES",
    "display_name": "GRAND VALLEY ESTATES",
    "county": "KENT",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002809",
    "resolved_pwsid": "MI0002809",
    "system_name": "GRAND VALLEY ESTATES",
    "display_name": "GRAND VALLEY ESTATES",
    "county": "KENT",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002809",
    "resolved_pwsid": "MI0002809",
    "system_name": "GRAND VALLEY ESTATES",
    "display_name": "GRAND VALLEY ESTATES",
    "county": "KENT",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0002820",
    "resolved_pwsid": "MI0002820",
    "system_name": "GRANDVILLE",
    "display_name": "GRANDVILLE",
    "county": "KENT",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002820",
    "resolved_pwsid": "MI0002820",
    "system_name": "GRANDVILLE",
    "display_name": "GRANDVILLE",
    "county": "KENT",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002820",
    "resolved_pwsid": "MI0002820",
    "system_name": "GRANDVILLE",
    "display_name": "GRANDVILLE",
    "county": "KENT",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002820",
    "resolved_pwsid": "MI0002820",
    "system_name": "GRANDVILLE",
    "display_name": "GRANDVILLE",
    "county": "KENT",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 33,
    "inventory_lead": 0,
    "inventory_gpcl": 100,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 100,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0002820",
    "resolved_pwsid": "MI0002820",
    "system_name": "GRANDVILLE",
    "display_name": "GRANDVILLE",
    "county": "KENT",
    "monitoring_end_date": "",
    "year": 2023,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 29,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002820",
    "resolved_pwsid": "MI0002820",
    "system_name": "GRANDVILLE",
    "display_name": "GRANDVILLE",
    "county": "KENT",
    "monitoring_end_date": "",
    "year": 2024,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 44,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002823",
    "resolved_pwsid": "MI0002823",
    "system_name": "GRANT",
    "display_name": "GRANT",
    "county": "NEWAYGO",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002823",
    "resolved_pwsid": "MI0002823",
    "system_name": "GRANT",
    "display_name": "GRANT",
    "county": "NEWAYGO",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002823",
    "resolved_pwsid": "MI0002823",
    "system_name": "GRANT",
    "display_name": "GRANT",
    "county": "NEWAYGO",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002823",
    "resolved_pwsid": "MI0002823",
    "system_name": "GRANT",
    "display_name": "GRANT",
    "county": "NEWAYGO",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0002830",
    "resolved_pwsid": "MI0002830",
    "system_name": "GRASS LAKE",
    "display_name": "GRASS LAKE",
    "county": "JACKSON",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002830",
    "resolved_pwsid": "MI0002830",
    "system_name": "GRASS LAKE",
    "display_name": "GRASS LAKE",
    "county": "JACKSON",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002830",
    "resolved_pwsid": "MI0002830",
    "system_name": "GRASS LAKE",
    "display_name": "GRASS LAKE",
    "county": "JACKSON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002830",
    "resolved_pwsid": "MI0002830",
    "system_name": "GRASS LAKE",
    "display_name": "GRASS LAKE",
    "county": "JACKSON",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002830",
    "resolved_pwsid": "MI0002830",
    "system_name": "GRASS LAKE",
    "display_name": "GRASS LAKE",
    "county": "JACKSON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 12,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002830",
    "resolved_pwsid": "MI0002830",
    "system_name": "GRASS LAKE",
    "display_name": "GRASS LAKE",
    "county": "JACKSON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 12,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002830",
    "resolved_pwsid": "MI0002830",
    "system_name": "GRASS LAKE",
    "display_name": "GRASS LAKE",
    "county": "JACKSON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 2,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002830",
    "resolved_pwsid": "MI0002830",
    "system_name": "GRASS LAKE",
    "display_name": "GRASS LAKE",
    "county": "JACKSON",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 242,
    "total_to_identify_or_replace": 242,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0002837",
    "resolved_pwsid": "MI0002837",
    "system_name": "GREENFIELD ESTATES",
    "display_name": "GREENFIELD ESTATES",
    "county": "ALLEGAN",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002837",
    "resolved_pwsid": "MI0002837",
    "system_name": "GREENFIELD ESTATES",
    "display_name": "GREENFIELD ESTATES",
    "county": "ALLEGAN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002837",
    "resolved_pwsid": "MI0002837",
    "system_name": "GREENFIELD ESTATES",
    "display_name": "GREENFIELD ESTATES",
    "county": "ALLEGAN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002839",
    "resolved_pwsid": "MI0002839",
    "system_name": "GREAT LAKES ADVENTIST ACADEMY",
    "display_name": "GREAT LAKES ADVENTIST ACADEMY",
    "county": "MONTCALM",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002839",
    "resolved_pwsid": "MI0002839",
    "system_name": "GREAT LAKES ADVENTIST ACADEMY",
    "display_name": "GREAT LAKES ADVENTIST ACADEMY",
    "county": "MONTCALM",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002839",
    "resolved_pwsid": "MI0002839",
    "system_name": "GREAT LAKES ADVENTIST ACADEMY",
    "display_name": "GREAT LAKES ADVENTIST ACADEMY",
    "county": "MONTCALM",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002840",
    "resolved_pwsid": "MI0002840",
    "system_name": "GRAYLING, CITY OF",
    "display_name": "GRAYLING, CITY OF",
    "county": "CRAWFORD",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002840",
    "resolved_pwsid": "MI0002840",
    "system_name": "GRAYLING, CITY OF",
    "display_name": "GRAYLING, CITY OF",
    "county": "CRAWFORD",
    "monitoring_end_date": "2021-06-30",
    "year": 2021,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002840",
    "resolved_pwsid": "MI0002840",
    "system_name": "GRAYLING, CITY OF",
    "display_name": "GRAYLING, CITY OF",
    "county": "CRAWFORD",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002840",
    "resolved_pwsid": "MI0002840",
    "system_name": "GRAYLING, CITY OF",
    "display_name": "GRAYLING, CITY OF",
    "county": "CRAWFORD",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002843",
    "resolved_pwsid": "MI0002843",
    "system_name": "GREEN LAKE TOWNSHIP",
    "display_name": "GREEN LAKE TOWNSHIP",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2023-06-30",
    "year": 2023,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002843",
    "resolved_pwsid": "MI0002843",
    "system_name": "GREEN LAKE TOWNSHIP",
    "display_name": "GREEN LAKE TOWNSHIP",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002843",
    "resolved_pwsid": "MI0002843",
    "system_name": "GREEN LAKE TOWNSHIP",
    "display_name": "GREEN LAKE TOWNSHIP",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002843",
    "resolved_pwsid": "MI0002843",
    "system_name": "GREEN LAKE TOWNSHIP",
    "display_name": "GREEN LAKE TOWNSHIP",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 9,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0002845",
    "resolved_pwsid": "MI0002845",
    "system_name": "GREGG APARTMENTS",
    "display_name": "GREGG APARTMENTS",
    "county": "KENT",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002845",
    "resolved_pwsid": "MI0002845",
    "system_name": "GREGG APARTMENTS",
    "display_name": "GREGG APARTMENTS",
    "county": "KENT",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002845",
    "resolved_pwsid": "MI0002845",
    "system_name": "GREGG APARTMENTS",
    "display_name": "GREGG APARTMENTS",
    "county": "KENT",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002845",
    "resolved_pwsid": "MI0002845",
    "system_name": "GREGG APARTMENTS",
    "display_name": "GREGG APARTMENTS",
    "county": "KENT",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0002846",
    "resolved_pwsid": "MI0002846",
    "system_name": "GREENFIELD POINTE SUBDIVISION",
    "display_name": "GREENFIELD POINTE SUBDIVISION",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002846",
    "resolved_pwsid": "MI0002846",
    "system_name": "GREENFIELD POINTE SUBDIVISION",
    "display_name": "GREENFIELD POINTE SUBDIVISION",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002846",
    "resolved_pwsid": "MI0002846",
    "system_name": "GREENFIELD POINTE SUBDIVISION",
    "display_name": "GREENFIELD POINTE SUBDIVISION",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002846",
    "resolved_pwsid": "MI0002846",
    "system_name": "GREENFIELD POINTE SUBDIVISION",
    "display_name": "GREENFIELD POINTE SUBDIVISION",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002846",
    "resolved_pwsid": "MI0002846",
    "system_name": "GREENFIELD POINTE SUBDIVISION",
    "display_name": "GREENFIELD POINTE SUBDIVISION",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002846",
    "resolved_pwsid": "MI0002846",
    "system_name": "GREENFIELD POINTE SUBDIVISION",
    "display_name": "GREENFIELD POINTE SUBDIVISION",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002846",
    "resolved_pwsid": "MI0002846",
    "system_name": "GREENFIELD POINTE SUBDIVISION",
    "display_name": "GREENFIELD POINTE SUBDIVISION",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002846",
    "resolved_pwsid": "MI0002846",
    "system_name": "GREENFIELD POINTE SUBDIVISION",
    "display_name": "GREENFIELD POINTE SUBDIVISION",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002846",
    "resolved_pwsid": "MI0002846",
    "system_name": "GREENFIELD POINTE SUBDIVISION",
    "display_name": "GREENFIELD POINTE SUBDIVISION",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002846",
    "resolved_pwsid": "MI0002846",
    "system_name": "GREENFIELD POINTE SUBDIVISION",
    "display_name": "GREENFIELD POINTE SUBDIVISION",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0002847",
    "resolved_pwsid": "MI0002847",
    "system_name": "GREENS LAKE APARTMENTS",
    "display_name": "GREENS LAKE APARTMENTS",
    "county": "OAKLAND",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002847",
    "resolved_pwsid": "MI0002847",
    "system_name": "GREENS LAKE APARTMENTS",
    "display_name": "GREENS LAKE APARTMENTS",
    "county": "OAKLAND",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002847",
    "resolved_pwsid": "MI0002847",
    "system_name": "GREENS LAKE APARTMENTS",
    "display_name": "GREENS LAKE APARTMENTS",
    "county": "OAKLAND",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002847",
    "resolved_pwsid": "MI0002847",
    "system_name": "GREENS LAKE APARTMENTS",
    "display_name": "GREENS LAKE APARTMENTS",
    "county": "OAKLAND",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0002850",
    "resolved_pwsid": "MI0002850",
    "system_name": "GREENVILLE",
    "display_name": "GREENVILLE",
    "county": "MONTCALM",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 12,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002850",
    "resolved_pwsid": "MI0002850",
    "system_name": "GREENVILLE",
    "display_name": "GREENVILLE",
    "county": "MONTCALM",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002850",
    "resolved_pwsid": "MI0002850",
    "system_name": "GREENVILLE",
    "display_name": "GREENVILLE",
    "county": "MONTCALM",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 9,
    "above_action_level": false,
    "lines_replaced": 40,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002850",
    "resolved_pwsid": "MI0002850",
    "system_name": "GREENVILLE",
    "display_name": "GREENVILLE",
    "county": "MONTCALM",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 9,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002850",
    "resolved_pwsid": "MI0002850",
    "system_name": "GREENVILLE",
    "display_name": "GREENVILLE",
    "county": "MONTCALM",
    "monitoring_end_date": "",
    "year": 2021,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 20,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002850",
    "resolved_pwsid": "MI0002850",
    "system_name": "GREENVILLE",
    "display_name": "GREENVILLE",
    "county": "MONTCALM",
    "monitoring_end_date": "",
    "year": 2024,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 7,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002850",
    "resolved_pwsid": "MI0002850",
    "system_name": "GREENVILLE",
    "display_name": "GREENVILLE",
    "county": "MONTCALM",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 20,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002851",
    "resolved_pwsid": "MI0002851",
    "system_name": "GREENVILLE ACRES",
    "display_name": "GREENVILLE ACRES",
    "county": "MONTCALM",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002851",
    "resolved_pwsid": "MI0002851",
    "system_name": "GREENVILLE ACRES",
    "display_name": "GREENVILLE ACRES",
    "county": "MONTCALM",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002860",
    "resolved_pwsid": "MI0002860",
    "system_name": "ELY TOWNSHIP-GREENWOOD",
    "display_name": "ELY TOWNSHIP-GREENWOOD",
    "county": "MARQUETTE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002860",
    "resolved_pwsid": "MI0002860",
    "system_name": "ELY TOWNSHIP-GREENWOOD",
    "display_name": "ELY TOWNSHIP-GREENWOOD",
    "county": "MARQUETTE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002860",
    "resolved_pwsid": "MI0002860",
    "system_name": "ELY TOWNSHIP-GREENWOOD",
    "display_name": "ELY TOWNSHIP-GREENWOOD",
    "county": "MARQUETTE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002860",
    "resolved_pwsid": "MI0002860",
    "system_name": "ELY TOWNSHIP-GREENWOOD",
    "display_name": "ELY TOWNSHIP-GREENWOOD",
    "county": "MARQUETTE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002870",
    "resolved_pwsid": "MI0002870",
    "system_name": "GROSSE ILE TOWNSHIP",
    "display_name": "GROSSE ILE TOWNSHIP",
    "county": "WAYNE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002870",
    "resolved_pwsid": "MI0002870",
    "system_name": "GROSSE ILE TOWNSHIP",
    "display_name": "GROSSE ILE TOWNSHIP",
    "county": "WAYNE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002870",
    "resolved_pwsid": "MI0002870",
    "system_name": "GROSSE ILE TOWNSHIP",
    "display_name": "GROSSE ILE TOWNSHIP",
    "county": "WAYNE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002870",
    "resolved_pwsid": "MI0002870",
    "system_name": "GROSSE ILE TOWNSHIP",
    "display_name": "GROSSE ILE TOWNSHIP",
    "county": "WAYNE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": 3,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002870",
    "resolved_pwsid": "MI0002870",
    "system_name": "GROSSE ILE TOWNSHIP",
    "display_name": "GROSSE ILE TOWNSHIP",
    "county": "WAYNE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": 2,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002870",
    "resolved_pwsid": "MI0002870",
    "system_name": "GROSSE ILE TOWNSHIP",
    "display_name": "GROSSE ILE TOWNSHIP",
    "county": "WAYNE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002870",
    "resolved_pwsid": "MI0002870",
    "system_name": "GROSSE ILE TOWNSHIP",
    "display_name": "GROSSE ILE TOWNSHIP",
    "county": "WAYNE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 10,
    "above_action_level": false,
    "lines_replaced": 2,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002870",
    "resolved_pwsid": "MI0002870",
    "system_name": "GROSSE ILE TOWNSHIP",
    "display_name": "GROSSE ILE TOWNSHIP",
    "county": "WAYNE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 19,
    "above_action_level": true,
    "lines_replaced": 11,
    "inventory_lead": 28,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 28,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0002870",
    "resolved_pwsid": "MI0002870",
    "system_name": "GROSSE ILE TOWNSHIP",
    "display_name": "GROSSE ILE TOWNSHIP",
    "county": "WAYNE",
    "monitoring_end_date": "2026-06-30",
    "year": 2026,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002880",
    "resolved_pwsid": "MI0002880",
    "system_name": "GROSSE POINTE, CITY OF",
    "display_name": "GROSSE POINTE, CITY OF",
    "county": "WAYNE",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002880",
    "resolved_pwsid": "MI0002880",
    "system_name": "GROSSE POINTE, CITY OF",
    "display_name": "GROSSE POINTE, CITY OF",
    "county": "WAYNE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002880",
    "resolved_pwsid": "MI0002880",
    "system_name": "GROSSE POINTE, CITY OF",
    "display_name": "GROSSE POINTE, CITY OF",
    "county": "WAYNE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002880",
    "resolved_pwsid": "MI0002880",
    "system_name": "GROSSE POINTE, CITY OF",
    "display_name": "GROSSE POINTE, CITY OF",
    "county": "WAYNE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 24,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002880",
    "resolved_pwsid": "MI0002880",
    "system_name": "GROSSE POINTE, CITY OF",
    "display_name": "GROSSE POINTE, CITY OF",
    "county": "WAYNE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002880",
    "resolved_pwsid": "MI0002880",
    "system_name": "GROSSE POINTE, CITY OF",
    "display_name": "GROSSE POINTE, CITY OF",
    "county": "WAYNE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": 35,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002880",
    "resolved_pwsid": "MI0002880",
    "system_name": "GROSSE POINTE, CITY OF",
    "display_name": "GROSSE POINTE, CITY OF",
    "county": "WAYNE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": 26,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002880",
    "resolved_pwsid": "MI0002880",
    "system_name": "GROSSE POINTE, CITY OF",
    "display_name": "GROSSE POINTE, CITY OF",
    "county": "WAYNE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 2,
    "inventory_lead": 113,
    "inventory_gpcl": 5,
    "inventory_unknown": 1199,
    "total_to_identify_or_replace": 1317,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0002890",
    "resolved_pwsid": "MI0002890",
    "system_name": "GROSSE POINTE FARMS",
    "display_name": "GROSSE POINTE FARMS",
    "county": "WAYNE",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002890",
    "resolved_pwsid": "MI0002890",
    "system_name": "GROSSE POINTE FARMS",
    "display_name": "GROSSE POINTE FARMS",
    "county": "WAYNE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002890",
    "resolved_pwsid": "MI0002890",
    "system_name": "GROSSE POINTE FARMS",
    "display_name": "GROSSE POINTE FARMS",
    "county": "WAYNE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002890",
    "resolved_pwsid": "MI0002890",
    "system_name": "GROSSE POINTE FARMS",
    "display_name": "GROSSE POINTE FARMS",
    "county": "WAYNE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": 14,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002890",
    "resolved_pwsid": "MI0002890",
    "system_name": "GROSSE POINTE FARMS",
    "display_name": "GROSSE POINTE FARMS",
    "county": "WAYNE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": 14,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002890",
    "resolved_pwsid": "MI0002890",
    "system_name": "GROSSE POINTE FARMS",
    "display_name": "GROSSE POINTE FARMS",
    "county": "WAYNE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": 14,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002890",
    "resolved_pwsid": "MI0002890",
    "system_name": "GROSSE POINTE FARMS",
    "display_name": "GROSSE POINTE FARMS",
    "county": "WAYNE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": 14,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002890",
    "resolved_pwsid": "MI0002890",
    "system_name": "GROSSE POINTE FARMS",
    "display_name": "GROSSE POINTE FARMS",
    "county": "WAYNE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": 27,
    "inventory_lead": 244,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 244,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0002900",
    "resolved_pwsid": "MI0002900",
    "system_name": "GROSSE POINTE PARK",
    "display_name": "GROSSE POINTE PARK",
    "county": "WAYNE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002900",
    "resolved_pwsid": "MI0002900",
    "system_name": "GROSSE POINTE PARK",
    "display_name": "GROSSE POINTE PARK",
    "county": "WAYNE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 9,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002900",
    "resolved_pwsid": "MI0002900",
    "system_name": "GROSSE POINTE PARK",
    "display_name": "GROSSE POINTE PARK",
    "county": "WAYNE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002900",
    "resolved_pwsid": "MI0002900",
    "system_name": "GROSSE POINTE PARK",
    "display_name": "GROSSE POINTE PARK",
    "county": "WAYNE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": 2,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002900",
    "resolved_pwsid": "MI0002900",
    "system_name": "GROSSE POINTE PARK",
    "display_name": "GROSSE POINTE PARK",
    "county": "WAYNE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": 6,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002900",
    "resolved_pwsid": "MI0002900",
    "system_name": "GROSSE POINTE PARK",
    "display_name": "GROSSE POINTE PARK",
    "county": "WAYNE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": 7,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002900",
    "resolved_pwsid": "MI0002900",
    "system_name": "GROSSE POINTE PARK",
    "display_name": "GROSSE POINTE PARK",
    "county": "WAYNE",
    "monitoring_end_date": "2024-06-30",
    "year": 2024,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": 81,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002900",
    "resolved_pwsid": "MI0002900",
    "system_name": "GROSSE POINTE PARK",
    "display_name": "GROSSE POINTE PARK",
    "county": "WAYNE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002900",
    "resolved_pwsid": "MI0002900",
    "system_name": "GROSSE POINTE PARK",
    "display_name": "GROSSE POINTE PARK",
    "county": "WAYNE",
    "monitoring_end_date": "2025-06-30",
    "year": 2025,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": 79,
    "inventory_lead": 1999,
    "inventory_gpcl": 1,
    "inventory_unknown": 13,
    "total_to_identify_or_replace": 2013,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0002910",
    "resolved_pwsid": "MI0002910",
    "system_name": "GROSSE POINTE SHORES",
    "display_name": "GROSSE POINTE SHORES",
    "county": "WAYNE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002910",
    "resolved_pwsid": "MI0002910",
    "system_name": "GROSSE POINTE SHORES",
    "display_name": "GROSSE POINTE SHORES",
    "county": "WAYNE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002910",
    "resolved_pwsid": "MI0002910",
    "system_name": "GROSSE POINTE SHORES",
    "display_name": "GROSSE POINTE SHORES",
    "county": "WAYNE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002910",
    "resolved_pwsid": "MI0002910",
    "system_name": "GROSSE POINTE SHORES",
    "display_name": "GROSSE POINTE SHORES",
    "county": "WAYNE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002910",
    "resolved_pwsid": "MI0002910",
    "system_name": "GROSSE POINTE SHORES",
    "display_name": "GROSSE POINTE SHORES",
    "county": "WAYNE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002910",
    "resolved_pwsid": "MI0002910",
    "system_name": "GROSSE POINTE SHORES",
    "display_name": "GROSSE POINTE SHORES",
    "county": "WAYNE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002910",
    "resolved_pwsid": "MI0002910",
    "system_name": "GROSSE POINTE SHORES",
    "display_name": "GROSSE POINTE SHORES",
    "county": "WAYNE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002910",
    "resolved_pwsid": "MI0002910",
    "system_name": "GROSSE POINTE SHORES",
    "display_name": "GROSSE POINTE SHORES",
    "county": "WAYNE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 6,
    "inventory_lead": 1,
    "inventory_gpcl": 0,
    "inventory_unknown": 689,
    "total_to_identify_or_replace": 690,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0002920",
    "resolved_pwsid": "MI0002920",
    "system_name": "GROSSE POINTE WOODS",
    "display_name": "GROSSE POINTE WOODS",
    "county": "WAYNE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002920",
    "resolved_pwsid": "MI0002920",
    "system_name": "GROSSE POINTE WOODS",
    "display_name": "GROSSE POINTE WOODS",
    "county": "WAYNE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002920",
    "resolved_pwsid": "MI0002920",
    "system_name": "GROSSE POINTE WOODS",
    "display_name": "GROSSE POINTE WOODS",
    "county": "WAYNE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 10,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002920",
    "resolved_pwsid": "MI0002920",
    "system_name": "GROSSE POINTE WOODS",
    "display_name": "GROSSE POINTE WOODS",
    "county": "WAYNE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 9,
    "above_action_level": false,
    "lines_replaced": 3,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002920",
    "resolved_pwsid": "MI0002920",
    "system_name": "GROSSE POINTE WOODS",
    "display_name": "GROSSE POINTE WOODS",
    "county": "WAYNE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 10,
    "above_action_level": false,
    "lines_replaced": 36,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002920",
    "resolved_pwsid": "MI0002920",
    "system_name": "GROSSE POINTE WOODS",
    "display_name": "GROSSE POINTE WOODS",
    "county": "WAYNE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 11,
    "above_action_level": false,
    "lines_replaced": 25,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002920",
    "resolved_pwsid": "MI0002920",
    "system_name": "GROSSE POINTE WOODS",
    "display_name": "GROSSE POINTE WOODS",
    "county": "WAYNE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 10,
    "above_action_level": false,
    "lines_replaced": 4,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002920",
    "resolved_pwsid": "MI0002920",
    "system_name": "GROSSE POINTE WOODS",
    "display_name": "GROSSE POINTE WOODS",
    "county": "WAYNE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 13,
    "above_action_level": true,
    "lines_replaced": 20,
    "inventory_lead": 69,
    "inventory_gpcl": 35,
    "inventory_unknown": 6448,
    "total_to_identify_or_replace": 6552,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0002920",
    "resolved_pwsid": "MI0002920",
    "system_name": "GROSSE POINTE WOODS",
    "display_name": "GROSSE POINTE WOODS",
    "county": "WAYNE",
    "monitoring_end_date": "2026-06-30",
    "year": 2026,
    "lead_90th_ppb": 11,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002925",
    "resolved_pwsid": "MI0002925",
    "system_name": "LAKE DOSTER",
    "display_name": "LAKE DOSTER",
    "county": "ALLEGAN",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002925",
    "resolved_pwsid": "MI0002925",
    "system_name": "LAKE DOSTER",
    "display_name": "LAKE DOSTER",
    "county": "ALLEGAN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002925",
    "resolved_pwsid": "MI0002925",
    "system_name": "LAKE DOSTER",
    "display_name": "LAKE DOSTER",
    "county": "ALLEGAN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002925",
    "resolved_pwsid": "MI0002925",
    "system_name": "LAKE DOSTER",
    "display_name": "LAKE DOSTER",
    "county": "ALLEGAN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002926",
    "resolved_pwsid": "MI0002926",
    "system_name": "GUN PLAIN TOWNSHIP",
    "display_name": "GUN PLAIN TOWNSHIP",
    "county": "ALLEGAN",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002926",
    "resolved_pwsid": "MI0002926",
    "system_name": "GUN PLAIN TOWNSHIP",
    "display_name": "GUN PLAIN TOWNSHIP",
    "county": "ALLEGAN",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002926",
    "resolved_pwsid": "MI0002926",
    "system_name": "GUN PLAIN TOWNSHIP",
    "display_name": "GUN PLAIN TOWNSHIP",
    "county": "ALLEGAN",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002926",
    "resolved_pwsid": "MI0002926",
    "system_name": "GUN PLAIN TOWNSHIP",
    "display_name": "GUN PLAIN TOWNSHIP",
    "county": "ALLEGAN",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002940",
    "resolved_pwsid": "MI0002940",
    "system_name": "STAMBAUGH TWP - HAGERMAN LAKE",
    "display_name": "STAMBAUGH TWP - HAGERMAN LAKE",
    "county": "IRON",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002940",
    "resolved_pwsid": "MI0002940",
    "system_name": "STAMBAUGH TWP - HAGERMAN LAKE",
    "display_name": "STAMBAUGH TWP - HAGERMAN LAKE",
    "county": "IRON",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002940",
    "resolved_pwsid": "MI0002940",
    "system_name": "STAMBAUGH TWP - HAGERMAN LAKE",
    "display_name": "STAMBAUGH TWP - HAGERMAN LAKE",
    "county": "IRON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 12,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002943",
    "resolved_pwsid": "MI0002943",
    "system_name": "HALE HOMESTEAD APARTMENTS",
    "display_name": "HALE HOMESTEAD APARTMENTS",
    "county": "IOSCO",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002943",
    "resolved_pwsid": "MI0002943",
    "system_name": "HALE HOMESTEAD APARTMENTS",
    "display_name": "HALE HOMESTEAD APARTMENTS",
    "county": "IOSCO",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002943",
    "resolved_pwsid": "MI0002943",
    "system_name": "HALE HOMESTEAD APARTMENTS",
    "display_name": "HALE HOMESTEAD APARTMENTS",
    "county": "IOSCO",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002943",
    "resolved_pwsid": "MI0002943",
    "system_name": "HALE HOMESTEAD APARTMENTS",
    "display_name": "HALE HOMESTEAD APARTMENTS",
    "county": "IOSCO",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002943",
    "resolved_pwsid": "MI0002943",
    "system_name": "HALE HOMESTEAD APARTMENTS",
    "display_name": "HALE HOMESTEAD APARTMENTS",
    "county": "IOSCO",
    "monitoring_end_date": "2024-09-30",
    "year": 2024,
    "lead_90th_ppb": 57,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002943",
    "resolved_pwsid": "MI0002943",
    "system_name": "HALE HOMESTEAD APARTMENTS",
    "display_name": "HALE HOMESTEAD APARTMENTS",
    "county": "IOSCO",
    "monitoring_end_date": "2025-06-30",
    "year": 2025,
    "lead_90th_ppb": 31,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002943",
    "resolved_pwsid": "MI0002943",
    "system_name": "HALE HOMESTEAD APARTMENTS",
    "display_name": "HALE HOMESTEAD APARTMENTS",
    "county": "IOSCO",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002943",
    "resolved_pwsid": "MI0002943",
    "system_name": "HALE HOMESTEAD APARTMENTS",
    "display_name": "HALE HOMESTEAD APARTMENTS",
    "county": "IOSCO",
    "monitoring_end_date": "2026-06-30",
    "year": 2026,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002944",
    "resolved_pwsid": "MI0002944",
    "system_name": "HAMLET VILLAGE CONDOMINIUMS ASSOCIATION",
    "display_name": "HAMLET VILLAGE CONDOMINIUMS ASSOCIATION",
    "county": "EMMET",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002944",
    "resolved_pwsid": "MI0002944",
    "system_name": "HAMLET VILLAGE CONDOMINIUMS ASSOCIATION",
    "display_name": "HAMLET VILLAGE CONDOMINIUMS ASSOCIATION",
    "county": "EMMET",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 9,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002944",
    "resolved_pwsid": "MI0002944",
    "system_name": "HAMLET VILLAGE CONDOMINIUMS ASSOCIATION",
    "display_name": "HAMLET VILLAGE CONDOMINIUMS ASSOCIATION",
    "county": "EMMET",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 9,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002944",
    "resolved_pwsid": "MI0002944",
    "system_name": "HAMLET VILLAGE CONDOMINIUMS ASSOCIATION",
    "display_name": "HAMLET VILLAGE CONDOMINIUMS ASSOCIATION",
    "county": "EMMET",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 30,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 45,
    "total_to_identify_or_replace": 45,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0002944",
    "resolved_pwsid": "MI0002944",
    "system_name": "HAMLET VILLAGE CONDOMINIUMS ASSOCIATION",
    "display_name": "HAMLET VILLAGE CONDOMINIUMS ASSOCIATION",
    "county": "EMMET",
    "monitoring_end_date": "2026-06-30",
    "year": 2026,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002945",
    "resolved_pwsid": "MI0002945",
    "system_name": "HAMLET WEST PROPERTY OWNERS ASSOC",
    "display_name": "HAMLET WEST PROPERTY OWNERS ASSOC",
    "county": "EMMET",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002945",
    "resolved_pwsid": "MI0002945",
    "system_name": "HAMLET WEST PROPERTY OWNERS ASSOC",
    "display_name": "HAMLET WEST PROPERTY OWNERS ASSOC",
    "county": "EMMET",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002945",
    "resolved_pwsid": "MI0002945",
    "system_name": "HAMLET WEST PROPERTY OWNERS ASSOC",
    "display_name": "HAMLET WEST PROPERTY OWNERS ASSOC",
    "county": "EMMET",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002945",
    "resolved_pwsid": "MI0002945",
    "system_name": "HAMLET WEST PROPERTY OWNERS ASSOC",
    "display_name": "HAMLET WEST PROPERTY OWNERS ASSOC",
    "county": "EMMET",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 76,
    "total_to_identify_or_replace": 76,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0002960",
    "resolved_pwsid": "MI0002960",
    "system_name": "HAMPTON TOWNSHIP",
    "display_name": "HAMPTON TOWNSHIP",
    "county": "BAY",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 21,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002960",
    "resolved_pwsid": "MI0002960",
    "system_name": "HAMPTON TOWNSHIP",
    "display_name": "HAMPTON TOWNSHIP",
    "county": "BAY",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 9,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002960",
    "resolved_pwsid": "MI0002960",
    "system_name": "HAMPTON TOWNSHIP",
    "display_name": "HAMPTON TOWNSHIP",
    "county": "BAY",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002960",
    "resolved_pwsid": "MI0002960",
    "system_name": "HAMPTON TOWNSHIP",
    "display_name": "HAMPTON TOWNSHIP",
    "county": "BAY",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002960",
    "resolved_pwsid": "MI0002960",
    "system_name": "HAMPTON TOWNSHIP",
    "display_name": "HAMPTON TOWNSHIP",
    "county": "BAY",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 6,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002960",
    "resolved_pwsid": "MI0002960",
    "system_name": "HAMPTON TOWNSHIP",
    "display_name": "HAMPTON TOWNSHIP",
    "county": "BAY",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": 7,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002960",
    "resolved_pwsid": "MI0002960",
    "system_name": "HAMPTON TOWNSHIP",
    "display_name": "HAMPTON TOWNSHIP",
    "county": "BAY",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002960",
    "resolved_pwsid": "MI0002960",
    "system_name": "HAMPTON TOWNSHIP",
    "display_name": "HAMPTON TOWNSHIP",
    "county": "BAY",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 48,
    "inventory_gpcl": 10,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 58,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0002970",
    "resolved_pwsid": "MI0002970",
    "system_name": "HAMTRAMCK",
    "display_name": "HAMTRAMCK",
    "county": "WAYNE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 28,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002970",
    "resolved_pwsid": "MI0002970",
    "system_name": "HAMTRAMCK",
    "display_name": "HAMTRAMCK",
    "county": "WAYNE",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 11,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002970",
    "resolved_pwsid": "MI0002970",
    "system_name": "HAMTRAMCK",
    "display_name": "HAMTRAMCK",
    "county": "WAYNE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 15,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002970",
    "resolved_pwsid": "MI0002970",
    "system_name": "HAMTRAMCK",
    "display_name": "HAMTRAMCK",
    "county": "WAYNE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 10,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002970",
    "resolved_pwsid": "MI0002970",
    "system_name": "HAMTRAMCK",
    "display_name": "HAMTRAMCK",
    "county": "WAYNE",
    "monitoring_end_date": "2021-09-30",
    "year": 2021,
    "lead_90th_ppb": 17,
    "above_action_level": true,
    "lines_replaced": 179,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002970",
    "resolved_pwsid": "MI0002970",
    "system_name": "HAMTRAMCK",
    "display_name": "HAMTRAMCK",
    "county": "WAYNE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 17,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002970",
    "resolved_pwsid": "MI0002970",
    "system_name": "HAMTRAMCK",
    "display_name": "HAMTRAMCK",
    "county": "WAYNE",
    "monitoring_end_date": "2022-06-30",
    "year": 2022,
    "lead_90th_ppb": 11,
    "above_action_level": false,
    "lines_replaced": 361,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002970",
    "resolved_pwsid": "MI0002970",
    "system_name": "HAMTRAMCK",
    "display_name": "HAMTRAMCK",
    "county": "WAYNE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 15,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002970",
    "resolved_pwsid": "MI0002970",
    "system_name": "HAMTRAMCK",
    "display_name": "HAMTRAMCK",
    "county": "WAYNE",
    "monitoring_end_date": "2023-06-30",
    "year": 2023,
    "lead_90th_ppb": 10,
    "above_action_level": false,
    "lines_replaced": 429,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002970",
    "resolved_pwsid": "MI0002970",
    "system_name": "HAMTRAMCK",
    "display_name": "HAMTRAMCK",
    "county": "WAYNE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 14,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002970",
    "resolved_pwsid": "MI0002970",
    "system_name": "HAMTRAMCK",
    "display_name": "HAMTRAMCK",
    "county": "WAYNE",
    "monitoring_end_date": "2024-06-30",
    "year": 2024,
    "lead_90th_ppb": 11,
    "above_action_level": false,
    "lines_replaced": 790,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002970",
    "resolved_pwsid": "MI0002970",
    "system_name": "HAMTRAMCK",
    "display_name": "HAMTRAMCK",
    "county": "WAYNE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 13,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002970",
    "resolved_pwsid": "MI0002970",
    "system_name": "HAMTRAMCK",
    "display_name": "HAMTRAMCK",
    "county": "WAYNE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 13,
    "above_action_level": true,
    "lines_replaced": 780,
    "inventory_lead": 793,
    "inventory_gpcl": 41,
    "inventory_unknown": 4551,
    "total_to_identify_or_replace": 5385,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0002970",
    "resolved_pwsid": "MI0002970",
    "system_name": "HAMTRAMCK",
    "display_name": "HAMTRAMCK",
    "county": "WAYNE",
    "monitoring_end_date": "2026-06-30",
    "year": 2026,
    "lead_90th_ppb": 12,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002980",
    "resolved_pwsid": "MI0002980",
    "system_name": "HANCOCK",
    "display_name": "HANCOCK",
    "county": "HOUGHTON",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002980",
    "resolved_pwsid": "MI0002980",
    "system_name": "HANCOCK",
    "display_name": "HANCOCK",
    "county": "HOUGHTON",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002980",
    "resolved_pwsid": "MI0002980",
    "system_name": "HANCOCK",
    "display_name": "HANCOCK",
    "county": "HOUGHTON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002980",
    "resolved_pwsid": "MI0002980",
    "system_name": "HANCOCK",
    "display_name": "HANCOCK",
    "county": "HOUGHTON",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 412,
    "total_to_identify_or_replace": 412,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0002982",
    "resolved_pwsid": "MI0002982",
    "system_name": "HANDY TOWNSHIP - RED CEDARS CROSSING",
    "display_name": "HANDY TOWNSHIP - RED CEDARS CROSSING",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002982",
    "resolved_pwsid": "MI0002982",
    "system_name": "HANDY TOWNSHIP - RED CEDARS CROSSING",
    "display_name": "HANDY TOWNSHIP - RED CEDARS CROSSING",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0002982",
    "resolved_pwsid": "MI0002982",
    "system_name": "HANDY TOWNSHIP - RED CEDARS CROSSING",
    "display_name": "HANDY TOWNSHIP - RED CEDARS CROSSING",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003000",
    "resolved_pwsid": "MI0003000",
    "system_name": "HARBOR BEACH, CITY OF",
    "display_name": "HARBOR BEACH, CITY OF",
    "county": "HURON",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003000",
    "resolved_pwsid": "MI0003000",
    "system_name": "HARBOR BEACH, CITY OF",
    "display_name": "HARBOR BEACH, CITY OF",
    "county": "HURON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003000",
    "resolved_pwsid": "MI0003000",
    "system_name": "HARBOR BEACH, CITY OF",
    "display_name": "HARBOR BEACH, CITY OF",
    "county": "HURON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 3,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003000",
    "resolved_pwsid": "MI0003000",
    "system_name": "HARBOR BEACH, CITY OF",
    "display_name": "HARBOR BEACH, CITY OF",
    "county": "HURON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003000",
    "resolved_pwsid": "MI0003000",
    "system_name": "HARBOR BEACH, CITY OF",
    "display_name": "HARBOR BEACH, CITY OF",
    "county": "HURON",
    "monitoring_end_date": "",
    "year": 2022,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 4,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003000",
    "resolved_pwsid": "MI0003000",
    "system_name": "HARBOR BEACH, CITY OF",
    "display_name": "HARBOR BEACH, CITY OF",
    "county": "HURON",
    "monitoring_end_date": "",
    "year": 2024,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 5,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003000",
    "resolved_pwsid": "MI0003000",
    "system_name": "HARBOR BEACH, CITY OF",
    "display_name": "HARBOR BEACH, CITY OF",
    "county": "HURON",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 15,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003001",
    "resolved_pwsid": "MI0003001",
    "system_name": "HARBOR COVE APARTMENTS",
    "display_name": "HARBOR COVE APARTMENTS",
    "county": "WASHTENAW",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003001",
    "resolved_pwsid": "MI0003001",
    "system_name": "HARBOR COVE APARTMENTS",
    "display_name": "HARBOR COVE APARTMENTS",
    "county": "WASHTENAW",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003001",
    "resolved_pwsid": "MI0003001",
    "system_name": "HARBOR COVE APARTMENTS",
    "display_name": "HARBOR COVE APARTMENTS",
    "county": "WASHTENAW",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003001",
    "resolved_pwsid": "MI0003001",
    "system_name": "HARBOR COVE APARTMENTS",
    "display_name": "HARBOR COVE APARTMENTS",
    "county": "WASHTENAW",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003005",
    "resolved_pwsid": "MI0003005",
    "system_name": "HARBOR HILLS SUBDIVISION ASSOCIATION",
    "display_name": "HARBOR HILLS SUBDIVISION ASSOCIATION",
    "county": "EMMET",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003005",
    "resolved_pwsid": "MI0003005",
    "system_name": "HARBOR HILLS SUBDIVISION ASSOCIATION",
    "display_name": "HARBOR HILLS SUBDIVISION ASSOCIATION",
    "county": "EMMET",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003005",
    "resolved_pwsid": "MI0003005",
    "system_name": "HARBOR HILLS SUBDIVISION ASSOCIATION",
    "display_name": "HARBOR HILLS SUBDIVISION ASSOCIATION",
    "county": "EMMET",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003010",
    "resolved_pwsid": "MI0003010",
    "system_name": "HARBOR SPRINGS, CITY OF",
    "display_name": "HARBOR SPRINGS, CITY OF",
    "county": "EMMET",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003010",
    "resolved_pwsid": "MI0003010",
    "system_name": "HARBOR SPRINGS, CITY OF",
    "display_name": "HARBOR SPRINGS, CITY OF",
    "county": "EMMET",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003010",
    "resolved_pwsid": "MI0003010",
    "system_name": "HARBOR SPRINGS, CITY OF",
    "display_name": "HARBOR SPRINGS, CITY OF",
    "county": "EMMET",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003015",
    "resolved_pwsid": "MI0003015",
    "system_name": "HARBOR SPRINGS AREA AUTHORITY",
    "display_name": "HARBOR SPRINGS AREA AUTHORITY",
    "county": "EMMET",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003015",
    "resolved_pwsid": "MI0003015",
    "system_name": "HARBOR SPRINGS AREA AUTHORITY",
    "display_name": "HARBOR SPRINGS AREA AUTHORITY",
    "county": "EMMET",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003015",
    "resolved_pwsid": "MI0003015",
    "system_name": "HARBOR SPRINGS AREA AUTHORITY",
    "display_name": "HARBOR SPRINGS AREA AUTHORITY",
    "county": "EMMET",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003018",
    "resolved_pwsid": "MI0003018",
    "system_name": "HARING CHARTER TOWNSHIP",
    "display_name": "HARING CHARTER TOWNSHIP",
    "county": "WEXFORD",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003018",
    "resolved_pwsid": "MI0003018",
    "system_name": "HARING CHARTER TOWNSHIP",
    "display_name": "HARING CHARTER TOWNSHIP",
    "county": "WEXFORD",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003018",
    "resolved_pwsid": "MI0003018",
    "system_name": "HARING CHARTER TOWNSHIP",
    "display_name": "HARING CHARTER TOWNSHIP",
    "county": "WEXFORD",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003018",
    "resolved_pwsid": "MI0003018",
    "system_name": "HARING CHARTER TOWNSHIP",
    "display_name": "HARING CHARTER TOWNSHIP",
    "county": "WEXFORD",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003018",
    "resolved_pwsid": "MI0003018",
    "system_name": "HARING CHARTER TOWNSHIP",
    "display_name": "HARING CHARTER TOWNSHIP",
    "county": "WEXFORD",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003020",
    "resolved_pwsid": "MI0003020",
    "system_name": "HARPER WOODS",
    "display_name": "HARPER WOODS",
    "county": "WAYNE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003020",
    "resolved_pwsid": "MI0003020",
    "system_name": "HARPER WOODS",
    "display_name": "HARPER WOODS",
    "county": "WAYNE",
    "monitoring_end_date": "2019-09-30",
    "year": 2019,
    "lead_90th_ppb": 20,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003020",
    "resolved_pwsid": "MI0003020",
    "system_name": "HARPER WOODS",
    "display_name": "HARPER WOODS",
    "county": "WAYNE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 20,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003020",
    "resolved_pwsid": "MI0003020",
    "system_name": "HARPER WOODS",
    "display_name": "HARPER WOODS",
    "county": "WAYNE",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 9,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003020",
    "resolved_pwsid": "MI0003020",
    "system_name": "HARPER WOODS",
    "display_name": "HARPER WOODS",
    "county": "WAYNE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 9,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003020",
    "resolved_pwsid": "MI0003020",
    "system_name": "HARPER WOODS",
    "display_name": "HARPER WOODS",
    "county": "WAYNE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 12,
    "above_action_level": false,
    "lines_replaced": 8,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003020",
    "resolved_pwsid": "MI0003020",
    "system_name": "HARPER WOODS",
    "display_name": "HARPER WOODS",
    "county": "WAYNE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 12,
    "above_action_level": false,
    "lines_replaced": 10,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003020",
    "resolved_pwsid": "MI0003020",
    "system_name": "HARPER WOODS",
    "display_name": "HARPER WOODS",
    "county": "WAYNE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 47,
    "above_action_level": true,
    "lines_replaced": 10,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003020",
    "resolved_pwsid": "MI0003020",
    "system_name": "HARPER WOODS",
    "display_name": "HARPER WOODS",
    "county": "WAYNE",
    "monitoring_end_date": "2024-06-30",
    "year": 2024,
    "lead_90th_ppb": 15,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003020",
    "resolved_pwsid": "MI0003020",
    "system_name": "HARPER WOODS",
    "display_name": "HARPER WOODS",
    "county": "WAYNE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 14,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003020",
    "resolved_pwsid": "MI0003020",
    "system_name": "HARPER WOODS",
    "display_name": "HARPER WOODS",
    "county": "WAYNE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": 92,
    "inventory_lead": 152,
    "inventory_gpcl": 720,
    "inventory_unknown": 1597,
    "total_to_identify_or_replace": 2469,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0003020",
    "resolved_pwsid": "MI0003020",
    "system_name": "HARPER WOODS",
    "display_name": "HARPER WOODS",
    "county": "WAYNE",
    "monitoring_end_date": "2026-06-30",
    "year": 2026,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003030",
    "resolved_pwsid": "MI0003030",
    "system_name": "HARRISON, CITY OF",
    "display_name": "HARRISON, CITY OF",
    "county": "CLARE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003030",
    "resolved_pwsid": "MI0003030",
    "system_name": "HARRISON, CITY OF",
    "display_name": "HARRISON, CITY OF",
    "county": "CLARE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003030",
    "resolved_pwsid": "MI0003030",
    "system_name": "HARRISON, CITY OF",
    "display_name": "HARRISON, CITY OF",
    "county": "CLARE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 5,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003030",
    "resolved_pwsid": "MI0003030",
    "system_name": "HARRISON, CITY OF",
    "display_name": "HARRISON, CITY OF",
    "county": "CLARE",
    "monitoring_end_date": "",
    "year": 2022,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 2,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003030",
    "resolved_pwsid": "MI0003030",
    "system_name": "HARRISON, CITY OF",
    "display_name": "HARRISON, CITY OF",
    "county": "CLARE",
    "monitoring_end_date": "",
    "year": 2023,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 17,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003040",
    "resolved_pwsid": "MI0003040",
    "system_name": "HARRISON TOWNSHIP",
    "display_name": "HARRISON TOWNSHIP",
    "county": "MACOMB",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003040",
    "resolved_pwsid": "MI0003040",
    "system_name": "HARRISON TOWNSHIP",
    "display_name": "HARRISON TOWNSHIP",
    "county": "MACOMB",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003040",
    "resolved_pwsid": "MI0003040",
    "system_name": "HARRISON TOWNSHIP",
    "display_name": "HARRISON TOWNSHIP",
    "county": "MACOMB",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003040",
    "resolved_pwsid": "MI0003040",
    "system_name": "HARRISON TOWNSHIP",
    "display_name": "HARRISON TOWNSHIP",
    "county": "MACOMB",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003040",
    "resolved_pwsid": "MI0003040",
    "system_name": "HARRISON TOWNSHIP",
    "display_name": "HARRISON TOWNSHIP",
    "county": "MACOMB",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003040",
    "resolved_pwsid": "MI0003040",
    "system_name": "HARRISON TOWNSHIP",
    "display_name": "HARRISON TOWNSHIP",
    "county": "MACOMB",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003040",
    "resolved_pwsid": "MI0003040",
    "system_name": "HARRISON TOWNSHIP",
    "display_name": "HARRISON TOWNSHIP",
    "county": "MACOMB",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003040",
    "resolved_pwsid": "MI0003040",
    "system_name": "HARRISON TOWNSHIP",
    "display_name": "HARRISON TOWNSHIP",
    "county": "MACOMB",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0003050",
    "resolved_pwsid": "MI0003050",
    "system_name": "HARRISVILLE, CITY OF",
    "display_name": "HARRISVILLE, CITY OF",
    "county": "ALCONA",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003050",
    "resolved_pwsid": "MI0003050",
    "system_name": "HARRISVILLE, CITY OF",
    "display_name": "HARRISVILLE, CITY OF",
    "county": "ALCONA",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003050",
    "resolved_pwsid": "MI0003050",
    "system_name": "HARRISVILLE, CITY OF",
    "display_name": "HARRISVILLE, CITY OF",
    "county": "ALCONA",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003060",
    "resolved_pwsid": "MI0003060",
    "system_name": "HART",
    "display_name": "HART",
    "county": "OCEANA",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003060",
    "resolved_pwsid": "MI0003060",
    "system_name": "HART",
    "display_name": "HART",
    "county": "OCEANA",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": 5,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003060",
    "resolved_pwsid": "MI0003060",
    "system_name": "HART",
    "display_name": "HART",
    "county": "OCEANA",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": 53,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003060",
    "resolved_pwsid": "MI0003060",
    "system_name": "HART",
    "display_name": "HART",
    "county": "OCEANA",
    "monitoring_end_date": "",
    "year": 2023,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 7,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003060",
    "resolved_pwsid": "MI0003060",
    "system_name": "HART",
    "display_name": "HART",
    "county": "OCEANA",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 2,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003070",
    "resolved_pwsid": "MI0003070",
    "system_name": "HARTFORD",
    "display_name": "HARTFORD",
    "county": "VAN BUREN",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003070",
    "resolved_pwsid": "MI0003070",
    "system_name": "HARTFORD",
    "display_name": "HARTFORD",
    "county": "VAN BUREN",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003070",
    "resolved_pwsid": "MI0003070",
    "system_name": "HARTFORD",
    "display_name": "HARTFORD",
    "county": "VAN BUREN",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003070",
    "resolved_pwsid": "MI0003070",
    "system_name": "HARTFORD",
    "display_name": "HARTFORD",
    "county": "VAN BUREN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003070",
    "resolved_pwsid": "MI0003070",
    "system_name": "HARTFORD",
    "display_name": "HARTFORD",
    "county": "VAN BUREN",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003070",
    "resolved_pwsid": "MI0003070",
    "system_name": "HARTFORD",
    "display_name": "HARTFORD",
    "county": "VAN BUREN",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 25,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003070",
    "resolved_pwsid": "MI0003070",
    "system_name": "HARTFORD",
    "display_name": "HARTFORD",
    "county": "VAN BUREN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003070",
    "resolved_pwsid": "MI0003070",
    "system_name": "HARTFORD",
    "display_name": "HARTFORD",
    "county": "VAN BUREN",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 14,
    "inventory_lead": 283,
    "inventory_gpcl": 340,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003073",
    "resolved_pwsid": "MI0003073",
    "system_name": "HARTLAND HILLS CONDOMINIUMS",
    "display_name": "HARTLAND HILLS CONDOMINIUMS",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003073",
    "resolved_pwsid": "MI0003073",
    "system_name": "HARTLAND HILLS CONDOMINIUMS",
    "display_name": "HARTLAND HILLS CONDOMINIUMS",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003073",
    "resolved_pwsid": "MI0003073",
    "system_name": "HARTLAND HILLS CONDOMINIUMS",
    "display_name": "HARTLAND HILLS CONDOMINIUMS",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003073",
    "resolved_pwsid": "MI0003073",
    "system_name": "HARTLAND HILLS CONDOMINIUMS",
    "display_name": "HARTLAND HILLS CONDOMINIUMS",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0003075",
    "resolved_pwsid": "MI0003075",
    "system_name": "HARTLAND TOWNSHIP",
    "display_name": "HARTLAND TOWNSHIP",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003075",
    "resolved_pwsid": "MI0003075",
    "system_name": "HARTLAND TOWNSHIP",
    "display_name": "HARTLAND TOWNSHIP",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003075",
    "resolved_pwsid": "MI0003075",
    "system_name": "HARTLAND TOWNSHIP",
    "display_name": "HARTLAND TOWNSHIP",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003075",
    "resolved_pwsid": "MI0003075",
    "system_name": "HARTLAND TOWNSHIP",
    "display_name": "HARTLAND TOWNSHIP",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003075",
    "resolved_pwsid": "MI0003075",
    "system_name": "HARTLAND TOWNSHIP",
    "display_name": "HARTLAND TOWNSHIP",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0003080",
    "resolved_pwsid": "MI0003080",
    "system_name": "HARVEST HILLS SUBDIVISION ASSO",
    "display_name": "HARVEST HILLS SUBDIVISION ASSO",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003080",
    "resolved_pwsid": "MI0003080",
    "system_name": "HARVEST HILLS SUBDIVISION ASSO",
    "display_name": "HARVEST HILLS SUBDIVISION ASSO",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003080",
    "resolved_pwsid": "MI0003080",
    "system_name": "HARVEST HILLS SUBDIVISION ASSO",
    "display_name": "HARVEST HILLS SUBDIVISION ASSO",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003090",
    "resolved_pwsid": "MI0003090",
    "system_name": "HASTINGS",
    "display_name": "HASTINGS",
    "county": "BARRY",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003090",
    "resolved_pwsid": "MI0003090",
    "system_name": "HASTINGS",
    "display_name": "HASTINGS",
    "county": "BARRY",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003090",
    "resolved_pwsid": "MI0003090",
    "system_name": "HASTINGS",
    "display_name": "HASTINGS",
    "county": "BARRY",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003090",
    "resolved_pwsid": "MI0003090",
    "system_name": "HASTINGS",
    "display_name": "HASTINGS",
    "county": "BARRY",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": 9,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003090",
    "resolved_pwsid": "MI0003090",
    "system_name": "HASTINGS",
    "display_name": "HASTINGS",
    "county": "BARRY",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": 7,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003090",
    "resolved_pwsid": "MI0003090",
    "system_name": "HASTINGS",
    "display_name": "HASTINGS",
    "county": "BARRY",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 10,
    "above_action_level": false,
    "lines_replaced": 34,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003090",
    "resolved_pwsid": "MI0003090",
    "system_name": "HASTINGS",
    "display_name": "HASTINGS",
    "county": "BARRY",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": 62,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003090",
    "resolved_pwsid": "MI0003090",
    "system_name": "HASTINGS",
    "display_name": "HASTINGS",
    "county": "BARRY",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": 92,
    "inventory_lead": 783,
    "inventory_gpcl": 767,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 1550,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0003100",
    "resolved_pwsid": "MI0003100",
    "system_name": "HAZEL PARK",
    "display_name": "HAZEL PARK",
    "county": "OAKLAND",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003100",
    "resolved_pwsid": "MI0003100",
    "system_name": "HAZEL PARK",
    "display_name": "HAZEL PARK",
    "county": "OAKLAND",
    "monitoring_end_date": "2019-09-30",
    "year": 2019,
    "lead_90th_ppb": 16,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003100",
    "resolved_pwsid": "MI0003100",
    "system_name": "HAZEL PARK",
    "display_name": "HAZEL PARK",
    "county": "OAKLAND",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 18,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003100",
    "resolved_pwsid": "MI0003100",
    "system_name": "HAZEL PARK",
    "display_name": "HAZEL PARK",
    "county": "OAKLAND",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 14,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003100",
    "resolved_pwsid": "MI0003100",
    "system_name": "HAZEL PARK",
    "display_name": "HAZEL PARK",
    "county": "OAKLAND",
    "monitoring_end_date": "2021-06-30",
    "year": 2021,
    "lead_90th_ppb": 13,
    "above_action_level": true,
    "lines_replaced": 32,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003100",
    "resolved_pwsid": "MI0003100",
    "system_name": "HAZEL PARK",
    "display_name": "HAZEL PARK",
    "county": "OAKLAND",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 13,
    "above_action_level": true,
    "lines_replaced": 29,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003100",
    "resolved_pwsid": "MI0003100",
    "system_name": "HAZEL PARK",
    "display_name": "HAZEL PARK",
    "county": "OAKLAND",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 10,
    "above_action_level": false,
    "lines_replaced": 31,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003100",
    "resolved_pwsid": "MI0003100",
    "system_name": "HAZEL PARK",
    "display_name": "HAZEL PARK",
    "county": "OAKLAND",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 9,
    "above_action_level": false,
    "lines_replaced": 80,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003100",
    "resolved_pwsid": "MI0003100",
    "system_name": "HAZEL PARK",
    "display_name": "HAZEL PARK",
    "county": "OAKLAND",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": 86,
    "inventory_lead": 568,
    "inventory_gpcl": 0,
    "inventory_unknown": 1718,
    "total_to_identify_or_replace": 2286,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0003110",
    "resolved_pwsid": "MI0003110",
    "system_name": "HEMLOCK/RICHLAND TOWNSHIP",
    "display_name": "HEMLOCK/RICHLAND TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003110",
    "resolved_pwsid": "MI0003110",
    "system_name": "HEMLOCK/RICHLAND TOWNSHIP",
    "display_name": "HEMLOCK/RICHLAND TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003110",
    "resolved_pwsid": "MI0003110",
    "system_name": "HEMLOCK/RICHLAND TOWNSHIP",
    "display_name": "HEMLOCK/RICHLAND TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003115",
    "resolved_pwsid": "MI0003115",
    "system_name": "HEMINGWAY POINTE CLUB OWNERS ASSOCIATION",
    "display_name": "HEMINGWAY POINTE CLUB OWNERS ASSOCIATION",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003115",
    "resolved_pwsid": "MI0003115",
    "system_name": "HEMINGWAY POINTE CLUB OWNERS ASSOCIATION",
    "display_name": "HEMINGWAY POINTE CLUB OWNERS ASSOCIATION",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003115",
    "resolved_pwsid": "MI0003115",
    "system_name": "HEMINGWAY POINTE CLUB OWNERS ASSOCIATION",
    "display_name": "HEMINGWAY POINTE CLUB OWNERS ASSOCIATION",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003115",
    "resolved_pwsid": "MI0003115",
    "system_name": "HEMINGWAY POINTE CLUB OWNERS ASSOCIATION",
    "display_name": "HEMINGWAY POINTE CLUB OWNERS ASSOCIATION",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003117",
    "resolved_pwsid": "MI0003117",
    "system_name": "HERITAGE APARTMENTS",
    "display_name": "HERITAGE APARTMENTS",
    "county": "OAKLAND",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003117",
    "resolved_pwsid": "MI0003117",
    "system_name": "HERITAGE APARTMENTS",
    "display_name": "HERITAGE APARTMENTS",
    "county": "OAKLAND",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003117",
    "resolved_pwsid": "MI0003117",
    "system_name": "HERITAGE APARTMENTS",
    "display_name": "HERITAGE APARTMENTS",
    "county": "OAKLAND",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003117",
    "resolved_pwsid": "MI0003117",
    "system_name": "HERITAGE APARTMENTS",
    "display_name": "HERITAGE APARTMENTS",
    "county": "OAKLAND",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003117",
    "resolved_pwsid": "MI0003117",
    "system_name": "HERITAGE APARTMENTS",
    "display_name": "HERITAGE APARTMENTS",
    "county": "OAKLAND",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 9,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003118",
    "resolved_pwsid": "MI0003118",
    "system_name": "HERITAGE DRIVE APARTMENTS",
    "display_name": "HERITAGE DRIVE APARTMENTS",
    "county": "MARQUETTE",
    "monitoring_end_date": "2022-06-30",
    "year": 2022,
    "lead_90th_ppb": 9,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003118",
    "resolved_pwsid": "MI0003118",
    "system_name": "HERITAGE DRIVE APARTMENTS",
    "display_name": "HERITAGE DRIVE APARTMENTS",
    "county": "MARQUETTE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003118",
    "resolved_pwsid": "MI0003118",
    "system_name": "HERITAGE DRIVE APARTMENTS",
    "display_name": "HERITAGE DRIVE APARTMENTS",
    "county": "MARQUETTE",
    "monitoring_end_date": "2023-06-30",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003118",
    "resolved_pwsid": "MI0003118",
    "system_name": "HERITAGE DRIVE APARTMENTS",
    "display_name": "HERITAGE DRIVE APARTMENTS",
    "county": "MARQUETTE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003118",
    "resolved_pwsid": "MI0003118",
    "system_name": "HERITAGE DRIVE APARTMENTS",
    "display_name": "HERITAGE DRIVE APARTMENTS",
    "county": "MARQUETTE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003118",
    "resolved_pwsid": "MI0003118",
    "system_name": "HERITAGE DRIVE APARTMENTS",
    "display_name": "HERITAGE DRIVE APARTMENTS",
    "county": "MARQUETTE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0003120",
    "resolved_pwsid": "MI0003120",
    "system_name": "HERMANSVILLE HOUSING COMM.",
    "display_name": "HERMANSVILLE HOUSING COMM.",
    "county": "MENOMINEE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 29,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003120",
    "resolved_pwsid": "MI0003120",
    "system_name": "HERMANSVILLE HOUSING COMM.",
    "display_name": "HERMANSVILLE HOUSING COMM.",
    "county": "MENOMINEE",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003120",
    "resolved_pwsid": "MI0003120",
    "system_name": "HERMANSVILLE HOUSING COMM.",
    "display_name": "HERMANSVILLE HOUSING COMM.",
    "county": "MENOMINEE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 30,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003120",
    "resolved_pwsid": "MI0003120",
    "system_name": "HERMANSVILLE HOUSING COMM.",
    "display_name": "HERMANSVILLE HOUSING COMM.",
    "county": "MENOMINEE",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003120",
    "resolved_pwsid": "MI0003120",
    "system_name": "HERMANSVILLE HOUSING COMM.",
    "display_name": "HERMANSVILLE HOUSING COMM.",
    "county": "MENOMINEE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 16,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003120",
    "resolved_pwsid": "MI0003120",
    "system_name": "HERMANSVILLE HOUSING COMM.",
    "display_name": "HERMANSVILLE HOUSING COMM.",
    "county": "MENOMINEE",
    "monitoring_end_date": "2021-06-30",
    "year": 2021,
    "lead_90th_ppb": 14,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003120",
    "resolved_pwsid": "MI0003120",
    "system_name": "HERMANSVILLE HOUSING COMM.",
    "display_name": "HERMANSVILLE HOUSING COMM.",
    "county": "MENOMINEE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 26,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003120",
    "resolved_pwsid": "MI0003120",
    "system_name": "HERMANSVILLE HOUSING COMM.",
    "display_name": "HERMANSVILLE HOUSING COMM.",
    "county": "MENOMINEE",
    "monitoring_end_date": "2022-06-30",
    "year": 2022,
    "lead_90th_ppb": 20,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003120",
    "resolved_pwsid": "MI0003120",
    "system_name": "HERMANSVILLE HOUSING COMM.",
    "display_name": "HERMANSVILLE HOUSING COMM.",
    "county": "MENOMINEE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 25,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003120",
    "resolved_pwsid": "MI0003120",
    "system_name": "HERMANSVILLE HOUSING COMM.",
    "display_name": "HERMANSVILLE HOUSING COMM.",
    "county": "MENOMINEE",
    "monitoring_end_date": "2023-06-30",
    "year": 2023,
    "lead_90th_ppb": 10,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003120",
    "resolved_pwsid": "MI0003120",
    "system_name": "HERMANSVILLE HOUSING COMM.",
    "display_name": "HERMANSVILLE HOUSING COMM.",
    "county": "MENOMINEE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 30,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003120",
    "resolved_pwsid": "MI0003120",
    "system_name": "HERMANSVILLE HOUSING COMM.",
    "display_name": "HERMANSVILLE HOUSING COMM.",
    "county": "MENOMINEE",
    "monitoring_end_date": "2024-06-30",
    "year": 2024,
    "lead_90th_ppb": 140,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003120",
    "resolved_pwsid": "MI0003120",
    "system_name": "HERMANSVILLE HOUSING COMM.",
    "display_name": "HERMANSVILLE HOUSING COMM.",
    "county": "MENOMINEE",
    "monitoring_end_date": "2025-06-30",
    "year": 2025,
    "lead_90th_ppb": 14,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0003120",
    "resolved_pwsid": "MI0003120",
    "system_name": "HERMANSVILLE HOUSING COMM.",
    "display_name": "HERMANSVILLE HOUSING COMM.",
    "county": "MENOMINEE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 79,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0003120",
    "resolved_pwsid": "MI0003120",
    "system_name": "HERMANSVILLE HOUSING COMM.",
    "display_name": "HERMANSVILLE HOUSING COMM.",
    "county": "MENOMINEE",
    "monitoring_end_date": "2026-06-30",
    "year": 2026,
    "lead_90th_ppb": 29,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003130",
    "resolved_pwsid": "MI0003130",
    "system_name": "HESPERIA",
    "display_name": "HESPERIA",
    "county": "NEWAYGO",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003130",
    "resolved_pwsid": "MI0003130",
    "system_name": "HESPERIA",
    "display_name": "HESPERIA",
    "county": "NEWAYGO",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003130",
    "resolved_pwsid": "MI0003130",
    "system_name": "HESPERIA",
    "display_name": "HESPERIA",
    "county": "NEWAYGO",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": 7,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003130",
    "resolved_pwsid": "MI0003130",
    "system_name": "HESPERIA",
    "display_name": "HESPERIA",
    "county": "NEWAYGO",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003130",
    "resolved_pwsid": "MI0003130",
    "system_name": "HESPERIA",
    "display_name": "HESPERIA",
    "county": "NEWAYGO",
    "monitoring_end_date": "2026-06-30",
    "year": 2026,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003130",
    "resolved_pwsid": "MI0003130",
    "system_name": "HESPERIA",
    "display_name": "HESPERIA",
    "county": "NEWAYGO",
    "monitoring_end_date": "",
    "year": 2021,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 3,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003130",
    "resolved_pwsid": "MI0003130",
    "system_name": "HESPERIA",
    "display_name": "HESPERIA",
    "county": "NEWAYGO",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 106,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003131",
    "resolved_pwsid": "MI0003131",
    "system_name": "HIDDEN GLEN APARTMENTS",
    "display_name": "HIDDEN GLEN APARTMENTS",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003131",
    "resolved_pwsid": "MI0003131",
    "system_name": "HIDDEN GLEN APARTMENTS",
    "display_name": "HIDDEN GLEN APARTMENTS",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003131",
    "resolved_pwsid": "MI0003131",
    "system_name": "HIDDEN GLEN APARTMENTS",
    "display_name": "HIDDEN GLEN APARTMENTS",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003131",
    "resolved_pwsid": "MI0003131",
    "system_name": "HIDDEN GLEN APARTMENTS",
    "display_name": "HIDDEN GLEN APARTMENTS",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003131",
    "resolved_pwsid": "MI0003131",
    "system_name": "HIDDEN GLEN APARTMENTS",
    "display_name": "HIDDEN GLEN APARTMENTS",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003131",
    "resolved_pwsid": "MI0003131",
    "system_name": "HIDDEN GLEN APARTMENTS",
    "display_name": "HIDDEN GLEN APARTMENTS",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003132",
    "resolved_pwsid": "MI0003132",
    "system_name": "HIDDEN HAMLET ASSOCIATION",
    "display_name": "HIDDEN HAMLET ASSOCIATION",
    "county": "EMMET",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003132",
    "resolved_pwsid": "MI0003132",
    "system_name": "HIDDEN HAMLET ASSOCIATION",
    "display_name": "HIDDEN HAMLET ASSOCIATION",
    "county": "EMMET",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003132",
    "resolved_pwsid": "MI0003132",
    "system_name": "HIDDEN HAMLET ASSOCIATION",
    "display_name": "HIDDEN HAMLET ASSOCIATION",
    "county": "EMMET",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003132",
    "resolved_pwsid": "MI0003132",
    "system_name": "HIDDEN HAMLET ASSOCIATION",
    "display_name": "HIDDEN HAMLET ASSOCIATION",
    "county": "EMMET",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 55,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003132",
    "resolved_pwsid": "MI0003132",
    "system_name": "HIDDEN HAMLET ASSOCIATION",
    "display_name": "HIDDEN HAMLET ASSOCIATION",
    "county": "EMMET",
    "monitoring_end_date": "2024-06-30",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003132",
    "resolved_pwsid": "MI0003132",
    "system_name": "HIDDEN HAMLET ASSOCIATION",
    "display_name": "HIDDEN HAMLET ASSOCIATION",
    "county": "EMMET",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003132",
    "resolved_pwsid": "MI0003132",
    "system_name": "HIDDEN HAMLET ASSOCIATION",
    "display_name": "HIDDEN HAMLET ASSOCIATION",
    "county": "EMMET",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003134",
    "resolved_pwsid": "MI0003134",
    "system_name": "HIGHFIELDS YOUTH CAMP",
    "display_name": "HIGHFIELDS YOUTH CAMP",
    "county": "INGHAM",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003134",
    "resolved_pwsid": "MI0003134",
    "system_name": "HIGHFIELDS YOUTH CAMP",
    "display_name": "HIGHFIELDS YOUTH CAMP",
    "county": "INGHAM",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003134",
    "resolved_pwsid": "MI0003134",
    "system_name": "HIGHFIELDS YOUTH CAMP",
    "display_name": "HIGHFIELDS YOUTH CAMP",
    "county": "INGHAM",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003137",
    "resolved_pwsid": "MI0003137",
    "system_name": "HIDDEN LAKES OF GREEN OAKS",
    "display_name": "HIDDEN LAKES OF GREEN OAKS",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003137",
    "resolved_pwsid": "MI0003137",
    "system_name": "HIDDEN LAKES OF GREEN OAKS",
    "display_name": "HIDDEN LAKES OF GREEN OAKS",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003137",
    "resolved_pwsid": "MI0003137",
    "system_name": "HIDDEN LAKES OF GREEN OAKS",
    "display_name": "HIDDEN LAKES OF GREEN OAKS",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003137",
    "resolved_pwsid": "MI0003137",
    "system_name": "HIDDEN LAKES OF GREEN OAKS",
    "display_name": "HIDDEN LAKES OF GREEN OAKS",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003138",
    "resolved_pwsid": "MI0003138",
    "system_name": "HIGHLAND HAVEN/WOODSIDE APTS",
    "display_name": "HIGHLAND HAVEN/WOODSIDE APTS",
    "county": "OAKLAND",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003138",
    "resolved_pwsid": "MI0003138",
    "system_name": "HIGHLAND HAVEN/WOODSIDE APTS",
    "display_name": "HIGHLAND HAVEN/WOODSIDE APTS",
    "county": "OAKLAND",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003138",
    "resolved_pwsid": "MI0003138",
    "system_name": "HIGHLAND HAVEN/WOODSIDE APTS",
    "display_name": "HIGHLAND HAVEN/WOODSIDE APTS",
    "county": "OAKLAND",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003138",
    "resolved_pwsid": "MI0003138",
    "system_name": "HIGHLAND HAVEN/WOODSIDE APTS",
    "display_name": "HIGHLAND HAVEN/WOODSIDE APTS",
    "county": "OAKLAND",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0003139",
    "resolved_pwsid": "MI0003139",
    "system_name": "HIGHLAND MEADOWVIEW APARTMENTS",
    "display_name": "HIGHLAND MEADOWVIEW APARTMENTS",
    "county": "OAKLAND",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003139",
    "resolved_pwsid": "MI0003139",
    "system_name": "HIGHLAND MEADOWVIEW APARTMENTS",
    "display_name": "HIGHLAND MEADOWVIEW APARTMENTS",
    "county": "OAKLAND",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003139",
    "resolved_pwsid": "MI0003139",
    "system_name": "HIGHLAND MEADOWVIEW APARTMENTS",
    "display_name": "HIGHLAND MEADOWVIEW APARTMENTS",
    "county": "OAKLAND",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003139",
    "resolved_pwsid": "MI0003139",
    "system_name": "HIGHLAND MEADOWVIEW APARTMENTS",
    "display_name": "HIGHLAND MEADOWVIEW APARTMENTS",
    "county": "OAKLAND",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0003140",
    "resolved_pwsid": "MI0003140",
    "system_name": "HIGHLAND PARK",
    "display_name": "HIGHLAND PARK",
    "county": "WAYNE",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003140",
    "resolved_pwsid": "MI0003140",
    "system_name": "HIGHLAND PARK",
    "display_name": "HIGHLAND PARK",
    "county": "WAYNE",
    "monitoring_end_date": "2019-09-30",
    "year": 2019,
    "lead_90th_ppb": 57,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003140",
    "resolved_pwsid": "MI0003140",
    "system_name": "HIGHLAND PARK",
    "display_name": "HIGHLAND PARK",
    "county": "WAYNE",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 10,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003140",
    "resolved_pwsid": "MI0003140",
    "system_name": "HIGHLAND PARK",
    "display_name": "HIGHLAND PARK",
    "county": "WAYNE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003140",
    "resolved_pwsid": "MI0003140",
    "system_name": "HIGHLAND PARK",
    "display_name": "HIGHLAND PARK",
    "county": "WAYNE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 9,
    "above_action_level": false,
    "lines_replaced": 59,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003140",
    "resolved_pwsid": "MI0003140",
    "system_name": "HIGHLAND PARK",
    "display_name": "HIGHLAND PARK",
    "county": "WAYNE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": 365,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003140",
    "resolved_pwsid": "MI0003140",
    "system_name": "HIGHLAND PARK",
    "display_name": "HIGHLAND PARK",
    "county": "WAYNE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": 12,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003140",
    "resolved_pwsid": "MI0003140",
    "system_name": "HIGHLAND PARK",
    "display_name": "HIGHLAND PARK",
    "county": "WAYNE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": 12,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003140",
    "resolved_pwsid": "MI0003140",
    "system_name": "HIGHLAND PARK",
    "display_name": "HIGHLAND PARK",
    "county": "WAYNE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 412,
    "inventory_lead": 2828,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 2828,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0003145",
    "resolved_pwsid": "MI0003145",
    "system_name": "LAKESHORE EAST CONDOMINIUMS",
    "display_name": "LAKESHORE EAST CONDOMINIUMS",
    "county": "ROSCOMMON",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003145",
    "resolved_pwsid": "MI0003145",
    "system_name": "LAKESHORE EAST CONDOMINIUMS",
    "display_name": "LAKESHORE EAST CONDOMINIUMS",
    "county": "ROSCOMMON",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003145",
    "resolved_pwsid": "MI0003145",
    "system_name": "LAKESHORE EAST CONDOMINIUMS",
    "display_name": "LAKESHORE EAST CONDOMINIUMS",
    "county": "ROSCOMMON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003145",
    "resolved_pwsid": "MI0003145",
    "system_name": "LAKESHORE EAST CONDOMINIUMS",
    "display_name": "LAKESHORE EAST CONDOMINIUMS",
    "county": "ROSCOMMON",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0003160",
    "resolved_pwsid": "MI0003160",
    "system_name": "HILLMAN, VILLAGE OF",
    "display_name": "HILLMAN, VILLAGE OF",
    "county": "MONTMORENCY",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 15,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003160",
    "resolved_pwsid": "MI0003160",
    "system_name": "HILLMAN, VILLAGE OF",
    "display_name": "HILLMAN, VILLAGE OF",
    "county": "MONTMORENCY",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 12,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003160",
    "resolved_pwsid": "MI0003160",
    "system_name": "HILLMAN, VILLAGE OF",
    "display_name": "HILLMAN, VILLAGE OF",
    "county": "MONTMORENCY",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003160",
    "resolved_pwsid": "MI0003160",
    "system_name": "HILLMAN, VILLAGE OF",
    "display_name": "HILLMAN, VILLAGE OF",
    "county": "MONTMORENCY",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003160",
    "resolved_pwsid": "MI0003160",
    "system_name": "HILLMAN, VILLAGE OF",
    "display_name": "HILLMAN, VILLAGE OF",
    "county": "MONTMORENCY",
    "monitoring_end_date": "2022-06-30",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003160",
    "resolved_pwsid": "MI0003160",
    "system_name": "HILLMAN, VILLAGE OF",
    "display_name": "HILLMAN, VILLAGE OF",
    "county": "MONTMORENCY",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003160",
    "resolved_pwsid": "MI0003160",
    "system_name": "HILLMAN, VILLAGE OF",
    "display_name": "HILLMAN, VILLAGE OF",
    "county": "MONTMORENCY",
    "monitoring_end_date": "2023-06-30",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003160",
    "resolved_pwsid": "MI0003160",
    "system_name": "HILLMAN, VILLAGE OF",
    "display_name": "HILLMAN, VILLAGE OF",
    "county": "MONTMORENCY",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003160",
    "resolved_pwsid": "MI0003160",
    "system_name": "HILLMAN, VILLAGE OF",
    "display_name": "HILLMAN, VILLAGE OF",
    "county": "MONTMORENCY",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0003165",
    "resolved_pwsid": "MI0003165",
    "system_name": "HILLS OF WALLOON ASSOCIATION",
    "display_name": "HILLS OF WALLOON ASSOCIATION",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 48,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003165",
    "resolved_pwsid": "MI0003165",
    "system_name": "HILLS OF WALLOON ASSOCIATION",
    "display_name": "HILLS OF WALLOON ASSOCIATION",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003165",
    "resolved_pwsid": "MI0003165",
    "system_name": "HILLS OF WALLOON ASSOCIATION",
    "display_name": "HILLS OF WALLOON ASSOCIATION",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003165",
    "resolved_pwsid": "MI0003165",
    "system_name": "HILLS OF WALLOON ASSOCIATION",
    "display_name": "HILLS OF WALLOON ASSOCIATION",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003165",
    "resolved_pwsid": "MI0003165",
    "system_name": "HILLS OF WALLOON ASSOCIATION",
    "display_name": "HILLS OF WALLOON ASSOCIATION",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 30,
    "total_to_identify_or_replace": 30,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0003170",
    "resolved_pwsid": "MI0003170",
    "system_name": "HILLSDALE",
    "display_name": "HILLSDALE",
    "county": "HILLSDALE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003170",
    "resolved_pwsid": "MI0003170",
    "system_name": "HILLSDALE",
    "display_name": "HILLSDALE",
    "county": "HILLSDALE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003170",
    "resolved_pwsid": "MI0003170",
    "system_name": "HILLSDALE",
    "display_name": "HILLSDALE",
    "county": "HILLSDALE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003170",
    "resolved_pwsid": "MI0003170",
    "system_name": "HILLSDALE",
    "display_name": "HILLSDALE",
    "county": "HILLSDALE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 49,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003170",
    "resolved_pwsid": "MI0003170",
    "system_name": "HILLSDALE",
    "display_name": "HILLSDALE",
    "county": "HILLSDALE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 21,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003170",
    "resolved_pwsid": "MI0003170",
    "system_name": "HILLSDALE",
    "display_name": "HILLSDALE",
    "county": "HILLSDALE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 127,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003170",
    "resolved_pwsid": "MI0003170",
    "system_name": "HILLSDALE",
    "display_name": "HILLSDALE",
    "county": "HILLSDALE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 88,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003170",
    "resolved_pwsid": "MI0003170",
    "system_name": "HILLSDALE",
    "display_name": "HILLSDALE",
    "county": "HILLSDALE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 91,
    "inventory_lead": 211,
    "inventory_gpcl": 694,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 905,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0003175",
    "resolved_pwsid": "MI0003175",
    "system_name": "HILLVIEW ESTATES SUBDIVISION",
    "display_name": "HILLVIEW ESTATES SUBDIVISION",
    "county": "OAKLAND",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003175",
    "resolved_pwsid": "MI0003175",
    "system_name": "HILLVIEW ESTATES SUBDIVISION",
    "display_name": "HILLVIEW ESTATES SUBDIVISION",
    "county": "OAKLAND",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003175",
    "resolved_pwsid": "MI0003175",
    "system_name": "HILLVIEW ESTATES SUBDIVISION",
    "display_name": "HILLVIEW ESTATES SUBDIVISION",
    "county": "OAKLAND",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003190",
    "resolved_pwsid": "MI0003190",
    "system_name": "HOLLAND BOARD OF PUBLIC WORKS",
    "display_name": "HOLLAND BOARD OF PUBLIC WORKS",
    "county": "OTTAWA",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003190",
    "resolved_pwsid": "MI0003190",
    "system_name": "HOLLAND BOARD OF PUBLIC WORKS",
    "display_name": "HOLLAND BOARD OF PUBLIC WORKS",
    "county": "OTTAWA",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003190",
    "resolved_pwsid": "MI0003190",
    "system_name": "HOLLAND BOARD OF PUBLIC WORKS",
    "display_name": "HOLLAND BOARD OF PUBLIC WORKS",
    "county": "OTTAWA",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 113,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003190",
    "resolved_pwsid": "MI0003190",
    "system_name": "HOLLAND BOARD OF PUBLIC WORKS",
    "display_name": "HOLLAND BOARD OF PUBLIC WORKS",
    "county": "OTTAWA",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003190",
    "resolved_pwsid": "MI0003190",
    "system_name": "HOLLAND BOARD OF PUBLIC WORKS",
    "display_name": "HOLLAND BOARD OF PUBLIC WORKS",
    "county": "OTTAWA",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 107,
    "inventory_lead": 1728,
    "inventory_gpcl": 1468,
    "inventory_unknown": 202,
    "total_to_identify_or_replace": 3398,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0003190",
    "resolved_pwsid": "MI0003190",
    "system_name": "HOLLAND BOARD OF PUBLIC WORKS",
    "display_name": "HOLLAND BOARD OF PUBLIC WORKS",
    "county": "OTTAWA",
    "monitoring_end_date": "",
    "year": 2021,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 71,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003190",
    "resolved_pwsid": "MI0003190",
    "system_name": "HOLLAND BOARD OF PUBLIC WORKS",
    "display_name": "HOLLAND BOARD OF PUBLIC WORKS",
    "county": "OTTAWA",
    "monitoring_end_date": "",
    "year": 2023,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 118,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003190",
    "resolved_pwsid": "MI0003190",
    "system_name": "HOLLAND BOARD OF PUBLIC WORKS",
    "display_name": "HOLLAND BOARD OF PUBLIC WORKS",
    "county": "OTTAWA",
    "monitoring_end_date": "",
    "year": 2024,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 86,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003195",
    "resolved_pwsid": "MI0003195",
    "system_name": "HOLLAND TOWNSHIP CONSOLIDATED",
    "display_name": "HOLLAND TOWNSHIP CONSOLIDATED",
    "county": "OTTAWA",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 13,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003195",
    "resolved_pwsid": "MI0003195",
    "system_name": "HOLLAND TOWNSHIP CONSOLIDATED",
    "display_name": "HOLLAND TOWNSHIP CONSOLIDATED",
    "county": "OTTAWA",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003195",
    "resolved_pwsid": "MI0003195",
    "system_name": "HOLLAND TOWNSHIP CONSOLIDATED",
    "display_name": "HOLLAND TOWNSHIP CONSOLIDATED",
    "county": "OTTAWA",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 2,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003195",
    "resolved_pwsid": "MI0003195",
    "system_name": "HOLLAND TOWNSHIP CONSOLIDATED",
    "display_name": "HOLLAND TOWNSHIP CONSOLIDATED",
    "county": "OTTAWA",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003195",
    "resolved_pwsid": "MI0003195",
    "system_name": "HOLLAND TOWNSHIP CONSOLIDATED",
    "display_name": "HOLLAND TOWNSHIP CONSOLIDATED",
    "county": "OTTAWA",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0003200",
    "resolved_pwsid": "MI0003200",
    "system_name": "HOLLY, VILLAGE OF",
    "display_name": "HOLLY, VILLAGE OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003200",
    "resolved_pwsid": "MI0003200",
    "system_name": "HOLLY, VILLAGE OF",
    "display_name": "HOLLY, VILLAGE OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003200",
    "resolved_pwsid": "MI0003200",
    "system_name": "HOLLY, VILLAGE OF",
    "display_name": "HOLLY, VILLAGE OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003200",
    "resolved_pwsid": "MI0003200",
    "system_name": "HOLLY, VILLAGE OF",
    "display_name": "HOLLY, VILLAGE OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003200",
    "resolved_pwsid": "MI0003200",
    "system_name": "HOLLY, VILLAGE OF",
    "display_name": "HOLLY, VILLAGE OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003215",
    "resolved_pwsid": "MI0003215",
    "system_name": "HOLTON COTTAGES",
    "display_name": "HOLTON COTTAGES",
    "county": "MUSKEGON",
    "monitoring_end_date": "2022-06-30",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003215",
    "resolved_pwsid": "MI0003215",
    "system_name": "HOLTON COTTAGES",
    "display_name": "HOLTON COTTAGES",
    "county": "MUSKEGON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003215",
    "resolved_pwsid": "MI0003215",
    "system_name": "HOLTON COTTAGES",
    "display_name": "HOLTON COTTAGES",
    "county": "MUSKEGON",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0003220",
    "resolved_pwsid": "MI0003220",
    "system_name": "HOMER",
    "display_name": "HOMER",
    "county": "CALHOUN",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003220",
    "resolved_pwsid": "MI0003220",
    "system_name": "HOMER",
    "display_name": "HOMER",
    "county": "CALHOUN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003220",
    "resolved_pwsid": "MI0003220",
    "system_name": "HOMER",
    "display_name": "HOMER",
    "county": "CALHOUN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003220",
    "resolved_pwsid": "MI0003220",
    "system_name": "HOMER",
    "display_name": "HOMER",
    "county": "CALHOUN",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003223",
    "resolved_pwsid": "MI0003223",
    "system_name": "HOMER TOWNSHIP",
    "display_name": "HOMER TOWNSHIP",
    "county": "MIDLAND",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003223",
    "resolved_pwsid": "MI0003223",
    "system_name": "HOMER TOWNSHIP",
    "display_name": "HOMER TOWNSHIP",
    "county": "MIDLAND",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003223",
    "resolved_pwsid": "MI0003223",
    "system_name": "HOMER TOWNSHIP",
    "display_name": "HOMER TOWNSHIP",
    "county": "MIDLAND",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003223",
    "resolved_pwsid": "MI0003223",
    "system_name": "HOMER TOWNSHIP",
    "display_name": "HOMER TOWNSHIP",
    "county": "MIDLAND",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003223",
    "resolved_pwsid": "MI0003223",
    "system_name": "HOMER TOWNSHIP",
    "display_name": "HOMER TOWNSHIP",
    "county": "MIDLAND",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003223",
    "resolved_pwsid": "MI0003223",
    "system_name": "HOMER TOWNSHIP",
    "display_name": "HOMER TOWNSHIP",
    "county": "MIDLAND",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003223",
    "resolved_pwsid": "MI0003223",
    "system_name": "HOMER TOWNSHIP",
    "display_name": "HOMER TOWNSHIP",
    "county": "MIDLAND",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003223",
    "resolved_pwsid": "MI0003223",
    "system_name": "HOMER TOWNSHIP",
    "display_name": "HOMER TOWNSHIP",
    "county": "MIDLAND",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003225",
    "resolved_pwsid": "MI0003225",
    "system_name": "HOMESTEAD PINES HOMEOWNERS' ASSOCIATION",
    "display_name": "HOMESTEAD PINES HOMEOWNERS' ASSOCIATION",
    "county": "EMMET",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003225",
    "resolved_pwsid": "MI0003225",
    "system_name": "HOMESTEAD PINES HOMEOWNERS' ASSOCIATION",
    "display_name": "HOMESTEAD PINES HOMEOWNERS' ASSOCIATION",
    "county": "EMMET",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003225",
    "resolved_pwsid": "MI0003225",
    "system_name": "HOMESTEAD PINES HOMEOWNERS' ASSOCIATION",
    "display_name": "HOMESTEAD PINES HOMEOWNERS' ASSOCIATION",
    "county": "EMMET",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003225",
    "resolved_pwsid": "MI0003225",
    "system_name": "HOMESTEAD PINES HOMEOWNERS' ASSOCIATION",
    "display_name": "HOMESTEAD PINES HOMEOWNERS' ASSOCIATION",
    "county": "EMMET",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0003228",
    "resolved_pwsid": "MI0003228",
    "system_name": "HOPE NETWORK - WEST LAKE- FACILITY",
    "display_name": "HOPE NETWORK - WEST LAKE- FACILITY",
    "county": "IONIA",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003228",
    "resolved_pwsid": "MI0003228",
    "system_name": "HOPE NETWORK - WEST LAKE- FACILITY",
    "display_name": "HOPE NETWORK - WEST LAKE- FACILITY",
    "county": "IONIA",
    "monitoring_end_date": "2019-09-30",
    "year": 2019,
    "lead_90th_ppb": 32,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003228",
    "resolved_pwsid": "MI0003228",
    "system_name": "HOPE NETWORK - WEST LAKE- FACILITY",
    "display_name": "HOPE NETWORK - WEST LAKE- FACILITY",
    "county": "IONIA",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 32,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003228",
    "resolved_pwsid": "MI0003228",
    "system_name": "HOPE NETWORK - WEST LAKE- FACILITY",
    "display_name": "HOPE NETWORK - WEST LAKE- FACILITY",
    "county": "IONIA",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003228",
    "resolved_pwsid": "MI0003228",
    "system_name": "HOPE NETWORK - WEST LAKE- FACILITY",
    "display_name": "HOPE NETWORK - WEST LAKE- FACILITY",
    "county": "IONIA",
    "monitoring_end_date": "2021-06-30",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003228",
    "resolved_pwsid": "MI0003228",
    "system_name": "HOPE NETWORK - WEST LAKE- FACILITY",
    "display_name": "HOPE NETWORK - WEST LAKE- FACILITY",
    "county": "IONIA",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003228",
    "resolved_pwsid": "MI0003228",
    "system_name": "HOPE NETWORK - WEST LAKE- FACILITY",
    "display_name": "HOPE NETWORK - WEST LAKE- FACILITY",
    "county": "IONIA",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003229",
    "resolved_pwsid": "MI0003229",
    "system_name": "HORTON BAY CLUB",
    "display_name": "HORTON BAY CLUB",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003229",
    "resolved_pwsid": "MI0003229",
    "system_name": "HORTON BAY CLUB",
    "display_name": "HORTON BAY CLUB",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003229",
    "resolved_pwsid": "MI0003229",
    "system_name": "HORTON BAY CLUB",
    "display_name": "HORTON BAY CLUB",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003229",
    "resolved_pwsid": "MI0003229",
    "system_name": "HORTON BAY CLUB",
    "display_name": "HORTON BAY CLUB",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003229",
    "resolved_pwsid": "MI0003229",
    "system_name": "HORTON BAY CLUB",
    "display_name": "HORTON BAY CLUB",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003230",
    "resolved_pwsid": "MI0003230",
    "system_name": "HOUGHTON",
    "display_name": "HOUGHTON",
    "county": "HOUGHTON",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003230",
    "resolved_pwsid": "MI0003230",
    "system_name": "HOUGHTON",
    "display_name": "HOUGHTON",
    "county": "HOUGHTON",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003230",
    "resolved_pwsid": "MI0003230",
    "system_name": "HOUGHTON",
    "display_name": "HOUGHTON",
    "county": "HOUGHTON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003230",
    "resolved_pwsid": "MI0003230",
    "system_name": "HOUGHTON",
    "display_name": "HOUGHTON",
    "county": "HOUGHTON",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003230",
    "resolved_pwsid": "MI0003230",
    "system_name": "HOUGHTON",
    "display_name": "HOUGHTON",
    "county": "HOUGHTON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003230",
    "resolved_pwsid": "MI0003230",
    "system_name": "HOUGHTON",
    "display_name": "HOUGHTON",
    "county": "HOUGHTON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 9,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003230",
    "resolved_pwsid": "MI0003230",
    "system_name": "HOUGHTON",
    "display_name": "HOUGHTON",
    "county": "HOUGHTON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003230",
    "resolved_pwsid": "MI0003230",
    "system_name": "HOUGHTON",
    "display_name": "HOUGHTON",
    "county": "HOUGHTON",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0003235",
    "resolved_pwsid": "MI0003235",
    "system_name": "HOUGHTON CO MEMORIAL AIRPORT",
    "display_name": "HOUGHTON CO MEMORIAL AIRPORT",
    "county": "HOUGHTON",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003235",
    "resolved_pwsid": "MI0003235",
    "system_name": "HOUGHTON CO MEMORIAL AIRPORT",
    "display_name": "HOUGHTON CO MEMORIAL AIRPORT",
    "county": "HOUGHTON",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 10,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003235",
    "resolved_pwsid": "MI0003235",
    "system_name": "HOUGHTON CO MEMORIAL AIRPORT",
    "display_name": "HOUGHTON CO MEMORIAL AIRPORT",
    "county": "HOUGHTON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003235",
    "resolved_pwsid": "MI0003235",
    "system_name": "HOUGHTON CO MEMORIAL AIRPORT",
    "display_name": "HOUGHTON CO MEMORIAL AIRPORT",
    "county": "HOUGHTON",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003235",
    "resolved_pwsid": "MI0003235",
    "system_name": "HOUGHTON CO MEMORIAL AIRPORT",
    "display_name": "HOUGHTON CO MEMORIAL AIRPORT",
    "county": "HOUGHTON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003235",
    "resolved_pwsid": "MI0003235",
    "system_name": "HOUGHTON CO MEMORIAL AIRPORT",
    "display_name": "HOUGHTON CO MEMORIAL AIRPORT",
    "county": "HOUGHTON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003235",
    "resolved_pwsid": "MI0003235",
    "system_name": "HOUGHTON CO MEMORIAL AIRPORT",
    "display_name": "HOUGHTON CO MEMORIAL AIRPORT",
    "county": "HOUGHTON",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0003237",
    "resolved_pwsid": "MI0003237",
    "system_name": "HOUGHTON HEIGHTS MANOR",
    "display_name": "HOUGHTON HEIGHTS MANOR",
    "county": "ROSCOMMON",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003237",
    "resolved_pwsid": "MI0003237",
    "system_name": "HOUGHTON HEIGHTS MANOR",
    "display_name": "HOUGHTON HEIGHTS MANOR",
    "county": "ROSCOMMON",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003237",
    "resolved_pwsid": "MI0003237",
    "system_name": "HOUGHTON HEIGHTS MANOR",
    "display_name": "HOUGHTON HEIGHTS MANOR",
    "county": "ROSCOMMON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003237",
    "resolved_pwsid": "MI0003237",
    "system_name": "HOUGHTON HEIGHTS MANOR",
    "display_name": "HOUGHTON HEIGHTS MANOR",
    "county": "ROSCOMMON",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0003238",
    "resolved_pwsid": "MI0003238",
    "system_name": "HOUGHTON LAKE TIMBER APTS.",
    "display_name": "HOUGHTON LAKE TIMBER APTS.",
    "county": "ROSCOMMON",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003238",
    "resolved_pwsid": "MI0003238",
    "system_name": "HOUGHTON LAKE TIMBER APTS.",
    "display_name": "HOUGHTON LAKE TIMBER APTS.",
    "county": "ROSCOMMON",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003238",
    "resolved_pwsid": "MI0003238",
    "system_name": "HOUGHTON LAKE TIMBER APTS.",
    "display_name": "HOUGHTON LAKE TIMBER APTS.",
    "county": "ROSCOMMON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003238",
    "resolved_pwsid": "MI0003238",
    "system_name": "HOUGHTON LAKE TIMBER APTS.",
    "display_name": "HOUGHTON LAKE TIMBER APTS.",
    "county": "ROSCOMMON",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0003240",
    "resolved_pwsid": "MI0003240",
    "system_name": "HOWARD CITY",
    "display_name": "HOWARD CITY",
    "county": "MONTCALM",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003240",
    "resolved_pwsid": "MI0003240",
    "system_name": "HOWARD CITY",
    "display_name": "HOWARD CITY",
    "county": "MONTCALM",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003240",
    "resolved_pwsid": "MI0003240",
    "system_name": "HOWARD CITY",
    "display_name": "HOWARD CITY",
    "county": "MONTCALM",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003250",
    "resolved_pwsid": "MI0003250",
    "system_name": "HOWELL, CITY OF",
    "display_name": "HOWELL, CITY OF",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003250",
    "resolved_pwsid": "MI0003250",
    "system_name": "HOWELL, CITY OF",
    "display_name": "HOWELL, CITY OF",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003250",
    "resolved_pwsid": "MI0003250",
    "system_name": "HOWELL, CITY OF",
    "display_name": "HOWELL, CITY OF",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 23,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003250",
    "resolved_pwsid": "MI0003250",
    "system_name": "HOWELL, CITY OF",
    "display_name": "HOWELL, CITY OF",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2022-06-30",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 6,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003250",
    "resolved_pwsid": "MI0003250",
    "system_name": "HOWELL, CITY OF",
    "display_name": "HOWELL, CITY OF",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003250",
    "resolved_pwsid": "MI0003250",
    "system_name": "HOWELL, CITY OF",
    "display_name": "HOWELL, CITY OF",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 4,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003250",
    "resolved_pwsid": "MI0003250",
    "system_name": "HOWELL, CITY OF",
    "display_name": "HOWELL, CITY OF",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 4,
    "inventory_lead": 7,
    "inventory_gpcl": 63,
    "inventory_unknown": 1485,
    "total_to_identify_or_replace": 1555,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0003270",
    "resolved_pwsid": "MI0003270",
    "system_name": "TORCH LAKE TOWNSHIP",
    "display_name": "TORCH LAKE TOWNSHIP",
    "county": "HOUGHTON",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003270",
    "resolved_pwsid": "MI0003270",
    "system_name": "TORCH LAKE TOWNSHIP",
    "display_name": "TORCH LAKE TOWNSHIP",
    "county": "HOUGHTON",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003270",
    "resolved_pwsid": "MI0003270",
    "system_name": "TORCH LAKE TOWNSHIP",
    "display_name": "TORCH LAKE TOWNSHIP",
    "county": "HOUGHTON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003270",
    "resolved_pwsid": "MI0003270",
    "system_name": "TORCH LAKE TOWNSHIP",
    "display_name": "TORCH LAKE TOWNSHIP",
    "county": "HOUGHTON",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": 0,
    "inventory_gpcl": 40,
    "inventory_unknown": 158,
    "total_to_identify_or_replace": 198,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0003270",
    "resolved_pwsid": "MI0003270",
    "system_name": "TORCH LAKE TOWNSHIP",
    "display_name": "TORCH LAKE TOWNSHIP",
    "county": "HOUGHTON",
    "monitoring_end_date": "",
    "year": 2024,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003280",
    "resolved_pwsid": "MI0003280",
    "system_name": "HUDSON",
    "display_name": "HUDSON",
    "county": "LENAWEE",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 11,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003280",
    "resolved_pwsid": "MI0003280",
    "system_name": "HUDSON",
    "display_name": "HUDSON",
    "county": "LENAWEE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003280",
    "resolved_pwsid": "MI0003280",
    "system_name": "HUDSON",
    "display_name": "HUDSON",
    "county": "LENAWEE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003280",
    "resolved_pwsid": "MI0003280",
    "system_name": "HUDSON",
    "display_name": "HUDSON",
    "county": "LENAWEE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003280",
    "resolved_pwsid": "MI0003280",
    "system_name": "HUDSON",
    "display_name": "HUDSON",
    "county": "LENAWEE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003280",
    "resolved_pwsid": "MI0003280",
    "system_name": "HUDSON",
    "display_name": "HUDSON",
    "county": "LENAWEE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 3,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003280",
    "resolved_pwsid": "MI0003280",
    "system_name": "HUDSON",
    "display_name": "HUDSON",
    "county": "LENAWEE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003280",
    "resolved_pwsid": "MI0003280",
    "system_name": "HUDSON",
    "display_name": "HUDSON",
    "county": "LENAWEE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": 3,
    "inventory_lead": 30,
    "inventory_gpcl": 25,
    "inventory_unknown": 760,
    "total_to_identify_or_replace": 815,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0003290",
    "resolved_pwsid": "MI0003290",
    "system_name": "HUDSONVILLE",
    "display_name": "HUDSONVILLE",
    "county": "OTTAWA",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003290",
    "resolved_pwsid": "MI0003290",
    "system_name": "HUDSONVILLE",
    "display_name": "HUDSONVILLE",
    "county": "OTTAWA",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003290",
    "resolved_pwsid": "MI0003290",
    "system_name": "HUDSONVILLE",
    "display_name": "HUDSONVILLE",
    "county": "OTTAWA",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003290",
    "resolved_pwsid": "MI0003290",
    "system_name": "HUDSONVILLE",
    "display_name": "HUDSONVILLE",
    "county": "OTTAWA",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003290",
    "resolved_pwsid": "MI0003290",
    "system_name": "HUDSONVILLE",
    "display_name": "HUDSONVILLE",
    "county": "OTTAWA",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0003310",
    "resolved_pwsid": "MI0003310",
    "system_name": "HUNTINGTON WOODS",
    "display_name": "HUNTINGTON WOODS",
    "county": "OAKLAND",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 9,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003310",
    "resolved_pwsid": "MI0003310",
    "system_name": "HUNTINGTON WOODS",
    "display_name": "HUNTINGTON WOODS",
    "county": "OAKLAND",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003310",
    "resolved_pwsid": "MI0003310",
    "system_name": "HUNTINGTON WOODS",
    "display_name": "HUNTINGTON WOODS",
    "county": "OAKLAND",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003310",
    "resolved_pwsid": "MI0003310",
    "system_name": "HUNTINGTON WOODS",
    "display_name": "HUNTINGTON WOODS",
    "county": "OAKLAND",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 27,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003310",
    "resolved_pwsid": "MI0003310",
    "system_name": "HUNTINGTON WOODS",
    "display_name": "HUNTINGTON WOODS",
    "county": "OAKLAND",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 4,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003310",
    "resolved_pwsid": "MI0003310",
    "system_name": "HUNTINGTON WOODS",
    "display_name": "HUNTINGTON WOODS",
    "county": "OAKLAND",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003310",
    "resolved_pwsid": "MI0003310",
    "system_name": "HUNTINGTON WOODS",
    "display_name": "HUNTINGTON WOODS",
    "county": "OAKLAND",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003310",
    "resolved_pwsid": "MI0003310",
    "system_name": "HUNTINGTON WOODS",
    "display_name": "HUNTINGTON WOODS",
    "county": "OAKLAND",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 3,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0003312",
    "resolved_pwsid": "MI0003312",
    "system_name": "HIGHLAND TOWNSHIP",
    "display_name": "HIGHLAND TOWNSHIP",
    "county": "OAKLAND",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003312",
    "resolved_pwsid": "MI0003312",
    "system_name": "HIGHLAND TOWNSHIP",
    "display_name": "HIGHLAND TOWNSHIP",
    "county": "OAKLAND",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003312",
    "resolved_pwsid": "MI0003312",
    "system_name": "HIGHLAND TOWNSHIP",
    "display_name": "HIGHLAND TOWNSHIP",
    "county": "OAKLAND",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003312",
    "resolved_pwsid": "MI0003312",
    "system_name": "HIGHLAND TOWNSHIP",
    "display_name": "HIGHLAND TOWNSHIP",
    "county": "OAKLAND",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003315",
    "resolved_pwsid": "MI0003315",
    "system_name": "HURON DUNES SUBDIVISION",
    "display_name": "HURON DUNES SUBDIVISION",
    "county": "HURON",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003315",
    "resolved_pwsid": "MI0003315",
    "system_name": "HURON DUNES SUBDIVISION",
    "display_name": "HURON DUNES SUBDIVISION",
    "county": "HURON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003315",
    "resolved_pwsid": "MI0003315",
    "system_name": "HURON DUNES SUBDIVISION",
    "display_name": "HURON DUNES SUBDIVISION",
    "county": "HURON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003320",
    "resolved_pwsid": "MI0003320",
    "system_name": "HURON TWP",
    "display_name": "HURON TWP",
    "county": "WAYNE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003320",
    "resolved_pwsid": "MI0003320",
    "system_name": "HURON TWP",
    "display_name": "HURON TWP",
    "county": "WAYNE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003320",
    "resolved_pwsid": "MI0003320",
    "system_name": "HURON TWP",
    "display_name": "HURON TWP",
    "county": "WAYNE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003320",
    "resolved_pwsid": "MI0003320",
    "system_name": "HURON TWP",
    "display_name": "HURON TWP",
    "county": "WAYNE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003320",
    "resolved_pwsid": "MI0003320",
    "system_name": "HURON TWP",
    "display_name": "HURON TWP",
    "county": "WAYNE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003320",
    "resolved_pwsid": "MI0003320",
    "system_name": "HURON TWP",
    "display_name": "HURON TWP",
    "county": "WAYNE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003320",
    "resolved_pwsid": "MI0003320",
    "system_name": "HURON TWP",
    "display_name": "HURON TWP",
    "county": "WAYNE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003320",
    "resolved_pwsid": "MI0003320",
    "system_name": "HURON TWP",
    "display_name": "HURON TWP",
    "county": "WAYNE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": 5053,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003323",
    "resolved_pwsid": "MI0003323",
    "system_name": "HURON TOWNSHIP",
    "display_name": "HURON TOWNSHIP",
    "county": "HURON",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003323",
    "resolved_pwsid": "MI0003323",
    "system_name": "HURON TOWNSHIP",
    "display_name": "HURON TOWNSHIP",
    "county": "HURON",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003323",
    "resolved_pwsid": "MI0003323",
    "system_name": "HURON TOWNSHIP",
    "display_name": "HURON TOWNSHIP",
    "county": "HURON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003323",
    "resolved_pwsid": "MI0003323-a",
    "system_name": "HURON TOWNSHIP (HURON COUNTY)",
    "display_name": "HURON TOWNSHIP",
    "county": "HURON",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0003330",
    "resolved_pwsid": "MI0003330-a",
    "system_name": "PORTAGE TOWNSHIP (ADAMS TOWNSHIP)",
    "display_name": "PORTAGE TOWNSHIP (ADAMS TOWNSHIP)",
    "county": "HOUGHTON",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003330",
    "resolved_pwsid": "MI0003330-e",
    "system_name": "PORTAGE TOWNSHIP (HOUGHTON)",
    "display_name": "PORTAGE TOWNSHIP (HOUGHTON)",
    "county": "HOUGHTON",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003330",
    "resolved_pwsid": "MI0003330-a",
    "system_name": "PORTAGE TOWNSHIP (ADAMS TOWNSHIP)",
    "display_name": "PORTAGE TOWNSHIP (ADAMS TOWNSHIP)",
    "county": "HOUGHTON",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003330",
    "resolved_pwsid": "MI0003330-b",
    "system_name": "PORTAGE TOWNSHIP (ADAMS TWP)",
    "display_name": "PORTAGE TOWNSHIP (ADAMS TWP)",
    "county": "HOUGHTON",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003330",
    "resolved_pwsid": "MI0003330-e",
    "system_name": "PORTAGE TOWNSHIP (HOUGHTON)",
    "display_name": "PORTAGE TOWNSHIP (HOUGHTON)",
    "county": "HOUGHTON",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003330",
    "resolved_pwsid": "MI0003330-b",
    "system_name": "PORTAGE TOWNSHIP (ADAMS TWP)",
    "display_name": "PORTAGE TOWNSHIP (ADAMS TWP)",
    "county": "HOUGHTON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003330",
    "resolved_pwsid": "MI0003330-e",
    "system_name": "PORTAGE TOWNSHIP (HOUGHTON)",
    "display_name": "PORTAGE TOWNSHIP (HOUGHTON)",
    "county": "HOUGHTON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003330",
    "resolved_pwsid": "MI0003330-b",
    "system_name": "PORTAGE TOWNSHIP (ADAMS TWP)",
    "display_name": "PORTAGE TOWNSHIP (ADAMS TWP)",
    "county": "HOUGHTON",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003330",
    "resolved_pwsid": "MI0003330-e",
    "system_name": "PORTAGE TOWNSHIP (HOUGHTON)",
    "display_name": "PORTAGE TOWNSHIP (HOUGHTON)",
    "county": "HOUGHTON",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003330",
    "resolved_pwsid": "MI0003330-e",
    "system_name": "PORTAGE TOWNSHIP (HOUGHTON)",
    "display_name": "PORTAGE TOWNSHIP (HOUGHTON)",
    "county": "HOUGHTON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003330",
    "resolved_pwsid": "MI0003330-b",
    "system_name": "PORTAGE TOWNSHIP (ADAMS TWP)",
    "display_name": "PORTAGE TOWNSHIP (ADAMS TWP)",
    "county": "HOUGHTON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003330",
    "resolved_pwsid": "MI0003330-e",
    "system_name": "PORTAGE TOWNSHIP (HOUGHTON)",
    "display_name": "PORTAGE TOWNSHIP (HOUGHTON)",
    "county": "HOUGHTON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003330",
    "resolved_pwsid": "MI0003330-c",
    "system_name": "PORTAGE TOWNSHIP (DIST)",
    "display_name": "PORTAGE TOWNSHIP (DIST)",
    "county": "HOUGHTON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003330",
    "resolved_pwsid": "MI0003330-d",
    "system_name": "PORTAGE TOWNSHIP (DIST2)",
    "display_name": "PORTAGE TOWNSHIP (DIST2)",
    "county": "HOUGHTON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003330",
    "resolved_pwsid": "MI0003330-f",
    "system_name": "PORTAGE TOWNSHIP (DS001)",
    "display_name": "PORTAGE TOWNSHIP (DS001)",
    "county": "HOUGHTON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003330",
    "resolved_pwsid": "MI0003330-g",
    "system_name": "PORTAGE TOWNSHIP (DS002)",
    "display_name": "PORTAGE TOWNSHIP (DS002)",
    "county": "HOUGHTON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003340",
    "resolved_pwsid": "MI0003340",
    "system_name": "IMLAY CITY, CITY OF",
    "display_name": "IMLAY CITY, CITY OF",
    "county": "LAPEER",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003340",
    "resolved_pwsid": "MI0003340",
    "system_name": "IMLAY CITY, CITY OF",
    "display_name": "IMLAY CITY, CITY OF",
    "county": "LAPEER",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003340",
    "resolved_pwsid": "MI0003340",
    "system_name": "IMLAY CITY, CITY OF",
    "display_name": "IMLAY CITY, CITY OF",
    "county": "LAPEER",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003340",
    "resolved_pwsid": "MI0003340",
    "system_name": "IMLAY CITY, CITY OF",
    "display_name": "IMLAY CITY, CITY OF",
    "county": "LAPEER",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 3,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003340",
    "resolved_pwsid": "MI0003340",
    "system_name": "IMLAY CITY, CITY OF",
    "display_name": "IMLAY CITY, CITY OF",
    "county": "LAPEER",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003340",
    "resolved_pwsid": "MI0003340",
    "system_name": "IMLAY CITY, CITY OF",
    "display_name": "IMLAY CITY, CITY OF",
    "county": "LAPEER",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003340",
    "resolved_pwsid": "MI0003340",
    "system_name": "IMLAY CITY, CITY OF",
    "display_name": "IMLAY CITY, CITY OF",
    "county": "LAPEER",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003340",
    "resolved_pwsid": "MI0003340",
    "system_name": "IMLAY CITY, CITY OF",
    "display_name": "IMLAY CITY, CITY OF",
    "county": "LAPEER",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": 12,
    "inventory_lead": 20,
    "inventory_gpcl": 11,
    "inventory_unknown": 185,
    "total_to_identify_or_replace": 216,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0003342",
    "resolved_pwsid": "MI0003342",
    "system_name": "INDEPENDENCE TOWNSHIP",
    "display_name": "INDEPENDENCE TOWNSHIP",
    "county": "OAKLAND",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003342",
    "resolved_pwsid": "MI0003342",
    "system_name": "INDEPENDENCE TOWNSHIP",
    "display_name": "INDEPENDENCE TOWNSHIP",
    "county": "OAKLAND",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003342",
    "resolved_pwsid": "MI0003342",
    "system_name": "INDEPENDENCE TOWNSHIP",
    "display_name": "INDEPENDENCE TOWNSHIP",
    "county": "OAKLAND",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003350",
    "resolved_pwsid": "MI0003350",
    "system_name": "STAMBAUGH TOWNSHIP-INDIAN LAKE",
    "display_name": "STAMBAUGH TOWNSHIP-INDIAN LAKE",
    "county": "IRON",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003350",
    "resolved_pwsid": "MI0003350",
    "system_name": "STAMBAUGH TOWNSHIP-INDIAN LAKE",
    "display_name": "STAMBAUGH TOWNSHIP-INDIAN LAKE",
    "county": "IRON",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003350",
    "resolved_pwsid": "MI0003350",
    "system_name": "STAMBAUGH TOWNSHIP-INDIAN LAKE",
    "display_name": "STAMBAUGH TOWNSHIP-INDIAN LAKE",
    "county": "IRON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003360",
    "resolved_pwsid": "MI0003360",
    "system_name": "INKSTER",
    "display_name": "INKSTER",
    "county": "WAYNE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003360",
    "resolved_pwsid": "MI0003360",
    "system_name": "INKSTER",
    "display_name": "INKSTER",
    "county": "WAYNE",
    "monitoring_end_date": "2019-09-30",
    "year": 2019,
    "lead_90th_ppb": 17,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003360",
    "resolved_pwsid": "MI0003360",
    "system_name": "INKSTER",
    "display_name": "INKSTER",
    "county": "WAYNE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 17,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003360",
    "resolved_pwsid": "MI0003360",
    "system_name": "INKSTER",
    "display_name": "INKSTER",
    "county": "WAYNE",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 11,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003360",
    "resolved_pwsid": "MI0003360",
    "system_name": "INKSTER",
    "display_name": "INKSTER",
    "county": "WAYNE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 18,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003360",
    "resolved_pwsid": "MI0003360",
    "system_name": "INKSTER",
    "display_name": "INKSTER",
    "county": "WAYNE",
    "monitoring_end_date": "2021-06-30",
    "year": 2021,
    "lead_90th_ppb": 9,
    "above_action_level": false,
    "lines_replaced": 67,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003360",
    "resolved_pwsid": "MI0003360",
    "system_name": "INKSTER",
    "display_name": "INKSTER",
    "county": "WAYNE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 12,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003360",
    "resolved_pwsid": "MI0003360",
    "system_name": "INKSTER",
    "display_name": "INKSTER",
    "county": "WAYNE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 77,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003360",
    "resolved_pwsid": "MI0003360",
    "system_name": "INKSTER",
    "display_name": "INKSTER",
    "county": "WAYNE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 114,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003360",
    "resolved_pwsid": "MI0003360",
    "system_name": "INKSTER",
    "display_name": "INKSTER",
    "county": "WAYNE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 13,
    "above_action_level": true,
    "lines_replaced": 88,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003360",
    "resolved_pwsid": "MI0003360",
    "system_name": "INKSTER",
    "display_name": "INKSTER",
    "county": "WAYNE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 18,
    "above_action_level": true,
    "lines_replaced": 149,
    "inventory_lead": 199,
    "inventory_gpcl": 77,
    "inventory_unknown": 1792,
    "total_to_identify_or_replace": 2068,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0003360",
    "resolved_pwsid": "MI0003360",
    "system_name": "INKSTER",
    "display_name": "INKSTER",
    "county": "WAYNE",
    "monitoring_end_date": "2026-06-30",
    "year": 2026,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003362",
    "resolved_pwsid": "MI0003362",
    "system_name": "INLAND HOUSE CONDOMINIUM ASSOCIATION",
    "display_name": "INLAND HOUSE CONDOMINIUM ASSOCIATION",
    "county": "EMMET",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003362",
    "resolved_pwsid": "MI0003362",
    "system_name": "INLAND HOUSE CONDOMINIUM ASSOCIATION",
    "display_name": "INLAND HOUSE CONDOMINIUM ASSOCIATION",
    "county": "EMMET",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 11,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003362",
    "resolved_pwsid": "MI0003362",
    "system_name": "INLAND HOUSE CONDOMINIUM ASSOCIATION",
    "display_name": "INLAND HOUSE CONDOMINIUM ASSOCIATION",
    "county": "EMMET",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003365",
    "resolved_pwsid": "MI0003365",
    "system_name": "INTERLOCHEN CENTER FOR THE ARTS",
    "display_name": "INTERLOCHEN CENTER FOR THE ARTS",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003365",
    "resolved_pwsid": "MI0003365",
    "system_name": "INTERLOCHEN CENTER FOR THE ARTS",
    "display_name": "INTERLOCHEN CENTER FOR THE ARTS",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003365",
    "resolved_pwsid": "MI0003365",
    "system_name": "INTERLOCHEN CENTER FOR THE ARTS",
    "display_name": "INTERLOCHEN CENTER FOR THE ARTS",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 11,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003370",
    "resolved_pwsid": "MI0003370",
    "system_name": "IONIA",
    "display_name": "IONIA",
    "county": "IONIA",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003370",
    "resolved_pwsid": "MI0003370",
    "system_name": "IONIA",
    "display_name": "IONIA",
    "county": "IONIA",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003370",
    "resolved_pwsid": "MI0003370",
    "system_name": "IONIA",
    "display_name": "IONIA",
    "county": "IONIA",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003370",
    "resolved_pwsid": "MI0003370",
    "system_name": "IONIA",
    "display_name": "IONIA",
    "county": "IONIA",
    "monitoring_end_date": "",
    "year": 2024,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 16,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003370",
    "resolved_pwsid": "MI0003370",
    "system_name": "IONIA",
    "display_name": "IONIA",
    "county": "IONIA",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 6,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003390",
    "resolved_pwsid": "MI0003390",
    "system_name": "IRA TOWNSHIP",
    "display_name": "IRA TOWNSHIP",
    "county": "ST CLAIR",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003390",
    "resolved_pwsid": "MI0003390",
    "system_name": "IRA TOWNSHIP",
    "display_name": "IRA TOWNSHIP",
    "county": "ST CLAIR",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003390",
    "resolved_pwsid": "MI0003390",
    "system_name": "IRA TOWNSHIP",
    "display_name": "IRA TOWNSHIP",
    "county": "ST. CLAIR",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003390",
    "resolved_pwsid": "MI0003390",
    "system_name": "IRA TOWNSHIP",
    "display_name": "IRA TOWNSHIP",
    "county": "ST. CLAIR",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003390",
    "resolved_pwsid": "MI0003390",
    "system_name": "IRA TOWNSHIP",
    "display_name": "IRA TOWNSHIP",
    "county": "ST CLAIR",
    "monitoring_end_date": "",
    "year": 2021,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 6,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003390",
    "resolved_pwsid": "MI0003390",
    "system_name": "IRA TOWNSHIP",
    "display_name": "IRA TOWNSHIP",
    "county": "ST CLAIR",
    "monitoring_end_date": "",
    "year": 2022,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 4,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003390",
    "resolved_pwsid": "MI0003390",
    "system_name": "IRA TOWNSHIP",
    "display_name": "IRA TOWNSHIP",
    "county": "ST CLAIR",
    "monitoring_end_date": "",
    "year": 2024,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003390",
    "resolved_pwsid": "MI0003390",
    "system_name": "IRA TOWNSHIP",
    "display_name": "IRA TOWNSHIP",
    "county": "ST CLAIR",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 2,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003400",
    "resolved_pwsid": "MI0003400",
    "system_name": "IRON MOUNTAIN",
    "display_name": "IRON MOUNTAIN",
    "county": "DICKINSON",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003400",
    "resolved_pwsid": "MI0003400",
    "system_name": "IRON MOUNTAIN",
    "display_name": "IRON MOUNTAIN",
    "county": "DICKINSON",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003400",
    "resolved_pwsid": "MI0003400",
    "system_name": "IRON MOUNTAIN",
    "display_name": "IRON MOUNTAIN",
    "county": "DICKINSON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 9,
    "above_action_level": false,
    "lines_replaced": 10,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003400",
    "resolved_pwsid": "MI0003400",
    "system_name": "IRON MOUNTAIN",
    "display_name": "IRON MOUNTAIN",
    "county": "DICKINSON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 9,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003400",
    "resolved_pwsid": "MI0003400",
    "system_name": "IRON MOUNTAIN",
    "display_name": "IRON MOUNTAIN",
    "county": "DICKINSON",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": 195,
    "inventory_lead": 923,
    "inventory_gpcl": 307,
    "inventory_unknown": 31,
    "total_to_identify_or_replace": 1261,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0003400",
    "resolved_pwsid": "MI0003400",
    "system_name": "IRON MOUNTAIN",
    "display_name": "IRON MOUNTAIN",
    "county": "DICKINSON",
    "monitoring_end_date": "",
    "year": 2021,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 53,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003400",
    "resolved_pwsid": "MI0003400",
    "system_name": "IRON MOUNTAIN",
    "display_name": "IRON MOUNTAIN",
    "county": "DICKINSON",
    "monitoring_end_date": "",
    "year": 2023,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 17,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003400",
    "resolved_pwsid": "MI0003400",
    "system_name": "IRON MOUNTAIN",
    "display_name": "IRON MOUNTAIN",
    "county": "DICKINSON",
    "monitoring_end_date": "",
    "year": 2024,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 46,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003410",
    "resolved_pwsid": "MI0003410",
    "system_name": "IRON RIVER",
    "display_name": "IRON RIVER",
    "county": "IRON",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003410",
    "resolved_pwsid": "MI0003410",
    "system_name": "IRON RIVER",
    "display_name": "IRON RIVER",
    "county": "IRON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003410",
    "resolved_pwsid": "MI0003410",
    "system_name": "IRON RIVER",
    "display_name": "IRON RIVER",
    "county": "IRON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 7,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003410",
    "resolved_pwsid": "MI0003410",
    "system_name": "IRON RIVER",
    "display_name": "IRON RIVER",
    "county": "IRON",
    "monitoring_end_date": "",
    "year": 2021,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 11,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003410",
    "resolved_pwsid": "MI0003410",
    "system_name": "IRON RIVER",
    "display_name": "IRON RIVER",
    "county": "IRON",
    "monitoring_end_date": "",
    "year": 2022,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003410",
    "resolved_pwsid": "MI0003410",
    "system_name": "IRON RIVER",
    "display_name": "IRON RIVER",
    "county": "IRON",
    "monitoring_end_date": "",
    "year": 2024,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 3,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003420",
    "resolved_pwsid": "MI0003420",
    "system_name": "IRONWOOD",
    "display_name": "IRONWOOD",
    "county": "GOGEBIC",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003420",
    "resolved_pwsid": "MI0003420",
    "system_name": "IRONWOOD",
    "display_name": "IRONWOOD",
    "county": "GOGEBIC",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003420",
    "resolved_pwsid": "MI0003420",
    "system_name": "IRONWOOD",
    "display_name": "IRONWOOD",
    "county": "GOGEBIC",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 43,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003420",
    "resolved_pwsid": "MI0003420",
    "system_name": "IRONWOOD",
    "display_name": "IRONWOOD",
    "county": "GOGEBIC",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 259,
    "inventory_lead": 25,
    "inventory_gpcl": 144,
    "inventory_unknown": 664,
    "total_to_identify_or_replace": 833,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0003420",
    "resolved_pwsid": "MI0003420",
    "system_name": "IRONWOOD",
    "display_name": "IRONWOOD",
    "county": "GOGEBIC",
    "monitoring_end_date": "",
    "year": 2021,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 79,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003420",
    "resolved_pwsid": "MI0003420",
    "system_name": "IRONWOOD",
    "display_name": "IRONWOOD",
    "county": "GOGEBIC",
    "monitoring_end_date": "",
    "year": 2023,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 91,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003420",
    "resolved_pwsid": "MI0003420",
    "system_name": "IRONWOOD",
    "display_name": "IRONWOOD",
    "county": "GOGEBIC",
    "monitoring_end_date": "",
    "year": 2024,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 164,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003430",
    "resolved_pwsid": "MI0003430",
    "system_name": "IRONWOOD TOWNSHIP",
    "display_name": "IRONWOOD TOWNSHIP",
    "county": "GOGEBIC",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003430",
    "resolved_pwsid": "MI0003430",
    "system_name": "IRONWOOD TOWNSHIP",
    "display_name": "IRONWOOD TOWNSHIP",
    "county": "GOGEBIC",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003430",
    "resolved_pwsid": "MI0003430",
    "system_name": "IRONWOOD TOWNSHIP",
    "display_name": "IRONWOOD TOWNSHIP",
    "county": "GOGEBIC",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003430",
    "resolved_pwsid": "MI0003430",
    "system_name": "IRONWOOD TOWNSHIP",
    "display_name": "IRONWOOD TOWNSHIP",
    "county": "GOGEBIC",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003430",
    "resolved_pwsid": "MI0003430",
    "system_name": "IRONWOOD TOWNSHIP",
    "display_name": "IRONWOOD TOWNSHIP",
    "county": "GOGEBIC",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003430",
    "resolved_pwsid": "MI0003430",
    "system_name": "IRONWOOD TOWNSHIP",
    "display_name": "IRONWOOD TOWNSHIP",
    "county": "GOGEBIC",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003430",
    "resolved_pwsid": "MI0003430",
    "system_name": "IRONWOOD TOWNSHIP",
    "display_name": "IRONWOOD TOWNSHIP",
    "county": "GOGEBIC",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003430",
    "resolved_pwsid": "MI0003430",
    "system_name": "IRONWOOD TOWNSHIP",
    "display_name": "IRONWOOD TOWNSHIP",
    "county": "GOGEBIC",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003430",
    "resolved_pwsid": "MI0003430",
    "system_name": "IRONWOOD TOWNSHIP",
    "display_name": "IRONWOOD TOWNSHIP",
    "county": "GOGEBIC",
    "monitoring_end_date": "",
    "year": 2024,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003430",
    "resolved_pwsid": "MI0003430",
    "system_name": "IRONWOOD TOWNSHIP",
    "display_name": "IRONWOOD TOWNSHIP",
    "county": "GOGEBIC",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003435",
    "resolved_pwsid": "MI0003435",
    "system_name": "LAKE ISABELLA WATER DIST. #1",
    "display_name": "LAKE ISABELLA WATER DIST. #1",
    "county": "ISABELLA",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003435",
    "resolved_pwsid": "MI0003435",
    "system_name": "LAKE ISABELLA WATER DIST. #1",
    "display_name": "LAKE ISABELLA WATER DIST. #1",
    "county": "ISABELLA",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003435",
    "resolved_pwsid": "MI0003435",
    "system_name": "LAKE ISABELLA WATER DIST. #1",
    "display_name": "LAKE ISABELLA WATER DIST. #1",
    "county": "ISABELLA",
    "monitoring_end_date": "2024-09-30",
    "year": 2024,
    "lead_90th_ppb": 41,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003435",
    "resolved_pwsid": "MI0003435",
    "system_name": "LAKE ISABELLA WATER DIST. #1",
    "display_name": "LAKE ISABELLA WATER DIST. #1",
    "county": "ISABELLA",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 41,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003435",
    "resolved_pwsid": "MI0003435",
    "system_name": "LAKE ISABELLA WATER DIST. #1",
    "display_name": "LAKE ISABELLA WATER DIST. #1",
    "county": "ISABELLA",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 86,
    "total_to_identify_or_replace": 86,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0003440",
    "resolved_pwsid": "MI0003440",
    "system_name": "ISHPEMING",
    "display_name": "ISHPEMING",
    "county": "MARQUETTE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003440",
    "resolved_pwsid": "MI0003440",
    "system_name": "ISHPEMING",
    "display_name": "ISHPEMING",
    "county": "MARQUETTE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003440",
    "resolved_pwsid": "MI0003440",
    "system_name": "ISHPEMING",
    "display_name": "ISHPEMING",
    "county": "MARQUETTE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003440",
    "resolved_pwsid": "MI0003440",
    "system_name": "ISHPEMING",
    "display_name": "ISHPEMING",
    "county": "MARQUETTE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003440",
    "resolved_pwsid": "MI0003440",
    "system_name": "ISHPEMING",
    "display_name": "ISHPEMING",
    "county": "MARQUETTE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003440",
    "resolved_pwsid": "MI0003440",
    "system_name": "ISHPEMING",
    "display_name": "ISHPEMING",
    "county": "MARQUETTE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003440",
    "resolved_pwsid": "MI0003440",
    "system_name": "ISHPEMING",
    "display_name": "ISHPEMING",
    "county": "MARQUETTE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003440",
    "resolved_pwsid": "MI0003440",
    "system_name": "ISHPEMING",
    "display_name": "ISHPEMING",
    "county": "MARQUETTE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": 3,
    "inventory_lead": 0,
    "inventory_gpcl": 7,
    "inventory_unknown": 2198,
    "total_to_identify_or_replace": 2205,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0003450",
    "resolved_pwsid": "MI0003450",
    "system_name": "ISHPEMING TWP - WEST",
    "display_name": "ISHPEMING TWP - WEST",
    "county": "MARQUETTE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003450",
    "resolved_pwsid": "MI0003450",
    "system_name": "ISHPEMING TWP - WEST",
    "display_name": "ISHPEMING TWP - WEST",
    "county": "MARQUETTE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003450",
    "resolved_pwsid": "MI0003450",
    "system_name": "ISHPEMING TWP - WEST",
    "display_name": "ISHPEMING TWP - WEST",
    "county": "MARQUETTE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003452",
    "resolved_pwsid": "MI0003452",
    "system_name": "ISLANDVIEW HOME OWNERS ASSOCIATION",
    "display_name": "ISLANDVIEW HOME OWNERS ASSOCIATION",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 13,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003452",
    "resolved_pwsid": "MI0003452",
    "system_name": "ISLANDVIEW HOME OWNERS ASSOCIATION",
    "display_name": "ISLANDVIEW HOME OWNERS ASSOCIATION",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003452",
    "resolved_pwsid": "MI0003452",
    "system_name": "ISLANDVIEW HOME OWNERS ASSOCIATION",
    "display_name": "ISLANDVIEW HOME OWNERS ASSOCIATION",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003452",
    "resolved_pwsid": "MI0003452",
    "system_name": "ISLANDVIEW HOME OWNERS ASSOCIATION",
    "display_name": "ISLANDVIEW HOME OWNERS ASSOCIATION",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003460",
    "resolved_pwsid": "MI0003460",
    "system_name": "ITHACA, CITY OF",
    "display_name": "ITHACA, CITY OF",
    "county": "GRATIOT",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003460",
    "resolved_pwsid": "MI0003460",
    "system_name": "ITHACA, CITY OF",
    "display_name": "ITHACA, CITY OF",
    "county": "GRATIOT",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 41,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003460",
    "resolved_pwsid": "MI0003460",
    "system_name": "ITHACA, CITY OF",
    "display_name": "ITHACA, CITY OF",
    "county": "GRATIOT",
    "monitoring_end_date": "2024-06-30",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 11,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003460",
    "resolved_pwsid": "MI0003460",
    "system_name": "ITHACA, CITY OF",
    "display_name": "ITHACA, CITY OF",
    "county": "GRATIOT",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003460",
    "resolved_pwsid": "MI0003460",
    "system_name": "ITHACA, CITY OF",
    "display_name": "ITHACA, CITY OF",
    "county": "GRATIOT",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 10,
    "inventory_lead": 0,
    "inventory_gpcl": 38,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003460",
    "resolved_pwsid": "MI0003460",
    "system_name": "ITHACA, CITY OF",
    "display_name": "ITHACA, CITY OF",
    "county": "GRATIOT",
    "monitoring_end_date": "2026-06-30",
    "year": 2026,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003460",
    "resolved_pwsid": "MI0003460",
    "system_name": "ITHACA, CITY OF",
    "display_name": "ITHACA, CITY OF",
    "county": "GRATIOT",
    "monitoring_end_date": "",
    "year": 2022,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 8,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003470",
    "resolved_pwsid": "MI0003470",
    "system_name": "JACKSON",
    "display_name": "JACKSON",
    "county": "JACKSON",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003470",
    "resolved_pwsid": "MI0003470",
    "system_name": "JACKSON",
    "display_name": "JACKSON",
    "county": "JACKSON",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 9,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003470",
    "resolved_pwsid": "MI0003470",
    "system_name": "JACKSON",
    "display_name": "JACKSON",
    "county": "JACKSON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003470",
    "resolved_pwsid": "MI0003470",
    "system_name": "JACKSON",
    "display_name": "JACKSON",
    "county": "JACKSON",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 338,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003470",
    "resolved_pwsid": "MI0003470",
    "system_name": "JACKSON",
    "display_name": "JACKSON",
    "county": "JACKSON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 103,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003470",
    "resolved_pwsid": "MI0003470",
    "system_name": "JACKSON",
    "display_name": "JACKSON",
    "county": "JACKSON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 186,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003470",
    "resolved_pwsid": "MI0003470",
    "system_name": "JACKSON",
    "display_name": "JACKSON",
    "county": "JACKSON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 368,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003470",
    "resolved_pwsid": "MI0003470",
    "system_name": "JACKSON",
    "display_name": "JACKSON",
    "county": "JACKSON",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 583,
    "inventory_lead": 7840,
    "inventory_gpcl": 1,
    "inventory_unknown": 3360,
    "total_to_identify_or_replace": 11201,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0003474",
    "resolved_pwsid": "MI0003474",
    "system_name": "JAMESTOWN TOWNSHIP",
    "display_name": "JAMESTOWN TOWNSHIP",
    "county": "OTTAWA",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003474",
    "resolved_pwsid": "MI0003474",
    "system_name": "JAMESTOWN TOWNSHIP",
    "display_name": "JAMESTOWN TOWNSHIP",
    "county": "OTTAWA",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003474",
    "resolved_pwsid": "MI0003474",
    "system_name": "JAMESTOWN TOWNSHIP",
    "display_name": "JAMESTOWN TOWNSHIP",
    "county": "OTTAWA",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003474",
    "resolved_pwsid": "MI0003474",
    "system_name": "JAMESTOWN TOWNSHIP",
    "display_name": "JAMESTOWN TOWNSHIP",
    "county": "OTTAWA",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0003475",
    "resolved_pwsid": "MI0003475",
    "system_name": "JAMES TOWNSHIP",
    "display_name": "JAMES TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003475",
    "resolved_pwsid": "MI0003475",
    "system_name": "JAMES TOWNSHIP",
    "display_name": "JAMES TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003475",
    "resolved_pwsid": "MI0003475",
    "system_name": "JAMES TOWNSHIP",
    "display_name": "JAMES TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003475",
    "resolved_pwsid": "MI0003475",
    "system_name": "JAMES TOWNSHIP",
    "display_name": "JAMES TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003475",
    "resolved_pwsid": "MI0003475",
    "system_name": "JAMES TOWNSHIP",
    "display_name": "JAMES TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003475",
    "resolved_pwsid": "MI0003475",
    "system_name": "JAMES TOWNSHIP",
    "display_name": "JAMES TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003475",
    "resolved_pwsid": "MI0003475",
    "system_name": "JAMES TOWNSHIP",
    "display_name": "JAMES TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003490",
    "resolved_pwsid": "MI0003490",
    "system_name": "JONESVILLE",
    "display_name": "JONESVILLE",
    "county": "HILLSDALE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003490",
    "resolved_pwsid": "MI0003490",
    "system_name": "JONESVILLE",
    "display_name": "JONESVILLE",
    "county": "HILLSDALE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": 2,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003490",
    "resolved_pwsid": "MI0003490",
    "system_name": "JONESVILLE",
    "display_name": "JONESVILLE",
    "county": "HILLSDALE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": 23,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003490",
    "resolved_pwsid": "MI0003490",
    "system_name": "JONESVILLE",
    "display_name": "JONESVILLE",
    "county": "HILLSDALE",
    "monitoring_end_date": "",
    "year": 2022,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003490",
    "resolved_pwsid": "MI0003490",
    "system_name": "JONESVILLE",
    "display_name": "JONESVILLE",
    "county": "HILLSDALE",
    "monitoring_end_date": "",
    "year": 2023,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 27,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003490",
    "resolved_pwsid": "MI0003490",
    "system_name": "JONESVILLE",
    "display_name": "JONESVILLE",
    "county": "HILLSDALE",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 2,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003505",
    "resolved_pwsid": "MI0003505",
    "system_name": "JUNIPER HILLS CONDOMINIUMS",
    "display_name": "JUNIPER HILLS CONDOMINIUMS",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003505",
    "resolved_pwsid": "MI0003505",
    "system_name": "JUNIPER HILLS CONDOMINIUMS",
    "display_name": "JUNIPER HILLS CONDOMINIUMS",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003505",
    "resolved_pwsid": "MI0003505",
    "system_name": "JUNIPER HILLS CONDOMINIUMS",
    "display_name": "JUNIPER HILLS CONDOMINIUMS",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003505",
    "resolved_pwsid": "MI0003505",
    "system_name": "JUNIPER HILLS CONDOMINIUMS",
    "display_name": "JUNIPER HILLS CONDOMINIUMS",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0003510",
    "resolved_pwsid": "MI0003510",
    "system_name": "K I SAWYER",
    "display_name": "K I SAWYER",
    "county": "MARQUETTE",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003510",
    "resolved_pwsid": "MI0003510",
    "system_name": "K I SAWYER",
    "display_name": "K I SAWYER",
    "county": "MARQUETTE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003510",
    "resolved_pwsid": "MI0003510",
    "system_name": "K I SAWYER",
    "display_name": "K I SAWYER",
    "county": "MARQUETTE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003510",
    "resolved_pwsid": "MI0003510",
    "system_name": "K I SAWYER",
    "display_name": "K I SAWYER",
    "county": "MARQUETTE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 5,
    "inventory_lead": 3,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 3,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0003510",
    "resolved_pwsid": "MI0003510",
    "system_name": "K I SAWYER",
    "display_name": "K I SAWYER",
    "county": "MARQUETTE",
    "monitoring_end_date": "2026-06-30",
    "year": 2026,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003520",
    "resolved_pwsid": "MI0003520",
    "system_name": "KALAMAZOO",
    "display_name": "KALAMAZOO",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003520",
    "resolved_pwsid": "MI0003520",
    "system_name": "KALAMAZOO",
    "display_name": "KALAMAZOO",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 13,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003520",
    "resolved_pwsid": "MI0003520",
    "system_name": "KALAMAZOO",
    "display_name": "KALAMAZOO",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 15,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003520",
    "resolved_pwsid": "MI0003520",
    "system_name": "KALAMAZOO",
    "display_name": "KALAMAZOO",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003520",
    "resolved_pwsid": "MI0003520",
    "system_name": "KALAMAZOO",
    "display_name": "KALAMAZOO",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003520",
    "resolved_pwsid": "MI0003520",
    "system_name": "KALAMAZOO",
    "display_name": "KALAMAZOO",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2021-06-30",
    "year": 2021,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": 940,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003520",
    "resolved_pwsid": "MI0003520",
    "system_name": "KALAMAZOO",
    "display_name": "KALAMAZOO",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 13,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003520",
    "resolved_pwsid": "MI0003520",
    "system_name": "KALAMAZOO",
    "display_name": "KALAMAZOO",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2022-06-30",
    "year": 2022,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": 829,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003520",
    "resolved_pwsid": "MI0003520",
    "system_name": "KALAMAZOO",
    "display_name": "KALAMAZOO",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003520",
    "resolved_pwsid": "MI0003520",
    "system_name": "KALAMAZOO",
    "display_name": "KALAMAZOO",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2023-06-30",
    "year": 2023,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": 363,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003520",
    "resolved_pwsid": "MI0003520",
    "system_name": "KALAMAZOO",
    "display_name": "KALAMAZOO",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 9,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003520",
    "resolved_pwsid": "MI0003520",
    "system_name": "KALAMAZOO",
    "display_name": "KALAMAZOO",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2024-06-30",
    "year": 2024,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": 810,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003520",
    "resolved_pwsid": "MI0003520",
    "system_name": "KALAMAZOO",
    "display_name": "KALAMAZOO",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 9,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003520",
    "resolved_pwsid": "MI0003520",
    "system_name": "KALAMAZOO",
    "display_name": "KALAMAZOO",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": 1045,
    "inventory_lead": 4328,
    "inventory_gpcl": 286,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 4614,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0003520",
    "resolved_pwsid": "MI0003520",
    "system_name": "KALAMAZOO",
    "display_name": "KALAMAZOO",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2026-06-30",
    "year": 2026,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003525",
    "resolved_pwsid": "MI0003525",
    "system_name": "KALAMAZOO LAKE SEWER & WATER AUTHORITY",
    "display_name": "KALAMAZOO LAKE SEWER & WATER AUTHORITY",
    "county": "ALLEGAN",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003525",
    "resolved_pwsid": "MI0003525",
    "system_name": "KALAMAZOO LAKE SEWER & WATER AUTHORITY",
    "display_name": "KALAMAZOO LAKE SEWER & WATER AUTHORITY",
    "county": "ALLEGAN",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003525",
    "resolved_pwsid": "MI0003525",
    "system_name": "KALAMAZOO LAKE SEWER & WATER AUTHORITY",
    "display_name": "KALAMAZOO LAKE SEWER & WATER AUTHORITY",
    "county": "ALLEGAN",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003525",
    "resolved_pwsid": "MI0003525",
    "system_name": "KALAMAZOO LAKE SEWER & WATER AUTHORITY",
    "display_name": "KALAMAZOO LAKE SEWER & WATER AUTHORITY",
    "county": "ALLEGAN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003525",
    "resolved_pwsid": "MI0003525",
    "system_name": "KALAMAZOO LAKE SEWER & WATER AUTHORITY",
    "display_name": "KALAMAZOO LAKE SEWER & WATER AUTHORITY",
    "county": "ALLEGAN",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 13,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003525",
    "resolved_pwsid": "MI0003525",
    "system_name": "KALAMAZOO LAKE SEWER & WATER AUTHORITY",
    "display_name": "KALAMAZOO LAKE SEWER & WATER AUTHORITY",
    "county": "ALLEGAN",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": 18,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003525",
    "resolved_pwsid": "MI0003525",
    "system_name": "KALAMAZOO LAKE SEWER & WATER AUTHORITY",
    "display_name": "KALAMAZOO LAKE SEWER & WATER AUTHORITY",
    "county": "ALLEGAN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": 3,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003525",
    "resolved_pwsid": "MI0003525",
    "system_name": "KALAMAZOO LAKE SEWER & WATER AUTHORITY",
    "display_name": "KALAMAZOO LAKE SEWER & WATER AUTHORITY",
    "county": "ALLEGAN",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0003545",
    "resolved_pwsid": "MI0003545",
    "system_name": "KALCHIK ESTATES",
    "display_name": "KALCHIK ESTATES",
    "county": "EMMET",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003545",
    "resolved_pwsid": "MI0003545",
    "system_name": "KALCHIK ESTATES",
    "display_name": "KALCHIK ESTATES",
    "county": "EMMET",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003545",
    "resolved_pwsid": "MI0003545",
    "system_name": "KALCHIK ESTATES",
    "display_name": "KALCHIK ESTATES",
    "county": "EMMET",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003545",
    "resolved_pwsid": "MI0003545",
    "system_name": "KALCHIK ESTATES",
    "display_name": "KALCHIK ESTATES",
    "county": "EMMET",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003550",
    "resolved_pwsid": "MI0003550",
    "system_name": "KALEVA, VILLAGE OF",
    "display_name": "KALEVA, VILLAGE OF",
    "county": "MANISTEE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003550",
    "resolved_pwsid": "MI0003550",
    "system_name": "KALEVA, VILLAGE OF",
    "display_name": "KALEVA, VILLAGE OF",
    "county": "MANISTEE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003550",
    "resolved_pwsid": "MI0003550",
    "system_name": "KALEVA, VILLAGE OF",
    "display_name": "KALEVA, VILLAGE OF",
    "county": "MANISTEE",
    "monitoring_end_date": "2024-06-30",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 7,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003550",
    "resolved_pwsid": "MI0003550",
    "system_name": "KALEVA, VILLAGE OF",
    "display_name": "KALEVA, VILLAGE OF",
    "county": "MANISTEE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003550",
    "resolved_pwsid": "MI0003550",
    "system_name": "KALEVA, VILLAGE OF",
    "display_name": "KALEVA, VILLAGE OF",
    "county": "MANISTEE",
    "monitoring_end_date": "2025-06-30",
    "year": 2025,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": 5,
    "inventory_lead": 1,
    "inventory_gpcl": 53,
    "inventory_unknown": 149,
    "total_to_identify_or_replace": 203,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0003550",
    "resolved_pwsid": "MI0003550",
    "system_name": "KALEVA, VILLAGE OF",
    "display_name": "KALEVA, VILLAGE OF",
    "county": "MANISTEE",
    "monitoring_end_date": "",
    "year": 2022,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 21,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003550",
    "resolved_pwsid": "MI0003550",
    "system_name": "KALEVA, VILLAGE OF",
    "display_name": "KALEVA, VILLAGE OF",
    "county": "MANISTEE",
    "monitoring_end_date": "",
    "year": 2023,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 24,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003560",
    "resolved_pwsid": "MI0003560",
    "system_name": "KALKASKA, VILLAGE OF",
    "display_name": "KALKASKA, VILLAGE OF",
    "county": "KALKASKA",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003560",
    "resolved_pwsid": "MI0003560",
    "system_name": "KALKASKA, VILLAGE OF",
    "display_name": "KALKASKA, VILLAGE OF",
    "county": "KALKASKA",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003560",
    "resolved_pwsid": "MI0003560",
    "system_name": "KALKASKA, VILLAGE OF",
    "display_name": "KALKASKA, VILLAGE OF",
    "county": "KALKASKA",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003560",
    "resolved_pwsid": "MI0003560",
    "system_name": "KALKASKA, VILLAGE OF",
    "display_name": "KALKASKA, VILLAGE OF",
    "county": "KALKASKA",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 629,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 629,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0003565",
    "resolved_pwsid": "MI0003565",
    "system_name": "KAWKAWLIN TOWNSHIP",
    "display_name": "KAWKAWLIN TOWNSHIP",
    "county": "BAY",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003565",
    "resolved_pwsid": "MI0003565",
    "system_name": "KAWKAWLIN TOWNSHIP",
    "display_name": "KAWKAWLIN TOWNSHIP",
    "county": "BAY",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003565",
    "resolved_pwsid": "MI0003565",
    "system_name": "KAWKAWLIN TOWNSHIP",
    "display_name": "KAWKAWLIN TOWNSHIP",
    "county": "BAY",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003565",
    "resolved_pwsid": "MI0003565",
    "system_name": "KAWKAWLIN TOWNSHIP",
    "display_name": "KAWKAWLIN TOWNSHIP",
    "county": "BAY",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003565",
    "resolved_pwsid": "MI0003565",
    "system_name": "KAWKAWLIN TOWNSHIP",
    "display_name": "KAWKAWLIN TOWNSHIP",
    "county": "BAY",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003565",
    "resolved_pwsid": "MI0003565",
    "system_name": "KAWKAWLIN TOWNSHIP",
    "display_name": "KAWKAWLIN TOWNSHIP",
    "county": "BAY",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003565",
    "resolved_pwsid": "MI0003565",
    "system_name": "KAWKAWLIN TOWNSHIP",
    "display_name": "KAWKAWLIN TOWNSHIP",
    "county": "BAY",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003570",
    "resolved_pwsid": "MI0003570",
    "system_name": "KAWKAWLIN METRO DIST WATER SUP",
    "display_name": "KAWKAWLIN METRO DIST WATER SUP",
    "county": "BAY",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003570",
    "resolved_pwsid": "MI0003570",
    "system_name": "KAWKAWLIN METRO DIST WATER SUP",
    "display_name": "KAWKAWLIN METRO DIST WATER SUP",
    "county": "BAY",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003570",
    "resolved_pwsid": "MI0003570",
    "system_name": "KAWKAWLIN METRO DIST WATER SUP",
    "display_name": "KAWKAWLIN METRO DIST WATER SUP",
    "county": "BAY",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003570",
    "resolved_pwsid": "MI0003570",
    "system_name": "KAWKAWLIN METRO DIST WATER SUP",
    "display_name": "KAWKAWLIN METRO DIST WATER SUP",
    "county": "BAY",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003570",
    "resolved_pwsid": "MI0003570",
    "system_name": "KAWKAWLIN METRO DIST WATER SUP",
    "display_name": "KAWKAWLIN METRO DIST WATER SUP",
    "county": "BAY",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003570",
    "resolved_pwsid": "MI0003570",
    "system_name": "KAWKAWLIN METRO DIST WATER SUP",
    "display_name": "KAWKAWLIN METRO DIST WATER SUP",
    "county": "BAY",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003570",
    "resolved_pwsid": "MI0003570",
    "system_name": "KAWKAWLIN METRO DIST WATER SUP",
    "display_name": "KAWKAWLIN METRO DIST WATER SUP",
    "county": "BAY",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003595",
    "resolved_pwsid": "MI0003595",
    "system_name": "KEEGO HARBOR, CITY OF",
    "display_name": "KEEGO HARBOR, CITY OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003595",
    "resolved_pwsid": "MI0003595",
    "system_name": "KEEGO HARBOR, CITY OF",
    "display_name": "KEEGO HARBOR, CITY OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003595",
    "resolved_pwsid": "MI0003595",
    "system_name": "KEEGO HARBOR, CITY OF",
    "display_name": "KEEGO HARBOR, CITY OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003595",
    "resolved_pwsid": "MI0003595",
    "system_name": "KEEGO HARBOR, CITY OF",
    "display_name": "KEEGO HARBOR, CITY OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003595",
    "resolved_pwsid": "MI0003595",
    "system_name": "KEEGO HARBOR, CITY OF",
    "display_name": "KEEGO HARBOR, CITY OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003595",
    "resolved_pwsid": "MI0003595",
    "system_name": "KEEGO HARBOR, CITY OF",
    "display_name": "KEEGO HARBOR, CITY OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003595",
    "resolved_pwsid": "MI0003595",
    "system_name": "KEEGO HARBOR, CITY OF",
    "display_name": "KEEGO HARBOR, CITY OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003595",
    "resolved_pwsid": "MI0003595",
    "system_name": "KEEGO HARBOR, CITY OF",
    "display_name": "KEEGO HARBOR, CITY OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0003598",
    "resolved_pwsid": "MI0003598",
    "system_name": "KELLOGG BIOLOGICAL STATION",
    "display_name": "KELLOGG BIOLOGICAL STATION",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 16,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003598",
    "resolved_pwsid": "MI0003598",
    "system_name": "KELLOGG BIOLOGICAL STATION",
    "display_name": "KELLOGG BIOLOGICAL STATION",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 12,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003598",
    "resolved_pwsid": "MI0003598",
    "system_name": "KELLOGG BIOLOGICAL STATION",
    "display_name": "KELLOGG BIOLOGICAL STATION",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 19,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003598",
    "resolved_pwsid": "MI0003598",
    "system_name": "KELLOGG BIOLOGICAL STATION",
    "display_name": "KELLOGG BIOLOGICAL STATION",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 14,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003598",
    "resolved_pwsid": "MI0003598",
    "system_name": "KELLOGG BIOLOGICAL STATION",
    "display_name": "KELLOGG BIOLOGICAL STATION",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003598",
    "resolved_pwsid": "MI0003598",
    "system_name": "KELLOGG BIOLOGICAL STATION",
    "display_name": "KELLOGG BIOLOGICAL STATION",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 14,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003598",
    "resolved_pwsid": "MI0003598",
    "system_name": "KELLOGG BIOLOGICAL STATION",
    "display_name": "KELLOGG BIOLOGICAL STATION",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003598",
    "resolved_pwsid": "MI0003598",
    "system_name": "KELLOGG BIOLOGICAL STATION",
    "display_name": "KELLOGG BIOLOGICAL STATION",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 13,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003598",
    "resolved_pwsid": "MI0003598",
    "system_name": "KELLOGG BIOLOGICAL STATION",
    "display_name": "KELLOGG BIOLOGICAL STATION",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003598",
    "resolved_pwsid": "MI0003598",
    "system_name": "KELLOGG BIOLOGICAL STATION",
    "display_name": "KELLOGG BIOLOGICAL STATION",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 9,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003615",
    "resolved_pwsid": "MI0003615",
    "system_name": "KENT RIDGE APARTMENTS",
    "display_name": "KENT RIDGE APARTMENTS",
    "county": "KENT",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003615",
    "resolved_pwsid": "MI0003615",
    "system_name": "KENT RIDGE APARTMENTS",
    "display_name": "KENT RIDGE APARTMENTS",
    "county": "KENT",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003615",
    "resolved_pwsid": "MI0003615",
    "system_name": "KENT RIDGE APARTMENTS",
    "display_name": "KENT RIDGE APARTMENTS",
    "county": "KENT",
    "monitoring_end_date": "2024-09-30",
    "year": 2024,
    "lead_90th_ppb": 36,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003615",
    "resolved_pwsid": "MI0003615",
    "system_name": "KENT RIDGE APARTMENTS",
    "display_name": "KENT RIDGE APARTMENTS",
    "county": "KENT",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 36,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003615",
    "resolved_pwsid": "MI0003615",
    "system_name": "KENT RIDGE APARTMENTS",
    "display_name": "KENT RIDGE APARTMENTS",
    "county": "KENT",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0003620",
    "resolved_pwsid": "MI0003620",
    "system_name": "KENTWOOD",
    "display_name": "KENTWOOD",
    "county": "KENT",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003620",
    "resolved_pwsid": "MI0003620",
    "system_name": "KENTWOOD",
    "display_name": "KENTWOOD",
    "county": "KENT",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003620",
    "resolved_pwsid": "MI0003620",
    "system_name": "KENTWOOD",
    "display_name": "KENTWOOD",
    "county": "KENT",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003620",
    "resolved_pwsid": "MI0003620",
    "system_name": "KENTWOOD",
    "display_name": "KENTWOOD",
    "county": "KENT",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0003628",
    "resolved_pwsid": "MI0003628",
    "system_name": "KIMBALL TOWNSHIP",
    "display_name": "KIMBALL TOWNSHIP",
    "county": "ST CLAIR",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003628",
    "resolved_pwsid": "MI0003628",
    "system_name": "KIMBALL TOWNSHIP",
    "display_name": "KIMBALL TOWNSHIP",
    "county": "ST CLAIR",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003628",
    "resolved_pwsid": "MI0003628",
    "system_name": "KIMBALL TOWNSHIP",
    "display_name": "KIMBALL TOWNSHIP",
    "county": "ST. CLAIR",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003628",
    "resolved_pwsid": "MI0003628",
    "system_name": "KIMBALL TOWNSHIP",
    "display_name": "KIMBALL TOWNSHIP",
    "county": "ST. CLAIR",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003628",
    "resolved_pwsid": "MI0003628",
    "system_name": "KIMBALL TOWNSHIP",
    "display_name": "KIMBALL TOWNSHIP",
    "county": "ST. CLAIR",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003630",
    "resolved_pwsid": "MI0003630",
    "system_name": "KINROSS TOWNSHIP",
    "display_name": "KINROSS TOWNSHIP",
    "county": "CHIPPEWA",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003630",
    "resolved_pwsid": "MI0003630",
    "system_name": "KINROSS TOWNSHIP",
    "display_name": "KINROSS TOWNSHIP",
    "county": "CHIPPEWA",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003630",
    "resolved_pwsid": "MI0003630",
    "system_name": "KINROSS TOWNSHIP",
    "display_name": "KINROSS TOWNSHIP",
    "county": "CHIPPEWA",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003630",
    "resolved_pwsid": "MI0003630",
    "system_name": "KINROSS TOWNSHIP",
    "display_name": "KINROSS TOWNSHIP",
    "county": "CHIPPEWA",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0003640",
    "resolved_pwsid": "MI0003640",
    "system_name": "KINGSFORD",
    "display_name": "KINGSFORD",
    "county": "DICKINSON",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003640",
    "resolved_pwsid": "MI0003640",
    "system_name": "KINGSFORD",
    "display_name": "KINGSFORD",
    "county": "DICKINSON",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003640",
    "resolved_pwsid": "MI0003640",
    "system_name": "KINGSFORD",
    "display_name": "KINGSFORD",
    "county": "DICKINSON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": 26,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003640",
    "resolved_pwsid": "MI0003640",
    "system_name": "KINGSFORD",
    "display_name": "KINGSFORD",
    "county": "DICKINSON",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": 175,
    "inventory_lead": 1262,
    "inventory_gpcl": 162,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 1424,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0003640",
    "resolved_pwsid": "MI0003640",
    "system_name": "KINGSFORD",
    "display_name": "KINGSFORD",
    "county": "DICKINSON",
    "monitoring_end_date": "",
    "year": 2021,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 10,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003640",
    "resolved_pwsid": "MI0003640",
    "system_name": "KINGSFORD",
    "display_name": "KINGSFORD",
    "county": "DICKINSON",
    "monitoring_end_date": "",
    "year": 2023,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 6,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003640",
    "resolved_pwsid": "MI0003640",
    "system_name": "KINGSFORD",
    "display_name": "KINGSFORD",
    "county": "DICKINSON",
    "monitoring_end_date": "",
    "year": 2024,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 281,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003650",
    "resolved_pwsid": "MI0003650",
    "system_name": "KINGSLEY, VILLAGE OF",
    "display_name": "KINGSLEY, VILLAGE OF",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003650",
    "resolved_pwsid": "MI0003650",
    "system_name": "KINGSLEY, VILLAGE OF",
    "display_name": "KINGSLEY, VILLAGE OF",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003650",
    "resolved_pwsid": "MI0003650",
    "system_name": "KINGSLEY, VILLAGE OF",
    "display_name": "KINGSLEY, VILLAGE OF",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003650",
    "resolved_pwsid": "MI0003650",
    "system_name": "KINGSLEY, VILLAGE OF",
    "display_name": "KINGSLEY, VILLAGE OF",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 2,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003650",
    "resolved_pwsid": "MI0003650",
    "system_name": "KINGSLEY, VILLAGE OF",
    "display_name": "KINGSLEY, VILLAGE OF",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003650",
    "resolved_pwsid": "MI0003650",
    "system_name": "KINGSLEY, VILLAGE OF",
    "display_name": "KINGSLEY, VILLAGE OF",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003650",
    "resolved_pwsid": "MI0003650",
    "system_name": "KINGSLEY, VILLAGE OF",
    "display_name": "KINGSLEY, VILLAGE OF",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0003650",
    "resolved_pwsid": "MI0003650",
    "system_name": "KINGSLEY, VILLAGE OF",
    "display_name": "KINGSLEY, VILLAGE OF",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "",
    "year": 2023,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 214,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003650",
    "resolved_pwsid": "MI0003650",
    "system_name": "KINGSLEY, VILLAGE OF",
    "display_name": "KINGSLEY, VILLAGE OF",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "",
    "year": 2024,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 38,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003660",
    "resolved_pwsid": "MI0003660",
    "system_name": "KINGSTON, VILLAGE OF",
    "display_name": "KINGSTON, VILLAGE OF",
    "county": "TUSCOLA",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003660",
    "resolved_pwsid": "MI0003660",
    "system_name": "KINGSTON, VILLAGE OF",
    "display_name": "KINGSTON, VILLAGE OF",
    "county": "TUSCOLA",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 12,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003660",
    "resolved_pwsid": "MI0003660",
    "system_name": "KINGSTON, VILLAGE OF",
    "display_name": "KINGSTON, VILLAGE OF",
    "county": "TUSCOLA",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 4,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003661",
    "resolved_pwsid": "MI0003661",
    "system_name": "KIRTLAND COMMUNITY COLLEGE",
    "display_name": "KIRTLAND COMMUNITY COLLEGE",
    "county": "ROSCOMMON",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003666",
    "resolved_pwsid": "MI0003666",
    "system_name": "KNORRWOOD KNOLLS SUBDIVISION",
    "display_name": "KNORRWOOD KNOLLS SUBDIVISION",
    "county": "OAKLAND",
    "monitoring_end_date": "2018-06-30",
    "year": 2018,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003666",
    "resolved_pwsid": "MI0003666",
    "system_name": "KNORRWOOD KNOLLS SUBDIVISION",
    "display_name": "KNORRWOOD KNOLLS SUBDIVISION",
    "county": "OAKLAND",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003666",
    "resolved_pwsid": "MI0003666",
    "system_name": "KNORRWOOD KNOLLS SUBDIVISION",
    "display_name": "KNORRWOOD KNOLLS SUBDIVISION",
    "county": "OAKLAND",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003666",
    "resolved_pwsid": "MI0003666",
    "system_name": "KNORRWOOD KNOLLS SUBDIVISION",
    "display_name": "KNORRWOOD KNOLLS SUBDIVISION",
    "county": "OAKLAND",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003666",
    "resolved_pwsid": "MI0003666",
    "system_name": "KNORRWOOD KNOLLS SUBDIVISION",
    "display_name": "KNORRWOOD KNOLLS SUBDIVISION",
    "county": "OAKLAND",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003666",
    "resolved_pwsid": "MI0003666",
    "system_name": "KNORRWOOD KNOLLS SUBDIVISION",
    "display_name": "KNORRWOOD KNOLLS SUBDIVISION",
    "county": "OAKLAND",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003666",
    "resolved_pwsid": "MI0003666",
    "system_name": "KNORRWOOD KNOLLS SUBDIVISION",
    "display_name": "KNORRWOOD KNOLLS SUBDIVISION",
    "county": "OAKLAND",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003667",
    "resolved_pwsid": "MI0003667",
    "system_name": "KOCHVILLE TOWNSHIP",
    "display_name": "KOCHVILLE TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003667",
    "resolved_pwsid": "MI0003667",
    "system_name": "KOCHVILLE TOWNSHIP",
    "display_name": "KOCHVILLE TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003667",
    "resolved_pwsid": "MI0003667",
    "system_name": "KOCHVILLE TOWNSHIP",
    "display_name": "KOCHVILLE TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003667",
    "resolved_pwsid": "MI0003667",
    "system_name": "KOCHVILLE TOWNSHIP",
    "display_name": "KOCHVILLE TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003667",
    "resolved_pwsid": "MI0003667",
    "system_name": "KOCHVILLE TOWNSHIP",
    "display_name": "KOCHVILLE TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003667",
    "resolved_pwsid": "MI0003667",
    "system_name": "KOCHVILLE TOWNSHIP",
    "display_name": "KOCHVILLE TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003667",
    "resolved_pwsid": "MI0003667",
    "system_name": "KOCHVILLE TOWNSHIP",
    "display_name": "KOCHVILLE TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003670",
    "resolved_pwsid": "MI0003670",
    "system_name": "L'ANSE",
    "display_name": "L'ANSE",
    "county": "BARAGA",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003670",
    "resolved_pwsid": "MI0003670",
    "system_name": "L'ANSE",
    "display_name": "L'ANSE",
    "county": "BARAGA",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003670",
    "resolved_pwsid": "MI0003670",
    "system_name": "L'ANSE",
    "display_name": "L'ANSE",
    "county": "BARAGA",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003670",
    "resolved_pwsid": "MI0003670",
    "system_name": "L'ANSE",
    "display_name": "L'ANSE",
    "county": "BARAGA",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 18,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003670",
    "resolved_pwsid": "MI0003670",
    "system_name": "L'ANSE",
    "display_name": "L'ANSE",
    "county": "BARAGA",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 18,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003670",
    "resolved_pwsid": "MI0003670",
    "system_name": "L'ANSE",
    "display_name": "L'ANSE",
    "county": "BARAGA",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003670",
    "resolved_pwsid": "MI0003670",
    "system_name": "L'ANSE",
    "display_name": "L'ANSE",
    "county": "BARAGA",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003670",
    "resolved_pwsid": "MI0003670",
    "system_name": "L'ANSE",
    "display_name": "L'ANSE",
    "county": "BARAGA",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0003685",
    "resolved_pwsid": "MI0003685",
    "system_name": "L'ARBRE CROCHE CLUB",
    "display_name": "L'ARBRE CROCHE CLUB",
    "county": "EMMET",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003685",
    "resolved_pwsid": "MI0003685",
    "system_name": "L'ARBRE CROCHE CLUB",
    "display_name": "L'ARBRE CROCHE CLUB",
    "county": "EMMET",
    "monitoring_end_date": "2021-09-30",
    "year": 2021,
    "lead_90th_ppb": 17,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003685",
    "resolved_pwsid": "MI0003685",
    "system_name": "L'ARBRE CROCHE CLUB",
    "display_name": "L'ARBRE CROCHE CLUB",
    "county": "EMMET",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 17,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003685",
    "resolved_pwsid": "MI0003685",
    "system_name": "L'ARBRE CROCHE CLUB",
    "display_name": "L'ARBRE CROCHE CLUB",
    "county": "EMMET",
    "monitoring_end_date": "2022-06-30",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003685",
    "resolved_pwsid": "MI0003685",
    "system_name": "L'ARBRE CROCHE CLUB",
    "display_name": "L'ARBRE CROCHE CLUB",
    "county": "EMMET",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 15,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003685",
    "resolved_pwsid": "MI0003685",
    "system_name": "L'ARBRE CROCHE CLUB",
    "display_name": "L'ARBRE CROCHE CLUB",
    "county": "EMMET",
    "monitoring_end_date": "2023-06-30",
    "year": 2023,
    "lead_90th_ppb": 13,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003685",
    "resolved_pwsid": "MI0003685",
    "system_name": "L'ARBRE CROCHE CLUB",
    "display_name": "L'ARBRE CROCHE CLUB",
    "county": "EMMET",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003685",
    "resolved_pwsid": "MI0003685",
    "system_name": "L'ARBRE CROCHE CLUB",
    "display_name": "L'ARBRE CROCHE CLUB",
    "county": "EMMET",
    "monitoring_end_date": "2024-06-30",
    "year": 2024,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003690",
    "resolved_pwsid": "MI0003690",
    "system_name": "LAGUNA VISTA SUBDIVISION",
    "display_name": "LAGUNA VISTA SUBDIVISION",
    "county": "OAKLAND",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003690",
    "resolved_pwsid": "MI0003690",
    "system_name": "LAGUNA VISTA SUBDIVISION",
    "display_name": "LAGUNA VISTA SUBDIVISION",
    "county": "OAKLAND",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003690",
    "resolved_pwsid": "MI0003690",
    "system_name": "LAGUNA VISTA SUBDIVISION",
    "display_name": "LAGUNA VISTA SUBDIVISION",
    "county": "OAKLAND",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003691",
    "resolved_pwsid": "MI0003691",
    "system_name": "LAKE ANGELA CONDO APTS #3",
    "display_name": "LAKE ANGELA CONDO APTS #3",
    "county": "OAKLAND",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003691",
    "resolved_pwsid": "MI0003691",
    "system_name": "LAKE ANGELA CONDO APTS #3",
    "display_name": "LAKE ANGELA CONDO APTS #3",
    "county": "OAKLAND",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 14,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003691",
    "resolved_pwsid": "MI0003691",
    "system_name": "LAKE ANGELA CONDO APTS #3",
    "display_name": "LAKE ANGELA CONDO APTS #3",
    "county": "OAKLAND",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003692",
    "resolved_pwsid": "MI0003692",
    "system_name": "LAKE ARROWHEAD ESTATES",
    "display_name": "LAKE ARROWHEAD ESTATES",
    "county": "LENAWEE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003692",
    "resolved_pwsid": "MI0003692",
    "system_name": "LAKE ARROWHEAD ESTATES",
    "display_name": "LAKE ARROWHEAD ESTATES",
    "county": "LENAWEE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003692",
    "resolved_pwsid": "MI0003692",
    "system_name": "LAKE ARROWHEAD ESTATES",
    "display_name": "LAKE ARROWHEAD ESTATES",
    "county": "LENAWEE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003693",
    "resolved_pwsid": "MI0003693",
    "system_name": "LAKE ANGELA CONDO APTS #5",
    "display_name": "LAKE ANGELA CONDO APTS #5",
    "county": "OAKLAND",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003693",
    "resolved_pwsid": "MI0003693",
    "system_name": "LAKE ANGELA CONDO APTS #5",
    "display_name": "LAKE ANGELA CONDO APTS #5",
    "county": "OAKLAND",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003693",
    "resolved_pwsid": "MI0003693",
    "system_name": "LAKE ANGELA CONDO APTS #5",
    "display_name": "LAKE ANGELA CONDO APTS #5",
    "county": "OAKLAND",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003693",
    "resolved_pwsid": "MI0003693",
    "system_name": "LAKE ANGELA CONDO APTS #5",
    "display_name": "LAKE ANGELA CONDO APTS #5",
    "county": "OAKLAND",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0003693",
    "resolved_pwsid": "MI0003693",
    "system_name": "LAKE ANGELA CONDO APTS #5",
    "display_name": "LAKE ANGELA CONDO APTS #5",
    "county": "OAKLAND",
    "monitoring_end_date": "2026-06-30",
    "year": 2026,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003694",
    "resolved_pwsid": "MI0003694",
    "system_name": "LAKE ANGELA CONDO APTS #4",
    "display_name": "LAKE ANGELA CONDO APTS #4",
    "county": "OAKLAND",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003694",
    "resolved_pwsid": "MI0003694",
    "system_name": "LAKE ANGELA CONDO APTS #4",
    "display_name": "LAKE ANGELA CONDO APTS #4",
    "county": "OAKLAND",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003694",
    "resolved_pwsid": "MI0003694",
    "system_name": "LAKE ANGELA CONDO APTS #4",
    "display_name": "LAKE ANGELA CONDO APTS #4",
    "county": "OAKLAND",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003695",
    "resolved_pwsid": "MI0003695",
    "system_name": "LAKE BELLA VISTA",
    "display_name": "LAKE BELLA VISTA",
    "county": "KENT",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003695",
    "resolved_pwsid": "MI0003695",
    "system_name": "LAKE BELLA VISTA",
    "display_name": "LAKE BELLA VISTA",
    "county": "KENT",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003695",
    "resolved_pwsid": "MI0003695",
    "system_name": "LAKE BELLA VISTA",
    "display_name": "LAKE BELLA VISTA",
    "county": "KENT",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003695",
    "resolved_pwsid": "MI0003695",
    "system_name": "LAKE BELLA VISTA",
    "display_name": "LAKE BELLA VISTA",
    "county": "KENT",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003696",
    "resolved_pwsid": "MI0003696",
    "system_name": "LAKE ANGELA CONDO APTS #6",
    "display_name": "LAKE ANGELA CONDO APTS #6",
    "county": "OAKLAND",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003696",
    "resolved_pwsid": "MI0003696",
    "system_name": "LAKE ANGELA CONDO APTS #6",
    "display_name": "LAKE ANGELA CONDO APTS #6",
    "county": "OAKLAND",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003696",
    "resolved_pwsid": "MI0003696",
    "system_name": "LAKE ANGELA CONDO APTS #6",
    "display_name": "LAKE ANGELA CONDO APTS #6",
    "county": "OAKLAND",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003697",
    "resolved_pwsid": "MI0003697",
    "system_name": "LAKE CHEMUNG OUTDOOR RESORT",
    "display_name": "LAKE CHEMUNG OUTDOOR RESORT",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2026-06-30",
    "year": 2026,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003700",
    "resolved_pwsid": "MI0003700",
    "system_name": "LAKE CITY, CITY OF",
    "display_name": "LAKE CITY, CITY OF",
    "county": "MISSAUKEE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003700",
    "resolved_pwsid": "MI0003700",
    "system_name": "LAKE CITY, CITY OF",
    "display_name": "LAKE CITY, CITY OF",
    "county": "MISSAUKEE",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003700",
    "resolved_pwsid": "MI0003700",
    "system_name": "LAKE CITY, CITY OF",
    "display_name": "LAKE CITY, CITY OF",
    "county": "MISSAUKEE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003700",
    "resolved_pwsid": "MI0003700",
    "system_name": "LAKE CITY, CITY OF",
    "display_name": "LAKE CITY, CITY OF",
    "county": "MISSAUKEE",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003700",
    "resolved_pwsid": "MI0003700",
    "system_name": "LAKE CITY, CITY OF",
    "display_name": "LAKE CITY, CITY OF",
    "county": "MISSAUKEE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003700",
    "resolved_pwsid": "MI0003700",
    "system_name": "LAKE CITY, CITY OF",
    "display_name": "LAKE CITY, CITY OF",
    "county": "MISSAUKEE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 20,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003700",
    "resolved_pwsid": "MI0003700",
    "system_name": "LAKE CITY, CITY OF",
    "display_name": "LAKE CITY, CITY OF",
    "county": "MISSAUKEE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 9,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003700",
    "resolved_pwsid": "MI0003700",
    "system_name": "LAKE CITY, CITY OF",
    "display_name": "LAKE CITY, CITY OF",
    "county": "MISSAUKEE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 8,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003700",
    "resolved_pwsid": "MI0003700",
    "system_name": "LAKE CITY, CITY OF",
    "display_name": "LAKE CITY, CITY OF",
    "county": "MISSAUKEE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 5,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003700",
    "resolved_pwsid": "MI0003700",
    "system_name": "LAKE CITY, CITY OF",
    "display_name": "LAKE CITY, CITY OF",
    "county": "MISSAUKEE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 144,
    "inventory_lead": 189,
    "inventory_gpcl": 56,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003720",
    "resolved_pwsid": "MI0003720",
    "system_name": "LAKE LINDEN",
    "display_name": "LAKE LINDEN",
    "county": "HOUGHTON",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003720",
    "resolved_pwsid": "MI0003720",
    "system_name": "LAKE LINDEN",
    "display_name": "LAKE LINDEN",
    "county": "HOUGHTON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003720",
    "resolved_pwsid": "MI0003720",
    "system_name": "LAKE LINDEN",
    "display_name": "LAKE LINDEN",
    "county": "HOUGHTON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003726",
    "resolved_pwsid": "MI0003726",
    "system_name": "SOUTHWEST MICHIGAN REGIONAL SANITARY SEW",
    "display_name": "SOUTHWEST MICHIGAN REGIONAL SANITARY SEW",
    "county": "BERRIEN",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003726",
    "resolved_pwsid": "MI0003726",
    "system_name": "SOUTHWEST MICHIGAN REGIONAL SANITARY SEW",
    "display_name": "SOUTHWEST MICHIGAN REGIONAL SANITARY SEW",
    "county": "BERRIEN",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003726",
    "resolved_pwsid": "MI0003726",
    "system_name": "SOUTHWEST MICHIGAN REGIONAL SANITARY SEW",
    "display_name": "SOUTHWEST MICHIGAN REGIONAL SANITARY SEW",
    "county": "BERRIEN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003726",
    "resolved_pwsid": "MI0003726",
    "system_name": "SOUTHWEST MICHIGAN REGIONAL SANITARY SEW",
    "display_name": "SOUTHWEST MICHIGAN REGIONAL SANITARY SEW",
    "county": "BERRIEN",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003726",
    "resolved_pwsid": "MI0003726",
    "system_name": "SOUTHWEST MICHIGAN REGIONAL SANITARY SEW",
    "display_name": "SOUTHWEST MICHIGAN REGIONAL SANITARY SEW",
    "county": "BERRIEN",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003726",
    "resolved_pwsid": "MI0003726",
    "system_name": "SOUTHWEST MICHIGAN REGIONAL SANITARY SEW",
    "display_name": "SOUTHWEST MICHIGAN REGIONAL SANITARY SEW",
    "county": "BERRIEN",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 2,
    "inventory_lead": 2,
    "inventory_gpcl": 18,
    "inventory_unknown": 7864,
    "total_to_identify_or_replace": 7884,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0003728",
    "resolved_pwsid": "MI0003728",
    "system_name": "LAKE MITCHELL CONDOMINIUM ASSOCIATION",
    "display_name": "LAKE MITCHELL CONDOMINIUM ASSOCIATION",
    "county": "WEXFORD",
    "monitoring_end_date": "2026-06-30",
    "year": 2026,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003730",
    "resolved_pwsid": "MI0003730",
    "system_name": "LAKE ODESSA",
    "display_name": "LAKE ODESSA",
    "county": "IONIA",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003730",
    "resolved_pwsid": "MI0003730",
    "system_name": "LAKE ODESSA",
    "display_name": "LAKE ODESSA",
    "county": "IONIA",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003730",
    "resolved_pwsid": "MI0003730",
    "system_name": "LAKE ODESSA",
    "display_name": "LAKE ODESSA",
    "county": "IONIA",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003737",
    "resolved_pwsid": "MI0003737",
    "system_name": "LAKE POINTE CONDOMINIUMS",
    "display_name": "LAKE POINTE CONDOMINIUMS",
    "county": "BERRIEN",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003737",
    "resolved_pwsid": "MI0003737",
    "system_name": "LAKE POINTE CONDOMINIUMS",
    "display_name": "LAKE POINTE CONDOMINIUMS",
    "county": "BERRIEN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003737",
    "resolved_pwsid": "MI0003737",
    "system_name": "LAKE POINTE CONDOMINIUMS",
    "display_name": "LAKE POINTE CONDOMINIUMS",
    "county": "BERRIEN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003740",
    "resolved_pwsid": "MI0003740",
    "system_name": "LAKE ORION, VILLAGE OF",
    "display_name": "LAKE ORION, VILLAGE OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003740",
    "resolved_pwsid": "MI0003740",
    "system_name": "LAKE ORION, VILLAGE OF",
    "display_name": "LAKE ORION, VILLAGE OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003740",
    "resolved_pwsid": "MI0003740",
    "system_name": "LAKE ORION, VILLAGE OF",
    "display_name": "LAKE ORION, VILLAGE OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003740",
    "resolved_pwsid": "MI0003740",
    "system_name": "LAKE ORION, VILLAGE OF",
    "display_name": "LAKE ORION, VILLAGE OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 25,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003740",
    "resolved_pwsid": "MI0003740",
    "system_name": "LAKE ORION, VILLAGE OF",
    "display_name": "LAKE ORION, VILLAGE OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003740",
    "resolved_pwsid": "MI0003740",
    "system_name": "LAKE ORION, VILLAGE OF",
    "display_name": "LAKE ORION, VILLAGE OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003740",
    "resolved_pwsid": "MI0003740",
    "system_name": "LAKE ORION, VILLAGE OF",
    "display_name": "LAKE ORION, VILLAGE OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 2,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003740",
    "resolved_pwsid": "MI0003740",
    "system_name": "LAKE ORION, VILLAGE OF",
    "display_name": "LAKE ORION, VILLAGE OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 33,
    "inventory_gpcl": 27,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003741",
    "resolved_pwsid": "MI0003741",
    "system_name": "LAKE CHARTER TOWNSHIP",
    "display_name": "LAKE CHARTER TOWNSHIP",
    "county": "BERRIEN",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003741",
    "resolved_pwsid": "MI0003741",
    "system_name": "LAKE CHARTER TOWNSHIP",
    "display_name": "LAKE CHARTER TOWNSHIP",
    "county": "BERRIEN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003741",
    "resolved_pwsid": "MI0003741",
    "system_name": "LAKE CHARTER TOWNSHIP",
    "display_name": "LAKE CHARTER TOWNSHIP",
    "county": "BERRIEN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003742",
    "resolved_pwsid": "MI0003742",
    "system_name": "LAKESIDE ESTATES SUBDIVISION",
    "display_name": "LAKESIDE ESTATES SUBDIVISION",
    "county": "BRANCH",
    "monitoring_end_date": "2015-12-31",
    "year": 2015,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003742",
    "resolved_pwsid": "MI0003742",
    "system_name": "LAKESIDE ESTATES SUBDIVISION",
    "display_name": "LAKESIDE ESTATES SUBDIVISION",
    "county": "BRANCH",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003742",
    "resolved_pwsid": "MI0003742",
    "system_name": "LAKESIDE ESTATES SUBDIVISION",
    "display_name": "LAKESIDE ESTATES SUBDIVISION",
    "county": "BRANCH",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003744",
    "resolved_pwsid": "MI0003744",
    "system_name": "LAKESIDE CLUB CONDOMINIUMS",
    "display_name": "LAKESIDE CLUB CONDOMINIUMS",
    "county": "EMMET",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003744",
    "resolved_pwsid": "MI0003744",
    "system_name": "LAKESIDE CLUB CONDOMINIUMS",
    "display_name": "LAKESIDE CLUB CONDOMINIUMS",
    "county": "EMMET",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003744",
    "resolved_pwsid": "MI0003744",
    "system_name": "LAKESIDE CLUB CONDOMINIUMS",
    "display_name": "LAKESIDE CLUB CONDOMINIUMS",
    "county": "EMMET",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003744",
    "resolved_pwsid": "MI0003744",
    "system_name": "LAKESIDE CLUB CONDOMINIUMS",
    "display_name": "LAKESIDE CLUB CONDOMINIUMS",
    "county": "EMMET",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0003747",
    "resolved_pwsid": "MI0003747",
    "system_name": "LAKETOWN TOWNSHIP",
    "display_name": "LAKETOWN TOWNSHIP",
    "county": "ALLEGAN",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003747",
    "resolved_pwsid": "MI0003747",
    "system_name": "LAKETOWN TOWNSHIP",
    "display_name": "LAKETOWN TOWNSHIP",
    "county": "ALLEGAN",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003747",
    "resolved_pwsid": "MI0003747",
    "system_name": "LAKETOWN TOWNSHIP",
    "display_name": "LAKETOWN TOWNSHIP",
    "county": "ALLEGAN",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003747",
    "resolved_pwsid": "MI0003747",
    "system_name": "LAKETOWN TOWNSHIP",
    "display_name": "LAKETOWN TOWNSHIP",
    "county": "ALLEGAN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003747",
    "resolved_pwsid": "MI0003747",
    "system_name": "LAKETOWN TOWNSHIP",
    "display_name": "LAKETOWN TOWNSHIP",
    "county": "ALLEGAN",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003747",
    "resolved_pwsid": "MI0003747",
    "system_name": "LAKETOWN TOWNSHIP",
    "display_name": "LAKETOWN TOWNSHIP",
    "county": "ALLEGAN",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003747",
    "resolved_pwsid": "MI0003747",
    "system_name": "LAKETOWN TOWNSHIP",
    "display_name": "LAKETOWN TOWNSHIP",
    "county": "ALLEGAN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003749",
    "resolved_pwsid": "MI0003749",
    "system_name": "SPRINGS/PORTSMOUTH APARTMENTS",
    "display_name": "SPRINGS/PORTSMOUTH APARTMENTS",
    "county": "OAKLAND",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003749",
    "resolved_pwsid": "MI0003749",
    "system_name": "SPRINGS/PORTSMOUTH APARTMENTS",
    "display_name": "SPRINGS/PORTSMOUTH APARTMENTS",
    "county": "OAKLAND",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003749",
    "resolved_pwsid": "MI0003749",
    "system_name": "SPRINGS/PORTSMOUTH APARTMENTS",
    "display_name": "SPRINGS/PORTSMOUTH APARTMENTS",
    "county": "OAKLAND",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003750",
    "resolved_pwsid": "MI0003750",
    "system_name": "LAKEVIEW",
    "display_name": "LAKEVIEW",
    "county": "MONTCALM",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003750",
    "resolved_pwsid": "MI0003750",
    "system_name": "LAKEVIEW",
    "display_name": "LAKEVIEW",
    "county": "MONTCALM",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 10,
    "above_action_level": false,
    "lines_replaced": 8,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003750",
    "resolved_pwsid": "MI0003750",
    "system_name": "LAKEVIEW",
    "display_name": "LAKEVIEW",
    "county": "MONTCALM",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": 4,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003750",
    "resolved_pwsid": "MI0003750",
    "system_name": "LAKEVIEW",
    "display_name": "LAKEVIEW",
    "county": "MONTCALM",
    "monitoring_end_date": "",
    "year": 2022,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 3,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003750",
    "resolved_pwsid": "MI0003750",
    "system_name": "LAKEVIEW",
    "display_name": "LAKEVIEW",
    "county": "MONTCALM",
    "monitoring_end_date": "",
    "year": 2023,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003750",
    "resolved_pwsid": "MI0003750",
    "system_name": "LAKEVIEW",
    "display_name": "LAKEVIEW",
    "county": "MONTCALM",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 3,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003751",
    "resolved_pwsid": "MI0003751",
    "system_name": "LAKESHORE CONDOMINIUMS",
    "display_name": "LAKESHORE CONDOMINIUMS",
    "county": "JACKSON",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003751",
    "resolved_pwsid": "MI0003751",
    "system_name": "LAKESHORE CONDOMINIUMS",
    "display_name": "LAKESHORE CONDOMINIUMS",
    "county": "JACKSON",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003751",
    "resolved_pwsid": "MI0003751",
    "system_name": "LAKESHORE CONDOMINIUMS",
    "display_name": "LAKESHORE CONDOMINIUMS",
    "county": "JACKSON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003751",
    "resolved_pwsid": "MI0003751",
    "system_name": "LAKESHORE CONDOMINIUMS",
    "display_name": "LAKESHORE CONDOMINIUMS",
    "county": "JACKSON",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0003752",
    "resolved_pwsid": "MI0003752",
    "system_name": "LAKESIDE DEVELOPMENT",
    "display_name": "LAKESIDE DEVELOPMENT",
    "county": "GLADWIN",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003752",
    "resolved_pwsid": "MI0003752",
    "system_name": "LAKESIDE DEVELOPMENT",
    "display_name": "LAKESIDE DEVELOPMENT",
    "county": "GLADWIN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003752",
    "resolved_pwsid": "MI0003752",
    "system_name": "LAKESIDE DEVELOPMENT",
    "display_name": "LAKESIDE DEVELOPMENT",
    "county": "GLADWIN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003753",
    "resolved_pwsid": "MI0003753",
    "system_name": "LAKESHORE HILLTOP APARTMENTS",
    "display_name": "LAKESHORE HILLTOP APARTMENTS",
    "county": "OAKLAND",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003753",
    "resolved_pwsid": "MI0003753",
    "system_name": "LAKESHORE HILLTOP APARTMENTS",
    "display_name": "LAKESHORE HILLTOP APARTMENTS",
    "county": "OAKLAND",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003753",
    "resolved_pwsid": "MI0003753",
    "system_name": "LAKESHORE HILLTOP APARTMENTS",
    "display_name": "LAKESHORE HILLTOP APARTMENTS",
    "county": "OAKLAND",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003753",
    "resolved_pwsid": "MI0003753",
    "system_name": "LAKESHORE HILLTOP APARTMENTS",
    "display_name": "LAKESHORE HILLTOP APARTMENTS",
    "county": "OAKLAND",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0003755",
    "resolved_pwsid": "MI0003755",
    "system_name": "LAKEVIEW APARTMENTS",
    "display_name": "LAKEVIEW APARTMENTS",
    "county": "OTSEGO",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003755",
    "resolved_pwsid": "MI0003755",
    "system_name": "LAKEVIEW APARTMENTS",
    "display_name": "LAKEVIEW APARTMENTS",
    "county": "OTSEGO",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003755",
    "resolved_pwsid": "MI0003755",
    "system_name": "LAKEVIEW APARTMENTS",
    "display_name": "LAKEVIEW APARTMENTS",
    "county": "OTSEGO",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003757",
    "resolved_pwsid": "MI0003757",
    "system_name": "LAKEWOOD BEACH COMMUNITY SERVICES CO.",
    "display_name": "LAKEWOOD BEACH COMMUNITY SERVICES CO.",
    "county": "ALLEGAN",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003757",
    "resolved_pwsid": "MI0003757",
    "system_name": "LAKEWOOD BEACH COMMUNITY SERVICES CO.",
    "display_name": "LAKEWOOD BEACH COMMUNITY SERVICES CO.",
    "county": "ALLEGAN",
    "monitoring_end_date": "2024-06-30",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003760",
    "resolved_pwsid": "MI0003760",
    "system_name": "LANSING BOARD OF WATER & LIGHT",
    "display_name": "LANSING BOARD OF WATER & LIGHT",
    "county": "INGHAM",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003760",
    "resolved_pwsid": "MI0003760",
    "system_name": "LANSING BOARD OF WATER & LIGHT",
    "display_name": "LANSING BOARD OF WATER & LIGHT",
    "county": "INGHAM",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003760",
    "resolved_pwsid": "MI0003760",
    "system_name": "LANSING BOARD OF WATER & LIGHT",
    "display_name": "LANSING BOARD OF WATER & LIGHT",
    "county": "INGHAM",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003770",
    "resolved_pwsid": "MI0003770",
    "system_name": "LANSING TOWNSHIP",
    "display_name": "LANSING TOWNSHIP",
    "county": "INGHAM",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003770",
    "resolved_pwsid": "MI0003770",
    "system_name": "LANSING TOWNSHIP",
    "display_name": "LANSING TOWNSHIP",
    "county": "INGHAM",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003770",
    "resolved_pwsid": "MI0003770",
    "system_name": "LANSING TOWNSHIP",
    "display_name": "LANSING TOWNSHIP",
    "county": "INGHAM",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003780",
    "resolved_pwsid": "MI0003780",
    "system_name": "LAPEER, CITY OF",
    "display_name": "LAPEER, CITY OF",
    "county": "LAPEER",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003780",
    "resolved_pwsid": "MI0003780",
    "system_name": "LAPEER, CITY OF",
    "display_name": "LAPEER, CITY OF",
    "county": "LAPEER",
    "monitoring_end_date": "2019-09-30",
    "year": 2019,
    "lead_90th_ppb": 19,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003780",
    "resolved_pwsid": "MI0003780",
    "system_name": "LAPEER, CITY OF",
    "display_name": "LAPEER, CITY OF",
    "county": "LAPEER",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 19,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003780",
    "resolved_pwsid": "MI0003780",
    "system_name": "LAPEER, CITY OF",
    "display_name": "LAPEER, CITY OF",
    "county": "LAPEER",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 9,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003780",
    "resolved_pwsid": "MI0003780",
    "system_name": "LAPEER, CITY OF",
    "display_name": "LAPEER, CITY OF",
    "county": "LAPEER",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003780",
    "resolved_pwsid": "MI0003780",
    "system_name": "LAPEER, CITY OF",
    "display_name": "LAPEER, CITY OF",
    "county": "LAPEER",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 11,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003780",
    "resolved_pwsid": "MI0003780",
    "system_name": "LAPEER, CITY OF",
    "display_name": "LAPEER, CITY OF",
    "county": "LAPEER",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 12,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003780",
    "resolved_pwsid": "MI0003780",
    "system_name": "LAPEER, CITY OF",
    "display_name": "LAPEER, CITY OF",
    "county": "LAPEER",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": 111,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003780",
    "resolved_pwsid": "MI0003780",
    "system_name": "LAPEER, CITY OF",
    "display_name": "LAPEER, CITY OF",
    "county": "LAPEER",
    "monitoring_end_date": "2024-06-30",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 21,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003780",
    "resolved_pwsid": "MI0003780",
    "system_name": "LAPEER, CITY OF",
    "display_name": "LAPEER, CITY OF",
    "county": "LAPEER",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003780",
    "resolved_pwsid": "MI0003780",
    "system_name": "LAPEER, CITY OF",
    "display_name": "LAPEER, CITY OF",
    "county": "LAPEER",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 4,
    "inventory_lead": 1,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 1,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0003794",
    "resolved_pwsid": "MI0003794",
    "system_name": "LARKIN TOWNSHIP",
    "display_name": "LARKIN TOWNSHIP",
    "county": "MIDLAND",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003794",
    "resolved_pwsid": "MI0003794",
    "system_name": "LARKIN TOWNSHIP",
    "display_name": "LARKIN TOWNSHIP",
    "county": "MIDLAND",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003794",
    "resolved_pwsid": "MI0003794",
    "system_name": "LARKIN TOWNSHIP",
    "display_name": "LARKIN TOWNSHIP",
    "county": "MIDLAND",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003794",
    "resolved_pwsid": "MI0003794",
    "system_name": "LARKIN TOWNSHIP",
    "display_name": "LARKIN TOWNSHIP",
    "county": "MIDLAND",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003794",
    "resolved_pwsid": "MI0003794",
    "system_name": "LARKIN TOWNSHIP",
    "display_name": "LARKIN TOWNSHIP",
    "county": "MIDLAND",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003794",
    "resolved_pwsid": "MI0003794",
    "system_name": "LARKIN TOWNSHIP",
    "display_name": "LARKIN TOWNSHIP",
    "county": "MIDLAND",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003794",
    "resolved_pwsid": "MI0003794",
    "system_name": "LARKIN TOWNSHIP",
    "display_name": "LARKIN TOWNSHIP",
    "county": "MIDLAND",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003800",
    "resolved_pwsid": "MI0003800",
    "system_name": "LATHRUP VILLAGE",
    "display_name": "LATHRUP VILLAGE",
    "county": "OAKLAND",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003800",
    "resolved_pwsid": "MI0003800",
    "system_name": "LATHRUP VILLAGE",
    "display_name": "LATHRUP VILLAGE",
    "county": "OAKLAND",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003800",
    "resolved_pwsid": "MI0003800",
    "system_name": "LATHRUP VILLAGE",
    "display_name": "LATHRUP VILLAGE",
    "county": "OAKLAND",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003800",
    "resolved_pwsid": "MI0003800",
    "system_name": "LATHRUP VILLAGE",
    "display_name": "LATHRUP VILLAGE",
    "county": "OAKLAND",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": 16,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003800",
    "resolved_pwsid": "MI0003800",
    "system_name": "LATHRUP VILLAGE",
    "display_name": "LATHRUP VILLAGE",
    "county": "OAKLAND",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": 5,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003800",
    "resolved_pwsid": "MI0003800",
    "system_name": "LATHRUP VILLAGE",
    "display_name": "LATHRUP VILLAGE",
    "county": "OAKLAND",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 3,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003800",
    "resolved_pwsid": "MI0003800",
    "system_name": "LATHRUP VILLAGE",
    "display_name": "LATHRUP VILLAGE",
    "county": "OAKLAND",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 6,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003800",
    "resolved_pwsid": "MI0003800",
    "system_name": "LATHRUP VILLAGE",
    "display_name": "LATHRUP VILLAGE",
    "county": "OAKLAND",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 2,
    "inventory_lead": 1,
    "inventory_gpcl": 0,
    "inventory_unknown": 25,
    "total_to_identify_or_replace": 26,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0003810",
    "resolved_pwsid": "MI0003810",
    "system_name": "LAURIUM",
    "display_name": "LAURIUM",
    "county": "HOUGHTON",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003810",
    "resolved_pwsid": "MI0003810",
    "system_name": "LAURIUM",
    "display_name": "LAURIUM",
    "county": "HOUGHTON",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003810",
    "resolved_pwsid": "MI0003810",
    "system_name": "LAURIUM",
    "display_name": "LAURIUM",
    "county": "HOUGHTON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003810",
    "resolved_pwsid": "MI0003810",
    "system_name": "LAURIUM",
    "display_name": "LAURIUM",
    "county": "HOUGHTON",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 474,
    "total_to_identify_or_replace": 474,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0003820",
    "resolved_pwsid": "MI0003820",
    "system_name": "LAWRENCE",
    "display_name": "LAWRENCE",
    "county": "VAN BUREN",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 24,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003820",
    "resolved_pwsid": "MI0003820",
    "system_name": "LAWRENCE",
    "display_name": "LAWRENCE",
    "county": "VAN BUREN",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003820",
    "resolved_pwsid": "MI0003820",
    "system_name": "LAWRENCE",
    "display_name": "LAWRENCE",
    "county": "VAN BUREN",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003820",
    "resolved_pwsid": "MI0003820",
    "system_name": "LAWRENCE",
    "display_name": "LAWRENCE",
    "county": "VAN BUREN",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 31,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003820",
    "resolved_pwsid": "MI0003820",
    "system_name": "LAWRENCE",
    "display_name": "LAWRENCE",
    "county": "VAN BUREN",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003820",
    "resolved_pwsid": "MI0003820",
    "system_name": "LAWRENCE",
    "display_name": "LAWRENCE",
    "county": "VAN BUREN",
    "monitoring_end_date": "2021-06-30",
    "year": 2021,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003820",
    "resolved_pwsid": "MI0003820",
    "system_name": "LAWRENCE",
    "display_name": "LAWRENCE",
    "county": "VAN BUREN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003820",
    "resolved_pwsid": "MI0003820",
    "system_name": "LAWRENCE",
    "display_name": "LAWRENCE",
    "county": "VAN BUREN",
    "monitoring_end_date": "2022-06-30",
    "year": 2022,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003820",
    "resolved_pwsid": "MI0003820",
    "system_name": "LAWRENCE",
    "display_name": "LAWRENCE",
    "county": "VAN BUREN",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003820",
    "resolved_pwsid": "MI0003820",
    "system_name": "LAWRENCE",
    "display_name": "LAWRENCE",
    "county": "VAN BUREN",
    "monitoring_end_date": "2023-06-30",
    "year": 2023,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003820",
    "resolved_pwsid": "MI0003820",
    "system_name": "LAWRENCE",
    "display_name": "LAWRENCE",
    "county": "VAN BUREN",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003820",
    "resolved_pwsid": "MI0003820",
    "system_name": "LAWRENCE",
    "display_name": "LAWRENCE",
    "county": "VAN BUREN",
    "monitoring_end_date": "2024-06-30",
    "year": 2024,
    "lead_90th_ppb": 13,
    "above_action_level": true,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003820",
    "resolved_pwsid": "MI0003820",
    "system_name": "LAWRENCE",
    "display_name": "LAWRENCE",
    "county": "VAN BUREN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003820",
    "resolved_pwsid": "MI0003820",
    "system_name": "LAWRENCE",
    "display_name": "LAWRENCE",
    "county": "VAN BUREN",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003820",
    "resolved_pwsid": "MI0003820",
    "system_name": "LAWRENCE",
    "display_name": "LAWRENCE",
    "county": "VAN BUREN",
    "monitoring_end_date": "2026-06-30",
    "year": 2026,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003829",
    "resolved_pwsid": "MI0003829",
    "system_name": "LEELANAU CO LAW ENFORCEMENT CENTER",
    "display_name": "LEELANAU CO LAW ENFORCEMENT CENTER",
    "county": "LEELANAU",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003829",
    "resolved_pwsid": "MI0003829",
    "system_name": "LEELANAU CO LAW ENFORCEMENT CENTER",
    "display_name": "LEELANAU CO LAW ENFORCEMENT CENTER",
    "county": "LEELANAU",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003829",
    "resolved_pwsid": "MI0003829",
    "system_name": "LEELANAU CO LAW ENFORCEMENT CENTER",
    "display_name": "LEELANAU CO LAW ENFORCEMENT CENTER",
    "county": "LEELANAU",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003829",
    "resolved_pwsid": "MI0003829",
    "system_name": "LEELANAU CO LAW ENFORCEMENT CENTER",
    "display_name": "LEELANAU CO LAW ENFORCEMENT CENTER",
    "county": "LEELANAU",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003829",
    "resolved_pwsid": "MI0003829",
    "system_name": "LEELANAU CO LAW ENFORCEMENT CENTER",
    "display_name": "LEELANAU CO LAW ENFORCEMENT CENTER",
    "county": "LEELANAU",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003829",
    "resolved_pwsid": "MI0003829",
    "system_name": "LEELANAU CO LAW ENFORCEMENT CENTER",
    "display_name": "LEELANAU CO LAW ENFORCEMENT CENTER",
    "county": "LEELANAU",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003829",
    "resolved_pwsid": "MI0003829",
    "system_name": "LEELANAU CO LAW ENFORCEMENT CENTER",
    "display_name": "LEELANAU CO LAW ENFORCEMENT CENTER",
    "county": "LEELANAU",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003829",
    "resolved_pwsid": "MI0003829",
    "system_name": "LEELANAU CO LAW ENFORCEMENT CENTER",
    "display_name": "LEELANAU CO LAW ENFORCEMENT CENTER",
    "county": "LEELANAU",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0003830",
    "resolved_pwsid": "MI0003830",
    "system_name": "LAWTON",
    "display_name": "LAWTON",
    "county": "VAN BUREN",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003830",
    "resolved_pwsid": "MI0003830",
    "system_name": "LAWTON",
    "display_name": "LAWTON",
    "county": "VAN BUREN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 4,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003830",
    "resolved_pwsid": "MI0003830",
    "system_name": "LAWTON",
    "display_name": "LAWTON",
    "county": "VAN BUREN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 34,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003830",
    "resolved_pwsid": "MI0003830",
    "system_name": "LAWTON",
    "display_name": "LAWTON",
    "county": "VAN BUREN",
    "monitoring_end_date": "",
    "year": 2022,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 4,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003830",
    "resolved_pwsid": "MI0003830",
    "system_name": "LAWTON",
    "display_name": "LAWTON",
    "county": "VAN BUREN",
    "monitoring_end_date": "",
    "year": 2023,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 4,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003830",
    "resolved_pwsid": "MI0003830",
    "system_name": "LAWTON",
    "display_name": "LAWTON",
    "county": "VAN BUREN",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 17,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003831",
    "resolved_pwsid": "MI0003831",
    "system_name": "THE LEELANAU SCHOOL",
    "display_name": "THE LEELANAU SCHOOL",
    "county": "LEELANAU",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003831",
    "resolved_pwsid": "MI0003831",
    "system_name": "THE LEELANAU SCHOOL",
    "display_name": "THE LEELANAU SCHOOL",
    "county": "LEELANAU",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003831",
    "resolved_pwsid": "MI0003831",
    "system_name": "THE LEELANAU SCHOOL",
    "display_name": "THE LEELANAU SCHOOL",
    "county": "LEELANAU",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003836",
    "resolved_pwsid": "MI0003836",
    "system_name": "LENOX TOWNSHIP",
    "display_name": "LENOX TOWNSHIP",
    "county": "MACOMB",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003836",
    "resolved_pwsid": "MI0003836",
    "system_name": "LENOX TOWNSHIP",
    "display_name": "LENOX TOWNSHIP",
    "county": "MACOMB",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003836",
    "resolved_pwsid": "MI0003836",
    "system_name": "LENOX TOWNSHIP",
    "display_name": "LENOX TOWNSHIP",
    "county": "MACOMB",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003836",
    "resolved_pwsid": "MI0003836",
    "system_name": "LENOX TOWNSHIP",
    "display_name": "LENOX TOWNSHIP",
    "county": "MACOMB",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003836",
    "resolved_pwsid": "MI0003836",
    "system_name": "LENOX TOWNSHIP",
    "display_name": "LENOX TOWNSHIP",
    "county": "MACOMB",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003836",
    "resolved_pwsid": "MI0003836",
    "system_name": "LENOX TOWNSHIP",
    "display_name": "LENOX TOWNSHIP",
    "county": "MACOMB",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003836",
    "resolved_pwsid": "MI0003836",
    "system_name": "LENOX TOWNSHIP",
    "display_name": "LENOX TOWNSHIP",
    "county": "MACOMB",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003836",
    "resolved_pwsid": "MI0003836",
    "system_name": "LENOX TOWNSHIP",
    "display_name": "LENOX TOWNSHIP",
    "county": "MACOMB",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0003837",
    "resolved_pwsid": "MI0003837",
    "system_name": "LEONI TOWNSHIP",
    "display_name": "LEONI TOWNSHIP",
    "county": "JACKSON",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003837",
    "resolved_pwsid": "MI0003837",
    "system_name": "LEONI TOWNSHIP",
    "display_name": "LEONI TOWNSHIP",
    "county": "JACKSON",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003837",
    "resolved_pwsid": "MI0003837",
    "system_name": "LEONI TOWNSHIP",
    "display_name": "LEONI TOWNSHIP",
    "county": "JACKSON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003837",
    "resolved_pwsid": "MI0003837",
    "system_name": "LEONI TOWNSHIP",
    "display_name": "LEONI TOWNSHIP",
    "county": "JACKSON",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 19,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0003837",
    "resolved_pwsid": "MI0003837",
    "system_name": "LEONI TOWNSHIP",
    "display_name": "LEONI TOWNSHIP",
    "county": "JACKSON",
    "monitoring_end_date": "2026-06-30",
    "year": 2026,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003838",
    "resolved_pwsid": "MI0003838-a",
    "system_name": "LEE TOWNSHIP",
    "display_name": "LEE TOWNSHIP",
    "county": "ALLEGAN",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003840",
    "resolved_pwsid": "MI0003840",
    "system_name": "LESLIE, CITY OF",
    "display_name": "LESLIE, CITY OF",
    "county": "INGHAM",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003840",
    "resolved_pwsid": "MI0003840",
    "system_name": "LESLIE, CITY OF",
    "display_name": "LESLIE, CITY OF",
    "county": "INGHAM",
    "monitoring_end_date": "2019-09-30",
    "year": 2019,
    "lead_90th_ppb": 19,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003840",
    "resolved_pwsid": "MI0003840",
    "system_name": "LESLIE, CITY OF",
    "display_name": "LESLIE, CITY OF",
    "county": "INGHAM",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 15,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003840",
    "resolved_pwsid": "MI0003840",
    "system_name": "LESLIE, CITY OF",
    "display_name": "LESLIE, CITY OF",
    "county": "INGHAM",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 16,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003840",
    "resolved_pwsid": "MI0003840",
    "system_name": "LESLIE, CITY OF",
    "display_name": "LESLIE, CITY OF",
    "county": "INGHAM",
    "monitoring_end_date": "2021-06-30",
    "year": 2021,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": 11,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003840",
    "resolved_pwsid": "MI0003840",
    "system_name": "LESLIE, CITY OF",
    "display_name": "LESLIE, CITY OF",
    "county": "INGHAM",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 18,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003840",
    "resolved_pwsid": "MI0003840",
    "system_name": "LESLIE, CITY OF",
    "display_name": "LESLIE, CITY OF",
    "county": "INGHAM",
    "monitoring_end_date": "2022-06-30",
    "year": 2022,
    "lead_90th_ppb": 54,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003840",
    "resolved_pwsid": "MI0003840",
    "system_name": "LESLIE, CITY OF",
    "display_name": "LESLIE, CITY OF",
    "county": "INGHAM",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003840",
    "resolved_pwsid": "MI0003840",
    "system_name": "LESLIE, CITY OF",
    "display_name": "LESLIE, CITY OF",
    "county": "INGHAM",
    "monitoring_end_date": "2023-06-30",
    "year": 2023,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": 21,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003840",
    "resolved_pwsid": "MI0003840",
    "system_name": "LESLIE, CITY OF",
    "display_name": "LESLIE, CITY OF",
    "county": "INGHAM",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003840",
    "resolved_pwsid": "MI0003840",
    "system_name": "LESLIE, CITY OF",
    "display_name": "LESLIE, CITY OF",
    "county": "INGHAM",
    "monitoring_end_date": "2024-06-30",
    "year": 2024,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": 21,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003840",
    "resolved_pwsid": "MI0003840",
    "system_name": "LESLIE, CITY OF",
    "display_name": "LESLIE, CITY OF",
    "county": "INGHAM",
    "monitoring_end_date": "2024-06-30",
    "year": 2024,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003840",
    "resolved_pwsid": "MI0003840",
    "system_name": "LESLIE, CITY OF",
    "display_name": "LESLIE, CITY OF",
    "county": "INGHAM",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": 12,
    "inventory_lead": 81,
    "inventory_gpcl": 1,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003850",
    "resolved_pwsid": "MI0003850",
    "system_name": "LEXINGTON, VILLAGE OF",
    "display_name": "LEXINGTON, VILLAGE OF",
    "county": "SANILAC",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003850",
    "resolved_pwsid": "MI0003850",
    "system_name": "LEXINGTON, VILLAGE OF",
    "display_name": "LEXINGTON, VILLAGE OF",
    "county": "SANILAC",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003850",
    "resolved_pwsid": "MI0003850",
    "system_name": "LEXINGTON, VILLAGE OF",
    "display_name": "LEXINGTON, VILLAGE OF",
    "county": "SANILAC",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003850",
    "resolved_pwsid": "MI0003850",
    "system_name": "LEXINGTON, VILLAGE OF",
    "display_name": "LEXINGTON, VILLAGE OF",
    "county": "SANILAC",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003856",
    "resolved_pwsid": "MI0003856",
    "system_name": "WORTH TOWNSHIP",
    "display_name": "WORTH TOWNSHIP",
    "county": "SANILAC",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003856",
    "resolved_pwsid": "MI0003856",
    "system_name": "WORTH TOWNSHIP",
    "display_name": "WORTH TOWNSHIP",
    "county": "SANILAC",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003856",
    "resolved_pwsid": "MI0003856",
    "system_name": "WORTH TOWNSHIP",
    "display_name": "WORTH TOWNSHIP",
    "county": "SANILAC",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003856",
    "resolved_pwsid": "MI0003856",
    "system_name": "WORTH TOWNSHIP",
    "display_name": "WORTH TOWNSHIP",
    "county": "SANILAC",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0003857",
    "resolved_pwsid": "MI0003857-a",
    "system_name": "ADDINGTON PLACE OF DEWITT",
    "display_name": "ADDINGTON PLACE OF DEWITT",
    "county": "CLINTON",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003857",
    "resolved_pwsid": "MI0003857-a",
    "system_name": "ADDINGTON PLACE OF DEWITT",
    "display_name": "ADDINGTON PLACE OF DEWITT",
    "county": "CLINTON",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003857",
    "resolved_pwsid": "MI0003857-a",
    "system_name": "ADDINGTON PLACE OF DEWITT",
    "display_name": "ADDINGTON PLACE OF DEWITT",
    "county": "CLINTON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003857",
    "resolved_pwsid": "MI0003857-b",
    "system_name": "SERENE GARDENS OF DEWITT",
    "display_name": "SERENE GARDENS OF DEWITT",
    "county": "CLINTON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003857",
    "resolved_pwsid": "MI0003857-c",
    "system_name": "DIVINE LIFE OF DEWITT",
    "display_name": "SERENE GARDENS OF DEWITT",
    "county": "CLINTON",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003868",
    "resolved_pwsid": "MI0003868",
    "system_name": "LINCOLN MANOR",
    "display_name": "LINCOLN MANOR",
    "county": "ALCONA",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003868",
    "resolved_pwsid": "MI0003868",
    "system_name": "LINCOLN MANOR",
    "display_name": "LINCOLN MANOR",
    "county": "ALCONA",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003868",
    "resolved_pwsid": "MI0003868",
    "system_name": "LINCOLN MANOR",
    "display_name": "LINCOLN MANOR",
    "county": "ALCONA",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003870",
    "resolved_pwsid": "MI0003870",
    "system_name": "LINCOLN PARK",
    "display_name": "LINCOLN PARK",
    "county": "WAYNE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003870",
    "resolved_pwsid": "MI0003870",
    "system_name": "LINCOLN PARK",
    "display_name": "LINCOLN PARK",
    "county": "WAYNE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003870",
    "resolved_pwsid": "MI0003870",
    "system_name": "LINCOLN PARK",
    "display_name": "LINCOLN PARK",
    "county": "WAYNE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 9,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003870",
    "resolved_pwsid": "MI0003870",
    "system_name": "LINCOLN PARK",
    "display_name": "LINCOLN PARK",
    "county": "WAYNE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": 75,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003870",
    "resolved_pwsid": "MI0003870",
    "system_name": "LINCOLN PARK",
    "display_name": "LINCOLN PARK",
    "county": "WAYNE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": 108,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003870",
    "resolved_pwsid": "MI0003870",
    "system_name": "LINCOLN PARK",
    "display_name": "LINCOLN PARK",
    "county": "WAYNE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 10,
    "above_action_level": false,
    "lines_replaced": 79,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003870",
    "resolved_pwsid": "MI0003870",
    "system_name": "LINCOLN PARK",
    "display_name": "LINCOLN PARK",
    "county": "WAYNE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": 7,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003870",
    "resolved_pwsid": "MI0003870",
    "system_name": "LINCOLN PARK",
    "display_name": "LINCOLN PARK",
    "county": "WAYNE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": 1481,
    "inventory_lead": 2647,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 2647,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0003880",
    "resolved_pwsid": "MI0003880",
    "system_name": "CRYSTAL FALLS TOWNSHIP - LIND",
    "display_name": "CRYSTAL FALLS TOWNSHIP - LIND",
    "county": "IRON",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003880",
    "resolved_pwsid": "MI0003880",
    "system_name": "CRYSTAL FALLS TOWNSHIP - LIND",
    "display_name": "CRYSTAL FALLS TOWNSHIP - LIND",
    "county": "IRON",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003880",
    "resolved_pwsid": "MI0003880",
    "system_name": "CRYSTAL FALLS TOWNSHIP - LIND",
    "display_name": "CRYSTAL FALLS TOWNSHIP - LIND",
    "county": "IRON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003880",
    "resolved_pwsid": "MI0003880",
    "system_name": "CRYSTAL FALLS TOWNSHIP - LIND",
    "display_name": "CRYSTAL FALLS TOWNSHIP - LIND",
    "county": "IRON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003880",
    "resolved_pwsid": "MI0003880",
    "system_name": "CRYSTAL FALLS TOWNSHIP - LIND",
    "display_name": "CRYSTAL FALLS TOWNSHIP - LIND",
    "county": "IRON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 2,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003880",
    "resolved_pwsid": "MI0003880",
    "system_name": "CRYSTAL FALLS TOWNSHIP - LIND",
    "display_name": "CRYSTAL FALLS TOWNSHIP - LIND",
    "county": "IRON",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": 21,
    "inventory_gpcl": 0,
    "inventory_unknown": 217,
    "total_to_identify_or_replace": 238,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0003880",
    "resolved_pwsid": "MI0003880",
    "system_name": "CRYSTAL FALLS TOWNSHIP - LIND",
    "display_name": "CRYSTAL FALLS TOWNSHIP - LIND",
    "county": "IRON",
    "monitoring_end_date": "2026-06-30",
    "year": 2026,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003890",
    "resolved_pwsid": "MI0003890",
    "system_name": "LINDEN, CITY OF",
    "display_name": "LINDEN, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003890",
    "resolved_pwsid": "MI0003890",
    "system_name": "LINDEN, CITY OF",
    "display_name": "LINDEN, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003890",
    "resolved_pwsid": "MI0003890",
    "system_name": "LINDEN, CITY OF",
    "display_name": "LINDEN, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003890",
    "resolved_pwsid": "MI0003890",
    "system_name": "LINDEN, CITY OF",
    "display_name": "LINDEN, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003890",
    "resolved_pwsid": "MI0003890",
    "system_name": "LINDEN, CITY OF",
    "display_name": "LINDEN, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0003890",
    "resolved_pwsid": "MI0003890",
    "system_name": "LINDEN, CITY OF",
    "display_name": "LINDEN, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2026-06-30",
    "year": 2026,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003910",
    "resolved_pwsid": "MI0003910",
    "system_name": "LINWOOD METROPOLITAN DISTRICT",
    "display_name": "LINWOOD METROPOLITAN DISTRICT",
    "county": "BAY",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 13,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003910",
    "resolved_pwsid": "MI0003910",
    "system_name": "LINWOOD METROPOLITAN DISTRICT",
    "display_name": "LINWOOD METROPOLITAN DISTRICT",
    "county": "BAY",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003910",
    "resolved_pwsid": "MI0003910",
    "system_name": "LINWOOD METROPOLITAN DISTRICT",
    "display_name": "LINWOOD METROPOLITAN DISTRICT",
    "county": "BAY",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003910",
    "resolved_pwsid": "MI0003910",
    "system_name": "LINWOOD METROPOLITAN DISTRICT",
    "display_name": "LINWOOD METROPOLITAN DISTRICT",
    "county": "BAY",
    "monitoring_end_date": "2024-06-30",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003910",
    "resolved_pwsid": "MI0003910",
    "system_name": "LINWOOD METROPOLITAN DISTRICT",
    "display_name": "LINWOOD METROPOLITAN DISTRICT",
    "county": "BAY",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003910",
    "resolved_pwsid": "MI0003910",
    "system_name": "LINWOOD METROPOLITAN DISTRICT",
    "display_name": "LINWOOD METROPOLITAN DISTRICT",
    "county": "BAY",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0003920",
    "resolved_pwsid": "MI0003920",
    "system_name": "LITCHFIELD",
    "display_name": "LITCHFIELD",
    "county": "HILLSDALE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003920",
    "resolved_pwsid": "MI0003920",
    "system_name": "LITCHFIELD",
    "display_name": "LITCHFIELD",
    "county": "HILLSDALE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003920",
    "resolved_pwsid": "MI0003920",
    "system_name": "LITCHFIELD",
    "display_name": "LITCHFIELD",
    "county": "HILLSDALE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003925",
    "resolved_pwsid": "MI0003925",
    "system_name": "BLUE LAKE RESIDENCES",
    "display_name": "BLUE LAKE RESIDENCES",
    "county": "MUSKEGON",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003925",
    "resolved_pwsid": "MI0003925",
    "system_name": "BLUE LAKE RESIDENCES",
    "display_name": "BLUE LAKE RESIDENCES",
    "county": "MUSKEGON",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003925",
    "resolved_pwsid": "MI0003925",
    "system_name": "BLUE LAKE RESIDENCES",
    "display_name": "BLUE LAKE RESIDENCES",
    "county": "MUSKEGON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 9,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003925",
    "resolved_pwsid": "MI0003925",
    "system_name": "BLUE LAKE RESIDENCES",
    "display_name": "BLUE LAKE RESIDENCES",
    "county": "MUSKEGON",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0003927",
    "resolved_pwsid": "MI0003927",
    "system_name": "LITTLE TRAVERSE TOWNSHIP",
    "display_name": "LITTLE TRAVERSE TOWNSHIP",
    "county": "EMMET",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003927",
    "resolved_pwsid": "MI0003927",
    "system_name": "LITTLE TRAVERSE TOWNSHIP",
    "display_name": "LITTLE TRAVERSE TOWNSHIP",
    "county": "EMMET",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003927",
    "resolved_pwsid": "MI0003927",
    "system_name": "LITTLE TRAVERSE TOWNSHIP",
    "display_name": "LITTLE TRAVERSE TOWNSHIP",
    "county": "EMMET",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003929",
    "resolved_pwsid": "MI0003929",
    "system_name": "LIVINGSTON COMMUNITY WATER AUTHORITY",
    "display_name": "LIVINGSTON COMMUNITY WATER AUTHORITY",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003929",
    "resolved_pwsid": "MI0003929",
    "system_name": "LIVINGSTON COMMUNITY WATER AUTHORITY",
    "display_name": "LIVINGSTON COMMUNITY WATER AUTHORITY",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003929",
    "resolved_pwsid": "MI0003929",
    "system_name": "LIVINGSTON COMMUNITY WATER AUTHORITY",
    "display_name": "LIVINGSTON COMMUNITY WATER AUTHORITY",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003929",
    "resolved_pwsid": "MI0003929",
    "system_name": "LIVINGSTON COMMUNITY WATER AUTHORITY",
    "display_name": "LIVINGSTON COMMUNITY WATER AUTHORITY",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003930",
    "resolved_pwsid": "MI0003930",
    "system_name": "LIVONIA",
    "display_name": "LIVONIA",
    "county": "WAYNE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003930",
    "resolved_pwsid": "MI0003930",
    "system_name": "LIVONIA",
    "display_name": "LIVONIA",
    "county": "WAYNE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003930",
    "resolved_pwsid": "MI0003930",
    "system_name": "LIVONIA",
    "display_name": "LIVONIA",
    "county": "WAYNE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 10,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003930",
    "resolved_pwsid": "MI0003930",
    "system_name": "LIVONIA",
    "display_name": "LIVONIA",
    "county": "WAYNE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": 20,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003930",
    "resolved_pwsid": "MI0003930",
    "system_name": "LIVONIA",
    "display_name": "LIVONIA",
    "county": "WAYNE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 9,
    "above_action_level": false,
    "lines_replaced": 20,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003930",
    "resolved_pwsid": "MI0003930",
    "system_name": "LIVONIA",
    "display_name": "LIVONIA",
    "county": "WAYNE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 10,
    "above_action_level": false,
    "lines_replaced": 16,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003930",
    "resolved_pwsid": "MI0003930",
    "system_name": "LIVONIA",
    "display_name": "LIVONIA",
    "county": "WAYNE",
    "monitoring_end_date": "2024-09-30",
    "year": 2024,
    "lead_90th_ppb": 17,
    "above_action_level": true,
    "lines_replaced": 32,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003930",
    "resolved_pwsid": "MI0003930",
    "system_name": "LIVONIA",
    "display_name": "LIVONIA",
    "county": "WAYNE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 17,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003930",
    "resolved_pwsid": "MI0003930",
    "system_name": "LIVONIA",
    "display_name": "LIVONIA",
    "county": "WAYNE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 214,
    "inventory_lead": 134,
    "inventory_gpcl": 31,
    "inventory_unknown": 29973,
    "total_to_identify_or_replace": 30138,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0003930",
    "resolved_pwsid": "MI0003930",
    "system_name": "LIVONIA",
    "display_name": "LIVONIA",
    "county": "WAYNE",
    "monitoring_end_date": "2026-06-30",
    "year": 2026,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003940",
    "resolved_pwsid": "MI0003940",
    "system_name": "LOCH ALPINE SANITARY AUTHORITY",
    "display_name": "LOCH ALPINE SANITARY AUTHORITY",
    "county": "WASHTENAW",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003940",
    "resolved_pwsid": "MI0003940",
    "system_name": "LOCH ALPINE SANITARY AUTHORITY",
    "display_name": "LOCH ALPINE SANITARY AUTHORITY",
    "county": "WASHTENAW",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003940",
    "resolved_pwsid": "MI0003940",
    "system_name": "LOCH ALPINE SANITARY AUTHORITY",
    "display_name": "LOCH ALPINE SANITARY AUTHORITY",
    "county": "WASHTENAW",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 89,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003940",
    "resolved_pwsid": "MI0003940",
    "system_name": "LOCH ALPINE SANITARY AUTHORITY",
    "display_name": "LOCH ALPINE SANITARY AUTHORITY",
    "county": "WASHTENAW",
    "monitoring_end_date": "2024-06-30",
    "year": 2024,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003940",
    "resolved_pwsid": "MI0003940",
    "system_name": "LOCH ALPINE SANITARY AUTHORITY",
    "display_name": "LOCH ALPINE SANITARY AUTHORITY",
    "county": "WASHTENAW",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003940",
    "resolved_pwsid": "MI0003940",
    "system_name": "LOCH ALPINE SANITARY AUTHORITY",
    "display_name": "LOCH ALPINE SANITARY AUTHORITY",
    "county": "WASHTENAW",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 98,
    "total_to_identify_or_replace": 98,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0003942",
    "resolved_pwsid": "MI0003942",
    "system_name": "ISLAND LAKE APARTMENTS",
    "display_name": "ISLAND LAKE APARTMENTS",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 12,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003942",
    "resolved_pwsid": "MI0003942",
    "system_name": "ISLAND LAKE APARTMENTS",
    "display_name": "ISLAND LAKE APARTMENTS",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003942",
    "resolved_pwsid": "MI0003942",
    "system_name": "ISLAND LAKE APARTMENTS",
    "display_name": "ISLAND LAKE APARTMENTS",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003942",
    "resolved_pwsid": "MI0003942",
    "system_name": "ISLAND LAKE APARTMENTS",
    "display_name": "ISLAND LAKE APARTMENTS",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2021-06-30",
    "year": 2021,
    "lead_90th_ppb": 9,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003942",
    "resolved_pwsid": "MI0003942",
    "system_name": "ISLAND LAKE APARTMENTS",
    "display_name": "ISLAND LAKE APARTMENTS",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003942",
    "resolved_pwsid": "MI0003942",
    "system_name": "ISLAND LAKE APARTMENTS",
    "display_name": "ISLAND LAKE APARTMENTS",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003942",
    "resolved_pwsid": "MI0003942",
    "system_name": "ISLAND LAKE APARTMENTS",
    "display_name": "ISLAND LAKE APARTMENTS",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 10,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003942",
    "resolved_pwsid": "MI0003942",
    "system_name": "ISLAND LAKE APARTMENTS",
    "display_name": "ISLAND LAKE APARTMENTS",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2024-09-30",
    "year": 2024,
    "lead_90th_ppb": 18,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003942",
    "resolved_pwsid": "MI0003942",
    "system_name": "ISLAND LAKE APARTMENTS",
    "display_name": "ISLAND LAKE APARTMENTS",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 18,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003942",
    "resolved_pwsid": "MI0003942",
    "system_name": "ISLAND LAKE APARTMENTS",
    "display_name": "ISLAND LAKE APARTMENTS",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0003942",
    "resolved_pwsid": "MI0003942",
    "system_name": "ISLAND LAKE APARTMENTS",
    "display_name": "ISLAND LAKE APARTMENTS",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2026-06-30",
    "year": 2026,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003943",
    "resolved_pwsid": "MI0003943",
    "system_name": "LOCKPORT TOWNSHIP",
    "display_name": "LOCKPORT TOWNSHIP",
    "county": "ST JOSEPH",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003943",
    "resolved_pwsid": "MI0003943",
    "system_name": "LOCKPORT TOWNSHIP",
    "display_name": "LOCKPORT TOWNSHIP",
    "county": "ST JOSEPH",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003943",
    "resolved_pwsid": "MI0003943",
    "system_name": "LOCKPORT TOWNSHIP",
    "display_name": "LOCKPORT TOWNSHIP",
    "county": "ST. JOSEPH",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003946",
    "resolved_pwsid": "MI0003946",
    "system_name": "LOOKING GLASS TERRACES APTS.",
    "display_name": "LOOKING GLASS TERRACES APTS.",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003946",
    "resolved_pwsid": "MI0003946",
    "system_name": "LOOKING GLASS TERRACES APTS.",
    "display_name": "LOOKING GLASS TERRACES APTS.",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003946",
    "resolved_pwsid": "MI0003946",
    "system_name": "LOOKING GLASS TERRACES APTS.",
    "display_name": "LOOKING GLASS TERRACES APTS.",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003947",
    "resolved_pwsid": "MI0003947",
    "system_name": "LONG LAKE VILLAGE SUBDIVISION",
    "display_name": "LONG LAKE VILLAGE SUBDIVISION",
    "county": "OAKLAND",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003947",
    "resolved_pwsid": "MI0003947",
    "system_name": "LONG LAKE VILLAGE SUBDIVISION",
    "display_name": "LONG LAKE VILLAGE SUBDIVISION",
    "county": "OAKLAND",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003947",
    "resolved_pwsid": "MI0003947",
    "system_name": "LONG LAKE VILLAGE SUBDIVISION",
    "display_name": "LONG LAKE VILLAGE SUBDIVISION",
    "county": "OAKLAND",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003950",
    "resolved_pwsid": "MI0003950",
    "system_name": "LOWELL",
    "display_name": "LOWELL",
    "county": "KENT",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003950",
    "resolved_pwsid": "MI0003950",
    "system_name": "LOWELL",
    "display_name": "LOWELL",
    "county": "KENT",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003950",
    "resolved_pwsid": "MI0003950",
    "system_name": "LOWELL",
    "display_name": "LOWELL",
    "county": "KENT",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 3,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003950",
    "resolved_pwsid": "MI0003950",
    "system_name": "LOWELL",
    "display_name": "LOWELL",
    "county": "KENT",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 36,
    "inventory_lead": 11,
    "inventory_gpcl": 69,
    "inventory_unknown": 509,
    "total_to_identify_or_replace": 589,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0003950",
    "resolved_pwsid": "MI0003950",
    "system_name": "LOWELL",
    "display_name": "LOWELL",
    "county": "KENT",
    "monitoring_end_date": "2026-06-30",
    "year": 2026,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003950",
    "resolved_pwsid": "MI0003950",
    "system_name": "LOWELL",
    "display_name": "LOWELL",
    "county": "KENT",
    "monitoring_end_date": "",
    "year": 2021,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 3,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003950",
    "resolved_pwsid": "MI0003950",
    "system_name": "LOWELL",
    "display_name": "LOWELL",
    "county": "KENT",
    "monitoring_end_date": "",
    "year": 2023,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 29,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003950",
    "resolved_pwsid": "MI0003950",
    "system_name": "LOWELL",
    "display_name": "LOWELL",
    "county": "KENT",
    "monitoring_end_date": "",
    "year": 2024,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 32,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003955",
    "resolved_pwsid": "MI0003955",
    "system_name": "LOWELL TOWNSHIP",
    "display_name": "LOWELL TOWNSHIP",
    "county": "KENT",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003955",
    "resolved_pwsid": "MI0003955",
    "system_name": "LOWELL TOWNSHIP",
    "display_name": "LOWELL TOWNSHIP",
    "county": "KENT",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003955",
    "resolved_pwsid": "MI0003955",
    "system_name": "LOWELL TOWNSHIP",
    "display_name": "LOWELL TOWNSHIP",
    "county": "KENT",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003955",
    "resolved_pwsid": "MI0003955",
    "system_name": "LOWELL TOWNSHIP",
    "display_name": "LOWELL TOWNSHIP",
    "county": "KENT",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0003960",
    "resolved_pwsid": "MI0003960-b",
    "system_name": "LUDINGTON, CITY OF",
    "display_name": "LUDINGTON, CITY OF",
    "county": "MASON",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003960",
    "resolved_pwsid": "MI0003960-b",
    "system_name": "LUDINGTON, CITY OF",
    "display_name": "LUDINGTON, CITY OF",
    "county": "MASON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003960",
    "resolved_pwsid": "MI0003960-a",
    "system_name": "LUDINGTON",
    "display_name": "LUDINGTON",
    "county": "MASON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 68,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003960",
    "resolved_pwsid": "MI0003960",
    "system_name": "LUDINGTON, CITY OF",
    "display_name": "LUDINGTON, CITY OF",
    "county": "MASON",
    "monitoring_end_date": "",
    "year": 2021,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 95,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003960",
    "resolved_pwsid": "MI0003960",
    "system_name": "LUDINGTON, CITY OF",
    "display_name": "LUDINGTON, CITY OF",
    "county": "MASON",
    "monitoring_end_date": "",
    "year": 2022,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 65,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003960",
    "resolved_pwsid": "MI0003960",
    "system_name": "LUDINGTON, CITY OF",
    "display_name": "LUDINGTON, CITY OF",
    "county": "MASON",
    "monitoring_end_date": "",
    "year": 2024,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 49,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003960",
    "resolved_pwsid": "MI0003960",
    "system_name": "LUDINGTON, CITY OF",
    "display_name": "LUDINGTON, CITY OF",
    "county": "MASON",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 37,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003966",
    "resolved_pwsid": "MI0003966",
    "system_name": "LYNX GOLF VIEW",
    "display_name": "LYNX GOLF VIEW",
    "county": "ALLEGAN",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003966",
    "resolved_pwsid": "MI0003966",
    "system_name": "LYNX GOLF VIEW",
    "display_name": "LYNX GOLF VIEW",
    "county": "ALLEGAN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003966",
    "resolved_pwsid": "MI0003966",
    "system_name": "LYNX GOLF VIEW",
    "display_name": "LYNX GOLF VIEW",
    "county": "ALLEGAN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003967",
    "resolved_pwsid": "MI0003967",
    "system_name": "LYONS",
    "display_name": "LYONS",
    "county": "IONIA",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003967",
    "resolved_pwsid": "MI0003967",
    "system_name": "LYONS",
    "display_name": "LYONS",
    "county": "IONIA",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003967",
    "resolved_pwsid": "MI0003967",
    "system_name": "LYONS",
    "display_name": "LYONS",
    "county": "IONIA",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003968",
    "resolved_pwsid": "MI0003968",
    "system_name": "LYON TOWNSHIP",
    "display_name": "LYON TOWNSHIP",
    "county": "OAKLAND",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003968",
    "resolved_pwsid": "MI0003968",
    "system_name": "LYON TOWNSHIP",
    "display_name": "LYON TOWNSHIP",
    "county": "OAKLAND",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003968",
    "resolved_pwsid": "MI0003968",
    "system_name": "LYON TOWNSHIP",
    "display_name": "LYON TOWNSHIP",
    "county": "OAKLAND",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003968",
    "resolved_pwsid": "MI0003968",
    "system_name": "LYON TOWNSHIP",
    "display_name": "LYON TOWNSHIP",
    "county": "OAKLAND",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003968",
    "resolved_pwsid": "MI0003968",
    "system_name": "LYON TOWNSHIP",
    "display_name": "LYON TOWNSHIP",
    "county": "OAKLAND",
    "monitoring_end_date": "2024-06-30",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003968",
    "resolved_pwsid": "MI0003968",
    "system_name": "LYON TOWNSHIP",
    "display_name": "LYON TOWNSHIP",
    "county": "OAKLAND",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003968",
    "resolved_pwsid": "MI0003968",
    "system_name": "LYON TOWNSHIP",
    "display_name": "LYON TOWNSHIP",
    "county": "OAKLAND",
    "monitoring_end_date": "2025-06-30",
    "year": 2025,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 3,
    "inventory_gpcl": 0,
    "inventory_unknown": 67,
    "total_to_identify_or_replace": 70,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0003970",
    "resolved_pwsid": "MI0003970",
    "system_name": "MACKINAC ISLAND",
    "display_name": "MACKINAC ISLAND",
    "county": "MACKINAC",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003970",
    "resolved_pwsid": "MI0003970",
    "system_name": "MACKINAC ISLAND",
    "display_name": "MACKINAC ISLAND",
    "county": "MACKINAC",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003970",
    "resolved_pwsid": "MI0003970",
    "system_name": "MACKINAC ISLAND",
    "display_name": "MACKINAC ISLAND",
    "county": "MACKINAC",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003970",
    "resolved_pwsid": "MI0003970",
    "system_name": "MACKINAC ISLAND",
    "display_name": "MACKINAC ISLAND",
    "county": "MACKINAC",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003980",
    "resolved_pwsid": "MI0003980",
    "system_name": "MACKINAW CITY, VILLAGE OF",
    "display_name": "MACKINAW CITY, VILLAGE OF",
    "county": "CHEBOYGAN",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003980",
    "resolved_pwsid": "MI0003980",
    "system_name": "MACKINAW CITY, VILLAGE OF",
    "display_name": "MACKINAW CITY, VILLAGE OF",
    "county": "CHEBOYGAN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003980",
    "resolved_pwsid": "MI0003980",
    "system_name": "MACKINAW CITY, VILLAGE OF",
    "display_name": "MACKINAW CITY, VILLAGE OF",
    "county": "CHEBOYGAN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 5,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003980",
    "resolved_pwsid": "MI0003980",
    "system_name": "MACKINAW CITY, VILLAGE OF",
    "display_name": "MACKINAW CITY, VILLAGE OF",
    "county": "CHEBOYGAN",
    "monitoring_end_date": "",
    "year": 2022,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003980",
    "resolved_pwsid": "MI0003980",
    "system_name": "MACKINAW CITY, VILLAGE OF",
    "display_name": "MACKINAW CITY, VILLAGE OF",
    "county": "CHEBOYGAN",
    "monitoring_end_date": "",
    "year": 2023,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 5,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003980",
    "resolved_pwsid": "MI0003980",
    "system_name": "MACKINAW CITY, VILLAGE OF",
    "display_name": "MACKINAW CITY, VILLAGE OF",
    "county": "CHEBOYGAN",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 5,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003990",
    "resolved_pwsid": "MI0003990",
    "system_name": "MACOMB TOWNSHIP",
    "display_name": "MACOMB TOWNSHIP",
    "county": "MACOMB",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003990",
    "resolved_pwsid": "MI0003990",
    "system_name": "MACOMB TOWNSHIP",
    "display_name": "MACOMB TOWNSHIP",
    "county": "MACOMB",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003990",
    "resolved_pwsid": "MI0003990",
    "system_name": "MACOMB TOWNSHIP",
    "display_name": "MACOMB TOWNSHIP",
    "county": "MACOMB",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003990",
    "resolved_pwsid": "MI0003990",
    "system_name": "MACOMB TOWNSHIP",
    "display_name": "MACOMB TOWNSHIP",
    "county": "MACOMB",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003990",
    "resolved_pwsid": "MI0003990",
    "system_name": "MACOMB TOWNSHIP",
    "display_name": "MACOMB TOWNSHIP",
    "county": "MACOMB",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003990",
    "resolved_pwsid": "MI0003990",
    "system_name": "MACOMB TOWNSHIP",
    "display_name": "MACOMB TOWNSHIP",
    "county": "MACOMB",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003990",
    "resolved_pwsid": "MI0003990",
    "system_name": "MACOMB TOWNSHIP",
    "display_name": "MACOMB TOWNSHIP",
    "county": "MACOMB",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0003990",
    "resolved_pwsid": "MI0003990",
    "system_name": "MACOMB TOWNSHIP",
    "display_name": "MACOMB TOWNSHIP",
    "county": "MACOMB",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0004000",
    "resolved_pwsid": "MI0004000",
    "system_name": "MADISON HEIGHTS",
    "display_name": "MADISON HEIGHTS",
    "county": "OAKLAND",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004000",
    "resolved_pwsid": "MI0004000",
    "system_name": "MADISON HEIGHTS",
    "display_name": "MADISON HEIGHTS",
    "county": "OAKLAND",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 14,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004000",
    "resolved_pwsid": "MI0004000",
    "system_name": "MADISON HEIGHTS",
    "display_name": "MADISON HEIGHTS",
    "county": "OAKLAND",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 13,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004000",
    "resolved_pwsid": "MI0004000",
    "system_name": "MADISON HEIGHTS",
    "display_name": "MADISON HEIGHTS",
    "county": "OAKLAND",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": 8,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004000",
    "resolved_pwsid": "MI0004000",
    "system_name": "MADISON HEIGHTS",
    "display_name": "MADISON HEIGHTS",
    "county": "OAKLAND",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 12,
    "above_action_level": false,
    "lines_replaced": 7,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004000",
    "resolved_pwsid": "MI0004000",
    "system_name": "MADISON HEIGHTS",
    "display_name": "MADISON HEIGHTS",
    "county": "OAKLAND",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 11,
    "above_action_level": false,
    "lines_replaced": 7,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004000",
    "resolved_pwsid": "MI0004000",
    "system_name": "MADISON HEIGHTS",
    "display_name": "MADISON HEIGHTS",
    "county": "OAKLAND",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": 6,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004000",
    "resolved_pwsid": "MI0004000",
    "system_name": "MADISON HEIGHTS",
    "display_name": "MADISON HEIGHTS",
    "county": "OAKLAND",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 18,
    "above_action_level": true,
    "lines_replaced": 21,
    "inventory_lead": 232,
    "inventory_gpcl": 0,
    "inventory_unknown": 15,
    "total_to_identify_or_replace": 247,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0004000",
    "resolved_pwsid": "MI0004000",
    "system_name": "MADISON HEIGHTS",
    "display_name": "MADISON HEIGHTS",
    "county": "OAKLAND",
    "monitoring_end_date": "2026-06-30",
    "year": 2026,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004006",
    "resolved_pwsid": "MI0004006",
    "system_name": "MADISON TOWNSHIP",
    "display_name": "MADISON TOWNSHIP",
    "county": "LENAWEE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004006",
    "resolved_pwsid": "MI0004006",
    "system_name": "MADISON TOWNSHIP",
    "display_name": "MADISON TOWNSHIP",
    "county": "LENAWEE",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004006",
    "resolved_pwsid": "MI0004006",
    "system_name": "MADISON TOWNSHIP",
    "display_name": "MADISON TOWNSHIP",
    "county": "LENAWEE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004006",
    "resolved_pwsid": "MI0004006",
    "system_name": "MADISON TOWNSHIP",
    "display_name": "MADISON TOWNSHIP",
    "county": "LENAWEE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004010",
    "resolved_pwsid": "MI0004010",
    "system_name": "MANCELONA AREA WATER AND SEWER AUTHORITY",
    "display_name": "MANCELONA AREA WATER AND SEWER AUTHORITY",
    "county": "ANTRIM",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004010",
    "resolved_pwsid": "MI0004010",
    "system_name": "MANCELONA AREA WATER AND SEWER AUTHORITY",
    "display_name": "MANCELONA AREA WATER AND SEWER AUTHORITY",
    "county": "ANTRIM",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004010",
    "resolved_pwsid": "MI0004010",
    "system_name": "MANCELONA AREA WATER AND SEWER AUTHORITY",
    "display_name": "MANCELONA AREA WATER AND SEWER AUTHORITY",
    "county": "ANTRIM",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004010",
    "resolved_pwsid": "MI0004010",
    "system_name": "MANCELONA AREA WATER AND SEWER AUTHORITY",
    "display_name": "MANCELONA AREA WATER AND SEWER AUTHORITY",
    "county": "ANTRIM",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 27,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004010",
    "resolved_pwsid": "MI0004010",
    "system_name": "MANCELONA AREA WATER AND SEWER AUTHORITY",
    "display_name": "MANCELONA AREA WATER AND SEWER AUTHORITY",
    "county": "ANTRIM",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 9,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004010",
    "resolved_pwsid": "MI0004010",
    "system_name": "MANCELONA AREA WATER AND SEWER AUTHORITY",
    "display_name": "MANCELONA AREA WATER AND SEWER AUTHORITY",
    "county": "ANTRIM",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": 8,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004010",
    "resolved_pwsid": "MI0004010",
    "system_name": "MANCELONA AREA WATER AND SEWER AUTHORITY",
    "display_name": "MANCELONA AREA WATER AND SEWER AUTHORITY",
    "county": "ANTRIM",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 14,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004010",
    "resolved_pwsid": "MI0004010",
    "system_name": "MANCELONA AREA WATER AND SEWER AUTHORITY",
    "display_name": "MANCELONA AREA WATER AND SEWER AUTHORITY",
    "county": "ANTRIM",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 21,
    "inventory_lead": 0,
    "inventory_gpcl": 334,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 334,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0004020",
    "resolved_pwsid": "MI0004020",
    "system_name": "MANCHESTER",
    "display_name": "MANCHESTER",
    "county": "WASHTENAW",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004020",
    "resolved_pwsid": "MI0004020",
    "system_name": "MANCHESTER",
    "display_name": "MANCHESTER",
    "county": "WASHTENAW",
    "monitoring_end_date": "2021-09-30",
    "year": 2021,
    "lead_90th_ppb": 31,
    "above_action_level": true,
    "lines_replaced": 12,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004020",
    "resolved_pwsid": "MI0004020",
    "system_name": "MANCHESTER",
    "display_name": "MANCHESTER",
    "county": "WASHTENAW",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 31,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004020",
    "resolved_pwsid": "MI0004020",
    "system_name": "MANCHESTER",
    "display_name": "MANCHESTER",
    "county": "WASHTENAW",
    "monitoring_end_date": "2022-06-30",
    "year": 2022,
    "lead_90th_ppb": 15,
    "above_action_level": true,
    "lines_replaced": 13,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004020",
    "resolved_pwsid": "MI0004020",
    "system_name": "MANCHESTER",
    "display_name": "MANCHESTER",
    "county": "WASHTENAW",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 11,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004020",
    "resolved_pwsid": "MI0004020",
    "system_name": "MANCHESTER",
    "display_name": "MANCHESTER",
    "county": "WASHTENAW",
    "monitoring_end_date": "2023-06-30",
    "year": 2023,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": 20,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004020",
    "resolved_pwsid": "MI0004020",
    "system_name": "MANCHESTER",
    "display_name": "MANCHESTER",
    "county": "WASHTENAW",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 57,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004020",
    "resolved_pwsid": "MI0004020",
    "system_name": "MANCHESTER",
    "display_name": "MANCHESTER",
    "county": "WASHTENAW",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 38,
    "inventory_gpcl": 19,
    "inventory_unknown": 1,
    "total_to_identify_or_replace": 58,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0004025",
    "resolved_pwsid": "MI0004025",
    "system_name": "MARQUETTE COUNTY CORRECTIONS CENTER",
    "display_name": "MARQUETTE COUNTY CORRECTIONS CENTER",
    "county": "MARQUETTE",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004025",
    "resolved_pwsid": "MI0004025",
    "system_name": "MARQUETTE COUNTY CORRECTIONS CENTER",
    "display_name": "MARQUETTE COUNTY CORRECTIONS CENTER",
    "county": "MARQUETTE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004025",
    "resolved_pwsid": "MI0004025",
    "system_name": "MARQUETTE COUNTY CORRECTIONS CENTER",
    "display_name": "MARQUETTE COUNTY CORRECTIONS CENTER",
    "county": "MARQUETTE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 11,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004030",
    "resolved_pwsid": "MI0004030",
    "system_name": "MANISTEE, CITY OF",
    "display_name": "MANISTEE, CITY OF",
    "county": "MANISTEE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004030",
    "resolved_pwsid": "MI0004030",
    "system_name": "MANISTEE, CITY OF",
    "display_name": "MANISTEE, CITY OF",
    "county": "MANISTEE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004030",
    "resolved_pwsid": "MI0004030",
    "system_name": "MANISTEE, CITY OF",
    "display_name": "MANISTEE, CITY OF",
    "county": "MANISTEE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004030",
    "resolved_pwsid": "MI0004030",
    "system_name": "MANISTEE, CITY OF",
    "display_name": "MANISTEE, CITY OF",
    "county": "MANISTEE",
    "monitoring_end_date": "2021-09-30",
    "year": 2021,
    "lead_90th_ppb": 28,
    "above_action_level": true,
    "lines_replaced": 3,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004030",
    "resolved_pwsid": "MI0004030",
    "system_name": "MANISTEE, CITY OF",
    "display_name": "MANISTEE, CITY OF",
    "county": "MANISTEE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 28,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004030",
    "resolved_pwsid": "MI0004030",
    "system_name": "MANISTEE, CITY OF",
    "display_name": "MANISTEE, CITY OF",
    "county": "MANISTEE",
    "monitoring_end_date": "2022-06-30",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 4,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004030",
    "resolved_pwsid": "MI0004030",
    "system_name": "MANISTEE, CITY OF",
    "display_name": "MANISTEE, CITY OF",
    "county": "MANISTEE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 19,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004030",
    "resolved_pwsid": "MI0004030",
    "system_name": "MANISTEE, CITY OF",
    "display_name": "MANISTEE, CITY OF",
    "county": "MANISTEE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 23,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004030",
    "resolved_pwsid": "MI0004030",
    "system_name": "MANISTEE, CITY OF",
    "display_name": "MANISTEE, CITY OF",
    "county": "MANISTEE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 27,
    "inventory_lead": 257,
    "inventory_gpcl": 541,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 798,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0004040",
    "resolved_pwsid": "MI0004040",
    "system_name": "MANISTIQUE",
    "display_name": "MANISTIQUE",
    "county": "SCHOOLCRAFT",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004040",
    "resolved_pwsid": "MI0004040",
    "system_name": "MANISTIQUE",
    "display_name": "MANISTIQUE",
    "county": "SCHOOLCRAFT",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004040",
    "resolved_pwsid": "MI0004040",
    "system_name": "MANISTIQUE",
    "display_name": "MANISTIQUE",
    "county": "SCHOOLCRAFT",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004040",
    "resolved_pwsid": "MI0004040",
    "system_name": "MANISTIQUE",
    "display_name": "MANISTIQUE",
    "county": "SCHOOLCRAFT",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 12,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004040",
    "resolved_pwsid": "MI0004040",
    "system_name": "MANISTIQUE",
    "display_name": "MANISTIQUE",
    "county": "SCHOOLCRAFT",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 4,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004040",
    "resolved_pwsid": "MI0004040",
    "system_name": "MANISTIQUE",
    "display_name": "MANISTIQUE",
    "county": "SCHOOLCRAFT",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 6,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004040",
    "resolved_pwsid": "MI0004040",
    "system_name": "MANISTIQUE",
    "display_name": "MANISTIQUE",
    "county": "SCHOOLCRAFT",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 7,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004040",
    "resolved_pwsid": "MI0004040",
    "system_name": "MANISTIQUE",
    "display_name": "MANISTIQUE",
    "county": "SCHOOLCRAFT",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 5,
    "inventory_lead": 0,
    "inventory_gpcl": 81,
    "inventory_unknown": 685,
    "total_to_identify_or_replace": 766,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0004042",
    "resolved_pwsid": "MI0004042",
    "system_name": "MANITOU LAKE APARTMENTS",
    "display_name": "MANITOU LAKE APARTMENTS",
    "county": "OAKLAND",
    "monitoring_end_date": "2017-06-30",
    "year": 2017,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004042",
    "resolved_pwsid": "MI0004042",
    "system_name": "MANITOU LAKE APARTMENTS",
    "display_name": "MANITOU LAKE APARTMENTS",
    "county": "OAKLAND",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004042",
    "resolved_pwsid": "MI0004042",
    "system_name": "MANITOU LAKE APARTMENTS",
    "display_name": "MANITOU LAKE APARTMENTS",
    "county": "OAKLAND",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004045",
    "resolved_pwsid": "MI0004045",
    "system_name": "COUNTRY EDEN  L.L.C.",
    "display_name": "COUNTRY EDEN  L.L.C.",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004045",
    "resolved_pwsid": "MI0004045",
    "system_name": "COUNTRY EDEN  L.L.C.",
    "display_name": "COUNTRY EDEN  L.L.C.",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004045",
    "resolved_pwsid": "MI0004045",
    "system_name": "COUNTRY EDEN  L.L.C.",
    "display_name": "COUNTRY EDEN  L.L.C.",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004045",
    "resolved_pwsid": "MI0004045",
    "system_name": "COUNTRY EDEN  L.L.C.",
    "display_name": "COUNTRY EDEN  L.L.C.",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0004050",
    "resolved_pwsid": "MI0004050",
    "system_name": "MANTON, CITY OF",
    "display_name": "MANTON, CITY OF",
    "county": "WEXFORD",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004050",
    "resolved_pwsid": "MI0004050",
    "system_name": "MANTON, CITY OF",
    "display_name": "MANTON, CITY OF",
    "county": "WEXFORD",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004050",
    "resolved_pwsid": "MI0004050",
    "system_name": "MANTON, CITY OF",
    "display_name": "MANTON, CITY OF",
    "county": "WEXFORD",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": 3,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004050",
    "resolved_pwsid": "MI0004050",
    "system_name": "MANTON, CITY OF",
    "display_name": "MANTON, CITY OF",
    "county": "WEXFORD",
    "monitoring_end_date": "",
    "year": 2022,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004050",
    "resolved_pwsid": "MI0004050",
    "system_name": "MANTON, CITY OF",
    "display_name": "MANTON, CITY OF",
    "county": "WEXFORD",
    "monitoring_end_date": "",
    "year": 2023,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 5,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004050",
    "resolved_pwsid": "MI0004050",
    "system_name": "MANTON, CITY OF",
    "display_name": "MANTON, CITY OF",
    "county": "WEXFORD",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 4,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004053",
    "resolved_pwsid": "MI0004053",
    "system_name": "MAPLE GROVE APARTMENTS",
    "display_name": "MAPLE GROVE APARTMENTS",
    "county": "ROSCOMMON",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004053",
    "resolved_pwsid": "MI0004053",
    "system_name": "MAPLE GROVE APARTMENTS",
    "display_name": "MAPLE GROVE APARTMENTS",
    "county": "ROSCOMMON",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004053",
    "resolved_pwsid": "MI0004053",
    "system_name": "MAPLE GROVE APARTMENTS",
    "display_name": "MAPLE GROVE APARTMENTS",
    "county": "ROSCOMMON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004060",
    "resolved_pwsid": "MI0004060",
    "system_name": "MAPLE RAPIDS, VILLAGE OF",
    "display_name": "MAPLE RAPIDS, VILLAGE OF",
    "county": "CLINTON",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004060",
    "resolved_pwsid": "MI0004060",
    "system_name": "MAPLE RAPIDS, VILLAGE OF",
    "display_name": "MAPLE RAPIDS, VILLAGE OF",
    "county": "CLINTON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004060",
    "resolved_pwsid": "MI0004060",
    "system_name": "MAPLE RAPIDS, VILLAGE OF",
    "display_name": "MAPLE RAPIDS, VILLAGE OF",
    "county": "CLINTON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004063",
    "resolved_pwsid": "MI0004063",
    "system_name": "MAPLE RIDGE TOWNSHIP",
    "display_name": "MAPLE RIDGE TOWNSHIP",
    "county": "DELTA",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004063",
    "resolved_pwsid": "MI0004063",
    "system_name": "MAPLE RIDGE TOWNSHIP",
    "display_name": "MAPLE RIDGE TOWNSHIP",
    "county": "DELTA",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004063",
    "resolved_pwsid": "MI0004063",
    "system_name": "MAPLE RIDGE TOWNSHIP",
    "display_name": "MAPLE RIDGE TOWNSHIP",
    "county": "DELTA",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004069",
    "resolved_pwsid": "MI0004069",
    "system_name": "MAPLEWOOD RIDGE CONDOMINIUMS",
    "display_name": "MAPLEWOOD RIDGE CONDOMINIUMS",
    "county": "ANTRIM",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004069",
    "resolved_pwsid": "MI0004069",
    "system_name": "MAPLEWOOD RIDGE CONDOMINIUMS",
    "display_name": "MAPLEWOOD RIDGE CONDOMINIUMS",
    "county": "ANTRIM",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 9,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004069",
    "resolved_pwsid": "MI0004069",
    "system_name": "MAPLEWOOD RIDGE CONDOMINIUMS",
    "display_name": "MAPLEWOOD RIDGE CONDOMINIUMS",
    "county": "ANTRIM",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004069",
    "resolved_pwsid": "MI0004069",
    "system_name": "MAPLEWOOD RIDGE CONDOMINIUMS",
    "display_name": "MAPLEWOOD RIDGE CONDOMINIUMS",
    "county": "ANTRIM",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0004070",
    "resolved_pwsid": "MI0004070",
    "system_name": "MARCELLUS",
    "display_name": "MARCELLUS",
    "county": "CASS",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004070",
    "resolved_pwsid": "MI0004070",
    "system_name": "MARCELLUS",
    "display_name": "MARCELLUS",
    "county": "CASS",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004070",
    "resolved_pwsid": "MI0004070",
    "system_name": "MARCELLUS",
    "display_name": "MARCELLUS",
    "county": "CASS",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004070",
    "resolved_pwsid": "MI0004070",
    "system_name": "MARCELLUS",
    "display_name": "MARCELLUS",
    "county": "CASS",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004070",
    "resolved_pwsid": "MI0004070",
    "system_name": "MARCELLUS",
    "display_name": "MARCELLUS",
    "county": "CASS",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004070",
    "resolved_pwsid": "MI0004070",
    "system_name": "MARCELLUS",
    "display_name": "MARCELLUS",
    "county": "CASS",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": 126,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004070",
    "resolved_pwsid": "MI0004070",
    "system_name": "MARCELLUS",
    "display_name": "MARCELLUS",
    "county": "CASS",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": 223,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004070",
    "resolved_pwsid": "MI0004070",
    "system_name": "MARCELLUS",
    "display_name": "MARCELLUS",
    "county": "CASS",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0004070",
    "resolved_pwsid": "MI0004070",
    "system_name": "MARCELLUS",
    "display_name": "MARCELLUS",
    "county": "CASS",
    "monitoring_end_date": "2026-06-30",
    "year": 2026,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004080",
    "resolved_pwsid": "MI0004080",
    "system_name": "MARENISCO TOWNSHIP",
    "display_name": "MARENISCO TOWNSHIP",
    "county": "GOGEBIC",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004080",
    "resolved_pwsid": "MI0004080",
    "system_name": "MARENISCO TOWNSHIP",
    "display_name": "MARENISCO TOWNSHIP",
    "county": "GOGEBIC",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004080",
    "resolved_pwsid": "MI0004080",
    "system_name": "MARENISCO TOWNSHIP",
    "display_name": "MARENISCO TOWNSHIP",
    "county": "GOGEBIC",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004090",
    "resolved_pwsid": "MI0004090",
    "system_name": "MARINE CITY",
    "display_name": "MARINE CITY",
    "county": "ST CLAIR",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004090",
    "resolved_pwsid": "MI0004090",
    "system_name": "MARINE CITY",
    "display_name": "MARINE CITY",
    "county": "ST CLAIR",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004090",
    "resolved_pwsid": "MI0004090",
    "system_name": "MARINE CITY",
    "display_name": "MARINE CITY",
    "county": "ST. CLAIR",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004090",
    "resolved_pwsid": "MI0004090",
    "system_name": "MARINE CITY",
    "display_name": "MARINE CITY",
    "county": "ST CLAIR",
    "monitoring_end_date": "",
    "year": 2021,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 26,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004090",
    "resolved_pwsid": "MI0004090",
    "system_name": "MARINE CITY",
    "display_name": "MARINE CITY",
    "county": "ST CLAIR",
    "monitoring_end_date": "",
    "year": 2022,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 20,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004090",
    "resolved_pwsid": "MI0004090",
    "system_name": "MARINE CITY",
    "display_name": "MARINE CITY",
    "county": "ST CLAIR",
    "monitoring_end_date": "",
    "year": 2024,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 6,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004090",
    "resolved_pwsid": "MI0004090",
    "system_name": "MARINE CITY",
    "display_name": "MARINE CITY",
    "county": "ST CLAIR",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 92,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004095",
    "resolved_pwsid": "MI0004095",
    "system_name": "RIVERFRONT CONDOS OF NILES",
    "display_name": "RIVERFRONT CONDOS OF NILES",
    "county": "BERRIEN",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 14,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004095",
    "resolved_pwsid": "MI0004095",
    "system_name": "RIVERFRONT CONDOS OF NILES",
    "display_name": "RIVERFRONT CONDOS OF NILES",
    "county": "BERRIEN",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004095",
    "resolved_pwsid": "MI0004095",
    "system_name": "RIVERFRONT CONDOS OF NILES",
    "display_name": "RIVERFRONT CONDOS OF NILES",
    "county": "BERRIEN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004095",
    "resolved_pwsid": "MI0004095",
    "system_name": "RIVERFRONT CONDOS OF NILES",
    "display_name": "RIVERFRONT CONDOS OF NILES",
    "county": "BERRIEN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004095",
    "resolved_pwsid": "MI0004095",
    "system_name": "RIVERFRONT CONDOS OF NILES",
    "display_name": "RIVERFRONT CONDOS OF NILES",
    "county": "BERRIEN",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0004098",
    "resolved_pwsid": "MI0004098",
    "system_name": "MHOG SEWER & WATER AUTHORITY",
    "display_name": "MHOG SEWER & WATER AUTHORITY",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004098",
    "resolved_pwsid": "MI0004098",
    "system_name": "MHOG SEWER & WATER AUTHORITY",
    "display_name": "MHOG SEWER & WATER AUTHORITY",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004098",
    "resolved_pwsid": "MI0004098",
    "system_name": "MHOG SEWER & WATER AUTHORITY",
    "display_name": "MHOG SEWER & WATER AUTHORITY",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004100",
    "resolved_pwsid": "MI0004100",
    "system_name": "MARION, VILLAGE OF",
    "display_name": "MARION, VILLAGE OF",
    "county": "OSCEOLA",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004100",
    "resolved_pwsid": "MI0004100",
    "system_name": "MARION, VILLAGE OF",
    "display_name": "MARION, VILLAGE OF",
    "county": "OSCEOLA",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004100",
    "resolved_pwsid": "MI0004100",
    "system_name": "MARION, VILLAGE OF",
    "display_name": "MARION, VILLAGE OF",
    "county": "OSCEOLA",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004100",
    "resolved_pwsid": "MI0004100",
    "system_name": "MARION, VILLAGE OF",
    "display_name": "MARION, VILLAGE OF",
    "county": "OSCEOLA",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004100",
    "resolved_pwsid": "MI0004100",
    "system_name": "MARION, VILLAGE OF",
    "display_name": "MARION, VILLAGE OF",
    "county": "OSCEOLA",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 2,
    "inventory_lead": 4,
    "inventory_gpcl": 26,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 30,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0004100",
    "resolved_pwsid": "MI0004100",
    "system_name": "MARION, VILLAGE OF",
    "display_name": "MARION, VILLAGE OF",
    "county": "OSCEOLA",
    "monitoring_end_date": "",
    "year": 2021,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004100",
    "resolved_pwsid": "MI0004100",
    "system_name": "MARION, VILLAGE OF",
    "display_name": "MARION, VILLAGE OF",
    "county": "OSCEOLA",
    "monitoring_end_date": "",
    "year": 2024,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 5,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004110",
    "resolved_pwsid": "MI0004110",
    "system_name": "MARLETTE, CITY OF",
    "display_name": "MARLETTE, CITY OF",
    "county": "SANILAC",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004110",
    "resolved_pwsid": "MI0004110",
    "system_name": "MARLETTE, CITY OF",
    "display_name": "MARLETTE, CITY OF",
    "county": "SANILAC",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 9,
    "above_action_level": false,
    "lines_replaced": 5,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004110",
    "resolved_pwsid": "MI0004110",
    "system_name": "MARLETTE, CITY OF",
    "display_name": "MARLETTE, CITY OF",
    "county": "SANILAC",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004120",
    "resolved_pwsid": "MI0004120",
    "system_name": "MARQUETTE",
    "display_name": "MARQUETTE",
    "county": "MARQUETTE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 11,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004120",
    "resolved_pwsid": "MI0004120",
    "system_name": "MARQUETTE",
    "display_name": "MARQUETTE",
    "county": "MARQUETTE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 11,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004120",
    "resolved_pwsid": "MI0004120",
    "system_name": "MARQUETTE",
    "display_name": "MARQUETTE",
    "county": "MARQUETTE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004120",
    "resolved_pwsid": "MI0004120",
    "system_name": "MARQUETTE",
    "display_name": "MARQUETTE",
    "county": "MARQUETTE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": 106,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004120",
    "resolved_pwsid": "MI0004120",
    "system_name": "MARQUETTE",
    "display_name": "MARQUETTE",
    "county": "MARQUETTE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004120",
    "resolved_pwsid": "MI0004120",
    "system_name": "MARQUETTE",
    "display_name": "MARQUETTE",
    "county": "MARQUETTE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004120",
    "resolved_pwsid": "MI0004120",
    "system_name": "MARQUETTE",
    "display_name": "MARQUETTE",
    "county": "MARQUETTE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004120",
    "resolved_pwsid": "MI0004120",
    "system_name": "MARQUETTE",
    "display_name": "MARQUETTE",
    "county": "MARQUETTE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 19,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 543,
    "total_to_identify_or_replace": 543,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0004120",
    "resolved_pwsid": "MI0004120",
    "system_name": "MARQUETTE",
    "display_name": "MARQUETTE",
    "county": "MARQUETTE",
    "monitoring_end_date": "2026-06-30",
    "year": 2026,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004140",
    "resolved_pwsid": "MI0004140-a",
    "system_name": "MARQUETTE TOWNSHIP",
    "display_name": "MARQUETTE TOWNSHIP",
    "county": "MARQUETTE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004140",
    "resolved_pwsid": "MI0004140-a",
    "system_name": "MARQUETTE TOWNSHIP",
    "display_name": "MARQUETTE TOWNSHIP",
    "county": "MARQUETTE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004140",
    "resolved_pwsid": "MI0004140-d",
    "system_name": "MARQUETTE TOWNSHIP (MARQUETTE)",
    "display_name": "MARQUETTE TOWNSHIP (MARQUETTE)",
    "county": "MARQUETTE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004140",
    "resolved_pwsid": "MI0004140-e",
    "system_name": "MARQUETTE TOWNSHIP (WELLS)",
    "display_name": "MARQUETTE TOWNSHIP (WELLS)",
    "county": "MARQUETTE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004140",
    "resolved_pwsid": "MI0004140-a",
    "system_name": "MARQUETTE TOWNSHIP",
    "display_name": "MARQUETTE TOWNSHIP",
    "county": "MARQUETTE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004140",
    "resolved_pwsid": "MI0004140-d",
    "system_name": "MARQUETTE TOWNSHIP (MARQUETTE)",
    "display_name": "MARQUETTE TOWNSHIP (MARQUETTE)",
    "county": "MARQUETTE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004140",
    "resolved_pwsid": "MI0004140-e",
    "system_name": "MARQUETTE TOWNSHIP (WELLS)",
    "display_name": "MARQUETTE TOWNSHIP (WELLS)",
    "county": "MARQUETTE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004140",
    "resolved_pwsid": "MI0004140-d",
    "system_name": "MARQUETTE TOWNSHIP (MARQUETTE)",
    "display_name": "MARQUETTE TOWNSHIP (MARQUETTE)",
    "county": "MARQUETTE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004140",
    "resolved_pwsid": "MI0004140-d",
    "system_name": "MARQUETTE TOWNSHIP (MARQUETTE)",
    "display_name": "MARQUETTE TOWNSHIP (MARQUETTE)",
    "county": "MARQUETTE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004140",
    "resolved_pwsid": "MI0004140-b",
    "system_name": "MARQUETTE TOWNSHIP (DIST)",
    "display_name": "MARQUETTE TOWNSHIP (DIST)",
    "county": "MARQUETTE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004140",
    "resolved_pwsid": "MI0004140-c",
    "system_name": "MARQUETTE TOWNSHIP (DIST2)",
    "display_name": "MARQUETTE TOWNSHIP (DIST2)",
    "county": "MARQUETTE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004140",
    "resolved_pwsid": "MI0004140-g",
    "system_name": "MARQUETTE TOWNSHIP (DS002)",
    "display_name": "MARQUETTE TOWNSHIP (DS002)",
    "county": "MARQUETTE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004140",
    "resolved_pwsid": "MI0004140-f",
    "system_name": "MARQUETTE TOWNSHIP (DS001)",
    "display_name": "MARQUETTE TOWNSHIP",
    "county": "MARQUETTE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004150",
    "resolved_pwsid": "MI0004150",
    "system_name": "MARSHALL",
    "display_name": "MARSHALL",
    "county": "CALHOUN",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004150",
    "resolved_pwsid": "MI0004150",
    "system_name": "MARSHALL",
    "display_name": "MARSHALL",
    "county": "CALHOUN",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004150",
    "resolved_pwsid": "MI0004150",
    "system_name": "MARSHALL",
    "display_name": "MARSHALL",
    "county": "CALHOUN",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004150",
    "resolved_pwsid": "MI0004150",
    "system_name": "MARSHALL",
    "display_name": "MARSHALL",
    "county": "CALHOUN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 6,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004150",
    "resolved_pwsid": "MI0004150",
    "system_name": "MARSHALL",
    "display_name": "MARSHALL",
    "county": "CALHOUN",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 25,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004150",
    "resolved_pwsid": "MI0004150",
    "system_name": "MARSHALL",
    "display_name": "MARSHALL",
    "county": "CALHOUN",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 4,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004150",
    "resolved_pwsid": "MI0004150",
    "system_name": "MARSHALL",
    "display_name": "MARSHALL",
    "county": "CALHOUN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004150",
    "resolved_pwsid": "MI0004150-a",
    "system_name": "MARSHALL (DS001)",
    "display_name": "MARSHALL",
    "county": "CALHOUN",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 9,
    "above_action_level": false,
    "lines_replaced": 15,
    "inventory_lead": 53,
    "inventory_gpcl": 30,
    "inventory_unknown": 177,
    "total_to_identify_or_replace": 260,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0004150",
    "resolved_pwsid": "MI0004150-b",
    "system_name": "MARSHALL (DS002)",
    "display_name": "MARSHALL (DS002)",
    "county": "CALHOUN",
    "monitoring_end_date": "2026-06-30",
    "year": 2026,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004152",
    "resolved_pwsid": "MI0004152",
    "system_name": "MATHIAS TOWNSHIP",
    "display_name": "MATHIAS TOWNSHIP",
    "county": "ALGER",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004152",
    "resolved_pwsid": "MI0004152",
    "system_name": "MATHIAS TOWNSHIP",
    "display_name": "MATHIAS TOWNSHIP",
    "county": "ALGER",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004152",
    "resolved_pwsid": "MI0004152",
    "system_name": "MATHIAS TOWNSHIP",
    "display_name": "MATHIAS TOWNSHIP",
    "county": "ALGER",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004155",
    "resolved_pwsid": "MI0004155",
    "system_name": "MARTIN",
    "display_name": "MARTIN",
    "county": "ALLEGAN",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004155",
    "resolved_pwsid": "MI0004155",
    "system_name": "MARTIN",
    "display_name": "MARTIN",
    "county": "ALLEGAN",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004155",
    "resolved_pwsid": "MI0004155",
    "system_name": "MARTIN",
    "display_name": "MARTIN",
    "county": "ALLEGAN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004155",
    "resolved_pwsid": "MI0004155",
    "system_name": "MARTIN",
    "display_name": "MARTIN",
    "county": "ALLEGAN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004158",
    "resolved_pwsid": "MI0004158",
    "system_name": "MARY'S CITY OF DAVID",
    "display_name": "MARY'S CITY OF DAVID",
    "county": "BERRIEN",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004158",
    "resolved_pwsid": "MI0004158",
    "system_name": "MARY'S CITY OF DAVID",
    "display_name": "MARY'S CITY OF DAVID",
    "county": "BERRIEN",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004158",
    "resolved_pwsid": "MI0004158",
    "system_name": "MARY'S CITY OF DAVID",
    "display_name": "MARY'S CITY OF DAVID",
    "county": "BERRIEN",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004160",
    "resolved_pwsid": "MI0004160",
    "system_name": "MARYSVILLE, CITY OF",
    "display_name": "MARYSVILLE, CITY OF",
    "county": "ST CLAIR",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004160",
    "resolved_pwsid": "MI0004160",
    "system_name": "MARYSVILLE, CITY OF",
    "display_name": "MARYSVILLE, CITY OF",
    "county": "ST CLAIR",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 10,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004160",
    "resolved_pwsid": "MI0004160",
    "system_name": "MARYSVILLE, CITY OF",
    "display_name": "MARYSVILLE, CITY OF",
    "county": "ST. CLAIR",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": 4,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004160",
    "resolved_pwsid": "MI0004160",
    "system_name": "MARYSVILLE, CITY OF",
    "display_name": "MARYSVILLE, CITY OF",
    "county": "ST CLAIR",
    "monitoring_end_date": "",
    "year": 2021,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 12,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004160",
    "resolved_pwsid": "MI0004160",
    "system_name": "MARYSVILLE, CITY OF",
    "display_name": "MARYSVILLE, CITY OF",
    "county": "ST CLAIR",
    "monitoring_end_date": "",
    "year": 2024,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 5,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004160",
    "resolved_pwsid": "MI0004160",
    "system_name": "MARYSVILLE, CITY OF",
    "display_name": "MARYSVILLE, CITY OF",
    "county": "ST CLAIR",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 17,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004170",
    "resolved_pwsid": "MI0004170",
    "system_name": "MASON, CITY OF",
    "display_name": "MASON, CITY OF",
    "county": "INGHAM",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004170",
    "resolved_pwsid": "MI0004170",
    "system_name": "MASON, CITY OF",
    "display_name": "MASON, CITY OF",
    "county": "INGHAM",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004170",
    "resolved_pwsid": "MI0004170",
    "system_name": "MASON, CITY OF",
    "display_name": "MASON, CITY OF",
    "county": "INGHAM",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004170",
    "resolved_pwsid": "MI0004170",
    "system_name": "MASON, CITY OF",
    "display_name": "MASON, CITY OF",
    "county": "INGHAM",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004170",
    "resolved_pwsid": "MI0004170",
    "system_name": "MASON, CITY OF",
    "display_name": "MASON, CITY OF",
    "county": "INGHAM",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": 5,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004170",
    "resolved_pwsid": "MI0004170",
    "system_name": "MASON, CITY OF",
    "display_name": "MASON, CITY OF",
    "county": "INGHAM",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": 27,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004170",
    "resolved_pwsid": "MI0004170",
    "system_name": "MASON, CITY OF",
    "display_name": "MASON, CITY OF",
    "county": "INGHAM",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 13,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004170",
    "resolved_pwsid": "MI0004170",
    "system_name": "MASON, CITY OF",
    "display_name": "MASON, CITY OF",
    "county": "INGHAM",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 28,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004170",
    "resolved_pwsid": "MI0004170",
    "system_name": "MASON, CITY OF",
    "display_name": "MASON, CITY OF",
    "county": "INGHAM",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 42,
    "inventory_lead": 415,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 415,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0004173",
    "resolved_pwsid": "MI0004173",
    "system_name": "MASONVILLE TOWNSHIP",
    "display_name": "MASONVILLE TOWNSHIP",
    "county": "DELTA",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004173",
    "resolved_pwsid": "MI0004173",
    "system_name": "MASONVILLE TOWNSHIP",
    "display_name": "MASONVILLE TOWNSHIP",
    "county": "DELTA",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 14,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004173",
    "resolved_pwsid": "MI0004173",
    "system_name": "MASONVILLE TOWNSHIP",
    "display_name": "MASONVILLE TOWNSHIP",
    "county": "DELTA",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004173",
    "resolved_pwsid": "MI0004173-a",
    "system_name": "RAPID RIVER HOUSING COMMISSION",
    "display_name": "MASONVILLE TOWNSHIP",
    "county": "DELTA",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0004177",
    "resolved_pwsid": "MI0004177",
    "system_name": "MATTAWAN",
    "display_name": "MATTAWAN",
    "county": "VAN BUREN",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004177",
    "resolved_pwsid": "MI0004177",
    "system_name": "MATTAWAN",
    "display_name": "MATTAWAN",
    "county": "VAN BUREN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004177",
    "resolved_pwsid": "MI0004177",
    "system_name": "MATTAWAN",
    "display_name": "MATTAWAN",
    "county": "VAN BUREN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004177",
    "resolved_pwsid": "MI0004177",
    "system_name": "MATTAWAN",
    "display_name": "MATTAWAN",
    "county": "VAN BUREN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004180",
    "resolved_pwsid": "MI0004180",
    "system_name": "MAYVILLE, VILLAGE OF",
    "display_name": "MAYVILLE, VILLAGE OF",
    "county": "TUSCOLA",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004180",
    "resolved_pwsid": "MI0004180",
    "system_name": "MAYVILLE, VILLAGE OF",
    "display_name": "MAYVILLE, VILLAGE OF",
    "county": "TUSCOLA",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 9,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004180",
    "resolved_pwsid": "MI0004180",
    "system_name": "MAYVILLE, VILLAGE OF",
    "display_name": "MAYVILLE, VILLAGE OF",
    "county": "TUSCOLA",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004190",
    "resolved_pwsid": "MI0004190",
    "system_name": "MCBAIN, CITY OF",
    "display_name": "MCBAIN, CITY OF",
    "county": "MISSAUKEE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004190",
    "resolved_pwsid": "MI0004190",
    "system_name": "MCBAIN, CITY OF",
    "display_name": "MCBAIN, CITY OF",
    "county": "MISSAUKEE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004190",
    "resolved_pwsid": "MI0004190",
    "system_name": "MCBAIN, CITY OF",
    "display_name": "MCBAIN, CITY OF",
    "county": "MISSAUKEE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 9,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004190",
    "resolved_pwsid": "MI0004190",
    "system_name": "MCBAIN, CITY OF",
    "display_name": "MCBAIN, CITY OF",
    "county": "MISSAUKEE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": 66,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004190",
    "resolved_pwsid": "MI0004190",
    "system_name": "MCBAIN, CITY OF",
    "display_name": "MCBAIN, CITY OF",
    "county": "MISSAUKEE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 60,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004190",
    "resolved_pwsid": "MI0004190",
    "system_name": "MCBAIN, CITY OF",
    "display_name": "MCBAIN, CITY OF",
    "county": "MISSAUKEE",
    "monitoring_end_date": "2023-06-30",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004190",
    "resolved_pwsid": "MI0004190",
    "system_name": "MCBAIN, CITY OF",
    "display_name": "MCBAIN, CITY OF",
    "county": "MISSAUKEE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004190",
    "resolved_pwsid": "MI0004190",
    "system_name": "MCBAIN, CITY OF",
    "display_name": "MCBAIN, CITY OF",
    "county": "MISSAUKEE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004190",
    "resolved_pwsid": "MI0004190",
    "system_name": "MCBAIN, CITY OF",
    "display_name": "MCBAIN, CITY OF",
    "county": "MISSAUKEE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004215",
    "resolved_pwsid": "MI0004215",
    "system_name": "MELROSE-CHANDLER WATER, LLC",
    "display_name": "MELROSE-CHANDLER WATER, LLC",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 25,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004215",
    "resolved_pwsid": "MI0004215",
    "system_name": "MELROSE-CHANDLER WATER, LLC",
    "display_name": "MELROSE-CHANDLER WATER, LLC",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004215",
    "resolved_pwsid": "MI0004215",
    "system_name": "MELROSE-CHANDLER WATER, LLC",
    "display_name": "MELROSE-CHANDLER WATER, LLC",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004215",
    "resolved_pwsid": "MI0004215",
    "system_name": "MELROSE-CHANDLER WATER, LLC",
    "display_name": "MELROSE-CHANDLER WATER, LLC",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004215",
    "resolved_pwsid": "MI0004215",
    "system_name": "MELROSE-CHANDLER WATER, LLC",
    "display_name": "MELROSE-CHANDLER WATER, LLC",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0004220",
    "resolved_pwsid": "MI0004220",
    "system_name": "MELVINDALE",
    "display_name": "MELVINDALE",
    "county": "WAYNE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004220",
    "resolved_pwsid": "MI0004220",
    "system_name": "MELVINDALE",
    "display_name": "MELVINDALE",
    "county": "WAYNE",
    "monitoring_end_date": "2019-09-30",
    "year": 2019,
    "lead_90th_ppb": 370,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004220",
    "resolved_pwsid": "MI0004220",
    "system_name": "MELVINDALE",
    "display_name": "MELVINDALE",
    "county": "WAYNE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 370,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004220",
    "resolved_pwsid": "MI0004220",
    "system_name": "MELVINDALE",
    "display_name": "MELVINDALE",
    "county": "WAYNE",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004220",
    "resolved_pwsid": "MI0004220",
    "system_name": "MELVINDALE",
    "display_name": "MELVINDALE",
    "county": "WAYNE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004220",
    "resolved_pwsid": "MI0004220",
    "system_name": "MELVINDALE",
    "display_name": "MELVINDALE",
    "county": "WAYNE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": 53,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004220",
    "resolved_pwsid": "MI0004220",
    "system_name": "MELVINDALE",
    "display_name": "MELVINDALE",
    "county": "WAYNE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": 244,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004220",
    "resolved_pwsid": "MI0004220",
    "system_name": "MELVINDALE",
    "display_name": "MELVINDALE",
    "county": "WAYNE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 407,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004220",
    "resolved_pwsid": "MI0004220",
    "system_name": "MELVINDALE",
    "display_name": "MELVINDALE",
    "county": "WAYNE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": 39,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004220",
    "resolved_pwsid": "MI0004220",
    "system_name": "MELVINDALE",
    "display_name": "MELVINDALE",
    "county": "WAYNE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 489,
    "inventory_lead": 8,
    "inventory_gpcl": 1,
    "inventory_unknown": 2750,
    "total_to_identify_or_replace": 2759,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0004230",
    "resolved_pwsid": "MI0004230",
    "system_name": "MEMPHIS, CITY OF",
    "display_name": "MEMPHIS, CITY OF",
    "county": "ST CLAIR",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004230",
    "resolved_pwsid": "MI0004230",
    "system_name": "MEMPHIS, CITY OF",
    "display_name": "MEMPHIS, CITY OF",
    "county": "ST CLAIR",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004230",
    "resolved_pwsid": "MI0004230",
    "system_name": "MEMPHIS, CITY OF",
    "display_name": "MEMPHIS, CITY OF",
    "county": "ST. CLAIR",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004230",
    "resolved_pwsid": "MI0004230",
    "system_name": "MEMPHIS, CITY OF",
    "display_name": "MEMPHIS, CITY OF",
    "county": "ST. CLAIR",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004230",
    "resolved_pwsid": "MI0004230",
    "system_name": "MEMPHIS, CITY OF",
    "display_name": "MEMPHIS, CITY OF",
    "county": "ST. CLAIR",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0004240",
    "resolved_pwsid": "MI0004240",
    "system_name": "MENDON",
    "display_name": "MENDON",
    "county": "ST JOSEPH",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004240",
    "resolved_pwsid": "MI0004240",
    "system_name": "MENDON",
    "display_name": "MENDON",
    "county": "ST JOSEPH",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004240",
    "resolved_pwsid": "MI0004240",
    "system_name": "MENDON",
    "display_name": "MENDON",
    "county": "ST JOSEPH",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004240",
    "resolved_pwsid": "MI0004240",
    "system_name": "MENDON",
    "display_name": "MENDON",
    "county": "ST JOSEPH",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004240",
    "resolved_pwsid": "MI0004240",
    "system_name": "MENDON",
    "display_name": "MENDON",
    "county": "ST JOSEPH",
    "monitoring_end_date": "2021-06-30",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004240",
    "resolved_pwsid": "MI0004240",
    "system_name": "MENDON",
    "display_name": "MENDON",
    "county": "ST JOSEPH",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004240",
    "resolved_pwsid": "MI0004240",
    "system_name": "MENDON",
    "display_name": "MENDON",
    "county": "ST. JOSEPH",
    "monitoring_end_date": "2022-06-30",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004240",
    "resolved_pwsid": "MI0004240",
    "system_name": "MENDON",
    "display_name": "MENDON",
    "county": "ST. JOSEPH",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004240",
    "resolved_pwsid": "MI0004240",
    "system_name": "MENDON",
    "display_name": "MENDON",
    "county": "ST. JOSEPH",
    "monitoring_end_date": "2023-06-30",
    "year": 2023,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": 4,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004240",
    "resolved_pwsid": "MI0004240",
    "system_name": "MENDON",
    "display_name": "MENDON",
    "county": "ST. JOSEPH",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004240",
    "resolved_pwsid": "MI0004240",
    "system_name": "MENDON",
    "display_name": "MENDON",
    "county": "ST. JOSEPH",
    "monitoring_end_date": "2024-06-30",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 16,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004240",
    "resolved_pwsid": "MI0004240",
    "system_name": "MENDON",
    "display_name": "MENDON",
    "county": "ST. JOSEPH",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004240",
    "resolved_pwsid": "MI0004240",
    "system_name": "MENDON",
    "display_name": "MENDON",
    "county": "ST. JOSEPH",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 3,
    "inventory_lead": 96,
    "inventory_gpcl": 18,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 114,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004250",
    "resolved_pwsid": "MI0004250",
    "system_name": "MENOMINEE",
    "display_name": "MENOMINEE",
    "county": "MENOMINEE",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004250",
    "resolved_pwsid": "MI0004250",
    "system_name": "MENOMINEE",
    "display_name": "MENOMINEE",
    "county": "MENOMINEE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004250",
    "resolved_pwsid": "MI0004250",
    "system_name": "MENOMINEE",
    "display_name": "MENOMINEE",
    "county": "MENOMINEE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004250",
    "resolved_pwsid": "MI0004250",
    "system_name": "MENOMINEE",
    "display_name": "MENOMINEE",
    "county": "MENOMINEE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 35,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004250",
    "resolved_pwsid": "MI0004250",
    "system_name": "MENOMINEE",
    "display_name": "MENOMINEE",
    "county": "MENOMINEE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 73,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004250",
    "resolved_pwsid": "MI0004250",
    "system_name": "MENOMINEE",
    "display_name": "MENOMINEE",
    "county": "MENOMINEE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 89,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004250",
    "resolved_pwsid": "MI0004250",
    "system_name": "MENOMINEE",
    "display_name": "MENOMINEE",
    "county": "MENOMINEE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 74,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004250",
    "resolved_pwsid": "MI0004250",
    "system_name": "MENOMINEE",
    "display_name": "MENOMINEE",
    "county": "MENOMINEE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 12,
    "inventory_lead": 190,
    "inventory_gpcl": 470,
    "inventory_unknown": 200,
    "total_to_identify_or_replace": 860,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0004260",
    "resolved_pwsid": "MI0004260",
    "system_name": "MERIDIAN TOWNSHIP",
    "display_name": "MERIDIAN TOWNSHIP",
    "county": "INGHAM",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004260",
    "resolved_pwsid": "MI0004260",
    "system_name": "MERIDIAN TOWNSHIP",
    "display_name": "MERIDIAN TOWNSHIP",
    "county": "INGHAM",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004260",
    "resolved_pwsid": "MI0004260",
    "system_name": "MERIDIAN TOWNSHIP",
    "display_name": "MERIDIAN TOWNSHIP",
    "county": "INGHAM",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004260",
    "resolved_pwsid": "MI0004260",
    "system_name": "MERIDIAN TOWNSHIP",
    "display_name": "MERIDIAN TOWNSHIP",
    "county": "INGHAM",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004260",
    "resolved_pwsid": "MI0004260",
    "system_name": "MERIDIAN TOWNSHIP",
    "display_name": "MERIDIAN TOWNSHIP",
    "county": "INGHAM",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004260",
    "resolved_pwsid": "MI0004260",
    "system_name": "MERIDIAN TOWNSHIP",
    "display_name": "MERIDIAN TOWNSHIP",
    "county": "INGHAM",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004260",
    "resolved_pwsid": "MI0004260",
    "system_name": "MERIDIAN TOWNSHIP",
    "display_name": "MERIDIAN TOWNSHIP",
    "county": "INGHAM",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004260",
    "resolved_pwsid": "MI0004260",
    "system_name": "MERIDIAN TOWNSHIP",
    "display_name": "MERIDIAN TOWNSHIP",
    "county": "INGHAM",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0004276",
    "resolved_pwsid": "MI0004276",
    "system_name": "MERRILL, VILLAGE OF",
    "display_name": "MERRILL, VILLAGE OF",
    "county": "SAGINAW",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004276",
    "resolved_pwsid": "MI0004276",
    "system_name": "MERRILL, VILLAGE OF",
    "display_name": "MERRILL, VILLAGE OF",
    "county": "SAGINAW",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004276",
    "resolved_pwsid": "MI0004276",
    "system_name": "MERRILL, VILLAGE OF",
    "display_name": "MERRILL, VILLAGE OF",
    "county": "SAGINAW",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004280",
    "resolved_pwsid": "MI0004280",
    "system_name": "MERRITT TOWNSHIP",
    "display_name": "MERRITT TOWNSHIP",
    "county": "BAY",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004280",
    "resolved_pwsid": "MI0004280",
    "system_name": "MERRITT TOWNSHIP",
    "display_name": "MERRITT TOWNSHIP",
    "county": "BAY",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004280",
    "resolved_pwsid": "MI0004280",
    "system_name": "MERRITT TOWNSHIP",
    "display_name": "MERRITT TOWNSHIP",
    "county": "BAY",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004280",
    "resolved_pwsid": "MI0004280",
    "system_name": "MERRITT TOWNSHIP",
    "display_name": "MERRITT TOWNSHIP",
    "county": "BAY",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004280",
    "resolved_pwsid": "MI0004280",
    "system_name": "MERRITT TOWNSHIP",
    "display_name": "MERRITT TOWNSHIP",
    "county": "BAY",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004280",
    "resolved_pwsid": "MI0004280",
    "system_name": "MERRITT TOWNSHIP",
    "display_name": "MERRITT TOWNSHIP",
    "county": "BAY",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004280",
    "resolved_pwsid": "MI0004280",
    "system_name": "MERRITT TOWNSHIP",
    "display_name": "MERRITT TOWNSHIP",
    "county": "BAY",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004310",
    "resolved_pwsid": "MI0004310",
    "system_name": "MESICK, VILLAGE OF",
    "display_name": "MESICK, VILLAGE OF",
    "county": "WEXFORD",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004310",
    "resolved_pwsid": "MI0004310",
    "system_name": "MESICK, VILLAGE OF",
    "display_name": "MESICK, VILLAGE OF",
    "county": "WEXFORD",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004310",
    "resolved_pwsid": "MI0004310",
    "system_name": "MESICK, VILLAGE OF",
    "display_name": "MESICK, VILLAGE OF",
    "county": "WEXFORD",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004310",
    "resolved_pwsid": "MI0004310",
    "system_name": "MESICK, VILLAGE OF",
    "display_name": "MESICK, VILLAGE OF",
    "county": "WEXFORD",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004310",
    "resolved_pwsid": "MI0004310",
    "system_name": "MESICK, VILLAGE OF",
    "display_name": "MESICK, VILLAGE OF",
    "county": "WEXFORD",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004312",
    "resolved_pwsid": "MI0004312",
    "system_name": "METAMORA, VILLAGE OF",
    "display_name": "METAMORA, VILLAGE OF",
    "county": "LAPEER",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004312",
    "resolved_pwsid": "MI0004312",
    "system_name": "METAMORA, VILLAGE OF",
    "display_name": "METAMORA, VILLAGE OF",
    "county": "LAPEER",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004312",
    "resolved_pwsid": "MI0004312",
    "system_name": "METAMORA, VILLAGE OF",
    "display_name": "METAMORA, VILLAGE OF",
    "county": "LAPEER",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004320",
    "resolved_pwsid": "MI0004320",
    "system_name": "MICHIANA",
    "display_name": "MICHIANA",
    "county": "BERRIEN",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004320",
    "resolved_pwsid": "MI0004320",
    "system_name": "MICHIANA",
    "display_name": "MICHIANA",
    "county": "BERRIEN",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004320",
    "resolved_pwsid": "MI0004320",
    "system_name": "MICHIANA",
    "display_name": "MICHIANA",
    "county": "BERRIEN",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004320",
    "resolved_pwsid": "MI0004320",
    "system_name": "MICHIANA",
    "display_name": "MICHIANA",
    "county": "BERRIEN",
    "monitoring_end_date": "2021-06-30",
    "year": 2021,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004320",
    "resolved_pwsid": "MI0004320",
    "system_name": "MICHIANA",
    "display_name": "MICHIANA",
    "county": "BERRIEN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004320",
    "resolved_pwsid": "MI0004320",
    "system_name": "MICHIANA",
    "display_name": "MICHIANA",
    "county": "BERRIEN",
    "monitoring_end_date": "2022-06-30",
    "year": 2022,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004320",
    "resolved_pwsid": "MI0004320",
    "system_name": "MICHIANA",
    "display_name": "MICHIANA",
    "county": "BERRIEN",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004320",
    "resolved_pwsid": "MI0004320",
    "system_name": "MICHIANA",
    "display_name": "MICHIANA",
    "county": "BERRIEN",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004320",
    "resolved_pwsid": "MI0004320",
    "system_name": "MICHIANA",
    "display_name": "MICHIANA",
    "county": "BERRIEN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004320",
    "resolved_pwsid": "MI0004320",
    "system_name": "MICHIANA",
    "display_name": "MICHIANA",
    "county": "BERRIEN",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0004340",
    "resolved_pwsid": "MI0004340-a",
    "system_name": "MICHIGAN STATE UNIVERSITY",
    "display_name": "MICHIGAN STATE UNIVERSITY",
    "county": "INGHAM",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 9,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004340",
    "resolved_pwsid": "MI0004340-a",
    "system_name": "MICHIGAN STATE UNIVERSITY",
    "display_name": "MICHIGAN STATE UNIVERSITY",
    "county": "INGHAM",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004340",
    "resolved_pwsid": "MI0004340-a",
    "system_name": "MICHIGAN STATE UNIVERSITY",
    "display_name": "MICHIGAN STATE UNIVERSITY",
    "county": "INGHAM",
    "monitoring_end_date": "2021-06-30",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004340",
    "resolved_pwsid": "MI0004340-a",
    "system_name": "MICHIGAN STATE UNIVERSITY",
    "display_name": "MICHIGAN STATE UNIVERSITY",
    "county": "INGHAM",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004340",
    "resolved_pwsid": "MI0004340-a",
    "system_name": "MICHIGAN STATE UNIVERSITY",
    "display_name": "MICHIGAN STATE UNIVERSITY",
    "county": "INGHAM",
    "monitoring_end_date": "2022-06-30",
    "year": 2022,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004340",
    "resolved_pwsid": "MI0004340-a",
    "system_name": "MICHIGAN STATE UNIVERSITY",
    "display_name": "MICHIGAN STATE UNIVERSITY",
    "county": "INGHAM",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004340",
    "resolved_pwsid": "MI0004340-c",
    "system_name": "MICHIGAN STATE UNIVERSITY (FARMS)",
    "display_name": "MICHIGAN STATE UNIVERSITY (FARMS)",
    "county": "INGHAM",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 50,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004340",
    "resolved_pwsid": "MI0004340-c",
    "system_name": "MICHIGAN STATE UNIVERSITY (FARMS)",
    "display_name": "MICHIGAN STATE UNIVERSITY (FARMS)",
    "county": "INGHAM",
    "monitoring_end_date": "2024-06-30",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004340",
    "resolved_pwsid": "MI0004340-a",
    "system_name": "MICHIGAN STATE UNIVERSITY",
    "display_name": "MICHIGAN STATE UNIVERSITY",
    "county": "INGHAM",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004340",
    "resolved_pwsid": "MI0004340-b",
    "system_name": "MICHIGAN STATE UNIVERSITY (FARM)",
    "display_name": "MICHIGAN STATE UNIVERSITY (FARM)",
    "county": "INGHAM",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004340",
    "resolved_pwsid": "MI0004340-e",
    "system_name": "MICHIGAN STATE UNIVERSITY (DS002)",
    "display_name": "MICHIGAN STATE UNIVERSITY (DS002)",
    "county": "INGHAM",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004340",
    "resolved_pwsid": "MI0004340-d",
    "system_name": "MICHIGAN STATE UNIVERSITY (DS001)",
    "display_name": "MICHIGAN STATE UNIVERSITY",
    "county": "INGHAM",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0004353",
    "resolved_pwsid": "MI0004353-a",
    "system_name": "MICHINDOH CONFERENCE CENTER (DS001)",
    "display_name": "MICHINDOH CONFERENCE CENTER (DS001)",
    "county": "HILLSDALE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004353",
    "resolved_pwsid": "MI0004353-b",
    "system_name": "MICHINDOH CONFERENCE CENTER (DS002)",
    "display_name": "MICHINDOH CONFERENCE CENTER (DS002)",
    "county": "HILLSDALE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004360",
    "resolved_pwsid": "MI0004360",
    "system_name": "MIDDLEVILLE",
    "display_name": "MIDDLEVILLE",
    "county": "BARRY",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004360",
    "resolved_pwsid": "MI0004360",
    "system_name": "MIDDLEVILLE",
    "display_name": "MIDDLEVILLE",
    "county": "BARRY",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004360",
    "resolved_pwsid": "MI0004360",
    "system_name": "MIDDLEVILLE",
    "display_name": "MIDDLEVILLE",
    "county": "BARRY",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004360",
    "resolved_pwsid": "MI0004360",
    "system_name": "MIDDLEVILLE",
    "display_name": "MIDDLEVILLE",
    "county": "BARRY",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004360",
    "resolved_pwsid": "MI0004360",
    "system_name": "MIDDLEVILLE",
    "display_name": "MIDDLEVILLE",
    "county": "BARRY",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004360",
    "resolved_pwsid": "MI0004360",
    "system_name": "MIDDLEVILLE",
    "display_name": "MIDDLEVILLE",
    "county": "BARRY",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": 10,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004360",
    "resolved_pwsid": "MI0004360",
    "system_name": "MIDDLEVILLE",
    "display_name": "MIDDLEVILLE",
    "county": "BARRY",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 2,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004360",
    "resolved_pwsid": "MI0004360",
    "system_name": "MIDDLEVILLE",
    "display_name": "MIDDLEVILLE",
    "county": "BARRY",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": 6,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004360",
    "resolved_pwsid": "MI0004360",
    "system_name": "MIDDLEVILLE",
    "display_name": "MIDDLEVILLE",
    "county": "BARRY",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004360",
    "resolved_pwsid": "MI0004360",
    "system_name": "MIDDLEVILLE",
    "display_name": "MIDDLEVILLE",
    "county": "BARRY",
    "monitoring_end_date": "",
    "year": 2024,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 30,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004360",
    "resolved_pwsid": "MI0004360",
    "system_name": "MIDDLEVILLE",
    "display_name": "MIDDLEVILLE",
    "county": "BARRY",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 24,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004370",
    "resolved_pwsid": "MI0004370",
    "system_name": "MIDLAND, CITY OF",
    "display_name": "MIDLAND, CITY OF",
    "county": "MIDLAND",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004370",
    "resolved_pwsid": "MI0004370",
    "system_name": "MIDLAND, CITY OF",
    "display_name": "MIDLAND, CITY OF",
    "county": "MIDLAND",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004370",
    "resolved_pwsid": "MI0004370",
    "system_name": "MIDLAND, CITY OF",
    "display_name": "MIDLAND, CITY OF",
    "county": "MIDLAND",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004370",
    "resolved_pwsid": "MI0004370",
    "system_name": "MIDLAND, CITY OF",
    "display_name": "MIDLAND, CITY OF",
    "county": "MIDLAND",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004370",
    "resolved_pwsid": "MI0004370",
    "system_name": "MIDLAND, CITY OF",
    "display_name": "MIDLAND, CITY OF",
    "county": "MIDLAND",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004370",
    "resolved_pwsid": "MI0004370",
    "system_name": "MIDLAND, CITY OF",
    "display_name": "MIDLAND, CITY OF",
    "county": "MIDLAND",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": 2,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004370",
    "resolved_pwsid": "MI0004370",
    "system_name": "MIDLAND, CITY OF",
    "display_name": "MIDLAND, CITY OF",
    "county": "MIDLAND",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004370",
    "resolved_pwsid": "MI0004370",
    "system_name": "MIDLAND, CITY OF",
    "display_name": "MIDLAND, CITY OF",
    "county": "MIDLAND",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 4,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004375",
    "resolved_pwsid": "MI0004375",
    "system_name": "MIDLAND CO., WATER DIST. NO. 1 OF",
    "display_name": "MIDLAND CO., WATER DIST. NO. 1 OF",
    "county": "MIDLAND",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004375",
    "resolved_pwsid": "MI0004375",
    "system_name": "MIDLAND CO., WATER DIST. NO. 1 OF",
    "display_name": "MIDLAND CO., WATER DIST. NO. 1 OF",
    "county": "MIDLAND",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004375",
    "resolved_pwsid": "MI0004375",
    "system_name": "MIDLAND CO., WATER DIST. NO. 1 OF",
    "display_name": "MIDLAND CO., WATER DIST. NO. 1 OF",
    "county": "MIDLAND",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004375",
    "resolved_pwsid": "MI0004375",
    "system_name": "MIDLAND CO., WATER DIST. NO. 1 OF",
    "display_name": "MIDLAND CO., WATER DIST. NO. 1 OF",
    "county": "MIDLAND",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004375",
    "resolved_pwsid": "MI0004375",
    "system_name": "MIDLAND CO., WATER DIST. NO. 1 OF",
    "display_name": "MIDLAND CO., WATER DIST. NO. 1 OF",
    "county": "MIDLAND",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004375",
    "resolved_pwsid": "MI0004375",
    "system_name": "MIDLAND CO., WATER DIST. NO. 1 OF",
    "display_name": "MIDLAND CO., WATER DIST. NO. 1 OF",
    "county": "MIDLAND",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004375",
    "resolved_pwsid": "MI0004375",
    "system_name": "MIDLAND CO., WATER DIST. NO. 1 OF",
    "display_name": "MIDLAND CO., WATER DIST. NO. 1 OF",
    "county": "MIDLAND",
    "monitoring_end_date": "2024-06-30",
    "year": 2024,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004375",
    "resolved_pwsid": "MI0004375",
    "system_name": "MIDLAND CO., WATER DIST. NO. 1 OF",
    "display_name": "MIDLAND CO., WATER DIST. NO. 1 OF",
    "county": "MIDLAND",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004375",
    "resolved_pwsid": "MI0004375",
    "system_name": "MIDLAND CO., WATER DIST. NO. 1 OF",
    "display_name": "MIDLAND CO., WATER DIST. NO. 1 OF",
    "county": "MIDLAND",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0004375",
    "resolved_pwsid": "MI0004375",
    "system_name": "MIDLAND CO., WATER DIST. NO. 1 OF",
    "display_name": "MIDLAND CO., WATER DIST. NO. 1 OF",
    "county": "MIDLAND",
    "monitoring_end_date": "2026-06-30",
    "year": 2026,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004377",
    "resolved_pwsid": "MI0004377",
    "system_name": "MIDLAND CHARTER TOWNSHIP",
    "display_name": "MIDLAND CHARTER TOWNSHIP",
    "county": "MIDLAND",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004377",
    "resolved_pwsid": "MI0004377",
    "system_name": "MIDLAND CHARTER TOWNSHIP",
    "display_name": "MIDLAND CHARTER TOWNSHIP",
    "county": "MIDLAND",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004377",
    "resolved_pwsid": "MI0004377",
    "system_name": "MIDLAND CHARTER TOWNSHIP",
    "display_name": "MIDLAND CHARTER TOWNSHIP",
    "county": "MIDLAND",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004377",
    "resolved_pwsid": "MI0004377",
    "system_name": "MIDLAND CHARTER TOWNSHIP",
    "display_name": "MIDLAND CHARTER TOWNSHIP",
    "county": "MIDLAND",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004377",
    "resolved_pwsid": "MI0004377",
    "system_name": "MIDLAND CHARTER TOWNSHIP",
    "display_name": "MIDLAND CHARTER TOWNSHIP",
    "county": "MIDLAND",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004377",
    "resolved_pwsid": "MI0004377",
    "system_name": "MIDLAND CHARTER TOWNSHIP",
    "display_name": "MIDLAND CHARTER TOWNSHIP",
    "county": "MIDLAND",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004377",
    "resolved_pwsid": "MI0004377",
    "system_name": "MIDLAND CHARTER TOWNSHIP",
    "display_name": "MIDLAND CHARTER TOWNSHIP",
    "county": "MIDLAND",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004377",
    "resolved_pwsid": "MI0004377",
    "system_name": "MIDLAND CHARTER TOWNSHIP",
    "display_name": "MIDLAND CHARTER TOWNSHIP",
    "county": "MIDLAND",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0004380",
    "resolved_pwsid": "MI0004380",
    "system_name": "MILAN",
    "display_name": "MILAN",
    "county": "WASHTENAW",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004380",
    "resolved_pwsid": "MI0004380",
    "system_name": "MILAN",
    "display_name": "MILAN",
    "county": "WASHTENAW",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": 7,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004380",
    "resolved_pwsid": "MI0004380",
    "system_name": "MILAN",
    "display_name": "MILAN",
    "county": "WASHTENAW",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": 9,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004380",
    "resolved_pwsid": "MI0004380",
    "system_name": "MILAN",
    "display_name": "MILAN",
    "county": "WASHTENAW",
    "monitoring_end_date": "",
    "year": 2022,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 14,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004380",
    "resolved_pwsid": "MI0004380",
    "system_name": "MILAN",
    "display_name": "MILAN",
    "county": "WASHTENAW",
    "monitoring_end_date": "",
    "year": 2023,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 12,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004380",
    "resolved_pwsid": "MI0004380",
    "system_name": "MILAN",
    "display_name": "MILAN",
    "county": "WASHTENAW",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 16,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004390",
    "resolved_pwsid": "MI0004390",
    "system_name": "MILFORD, VILLAGE OF",
    "display_name": "MILFORD, VILLAGE OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004390",
    "resolved_pwsid": "MI0004390",
    "system_name": "MILFORD, VILLAGE OF",
    "display_name": "MILFORD, VILLAGE OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004390",
    "resolved_pwsid": "MI0004390",
    "system_name": "MILFORD, VILLAGE OF",
    "display_name": "MILFORD, VILLAGE OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": 24,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004390",
    "resolved_pwsid": "MI0004390",
    "system_name": "MILFORD, VILLAGE OF",
    "display_name": "MILFORD, VILLAGE OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004390",
    "resolved_pwsid": "MI0004390",
    "system_name": "MILFORD, VILLAGE OF",
    "display_name": "MILFORD, VILLAGE OF",
    "county": "OAKLAND",
    "monitoring_end_date": "",
    "year": 2021,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 6,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004390",
    "resolved_pwsid": "MI0004390",
    "system_name": "MILFORD, VILLAGE OF",
    "display_name": "MILFORD, VILLAGE OF",
    "county": "OAKLAND",
    "monitoring_end_date": "",
    "year": 2022,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 3,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004390",
    "resolved_pwsid": "MI0004390",
    "system_name": "MILFORD, VILLAGE OF",
    "display_name": "MILFORD, VILLAGE OF",
    "county": "OAKLAND",
    "monitoring_end_date": "",
    "year": 2024,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 31,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004390",
    "resolved_pwsid": "MI0004390",
    "system_name": "MILFORD, VILLAGE OF",
    "display_name": "MILFORD, VILLAGE OF",
    "county": "OAKLAND",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 17,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004397",
    "resolved_pwsid": "MI0004397",
    "system_name": "MILLERSBURG, VILLAGE OF",
    "display_name": "MILLERSBURG, VILLAGE OF",
    "county": "PRESQUE ISLE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004397",
    "resolved_pwsid": "MI0004397",
    "system_name": "MILLERSBURG, VILLAGE OF",
    "display_name": "MILLERSBURG, VILLAGE OF",
    "county": "PRESQUE ISLE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004397",
    "resolved_pwsid": "MI0004397",
    "system_name": "MILLERSBURG, VILLAGE OF",
    "display_name": "MILLERSBURG, VILLAGE OF",
    "county": "PRESQUE ISLE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004400",
    "resolved_pwsid": "MI0004400",
    "system_name": "MILLINGTON, VILLAGE OF",
    "display_name": "MILLINGTON, VILLAGE OF",
    "county": "TUSCOLA",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004400",
    "resolved_pwsid": "MI0004400",
    "system_name": "MILLINGTON, VILLAGE OF",
    "display_name": "MILLINGTON, VILLAGE OF",
    "county": "TUSCOLA",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004400",
    "resolved_pwsid": "MI0004400",
    "system_name": "MILLINGTON, VILLAGE OF",
    "display_name": "MILLINGTON, VILLAGE OF",
    "county": "TUSCOLA",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004403",
    "resolved_pwsid": "MI0004403",
    "system_name": "MILLPOINTE OF HARTLAND",
    "display_name": "MILLPOINTE OF HARTLAND",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004403",
    "resolved_pwsid": "MI0004403",
    "system_name": "MILLPOINTE OF HARTLAND",
    "display_name": "MILLPOINTE OF HARTLAND",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004403",
    "resolved_pwsid": "MI0004403",
    "system_name": "MILLPOINTE OF HARTLAND",
    "display_name": "MILLPOINTE OF HARTLAND",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004403",
    "resolved_pwsid": "MI0004403",
    "system_name": "MILLPOINTE OF HARTLAND",
    "display_name": "MILLPOINTE OF HARTLAND",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0004404",
    "resolved_pwsid": "MI0004404",
    "system_name": "MILLS TOWNSHIP",
    "display_name": "MILLS TOWNSHIP",
    "county": "MIDLAND",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004404",
    "resolved_pwsid": "MI0004404",
    "system_name": "MILLS TOWNSHIP",
    "display_name": "MILLS TOWNSHIP",
    "county": "MIDLAND",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004404",
    "resolved_pwsid": "MI0004404",
    "system_name": "MILLS TOWNSHIP",
    "display_name": "MILLS TOWNSHIP",
    "county": "MIDLAND",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004404",
    "resolved_pwsid": "MI0004404",
    "system_name": "MILLS TOWNSHIP",
    "display_name": "MILLS TOWNSHIP",
    "county": "MIDLAND",
    "monitoring_end_date": "2021-09-30",
    "year": 2021,
    "lead_90th_ppb": 20,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004404",
    "resolved_pwsid": "MI0004404",
    "system_name": "MILLS TOWNSHIP",
    "display_name": "MILLS TOWNSHIP",
    "county": "MIDLAND",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 20,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004404",
    "resolved_pwsid": "MI0004404",
    "system_name": "MILLS TOWNSHIP",
    "display_name": "MILLS TOWNSHIP",
    "county": "MIDLAND",
    "monitoring_end_date": "2022-06-30",
    "year": 2022,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004404",
    "resolved_pwsid": "MI0004404",
    "system_name": "MILLS TOWNSHIP",
    "display_name": "MILLS TOWNSHIP",
    "county": "MIDLAND",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004404",
    "resolved_pwsid": "MI0004404",
    "system_name": "MILLS TOWNSHIP",
    "display_name": "MILLS TOWNSHIP",
    "county": "MIDLAND",
    "monitoring_end_date": "2023-06-30",
    "year": 2023,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004404",
    "resolved_pwsid": "MI0004404",
    "system_name": "MILLS TOWNSHIP",
    "display_name": "MILLS TOWNSHIP",
    "county": "MIDLAND",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004404",
    "resolved_pwsid": "MI0004404",
    "system_name": "MILLS TOWNSHIP",
    "display_name": "MILLS TOWNSHIP",
    "county": "MIDLAND",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0004410",
    "resolved_pwsid": "MI0004410",
    "system_name": "MINDEN CITY, VILLAGE OF",
    "display_name": "MINDEN CITY, VILLAGE OF",
    "county": "SANILAC",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004410",
    "resolved_pwsid": "MI0004410",
    "system_name": "MINDEN CITY, VILLAGE OF",
    "display_name": "MINDEN CITY, VILLAGE OF",
    "county": "SANILAC",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004410",
    "resolved_pwsid": "MI0004410",
    "system_name": "MINDEN CITY, VILLAGE OF",
    "display_name": "MINDEN CITY, VILLAGE OF",
    "county": "SANILAC",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004419",
    "resolved_pwsid": "MI0004419",
    "system_name": "MAPLEWOOD AND STONE MANORS",
    "display_name": "MAPLEWOOD AND STONE MANORS",
    "county": "OSCODA",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004419",
    "resolved_pwsid": "MI0004419",
    "system_name": "MAPLEWOOD AND STONE MANORS",
    "display_name": "MAPLEWOOD AND STONE MANORS",
    "county": "OSCODA",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004419",
    "resolved_pwsid": "MI0004419",
    "system_name": "MAPLEWOOD AND STONE MANORS",
    "display_name": "MAPLEWOOD AND STONE MANORS",
    "county": "OSCODA",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004428",
    "resolved_pwsid": "MI0004428",
    "system_name": "MISTY COVE SENIOR APARTMENTS",
    "display_name": "MISTY COVE SENIOR APARTMENTS",
    "county": "EATON",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004428",
    "resolved_pwsid": "MI0004428",
    "system_name": "MISTY COVE SENIOR APARTMENTS",
    "display_name": "MISTY COVE SENIOR APARTMENTS",
    "county": "EATON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004428",
    "resolved_pwsid": "MI0004428",
    "system_name": "MISTY COVE SENIOR APARTMENTS",
    "display_name": "MISTY COVE SENIOR APARTMENTS",
    "county": "EATON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004440",
    "resolved_pwsid": "MI0004440",
    "system_name": "MONITOR TOWNSHIP",
    "display_name": "MONITOR TOWNSHIP",
    "county": "BAY",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004440",
    "resolved_pwsid": "MI0004440",
    "system_name": "MONITOR TOWNSHIP",
    "display_name": "MONITOR TOWNSHIP",
    "county": "BAY",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004440",
    "resolved_pwsid": "MI0004440",
    "system_name": "MONITOR TOWNSHIP",
    "display_name": "MONITOR TOWNSHIP",
    "county": "BAY",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004440",
    "resolved_pwsid": "MI0004440",
    "system_name": "MONITOR TOWNSHIP",
    "display_name": "MONITOR TOWNSHIP",
    "county": "BAY",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004440",
    "resolved_pwsid": "MI0004440",
    "system_name": "MONITOR TOWNSHIP",
    "display_name": "MONITOR TOWNSHIP",
    "county": "BAY",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004440",
    "resolved_pwsid": "MI0004440",
    "system_name": "MONITOR TOWNSHIP",
    "display_name": "MONITOR TOWNSHIP",
    "county": "BAY",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004440",
    "resolved_pwsid": "MI0004440",
    "system_name": "MONITOR TOWNSHIP",
    "display_name": "MONITOR TOWNSHIP",
    "county": "BAY",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004450",
    "resolved_pwsid": "MI0004450",
    "system_name": "MONROE",
    "display_name": "MONROE",
    "county": "MONROE",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 15,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004450",
    "resolved_pwsid": "MI0004450",
    "system_name": "MONROE",
    "display_name": "MONROE",
    "county": "MONROE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004450",
    "resolved_pwsid": "MI0004450",
    "system_name": "MONROE",
    "display_name": "MONROE",
    "county": "MONROE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004450",
    "resolved_pwsid": "MI0004450",
    "system_name": "MONROE",
    "display_name": "MONROE",
    "county": "MONROE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": 120,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004450",
    "resolved_pwsid": "MI0004450",
    "system_name": "MONROE",
    "display_name": "MONROE",
    "county": "MONROE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": 82,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004450",
    "resolved_pwsid": "MI0004450",
    "system_name": "MONROE",
    "display_name": "MONROE",
    "county": "MONROE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": 85,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004450",
    "resolved_pwsid": "MI0004450",
    "system_name": "MONROE",
    "display_name": "MONROE",
    "county": "MONROE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": 52,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004450",
    "resolved_pwsid": "MI0004450",
    "system_name": "MONROE",
    "display_name": "MONROE",
    "county": "MONROE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 74,
    "inventory_lead": 731,
    "inventory_gpcl": 392,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 1123,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0004455",
    "resolved_pwsid": "MI0004455",
    "system_name": "MONROE SOUTH COUNTY",
    "display_name": "MONROE SOUTH COUNTY",
    "county": "MONROE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004455",
    "resolved_pwsid": "MI0004455",
    "system_name": "MONROE SOUTH COUNTY",
    "display_name": "MONROE SOUTH COUNTY",
    "county": "MONROE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004455",
    "resolved_pwsid": "MI0004455",
    "system_name": "MONROE SOUTH COUNTY",
    "display_name": "MONROE SOUTH COUNTY",
    "county": "MONROE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004455",
    "resolved_pwsid": "MI0004455",
    "system_name": "MONROE SOUTH COUNTY",
    "display_name": "MONROE SOUTH COUNTY",
    "county": "MONROE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004455",
    "resolved_pwsid": "MI0004455",
    "system_name": "MONROE SOUTH COUNTY",
    "display_name": "MONROE SOUTH COUNTY",
    "county": "MONROE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004455",
    "resolved_pwsid": "MI0004455",
    "system_name": "MONROE SOUTH COUNTY",
    "display_name": "MONROE SOUTH COUNTY",
    "county": "MONROE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004455",
    "resolved_pwsid": "MI0004455",
    "system_name": "MONROE SOUTH COUNTY",
    "display_name": "MONROE SOUTH COUNTY",
    "county": "MONROE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004455",
    "resolved_pwsid": "MI0004455",
    "system_name": "MONROE SOUTH COUNTY",
    "display_name": "MONROE SOUTH COUNTY",
    "county": "MONROE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0004470",
    "resolved_pwsid": "MI0004470",
    "system_name": "MONTAGUE",
    "display_name": "MONTAGUE",
    "county": "MUSKEGON",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004470",
    "resolved_pwsid": "MI0004470",
    "system_name": "MONTAGUE",
    "display_name": "MONTAGUE",
    "county": "MUSKEGON",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": 24,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004470",
    "resolved_pwsid": "MI0004470",
    "system_name": "MONTAGUE",
    "display_name": "MONTAGUE",
    "county": "MUSKEGON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": 18,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004470",
    "resolved_pwsid": "MI0004470",
    "system_name": "MONTAGUE",
    "display_name": "MONTAGUE",
    "county": "MUSKEGON",
    "monitoring_end_date": "",
    "year": 2022,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 77,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004470",
    "resolved_pwsid": "MI0004470",
    "system_name": "MONTAGUE",
    "display_name": "MONTAGUE",
    "county": "MUSKEGON",
    "monitoring_end_date": "",
    "year": 2023,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 46,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004470",
    "resolved_pwsid": "MI0004470",
    "system_name": "MONTAGUE",
    "display_name": "MONTAGUE",
    "county": "MUSKEGON",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 24,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004480",
    "resolved_pwsid": "MI0004480",
    "system_name": "MONTROSE, CITY OF",
    "display_name": "MONTROSE, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004480",
    "resolved_pwsid": "MI0004480",
    "system_name": "MONTROSE, CITY OF",
    "display_name": "MONTROSE, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004480",
    "resolved_pwsid": "MI0004480",
    "system_name": "MONTROSE, CITY OF",
    "display_name": "MONTROSE, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004480",
    "resolved_pwsid": "MI0004480",
    "system_name": "MONTROSE, CITY OF",
    "display_name": "MONTROSE, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004480",
    "resolved_pwsid": "MI0004480",
    "system_name": "MONTROSE, CITY OF",
    "display_name": "MONTROSE, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2021-06-30",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004480",
    "resolved_pwsid": "MI0004480",
    "system_name": "MONTROSE, CITY OF",
    "display_name": "MONTROSE, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004480",
    "resolved_pwsid": "MI0004480",
    "system_name": "MONTROSE, CITY OF",
    "display_name": "MONTROSE, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 7,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004490",
    "resolved_pwsid": "MI0004490",
    "system_name": "MORENCI",
    "display_name": "MORENCI",
    "county": "LENAWEE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004490",
    "resolved_pwsid": "MI0004490",
    "system_name": "MORENCI",
    "display_name": "MORENCI",
    "county": "LENAWEE",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004490",
    "resolved_pwsid": "MI0004490",
    "system_name": "MORENCI",
    "display_name": "MORENCI",
    "county": "LENAWEE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004490",
    "resolved_pwsid": "MI0004490",
    "system_name": "MORENCI",
    "display_name": "MORENCI",
    "county": "LENAWEE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 2,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004490",
    "resolved_pwsid": "MI0004490",
    "system_name": "MORENCI",
    "display_name": "MORENCI",
    "county": "LENAWEE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004490",
    "resolved_pwsid": "MI0004490",
    "system_name": "MORENCI",
    "display_name": "MORENCI",
    "county": "LENAWEE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004490",
    "resolved_pwsid": "MI0004490",
    "system_name": "MORENCI",
    "display_name": "MORENCI",
    "county": "LENAWEE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 65,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004510",
    "resolved_pwsid": "MI0004510",
    "system_name": "MOUNT CLEMENS, CITY OF",
    "display_name": "MOUNT CLEMENS, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004510",
    "resolved_pwsid": "MI0004510",
    "system_name": "MOUNT CLEMENS, CITY OF",
    "display_name": "MOUNT CLEMENS, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004510",
    "resolved_pwsid": "MI0004510",
    "system_name": "MOUNT CLEMENS, CITY OF",
    "display_name": "MOUNT CLEMENS, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004510",
    "resolved_pwsid": "MI0004510",
    "system_name": "MOUNT CLEMENS, CITY OF",
    "display_name": "MOUNT CLEMENS, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": 11,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004510",
    "resolved_pwsid": "MI0004510",
    "system_name": "MOUNT CLEMENS, CITY OF",
    "display_name": "MOUNT CLEMENS, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": 25,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004510",
    "resolved_pwsid": "MI0004510",
    "system_name": "MOUNT CLEMENS, CITY OF",
    "display_name": "MOUNT CLEMENS, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 13,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004510",
    "resolved_pwsid": "MI0004510",
    "system_name": "MOUNT CLEMENS, CITY OF",
    "display_name": "MOUNT CLEMENS, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 35,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004510",
    "resolved_pwsid": "MI0004510",
    "system_name": "MOUNT CLEMENS, CITY OF",
    "display_name": "MOUNT CLEMENS, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 55,
    "inventory_lead": 779,
    "inventory_gpcl": 66,
    "inventory_unknown": 1817,
    "total_to_identify_or_replace": 2662,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0004520",
    "resolved_pwsid": "MI0004520",
    "system_name": "MOUNT MORRIS, CITY OF",
    "display_name": "MOUNT MORRIS, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004520",
    "resolved_pwsid": "MI0004520",
    "system_name": "MOUNT MORRIS, CITY OF",
    "display_name": "MOUNT MORRIS, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004520",
    "resolved_pwsid": "MI0004520",
    "system_name": "MOUNT MORRIS, CITY OF",
    "display_name": "MOUNT MORRIS, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004520",
    "resolved_pwsid": "MI0004520",
    "system_name": "MOUNT MORRIS, CITY OF",
    "display_name": "MOUNT MORRIS, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004520",
    "resolved_pwsid": "MI0004520",
    "system_name": "MOUNT MORRIS, CITY OF",
    "display_name": "MOUNT MORRIS, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004520",
    "resolved_pwsid": "MI0004520",
    "system_name": "MOUNT MORRIS, CITY OF",
    "display_name": "MOUNT MORRIS, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2021-06-30",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 4,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004520",
    "resolved_pwsid": "MI0004520",
    "system_name": "MOUNT MORRIS, CITY OF",
    "display_name": "MOUNT MORRIS, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004520",
    "resolved_pwsid": "MI0004520",
    "system_name": "MOUNT MORRIS, CITY OF",
    "display_name": "MOUNT MORRIS, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2022-06-30",
    "year": 2022,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": 5,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004520",
    "resolved_pwsid": "MI0004520",
    "system_name": "MOUNT MORRIS, CITY OF",
    "display_name": "MOUNT MORRIS, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": 6,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004520",
    "resolved_pwsid": "MI0004520",
    "system_name": "MOUNT MORRIS, CITY OF",
    "display_name": "MOUNT MORRIS, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 6,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004520",
    "resolved_pwsid": "MI0004520",
    "system_name": "MOUNT MORRIS, CITY OF",
    "display_name": "MOUNT MORRIS, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 12,
    "inventory_lead": 63,
    "inventory_gpcl": 59,
    "inventory_unknown": 149,
    "total_to_identify_or_replace": 271,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0004530",
    "resolved_pwsid": "MI0004530",
    "system_name": "MOUNT PLEASANT",
    "display_name": "MOUNT PLEASANT",
    "county": "ISABELLA",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004530",
    "resolved_pwsid": "MI0004530",
    "system_name": "MOUNT PLEASANT",
    "display_name": "MOUNT PLEASANT",
    "county": "ISABELLA",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004530",
    "resolved_pwsid": "MI0004530",
    "system_name": "MOUNT PLEASANT",
    "display_name": "MOUNT PLEASANT",
    "county": "ISABELLA",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004530",
    "resolved_pwsid": "MI0004530",
    "system_name": "MOUNT PLEASANT",
    "display_name": "MOUNT PLEASANT",
    "county": "ISABELLA",
    "monitoring_end_date": "",
    "year": 2022,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004550",
    "resolved_pwsid": "MI0004550",
    "system_name": "MUIR",
    "display_name": "MUIR",
    "county": "IONIA",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004550",
    "resolved_pwsid": "MI0004550",
    "system_name": "MUIR",
    "display_name": "MUIR",
    "county": "IONIA",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004550",
    "resolved_pwsid": "MI0004550",
    "system_name": "MUIR",
    "display_name": "MUIR",
    "county": "IONIA",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004550",
    "resolved_pwsid": "MI0004550",
    "system_name": "MUIR",
    "display_name": "MUIR",
    "county": "IONIA",
    "monitoring_end_date": "",
    "year": 2022,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 182,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004550",
    "resolved_pwsid": "MI0004550",
    "system_name": "MUIR",
    "display_name": "MUIR",
    "county": "IONIA",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004560",
    "resolved_pwsid": "MI0004560",
    "system_name": "MUNISING",
    "display_name": "MUNISING",
    "county": "ALGER",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004560",
    "resolved_pwsid": "MI0004560",
    "system_name": "MUNISING",
    "display_name": "MUNISING",
    "county": "ALGER",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 10,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004560",
    "resolved_pwsid": "MI0004560",
    "system_name": "MUNISING",
    "display_name": "MUNISING",
    "county": "ALGER",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 8,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004560",
    "resolved_pwsid": "MI0004560",
    "system_name": "MUNISING",
    "display_name": "MUNISING",
    "county": "ALGER",
    "monitoring_end_date": "",
    "year": 2023,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 4,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004560",
    "resolved_pwsid": "MI0004560",
    "system_name": "MUNISING",
    "display_name": "MUNISING",
    "county": "ALGER",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 7,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004561",
    "resolved_pwsid": "MI0004561",
    "system_name": "MUNISING INDUSTRIAL PARK",
    "display_name": "MUNISING INDUSTRIAL PARK",
    "county": "ALGER",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004561",
    "resolved_pwsid": "MI0004561",
    "system_name": "MUNISING INDUSTRIAL PARK",
    "display_name": "MUNISING INDUSTRIAL PARK",
    "county": "ALGER",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004561",
    "resolved_pwsid": "MI0004561",
    "system_name": "MUNISING INDUSTRIAL PARK",
    "display_name": "MUNISING INDUSTRIAL PARK",
    "county": "ALGER",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004570",
    "resolved_pwsid": "MI0004570",
    "system_name": "MUSKEGON",
    "display_name": "MUSKEGON",
    "county": "MUSKEGON",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004570",
    "resolved_pwsid": "MI0004570",
    "system_name": "MUSKEGON",
    "display_name": "MUSKEGON",
    "county": "MUSKEGON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004570",
    "resolved_pwsid": "MI0004570",
    "system_name": "MUSKEGON",
    "display_name": "MUSKEGON",
    "county": "MUSKEGON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": 446,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004570",
    "resolved_pwsid": "MI0004570",
    "system_name": "MUSKEGON",
    "display_name": "MUSKEGON",
    "county": "MUSKEGON",
    "monitoring_end_date": "",
    "year": 2021,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 336,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004570",
    "resolved_pwsid": "MI0004570",
    "system_name": "MUSKEGON",
    "display_name": "MUSKEGON",
    "county": "MUSKEGON",
    "monitoring_end_date": "",
    "year": 2022,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 180,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004570",
    "resolved_pwsid": "MI0004570",
    "system_name": "MUSKEGON",
    "display_name": "MUSKEGON",
    "county": "MUSKEGON",
    "monitoring_end_date": "",
    "year": 2024,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 609,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004570",
    "resolved_pwsid": "MI0004570",
    "system_name": "MUSKEGON",
    "display_name": "MUSKEGON",
    "county": "MUSKEGON",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 713,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004577",
    "resolved_pwsid": "MI0004577",
    "system_name": "MUSK CO NORTHSIDE WATER SYSTEM",
    "display_name": "MUSK CO NORTHSIDE WATER SYSTEM",
    "county": "MUSKEGON",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004577",
    "resolved_pwsid": "MI0004577",
    "system_name": "MUSK CO NORTHSIDE WATER SYSTEM",
    "display_name": "MUSK CO NORTHSIDE WATER SYSTEM",
    "county": "MUSKEGON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004577",
    "resolved_pwsid": "MI0004577",
    "system_name": "MUSK CO NORTHSIDE WATER SYSTEM",
    "display_name": "MUSK CO NORTHSIDE WATER SYSTEM",
    "county": "MUSKEGON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004580",
    "resolved_pwsid": "MI0004580",
    "system_name": "MUSKEGON HEIGHTS",
    "display_name": "MUSKEGON HEIGHTS",
    "county": "MUSKEGON",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004580",
    "resolved_pwsid": "MI0004580",
    "system_name": "MUSKEGON HEIGHTS",
    "display_name": "MUSKEGON HEIGHTS",
    "county": "MUSKEGON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004580",
    "resolved_pwsid": "MI0004580",
    "system_name": "MUSKEGON HEIGHTS",
    "display_name": "MUSKEGON HEIGHTS",
    "county": "MUSKEGON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": 249,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004580",
    "resolved_pwsid": "MI0004580",
    "system_name": "MUSKEGON HEIGHTS",
    "display_name": "MUSKEGON HEIGHTS",
    "county": "MUSKEGON",
    "monitoring_end_date": "",
    "year": 2021,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 27,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004580",
    "resolved_pwsid": "MI0004580",
    "system_name": "MUSKEGON HEIGHTS",
    "display_name": "MUSKEGON HEIGHTS",
    "county": "MUSKEGON",
    "monitoring_end_date": "",
    "year": 2022,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 46,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004580",
    "resolved_pwsid": "MI0004580",
    "system_name": "MUSKEGON HEIGHTS",
    "display_name": "MUSKEGON HEIGHTS",
    "county": "MUSKEGON",
    "monitoring_end_date": "",
    "year": 2024,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 371,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004580",
    "resolved_pwsid": "MI0004580",
    "system_name": "MUSKEGON HEIGHTS",
    "display_name": "MUSKEGON HEIGHTS",
    "county": "MUSKEGON",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 1223,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004590",
    "resolved_pwsid": "MI0004590",
    "system_name": "MUSKEGON CO EASTSIDE WATER SYSTEM",
    "display_name": "MUSKEGON CO EASTSIDE WATER SYSTEM",
    "county": "MUSKEGON",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004590",
    "resolved_pwsid": "MI0004590",
    "system_name": "MUSKEGON CO EASTSIDE WATER SYSTEM",
    "display_name": "MUSKEGON CO EASTSIDE WATER SYSTEM",
    "county": "MUSKEGON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004590",
    "resolved_pwsid": "MI0004590",
    "system_name": "MUSKEGON CO EASTSIDE WATER SYSTEM",
    "display_name": "MUSKEGON CO EASTSIDE WATER SYSTEM",
    "county": "MUSKEGON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004595",
    "resolved_pwsid": "MI0004595",
    "system_name": "MYSTIC RIDGE L.L.C.",
    "display_name": "MYSTIC RIDGE L.L.C.",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004595",
    "resolved_pwsid": "MI0004595",
    "system_name": "MYSTIC RIDGE L.L.C.",
    "display_name": "MYSTIC RIDGE L.L.C.",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004595",
    "resolved_pwsid": "MI0004595",
    "system_name": "MYSTIC RIDGE L.L.C.",
    "display_name": "MYSTIC RIDGE L.L.C.",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004595",
    "resolved_pwsid": "MI0004595",
    "system_name": "MYSTIC RIDGE L.L.C.",
    "display_name": "MYSTIC RIDGE L.L.C.",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004596",
    "resolved_pwsid": "MI0004596",
    "system_name": "MYSTIC VIEW APARTMENTS",
    "display_name": "MYSTIC VIEW APARTMENTS",
    "county": "ALLEGAN",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004596",
    "resolved_pwsid": "MI0004596",
    "system_name": "MYSTIC VIEW APARTMENTS",
    "display_name": "MYSTIC VIEW APARTMENTS",
    "county": "ALLEGAN",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004596",
    "resolved_pwsid": "MI0004596",
    "system_name": "MYSTIC VIEW APARTMENTS",
    "display_name": "MYSTIC VIEW APARTMENTS",
    "county": "ALLEGAN",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004596",
    "resolved_pwsid": "MI0004596",
    "system_name": "MYSTIC VIEW APARTMENTS",
    "display_name": "MYSTIC VIEW APARTMENTS",
    "county": "ALLEGAN",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004596",
    "resolved_pwsid": "MI0004596",
    "system_name": "MYSTIC VIEW APARTMENTS",
    "display_name": "MYSTIC VIEW APARTMENTS",
    "county": "ALLEGAN",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004596",
    "resolved_pwsid": "MI0004596",
    "system_name": "MYSTIC VIEW APARTMENTS",
    "display_name": "MYSTIC VIEW APARTMENTS",
    "county": "ALLEGAN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004596",
    "resolved_pwsid": "MI0004596",
    "system_name": "MYSTIC VIEW APARTMENTS",
    "display_name": "MYSTIC VIEW APARTMENTS",
    "county": "ALLEGAN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004600",
    "resolved_pwsid": "MI0004600",
    "system_name": "NAHMA TOWNSHIP",
    "display_name": "NAHMA TOWNSHIP",
    "county": "DELTA",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004600",
    "resolved_pwsid": "MI0004600",
    "system_name": "NAHMA TOWNSHIP",
    "display_name": "NAHMA TOWNSHIP",
    "county": "DELTA",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004600",
    "resolved_pwsid": "MI0004600",
    "system_name": "NAHMA TOWNSHIP",
    "display_name": "NAHMA TOWNSHIP",
    "county": "DELTA",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004600",
    "resolved_pwsid": "MI0004600",
    "system_name": "NAHMA TOWNSHIP",
    "display_name": "NAHMA TOWNSHIP",
    "county": "DELTA",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004600",
    "resolved_pwsid": "MI0004600",
    "system_name": "NAHMA TOWNSHIP",
    "display_name": "NAHMA TOWNSHIP",
    "county": "DELTA",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004600",
    "resolved_pwsid": "MI0004600",
    "system_name": "NAHMA TOWNSHIP",
    "display_name": "NAHMA TOWNSHIP",
    "county": "DELTA",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004600",
    "resolved_pwsid": "MI0004600",
    "system_name": "NAHMA TOWNSHIP",
    "display_name": "NAHMA TOWNSHIP",
    "county": "DELTA",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004600",
    "resolved_pwsid": "MI0004600",
    "system_name": "NAHMA TOWNSHIP",
    "display_name": "NAHMA TOWNSHIP",
    "county": "DELTA",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0004605",
    "resolved_pwsid": "MI0004605",
    "system_name": "NAPOLEON TOWNSHIP",
    "display_name": "NAPOLEON TOWNSHIP",
    "county": "JACKSON",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 11,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004605",
    "resolved_pwsid": "MI0004605",
    "system_name": "NAPOLEON TOWNSHIP",
    "display_name": "NAPOLEON TOWNSHIP",
    "county": "JACKSON",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004605",
    "resolved_pwsid": "MI0004605",
    "system_name": "NAPOLEON TOWNSHIP",
    "display_name": "NAPOLEON TOWNSHIP",
    "county": "JACKSON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004605",
    "resolved_pwsid": "MI0004605",
    "system_name": "NAPOLEON TOWNSHIP",
    "display_name": "NAPOLEON TOWNSHIP",
    "county": "JACKSON",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0004610",
    "resolved_pwsid": "MI0004610",
    "system_name": "IRON RIVER TOWNSHIP-NASH",
    "display_name": "IRON RIVER TOWNSHIP-NASH",
    "county": "IRON",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004610",
    "resolved_pwsid": "MI0004610",
    "system_name": "IRON RIVER TOWNSHIP-NASH",
    "display_name": "IRON RIVER TOWNSHIP-NASH",
    "county": "IRON",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004610",
    "resolved_pwsid": "MI0004610",
    "system_name": "IRON RIVER TOWNSHIP-NASH",
    "display_name": "IRON RIVER TOWNSHIP-NASH",
    "county": "IRON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004620",
    "resolved_pwsid": "MI0004620",
    "system_name": "NASHVILLE",
    "display_name": "NASHVILLE",
    "county": "BARRY",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004620",
    "resolved_pwsid": "MI0004620",
    "system_name": "NASHVILLE",
    "display_name": "NASHVILLE",
    "county": "BARRY",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004620",
    "resolved_pwsid": "MI0004620",
    "system_name": "NASHVILLE",
    "display_name": "NASHVILLE",
    "county": "BARRY",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004620",
    "resolved_pwsid": "MI0004620",
    "system_name": "NASHVILLE",
    "display_name": "NASHVILLE",
    "county": "BARRY",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004620",
    "resolved_pwsid": "MI0004620",
    "system_name": "NASHVILLE",
    "display_name": "NASHVILLE",
    "county": "BARRY",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 99,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004620",
    "resolved_pwsid": "MI0004620",
    "system_name": "NASHVILLE",
    "display_name": "NASHVILLE",
    "county": "BARRY",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 163,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004620",
    "resolved_pwsid": "MI0004620",
    "system_name": "NASHVILLE",
    "display_name": "NASHVILLE",
    "county": "BARRY",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004620",
    "resolved_pwsid": "MI0004620",
    "system_name": "NASHVILLE",
    "display_name": "NASHVILLE",
    "county": "BARRY",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 4,
    "inventory_lead": 0,
    "inventory_gpcl": 50,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 50,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0004640",
    "resolved_pwsid": "MI0004640",
    "system_name": "TILDEN TOWNSHIP",
    "display_name": "TILDEN TOWNSHIP",
    "county": "MARQUETTE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004640",
    "resolved_pwsid": "MI0004640",
    "system_name": "TILDEN TOWNSHIP",
    "display_name": "TILDEN TOWNSHIP",
    "county": "MARQUETTE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004640",
    "resolved_pwsid": "MI0004640",
    "system_name": "TILDEN TOWNSHIP",
    "display_name": "TILDEN TOWNSHIP",
    "county": "MARQUETTE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004647",
    "resolved_pwsid": "MI0004647",
    "system_name": "NAZARENE CAMP",
    "display_name": "NAZARENE CAMP",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004647",
    "resolved_pwsid": "MI0004647",
    "system_name": "NAZARENE CAMP",
    "display_name": "NAZARENE CAMP",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004647",
    "resolved_pwsid": "MI0004647",
    "system_name": "NAZARENE CAMP",
    "display_name": "NAZARENE CAMP",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004647",
    "resolved_pwsid": "MI0004647",
    "system_name": "NAZARENE CAMP",
    "display_name": "NAZARENE CAMP",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004647",
    "resolved_pwsid": "MI0004647",
    "system_name": "NAZARENE CAMP",
    "display_name": "NAZARENE CAMP",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2024-09-30",
    "year": 2024,
    "lead_90th_ppb": 20,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004647",
    "resolved_pwsid": "MI0004647",
    "system_name": "NAZARENE CAMP",
    "display_name": "NAZARENE CAMP",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 20,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004647",
    "resolved_pwsid": "MI0004647",
    "system_name": "NAZARENE CAMP",
    "display_name": "NAZARENE CAMP",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004650",
    "resolved_pwsid": "MI0004650",
    "system_name": "NEGAUNEE",
    "display_name": "NEGAUNEE",
    "county": "MARQUETTE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004650",
    "resolved_pwsid": "MI0004650",
    "system_name": "NEGAUNEE",
    "display_name": "NEGAUNEE",
    "county": "MARQUETTE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004650",
    "resolved_pwsid": "MI0004650",
    "system_name": "NEGAUNEE",
    "display_name": "NEGAUNEE",
    "county": "MARQUETTE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004650",
    "resolved_pwsid": "MI0004650",
    "system_name": "NEGAUNEE",
    "display_name": "NEGAUNEE",
    "county": "MARQUETTE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004650",
    "resolved_pwsid": "MI0004650",
    "system_name": "NEGAUNEE",
    "display_name": "NEGAUNEE",
    "county": "MARQUETTE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004650",
    "resolved_pwsid": "MI0004650",
    "system_name": "NEGAUNEE",
    "display_name": "NEGAUNEE",
    "county": "MARQUETTE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": 4,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004650",
    "resolved_pwsid": "MI0004650",
    "system_name": "NEGAUNEE",
    "display_name": "NEGAUNEE",
    "county": "MARQUETTE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 5,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004650",
    "resolved_pwsid": "MI0004650",
    "system_name": "NEGAUNEE",
    "display_name": "NEGAUNEE",
    "county": "MARQUETTE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 8,
    "inventory_lead": 0,
    "inventory_gpcl": 16,
    "inventory_unknown": 700,
    "total_to_identify_or_replace": 716,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0004655",
    "resolved_pwsid": "MI0004655",
    "system_name": "NEGAUNEE TOWNSHIP",
    "display_name": "NEGAUNEE TOWNSHIP",
    "county": "MARQUETTE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004655",
    "resolved_pwsid": "MI0004655",
    "system_name": "NEGAUNEE TOWNSHIP",
    "display_name": "NEGAUNEE TOWNSHIP",
    "county": "MARQUETTE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004655",
    "resolved_pwsid": "MI0004655",
    "system_name": "NEGAUNEE TOWNSHIP",
    "display_name": "NEGAUNEE TOWNSHIP",
    "county": "MARQUETTE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004670",
    "resolved_pwsid": "MI0004670",
    "system_name": "NEW BALTIMORE, CITY OF",
    "display_name": "NEW BALTIMORE, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004670",
    "resolved_pwsid": "MI0004670",
    "system_name": "NEW BALTIMORE, CITY OF",
    "display_name": "NEW BALTIMORE, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004670",
    "resolved_pwsid": "MI0004670",
    "system_name": "NEW BALTIMORE, CITY OF",
    "display_name": "NEW BALTIMORE, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004670",
    "resolved_pwsid": "MI0004670",
    "system_name": "NEW BALTIMORE, CITY OF",
    "display_name": "NEW BALTIMORE, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 3,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004670",
    "resolved_pwsid": "MI0004670",
    "system_name": "NEW BALTIMORE, CITY OF",
    "display_name": "NEW BALTIMORE, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 2,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004670",
    "resolved_pwsid": "MI0004670",
    "system_name": "NEW BALTIMORE, CITY OF",
    "display_name": "NEW BALTIMORE, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004670",
    "resolved_pwsid": "MI0004670",
    "system_name": "NEW BALTIMORE, CITY OF",
    "display_name": "NEW BALTIMORE, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 2,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004670",
    "resolved_pwsid": "MI0004670",
    "system_name": "NEW BALTIMORE, CITY OF",
    "display_name": "NEW BALTIMORE, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 11,
    "inventory_lead": 6,
    "inventory_gpcl": 13,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004670",
    "resolved_pwsid": "MI0004670",
    "system_name": "NEW BALTIMORE, CITY OF",
    "display_name": "NEW BALTIMORE, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2026-06-30",
    "year": 2026,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004680",
    "resolved_pwsid": "MI0004680",
    "system_name": "NEW BUFFALO",
    "display_name": "NEW BUFFALO",
    "county": "BERRIEN",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004680",
    "resolved_pwsid": "MI0004680",
    "system_name": "NEW BUFFALO",
    "display_name": "NEW BUFFALO",
    "county": "BERRIEN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004680",
    "resolved_pwsid": "MI0004680",
    "system_name": "NEW BUFFALO",
    "display_name": "NEW BUFFALO",
    "county": "BERRIEN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004685",
    "resolved_pwsid": "MI0004685",
    "system_name": "NEW BUFFALO TOWNSHIP",
    "display_name": "NEW BUFFALO TOWNSHIP",
    "county": "BERRIEN",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004685",
    "resolved_pwsid": "MI0004685",
    "system_name": "NEW BUFFALO TOWNSHIP",
    "display_name": "NEW BUFFALO TOWNSHIP",
    "county": "BERRIEN",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004685",
    "resolved_pwsid": "MI0004685",
    "system_name": "NEW BUFFALO TOWNSHIP",
    "display_name": "NEW BUFFALO TOWNSHIP",
    "county": "BERRIEN",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004685",
    "resolved_pwsid": "MI0004685",
    "system_name": "NEW BUFFALO TOWNSHIP",
    "display_name": "NEW BUFFALO TOWNSHIP",
    "county": "BERRIEN",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 4,
    "inventory_lead": 0,
    "inventory_gpcl": 4,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 4,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0004690",
    "resolved_pwsid": "MI0004690",
    "system_name": "NEW HAVEN, VILLAGE OF",
    "display_name": "NEW HAVEN, VILLAGE OF",
    "county": "MACOMB",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004690",
    "resolved_pwsid": "MI0004690",
    "system_name": "NEW HAVEN, VILLAGE OF",
    "display_name": "NEW HAVEN, VILLAGE OF",
    "county": "MACOMB",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004690",
    "resolved_pwsid": "MI0004690",
    "system_name": "NEW HAVEN, VILLAGE OF",
    "display_name": "NEW HAVEN, VILLAGE OF",
    "county": "MACOMB",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004690",
    "resolved_pwsid": "MI0004690",
    "system_name": "NEW HAVEN, VILLAGE OF",
    "display_name": "NEW HAVEN, VILLAGE OF",
    "county": "MACOMB",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004690",
    "resolved_pwsid": "MI0004690",
    "system_name": "NEW HAVEN, VILLAGE OF",
    "display_name": "NEW HAVEN, VILLAGE OF",
    "county": "MACOMB",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004690",
    "resolved_pwsid": "MI0004690",
    "system_name": "NEW HAVEN, VILLAGE OF",
    "display_name": "NEW HAVEN, VILLAGE OF",
    "county": "MACOMB",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004690",
    "resolved_pwsid": "MI0004690",
    "system_name": "NEW HAVEN, VILLAGE OF",
    "display_name": "NEW HAVEN, VILLAGE OF",
    "county": "MACOMB",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004690",
    "resolved_pwsid": "MI0004690",
    "system_name": "NEW HAVEN, VILLAGE OF",
    "display_name": "NEW HAVEN, VILLAGE OF",
    "county": "MACOMB",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004700",
    "resolved_pwsid": "MI0004700",
    "system_name": "NEW LOTHROP, VILLAGE OF",
    "display_name": "NEW LOTHROP, VILLAGE OF",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004700",
    "resolved_pwsid": "MI0004700",
    "system_name": "NEW LOTHROP, VILLAGE OF",
    "display_name": "NEW LOTHROP, VILLAGE OF",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004700",
    "resolved_pwsid": "MI0004700",
    "system_name": "NEW LOTHROP, VILLAGE OF",
    "display_name": "NEW LOTHROP, VILLAGE OF",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004700",
    "resolved_pwsid": "MI0004700",
    "system_name": "NEW LOTHROP, VILLAGE OF",
    "display_name": "NEW LOTHROP, VILLAGE OF",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "",
    "year": 2022,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 4,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004710",
    "resolved_pwsid": "MI0004710",
    "system_name": "NEWAYGO",
    "display_name": "NEWAYGO",
    "county": "NEWAYGO",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004710",
    "resolved_pwsid": "MI0004710",
    "system_name": "NEWAYGO",
    "display_name": "NEWAYGO",
    "county": "NEWAYGO",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": 6,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004710",
    "resolved_pwsid": "MI0004710",
    "system_name": "NEWAYGO",
    "display_name": "NEWAYGO",
    "county": "NEWAYGO",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004710",
    "resolved_pwsid": "MI0004710",
    "system_name": "NEWAYGO",
    "display_name": "NEWAYGO",
    "county": "NEWAYGO",
    "monitoring_end_date": "",
    "year": 2023,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 8,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004710",
    "resolved_pwsid": "MI0004710",
    "system_name": "NEWAYGO",
    "display_name": "NEWAYGO",
    "county": "NEWAYGO",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 73,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004720",
    "resolved_pwsid": "MI0004720",
    "system_name": "NEWBERRY WATER & LIGHT",
    "display_name": "NEWBERRY WATER & LIGHT",
    "county": "LUCE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004720",
    "resolved_pwsid": "MI0004720",
    "system_name": "NEWBERRY WATER & LIGHT",
    "display_name": "NEWBERRY WATER & LIGHT",
    "county": "LUCE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 10,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004720",
    "resolved_pwsid": "MI0004720",
    "system_name": "NEWBERRY WATER & LIGHT",
    "display_name": "NEWBERRY WATER & LIGHT",
    "county": "LUCE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": 4,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004720",
    "resolved_pwsid": "MI0004720",
    "system_name": "NEWBERRY WATER & LIGHT",
    "display_name": "NEWBERRY WATER & LIGHT",
    "county": "LUCE",
    "monitoring_end_date": "",
    "year": 2021,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 5,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004720",
    "resolved_pwsid": "MI0004720",
    "system_name": "NEWBERRY WATER & LIGHT",
    "display_name": "NEWBERRY WATER & LIGHT",
    "county": "LUCE",
    "monitoring_end_date": "",
    "year": 2022,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 5,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004720",
    "resolved_pwsid": "MI0004720",
    "system_name": "NEWBERRY WATER & LIGHT",
    "display_name": "NEWBERRY WATER & LIGHT",
    "county": "LUCE",
    "monitoring_end_date": "",
    "year": 2024,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 2,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004720",
    "resolved_pwsid": "MI0004720",
    "system_name": "NEWBERRY WATER & LIGHT",
    "display_name": "NEWBERRY WATER & LIGHT",
    "county": "LUCE",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 8,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004730",
    "resolved_pwsid": "MI0004730",
    "system_name": "NEWBERRY CORRECTIONAL FACILITY",
    "display_name": "NEWBERRY CORRECTIONAL FACILITY",
    "county": "LUCE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004730",
    "resolved_pwsid": "MI0004730",
    "system_name": "NEWBERRY CORRECTIONAL FACILITY",
    "display_name": "NEWBERRY CORRECTIONAL FACILITY",
    "county": "LUCE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004730",
    "resolved_pwsid": "MI0004730",
    "system_name": "NEWBERRY CORRECTIONAL FACILITY",
    "display_name": "NEWBERRY CORRECTIONAL FACILITY",
    "county": "LUCE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004730",
    "resolved_pwsid": "MI0004730",
    "system_name": "NEWBERRY CORRECTIONAL FACILITY",
    "display_name": "NEWBERRY CORRECTIONAL FACILITY",
    "county": "LUCE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004730",
    "resolved_pwsid": "MI0004730",
    "system_name": "NEWBERRY CORRECTIONAL FACILITY",
    "display_name": "NEWBERRY CORRECTIONAL FACILITY",
    "county": "LUCE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004730",
    "resolved_pwsid": "MI0004730",
    "system_name": "NEWBERRY CORRECTIONAL FACILITY",
    "display_name": "NEWBERRY CORRECTIONAL FACILITY",
    "county": "LUCE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004730",
    "resolved_pwsid": "MI0004730",
    "system_name": "NEWBERRY CORRECTIONAL FACILITY",
    "display_name": "NEWBERRY CORRECTIONAL FACILITY",
    "county": "LUCE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0004740",
    "resolved_pwsid": "MI0004740-a",
    "system_name": "NILES",
    "display_name": "NILES",
    "county": "BERRIEN",
    "monitoring_end_date": "2017-06-30",
    "year": 2017,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004740",
    "resolved_pwsid": "MI0004740-a",
    "system_name": "NILES",
    "display_name": "NILES",
    "county": "BERRIEN",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004740",
    "resolved_pwsid": "MI0004740-a",
    "system_name": "NILES",
    "display_name": "NILES",
    "county": "BERRIEN",
    "monitoring_end_date": "2021-06-30",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 14,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004740",
    "resolved_pwsid": "MI0004740-b",
    "system_name": "NILES (DIST HIGH)",
    "display_name": "NILES (DIST HIGH)",
    "county": "BERRIEN",
    "monitoring_end_date": "2021-06-30",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004740",
    "resolved_pwsid": "MI0004740-b",
    "system_name": "NILES (DIST HIGH)",
    "display_name": "NILES (DIST HIGH)",
    "county": "BERRIEN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004740",
    "resolved_pwsid": "MI0004740-c",
    "system_name": "NILES (DIST LOW)",
    "display_name": "NILES (DIST LOW)",
    "county": "BERRIEN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004740",
    "resolved_pwsid": "MI0004740-c",
    "system_name": "NILES (DIST LOW)",
    "display_name": "NILES (DIST LOW)",
    "county": "BERRIEN",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 17,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004740",
    "resolved_pwsid": "MI0004740-f",
    "system_name": "NILES (LOW)",
    "display_name": "NILES (LOW)",
    "county": "BERRIEN",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 33,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004740",
    "resolved_pwsid": "MI0004740-d",
    "system_name": "NILES (DIST)",
    "display_name": "NILES (DIST)",
    "county": "BERRIEN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 26,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004740",
    "resolved_pwsid": "MI0004740-e",
    "system_name": "NILES (DIST2)",
    "display_name": "NILES (DIST2)",
    "county": "BERRIEN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004740",
    "resolved_pwsid": "MI0004740-h",
    "system_name": "NILES (DS002)",
    "display_name": "NILES (DS002)",
    "county": "BERRIEN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004740",
    "resolved_pwsid": "MI0004740-g",
    "system_name": "NILES (DS001)",
    "display_name": "NILES",
    "county": "BERRIEN",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 41,
    "inventory_lead": 414,
    "inventory_gpcl": 8,
    "inventory_unknown": 969,
    "total_to_identify_or_replace": 1391,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0004750",
    "resolved_pwsid": "MI0004750-a",
    "system_name": "NILES TOWNSHIP",
    "display_name": "NILES TOWNSHIP",
    "county": "BERRIEN",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004750",
    "resolved_pwsid": "MI0004750-a",
    "system_name": "NILES TOWNSHIP",
    "display_name": "NILES TOWNSHIP",
    "county": "BERRIEN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004750",
    "resolved_pwsid": "MI0004750-b",
    "system_name": "NILES TOWNSHIP (DIST)",
    "display_name": "NILES TOWNSHIP (DIST)",
    "county": "BERRIEN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004750",
    "resolved_pwsid": "MI0004750-c",
    "system_name": "NILES TOWNSHIP (DIST2)",
    "display_name": "NILES TOWNSHIP (DIST2)",
    "county": "BERRIEN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004750",
    "resolved_pwsid": "MI0004750-d",
    "system_name": "NILES TOWNSHIP (DS001)",
    "display_name": "NILES TOWNSHIP (DS001)",
    "county": "BERRIEN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004750",
    "resolved_pwsid": "MI0004750-e",
    "system_name": "NILES TOWNSHIP (DS002)",
    "display_name": "NILES TOWNSHIP (DS002)",
    "county": "BERRIEN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004753",
    "resolved_pwsid": "MI0004753",
    "system_name": "NINE MILE POINTE",
    "display_name": "NINE MILE POINTE",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004753",
    "resolved_pwsid": "MI0004753",
    "system_name": "NINE MILE POINTE",
    "display_name": "NINE MILE POINTE",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004753",
    "resolved_pwsid": "MI0004753",
    "system_name": "NINE MILE POINTE",
    "display_name": "NINE MILE POINTE",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004753",
    "resolved_pwsid": "MI0004753",
    "system_name": "NINE MILE POINTE",
    "display_name": "NINE MILE POINTE",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 10,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0004754",
    "resolved_pwsid": "MI0004754",
    "system_name": "WESTERN PINES APARTMENTS",
    "display_name": "WESTERN PINES APARTMENTS",
    "county": "GENESEE",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004754",
    "resolved_pwsid": "MI0004754",
    "system_name": "WESTERN PINES APARTMENTS",
    "display_name": "WESTERN PINES APARTMENTS",
    "county": "GENESEE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004754",
    "resolved_pwsid": "MI0004754",
    "system_name": "WESTERN PINES APARTMENTS",
    "display_name": "WESTERN PINES APARTMENTS",
    "county": "GENESEE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004760",
    "resolved_pwsid": "MI0004760",
    "system_name": "PENNFIELD TOWNSHIP",
    "display_name": "PENNFIELD TOWNSHIP",
    "county": "CALHOUN",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 12,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004760",
    "resolved_pwsid": "MI0004760",
    "system_name": "PENNFIELD TOWNSHIP",
    "display_name": "PENNFIELD TOWNSHIP",
    "county": "CALHOUN",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004760",
    "resolved_pwsid": "MI0004760",
    "system_name": "PENNFIELD TOWNSHIP",
    "display_name": "PENNFIELD TOWNSHIP",
    "county": "CALHOUN",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004760",
    "resolved_pwsid": "MI0004760",
    "system_name": "PENNFIELD TOWNSHIP",
    "display_name": "PENNFIELD TOWNSHIP",
    "county": "CALHOUN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004760",
    "resolved_pwsid": "MI0004760",
    "system_name": "PENNFIELD TOWNSHIP",
    "display_name": "PENNFIELD TOWNSHIP",
    "county": "CALHOUN",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004760",
    "resolved_pwsid": "MI0004760",
    "system_name": "PENNFIELD TOWNSHIP",
    "display_name": "PENNFIELD TOWNSHIP",
    "county": "CALHOUN",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004760",
    "resolved_pwsid": "MI0004760",
    "system_name": "PENNFIELD TOWNSHIP",
    "display_name": "PENNFIELD TOWNSHIP",
    "county": "CALHOUN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004760",
    "resolved_pwsid": "MI0004760",
    "system_name": "PENNFIELD TOWNSHIP",
    "display_name": "PENNFIELD TOWNSHIP",
    "county": "CALHOUN",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 2,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 2,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0004770",
    "resolved_pwsid": "MI0004770",
    "system_name": "NORTH BRANCH, VILLAGE OF",
    "display_name": "NORTH BRANCH, VILLAGE OF",
    "county": "LAPEER",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004770",
    "resolved_pwsid": "MI0004770",
    "system_name": "NORTH BRANCH, VILLAGE OF",
    "display_name": "NORTH BRANCH, VILLAGE OF",
    "county": "LAPEER",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004770",
    "resolved_pwsid": "MI0004770",
    "system_name": "NORTH BRANCH, VILLAGE OF",
    "display_name": "NORTH BRANCH, VILLAGE OF",
    "county": "LAPEER",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004775",
    "resolved_pwsid": "MI0004775",
    "system_name": "ISHPEMING TWP - EAST",
    "display_name": "ISHPEMING TWP - EAST",
    "county": "MARQUETTE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004775",
    "resolved_pwsid": "MI0004775",
    "system_name": "ISHPEMING TWP - EAST",
    "display_name": "ISHPEMING TWP - EAST",
    "county": "MARQUETTE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004775",
    "resolved_pwsid": "MI0004775",
    "system_name": "ISHPEMING TWP - EAST",
    "display_name": "ISHPEMING TWP - EAST",
    "county": "MARQUETTE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004778",
    "resolved_pwsid": "MI0004778-b",
    "system_name": "ARBOR VIEW CONDO OWNERS ASSOCIATION",
    "display_name": "ARBOR VIEW CONDO OWNERS ASSOCIATION",
    "county": "BRANCH",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004778",
    "resolved_pwsid": "MI0004778-b",
    "system_name": "ARBOR VIEW CONDO OWNERS ASSOCIATION",
    "display_name": "ARBOR VIEW CONDO OWNERS ASSOCIATION",
    "county": "BRANCH",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004778",
    "resolved_pwsid": "MI0004778-a",
    "system_name": "ARBOR VIEW",
    "display_name": "ARBOR VIEW",
    "county": "BRANCH",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004778",
    "resolved_pwsid": "MI0004778-a",
    "system_name": "ARBOR VIEW",
    "display_name": "ARBOR VIEW",
    "county": "BRANCH",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0004780",
    "resolved_pwsid": "MI0004780",
    "system_name": "NORTH MUSKEGON",
    "display_name": "NORTH MUSKEGON",
    "county": "MUSKEGON",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004780",
    "resolved_pwsid": "MI0004780",
    "system_name": "NORTH MUSKEGON",
    "display_name": "NORTH MUSKEGON",
    "county": "MUSKEGON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004780",
    "resolved_pwsid": "MI0004780",
    "system_name": "NORTH MUSKEGON",
    "display_name": "NORTH MUSKEGON",
    "county": "MUSKEGON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": 22,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004780",
    "resolved_pwsid": "MI0004780",
    "system_name": "NORTH MUSKEGON",
    "display_name": "NORTH MUSKEGON",
    "county": "MUSKEGON",
    "monitoring_end_date": "",
    "year": 2021,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 42,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004780",
    "resolved_pwsid": "MI0004780",
    "system_name": "NORTH MUSKEGON",
    "display_name": "NORTH MUSKEGON",
    "county": "MUSKEGON",
    "monitoring_end_date": "",
    "year": 2022,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 54,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004780",
    "resolved_pwsid": "MI0004780",
    "system_name": "NORTH MUSKEGON",
    "display_name": "NORTH MUSKEGON",
    "county": "MUSKEGON",
    "monitoring_end_date": "",
    "year": 2024,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 16,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004780",
    "resolved_pwsid": "MI0004780",
    "system_name": "NORTH MUSKEGON",
    "display_name": "NORTH MUSKEGON",
    "county": "MUSKEGON",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 42,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004800",
    "resolved_pwsid": "MI0004800-a",
    "system_name": "MICHIGAN-AMERICAN WATER CO",
    "display_name": "MICHIGAN-AMERICAN WATER CO",
    "county": "HOUGHTON",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004800",
    "resolved_pwsid": "MI0004800-a",
    "system_name": "MICHIGAN-AMERICAN WATER CO",
    "display_name": "MICHIGAN-AMERICAN WATER CO",
    "county": "HOUGHTON",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004800",
    "resolved_pwsid": "MI0004800-a",
    "system_name": "MICHIGAN-AMERICAN WATER CO",
    "display_name": "MICHIGAN-AMERICAN WATER CO",
    "county": "HOUGHTON",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004800",
    "resolved_pwsid": "MI0004800-b",
    "system_name": "UPPER MICHIGAN WATER COMPANY",
    "display_name": "UPPER MICHIGAN WATER COMPANY",
    "county": "HOUGHTON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004800",
    "resolved_pwsid": "MI0004800-b",
    "system_name": "UPPER MICHIGAN WATER COMPANY",
    "display_name": "UPPER MICHIGAN WATER COMPANY",
    "county": "HOUGHTON",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 8,
    "inventory_lead": 8,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 8,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0004810",
    "resolved_pwsid": "MI0004810",
    "system_name": "NORTHPORT, VILLAGE OF",
    "display_name": "NORTHPORT, VILLAGE OF",
    "county": "LEELANAU",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004810",
    "resolved_pwsid": "MI0004810",
    "system_name": "NORTHPORT, VILLAGE OF",
    "display_name": "NORTHPORT, VILLAGE OF",
    "county": "LEELANAU",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004810",
    "resolved_pwsid": "MI0004810",
    "system_name": "NORTHPORT, VILLAGE OF",
    "display_name": "NORTHPORT, VILLAGE OF",
    "county": "LEELANAU",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004820",
    "resolved_pwsid": "MI0004820",
    "system_name": "NORTHPORT COTTAGE OWNERS",
    "display_name": "NORTHPORT COTTAGE OWNERS",
    "county": "LEELANAU",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004820",
    "resolved_pwsid": "MI0004820",
    "system_name": "NORTHPORT COTTAGE OWNERS",
    "display_name": "NORTHPORT COTTAGE OWNERS",
    "county": "LEELANAU",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004820",
    "resolved_pwsid": "MI0004820",
    "system_name": "NORTHPORT COTTAGE OWNERS",
    "display_name": "NORTHPORT COTTAGE OWNERS",
    "county": "LEELANAU",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004830",
    "resolved_pwsid": "MI0004830",
    "system_name": "NORTHVILLE",
    "display_name": "NORTHVILLE",
    "county": "WAYNE",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004830",
    "resolved_pwsid": "MI0004830",
    "system_name": "NORTHVILLE",
    "display_name": "NORTHVILLE",
    "county": "WAYNE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004830",
    "resolved_pwsid": "MI0004830",
    "system_name": "NORTHVILLE",
    "display_name": "NORTHVILLE",
    "county": "WAYNE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004830",
    "resolved_pwsid": "MI0004830",
    "system_name": "NORTHVILLE",
    "display_name": "NORTHVILLE",
    "county": "WAYNE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 5,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004830",
    "resolved_pwsid": "MI0004830",
    "system_name": "NORTHVILLE",
    "display_name": "NORTHVILLE",
    "county": "WAYNE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": 5,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004830",
    "resolved_pwsid": "MI0004830",
    "system_name": "NORTHVILLE",
    "display_name": "NORTHVILLE",
    "county": "WAYNE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 17,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004830",
    "resolved_pwsid": "MI0004830",
    "system_name": "NORTHVILLE",
    "display_name": "NORTHVILLE",
    "county": "WAYNE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 3,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004830",
    "resolved_pwsid": "MI0004830",
    "system_name": "NORTHVILLE",
    "display_name": "NORTHVILLE",
    "county": "WAYNE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 9,
    "inventory_lead": 3,
    "inventory_gpcl": 193,
    "inventory_unknown": 276,
    "total_to_identify_or_replace": 472,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0004845",
    "resolved_pwsid": "MI0004845",
    "system_name": "NORTHVILLE TOWNSHIP",
    "display_name": "NORTHVILLE TOWNSHIP",
    "county": "WAYNE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004845",
    "resolved_pwsid": "MI0004845",
    "system_name": "NORTHVILLE TOWNSHIP",
    "display_name": "NORTHVILLE TOWNSHIP",
    "county": "WAYNE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004845",
    "resolved_pwsid": "MI0004845",
    "system_name": "NORTHVILLE TOWNSHIP",
    "display_name": "NORTHVILLE TOWNSHIP",
    "county": "WAYNE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004845",
    "resolved_pwsid": "MI0004845",
    "system_name": "NORTHVILLE TOWNSHIP",
    "display_name": "NORTHVILLE TOWNSHIP",
    "county": "WAYNE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004845",
    "resolved_pwsid": "MI0004845",
    "system_name": "NORTHVILLE TOWNSHIP",
    "display_name": "NORTHVILLE TOWNSHIP",
    "county": "WAYNE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004845",
    "resolved_pwsid": "MI0004845",
    "system_name": "NORTHVILLE TOWNSHIP",
    "display_name": "NORTHVILLE TOWNSHIP",
    "county": "WAYNE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004845",
    "resolved_pwsid": "MI0004845",
    "system_name": "NORTHVILLE TOWNSHIP",
    "display_name": "NORTHVILLE TOWNSHIP",
    "county": "WAYNE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004845",
    "resolved_pwsid": "MI0004845",
    "system_name": "NORTHVILLE TOWNSHIP",
    "display_name": "NORTHVILLE TOWNSHIP",
    "county": "WAYNE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0004850",
    "resolved_pwsid": "MI0004850",
    "system_name": "NORTON SHORES",
    "display_name": "NORTON SHORES",
    "county": "MUSKEGON",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004850",
    "resolved_pwsid": "MI0004850",
    "system_name": "NORTON SHORES",
    "display_name": "NORTON SHORES",
    "county": "MUSKEGON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004850",
    "resolved_pwsid": "MI0004850",
    "system_name": "NORTON SHORES",
    "display_name": "NORTON SHORES",
    "county": "MUSKEGON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 20,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004850",
    "resolved_pwsid": "MI0004850",
    "system_name": "NORTON SHORES",
    "display_name": "NORTON SHORES",
    "county": "MUSKEGON",
    "monitoring_end_date": "",
    "year": 2021,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 27,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004850",
    "resolved_pwsid": "MI0004850",
    "system_name": "NORTON SHORES",
    "display_name": "NORTON SHORES",
    "county": "MUSKEGON",
    "monitoring_end_date": "",
    "year": 2022,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 4,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004850",
    "resolved_pwsid": "MI0004850",
    "system_name": "NORTON SHORES",
    "display_name": "NORTON SHORES",
    "county": "MUSKEGON",
    "monitoring_end_date": "",
    "year": 2024,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 6,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004850",
    "resolved_pwsid": "MI0004850",
    "system_name": "NORTON SHORES",
    "display_name": "NORTON SHORES",
    "county": "MUSKEGON",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 7,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004860",
    "resolved_pwsid": "MI0004860",
    "system_name": "NORWAY",
    "display_name": "NORWAY",
    "county": "DICKINSON",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004860",
    "resolved_pwsid": "MI0004860",
    "system_name": "NORWAY",
    "display_name": "NORWAY",
    "county": "DICKINSON",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004860",
    "resolved_pwsid": "MI0004860",
    "system_name": "NORWAY",
    "display_name": "NORWAY",
    "county": "DICKINSON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 6,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004860",
    "resolved_pwsid": "MI0004860",
    "system_name": "NORWAY",
    "display_name": "NORWAY",
    "county": "DICKINSON",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 7,
    "inventory_lead": 2,
    "inventory_gpcl": 271,
    "inventory_unknown": 1220,
    "total_to_identify_or_replace": 1493,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0004860",
    "resolved_pwsid": "MI0004860",
    "system_name": "NORWAY",
    "display_name": "NORWAY",
    "county": "DICKINSON",
    "monitoring_end_date": "",
    "year": 2021,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 8,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004860",
    "resolved_pwsid": "MI0004860",
    "system_name": "NORWAY",
    "display_name": "NORWAY",
    "county": "DICKINSON",
    "monitoring_end_date": "",
    "year": 2023,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 6,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004860",
    "resolved_pwsid": "MI0004860",
    "system_name": "NORWAY",
    "display_name": "NORWAY",
    "county": "DICKINSON",
    "monitoring_end_date": "",
    "year": 2024,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 5,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004870",
    "resolved_pwsid": "MI0004870",
    "system_name": "NOVI, CITY OF",
    "display_name": "NOVI, CITY OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004870",
    "resolved_pwsid": "MI0004870",
    "system_name": "NOVI, CITY OF",
    "display_name": "NOVI, CITY OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004870",
    "resolved_pwsid": "MI0004870",
    "system_name": "NOVI, CITY OF",
    "display_name": "NOVI, CITY OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004870",
    "resolved_pwsid": "MI0004870",
    "system_name": "NOVI, CITY OF",
    "display_name": "NOVI, CITY OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004870",
    "resolved_pwsid": "MI0004870",
    "system_name": "NOVI, CITY OF",
    "display_name": "NOVI, CITY OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004870",
    "resolved_pwsid": "MI0004870",
    "system_name": "NOVI, CITY OF",
    "display_name": "NOVI, CITY OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004870",
    "resolved_pwsid": "MI0004870",
    "system_name": "NOVI, CITY OF",
    "display_name": "NOVI, CITY OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004870",
    "resolved_pwsid": "MI0004870",
    "system_name": "NOVI, CITY OF",
    "display_name": "NOVI, CITY OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 4742,
    "total_to_identify_or_replace": 4742,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0004873",
    "resolved_pwsid": "MI0004873",
    "system_name": "OAK HAVEN",
    "display_name": "OAK HAVEN",
    "county": "ALLEGAN",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004873",
    "resolved_pwsid": "MI0004873",
    "system_name": "OAK HAVEN",
    "display_name": "OAK HAVEN",
    "county": "ALLEGAN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004873",
    "resolved_pwsid": "MI0004873",
    "system_name": "OAK HAVEN",
    "display_name": "OAK HAVEN",
    "county": "ALLEGAN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004873",
    "resolved_pwsid": "MI0004873-a",
    "system_name": "STREAMS OF LIGHT INTERNATIONAL",
    "display_name": "STREAMS OF LIGHT INTERNATIONAL",
    "county": "ALLEGAN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004874",
    "resolved_pwsid": "MI0004874",
    "system_name": "OAK LEAF MANOR",
    "display_name": "OAK LEAF MANOR",
    "county": "MONTMORENCY",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004874",
    "resolved_pwsid": "MI0004874",
    "system_name": "OAK LEAF MANOR",
    "display_name": "OAK LEAF MANOR",
    "county": "MONTMORENCY",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004874",
    "resolved_pwsid": "MI0004874",
    "system_name": "OAK LEAF MANOR",
    "display_name": "OAK LEAF MANOR",
    "county": "MONTMORENCY",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004876",
    "resolved_pwsid": "MI0004876",
    "system_name": "OAK LANE APARTMENTS",
    "display_name": "OAK LANE APARTMENTS",
    "county": "ALLEGAN",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004876",
    "resolved_pwsid": "MI0004876",
    "system_name": "OAK LANE APARTMENTS",
    "display_name": "OAK LANE APARTMENTS",
    "county": "ALLEGAN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004876",
    "resolved_pwsid": "MI0004876",
    "system_name": "OAK LANE APARTMENTS",
    "display_name": "OAK LANE APARTMENTS",
    "county": "ALLEGAN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004876",
    "resolved_pwsid": "MI0004876",
    "system_name": "OAK LANE APARTMENTS",
    "display_name": "OAK LANE APARTMENTS",
    "county": "ALLEGAN",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0004877",
    "resolved_pwsid": "MI0004877-a",
    "system_name": "SOUTHEAST OAKLAND TOWNSHIP",
    "display_name": "SOUTHEAST OAKLAND TOWNSHIP",
    "county": "OAKLAND",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004877",
    "resolved_pwsid": "MI0004877-a",
    "system_name": "SOUTHEAST OAKLAND TOWNSHIP",
    "display_name": "SOUTHEAST OAKLAND TOWNSHIP",
    "county": "OAKLAND",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004877",
    "resolved_pwsid": "MI0004877-a",
    "system_name": "SOUTHEAST OAKLAND TOWNSHIP",
    "display_name": "SOUTHEAST OAKLAND TOWNSHIP",
    "county": "OAKLAND",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004877",
    "resolved_pwsid": "MI0004877-a",
    "system_name": "SOUTHEAST OAKLAND TOWNSHIP",
    "display_name": "SOUTHEAST OAKLAND TOWNSHIP",
    "county": "OAKLAND",
    "monitoring_end_date": "2023-06-30",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004877",
    "resolved_pwsid": "MI0004877-d",
    "system_name": "SOUTHEAST OAKLAND TOWNSHIP (NORTH)",
    "display_name": "SOUTHEAST OAKLAND TOWNSHIP (NORTH)",
    "county": "OAKLAND",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004877",
    "resolved_pwsid": "MI0004877-e",
    "system_name": "SOUTHEAST OAKLAND TOWNSHIP (SOUTH)",
    "display_name": "SOUTHEAST OAKLAND TOWNSHIP (SOUTH)",
    "county": "OAKLAND",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004877",
    "resolved_pwsid": "MI0004877-d",
    "system_name": "SOUTHEAST OAKLAND TOWNSHIP (NORTH)",
    "display_name": "SOUTHEAST OAKLAND TOWNSHIP (NORTH)",
    "county": "OAKLAND",
    "monitoring_end_date": "2024-06-30",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004877",
    "resolved_pwsid": "MI0004877-e",
    "system_name": "SOUTHEAST OAKLAND TOWNSHIP (SOUTH)",
    "display_name": "SOUTHEAST OAKLAND TOWNSHIP (SOUTH)",
    "county": "OAKLAND",
    "monitoring_end_date": "2024-06-30",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004877",
    "resolved_pwsid": "MI0004877-b",
    "system_name": "SOUTHEAST OAKLAND TOWNSHIP (DIST)",
    "display_name": "SOUTHEAST OAKLAND TOWNSHIP (DIST)",
    "county": "OAKLAND",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004877",
    "resolved_pwsid": "MI0004877-c",
    "system_name": "SOUTHEAST OAKLAND TOWNSHIP (DIST2)",
    "display_name": "SOUTHEAST OAKLAND TOWNSHIP (DIST2)",
    "county": "OAKLAND",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004877",
    "resolved_pwsid": "MI0004877-f",
    "system_name": "SOUTHEAST OAKLAND TOWNSHIP (DS001)",
    "display_name": "SOUTHEAST OAKLAND TOWNSHIP",
    "county": "OAKLAND",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0004877",
    "resolved_pwsid": "MI0004877-g",
    "system_name": "SOUTHEAST OAKLAND TOWNSHIP (DS002)",
    "display_name": "SOUTHEAST OAKLAND TOWNSHIP",
    "county": "OAKLAND",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0004878",
    "resolved_pwsid": "MI0004878",
    "system_name": "SOUTHWEST OAKLAND TOWNSHIP",
    "display_name": "SOUTHWEST OAKLAND TOWNSHIP",
    "county": "OAKLAND",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004878",
    "resolved_pwsid": "MI0004878",
    "system_name": "SOUTHWEST OAKLAND TOWNSHIP",
    "display_name": "SOUTHWEST OAKLAND TOWNSHIP",
    "county": "OAKLAND",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004878",
    "resolved_pwsid": "MI0004878",
    "system_name": "SOUTHWEST OAKLAND TOWNSHIP",
    "display_name": "SOUTHWEST OAKLAND TOWNSHIP",
    "county": "OAKLAND",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004878",
    "resolved_pwsid": "MI0004878",
    "system_name": "SOUTHWEST OAKLAND TOWNSHIP",
    "display_name": "SOUTHWEST OAKLAND TOWNSHIP",
    "county": "OAKLAND",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004878",
    "resolved_pwsid": "MI0004878",
    "system_name": "SOUTHWEST OAKLAND TOWNSHIP",
    "display_name": "SOUTHWEST OAKLAND TOWNSHIP",
    "county": "OAKLAND",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0004880",
    "resolved_pwsid": "MI0004880",
    "system_name": "OAK PARK",
    "display_name": "OAK PARK",
    "county": "OAKLAND",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004880",
    "resolved_pwsid": "MI0004880",
    "system_name": "OAK PARK",
    "display_name": "OAK PARK",
    "county": "OAKLAND",
    "monitoring_end_date": "2019-09-30",
    "year": 2019,
    "lead_90th_ppb": 25,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004880",
    "resolved_pwsid": "MI0004880",
    "system_name": "OAK PARK",
    "display_name": "OAK PARK",
    "county": "OAKLAND",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 25,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004880",
    "resolved_pwsid": "MI0004880",
    "system_name": "OAK PARK",
    "display_name": "OAK PARK",
    "county": "OAKLAND",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004880",
    "resolved_pwsid": "MI0004880",
    "system_name": "OAK PARK",
    "display_name": "OAK PARK",
    "county": "OAKLAND",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004880",
    "resolved_pwsid": "MI0004880",
    "system_name": "OAK PARK",
    "display_name": "OAK PARK",
    "county": "OAKLAND",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004880",
    "resolved_pwsid": "MI0004880",
    "system_name": "OAK PARK",
    "display_name": "OAK PARK",
    "county": "OAKLAND",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004880",
    "resolved_pwsid": "MI0004880",
    "system_name": "OAK PARK",
    "display_name": "OAK PARK",
    "county": "OAKLAND",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004880",
    "resolved_pwsid": "MI0004880",
    "system_name": "OAK PARK",
    "display_name": "OAK PARK",
    "county": "OAKLAND",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004880",
    "resolved_pwsid": "MI0004880",
    "system_name": "OAK PARK",
    "display_name": "OAK PARK",
    "county": "OAKLAND",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 1243,
    "total_to_identify_or_replace": 1243,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0004890",
    "resolved_pwsid": "MI0004890",
    "system_name": "SOUTH SHORE WATER SYSTEM",
    "display_name": "SOUTH SHORE WATER SYSTEM",
    "county": "LENAWEE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004890",
    "resolved_pwsid": "MI0004890",
    "system_name": "SOUTH SHORE WATER SYSTEM",
    "display_name": "SOUTH SHORE WATER SYSTEM",
    "county": "LENAWEE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004890",
    "resolved_pwsid": "MI0004890",
    "system_name": "SOUTH SHORE WATER SYSTEM",
    "display_name": "SOUTH SHORE WATER SYSTEM",
    "county": "LENAWEE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004890",
    "resolved_pwsid": "MI0004890",
    "system_name": "SOUTH SHORE WATER SYSTEM",
    "display_name": "SOUTH SHORE WATER SYSTEM",
    "county": "LENAWEE",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004920",
    "resolved_pwsid": "MI0004920",
    "system_name": "OCEANA ACRES",
    "display_name": "OCEANA ACRES",
    "county": "OCEANA",
    "monitoring_end_date": "2021-06-30",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004920",
    "resolved_pwsid": "MI0004920",
    "system_name": "OCEANA ACRES",
    "display_name": "OCEANA ACRES",
    "county": "OCEANA",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004920",
    "resolved_pwsid": "MI0004920",
    "system_name": "OCEANA ACRES",
    "display_name": "OCEANA ACRES",
    "county": "OCEANA",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004935",
    "resolved_pwsid": "MI0004935",
    "system_name": "OGEMAW TOWNSHIP",
    "display_name": "OGEMAW TOWNSHIP",
    "county": "OGEMAW",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 11,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004935",
    "resolved_pwsid": "MI0004935",
    "system_name": "OGEMAW TOWNSHIP",
    "display_name": "OGEMAW TOWNSHIP",
    "county": "OGEMAW",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004935",
    "resolved_pwsid": "MI0004935",
    "system_name": "OGEMAW TOWNSHIP",
    "display_name": "OGEMAW TOWNSHIP",
    "county": "OGEMAW",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004935",
    "resolved_pwsid": "MI0004935",
    "system_name": "OGEMAW TOWNSHIP",
    "display_name": "OGEMAW TOWNSHIP",
    "county": "OGEMAW",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0004960",
    "resolved_pwsid": "MI0004960",
    "system_name": "OLD FARM COLONY WATER ASSOCIATION",
    "display_name": "OLD FARM COLONY WATER ASSOCIATION",
    "county": "OAKLAND",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004960",
    "resolved_pwsid": "MI0004960",
    "system_name": "OLD FARM COLONY WATER ASSOCIATION",
    "display_name": "OLD FARM COLONY WATER ASSOCIATION",
    "county": "OAKLAND",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004960",
    "resolved_pwsid": "MI0004960",
    "system_name": "OLD FARM COLONY WATER ASSOCIATION",
    "display_name": "OLD FARM COLONY WATER ASSOCIATION",
    "county": "OAKLAND",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004989",
    "resolved_pwsid": "MI0004989",
    "system_name": "OLIVE/BLENDON TWPS",
    "display_name": "OLIVE/BLENDON TWPS",
    "county": "OTTAWA",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004989",
    "resolved_pwsid": "MI0004989",
    "system_name": "OLIVE/BLENDON TWPS",
    "display_name": "OLIVE/BLENDON TWPS",
    "county": "OTTAWA",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004989",
    "resolved_pwsid": "MI0004989",
    "system_name": "OLIVE/BLENDON TWPS",
    "display_name": "OLIVE/BLENDON TWPS",
    "county": "OTTAWA",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004989",
    "resolved_pwsid": "MI0004989",
    "system_name": "OLIVE/BLENDON TWPS",
    "display_name": "OLIVE/BLENDON TWPS",
    "county": "OTTAWA",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 86,
    "total_to_identify_or_replace": 86,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0004990",
    "resolved_pwsid": "MI0004990",
    "system_name": "OLIVET, CITY OF",
    "display_name": "OLIVET, CITY OF",
    "county": "EATON",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004990",
    "resolved_pwsid": "MI0004990",
    "system_name": "OLIVET, CITY OF",
    "display_name": "OLIVET, CITY OF",
    "county": "EATON",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004990",
    "resolved_pwsid": "MI0004990",
    "system_name": "OLIVET, CITY OF",
    "display_name": "OLIVET, CITY OF",
    "county": "EATON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0004990",
    "resolved_pwsid": "MI0004990",
    "system_name": "OLIVET, CITY OF",
    "display_name": "OLIVET, CITY OF",
    "county": "EATON",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005005",
    "resolved_pwsid": "MI0005005",
    "system_name": "OMER, CITY OF",
    "display_name": "OMER, CITY OF",
    "county": "ARENAC",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005005",
    "resolved_pwsid": "MI0005005",
    "system_name": "OMER, CITY OF",
    "display_name": "OMER, CITY OF",
    "county": "ARENAC",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005005",
    "resolved_pwsid": "MI0005005",
    "system_name": "OMER, CITY OF",
    "display_name": "OMER, CITY OF",
    "county": "ARENAC",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 9,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005005",
    "resolved_pwsid": "MI0005005",
    "system_name": "OMER, CITY OF",
    "display_name": "OMER, CITY OF",
    "county": "ARENAC",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 9,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005010",
    "resolved_pwsid": "MI0005010",
    "system_name": "ONAWAY, CITY OF",
    "display_name": "ONAWAY, CITY OF",
    "county": "PRESQUE ISLE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005010",
    "resolved_pwsid": "MI0005010",
    "system_name": "ONAWAY, CITY OF",
    "display_name": "ONAWAY, CITY OF",
    "county": "PRESQUE ISLE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": 5,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005010",
    "resolved_pwsid": "MI0005010",
    "system_name": "ONAWAY, CITY OF",
    "display_name": "ONAWAY, CITY OF",
    "county": "PRESQUE ISLE",
    "monitoring_end_date": "2022-06-30",
    "year": 2022,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": 10,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005010",
    "resolved_pwsid": "MI0005010",
    "system_name": "ONAWAY, CITY OF",
    "display_name": "ONAWAY, CITY OF",
    "county": "PRESQUE ISLE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005010",
    "resolved_pwsid": "MI0005010",
    "system_name": "ONAWAY, CITY OF",
    "display_name": "ONAWAY, CITY OF",
    "county": "PRESQUE ISLE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 106,
    "inventory_lead": 177,
    "inventory_gpcl": 65,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 242,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0005010",
    "resolved_pwsid": "MI0005010",
    "system_name": "ONAWAY, CITY OF",
    "display_name": "ONAWAY, CITY OF",
    "county": "PRESQUE ISLE",
    "monitoring_end_date": "",
    "year": 2024,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 116,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005020",
    "resolved_pwsid": "MI0005020",
    "system_name": "ONSTED",
    "display_name": "ONSTED",
    "county": "LENAWEE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005020",
    "resolved_pwsid": "MI0005020",
    "system_name": "ONSTED",
    "display_name": "ONSTED",
    "county": "LENAWEE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005020",
    "resolved_pwsid": "MI0005020",
    "system_name": "ONSTED",
    "display_name": "ONSTED",
    "county": "LENAWEE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": 107,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005020",
    "resolved_pwsid": "MI0005020",
    "system_name": "ONSTED",
    "display_name": "ONSTED",
    "county": "LENAWEE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 6,
    "inventory_gpcl": null,
    "inventory_unknown": 134,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005030",
    "resolved_pwsid": "MI0005030",
    "system_name": "ONTONAGON",
    "display_name": "ONTONAGON",
    "county": "ONTONAGON",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005030",
    "resolved_pwsid": "MI0005030",
    "system_name": "ONTONAGON",
    "display_name": "ONTONAGON",
    "county": "ONTONAGON",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005030",
    "resolved_pwsid": "MI0005030",
    "system_name": "ONTONAGON",
    "display_name": "ONTONAGON",
    "county": "ONTONAGON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005030",
    "resolved_pwsid": "MI0005030",
    "system_name": "ONTONAGON",
    "display_name": "ONTONAGON",
    "county": "ONTONAGON",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005030",
    "resolved_pwsid": "MI0005030",
    "system_name": "ONTONAGON",
    "display_name": "ONTONAGON",
    "county": "ONTONAGON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005030",
    "resolved_pwsid": "MI0005030",
    "system_name": "ONTONAGON",
    "display_name": "ONTONAGON",
    "county": "ONTONAGON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005030",
    "resolved_pwsid": "MI0005030",
    "system_name": "ONTONAGON",
    "display_name": "ONTONAGON",
    "county": "ONTONAGON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005030",
    "resolved_pwsid": "MI0005030",
    "system_name": "ONTONAGON",
    "display_name": "ONTONAGON",
    "county": "ONTONAGON",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0005031",
    "resolved_pwsid": "MI0005031",
    "system_name": "ORCHARD LAKE VILLAGE",
    "display_name": "ORCHARD LAKE VILLAGE",
    "county": "OAKLAND",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005031",
    "resolved_pwsid": "MI0005031",
    "system_name": "ORCHARD LAKE VILLAGE",
    "display_name": "ORCHARD LAKE VILLAGE",
    "county": "OAKLAND",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005031",
    "resolved_pwsid": "MI0005031",
    "system_name": "ORCHARD LAKE VILLAGE",
    "display_name": "ORCHARD LAKE VILLAGE",
    "county": "OAKLAND",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005031",
    "resolved_pwsid": "MI0005031",
    "system_name": "ORCHARD LAKE VILLAGE",
    "display_name": "ORCHARD LAKE VILLAGE",
    "county": "OAKLAND",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005031",
    "resolved_pwsid": "MI0005031",
    "system_name": "ORCHARD LAKE VILLAGE",
    "display_name": "ORCHARD LAKE VILLAGE",
    "county": "OAKLAND",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005031",
    "resolved_pwsid": "MI0005031",
    "system_name": "ORCHARD LAKE VILLAGE",
    "display_name": "ORCHARD LAKE VILLAGE",
    "county": "OAKLAND",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005031",
    "resolved_pwsid": "MI0005031",
    "system_name": "ORCHARD LAKE VILLAGE",
    "display_name": "ORCHARD LAKE VILLAGE",
    "county": "OAKLAND",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005031",
    "resolved_pwsid": "MI0005031",
    "system_name": "ORCHARD LAKE VILLAGE",
    "display_name": "ORCHARD LAKE VILLAGE",
    "county": "OAKLAND",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0005033",
    "resolved_pwsid": "MI0005033",
    "system_name": "HUNTMORE ESTATES",
    "display_name": "HUNTMORE ESTATES",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005033",
    "resolved_pwsid": "MI0005033",
    "system_name": "HUNTMORE ESTATES",
    "display_name": "HUNTMORE ESTATES",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005033",
    "resolved_pwsid": "MI0005033",
    "system_name": "HUNTMORE ESTATES",
    "display_name": "HUNTMORE ESTATES",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005033",
    "resolved_pwsid": "MI0005033",
    "system_name": "HUNTMORE ESTATES",
    "display_name": "HUNTMORE ESTATES",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005033",
    "resolved_pwsid": "MI0005033",
    "system_name": "HUNTMORE ESTATES",
    "display_name": "HUNTMORE ESTATES",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2026-12-31",
    "year": 2026,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005033",
    "resolved_pwsid": "MI0005033",
    "system_name": "HUNTMORE ESTATES",
    "display_name": "HUNTMORE ESTATES",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2025-09-30",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005034",
    "resolved_pwsid": "MI0005034",
    "system_name": "ORONOKO TOWNSHIP",
    "display_name": "ORONOKO TOWNSHIP",
    "county": "BERRIEN",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005034",
    "resolved_pwsid": "MI0005034",
    "system_name": "ORONOKO TOWNSHIP",
    "display_name": "ORONOKO TOWNSHIP",
    "county": "BERRIEN",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005034",
    "resolved_pwsid": "MI0005034",
    "system_name": "ORONOKO TOWNSHIP",
    "display_name": "ORONOKO TOWNSHIP",
    "county": "BERRIEN",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 3,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005034",
    "resolved_pwsid": "MI0005034",
    "system_name": "ORONOKO TOWNSHIP",
    "display_name": "ORONOKO TOWNSHIP",
    "county": "BERRIEN",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 5,
    "inventory_lead": 400,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 400,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0005034",
    "resolved_pwsid": "MI0005034",
    "system_name": "ORONOKO TOWNSHIP",
    "display_name": "ORONOKO TOWNSHIP",
    "county": "BERRIEN",
    "monitoring_end_date": "",
    "year": 2021,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 2,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005034",
    "resolved_pwsid": "MI0005034",
    "system_name": "ORONOKO TOWNSHIP",
    "display_name": "ORONOKO TOWNSHIP",
    "county": "BERRIEN",
    "monitoring_end_date": "",
    "year": 2023,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 9,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005034",
    "resolved_pwsid": "MI0005034",
    "system_name": "ORONOKO TOWNSHIP",
    "display_name": "ORONOKO TOWNSHIP",
    "county": "BERRIEN",
    "monitoring_end_date": "",
    "year": 2024,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 6,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005035",
    "resolved_pwsid": "MI0005035",
    "system_name": "ORION TOWNSHIP",
    "display_name": "ORION TOWNSHIP",
    "county": "OAKLAND",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005035",
    "resolved_pwsid": "MI0005035",
    "system_name": "ORION TOWNSHIP",
    "display_name": "ORION TOWNSHIP",
    "county": "OAKLAND",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005035",
    "resolved_pwsid": "MI0005035",
    "system_name": "ORION TOWNSHIP",
    "display_name": "ORION TOWNSHIP",
    "county": "OAKLAND",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005035",
    "resolved_pwsid": "MI0005035",
    "system_name": "ORION TOWNSHIP",
    "display_name": "ORION TOWNSHIP",
    "county": "OAKLAND",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005035",
    "resolved_pwsid": "MI0005035",
    "system_name": "ORION TOWNSHIP",
    "display_name": "ORION TOWNSHIP",
    "county": "OAKLAND",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005035",
    "resolved_pwsid": "MI0005035",
    "system_name": "ORION TOWNSHIP",
    "display_name": "ORION TOWNSHIP",
    "county": "OAKLAND",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005035",
    "resolved_pwsid": "MI0005035",
    "system_name": "ORION TOWNSHIP",
    "display_name": "ORION TOWNSHIP",
    "county": "OAKLAND",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005035",
    "resolved_pwsid": "MI0005035",
    "system_name": "ORION TOWNSHIP",
    "display_name": "ORION TOWNSHIP",
    "county": "OAKLAND",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 2474,
    "total_to_identify_or_replace": 2474,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0005037",
    "resolved_pwsid": "MI0005037",
    "system_name": "OSBORN LAKE ESTATES",
    "display_name": "OSBORN LAKE ESTATES",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005037",
    "resolved_pwsid": "MI0005037",
    "system_name": "OSBORN LAKE ESTATES",
    "display_name": "OSBORN LAKE ESTATES",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005037",
    "resolved_pwsid": "MI0005037",
    "system_name": "OSBORN LAKE ESTATES",
    "display_name": "OSBORN LAKE ESTATES",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005037",
    "resolved_pwsid": "MI0005037",
    "system_name": "OSBORN LAKE ESTATES",
    "display_name": "OSBORN LAKE ESTATES",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005037",
    "resolved_pwsid": "MI0005037",
    "system_name": "OSBORN LAKE ESTATES",
    "display_name": "OSBORN LAKE ESTATES",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0005039",
    "resolved_pwsid": "MI0005039",
    "system_name": "ORCHARD PLACE MANOR APARTMENTS",
    "display_name": "ORCHARD PLACE MANOR APARTMENTS",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005039",
    "resolved_pwsid": "MI0005039",
    "system_name": "ORCHARD PLACE MANOR APARTMENTS",
    "display_name": "ORCHARD PLACE MANOR APARTMENTS",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005039",
    "resolved_pwsid": "MI0005039",
    "system_name": "ORCHARD PLACE MANOR APARTMENTS",
    "display_name": "ORCHARD PLACE MANOR APARTMENTS",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005039",
    "resolved_pwsid": "MI0005039",
    "system_name": "ORCHARD PLACE MANOR APARTMENTS",
    "display_name": "ORCHARD PLACE MANOR APARTMENTS",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005039",
    "resolved_pwsid": "MI0005039",
    "system_name": "ORCHARD PLACE MANOR APARTMENTS",
    "display_name": "ORCHARD PLACE MANOR APARTMENTS",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005040",
    "resolved_pwsid": "MI0005040",
    "system_name": "OSCODA TOWNSHIP",
    "display_name": "OSCODA TOWNSHIP",
    "county": "IOSCO",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005040",
    "resolved_pwsid": "MI0005040",
    "system_name": "OSCODA TOWNSHIP",
    "display_name": "OSCODA TOWNSHIP",
    "county": "IOSCO",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005040",
    "resolved_pwsid": "MI0005040",
    "system_name": "OSCODA TOWNSHIP",
    "display_name": "OSCODA TOWNSHIP",
    "county": "IOSCO",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005040",
    "resolved_pwsid": "MI0005040",
    "system_name": "OSCODA TOWNSHIP",
    "display_name": "OSCODA TOWNSHIP",
    "county": "IOSCO",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": 0,
    "inventory_gpcl": 6,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 6,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0005050",
    "resolved_pwsid": "MI0005050",
    "system_name": "OTISVILLE, VILLAGE OF",
    "display_name": "OTISVILLE, VILLAGE OF",
    "county": "GENESEE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005050",
    "resolved_pwsid": "MI0005050",
    "system_name": "OTISVILLE, VILLAGE OF",
    "display_name": "OTISVILLE, VILLAGE OF",
    "county": "GENESEE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005050",
    "resolved_pwsid": "MI0005050",
    "system_name": "OTISVILLE, VILLAGE OF",
    "display_name": "OTISVILLE, VILLAGE OF",
    "county": "GENESEE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005050",
    "resolved_pwsid": "MI0005050",
    "system_name": "OTISVILLE, VILLAGE OF",
    "display_name": "OTISVILLE, VILLAGE OF",
    "county": "GENESEE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005050",
    "resolved_pwsid": "MI0005050",
    "system_name": "OTISVILLE, VILLAGE OF",
    "display_name": "OTISVILLE, VILLAGE OF",
    "county": "GENESEE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005050",
    "resolved_pwsid": "MI0005050",
    "system_name": "OTISVILLE, VILLAGE OF",
    "display_name": "OTISVILLE, VILLAGE OF",
    "county": "GENESEE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005060",
    "resolved_pwsid": "MI0005060",
    "system_name": "OTSEGO",
    "display_name": "OTSEGO",
    "county": "ALLEGAN",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005060",
    "resolved_pwsid": "MI0005060",
    "system_name": "OTSEGO",
    "display_name": "OTSEGO",
    "county": "ALLEGAN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 8,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005060",
    "resolved_pwsid": "MI0005060",
    "system_name": "OTSEGO",
    "display_name": "OTSEGO",
    "county": "ALLEGAN",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 21,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005060",
    "resolved_pwsid": "MI0005060",
    "system_name": "OTSEGO",
    "display_name": "OTSEGO",
    "county": "ALLEGAN",
    "monitoring_end_date": "2024-06-30",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 36,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005060",
    "resolved_pwsid": "MI0005060",
    "system_name": "OTSEGO",
    "display_name": "OTSEGO",
    "county": "ALLEGAN",
    "monitoring_end_date": "2024-06-30",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005060",
    "resolved_pwsid": "MI0005060",
    "system_name": "OTSEGO",
    "display_name": "OTSEGO",
    "county": "ALLEGAN",
    "monitoring_end_date": "",
    "year": 2022,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 11,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005060",
    "resolved_pwsid": "MI0005060",
    "system_name": "OTSEGO",
    "display_name": "OTSEGO",
    "county": "ALLEGAN",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 43,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005065",
    "resolved_pwsid": "MI0005065",
    "system_name": "OTSEGO TOWNSHIP",
    "display_name": "OTSEGO TOWNSHIP",
    "county": "ALLEGAN",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005065",
    "resolved_pwsid": "MI0005065",
    "system_name": "OTSEGO TOWNSHIP",
    "display_name": "OTSEGO TOWNSHIP",
    "county": "ALLEGAN",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005065",
    "resolved_pwsid": "MI0005065",
    "system_name": "OTSEGO TOWNSHIP",
    "display_name": "OTSEGO TOWNSHIP",
    "county": "ALLEGAN",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005065",
    "resolved_pwsid": "MI0005065",
    "system_name": "OTSEGO TOWNSHIP",
    "display_name": "OTSEGO TOWNSHIP",
    "county": "ALLEGAN",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005100",
    "resolved_pwsid": "MI0005100",
    "system_name": "OVID, CITY OF",
    "display_name": "OVID, CITY OF",
    "county": "CLINTON",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005100",
    "resolved_pwsid": "MI0005100",
    "system_name": "OVID, CITY OF",
    "display_name": "OVID, CITY OF",
    "county": "CLINTON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005100",
    "resolved_pwsid": "MI0005100",
    "system_name": "OVID, CITY OF",
    "display_name": "OVID, CITY OF",
    "county": "CLINTON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 3,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005100",
    "resolved_pwsid": "MI0005100",
    "system_name": "OVID, CITY OF",
    "display_name": "OVID, CITY OF",
    "county": "CLINTON",
    "monitoring_end_date": "",
    "year": 2024,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 174,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005100",
    "resolved_pwsid": "MI0005100",
    "system_name": "OVID, CITY OF",
    "display_name": "OVID, CITY OF",
    "county": "CLINTON",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 4,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005110",
    "resolved_pwsid": "MI0005110",
    "system_name": "OWENDALE, VILLAGE OF",
    "display_name": "OWENDALE, VILLAGE OF",
    "county": "HURON",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005110",
    "resolved_pwsid": "MI0005110",
    "system_name": "OWENDALE, VILLAGE OF",
    "display_name": "OWENDALE, VILLAGE OF",
    "county": "HURON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005110",
    "resolved_pwsid": "MI0005110",
    "system_name": "OWENDALE, VILLAGE OF",
    "display_name": "OWENDALE, VILLAGE OF",
    "county": "HURON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005110",
    "resolved_pwsid": "MI0005110",
    "system_name": "OWENDALE, VILLAGE OF",
    "display_name": "OWENDALE, VILLAGE OF",
    "county": "HURON",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005120",
    "resolved_pwsid": "MI0005120",
    "system_name": "OWOSSO, CITY OF",
    "display_name": "OWOSSO, CITY OF",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005120",
    "resolved_pwsid": "MI0005120",
    "system_name": "OWOSSO, CITY OF",
    "display_name": "OWOSSO, CITY OF",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2020-09-30",
    "year": 2020,
    "lead_90th_ppb": 21,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005120",
    "resolved_pwsid": "MI0005120",
    "system_name": "OWOSSO, CITY OF",
    "display_name": "OWOSSO, CITY OF",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 21,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005120",
    "resolved_pwsid": "MI0005120",
    "system_name": "OWOSSO, CITY OF",
    "display_name": "OWOSSO, CITY OF",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2021-06-30",
    "year": 2021,
    "lead_90th_ppb": 10,
    "above_action_level": false,
    "lines_replaced": 85,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005120",
    "resolved_pwsid": "MI0005120",
    "system_name": "OWOSSO, CITY OF",
    "display_name": "OWOSSO, CITY OF",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 11,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005120",
    "resolved_pwsid": "MI0005120",
    "system_name": "OWOSSO, CITY OF",
    "display_name": "OWOSSO, CITY OF",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": 236,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005120",
    "resolved_pwsid": "MI0005120",
    "system_name": "OWOSSO, CITY OF",
    "display_name": "OWOSSO, CITY OF",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": 362,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005120",
    "resolved_pwsid": "MI0005120",
    "system_name": "OWOSSO, CITY OF",
    "display_name": "OWOSSO, CITY OF",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": 276,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005120",
    "resolved_pwsid": "MI0005120",
    "system_name": "OWOSSO, CITY OF",
    "display_name": "OWOSSO, CITY OF",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 9,
    "above_action_level": false,
    "lines_replaced": 260,
    "inventory_lead": 1950,
    "inventory_gpcl": 1809,
    "inventory_unknown": 13,
    "total_to_identify_or_replace": 3772,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0005130",
    "resolved_pwsid": "MI0005130",
    "system_name": "OXFORD, VILLAGE OF",
    "display_name": "OXFORD, VILLAGE OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005130",
    "resolved_pwsid": "MI0005130",
    "system_name": "OXFORD, VILLAGE OF",
    "display_name": "OXFORD, VILLAGE OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005130",
    "resolved_pwsid": "MI0005130",
    "system_name": "OXFORD, VILLAGE OF",
    "display_name": "OXFORD, VILLAGE OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005130",
    "resolved_pwsid": "MI0005130",
    "system_name": "OXFORD, VILLAGE OF",
    "display_name": "OXFORD, VILLAGE OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 16,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005130",
    "resolved_pwsid": "MI0005130",
    "system_name": "OXFORD, VILLAGE OF",
    "display_name": "OXFORD, VILLAGE OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 32,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005130",
    "resolved_pwsid": "MI0005130",
    "system_name": "OXFORD, VILLAGE OF",
    "display_name": "OXFORD, VILLAGE OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 50,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005130",
    "resolved_pwsid": "MI0005130",
    "system_name": "OXFORD, VILLAGE OF",
    "display_name": "OXFORD, VILLAGE OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005130",
    "resolved_pwsid": "MI0005130",
    "system_name": "OXFORD, VILLAGE OF",
    "display_name": "OXFORD, VILLAGE OF",
    "county": "OAKLAND",
    "monitoring_end_date": "",
    "year": 2024,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 47,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005130",
    "resolved_pwsid": "MI0005130",
    "system_name": "OXFORD, VILLAGE OF",
    "display_name": "OXFORD, VILLAGE OF",
    "county": "OAKLAND",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 9,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005136",
    "resolved_pwsid": "MI0005136",
    "system_name": "OXFORD VILLAGE CONDOMINIUMS",
    "display_name": "OXFORD VILLAGE CONDOMINIUMS",
    "county": "OAKLAND",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005136",
    "resolved_pwsid": "MI0005136",
    "system_name": "OXFORD VILLAGE CONDOMINIUMS",
    "display_name": "OXFORD VILLAGE CONDOMINIUMS",
    "county": "OAKLAND",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005136",
    "resolved_pwsid": "MI0005136",
    "system_name": "OXFORD VILLAGE CONDOMINIUMS",
    "display_name": "OXFORD VILLAGE CONDOMINIUMS",
    "county": "OAKLAND",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005136",
    "resolved_pwsid": "MI0005136",
    "system_name": "OXFORD VILLAGE CONDOMINIUMS",
    "display_name": "OXFORD VILLAGE CONDOMINIUMS",
    "county": "OAKLAND",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005138",
    "resolved_pwsid": "MI0005138",
    "system_name": "OXFORD TOWNSHIP",
    "display_name": "OXFORD TOWNSHIP",
    "county": "OAKLAND",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005138",
    "resolved_pwsid": "MI0005138",
    "system_name": "OXFORD TOWNSHIP",
    "display_name": "OXFORD TOWNSHIP",
    "county": "OAKLAND",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005138",
    "resolved_pwsid": "MI0005138",
    "system_name": "OXFORD TOWNSHIP",
    "display_name": "OXFORD TOWNSHIP",
    "county": "OAKLAND",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005138",
    "resolved_pwsid": "MI0005138",
    "system_name": "OXFORD TOWNSHIP",
    "display_name": "OXFORD TOWNSHIP",
    "county": "OAKLAND",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005150",
    "resolved_pwsid": "MI0005150",
    "system_name": "OYSTER POINTE CONDOMINIUMS",
    "display_name": "OYSTER POINTE CONDOMINIUMS",
    "county": "OAKLAND",
    "monitoring_end_date": "2024-06-30",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005150",
    "resolved_pwsid": "MI0005150",
    "system_name": "OYSTER POINTE CONDOMINIUMS",
    "display_name": "OYSTER POINTE CONDOMINIUMS",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005160",
    "resolved_pwsid": "MI0005160",
    "system_name": "RICHMOND TOWNSHIP",
    "display_name": "RICHMOND TOWNSHIP",
    "county": "MARQUETTE",
    "monitoring_end_date": "2015-12-31",
    "year": 2015,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005160",
    "resolved_pwsid": "MI0005160",
    "system_name": "RICHMOND TOWNSHIP",
    "display_name": "RICHMOND TOWNSHIP",
    "county": "MARQUETTE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005160",
    "resolved_pwsid": "MI0005160",
    "system_name": "RICHMOND TOWNSHIP",
    "display_name": "RICHMOND TOWNSHIP",
    "county": "MARQUETTE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005160",
    "resolved_pwsid": "MI0005160",
    "system_name": "RICHMOND TOWNSHIP",
    "display_name": "RICHMOND TOWNSHIP",
    "county": "MARQUETTE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005180",
    "resolved_pwsid": "MI0005180",
    "system_name": "MAN NOR FARMS SUBDIVISION",
    "display_name": "MAN NOR FARMS SUBDIVISION",
    "county": "LENAWEE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005180",
    "resolved_pwsid": "MI0005180",
    "system_name": "MAN NOR FARMS SUBDIVISION",
    "display_name": "MAN NOR FARMS SUBDIVISION",
    "county": "LENAWEE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005180",
    "resolved_pwsid": "MI0005180",
    "system_name": "MAN NOR FARMS SUBDIVISION",
    "display_name": "MAN NOR FARMS SUBDIVISION",
    "county": "LENAWEE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005200",
    "resolved_pwsid": "MI0005200",
    "system_name": "PARCHMENT",
    "display_name": "PARCHMENT",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 16,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005200",
    "resolved_pwsid": "MI0005200",
    "system_name": "PARCHMENT",
    "display_name": "PARCHMENT",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 58,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005200",
    "resolved_pwsid": "MI0005200",
    "system_name": "PARCHMENT",
    "display_name": "PARCHMENT",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 89,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005200",
    "resolved_pwsid": "MI0005200",
    "system_name": "PARCHMENT",
    "display_name": "PARCHMENT",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005203",
    "resolved_pwsid": "MI0005203",
    "system_name": "PARK TOWNSHIP (HBPW SERVICE AREA)",
    "display_name": "PARK TOWNSHIP (HBPW SERVICE AREA)",
    "county": "OTTAWA",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005203",
    "resolved_pwsid": "MI0005203",
    "system_name": "PARK TOWNSHIP (HBPW SERVICE AREA)",
    "display_name": "PARK TOWNSHIP (HBPW SERVICE AREA)",
    "county": "OTTAWA",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005203",
    "resolved_pwsid": "MI0005203",
    "system_name": "PARK TOWNSHIP (HBPW SERVICE AREA)",
    "display_name": "PARK TOWNSHIP (HBPW SERVICE AREA)",
    "county": "OTTAWA",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005204",
    "resolved_pwsid": "MI0005204",
    "system_name": "PARMA, VILLAGE OF",
    "display_name": "PARMA, VILLAGE OF",
    "county": "JACKSON",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005204",
    "resolved_pwsid": "MI0005204",
    "system_name": "PARMA, VILLAGE OF",
    "display_name": "PARMA, VILLAGE OF",
    "county": "JACKSON",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005204",
    "resolved_pwsid": "MI0005204",
    "system_name": "PARMA, VILLAGE OF",
    "display_name": "PARMA, VILLAGE OF",
    "county": "JACKSON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005205",
    "resolved_pwsid": "MI0005205",
    "system_name": "PARMA TOWNSHIP-AMBERTON VILL.",
    "display_name": "PARMA TOWNSHIP-AMBERTON VILL.",
    "county": "JACKSON",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005205",
    "resolved_pwsid": "MI0005205",
    "system_name": "PARMA TOWNSHIP-AMBERTON VILL.",
    "display_name": "PARMA TOWNSHIP-AMBERTON VILL.",
    "county": "JACKSON",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005205",
    "resolved_pwsid": "MI0005205",
    "system_name": "PARMA TOWNSHIP-AMBERTON VILL.",
    "display_name": "PARMA TOWNSHIP-AMBERTON VILL.",
    "county": "JACKSON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005209",
    "resolved_pwsid": "MI0005209-a",
    "system_name": "PAW PAW APTS - WEST MAPLE LAKE (DIST1)",
    "display_name": "PAW PAW APTS - WEST MAPLE LAKE (DIST1)",
    "county": "VAN BUREN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005209",
    "resolved_pwsid": "MI0005209-b",
    "system_name": "PAW PAW APTS - WEST MAPLE LAKE (DIST2)",
    "display_name": "PAW PAW APTS - WEST MAPLE LAKE (DIST2)",
    "county": "VAN BUREN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005209",
    "resolved_pwsid": "MI0005209-c",
    "system_name": "PAW PAW APTS - WEST MAPLE LAKE (EAST)",
    "display_name": "PAW PAW APTS - WEST MAPLE LAKE (EAST)",
    "county": "VAN BUREN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005209",
    "resolved_pwsid": "MI0005209-d",
    "system_name": "PAW PAW APTS - WEST MAPLE LAKE (WEST)",
    "display_name": "PAW PAW APTS - WEST MAPLE LAKE (WEST)",
    "county": "VAN BUREN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005209",
    "resolved_pwsid": "MI0005209-c",
    "system_name": "PAW PAW APTS - WEST MAPLE LAKE (EAST)",
    "display_name": "PAW PAW APTS - WEST MAPLE LAKE (EAST)",
    "county": "VAN BUREN",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005209",
    "resolved_pwsid": "MI0005209-d",
    "system_name": "PAW PAW APTS - WEST MAPLE LAKE (WEST)",
    "display_name": "PAW PAW APTS - WEST MAPLE LAKE (WEST)",
    "county": "VAN BUREN",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005209",
    "resolved_pwsid": "MI0005209-c",
    "system_name": "PAW PAW APTS - WEST MAPLE LAKE (EAST)",
    "display_name": "PAW PAW APTS - WEST MAPLE LAKE (EAST)",
    "county": "VAN BUREN",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005209",
    "resolved_pwsid": "MI0005209-d",
    "system_name": "PAW PAW APTS - WEST MAPLE LAKE (WEST)",
    "display_name": "PAW PAW APTS - WEST MAPLE LAKE (WEST)",
    "county": "VAN BUREN",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005209",
    "resolved_pwsid": "MI0005209-a",
    "system_name": "PAW PAW APTS - WEST MAPLE LAKE (DIST1)",
    "display_name": "PAW PAW APTS - WEST MAPLE LAKE (DIST1)",
    "county": "VAN BUREN",
    "monitoring_end_date": "2024-06-30",
    "year": 2024,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005209",
    "resolved_pwsid": "MI0005209-b",
    "system_name": "PAW PAW APTS - WEST MAPLE LAKE (DIST2)",
    "display_name": "PAW PAW APTS - WEST MAPLE LAKE (DIST2)",
    "county": "VAN BUREN",
    "monitoring_end_date": "2024-06-30",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005209",
    "resolved_pwsid": "MI0005209-c",
    "system_name": "PAW PAW APTS - WEST MAPLE LAKE (EAST)",
    "display_name": "PAW PAW APTS - WEST MAPLE LAKE (EAST)",
    "county": "VAN BUREN",
    "monitoring_end_date": "2024-06-30",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005209",
    "resolved_pwsid": "MI0005209-d",
    "system_name": "PAW PAW APTS - WEST MAPLE LAKE (WEST)",
    "display_name": "PAW PAW APTS - WEST MAPLE LAKE (WEST)",
    "county": "VAN BUREN",
    "monitoring_end_date": "2024-06-30",
    "year": 2024,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005209",
    "resolved_pwsid": "MI0005209-f",
    "system_name": "PAW PAW APTS - WEST MAPLE LAKE (DS002)",
    "display_name": "PAW PAW APTS - WEST MAPLE LAKE (DS002)",
    "county": "VAN BUREN",
    "monitoring_end_date": "2024-06-30",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005209",
    "resolved_pwsid": "MI0005209-e",
    "system_name": "PAW PAW APTS - WEST MAPLE LAKE  (DS001)",
    "display_name": "PAW PAW APTS - WEST MAPLE LAKE",
    "county": "VAN BUREN",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0005210",
    "resolved_pwsid": "MI0005210",
    "system_name": "PAW PAW",
    "display_name": "PAW PAW",
    "county": "VAN BUREN",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005210",
    "resolved_pwsid": "MI0005210",
    "system_name": "PAW PAW",
    "display_name": "PAW PAW",
    "county": "VAN BUREN",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005210",
    "resolved_pwsid": "MI0005210",
    "system_name": "PAW PAW",
    "display_name": "PAW PAW",
    "county": "VAN BUREN",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 432,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005210",
    "resolved_pwsid": "MI0005210",
    "system_name": "PAW PAW",
    "display_name": "PAW PAW",
    "county": "VAN BUREN",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005210",
    "resolved_pwsid": "MI0005210",
    "system_name": "PAW PAW",
    "display_name": "PAW PAW",
    "county": "VAN BUREN",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 12,
    "inventory_lead": 0,
    "inventory_gpcl": 56,
    "inventory_unknown": 208,
    "total_to_identify_or_replace": 264,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0005210",
    "resolved_pwsid": "MI0005210",
    "system_name": "PAW PAW",
    "display_name": "PAW PAW",
    "county": "VAN BUREN",
    "monitoring_end_date": "",
    "year": 2021,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 3,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005210",
    "resolved_pwsid": "MI0005210",
    "system_name": "PAW PAW",
    "display_name": "PAW PAW",
    "county": "VAN BUREN",
    "monitoring_end_date": "",
    "year": 2023,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 68,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005210",
    "resolved_pwsid": "MI0005210",
    "system_name": "PAW PAW",
    "display_name": "PAW PAW",
    "county": "VAN BUREN",
    "monitoring_end_date": "",
    "year": 2024,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 19,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005220",
    "resolved_pwsid": "MI0005220",
    "system_name": "PECK, VILLAGE OF",
    "display_name": "PECK, VILLAGE OF",
    "county": "SANILAC",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005220",
    "resolved_pwsid": "MI0005220",
    "system_name": "PECK, VILLAGE OF",
    "display_name": "PECK, VILLAGE OF",
    "county": "SANILAC",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005220",
    "resolved_pwsid": "MI0005220",
    "system_name": "PECK, VILLAGE OF",
    "display_name": "PECK, VILLAGE OF",
    "county": "SANILAC",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005220",
    "resolved_pwsid": "MI0005220",
    "system_name": "PECK, VILLAGE OF",
    "display_name": "PECK, VILLAGE OF",
    "county": "SANILAC",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005229",
    "resolved_pwsid": "MI0005229",
    "system_name": "THE PENINSULA DEVELOPMENT LLC",
    "display_name": "THE PENINSULA DEVELOPMENT LLC",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005229",
    "resolved_pwsid": "MI0005229",
    "system_name": "THE PENINSULA DEVELOPMENT LLC",
    "display_name": "THE PENINSULA DEVELOPMENT LLC",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005229",
    "resolved_pwsid": "MI0005229",
    "system_name": "THE PENINSULA DEVELOPMENT LLC",
    "display_name": "THE PENINSULA DEVELOPMENT LLC",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005229",
    "resolved_pwsid": "MI0005229",
    "system_name": "THE PENINSULA DEVELOPMENT LLC",
    "display_name": "THE PENINSULA DEVELOPMENT LLC",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005229",
    "resolved_pwsid": "MI0005229",
    "system_name": "THE PENINSULA DEVELOPMENT LLC",
    "display_name": "THE PENINSULA DEVELOPMENT LLC",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005232",
    "resolved_pwsid": "MI0005232",
    "system_name": "PENNFIELD TWP-CONVIS/VERONA",
    "display_name": "PENNFIELD TWP-CONVIS/VERONA",
    "county": "CALHOUN",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005232",
    "resolved_pwsid": "MI0005232",
    "system_name": "PENNFIELD TWP-CONVIS/VERONA",
    "display_name": "PENNFIELD TWP-CONVIS/VERONA",
    "county": "CALHOUN",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005232",
    "resolved_pwsid": "MI0005232",
    "system_name": "PENNFIELD TWP-CONVIS/VERONA",
    "display_name": "PENNFIELD TWP-CONVIS/VERONA",
    "county": "CALHOUN",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005232",
    "resolved_pwsid": "MI0005232",
    "system_name": "PENNFIELD TWP-CONVIS/VERONA",
    "display_name": "PENNFIELD TWP-CONVIS/VERONA",
    "county": "CALHOUN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005232",
    "resolved_pwsid": "MI0005232",
    "system_name": "PENNFIELD TWP-CONVIS/VERONA",
    "display_name": "PENNFIELD TWP-CONVIS/VERONA",
    "county": "CALHOUN",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005232",
    "resolved_pwsid": "MI0005232",
    "system_name": "PENNFIELD TWP-CONVIS/VERONA",
    "display_name": "PENNFIELD TWP-CONVIS/VERONA",
    "county": "CALHOUN",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005232",
    "resolved_pwsid": "MI0005232",
    "system_name": "PENNFIELD TWP-CONVIS/VERONA",
    "display_name": "PENNFIELD TWP-CONVIS/VERONA",
    "county": "CALHOUN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005232",
    "resolved_pwsid": "MI0005232",
    "system_name": "PENNFIELD TWP-CONVIS/VERONA",
    "display_name": "PENNFIELD TWP-CONVIS/VERONA",
    "county": "CALHOUN",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 2,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 2,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0005233",
    "resolved_pwsid": "MI0005233",
    "system_name": "PENINSULA TOWNSHIP",
    "display_name": "PENINSULA TOWNSHIP",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005233",
    "resolved_pwsid": "MI0005233",
    "system_name": "PENINSULA TOWNSHIP",
    "display_name": "PENINSULA TOWNSHIP",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005233",
    "resolved_pwsid": "MI0005233",
    "system_name": "PENINSULA TOWNSHIP",
    "display_name": "PENINSULA TOWNSHIP",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005233",
    "resolved_pwsid": "MI0005233",
    "system_name": "PENINSULA TOWNSHIP",
    "display_name": "PENINSULA TOWNSHIP",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005234",
    "resolved_pwsid": "MI0005234",
    "system_name": "CASS COUNTY WATER SYSTEM",
    "display_name": "CASS COUNTY WATER SYSTEM",
    "county": "CASS",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005234",
    "resolved_pwsid": "MI0005234",
    "system_name": "CASS COUNTY WATER SYSTEM",
    "display_name": "CASS COUNTY WATER SYSTEM",
    "county": "CASS",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005234",
    "resolved_pwsid": "MI0005234",
    "system_name": "CASS COUNTY WATER SYSTEM",
    "display_name": "CASS COUNTY WATER SYSTEM",
    "county": "CASS",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005234",
    "resolved_pwsid": "MI0005234",
    "system_name": "CASS COUNTY WATER SYSTEM",
    "display_name": "CASS COUNTY WATER SYSTEM",
    "county": "CASS",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005234",
    "resolved_pwsid": "MI0005234",
    "system_name": "CASS COUNTY WATER SYSTEM",
    "display_name": "CASS COUNTY WATER SYSTEM",
    "county": "CASS",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005235",
    "resolved_pwsid": "MI0005235",
    "system_name": "PENNY LAKE ESTATES SUBDIVISION",
    "display_name": "PENNY LAKE ESTATES SUBDIVISION",
    "county": "OAKLAND",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 10,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005235",
    "resolved_pwsid": "MI0005235",
    "system_name": "PENNY LAKE ESTATES SUBDIVISION",
    "display_name": "PENNY LAKE ESTATES SUBDIVISION",
    "county": "OAKLAND",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005235",
    "resolved_pwsid": "MI0005235",
    "system_name": "PENNY LAKE ESTATES SUBDIVISION",
    "display_name": "PENNY LAKE ESTATES SUBDIVISION",
    "county": "OAKLAND",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005240",
    "resolved_pwsid": "MI0005240",
    "system_name": "PENTLAND TOWNSHIP",
    "display_name": "PENTLAND TOWNSHIP",
    "county": "LUCE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005240",
    "resolved_pwsid": "MI0005240",
    "system_name": "PENTLAND TOWNSHIP",
    "display_name": "PENTLAND TOWNSHIP",
    "county": "LUCE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005240",
    "resolved_pwsid": "MI0005240",
    "system_name": "PENTLAND TOWNSHIP",
    "display_name": "PENTLAND TOWNSHIP",
    "county": "LUCE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005240",
    "resolved_pwsid": "MI0005240",
    "system_name": "PENTLAND TOWNSHIP",
    "display_name": "PENTLAND TOWNSHIP",
    "county": "LUCE",
    "monitoring_end_date": "",
    "year": 2024,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005240",
    "resolved_pwsid": "MI0005240",
    "system_name": "PENTLAND TOWNSHIP",
    "display_name": "PENTLAND TOWNSHIP",
    "county": "LUCE",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005260",
    "resolved_pwsid": "MI0005260",
    "system_name": "PENTWATER",
    "display_name": "PENTWATER",
    "county": "OCEANA",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005260",
    "resolved_pwsid": "MI0005260",
    "system_name": "PENTWATER",
    "display_name": "PENTWATER",
    "county": "OCEANA",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005260",
    "resolved_pwsid": "MI0005260",
    "system_name": "PENTWATER",
    "display_name": "PENTWATER",
    "county": "OCEANA",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005260",
    "resolved_pwsid": "MI0005260",
    "system_name": "PENTWATER",
    "display_name": "PENTWATER",
    "county": "OCEANA",
    "monitoring_end_date": "",
    "year": 2022,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005260",
    "resolved_pwsid": "MI0005260",
    "system_name": "PENTWATER",
    "display_name": "PENTWATER",
    "county": "OCEANA",
    "monitoring_end_date": "",
    "year": 2023,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 16,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005260",
    "resolved_pwsid": "MI0005260",
    "system_name": "PENTWATER",
    "display_name": "PENTWATER",
    "county": "OCEANA",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 155,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005267",
    "resolved_pwsid": "MI0005267",
    "system_name": "PERE MARQUETTE TWP - CUSTOMER",
    "display_name": "PERE MARQUETTE TWP - CUSTOMER",
    "county": "MASON",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005267",
    "resolved_pwsid": "MI0005267",
    "system_name": "PERE MARQUETTE TWP - CUSTOMER",
    "display_name": "PERE MARQUETTE TWP - CUSTOMER",
    "county": "MASON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005267",
    "resolved_pwsid": "MI0005267",
    "system_name": "PERE MARQUETTE TWP - CUSTOMER",
    "display_name": "PERE MARQUETTE TWP - CUSTOMER",
    "county": "MASON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005267",
    "resolved_pwsid": "MI0005267",
    "system_name": "PERE MARQUETTE TWP - CUSTOMER",
    "display_name": "PERE MARQUETTE TWP - CUSTOMER",
    "county": "MASON",
    "monitoring_end_date": "",
    "year": 2021,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005268",
    "resolved_pwsid": "MI0005268",
    "system_name": "PERE MARQUETTE TWP - WELLS",
    "display_name": "PERE MARQUETTE TWP - WELLS",
    "county": "MASON",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005268",
    "resolved_pwsid": "MI0005268",
    "system_name": "PERE MARQUETTE TWP - WELLS",
    "display_name": "PERE MARQUETTE TWP - WELLS",
    "county": "MASON",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005268",
    "resolved_pwsid": "MI0005268",
    "system_name": "PERE MARQUETTE TWP - WELLS",
    "display_name": "PERE MARQUETTE TWP - WELLS",
    "county": "MASON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005270",
    "resolved_pwsid": "MI0005270",
    "system_name": "PERRINTON, VILLAGE OF",
    "display_name": "PERRINTON, VILLAGE OF",
    "county": "GRATIOT",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005270",
    "resolved_pwsid": "MI0005270",
    "system_name": "PERRINTON, VILLAGE OF",
    "display_name": "PERRINTON, VILLAGE OF",
    "county": "GRATIOT",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005270",
    "resolved_pwsid": "MI0005270",
    "system_name": "PERRINTON, VILLAGE OF",
    "display_name": "PERRINTON, VILLAGE OF",
    "county": "GRATIOT",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005280",
    "resolved_pwsid": "MI0005280",
    "system_name": "PERRY, CITY OF",
    "display_name": "PERRY, CITY OF",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005280",
    "resolved_pwsid": "MI0005280",
    "system_name": "PERRY, CITY OF",
    "display_name": "PERRY, CITY OF",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 2,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005280",
    "resolved_pwsid": "MI0005280",
    "system_name": "PERRY, CITY OF",
    "display_name": "PERRY, CITY OF",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": 6,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005280",
    "resolved_pwsid": "MI0005280",
    "system_name": "PERRY, CITY OF",
    "display_name": "PERRY, CITY OF",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": 4,
    "inventory_lead": null,
    "inventory_gpcl": 137,
    "inventory_unknown": 8,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005280",
    "resolved_pwsid": "MI0005280",
    "system_name": "PERRY, CITY OF",
    "display_name": "PERRY, CITY OF",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2026-06-30",
    "year": 2026,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005280",
    "resolved_pwsid": "MI0005280",
    "system_name": "PERRY, CITY OF",
    "display_name": "PERRY, CITY OF",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "",
    "year": 2022,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005280",
    "resolved_pwsid": "MI0005280",
    "system_name": "PERRY, CITY OF",
    "display_name": "PERRY, CITY OF",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "",
    "year": 2023,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 6,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005290",
    "resolved_pwsid": "MI0005290",
    "system_name": "PETERSBURG",
    "display_name": "PETERSBURG",
    "county": "MONROE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005290",
    "resolved_pwsid": "MI0005290",
    "system_name": "PETERSBURG",
    "display_name": "PETERSBURG",
    "county": "MONROE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005290",
    "resolved_pwsid": "MI0005290",
    "system_name": "PETERSBURG",
    "display_name": "PETERSBURG",
    "county": "MONROE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005290",
    "resolved_pwsid": "MI0005290",
    "system_name": "PETERSBURG",
    "display_name": "PETERSBURG",
    "county": "MONROE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005290",
    "resolved_pwsid": "MI0005290",
    "system_name": "PETERSBURG",
    "display_name": "PETERSBURG",
    "county": "MONROE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005290",
    "resolved_pwsid": "MI0005290",
    "system_name": "PETERSBURG",
    "display_name": "PETERSBURG",
    "county": "MONROE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005290",
    "resolved_pwsid": "MI0005290",
    "system_name": "PETERSBURG",
    "display_name": "PETERSBURG",
    "county": "MONROE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005290",
    "resolved_pwsid": "MI0005290",
    "system_name": "PETERSBURG",
    "display_name": "PETERSBURG",
    "county": "MONROE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005300",
    "resolved_pwsid": "MI0005300",
    "system_name": "PETOSKEY, CITY OF",
    "display_name": "PETOSKEY, CITY OF",
    "county": "EMMET",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005300",
    "resolved_pwsid": "MI0005300",
    "system_name": "PETOSKEY, CITY OF",
    "display_name": "PETOSKEY, CITY OF",
    "county": "EMMET",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": 5,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005300",
    "resolved_pwsid": "MI0005300",
    "system_name": "PETOSKEY, CITY OF",
    "display_name": "PETOSKEY, CITY OF",
    "county": "EMMET",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 5,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005300",
    "resolved_pwsid": "MI0005300",
    "system_name": "PETOSKEY, CITY OF",
    "display_name": "PETOSKEY, CITY OF",
    "county": "EMMET",
    "monitoring_end_date": "",
    "year": 2022,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 10,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005300",
    "resolved_pwsid": "MI0005300",
    "system_name": "PETOSKEY, CITY OF",
    "display_name": "PETOSKEY, CITY OF",
    "county": "EMMET",
    "monitoring_end_date": "",
    "year": 2023,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 23,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005300",
    "resolved_pwsid": "MI0005300",
    "system_name": "PETOSKEY, CITY OF",
    "display_name": "PETOSKEY, CITY OF",
    "county": "EMMET",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 10,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005305",
    "resolved_pwsid": "MI0005305",
    "system_name": "PETOSKEY PARK APARTMENTS",
    "display_name": "PETOSKEY PARK APARTMENTS",
    "county": "EMMET",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005305",
    "resolved_pwsid": "MI0005305",
    "system_name": "PETOSKEY PARK APARTMENTS",
    "display_name": "PETOSKEY PARK APARTMENTS",
    "county": "EMMET",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005305",
    "resolved_pwsid": "MI0005305",
    "system_name": "PETOSKEY PARK APARTMENTS",
    "display_name": "PETOSKEY PARK APARTMENTS",
    "county": "EMMET",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005305",
    "resolved_pwsid": "MI0005305",
    "system_name": "PETOSKEY PARK APARTMENTS",
    "display_name": "PETOSKEY PARK APARTMENTS",
    "county": "EMMET",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 9,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0005310",
    "resolved_pwsid": "MI0005310",
    "system_name": "PEWAMO",
    "display_name": "PEWAMO",
    "county": "IONIA",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005310",
    "resolved_pwsid": "MI0005310",
    "system_name": "PEWAMO",
    "display_name": "PEWAMO",
    "county": "IONIA",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005310",
    "resolved_pwsid": "MI0005310",
    "system_name": "PEWAMO",
    "display_name": "PEWAMO",
    "county": "IONIA",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005310",
    "resolved_pwsid": "MI0005310",
    "system_name": "PEWAMO",
    "display_name": "PEWAMO",
    "county": "IONIA",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005315",
    "resolved_pwsid": "MI0005315",
    "system_name": "PHEASANT RUN MANOR APARTMENTS",
    "display_name": "PHEASANT RUN MANOR APARTMENTS",
    "county": "GENESEE",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005315",
    "resolved_pwsid": "MI0005315",
    "system_name": "PHEASANT RUN MANOR APARTMENTS",
    "display_name": "PHEASANT RUN MANOR APARTMENTS",
    "county": "GENESEE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005315",
    "resolved_pwsid": "MI0005315",
    "system_name": "PHEASANT RUN MANOR APARTMENTS",
    "display_name": "PHEASANT RUN MANOR APARTMENTS",
    "county": "GENESEE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005315",
    "resolved_pwsid": "MI0005315",
    "system_name": "PHEASANT RUN MANOR APARTMENTS",
    "display_name": "PHEASANT RUN MANOR APARTMENTS",
    "county": "GENESEE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005320",
    "resolved_pwsid": "MI0005320",
    "system_name": "PIGEON, VILLAGE OF",
    "display_name": "PIGEON, VILLAGE OF",
    "county": "HURON",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005320",
    "resolved_pwsid": "MI0005320",
    "system_name": "PIGEON, VILLAGE OF",
    "display_name": "PIGEON, VILLAGE OF",
    "county": "HURON",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 12,
    "above_action_level": false,
    "lines_replaced": 5,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005320",
    "resolved_pwsid": "MI0005320",
    "system_name": "PIGEON, VILLAGE OF",
    "display_name": "PIGEON, VILLAGE OF",
    "county": "HURON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005320",
    "resolved_pwsid": "MI0005320",
    "system_name": "PIGEON, VILLAGE OF",
    "display_name": "PIGEON, VILLAGE OF",
    "county": "HURON",
    "monitoring_end_date": "",
    "year": 2022,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005322",
    "resolved_pwsid": "MI0005322",
    "system_name": "PINCKNEY, VILLAGE OF",
    "display_name": "PINCKNEY, VILLAGE OF",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005322",
    "resolved_pwsid": "MI0005322",
    "system_name": "PINCKNEY, VILLAGE OF",
    "display_name": "PINCKNEY, VILLAGE OF",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005322",
    "resolved_pwsid": "MI0005322",
    "system_name": "PINCKNEY, VILLAGE OF",
    "display_name": "PINCKNEY, VILLAGE OF",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005322",
    "resolved_pwsid": "MI0005322",
    "system_name": "PINCKNEY, VILLAGE OF",
    "display_name": "PINCKNEY, VILLAGE OF",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005330",
    "resolved_pwsid": "MI0005330",
    "system_name": "PINCONNING, CITY OF",
    "display_name": "PINCONNING, CITY OF",
    "county": "BAY",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005330",
    "resolved_pwsid": "MI0005330",
    "system_name": "PINCONNING, CITY OF",
    "display_name": "PINCONNING, CITY OF",
    "county": "BAY",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005330",
    "resolved_pwsid": "MI0005330",
    "system_name": "PINCONNING, CITY OF",
    "display_name": "PINCONNING, CITY OF",
    "county": "BAY",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005330",
    "resolved_pwsid": "MI0005330",
    "system_name": "PINCONNING, CITY OF",
    "display_name": "PINCONNING, CITY OF",
    "county": "BAY",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005330",
    "resolved_pwsid": "MI0005330",
    "system_name": "PINCONNING, CITY OF",
    "display_name": "PINCONNING, CITY OF",
    "county": "BAY",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005330",
    "resolved_pwsid": "MI0005330",
    "system_name": "PINCONNING, CITY OF",
    "display_name": "PINCONNING, CITY OF",
    "county": "BAY",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005330",
    "resolved_pwsid": "MI0005330",
    "system_name": "PINCONNING, CITY OF",
    "display_name": "PINCONNING, CITY OF",
    "county": "BAY",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005335",
    "resolved_pwsid": "MI0005335",
    "system_name": "PINCONNING TOWNSHIP",
    "display_name": "PINCONNING TOWNSHIP",
    "county": "BAY",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005335",
    "resolved_pwsid": "MI0005335",
    "system_name": "PINCONNING TOWNSHIP",
    "display_name": "PINCONNING TOWNSHIP",
    "county": "BAY",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005335",
    "resolved_pwsid": "MI0005335",
    "system_name": "PINCONNING TOWNSHIP",
    "display_name": "PINCONNING TOWNSHIP",
    "county": "BAY",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005335",
    "resolved_pwsid": "MI0005335",
    "system_name": "PINCONNING TOWNSHIP",
    "display_name": "PINCONNING TOWNSHIP",
    "county": "BAY",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005335",
    "resolved_pwsid": "MI0005335",
    "system_name": "PINCONNING TOWNSHIP",
    "display_name": "PINCONNING TOWNSHIP",
    "county": "BAY",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005335",
    "resolved_pwsid": "MI0005335",
    "system_name": "PINCONNING TOWNSHIP",
    "display_name": "PINCONNING TOWNSHIP",
    "county": "BAY",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005335",
    "resolved_pwsid": "MI0005335",
    "system_name": "PINCONNING TOWNSHIP",
    "display_name": "PINCONNING TOWNSHIP",
    "county": "BAY",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005345",
    "resolved_pwsid": "MI0005345",
    "system_name": "PINECREST APARTMENTS",
    "display_name": "PINECREST APARTMENTS",
    "county": "OAKLAND",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005345",
    "resolved_pwsid": "MI0005345",
    "system_name": "PINECREST APARTMENTS",
    "display_name": "PINECREST APARTMENTS",
    "county": "OAKLAND",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005345",
    "resolved_pwsid": "MI0005345",
    "system_name": "PINECREST APARTMENTS",
    "display_name": "PINECREST APARTMENTS",
    "county": "OAKLAND",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005345",
    "resolved_pwsid": "MI0005345",
    "system_name": "PINECREST APARTMENTS",
    "display_name": "PINECREST APARTMENTS",
    "county": "OAKLAND",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0005349",
    "resolved_pwsid": "MI0005349",
    "system_name": "COTTAGE HS, LLC (PINEVIEW COTTAGE)",
    "display_name": "COTTAGE HS, LLC (PINEVIEW COTTAGE)",
    "county": "EMMET",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005349",
    "resolved_pwsid": "MI0005349",
    "system_name": "COTTAGE HS, LLC (PINEVIEW COTTAGE)",
    "display_name": "COTTAGE HS, LLC (PINEVIEW COTTAGE)",
    "county": "EMMET",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005349",
    "resolved_pwsid": "MI0005349",
    "system_name": "COTTAGE HS, LLC (PINEVIEW COTTAGE)",
    "display_name": "COTTAGE HS, LLC (PINEVIEW COTTAGE)",
    "county": "EMMET",
    "monitoring_end_date": "2022-09-30",
    "year": 2022,
    "lead_90th_ppb": 30,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005349",
    "resolved_pwsid": "MI0005349",
    "system_name": "COTTAGE HS, LLC (PINEVIEW COTTAGE)",
    "display_name": "COTTAGE HS, LLC (PINEVIEW COTTAGE)",
    "county": "EMMET",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 30,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005349",
    "resolved_pwsid": "MI0005349",
    "system_name": "COTTAGE HS, LLC (PINEVIEW COTTAGE)",
    "display_name": "COTTAGE HS, LLC (PINEVIEW COTTAGE)",
    "county": "EMMET",
    "monitoring_end_date": "2023-06-30",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005349",
    "resolved_pwsid": "MI0005349",
    "system_name": "COTTAGE HS, LLC (PINEVIEW COTTAGE)",
    "display_name": "COTTAGE HS, LLC (PINEVIEW COTTAGE)",
    "county": "EMMET",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005351",
    "resolved_pwsid": "MI0005351",
    "system_name": "PINEVIEW HOMES",
    "display_name": "PINEVIEW HOMES",
    "county": "OSCEOLA",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005351",
    "resolved_pwsid": "MI0005351",
    "system_name": "PINEVIEW HOMES",
    "display_name": "PINEVIEW HOMES",
    "county": "OSCEOLA",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005351",
    "resolved_pwsid": "MI0005351",
    "system_name": "PINEVIEW HOMES",
    "display_name": "PINEVIEW HOMES",
    "county": "OSCEOLA",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005353",
    "resolved_pwsid": "MI0005353",
    "system_name": "PINEHURST APARTMENTS",
    "display_name": "PINEHURST APARTMENTS",
    "county": "GENESEE",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005353",
    "resolved_pwsid": "MI0005353",
    "system_name": "PINEHURST APARTMENTS",
    "display_name": "PINEHURST APARTMENTS",
    "county": "GENESEE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005353",
    "resolved_pwsid": "MI0005353",
    "system_name": "PINEHURST APARTMENTS",
    "display_name": "PINEHURST APARTMENTS",
    "county": "GENESEE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005353",
    "resolved_pwsid": "MI0005353",
    "system_name": "PINEHURST APARTMENTS",
    "display_name": "PINEHURST APARTMENTS",
    "county": "GENESEE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0005355",
    "resolved_pwsid": "MI0005355",
    "system_name": "PIRATES COVE CONDOMINIUMS",
    "display_name": "PIRATES COVE CONDOMINIUMS",
    "county": "MANISTEE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005355",
    "resolved_pwsid": "MI0005355",
    "system_name": "PIRATES COVE CONDOMINIUMS",
    "display_name": "PIRATES COVE CONDOMINIUMS",
    "county": "MANISTEE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005355",
    "resolved_pwsid": "MI0005355",
    "system_name": "PIRATES COVE CONDOMINIUMS",
    "display_name": "PIRATES COVE CONDOMINIUMS",
    "county": "MANISTEE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005360",
    "resolved_pwsid": "MI0005360",
    "system_name": "PITTSFIELD TOWNSHIP",
    "display_name": "PITTSFIELD TOWNSHIP",
    "county": "WASHTENAW",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005360",
    "resolved_pwsid": "MI0005360",
    "system_name": "PITTSFIELD TOWNSHIP",
    "display_name": "PITTSFIELD TOWNSHIP",
    "county": "WASHTENAW",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005360",
    "resolved_pwsid": "MI0005360",
    "system_name": "PITTSFIELD TOWNSHIP",
    "display_name": "PITTSFIELD TOWNSHIP",
    "county": "WASHTENAW",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005360",
    "resolved_pwsid": "MI0005360",
    "system_name": "PITTSFIELD TOWNSHIP",
    "display_name": "PITTSFIELD TOWNSHIP",
    "county": "WASHTENAW",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005360",
    "resolved_pwsid": "MI0005360",
    "system_name": "PITTSFIELD TOWNSHIP",
    "display_name": "PITTSFIELD TOWNSHIP",
    "county": "WASHTENAW",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005360",
    "resolved_pwsid": "MI0005360",
    "system_name": "PITTSFIELD TOWNSHIP",
    "display_name": "PITTSFIELD TOWNSHIP",
    "county": "WASHTENAW",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005360",
    "resolved_pwsid": "MI0005360",
    "system_name": "PITTSFIELD TOWNSHIP",
    "display_name": "PITTSFIELD TOWNSHIP",
    "county": "WASHTENAW",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005360",
    "resolved_pwsid": "MI0005360",
    "system_name": "PITTSFIELD TOWNSHIP",
    "display_name": "PITTSFIELD TOWNSHIP",
    "county": "WASHTENAW",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0005370",
    "resolved_pwsid": "MI0005370",
    "system_name": "PLAINFIELD TOWNSHIP",
    "display_name": "PLAINFIELD TOWNSHIP",
    "county": "KENT",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005370",
    "resolved_pwsid": "MI0005370",
    "system_name": "PLAINFIELD TOWNSHIP",
    "display_name": "PLAINFIELD TOWNSHIP",
    "county": "KENT",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005370",
    "resolved_pwsid": "MI0005370",
    "system_name": "PLAINFIELD TOWNSHIP",
    "display_name": "PLAINFIELD TOWNSHIP",
    "county": "KENT",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005370",
    "resolved_pwsid": "MI0005370",
    "system_name": "PLAINFIELD TOWNSHIP",
    "display_name": "PLAINFIELD TOWNSHIP",
    "county": "KENT",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005370",
    "resolved_pwsid": "MI0005370",
    "system_name": "PLAINFIELD TOWNSHIP",
    "display_name": "PLAINFIELD TOWNSHIP",
    "county": "KENT",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0005380",
    "resolved_pwsid": "MI0005380",
    "system_name": "PLAINWELL",
    "display_name": "PLAINWELL",
    "county": "ALLEGAN",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005380",
    "resolved_pwsid": "MI0005380",
    "system_name": "PLAINWELL",
    "display_name": "PLAINWELL",
    "county": "ALLEGAN",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005380",
    "resolved_pwsid": "MI0005380",
    "system_name": "PLAINWELL",
    "display_name": "PLAINWELL",
    "county": "ALLEGAN",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005390",
    "resolved_pwsid": "MI0005390",
    "system_name": "PLEASANT RIDGE",
    "display_name": "PLEASANT RIDGE",
    "county": "OAKLAND",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005390",
    "resolved_pwsid": "MI0005390",
    "system_name": "PLEASANT RIDGE",
    "display_name": "PLEASANT RIDGE",
    "county": "OAKLAND",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005390",
    "resolved_pwsid": "MI0005390",
    "system_name": "PLEASANT RIDGE",
    "display_name": "PLEASANT RIDGE",
    "county": "OAKLAND",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005390",
    "resolved_pwsid": "MI0005390",
    "system_name": "PLEASANT RIDGE",
    "display_name": "PLEASANT RIDGE",
    "county": "OAKLAND",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": 33,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005390",
    "resolved_pwsid": "MI0005390",
    "system_name": "PLEASANT RIDGE",
    "display_name": "PLEASANT RIDGE",
    "county": "OAKLAND",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": 3,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005390",
    "resolved_pwsid": "MI0005390",
    "system_name": "PLEASANT RIDGE",
    "display_name": "PLEASANT RIDGE",
    "county": "OAKLAND",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005390",
    "resolved_pwsid": "MI0005390",
    "system_name": "PLEASANT RIDGE",
    "display_name": "PLEASANT RIDGE",
    "county": "OAKLAND",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": 72,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005390",
    "resolved_pwsid": "MI0005390",
    "system_name": "PLEASANT RIDGE",
    "display_name": "PLEASANT RIDGE",
    "county": "OAKLAND",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": 63,
    "inventory_lead": 646,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 646,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0005395",
    "resolved_pwsid": "MI0005395",
    "system_name": "GREEN BROOK ESTATES",
    "display_name": "GREEN BROOK ESTATES",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005395",
    "resolved_pwsid": "MI0005395",
    "system_name": "GREEN BROOK ESTATES",
    "display_name": "GREEN BROOK ESTATES",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005395",
    "resolved_pwsid": "MI0005395",
    "system_name": "GREEN BROOK ESTATES",
    "display_name": "GREEN BROOK ESTATES",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005395",
    "resolved_pwsid": "MI0005395",
    "system_name": "GREEN BROOK ESTATES",
    "display_name": "GREEN BROOK ESTATES",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005395",
    "resolved_pwsid": "MI0005395",
    "system_name": "GREEN BROOK ESTATES",
    "display_name": "GREEN BROOK ESTATES",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005395",
    "resolved_pwsid": "MI0005395",
    "system_name": "GREEN BROOK ESTATES",
    "display_name": "GREEN BROOK ESTATES",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005397",
    "resolved_pwsid": "MI0005397",
    "system_name": "PLUM CREEK SUB",
    "display_name": "PLUM CREEK SUB",
    "county": "OAKLAND",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005397",
    "resolved_pwsid": "MI0005397",
    "system_name": "PLUM CREEK SUB",
    "display_name": "PLUM CREEK SUB",
    "county": "OAKLAND",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005397",
    "resolved_pwsid": "MI0005397",
    "system_name": "PLUM CREEK SUB",
    "display_name": "PLUM CREEK SUB",
    "county": "OAKLAND",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005397",
    "resolved_pwsid": "MI0005397",
    "system_name": "PLUM CREEK SUB",
    "display_name": "PLUM CREEK SUB",
    "county": "OAKLAND",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0005400",
    "resolved_pwsid": "MI0005400",
    "system_name": "PLYMOUTH",
    "display_name": "PLYMOUTH",
    "county": "WAYNE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005400",
    "resolved_pwsid": "MI0005400",
    "system_name": "PLYMOUTH",
    "display_name": "PLYMOUTH",
    "county": "WAYNE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005400",
    "resolved_pwsid": "MI0005400",
    "system_name": "PLYMOUTH",
    "display_name": "PLYMOUTH",
    "county": "WAYNE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005400",
    "resolved_pwsid": "MI0005400",
    "system_name": "PLYMOUTH",
    "display_name": "PLYMOUTH",
    "county": "WAYNE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": 9,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005400",
    "resolved_pwsid": "MI0005400",
    "system_name": "PLYMOUTH",
    "display_name": "PLYMOUTH",
    "county": "WAYNE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005400",
    "resolved_pwsid": "MI0005400",
    "system_name": "PLYMOUTH",
    "display_name": "PLYMOUTH",
    "county": "WAYNE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 8,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005400",
    "resolved_pwsid": "MI0005400",
    "system_name": "PLYMOUTH",
    "display_name": "PLYMOUTH",
    "county": "WAYNE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 26,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005400",
    "resolved_pwsid": "MI0005400",
    "system_name": "PLYMOUTH",
    "display_name": "PLYMOUTH",
    "county": "WAYNE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 8,
    "inventory_lead": 173,
    "inventory_gpcl": 109,
    "inventory_unknown": 414,
    "total_to_identify_or_replace": 696,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0005420",
    "resolved_pwsid": "MI0005420",
    "system_name": "PLYMOUTH TOWNSHIP",
    "display_name": "PLYMOUTH TOWNSHIP",
    "county": "WAYNE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005420",
    "resolved_pwsid": "MI0005420",
    "system_name": "PLYMOUTH TOWNSHIP",
    "display_name": "PLYMOUTH TOWNSHIP",
    "county": "WAYNE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005420",
    "resolved_pwsid": "MI0005420",
    "system_name": "PLYMOUTH TOWNSHIP",
    "display_name": "PLYMOUTH TOWNSHIP",
    "county": "WAYNE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005420",
    "resolved_pwsid": "MI0005420",
    "system_name": "PLYMOUTH TOWNSHIP",
    "display_name": "PLYMOUTH TOWNSHIP",
    "county": "WAYNE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 3,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005420",
    "resolved_pwsid": "MI0005420",
    "system_name": "PLYMOUTH TOWNSHIP",
    "display_name": "PLYMOUTH TOWNSHIP",
    "county": "WAYNE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 3,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005420",
    "resolved_pwsid": "MI0005420",
    "system_name": "PLYMOUTH TOWNSHIP",
    "display_name": "PLYMOUTH TOWNSHIP",
    "county": "WAYNE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005420",
    "resolved_pwsid": "MI0005420",
    "system_name": "PLYMOUTH TOWNSHIP",
    "display_name": "PLYMOUTH TOWNSHIP",
    "county": "WAYNE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 16,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005420",
    "resolved_pwsid": "MI0005420",
    "system_name": "PLYMOUTH TOWNSHIP",
    "display_name": "PLYMOUTH TOWNSHIP",
    "county": "WAYNE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": 5,
    "inventory_gpcl": 6,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 11,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0005425",
    "resolved_pwsid": "MI0005425",
    "system_name": "POINT NIPIGON RESORT",
    "display_name": "POINT NIPIGON RESORT",
    "county": "CHEBOYGAN",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005425",
    "resolved_pwsid": "MI0005425",
    "system_name": "POINT NIPIGON RESORT",
    "display_name": "POINT NIPIGON RESORT",
    "county": "CHEBOYGAN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005425",
    "resolved_pwsid": "MI0005425",
    "system_name": "POINT NIPIGON RESORT",
    "display_name": "POINT NIPIGON RESORT",
    "county": "CHEBOYGAN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005425",
    "resolved_pwsid": "MI0005425",
    "system_name": "POINT NIPIGON RESORT",
    "display_name": "POINT NIPIGON RESORT",
    "county": "CHEBOYGAN",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0005427",
    "resolved_pwsid": "MI0005427",
    "system_name": "POLKTON TOWNSHIP",
    "display_name": "POLKTON TOWNSHIP",
    "county": "OTTAWA",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005427",
    "resolved_pwsid": "MI0005427",
    "system_name": "POLKTON TOWNSHIP",
    "display_name": "POLKTON TOWNSHIP",
    "county": "OTTAWA",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005427",
    "resolved_pwsid": "MI0005427",
    "system_name": "POLKTON TOWNSHIP",
    "display_name": "POLKTON TOWNSHIP",
    "county": "OTTAWA",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005427",
    "resolved_pwsid": "MI0005427",
    "system_name": "POLKTON TOWNSHIP",
    "display_name": "POLKTON TOWNSHIP",
    "county": "OTTAWA",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005427",
    "resolved_pwsid": "MI0005427",
    "system_name": "POLKTON TOWNSHIP",
    "display_name": "POLKTON TOWNSHIP",
    "county": "OTTAWA",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005427",
    "resolved_pwsid": "MI0005427",
    "system_name": "POLKTON TOWNSHIP",
    "display_name": "POLKTON TOWNSHIP",
    "county": "OTTAWA",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005427",
    "resolved_pwsid": "MI0005427",
    "system_name": "POLKTON TOWNSHIP",
    "display_name": "POLKTON TOWNSHIP",
    "county": "OTTAWA",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005430",
    "resolved_pwsid": "MI0005430",
    "system_name": "POINTE AUX BARQUES TOWNSHIP",
    "display_name": "POINTE AUX BARQUES TOWNSHIP",
    "county": "HURON",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005430",
    "resolved_pwsid": "MI0005430",
    "system_name": "POINTE AUX BARQUES TOWNSHIP",
    "display_name": "POINTE AUX BARQUES TOWNSHIP",
    "county": "HURON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005430",
    "resolved_pwsid": "MI0005430",
    "system_name": "POINTE AUX BARQUES TOWNSHIP",
    "display_name": "POINTE AUX BARQUES TOWNSHIP",
    "county": "HURON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005440",
    "resolved_pwsid": "MI0005440",
    "system_name": "PONTIAC",
    "display_name": "PONTIAC",
    "county": "OAKLAND",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005440",
    "resolved_pwsid": "MI0005440",
    "system_name": "PONTIAC",
    "display_name": "PONTIAC",
    "county": "OAKLAND",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005440",
    "resolved_pwsid": "MI0005440",
    "system_name": "PONTIAC",
    "display_name": "PONTIAC",
    "county": "OAKLAND",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005440",
    "resolved_pwsid": "MI0005440",
    "system_name": "PONTIAC",
    "display_name": "PONTIAC",
    "county": "OAKLAND",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 146,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005440",
    "resolved_pwsid": "MI0005440",
    "system_name": "PONTIAC",
    "display_name": "PONTIAC",
    "county": "OAKLAND",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 133,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005440",
    "resolved_pwsid": "MI0005440",
    "system_name": "PONTIAC",
    "display_name": "PONTIAC",
    "county": "OAKLAND",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": 258,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005440",
    "resolved_pwsid": "MI0005440",
    "system_name": "PONTIAC",
    "display_name": "PONTIAC",
    "county": "OAKLAND",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": 314,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005440",
    "resolved_pwsid": "MI0005440",
    "system_name": "PONTIAC",
    "display_name": "PONTIAC",
    "county": "OAKLAND",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 533,
    "inventory_lead": 101,
    "inventory_gpcl": 1036,
    "inventory_unknown": 9609,
    "total_to_identify_or_replace": 10746,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0005445",
    "resolved_pwsid": "MI0005445",
    "system_name": "LAKEVIEW CHALET CONDOMINIUMS",
    "display_name": "LAKEVIEW CHALET CONDOMINIUMS",
    "county": "OAKLAND",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 43,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005445",
    "resolved_pwsid": "MI0005445",
    "system_name": "LAKEVIEW CHALET CONDOMINIUMS",
    "display_name": "LAKEVIEW CHALET CONDOMINIUMS",
    "county": "OAKLAND",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005445",
    "resolved_pwsid": "MI0005445",
    "system_name": "LAKEVIEW CHALET CONDOMINIUMS",
    "display_name": "LAKEVIEW CHALET CONDOMINIUMS",
    "county": "OAKLAND",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 57,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005445",
    "resolved_pwsid": "MI0005445",
    "system_name": "LAKEVIEW CHALET CONDOMINIUMS",
    "display_name": "LAKEVIEW CHALET CONDOMINIUMS",
    "county": "OAKLAND",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005445",
    "resolved_pwsid": "MI0005445",
    "system_name": "LAKEVIEW CHALET CONDOMINIUMS",
    "display_name": "LAKEVIEW CHALET CONDOMINIUMS",
    "county": "OAKLAND",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005445",
    "resolved_pwsid": "MI0005445",
    "system_name": "LAKEVIEW CHALET CONDOMINIUMS",
    "display_name": "LAKEVIEW CHALET CONDOMINIUMS",
    "county": "OAKLAND",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005445",
    "resolved_pwsid": "MI0005445",
    "system_name": "LAKEVIEW CHALET CONDOMINIUMS",
    "display_name": "LAKEVIEW CHALET CONDOMINIUMS",
    "county": "OAKLAND",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005445",
    "resolved_pwsid": "MI0005445",
    "system_name": "LAKEVIEW CHALET CONDOMINIUMS",
    "display_name": "LAKEVIEW CHALET CONDOMINIUMS",
    "county": "OAKLAND",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005450",
    "resolved_pwsid": "MI0005450",
    "system_name": "AUBURN HILLS",
    "display_name": "AUBURN HILLS",
    "county": "OAKLAND",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005450",
    "resolved_pwsid": "MI0005450",
    "system_name": "AUBURN HILLS",
    "display_name": "AUBURN HILLS",
    "county": "OAKLAND",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005450",
    "resolved_pwsid": "MI0005450",
    "system_name": "AUBURN HILLS",
    "display_name": "AUBURN HILLS",
    "county": "OAKLAND",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005450",
    "resolved_pwsid": "MI0005450",
    "system_name": "AUBURN HILLS",
    "display_name": "AUBURN HILLS",
    "county": "OAKLAND",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005450",
    "resolved_pwsid": "MI0005450",
    "system_name": "AUBURN HILLS",
    "display_name": "AUBURN HILLS",
    "county": "OAKLAND",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005450",
    "resolved_pwsid": "MI0005450",
    "system_name": "AUBURN HILLS",
    "display_name": "AUBURN HILLS",
    "county": "OAKLAND",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005450",
    "resolved_pwsid": "MI0005450",
    "system_name": "AUBURN HILLS",
    "display_name": "AUBURN HILLS",
    "county": "OAKLAND",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005450",
    "resolved_pwsid": "MI0005450",
    "system_name": "AUBURN HILLS",
    "display_name": "AUBURN HILLS",
    "county": "OAKLAND",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005460",
    "resolved_pwsid": "MI0005460",
    "system_name": "PORT AUSTIN AREA SEWER & WATER",
    "display_name": "PORT AUSTIN AREA SEWER & WATER",
    "county": "HURON",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005460",
    "resolved_pwsid": "MI0005460",
    "system_name": "PORT AUSTIN AREA SEWER & WATER",
    "display_name": "PORT AUSTIN AREA SEWER & WATER",
    "county": "HURON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005460",
    "resolved_pwsid": "MI0005460",
    "system_name": "PORT AUSTIN AREA SEWER & WATER",
    "display_name": "PORT AUSTIN AREA SEWER & WATER",
    "county": "HURON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005475",
    "resolved_pwsid": "MI0005475",
    "system_name": "PORT HOPE-GORE-RUBICON U. A.",
    "display_name": "PORT HOPE-GORE-RUBICON U. A.",
    "county": "HURON",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005475",
    "resolved_pwsid": "MI0005475",
    "system_name": "PORT HOPE-GORE-RUBICON U. A.",
    "display_name": "PORT HOPE-GORE-RUBICON U. A.",
    "county": "HURON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005475",
    "resolved_pwsid": "MI0005475",
    "system_name": "PORT HOPE-GORE-RUBICON U. A.",
    "display_name": "PORT HOPE-GORE-RUBICON U. A.",
    "county": "HURON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005480",
    "resolved_pwsid": "MI0005480",
    "system_name": "PORT HURON, CITY OF",
    "display_name": "PORT HURON, CITY OF",
    "county": "ST CLAIR",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005480",
    "resolved_pwsid": "MI0005480",
    "system_name": "PORT HURON, CITY OF",
    "display_name": "PORT HURON, CITY OF",
    "county": "ST CLAIR",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 9,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005480",
    "resolved_pwsid": "MI0005480",
    "system_name": "PORT HURON, CITY OF",
    "display_name": "PORT HURON, CITY OF",
    "county": "ST. CLAIR",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": 61,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005480",
    "resolved_pwsid": "MI0005480",
    "system_name": "PORT HURON, CITY OF",
    "display_name": "PORT HURON, CITY OF",
    "county": "ST CLAIR",
    "monitoring_end_date": "",
    "year": 2021,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 4,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005480",
    "resolved_pwsid": "MI0005480",
    "system_name": "PORT HURON, CITY OF",
    "display_name": "PORT HURON, CITY OF",
    "county": "ST CLAIR",
    "monitoring_end_date": "",
    "year": 2022,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 7,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005480",
    "resolved_pwsid": "MI0005480",
    "system_name": "PORT HURON, CITY OF",
    "display_name": "PORT HURON, CITY OF",
    "county": "ST CLAIR",
    "monitoring_end_date": "",
    "year": 2024,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 22,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005480",
    "resolved_pwsid": "MI0005480",
    "system_name": "PORT HURON, CITY OF",
    "display_name": "PORT HURON, CITY OF",
    "county": "ST CLAIR",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 40,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005490",
    "resolved_pwsid": "MI0005490",
    "system_name": "PORT HURON TOWNSHIP",
    "display_name": "PORT HURON TOWNSHIP",
    "county": "ST CLAIR",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005490",
    "resolved_pwsid": "MI0005490",
    "system_name": "PORT HURON TOWNSHIP",
    "display_name": "PORT HURON TOWNSHIP",
    "county": "ST CLAIR",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005490",
    "resolved_pwsid": "MI0005490",
    "system_name": "PORT HURON TOWNSHIP",
    "display_name": "PORT HURON TOWNSHIP",
    "county": "ST. CLAIR",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005490",
    "resolved_pwsid": "MI0005490",
    "system_name": "PORT HURON TOWNSHIP",
    "display_name": "PORT HURON TOWNSHIP",
    "county": "ST. CLAIR",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005490",
    "resolved_pwsid": "MI0005490",
    "system_name": "PORT HURON TOWNSHIP",
    "display_name": "PORT HURON TOWNSHIP",
    "county": "ST CLAIR",
    "monitoring_end_date": "",
    "year": 2021,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005490",
    "resolved_pwsid": "MI0005490",
    "system_name": "PORT HURON TOWNSHIP",
    "display_name": "PORT HURON TOWNSHIP",
    "county": "ST CLAIR",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 2,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005500",
    "resolved_pwsid": "MI0005500",
    "system_name": "PORT SANILAC, VILLAGE OF",
    "display_name": "PORT SANILAC, VILLAGE OF",
    "county": "SANILAC",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005500",
    "resolved_pwsid": "MI0005500",
    "system_name": "PORT SANILAC, VILLAGE OF",
    "display_name": "PORT SANILAC, VILLAGE OF",
    "county": "SANILAC",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005500",
    "resolved_pwsid": "MI0005500",
    "system_name": "PORT SANILAC, VILLAGE OF",
    "display_name": "PORT SANILAC, VILLAGE OF",
    "county": "SANILAC",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005500",
    "resolved_pwsid": "MI0005500",
    "system_name": "PORT SANILAC, VILLAGE OF",
    "display_name": "PORT SANILAC, VILLAGE OF",
    "county": "SANILAC",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005500",
    "resolved_pwsid": "MI0005500",
    "system_name": "PORT SANILAC, VILLAGE OF",
    "display_name": "PORT SANILAC, VILLAGE OF",
    "county": "SANILAC",
    "monitoring_end_date": "2026-06-30",
    "year": 2026,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005520",
    "resolved_pwsid": "MI0005520",
    "system_name": "PORTAGE",
    "display_name": "PORTAGE",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005520",
    "resolved_pwsid": "MI0005520",
    "system_name": "PORTAGE",
    "display_name": "PORTAGE",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005520",
    "resolved_pwsid": "MI0005520",
    "system_name": "PORTAGE",
    "display_name": "PORTAGE",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005527",
    "resolved_pwsid": "MI0005527",
    "system_name": "PORTAGE POINT INN",
    "display_name": "PORTAGE POINT INN",
    "county": "MANISTEE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005527",
    "resolved_pwsid": "MI0005527",
    "system_name": "PORTAGE POINT INN",
    "display_name": "PORTAGE POINT INN",
    "county": "MANISTEE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005527",
    "resolved_pwsid": "MI0005527",
    "system_name": "PORTAGE POINT INN",
    "display_name": "PORTAGE POINT INN",
    "county": "MANISTEE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005530",
    "resolved_pwsid": "MI0005530",
    "system_name": "PORTLAND",
    "display_name": "PORTLAND",
    "county": "IONIA",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005530",
    "resolved_pwsid": "MI0005530",
    "system_name": "PORTLAND",
    "display_name": "PORTLAND",
    "county": "IONIA",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005530",
    "resolved_pwsid": "MI0005530",
    "system_name": "PORTLAND",
    "display_name": "PORTLAND",
    "county": "IONIA",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": 103,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005530",
    "resolved_pwsid": "MI0005530",
    "system_name": "PORTLAND",
    "display_name": "PORTLAND",
    "county": "IONIA",
    "monitoring_end_date": "",
    "year": 2022,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005530",
    "resolved_pwsid": "MI0005530",
    "system_name": "PORTLAND",
    "display_name": "PORTLAND",
    "county": "IONIA",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 13,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005540",
    "resolved_pwsid": "MI0005540",
    "system_name": "PORTSMOUTH TOWNSHIP",
    "display_name": "PORTSMOUTH TOWNSHIP",
    "county": "BAY",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005540",
    "resolved_pwsid": "MI0005540",
    "system_name": "PORTSMOUTH TOWNSHIP",
    "display_name": "PORTSMOUTH TOWNSHIP",
    "county": "BAY",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005540",
    "resolved_pwsid": "MI0005540",
    "system_name": "PORTSMOUTH TOWNSHIP",
    "display_name": "PORTSMOUTH TOWNSHIP",
    "county": "BAY",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005540",
    "resolved_pwsid": "MI0005540",
    "system_name": "PORTSMOUTH TOWNSHIP",
    "display_name": "PORTSMOUTH TOWNSHIP",
    "county": "BAY",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005540",
    "resolved_pwsid": "MI0005540",
    "system_name": "PORTSMOUTH TOWNSHIP",
    "display_name": "PORTSMOUTH TOWNSHIP",
    "county": "BAY",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005540",
    "resolved_pwsid": "MI0005540",
    "system_name": "PORTSMOUTH TOWNSHIP",
    "display_name": "PORTSMOUTH TOWNSHIP",
    "county": "BAY",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005540",
    "resolved_pwsid": "MI0005540",
    "system_name": "PORTSMOUTH TOWNSHIP",
    "display_name": "PORTSMOUTH TOWNSHIP",
    "county": "BAY",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005543",
    "resolved_pwsid": "MI0005543",
    "system_name": "POSEN, VILLAGE OF",
    "display_name": "POSEN, VILLAGE OF",
    "county": "PRESQUE ISLE",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005543",
    "resolved_pwsid": "MI0005543",
    "system_name": "POSEN, VILLAGE OF",
    "display_name": "POSEN, VILLAGE OF",
    "county": "PRESQUE ISLE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005543",
    "resolved_pwsid": "MI0005543",
    "system_name": "POSEN, VILLAGE OF",
    "display_name": "POSEN, VILLAGE OF",
    "county": "PRESQUE ISLE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005543",
    "resolved_pwsid": "MI0005543",
    "system_name": "POSEN, VILLAGE OF",
    "display_name": "POSEN, VILLAGE OF",
    "county": "PRESQUE ISLE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0005549",
    "resolved_pwsid": "MI0005549",
    "system_name": "LAKE MICHIGAN BEACH RESORT POTTAWATTAMIE",
    "display_name": "LAKE MICHIGAN BEACH RESORT POTTAWATTAMIE",
    "county": "BERRIEN",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005549",
    "resolved_pwsid": "MI0005549",
    "system_name": "LAKE MICHIGAN BEACH RESORT POTTAWATTAMIE",
    "display_name": "LAKE MICHIGAN BEACH RESORT POTTAWATTAMIE",
    "county": "BERRIEN",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005549",
    "resolved_pwsid": "MI0005549",
    "system_name": "LAKE MICHIGAN BEACH RESORT POTTAWATTAMIE",
    "display_name": "LAKE MICHIGAN BEACH RESORT POTTAWATTAMIE",
    "county": "BERRIEN",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005549",
    "resolved_pwsid": "MI0005549",
    "system_name": "LAKE MICHIGAN BEACH RESORT POTTAWATTAMIE",
    "display_name": "LAKE MICHIGAN BEACH RESORT POTTAWATTAMIE",
    "county": "BERRIEN",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0005550",
    "resolved_pwsid": "MI0005550",
    "system_name": "POTTERVILLE, CITY OF",
    "display_name": "POTTERVILLE, CITY OF",
    "county": "EATON",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005550",
    "resolved_pwsid": "MI0005550",
    "system_name": "POTTERVILLE, CITY OF",
    "display_name": "POTTERVILLE, CITY OF",
    "county": "EATON",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005550",
    "resolved_pwsid": "MI0005550",
    "system_name": "POTTERVILLE, CITY OF",
    "display_name": "POTTERVILLE, CITY OF",
    "county": "EATON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005563",
    "resolved_pwsid": "MI0005563",
    "system_name": "POWERS-SPALDING WATER AUTHORITY",
    "display_name": "POWERS-SPALDING WATER AUTHORITY",
    "county": "MENOMINEE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005563",
    "resolved_pwsid": "MI0005563",
    "system_name": "POWERS-SPALDING WATER AUTHORITY",
    "display_name": "POWERS-SPALDING WATER AUTHORITY",
    "county": "MENOMINEE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005563",
    "resolved_pwsid": "MI0005563",
    "system_name": "POWERS-SPALDING WATER AUTHORITY",
    "display_name": "POWERS-SPALDING WATER AUTHORITY",
    "county": "MENOMINEE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005566",
    "resolved_pwsid": "MI0005566",
    "system_name": "PRAIRIE VILLAGE APARTMENTS",
    "display_name": "PRAIRIE VILLAGE APARTMENTS",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005566",
    "resolved_pwsid": "MI0005566",
    "system_name": "PRAIRIE VILLAGE APARTMENTS",
    "display_name": "PRAIRIE VILLAGE APARTMENTS",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005566",
    "resolved_pwsid": "MI0005566",
    "system_name": "PRAIRIE VILLAGE APARTMENTS",
    "display_name": "PRAIRIE VILLAGE APARTMENTS",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005566",
    "resolved_pwsid": "MI0005566",
    "system_name": "PRAIRIE VILLAGE APARTMENTS",
    "display_name": "PRAIRIE VILLAGE APARTMENTS",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005566",
    "resolved_pwsid": "MI0005566",
    "system_name": "PRAIRIE VILLAGE APARTMENTS",
    "display_name": "PRAIRIE VILLAGE APARTMENTS",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005566",
    "resolved_pwsid": "MI0005566",
    "system_name": "PRAIRIE VILLAGE APARTMENTS",
    "display_name": "PRAIRIE VILLAGE APARTMENTS",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005566",
    "resolved_pwsid": "MI0005566",
    "system_name": "PRAIRIE VILLAGE APARTMENTS",
    "display_name": "PRAIRIE VILLAGE APARTMENTS",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0005570",
    "resolved_pwsid": "MI0005570",
    "system_name": "PRESCOTT-HIDDEN CREEK MANOR",
    "display_name": "PRESCOTT-HIDDEN CREEK MANOR",
    "county": "OGEMAW",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005570",
    "resolved_pwsid": "MI0005570",
    "system_name": "PRESCOTT-HIDDEN CREEK MANOR",
    "display_name": "PRESCOTT-HIDDEN CREEK MANOR",
    "county": "OGEMAW",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005570",
    "resolved_pwsid": "MI0005570",
    "system_name": "PRESCOTT-HIDDEN CREEK MANOR",
    "display_name": "PRESCOTT-HIDDEN CREEK MANOR",
    "county": "OGEMAW",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005573",
    "resolved_pwsid": "MI0005573",
    "system_name": "OAKLAND HUNT SUBDIVISION",
    "display_name": "OAKLAND HUNT SUBDIVISION",
    "county": "OAKLAND",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005573",
    "resolved_pwsid": "MI0005573",
    "system_name": "OAKLAND HUNT SUBDIVISION",
    "display_name": "OAKLAND HUNT SUBDIVISION",
    "county": "OAKLAND",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005573",
    "resolved_pwsid": "MI0005573",
    "system_name": "OAKLAND HUNT SUBDIVISION",
    "display_name": "OAKLAND HUNT SUBDIVISION",
    "county": "OAKLAND",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005573",
    "resolved_pwsid": "MI0005573",
    "system_name": "OAKLAND HUNT SUBDIVISION",
    "display_name": "OAKLAND HUNT SUBDIVISION",
    "county": "OAKLAND",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005573",
    "resolved_pwsid": "MI0005573",
    "system_name": "OAKLAND HUNT SUBDIVISION",
    "display_name": "OAKLAND HUNT SUBDIVISION",
    "county": "OAKLAND",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0005575",
    "resolved_pwsid": "MI0005575",
    "system_name": "PRESQUE ISLE HARBOR WATER CO.",
    "display_name": "PRESQUE ISLE HARBOR WATER CO.",
    "county": "PRESQUE ISLE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005575",
    "resolved_pwsid": "MI0005575",
    "system_name": "PRESQUE ISLE HARBOR WATER CO.",
    "display_name": "PRESQUE ISLE HARBOR WATER CO.",
    "county": "PRESQUE ISLE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005575",
    "resolved_pwsid": "MI0005575",
    "system_name": "PRESQUE ISLE HARBOR WATER CO.",
    "display_name": "PRESQUE ISLE HARBOR WATER CO.",
    "county": "PRESQUE ISLE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005575",
    "resolved_pwsid": "MI0005575",
    "system_name": "PRESQUE ISLE HARBOR WATER CO.",
    "display_name": "PRESQUE ISLE HARBOR WATER CO.",
    "county": "PRESQUE ISLE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005577",
    "resolved_pwsid": "MI0005577",
    "system_name": "LAKESHORE VILLAGE SUBDIVISION",
    "display_name": "LAKESHORE VILLAGE SUBDIVISION",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005577",
    "resolved_pwsid": "MI0005577",
    "system_name": "LAKESHORE VILLAGE SUBDIVISION",
    "display_name": "LAKESHORE VILLAGE SUBDIVISION",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005577",
    "resolved_pwsid": "MI0005577",
    "system_name": "LAKESHORE VILLAGE SUBDIVISION",
    "display_name": "LAKESHORE VILLAGE SUBDIVISION",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005577",
    "resolved_pwsid": "MI0005577",
    "system_name": "LAKESHORE VILLAGE SUBDIVISION",
    "display_name": "LAKESHORE VILLAGE SUBDIVISION",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005577",
    "resolved_pwsid": "MI0005577",
    "system_name": "LAKESHORE VILLAGE SUBDIVISION",
    "display_name": "LAKESHORE VILLAGE SUBDIVISION",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005580",
    "resolved_pwsid": "MI0005580",
    "system_name": "QUINCY",
    "display_name": "QUINCY",
    "county": "BRANCH",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005580",
    "resolved_pwsid": "MI0005580",
    "system_name": "QUINCY",
    "display_name": "QUINCY",
    "county": "BRANCH",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005580",
    "resolved_pwsid": "MI0005580",
    "system_name": "QUINCY",
    "display_name": "QUINCY",
    "county": "BRANCH",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005580",
    "resolved_pwsid": "MI0005580",
    "system_name": "QUINCY",
    "display_name": "QUINCY",
    "county": "BRANCH",
    "monitoring_end_date": "",
    "year": 2023,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 32,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005580",
    "resolved_pwsid": "MI0005580",
    "system_name": "QUINCY",
    "display_name": "QUINCY",
    "county": "BRANCH",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 4,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005585",
    "resolved_pwsid": "MI0005585",
    "system_name": "FRANKLIN-QUINCY WATER AUTHORITY",
    "display_name": "FRANKLIN-QUINCY WATER AUTHORITY",
    "county": "HOUGHTON",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005585",
    "resolved_pwsid": "MI0005585",
    "system_name": "FRANKLIN-QUINCY WATER AUTHORITY",
    "display_name": "FRANKLIN-QUINCY WATER AUTHORITY",
    "county": "HOUGHTON",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005585",
    "resolved_pwsid": "MI0005585",
    "system_name": "FRANKLIN-QUINCY WATER AUTHORITY",
    "display_name": "FRANKLIN-QUINCY WATER AUTHORITY",
    "county": "HOUGHTON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005585",
    "resolved_pwsid": "MI0005585",
    "system_name": "FRANKLIN-QUINCY WATER AUTHORITY",
    "display_name": "FRANKLIN-QUINCY WATER AUTHORITY",
    "county": "HOUGHTON",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0005590",
    "resolved_pwsid": "MI0005590",
    "system_name": "QUINNESEC",
    "display_name": "QUINNESEC",
    "county": "DICKINSON",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005590",
    "resolved_pwsid": "MI0005590",
    "system_name": "QUINNESEC",
    "display_name": "QUINNESEC",
    "county": "DICKINSON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005590",
    "resolved_pwsid": "MI0005590",
    "system_name": "QUINNESEC",
    "display_name": "QUINNESEC",
    "county": "DICKINSON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": 19,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005590",
    "resolved_pwsid": "MI0005590",
    "system_name": "QUINNESEC",
    "display_name": "QUINNESEC",
    "county": "DICKINSON",
    "monitoring_end_date": "",
    "year": 2021,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 3,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005590",
    "resolved_pwsid": "MI0005590",
    "system_name": "QUINNESEC",
    "display_name": "QUINNESEC",
    "county": "DICKINSON",
    "monitoring_end_date": "",
    "year": 2024,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 5,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005590",
    "resolved_pwsid": "MI0005590",
    "system_name": "QUINNESEC",
    "display_name": "QUINNESEC",
    "county": "DICKINSON",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 2,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005600",
    "resolved_pwsid": "MI0005600",
    "system_name": "BESSEMER TOWNSHIP",
    "display_name": "BESSEMER TOWNSHIP",
    "county": "GOGEBIC",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005600",
    "resolved_pwsid": "MI0005600",
    "system_name": "BESSEMER TOWNSHIP",
    "display_name": "BESSEMER TOWNSHIP",
    "county": "GOGEBIC",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005600",
    "resolved_pwsid": "MI0005600",
    "system_name": "BESSEMER TOWNSHIP",
    "display_name": "BESSEMER TOWNSHIP",
    "county": "GOGEBIC",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005600",
    "resolved_pwsid": "MI0005600",
    "system_name": "BESSEMER TOWNSHIP",
    "display_name": "BESSEMER TOWNSHIP",
    "county": "GOGEBIC",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005600",
    "resolved_pwsid": "MI0005600",
    "system_name": "BESSEMER TOWNSHIP",
    "display_name": "BESSEMER TOWNSHIP",
    "county": "GOGEBIC",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 10,
    "above_action_level": false,
    "lines_replaced": 3,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005600",
    "resolved_pwsid": "MI0005600",
    "system_name": "BESSEMER TOWNSHIP",
    "display_name": "BESSEMER TOWNSHIP",
    "county": "GOGEBIC",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005600",
    "resolved_pwsid": "MI0005600",
    "system_name": "BESSEMER TOWNSHIP",
    "display_name": "BESSEMER TOWNSHIP",
    "county": "GOGEBIC",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 30,
    "inventory_gpcl": 0,
    "inventory_unknown": 242,
    "total_to_identify_or_replace": 272,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0005606",
    "resolved_pwsid": "MI0005606",
    "system_name": "WEST PARK APARTMENTS",
    "display_name": "WEST PARK APARTMENTS",
    "county": "OTSEGO",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005606",
    "resolved_pwsid": "MI0005606",
    "system_name": "WEST PARK APARTMENTS",
    "display_name": "WEST PARK APARTMENTS",
    "county": "OTSEGO",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005606",
    "resolved_pwsid": "MI0005606",
    "system_name": "WEST PARK APARTMENTS",
    "display_name": "WEST PARK APARTMENTS",
    "county": "OTSEGO",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005607",
    "resolved_pwsid": "MI0005607",
    "system_name": "RAPID RIVER MEADOWS",
    "display_name": "RAPID RIVER MEADOWS",
    "county": "KALKASKA",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005607",
    "resolved_pwsid": "MI0005607",
    "system_name": "RAPID RIVER MEADOWS",
    "display_name": "RAPID RIVER MEADOWS",
    "county": "KALKASKA",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005607",
    "resolved_pwsid": "MI0005607",
    "system_name": "RAPID RIVER MEADOWS",
    "display_name": "RAPID RIVER MEADOWS",
    "county": "KALKASKA",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005610",
    "resolved_pwsid": "MI0005610",
    "system_name": "RAVENNA",
    "display_name": "RAVENNA",
    "county": "MUSKEGON",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005610",
    "resolved_pwsid": "MI0005610",
    "system_name": "RAVENNA",
    "display_name": "RAVENNA",
    "county": "MUSKEGON",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005610",
    "resolved_pwsid": "MI0005610",
    "system_name": "RAVENNA",
    "display_name": "RAVENNA",
    "county": "MUSKEGON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005610",
    "resolved_pwsid": "MI0005610",
    "system_name": "RAVENNA",
    "display_name": "RAVENNA",
    "county": "MUSKEGON",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005610",
    "resolved_pwsid": "MI0005610",
    "system_name": "RAVENNA",
    "display_name": "RAVENNA",
    "county": "MUSKEGON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005610",
    "resolved_pwsid": "MI0005610",
    "system_name": "RAVENNA",
    "display_name": "RAVENNA",
    "county": "MUSKEGON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005610",
    "resolved_pwsid": "MI0005610",
    "system_name": "RAVENNA",
    "display_name": "RAVENNA",
    "county": "MUSKEGON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005620",
    "resolved_pwsid": "MI0005620",
    "system_name": "READING",
    "display_name": "READING",
    "county": "HILLSDALE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005620",
    "resolved_pwsid": "MI0005620",
    "system_name": "READING",
    "display_name": "READING",
    "county": "HILLSDALE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005620",
    "resolved_pwsid": "MI0005620",
    "system_name": "READING",
    "display_name": "READING",
    "county": "HILLSDALE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005620",
    "resolved_pwsid": "MI0005620",
    "system_name": "READING",
    "display_name": "READING",
    "county": "HILLSDALE",
    "monitoring_end_date": "",
    "year": 2023,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 4,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005620",
    "resolved_pwsid": "MI0005620",
    "system_name": "READING",
    "display_name": "READING",
    "county": "HILLSDALE",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 66,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005640",
    "resolved_pwsid": "MI0005640",
    "system_name": "REDFORD TOWNSHIP",
    "display_name": "REDFORD TOWNSHIP",
    "county": "WAYNE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005640",
    "resolved_pwsid": "MI0005640",
    "system_name": "REDFORD TOWNSHIP",
    "display_name": "REDFORD TOWNSHIP",
    "county": "WAYNE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005640",
    "resolved_pwsid": "MI0005640",
    "system_name": "REDFORD TOWNSHIP",
    "display_name": "REDFORD TOWNSHIP",
    "county": "WAYNE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005640",
    "resolved_pwsid": "MI0005640",
    "system_name": "REDFORD TOWNSHIP",
    "display_name": "REDFORD TOWNSHIP",
    "county": "WAYNE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 13,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005640",
    "resolved_pwsid": "MI0005640",
    "system_name": "REDFORD TOWNSHIP",
    "display_name": "REDFORD TOWNSHIP",
    "county": "WAYNE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 10,
    "above_action_level": false,
    "lines_replaced": 12,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005640",
    "resolved_pwsid": "MI0005640",
    "system_name": "REDFORD TOWNSHIP",
    "display_name": "REDFORD TOWNSHIP",
    "county": "WAYNE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 21,
    "above_action_level": true,
    "lines_replaced": 109,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005640",
    "resolved_pwsid": "MI0005640",
    "system_name": "REDFORD TOWNSHIP",
    "display_name": "REDFORD TOWNSHIP",
    "county": "WAYNE",
    "monitoring_end_date": "2024-06-30",
    "year": 2024,
    "lead_90th_ppb": 16,
    "above_action_level": true,
    "lines_replaced": 30,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005640",
    "resolved_pwsid": "MI0005640",
    "system_name": "REDFORD TOWNSHIP",
    "display_name": "REDFORD TOWNSHIP",
    "county": "WAYNE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 12,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005640",
    "resolved_pwsid": "MI0005640",
    "system_name": "REDFORD TOWNSHIP",
    "display_name": "REDFORD TOWNSHIP",
    "county": "WAYNE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 10,
    "above_action_level": false,
    "lines_replaced": 102,
    "inventory_lead": 94,
    "inventory_gpcl": 0,
    "inventory_unknown": 4922,
    "total_to_identify_or_replace": 5016,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0005640",
    "resolved_pwsid": "MI0005640",
    "system_name": "REDFORD TOWNSHIP",
    "display_name": "REDFORD TOWNSHIP",
    "county": "WAYNE",
    "monitoring_end_date": "2026-06-30",
    "year": 2026,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005650",
    "resolved_pwsid": "MI0005650",
    "system_name": "REED CITY, CITY OF",
    "display_name": "REED CITY, CITY OF",
    "county": "OSCEOLA",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005650",
    "resolved_pwsid": "MI0005650",
    "system_name": "REED CITY, CITY OF",
    "display_name": "REED CITY, CITY OF",
    "county": "OSCEOLA",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": 24,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005650",
    "resolved_pwsid": "MI0005650",
    "system_name": "REED CITY, CITY OF",
    "display_name": "REED CITY, CITY OF",
    "county": "OSCEOLA",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": 100,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005650",
    "resolved_pwsid": "MI0005650",
    "system_name": "REED CITY, CITY OF",
    "display_name": "REED CITY, CITY OF",
    "county": "OSCEOLA",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005650",
    "resolved_pwsid": "MI0005650",
    "system_name": "REED CITY, CITY OF",
    "display_name": "REED CITY, CITY OF",
    "county": "OSCEOLA",
    "monitoring_end_date": "2026-06-30",
    "year": 2026,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005650",
    "resolved_pwsid": "MI0005650",
    "system_name": "REED CITY, CITY OF",
    "display_name": "REED CITY, CITY OF",
    "county": "OSCEOLA",
    "monitoring_end_date": "",
    "year": 2022,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 34,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005650",
    "resolved_pwsid": "MI0005650",
    "system_name": "REED CITY, CITY OF",
    "display_name": "REED CITY, CITY OF",
    "county": "OSCEOLA",
    "monitoring_end_date": "",
    "year": 2023,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 54,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005650",
    "resolved_pwsid": "MI0005650",
    "system_name": "REED CITY, CITY OF",
    "display_name": "REED CITY, CITY OF",
    "county": "OSCEOLA",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 214,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005655",
    "resolved_pwsid": "MI0005655",
    "system_name": "REMUS APARTMENT COMPANY",
    "display_name": "REMUS APARTMENT COMPANY",
    "county": "MECOSTA",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005655",
    "resolved_pwsid": "MI0005655",
    "system_name": "REMUS APARTMENT COMPANY",
    "display_name": "REMUS APARTMENT COMPANY",
    "county": "MECOSTA",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005655",
    "resolved_pwsid": "MI0005655",
    "system_name": "REMUS APARTMENT COMPANY",
    "display_name": "REMUS APARTMENT COMPANY",
    "county": "MECOSTA",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005655",
    "resolved_pwsid": "MI0005655",
    "system_name": "REMUS APARTMENT COMPANY",
    "display_name": "REMUS APARTMENT COMPANY",
    "county": "MECOSTA",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0005660",
    "resolved_pwsid": "MI0005660",
    "system_name": "REPUBLIC TOWNSHIP",
    "display_name": "REPUBLIC TOWNSHIP",
    "county": "MARQUETTE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005660",
    "resolved_pwsid": "MI0005660",
    "system_name": "REPUBLIC TOWNSHIP",
    "display_name": "REPUBLIC TOWNSHIP",
    "county": "MARQUETTE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005660",
    "resolved_pwsid": "MI0005660",
    "system_name": "REPUBLIC TOWNSHIP",
    "display_name": "REPUBLIC TOWNSHIP",
    "county": "MARQUETTE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005660",
    "resolved_pwsid": "MI0005660",
    "system_name": "REPUBLIC TOWNSHIP",
    "display_name": "REPUBLIC TOWNSHIP",
    "county": "MARQUETTE",
    "monitoring_end_date": "",
    "year": 2024,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 4,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005670",
    "resolved_pwsid": "MI0005670",
    "system_name": "RICHMOND, CITY OF",
    "display_name": "RICHMOND, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005670",
    "resolved_pwsid": "MI0005670",
    "system_name": "RICHMOND, CITY OF",
    "display_name": "RICHMOND, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005670",
    "resolved_pwsid": "MI0005670",
    "system_name": "RICHMOND, CITY OF",
    "display_name": "RICHMOND, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005670",
    "resolved_pwsid": "MI0005670",
    "system_name": "RICHMOND, CITY OF",
    "display_name": "RICHMOND, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005670",
    "resolved_pwsid": "MI0005670",
    "system_name": "RICHMOND, CITY OF",
    "display_name": "RICHMOND, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "",
    "year": 2024,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005673",
    "resolved_pwsid": "MI0005673",
    "system_name": "RIDGEWAY",
    "display_name": "RIDGEWAY",
    "county": "MACOMB",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005673",
    "resolved_pwsid": "MI0005673",
    "system_name": "RIDGEWAY",
    "display_name": "RIDGEWAY",
    "county": "MACOMB",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005673",
    "resolved_pwsid": "MI0005673",
    "system_name": "RIDGEWAY",
    "display_name": "RIDGEWAY",
    "county": "MACOMB",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005673",
    "resolved_pwsid": "MI0005673",
    "system_name": "RIDGEWAY",
    "display_name": "RIDGEWAY",
    "county": "MACOMB",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005673",
    "resolved_pwsid": "MI0005673",
    "system_name": "RIDGEWAY",
    "display_name": "RIDGEWAY",
    "county": "MACOMB",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005673",
    "resolved_pwsid": "MI0005673",
    "system_name": "RIDGEWAY",
    "display_name": "RIDGEWAY",
    "county": "MACOMB",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0005675",
    "resolved_pwsid": "MI0005675",
    "system_name": "RIGA TOWNSHIP",
    "display_name": "RIGA TOWNSHIP",
    "county": "LENAWEE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005675",
    "resolved_pwsid": "MI0005675",
    "system_name": "RIGA TOWNSHIP",
    "display_name": "RIGA TOWNSHIP",
    "county": "LENAWEE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005675",
    "resolved_pwsid": "MI0005675",
    "system_name": "RIGA TOWNSHIP",
    "display_name": "RIGA TOWNSHIP",
    "county": "LENAWEE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005675",
    "resolved_pwsid": "MI0005675",
    "system_name": "RIGA TOWNSHIP",
    "display_name": "RIGA TOWNSHIP",
    "county": "LENAWEE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005675",
    "resolved_pwsid": "MI0005675",
    "system_name": "RIGA TOWNSHIP",
    "display_name": "RIGA TOWNSHIP",
    "county": "LENAWEE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005675",
    "resolved_pwsid": "MI0005675",
    "system_name": "RIGA TOWNSHIP",
    "display_name": "RIGA TOWNSHIP",
    "county": "LENAWEE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005675",
    "resolved_pwsid": "MI0005675",
    "system_name": "RIGA TOWNSHIP",
    "display_name": "RIGA TOWNSHIP",
    "county": "LENAWEE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005675",
    "resolved_pwsid": "MI0005675",
    "system_name": "RIGA TOWNSHIP",
    "display_name": "RIGA TOWNSHIP",
    "county": "LENAWEE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0005680",
    "resolved_pwsid": "MI0005680",
    "system_name": "FRANKLIN TOWNSHIP",
    "display_name": "FRANKLIN TOWNSHIP",
    "county": "HOUGHTON",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005680",
    "resolved_pwsid": "MI0005680",
    "system_name": "FRANKLIN TOWNSHIP",
    "display_name": "FRANKLIN TOWNSHIP",
    "county": "HOUGHTON",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005680",
    "resolved_pwsid": "MI0005680",
    "system_name": "FRANKLIN TOWNSHIP",
    "display_name": "FRANKLIN TOWNSHIP",
    "county": "HOUGHTON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005690",
    "resolved_pwsid": "MI0005690",
    "system_name": "RIVER ROUGE",
    "display_name": "RIVER ROUGE",
    "county": "WAYNE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005690",
    "resolved_pwsid": "MI0005690",
    "system_name": "RIVER ROUGE",
    "display_name": "RIVER ROUGE",
    "county": "WAYNE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005690",
    "resolved_pwsid": "MI0005690",
    "system_name": "RIVER ROUGE",
    "display_name": "RIVER ROUGE",
    "county": "WAYNE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005690",
    "resolved_pwsid": "MI0005690",
    "system_name": "RIVER ROUGE",
    "display_name": "RIVER ROUGE",
    "county": "WAYNE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 9,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005690",
    "resolved_pwsid": "MI0005690",
    "system_name": "RIVER ROUGE",
    "display_name": "RIVER ROUGE",
    "county": "WAYNE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005690",
    "resolved_pwsid": "MI0005690",
    "system_name": "RIVER ROUGE",
    "display_name": "RIVER ROUGE",
    "county": "WAYNE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": 97,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005690",
    "resolved_pwsid": "MI0005690",
    "system_name": "RIVER ROUGE",
    "display_name": "RIVER ROUGE",
    "county": "WAYNE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": 139,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005690",
    "resolved_pwsid": "MI0005690",
    "system_name": "RIVER ROUGE",
    "display_name": "RIVER ROUGE",
    "county": "WAYNE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 13,
    "above_action_level": true,
    "lines_replaced": 241,
    "inventory_lead": 155,
    "inventory_gpcl": 0,
    "inventory_unknown": 2481,
    "total_to_identify_or_replace": 2636,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0005690",
    "resolved_pwsid": "MI0005690",
    "system_name": "RIVER ROUGE",
    "display_name": "RIVER ROUGE",
    "county": "WAYNE",
    "monitoring_end_date": "2026-06-30",
    "year": 2026,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005692",
    "resolved_pwsid": "MI0005692",
    "system_name": "RIVERBROOKE HOME OWNERS ASSOCIATION",
    "display_name": "RIVERBROOKE HOME OWNERS ASSOCIATION",
    "county": "BERRIEN",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005692",
    "resolved_pwsid": "MI0005692",
    "system_name": "RIVERBROOKE HOME OWNERS ASSOCIATION",
    "display_name": "RIVERBROOKE HOME OWNERS ASSOCIATION",
    "county": "BERRIEN",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005692",
    "resolved_pwsid": "MI0005692",
    "system_name": "RIVERBROOKE HOME OWNERS ASSOCIATION",
    "display_name": "RIVERBROOKE HOME OWNERS ASSOCIATION",
    "county": "BERRIEN",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005692",
    "resolved_pwsid": "MI0005692-a",
    "system_name": "RIVERBROOKE HOMEOWNERS ASSOCIATION",
    "display_name": "RIVERBROOKE HOMEOWNERS ASSOCIATION",
    "county": "BERRIEN",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005710",
    "resolved_pwsid": "MI0005710",
    "system_name": "RIVERVIEW",
    "display_name": "RIVERVIEW",
    "county": "WAYNE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005710",
    "resolved_pwsid": "MI0005710",
    "system_name": "RIVERVIEW",
    "display_name": "RIVERVIEW",
    "county": "WAYNE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 15,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005710",
    "resolved_pwsid": "MI0005710",
    "system_name": "RIVERVIEW",
    "display_name": "RIVERVIEW",
    "county": "WAYNE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 10,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005710",
    "resolved_pwsid": "MI0005710",
    "system_name": "RIVERVIEW",
    "display_name": "RIVERVIEW",
    "county": "WAYNE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 12,
    "above_action_level": false,
    "lines_replaced": 7,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005710",
    "resolved_pwsid": "MI0005710",
    "system_name": "RIVERVIEW",
    "display_name": "RIVERVIEW",
    "county": "WAYNE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 12,
    "above_action_level": false,
    "lines_replaced": 8,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005710",
    "resolved_pwsid": "MI0005710",
    "system_name": "RIVERVIEW",
    "display_name": "RIVERVIEW",
    "county": "WAYNE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 13,
    "above_action_level": true,
    "lines_replaced": 7,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005710",
    "resolved_pwsid": "MI0005710",
    "system_name": "RIVERVIEW",
    "display_name": "RIVERVIEW",
    "county": "WAYNE",
    "monitoring_end_date": "2024-09-30",
    "year": 2024,
    "lead_90th_ppb": 16,
    "above_action_level": true,
    "lines_replaced": 23,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005710",
    "resolved_pwsid": "MI0005710",
    "system_name": "RIVERVIEW",
    "display_name": "RIVERVIEW",
    "county": "WAYNE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 16,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005710",
    "resolved_pwsid": "MI0005710",
    "system_name": "RIVERVIEW",
    "display_name": "RIVERVIEW",
    "county": "WAYNE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": 20,
    "inventory_lead": 84,
    "inventory_gpcl": 1,
    "inventory_unknown": 38,
    "total_to_identify_or_replace": 123,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0005712",
    "resolved_pwsid": "MI0005712",
    "system_name": "RIVERWALK DEVELOPMENT",
    "display_name": "RIVERWALK DEVELOPMENT",
    "county": "ALLEGAN",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005712",
    "resolved_pwsid": "MI0005712",
    "system_name": "RIVERWALK DEVELOPMENT",
    "display_name": "RIVERWALK DEVELOPMENT",
    "county": "ALLEGAN",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005712",
    "resolved_pwsid": "MI0005712",
    "system_name": "RIVERWALK DEVELOPMENT",
    "display_name": "RIVERWALK DEVELOPMENT",
    "county": "ALLEGAN",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005720",
    "resolved_pwsid": "MI0005720",
    "system_name": "ROCHESTER",
    "display_name": "ROCHESTER",
    "county": "OAKLAND",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005720",
    "resolved_pwsid": "MI0005720",
    "system_name": "ROCHESTER",
    "display_name": "ROCHESTER",
    "county": "OAKLAND",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005720",
    "resolved_pwsid": "MI0005720",
    "system_name": "ROCHESTER",
    "display_name": "ROCHESTER",
    "county": "OAKLAND",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 6,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005720",
    "resolved_pwsid": "MI0005720",
    "system_name": "ROCHESTER",
    "display_name": "ROCHESTER",
    "county": "OAKLAND",
    "monitoring_end_date": "",
    "year": 2021,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 18,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005720",
    "resolved_pwsid": "MI0005720",
    "system_name": "ROCHESTER",
    "display_name": "ROCHESTER",
    "county": "OAKLAND",
    "monitoring_end_date": "",
    "year": 2022,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 10,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005720",
    "resolved_pwsid": "MI0005720",
    "system_name": "ROCHESTER",
    "display_name": "ROCHESTER",
    "county": "OAKLAND",
    "monitoring_end_date": "",
    "year": 2024,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 7,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005720",
    "resolved_pwsid": "MI0005720",
    "system_name": "ROCHESTER",
    "display_name": "ROCHESTER",
    "county": "OAKLAND",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 5,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005723",
    "resolved_pwsid": "MI0005723",
    "system_name": "ROCHESTER EAST",
    "display_name": "ROCHESTER EAST",
    "county": "OAKLAND",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005723",
    "resolved_pwsid": "MI0005723",
    "system_name": "ROCHESTER EAST",
    "display_name": "ROCHESTER EAST",
    "county": "OAKLAND",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005723",
    "resolved_pwsid": "MI0005723",
    "system_name": "ROCHESTER EAST",
    "display_name": "ROCHESTER EAST",
    "county": "OAKLAND",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005723",
    "resolved_pwsid": "MI0005723",
    "system_name": "ROCHESTER EAST",
    "display_name": "ROCHESTER EAST",
    "county": "OAKLAND",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005723",
    "resolved_pwsid": "MI0005723",
    "system_name": "ROCHESTER EAST",
    "display_name": "ROCHESTER EAST",
    "county": "OAKLAND",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005723",
    "resolved_pwsid": "MI0005723",
    "system_name": "ROCHESTER EAST",
    "display_name": "ROCHESTER EAST",
    "county": "OAKLAND",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005723",
    "resolved_pwsid": "MI0005723",
    "system_name": "ROCHESTER EAST",
    "display_name": "ROCHESTER EAST",
    "county": "OAKLAND",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005723",
    "resolved_pwsid": "MI0005723",
    "system_name": "ROCHESTER EAST",
    "display_name": "ROCHESTER EAST",
    "county": "OAKLAND",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0005730",
    "resolved_pwsid": "MI0005730",
    "system_name": "ROCKFORD",
    "display_name": "ROCKFORD",
    "county": "KENT",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005730",
    "resolved_pwsid": "MI0005730",
    "system_name": "ROCKFORD",
    "display_name": "ROCKFORD",
    "county": "KENT",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005730",
    "resolved_pwsid": "MI0005730",
    "system_name": "ROCKFORD",
    "display_name": "ROCKFORD",
    "county": "KENT",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005730",
    "resolved_pwsid": "MI0005730",
    "system_name": "ROCKFORD",
    "display_name": "ROCKFORD",
    "county": "KENT",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005730",
    "resolved_pwsid": "MI0005730",
    "system_name": "ROCKFORD",
    "display_name": "ROCKFORD",
    "county": "KENT",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005730",
    "resolved_pwsid": "MI0005730",
    "system_name": "ROCKFORD",
    "display_name": "ROCKFORD",
    "county": "KENT",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 42,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005730",
    "resolved_pwsid": "MI0005730",
    "system_name": "ROCKFORD",
    "display_name": "ROCKFORD",
    "county": "KENT",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 47,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005730",
    "resolved_pwsid": "MI0005730",
    "system_name": "ROCKFORD",
    "display_name": "ROCKFORD",
    "county": "KENT",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 67,
    "inventory_lead": 44,
    "inventory_gpcl": 357,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 401,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0005740",
    "resolved_pwsid": "MI0005740",
    "system_name": "ROCKLAND TOWNSHIP",
    "display_name": "ROCKLAND TOWNSHIP",
    "county": "ONTONAGON",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005740",
    "resolved_pwsid": "MI0005740",
    "system_name": "ROCKLAND TOWNSHIP",
    "display_name": "ROCKLAND TOWNSHIP",
    "county": "ONTONAGON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005740",
    "resolved_pwsid": "MI0005740",
    "system_name": "ROCKLAND TOWNSHIP",
    "display_name": "ROCKLAND TOWNSHIP",
    "county": "ONTONAGON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 15,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005750",
    "resolved_pwsid": "MI0005750",
    "system_name": "ROCKWOOD",
    "display_name": "ROCKWOOD",
    "county": "WAYNE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005750",
    "resolved_pwsid": "MI0005750",
    "system_name": "ROCKWOOD",
    "display_name": "ROCKWOOD",
    "county": "WAYNE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005750",
    "resolved_pwsid": "MI0005750",
    "system_name": "ROCKWOOD",
    "display_name": "ROCKWOOD",
    "county": "WAYNE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005750",
    "resolved_pwsid": "MI0005750",
    "system_name": "ROCKWOOD",
    "display_name": "ROCKWOOD",
    "county": "WAYNE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005750",
    "resolved_pwsid": "MI0005750",
    "system_name": "ROCKWOOD",
    "display_name": "ROCKWOOD",
    "county": "WAYNE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005750",
    "resolved_pwsid": "MI0005750",
    "system_name": "ROCKWOOD",
    "display_name": "ROCKWOOD",
    "county": "WAYNE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005750",
    "resolved_pwsid": "MI0005750",
    "system_name": "ROCKWOOD",
    "display_name": "ROCKWOOD",
    "county": "WAYNE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005750",
    "resolved_pwsid": "MI0005750",
    "system_name": "ROCKWOOD",
    "display_name": "ROCKWOOD",
    "county": "WAYNE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 86,
    "total_to_identify_or_replace": 86,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0005760",
    "resolved_pwsid": "MI0005760",
    "system_name": "IRON RIVER TOWNSHIP-RYDEN ROAD",
    "display_name": "IRON RIVER TOWNSHIP-RYDEN ROAD",
    "county": "IRON",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005760",
    "resolved_pwsid": "MI0005760",
    "system_name": "IRON RIVER TOWNSHIP-RYDEN ROAD",
    "display_name": "IRON RIVER TOWNSHIP-RYDEN ROAD",
    "county": "IRON",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005760",
    "resolved_pwsid": "MI0005760",
    "system_name": "IRON RIVER TOWNSHIP-RYDEN ROAD",
    "display_name": "IRON RIVER TOWNSHIP-RYDEN ROAD",
    "county": "IRON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005770",
    "resolved_pwsid": "MI0005770",
    "system_name": "ROGERS CITY, CITY OF",
    "display_name": "ROGERS CITY, CITY OF",
    "county": "PRESQUE ISLE",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005770",
    "resolved_pwsid": "MI0005770",
    "system_name": "ROGERS CITY, CITY OF",
    "display_name": "ROGERS CITY, CITY OF",
    "county": "PRESQUE ISLE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005770",
    "resolved_pwsid": "MI0005770",
    "system_name": "ROGERS CITY, CITY OF",
    "display_name": "ROGERS CITY, CITY OF",
    "county": "PRESQUE ISLE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005770",
    "resolved_pwsid": "MI0005770",
    "system_name": "ROGERS CITY, CITY OF",
    "display_name": "ROGERS CITY, CITY OF",
    "county": "PRESQUE ISLE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005770",
    "resolved_pwsid": "MI0005770",
    "system_name": "ROGERS CITY, CITY OF",
    "display_name": "ROGERS CITY, CITY OF",
    "county": "PRESQUE ISLE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005770",
    "resolved_pwsid": "MI0005770",
    "system_name": "ROGERS CITY, CITY OF",
    "display_name": "ROGERS CITY, CITY OF",
    "county": "PRESQUE ISLE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005770",
    "resolved_pwsid": "MI0005770",
    "system_name": "ROGERS CITY, CITY OF",
    "display_name": "ROGERS CITY, CITY OF",
    "county": "PRESQUE ISLE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005770",
    "resolved_pwsid": "MI0005770",
    "system_name": "ROGERS CITY, CITY OF",
    "display_name": "ROGERS CITY, CITY OF",
    "county": "PRESQUE ISLE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0005775",
    "resolved_pwsid": "MI0005775",
    "system_name": "ROLLING MEADOWS WATER ASSN.",
    "display_name": "ROLLING MEADOWS WATER ASSN.",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005775",
    "resolved_pwsid": "MI0005775",
    "system_name": "ROLLING MEADOWS WATER ASSN.",
    "display_name": "ROLLING MEADOWS WATER ASSN.",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005775",
    "resolved_pwsid": "MI0005775",
    "system_name": "ROLLING MEADOWS WATER ASSN.",
    "display_name": "ROLLING MEADOWS WATER ASSN.",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005775",
    "resolved_pwsid": "MI0005775",
    "system_name": "ROLLING MEADOWS WATER ASSN.",
    "display_name": "ROLLING MEADOWS WATER ASSN.",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0005780",
    "resolved_pwsid": "MI0005780-a",
    "system_name": "ROMEO, VILLAGE OF",
    "display_name": "ROMEO, VILLAGE OF",
    "county": "MACOMB",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005780",
    "resolved_pwsid": "MI0005780-a",
    "system_name": "ROMEO, VILLAGE OF",
    "display_name": "ROMEO, VILLAGE OF",
    "county": "MACOMB",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005780",
    "resolved_pwsid": "MI0005780-e",
    "system_name": "ROMEO, VILLAGE OF (WELLS)",
    "display_name": "ROMEO, VILLAGE OF (WELLS)",
    "county": "MACOMB",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005780",
    "resolved_pwsid": "MI0005780-a",
    "system_name": "ROMEO, VILLAGE OF",
    "display_name": "ROMEO, VILLAGE OF",
    "county": "MACOMB",
    "monitoring_end_date": "2021-06-30",
    "year": 2021,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005780",
    "resolved_pwsid": "MI0005780-d",
    "system_name": "ROMEO, VILLAGE OF (GLWA)",
    "display_name": "ROMEO, VILLAGE OF (GLWA)",
    "county": "MACOMB",
    "monitoring_end_date": "2021-06-30",
    "year": 2021,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005780",
    "resolved_pwsid": "MI0005780-d",
    "system_name": "ROMEO, VILLAGE OF (GLWA)",
    "display_name": "ROMEO, VILLAGE OF (GLWA)",
    "county": "MACOMB",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005780",
    "resolved_pwsid": "MI0005780-d",
    "system_name": "ROMEO, VILLAGE OF (GLWA)",
    "display_name": "ROMEO, VILLAGE OF (GLWA)",
    "county": "MACOMB",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005780",
    "resolved_pwsid": "MI0005780-b",
    "system_name": "ROMEO, VILLAGE OF (DIST)",
    "display_name": "ROMEO, VILLAGE OF (DIST)",
    "county": "MACOMB",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005780",
    "resolved_pwsid": "MI0005780-d",
    "system_name": "ROMEO, VILLAGE OF (GLWA)",
    "display_name": "ROMEO, VILLAGE OF (GLWA)",
    "county": "MACOMB",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005780",
    "resolved_pwsid": "MI0005780-e",
    "system_name": "ROMEO, VILLAGE OF (WELLS)",
    "display_name": "ROMEO, VILLAGE OF (WELLS)",
    "county": "MACOMB",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005780",
    "resolved_pwsid": "MI0005780-f",
    "system_name": "ROMEO, VILLAGE OF  (DS001)",
    "display_name": "ROMEO, VILLAGE OF  (DS001)",
    "county": "MACOMB",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005780",
    "resolved_pwsid": "MI0005780-c",
    "system_name": "ROMEO, VILLAGE OF (DIST2)",
    "display_name": "ROMEO, VILLAGE OF (DIST2)",
    "county": "MACOMB",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005780",
    "resolved_pwsid": "MI0005780-g",
    "system_name": "ROMEO, VILLAGE OF (DS003)",
    "display_name": "ROMEO, VILLAGE OF",
    "county": "MACOMB",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 551,
    "total_to_identify_or_replace": 551,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0005785",
    "resolved_pwsid": "MI0005785",
    "system_name": "ROMULUS",
    "display_name": "ROMULUS",
    "county": "WAYNE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005785",
    "resolved_pwsid": "MI0005785",
    "system_name": "ROMULUS",
    "display_name": "ROMULUS",
    "county": "WAYNE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 9,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005785",
    "resolved_pwsid": "MI0005785",
    "system_name": "ROMULUS",
    "display_name": "ROMULUS",
    "county": "WAYNE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005785",
    "resolved_pwsid": "MI0005785",
    "system_name": "ROMULUS",
    "display_name": "ROMULUS",
    "county": "WAYNE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": 3,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005785",
    "resolved_pwsid": "MI0005785",
    "system_name": "ROMULUS",
    "display_name": "ROMULUS",
    "county": "WAYNE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 10,
    "above_action_level": false,
    "lines_replaced": 11,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005785",
    "resolved_pwsid": "MI0005785",
    "system_name": "ROMULUS",
    "display_name": "ROMULUS",
    "county": "WAYNE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 9,
    "above_action_level": false,
    "lines_replaced": 8,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005785",
    "resolved_pwsid": "MI0005785",
    "system_name": "ROMULUS",
    "display_name": "ROMULUS",
    "county": "WAYNE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 10,
    "above_action_level": false,
    "lines_replaced": 11,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005785",
    "resolved_pwsid": "MI0005785",
    "system_name": "ROMULUS",
    "display_name": "ROMULUS",
    "county": "WAYNE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": 14,
    "inventory_lead": 43,
    "inventory_gpcl": 14,
    "inventory_unknown": 5533,
    "total_to_identify_or_replace": 5590,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0005800",
    "resolved_pwsid": "MI0005800",
    "system_name": "ROOSEVELT PARK",
    "display_name": "ROOSEVELT PARK",
    "county": "MUSKEGON",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005800",
    "resolved_pwsid": "MI0005800",
    "system_name": "ROOSEVELT PARK",
    "display_name": "ROOSEVELT PARK",
    "county": "MUSKEGON",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 7,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005800",
    "resolved_pwsid": "MI0005800",
    "system_name": "ROOSEVELT PARK",
    "display_name": "ROOSEVELT PARK",
    "county": "MUSKEGON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 23,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005800",
    "resolved_pwsid": "MI0005800",
    "system_name": "ROOSEVELT PARK",
    "display_name": "ROOSEVELT PARK",
    "county": "MUSKEGON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005800",
    "resolved_pwsid": "MI0005800",
    "system_name": "ROOSEVELT PARK",
    "display_name": "ROOSEVELT PARK",
    "county": "MUSKEGON",
    "monitoring_end_date": "",
    "year": 2022,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 5,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005800",
    "resolved_pwsid": "MI0005800",
    "system_name": "ROOSEVELT PARK",
    "display_name": "ROOSEVELT PARK",
    "county": "MUSKEGON",
    "monitoring_end_date": "",
    "year": 2023,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 39,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005800",
    "resolved_pwsid": "MI0005800",
    "system_name": "ROOSEVELT PARK",
    "display_name": "ROOSEVELT PARK",
    "county": "MUSKEGON",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 35,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005810",
    "resolved_pwsid": "MI0005810",
    "system_name": "ROSCOMMON, VILLAGE OF",
    "display_name": "ROSCOMMON, VILLAGE OF",
    "county": "ROSCOMMON",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005810",
    "resolved_pwsid": "MI0005810",
    "system_name": "ROSCOMMON, VILLAGE OF",
    "display_name": "ROSCOMMON, VILLAGE OF",
    "county": "ROSCOMMON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005810",
    "resolved_pwsid": "MI0005810",
    "system_name": "ROSCOMMON, VILLAGE OF",
    "display_name": "ROSCOMMON, VILLAGE OF",
    "county": "ROSCOMMON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 4,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005810",
    "resolved_pwsid": "MI0005810",
    "system_name": "ROSCOMMON, VILLAGE OF",
    "display_name": "ROSCOMMON, VILLAGE OF",
    "county": "ROSCOMMON",
    "monitoring_end_date": "",
    "year": 2021,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 3,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005810",
    "resolved_pwsid": "MI0005810",
    "system_name": "ROSCOMMON, VILLAGE OF",
    "display_name": "ROSCOMMON, VILLAGE OF",
    "county": "ROSCOMMON",
    "monitoring_end_date": "",
    "year": 2022,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 5,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005810",
    "resolved_pwsid": "MI0005810",
    "system_name": "ROSCOMMON, VILLAGE OF",
    "display_name": "ROSCOMMON, VILLAGE OF",
    "county": "ROSCOMMON",
    "monitoring_end_date": "",
    "year": 2024,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 7,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005810",
    "resolved_pwsid": "MI0005810",
    "system_name": "ROSCOMMON, VILLAGE OF",
    "display_name": "ROSCOMMON, VILLAGE OF",
    "county": "ROSCOMMON",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 5,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005815",
    "resolved_pwsid": "MI0005815",
    "system_name": "ROSE CITY, CITY OF",
    "display_name": "ROSE CITY, CITY OF",
    "county": "OGEMAW",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005815",
    "resolved_pwsid": "MI0005815",
    "system_name": "ROSE CITY, CITY OF",
    "display_name": "ROSE CITY, CITY OF",
    "county": "OGEMAW",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005815",
    "resolved_pwsid": "MI0005815",
    "system_name": "ROSE CITY, CITY OF",
    "display_name": "ROSE CITY, CITY OF",
    "county": "OGEMAW",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005816",
    "resolved_pwsid": "MI0005816",
    "system_name": "ROSE HILL CENTER",
    "display_name": "ROSE HILL CENTER",
    "county": "OAKLAND",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005816",
    "resolved_pwsid": "MI0005816",
    "system_name": "ROSE HILL CENTER",
    "display_name": "ROSE HILL CENTER",
    "county": "OAKLAND",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005816",
    "resolved_pwsid": "MI0005816",
    "system_name": "ROSE HILL CENTER",
    "display_name": "ROSE HILL CENTER",
    "county": "OAKLAND",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005816",
    "resolved_pwsid": "MI0005816",
    "system_name": "ROSE HILL CENTER",
    "display_name": "ROSE HILL CENTER",
    "county": "OAKLAND",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0005819",
    "resolved_pwsid": "MI0005819",
    "system_name": "HIDDEN SHORES WEST",
    "display_name": "HIDDEN SHORES WEST",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005819",
    "resolved_pwsid": "MI0005819",
    "system_name": "HIDDEN SHORES WEST",
    "display_name": "HIDDEN SHORES WEST",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005819",
    "resolved_pwsid": "MI0005819",
    "system_name": "HIDDEN SHORES WEST",
    "display_name": "HIDDEN SHORES WEST",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005819",
    "resolved_pwsid": "MI0005819",
    "system_name": "HIDDEN SHORES WEST",
    "display_name": "HIDDEN SHORES WEST",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005820",
    "resolved_pwsid": "MI0005820",
    "system_name": "ROSEVILLE, CITY OF",
    "display_name": "ROSEVILLE, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005820",
    "resolved_pwsid": "MI0005820",
    "system_name": "ROSEVILLE, CITY OF",
    "display_name": "ROSEVILLE, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 9,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005820",
    "resolved_pwsid": "MI0005820",
    "system_name": "ROSEVILLE, CITY OF",
    "display_name": "ROSEVILLE, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005820",
    "resolved_pwsid": "MI0005820",
    "system_name": "ROSEVILLE, CITY OF",
    "display_name": "ROSEVILLE, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": 3,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005820",
    "resolved_pwsid": "MI0005820",
    "system_name": "ROSEVILLE, CITY OF",
    "display_name": "ROSEVILLE, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": 3,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005820",
    "resolved_pwsid": "MI0005820",
    "system_name": "ROSEVILLE, CITY OF",
    "display_name": "ROSEVILLE, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 10,
    "above_action_level": false,
    "lines_replaced": 4,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005820",
    "resolved_pwsid": "MI0005820",
    "system_name": "ROSEVILLE, CITY OF",
    "display_name": "ROSEVILLE, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": 8,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005820",
    "resolved_pwsid": "MI0005820",
    "system_name": "ROSEVILLE, CITY OF",
    "display_name": "ROSEVILLE, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 9,
    "above_action_level": false,
    "lines_replaced": 28,
    "inventory_lead": 108,
    "inventory_gpcl": 127,
    "inventory_unknown": 983,
    "total_to_identify_or_replace": 1218,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0005821",
    "resolved_pwsid": "MI0005821",
    "system_name": "ROSEVILLE APARTMENTS",
    "display_name": "ROSEVILLE APARTMENTS",
    "county": "MECOSTA",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005821",
    "resolved_pwsid": "MI0005821",
    "system_name": "ROSEVILLE APARTMENTS",
    "display_name": "ROSEVILLE APARTMENTS",
    "county": "MECOSTA",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005821",
    "resolved_pwsid": "MI0005821",
    "system_name": "ROSEVILLE APARTMENTS",
    "display_name": "ROSEVILLE APARTMENTS",
    "county": "MECOSTA",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005821",
    "resolved_pwsid": "MI0005821",
    "system_name": "ROSEVILLE APARTMENTS",
    "display_name": "ROSEVILLE APARTMENTS",
    "county": "MECOSTA",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0005823",
    "resolved_pwsid": "MI0005823",
    "system_name": "ROSEBUSH ESTATES APARTMENTS",
    "display_name": "ROSEBUSH ESTATES APARTMENTS",
    "county": "ISABELLA",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005823",
    "resolved_pwsid": "MI0005823",
    "system_name": "ROSEBUSH ESTATES APARTMENTS",
    "display_name": "ROSEBUSH ESTATES APARTMENTS",
    "county": "ISABELLA",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005823",
    "resolved_pwsid": "MI0005823",
    "system_name": "ROSEBUSH ESTATES APARTMENTS",
    "display_name": "ROSEBUSH ESTATES APARTMENTS",
    "county": "ISABELLA",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005823",
    "resolved_pwsid": "MI0005823",
    "system_name": "ROSEBUSH ESTATES APARTMENTS",
    "display_name": "ROSEBUSH ESTATES APARTMENTS",
    "county": "ISABELLA",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 13,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0005823",
    "resolved_pwsid": "MI0005823",
    "system_name": "ROSEBUSH ESTATES APARTMENTS",
    "display_name": "ROSEBUSH ESTATES APARTMENTS",
    "county": "ISABELLA",
    "monitoring_end_date": "2026-06-30",
    "year": 2026,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005824",
    "resolved_pwsid": "MI0005824-b",
    "system_name": "ROSEBUSH MANOR SENIOR LIVING COMMUNITY",
    "display_name": "ROSEBUSH MANOR SENIOR LIVING COMMUNITY",
    "county": "ISABELLA",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005824",
    "resolved_pwsid": "MI0005824-b",
    "system_name": "ROSEBUSH MANOR SENIOR LIVING COMMUNITY",
    "display_name": "ROSEBUSH MANOR SENIOR LIVING COMMUNITY",
    "county": "ISABELLA",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005824",
    "resolved_pwsid": "MI0005824-a",
    "system_name": "ROSEBUSH MANOR",
    "display_name": "ROSEBUSH MANOR",
    "county": "ISABELLA",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005830",
    "resolved_pwsid": "MI0005830",
    "system_name": "ROYAL OAK, CITY OF",
    "display_name": "ROYAL OAK, CITY OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005830",
    "resolved_pwsid": "MI0005830",
    "system_name": "ROYAL OAK, CITY OF",
    "display_name": "ROYAL OAK, CITY OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2019-09-30",
    "year": 2019,
    "lead_90th_ppb": 23,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005830",
    "resolved_pwsid": "MI0005830",
    "system_name": "ROYAL OAK, CITY OF",
    "display_name": "ROYAL OAK, CITY OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 23,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005830",
    "resolved_pwsid": "MI0005830",
    "system_name": "ROYAL OAK, CITY OF",
    "display_name": "ROYAL OAK, CITY OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 15,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005830",
    "resolved_pwsid": "MI0005830",
    "system_name": "ROYAL OAK, CITY OF",
    "display_name": "ROYAL OAK, CITY OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 12,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005830",
    "resolved_pwsid": "MI0005830",
    "system_name": "ROYAL OAK, CITY OF",
    "display_name": "ROYAL OAK, CITY OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 10,
    "above_action_level": false,
    "lines_replaced": 225,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005830",
    "resolved_pwsid": "MI0005830",
    "system_name": "ROYAL OAK, CITY OF",
    "display_name": "ROYAL OAK, CITY OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": 192,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005830",
    "resolved_pwsid": "MI0005830",
    "system_name": "ROYAL OAK, CITY OF",
    "display_name": "ROYAL OAK, CITY OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 12,
    "above_action_level": false,
    "lines_replaced": 266,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005830",
    "resolved_pwsid": "MI0005830",
    "system_name": "ROYAL OAK, CITY OF",
    "display_name": "ROYAL OAK, CITY OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 267,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005830",
    "resolved_pwsid": "MI0005830",
    "system_name": "ROYAL OAK, CITY OF",
    "display_name": "ROYAL OAK, CITY OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": 221,
    "inventory_lead": 879,
    "inventory_gpcl": 723,
    "inventory_unknown": 766,
    "total_to_identify_or_replace": 2368,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0005840",
    "resolved_pwsid": "MI0005840",
    "system_name": "ROYAL OAK TOWNSHIP",
    "display_name": "ROYAL OAK TOWNSHIP",
    "county": "OAKLAND",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005840",
    "resolved_pwsid": "MI0005840",
    "system_name": "ROYAL OAK TOWNSHIP",
    "display_name": "ROYAL OAK TOWNSHIP",
    "county": "OAKLAND",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005840",
    "resolved_pwsid": "MI0005840",
    "system_name": "ROYAL OAK TOWNSHIP",
    "display_name": "ROYAL OAK TOWNSHIP",
    "county": "OAKLAND",
    "monitoring_end_date": "2020-09-30",
    "year": 2020,
    "lead_90th_ppb": 22,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005840",
    "resolved_pwsid": "MI0005840",
    "system_name": "ROYAL OAK TOWNSHIP",
    "display_name": "ROYAL OAK TOWNSHIP",
    "county": "OAKLAND",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 22,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005840",
    "resolved_pwsid": "MI0005840",
    "system_name": "ROYAL OAK TOWNSHIP",
    "display_name": "ROYAL OAK TOWNSHIP",
    "county": "OAKLAND",
    "monitoring_end_date": "2021-06-30",
    "year": 2021,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": 2,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005840",
    "resolved_pwsid": "MI0005840",
    "system_name": "ROYAL OAK TOWNSHIP",
    "display_name": "ROYAL OAK TOWNSHIP",
    "county": "OAKLAND",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005840",
    "resolved_pwsid": "MI0005840",
    "system_name": "ROYAL OAK TOWNSHIP",
    "display_name": "ROYAL OAK TOWNSHIP",
    "county": "OAKLAND",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005840",
    "resolved_pwsid": "MI0005840",
    "system_name": "ROYAL OAK TOWNSHIP",
    "display_name": "ROYAL OAK TOWNSHIP",
    "county": "OAKLAND",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 16,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005840",
    "resolved_pwsid": "MI0005840",
    "system_name": "ROYAL OAK TOWNSHIP",
    "display_name": "ROYAL OAK TOWNSHIP",
    "county": "OAKLAND",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 9,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005840",
    "resolved_pwsid": "MI0005840",
    "system_name": "ROYAL OAK TOWNSHIP",
    "display_name": "ROYAL OAK TOWNSHIP",
    "county": "OAKLAND",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 5,
    "inventory_lead": 7,
    "inventory_gpcl": 3,
    "inventory_unknown": 97,
    "total_to_identify_or_replace": 107,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0005841",
    "resolved_pwsid": "MI0005841",
    "system_name": "ROYAL VIEW RETIREMENT VILLAGE",
    "display_name": "ROYAL VIEW RETIREMENT VILLAGE",
    "county": "MECOSTA",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005841",
    "resolved_pwsid": "MI0005841",
    "system_name": "ROYAL VIEW RETIREMENT VILLAGE",
    "display_name": "ROYAL VIEW RETIREMENT VILLAGE",
    "county": "MECOSTA",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005841",
    "resolved_pwsid": "MI0005841",
    "system_name": "ROYAL VIEW RETIREMENT VILLAGE",
    "display_name": "ROYAL VIEW RETIREMENT VILLAGE",
    "county": "MECOSTA",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005844",
    "resolved_pwsid": "MI0005844",
    "system_name": "RUDYARD TOWNSHIP",
    "display_name": "RUDYARD TOWNSHIP",
    "county": "CHIPPEWA",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005844",
    "resolved_pwsid": "MI0005844",
    "system_name": "RUDYARD TOWNSHIP",
    "display_name": "RUDYARD TOWNSHIP",
    "county": "CHIPPEWA",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005844",
    "resolved_pwsid": "MI0005844",
    "system_name": "RUDYARD TOWNSHIP",
    "display_name": "RUDYARD TOWNSHIP",
    "county": "CHIPPEWA",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005849",
    "resolved_pwsid": "MI0005849",
    "system_name": "SADDLE RIDGE CONDO ASSOC.",
    "display_name": "SADDLE RIDGE CONDO ASSOC.",
    "county": "KENT",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005849",
    "resolved_pwsid": "MI0005849",
    "system_name": "SADDLE RIDGE CONDO ASSOC.",
    "display_name": "SADDLE RIDGE CONDO ASSOC.",
    "county": "KENT",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005849",
    "resolved_pwsid": "MI0005849",
    "system_name": "SADDLE RIDGE CONDO ASSOC.",
    "display_name": "SADDLE RIDGE CONDO ASSOC.",
    "county": "KENT",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005849",
    "resolved_pwsid": "MI0005849",
    "system_name": "SADDLE RIDGE CONDO ASSOC.",
    "display_name": "SADDLE RIDGE CONDO ASSOC.",
    "county": "KENT",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005849",
    "resolved_pwsid": "MI0005849",
    "system_name": "SADDLE RIDGE CONDO ASSOC.",
    "display_name": "SADDLE RIDGE CONDO ASSOC.",
    "county": "KENT",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005849",
    "resolved_pwsid": "MI0005849",
    "system_name": "SADDLE RIDGE CONDO ASSOC.",
    "display_name": "SADDLE RIDGE CONDO ASSOC.",
    "county": "KENT",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0005850",
    "resolved_pwsid": "MI0005850",
    "system_name": "SAGINAW, CITY OF",
    "display_name": "SAGINAW, CITY OF",
    "county": "SAGINAW",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 10,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005850",
    "resolved_pwsid": "MI0005850",
    "system_name": "SAGINAW, CITY OF",
    "display_name": "SAGINAW, CITY OF",
    "county": "SAGINAW",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 13,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005850",
    "resolved_pwsid": "MI0005850",
    "system_name": "SAGINAW, CITY OF",
    "display_name": "SAGINAW, CITY OF",
    "county": "SAGINAW",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 15,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005850",
    "resolved_pwsid": "MI0005850",
    "system_name": "SAGINAW, CITY OF",
    "display_name": "SAGINAW, CITY OF",
    "county": "SAGINAW",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": 713,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005850",
    "resolved_pwsid": "MI0005850",
    "system_name": "SAGINAW, CITY OF",
    "display_name": "SAGINAW, CITY OF",
    "county": "SAGINAW",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 11,
    "above_action_level": false,
    "lines_replaced": 1143,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005850",
    "resolved_pwsid": "MI0005850",
    "system_name": "SAGINAW, CITY OF",
    "display_name": "SAGINAW, CITY OF",
    "county": "SAGINAW",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": 931,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005850",
    "resolved_pwsid": "MI0005850",
    "system_name": "SAGINAW, CITY OF",
    "display_name": "SAGINAW, CITY OF",
    "county": "SAGINAW",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": 1133,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005850",
    "resolved_pwsid": "MI0005850",
    "system_name": "SAGINAW, CITY OF",
    "display_name": "SAGINAW, CITY OF",
    "county": "SAGINAW",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 9,
    "above_action_level": false,
    "lines_replaced": 1020,
    "inventory_lead": 6317,
    "inventory_gpcl": 0,
    "inventory_unknown": 736,
    "total_to_identify_or_replace": 7053,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0005860",
    "resolved_pwsid": "MI0005860",
    "system_name": "SAGINAW CHARTER TOWNSHIP",
    "display_name": "SAGINAW CHARTER TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005860",
    "resolved_pwsid": "MI0005860",
    "system_name": "SAGINAW CHARTER TOWNSHIP",
    "display_name": "SAGINAW CHARTER TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005860",
    "resolved_pwsid": "MI0005860",
    "system_name": "SAGINAW CHARTER TOWNSHIP",
    "display_name": "SAGINAW CHARTER TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005860",
    "resolved_pwsid": "MI0005860",
    "system_name": "SAGINAW CHARTER TOWNSHIP",
    "display_name": "SAGINAW CHARTER TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005860",
    "resolved_pwsid": "MI0005860",
    "system_name": "SAGINAW CHARTER TOWNSHIP",
    "display_name": "SAGINAW CHARTER TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005860",
    "resolved_pwsid": "MI0005860",
    "system_name": "SAGINAW CHARTER TOWNSHIP",
    "display_name": "SAGINAW CHARTER TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005860",
    "resolved_pwsid": "MI0005860",
    "system_name": "SAGINAW CHARTER TOWNSHIP",
    "display_name": "SAGINAW CHARTER TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005900",
    "resolved_pwsid": "MI0005900",
    "system_name": "SALINE",
    "display_name": "SALINE",
    "county": "WASHTENAW",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005900",
    "resolved_pwsid": "MI0005900",
    "system_name": "SALINE",
    "display_name": "SALINE",
    "county": "WASHTENAW",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005900",
    "resolved_pwsid": "MI0005900",
    "system_name": "SALINE",
    "display_name": "SALINE",
    "county": "WASHTENAW",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005900",
    "resolved_pwsid": "MI0005900",
    "system_name": "SALINE",
    "display_name": "SALINE",
    "county": "WASHTENAW",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005900",
    "resolved_pwsid": "MI0005900",
    "system_name": "SALINE",
    "display_name": "SALINE",
    "county": "WASHTENAW",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005900",
    "resolved_pwsid": "MI0005900",
    "system_name": "SALINE",
    "display_name": "SALINE",
    "county": "WASHTENAW",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005900",
    "resolved_pwsid": "MI0005900",
    "system_name": "SALINE",
    "display_name": "SALINE",
    "county": "WASHTENAW",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005900",
    "resolved_pwsid": "MI0005900",
    "system_name": "SALINE",
    "display_name": "SALINE",
    "county": "WASHTENAW",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 43,
    "inventory_gpcl": 0,
    "inventory_unknown": 1468,
    "total_to_identify_or_replace": 1511,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0005901",
    "resolved_pwsid": "MI0005901",
    "system_name": "SALINE VALLEY FARMS",
    "display_name": "SALINE VALLEY FARMS",
    "county": "WASHTENAW",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005901",
    "resolved_pwsid": "MI0005901",
    "system_name": "SALINE VALLEY FARMS",
    "display_name": "SALINE VALLEY FARMS",
    "county": "WASHTENAW",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005901",
    "resolved_pwsid": "MI0005901",
    "system_name": "SALINE VALLEY FARMS",
    "display_name": "SALINE VALLEY FARMS",
    "county": "WASHTENAW",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005901",
    "resolved_pwsid": "MI0005901",
    "system_name": "SALINE VALLEY FARMS",
    "display_name": "SALINE VALLEY FARMS",
    "county": "WASHTENAW",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005901",
    "resolved_pwsid": "MI0005901",
    "system_name": "SALINE VALLEY FARMS",
    "display_name": "SALINE VALLEY FARMS",
    "county": "WASHTENAW",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005903",
    "resolved_pwsid": "MI0005903",
    "system_name": "SAND BEACH TOWNSHIP",
    "display_name": "SAND BEACH TOWNSHIP",
    "county": "HURON",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005903",
    "resolved_pwsid": "MI0005903",
    "system_name": "SAND BEACH TOWNSHIP",
    "display_name": "SAND BEACH TOWNSHIP",
    "county": "HURON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005903",
    "resolved_pwsid": "MI0005903",
    "system_name": "SAND BEACH TOWNSHIP",
    "display_name": "SAND BEACH TOWNSHIP",
    "county": "HURON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005905",
    "resolved_pwsid": "MI0005905",
    "system_name": "SANDHILL MANOR",
    "display_name": "SANDHILL MANOR",
    "county": "ROSCOMMON",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005905",
    "resolved_pwsid": "MI0005905",
    "system_name": "SANDHILL MANOR",
    "display_name": "SANDHILL MANOR",
    "county": "ROSCOMMON",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005905",
    "resolved_pwsid": "MI0005905",
    "system_name": "SANDHILL MANOR",
    "display_name": "SANDHILL MANOR",
    "county": "ROSCOMMON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005907",
    "resolved_pwsid": "MI0005907",
    "system_name": "SAND LAKE",
    "display_name": "SAND LAKE",
    "county": "KENT",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005907",
    "resolved_pwsid": "MI0005907",
    "system_name": "SAND LAKE",
    "display_name": "SAND LAKE",
    "county": "KENT",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005907",
    "resolved_pwsid": "MI0005907",
    "system_name": "SAND LAKE",
    "display_name": "SAND LAKE",
    "county": "KENT",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005910",
    "resolved_pwsid": "MI0005910",
    "system_name": "SAN MARINO VILLAS SUBDIVISION",
    "display_name": "SAN MARINO VILLAS SUBDIVISION",
    "county": "OAKLAND",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005910",
    "resolved_pwsid": "MI0005910",
    "system_name": "SAN MARINO VILLAS SUBDIVISION",
    "display_name": "SAN MARINO VILLAS SUBDIVISION",
    "county": "OAKLAND",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 11,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005911",
    "resolved_pwsid": "MI0005911",
    "system_name": "SANDY PINES",
    "display_name": "SANDY PINES",
    "county": "ALLEGAN",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005911",
    "resolved_pwsid": "MI0005911",
    "system_name": "SANDY PINES",
    "display_name": "SANDY PINES",
    "county": "ALLEGAN",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005911",
    "resolved_pwsid": "MI0005911",
    "system_name": "SANDY PINES",
    "display_name": "SANDY PINES",
    "county": "ALLEGAN",
    "monitoring_end_date": "2022-09-30",
    "year": 2022,
    "lead_90th_ppb": 55,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005911",
    "resolved_pwsid": "MI0005911",
    "system_name": "SANDY PINES",
    "display_name": "SANDY PINES",
    "county": "ALLEGAN",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 55,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005911",
    "resolved_pwsid": "MI0005911",
    "system_name": "SANDY PINES",
    "display_name": "SANDY PINES",
    "county": "ALLEGAN",
    "monitoring_end_date": "2023-06-30",
    "year": 2023,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005911",
    "resolved_pwsid": "MI0005911",
    "system_name": "SANDY PINES",
    "display_name": "SANDY PINES",
    "county": "ALLEGAN",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005911",
    "resolved_pwsid": "MI0005911",
    "system_name": "SANDY PINES",
    "display_name": "SANDY PINES",
    "county": "ALLEGAN",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005920",
    "resolved_pwsid": "MI0005920",
    "system_name": "SANDUSKY, CITY OF",
    "display_name": "SANDUSKY, CITY OF",
    "county": "SANILAC",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005920",
    "resolved_pwsid": "MI0005920",
    "system_name": "SANDUSKY, CITY OF",
    "display_name": "SANDUSKY, CITY OF",
    "county": "SANILAC",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005920",
    "resolved_pwsid": "MI0005920",
    "system_name": "SANDUSKY, CITY OF",
    "display_name": "SANDUSKY, CITY OF",
    "county": "SANILAC",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 4,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005920",
    "resolved_pwsid": "MI0005920",
    "system_name": "SANDUSKY, CITY OF",
    "display_name": "SANDUSKY, CITY OF",
    "county": "SANILAC",
    "monitoring_end_date": "",
    "year": 2023,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 2,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005925",
    "resolved_pwsid": "MI0005925",
    "system_name": "SANILAC TOWNSHIP",
    "display_name": "SANILAC TOWNSHIP",
    "county": "SANILAC",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 9,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005925",
    "resolved_pwsid": "MI0005925",
    "system_name": "SANILAC TOWNSHIP",
    "display_name": "SANILAC TOWNSHIP",
    "county": "SANILAC",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005925",
    "resolved_pwsid": "MI0005925",
    "system_name": "SANILAC TOWNSHIP",
    "display_name": "SANILAC TOWNSHIP",
    "county": "SANILAC",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005930",
    "resolved_pwsid": "MI0005930",
    "system_name": "SARANAC",
    "display_name": "SARANAC",
    "county": "IONIA",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005930",
    "resolved_pwsid": "MI0005930",
    "system_name": "SARANAC",
    "display_name": "SARANAC",
    "county": "IONIA",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005930",
    "resolved_pwsid": "MI0005930",
    "system_name": "SARANAC",
    "display_name": "SARANAC",
    "county": "IONIA",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005950",
    "resolved_pwsid": "MI0005950",
    "system_name": "SAULT STE MARIE",
    "display_name": "SAULT STE MARIE",
    "county": "CHIPPEWA",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005950",
    "resolved_pwsid": "MI0005950",
    "system_name": "SAULT STE MARIE",
    "display_name": "SAULT STE MARIE",
    "county": "CHIPPEWA",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005950",
    "resolved_pwsid": "MI0005950",
    "system_name": "SAULT STE MARIE",
    "display_name": "SAULT STE MARIE",
    "county": "CHIPPEWA",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005950",
    "resolved_pwsid": "MI0005950",
    "system_name": "SAULT STE MARIE",
    "display_name": "SAULT STE MARIE",
    "county": "CHIPPEWA",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 3,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005950",
    "resolved_pwsid": "MI0005950",
    "system_name": "SAULT STE MARIE",
    "display_name": "SAULT STE MARIE",
    "county": "CHIPPEWA",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 2,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005950",
    "resolved_pwsid": "MI0005950",
    "system_name": "SAULT STE MARIE",
    "display_name": "SAULT STE MARIE",
    "county": "CHIPPEWA",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 7,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005950",
    "resolved_pwsid": "MI0005950",
    "system_name": "SAULT STE MARIE",
    "display_name": "SAULT STE MARIE",
    "county": "CHIPPEWA",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 14,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005950",
    "resolved_pwsid": "MI0005950",
    "system_name": "SAULT STE MARIE",
    "display_name": "SAULT STE MARIE",
    "county": "CHIPPEWA",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 10,
    "inventory_lead": 199,
    "inventory_gpcl": 186,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005970",
    "resolved_pwsid": "MI0005970",
    "system_name": "SCHOOLCRAFT",
    "display_name": "SCHOOLCRAFT",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005970",
    "resolved_pwsid": "MI0005970",
    "system_name": "SCHOOLCRAFT",
    "display_name": "SCHOOLCRAFT",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005970",
    "resolved_pwsid": "MI0005970",
    "system_name": "SCHOOLCRAFT",
    "display_name": "SCHOOLCRAFT",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 21,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005970",
    "resolved_pwsid": "MI0005970",
    "system_name": "SCHOOLCRAFT",
    "display_name": "SCHOOLCRAFT",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005970",
    "resolved_pwsid": "MI0005970",
    "system_name": "SCHOOLCRAFT",
    "display_name": "SCHOOLCRAFT",
    "county": "KALAMAZOO",
    "monitoring_end_date": "",
    "year": 2022,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 5,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005970",
    "resolved_pwsid": "MI0005970",
    "system_name": "SCHOOLCRAFT",
    "display_name": "SCHOOLCRAFT",
    "county": "KALAMAZOO",
    "monitoring_end_date": "",
    "year": 2023,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 3,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005970",
    "resolved_pwsid": "MI0005970",
    "system_name": "SCHOOLCRAFT",
    "display_name": "SCHOOLCRAFT",
    "county": "KALAMAZOO",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 37,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005977",
    "resolved_pwsid": "MI0005977",
    "system_name": "SCIO TOWNSHIP",
    "display_name": "SCIO TOWNSHIP",
    "county": "WASHTENAW",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005977",
    "resolved_pwsid": "MI0005977",
    "system_name": "SCIO TOWNSHIP",
    "display_name": "SCIO TOWNSHIP",
    "county": "WASHTENAW",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005977",
    "resolved_pwsid": "MI0005977",
    "system_name": "SCIO TOWNSHIP",
    "display_name": "SCIO TOWNSHIP",
    "county": "WASHTENAW",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005977",
    "resolved_pwsid": "MI0005977",
    "system_name": "SCIO TOWNSHIP",
    "display_name": "SCIO TOWNSHIP",
    "county": "WASHTENAW",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005977",
    "resolved_pwsid": "MI0005977",
    "system_name": "SCIO TOWNSHIP",
    "display_name": "SCIO TOWNSHIP",
    "county": "WASHTENAW",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005977",
    "resolved_pwsid": "MI0005977",
    "system_name": "SCIO TOWNSHIP",
    "display_name": "SCIO TOWNSHIP",
    "county": "WASHTENAW",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005977",
    "resolved_pwsid": "MI0005977",
    "system_name": "SCIO TOWNSHIP",
    "display_name": "SCIO TOWNSHIP",
    "county": "WASHTENAW",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005980",
    "resolved_pwsid": "MI0005980",
    "system_name": "SCOTTVILLE, CITY OF",
    "display_name": "SCOTTVILLE, CITY OF",
    "county": "MASON",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005980",
    "resolved_pwsid": "MI0005980",
    "system_name": "SCOTTVILLE, CITY OF",
    "display_name": "SCOTTVILLE, CITY OF",
    "county": "MASON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005980",
    "resolved_pwsid": "MI0005980",
    "system_name": "SCOTTVILLE, CITY OF",
    "display_name": "SCOTTVILLE, CITY OF",
    "county": "MASON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 10,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005980",
    "resolved_pwsid": "MI0005980",
    "system_name": "SCOTTVILLE, CITY OF",
    "display_name": "SCOTTVILLE, CITY OF",
    "county": "MASON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005980",
    "resolved_pwsid": "MI0005980",
    "system_name": "SCOTTVILLE, CITY OF",
    "display_name": "SCOTTVILLE, CITY OF",
    "county": "MASON",
    "monitoring_end_date": "",
    "year": 2022,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 8,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005980",
    "resolved_pwsid": "MI0005980",
    "system_name": "SCOTTVILLE, CITY OF",
    "display_name": "SCOTTVILLE, CITY OF",
    "county": "MASON",
    "monitoring_end_date": "",
    "year": 2024,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 3,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005980",
    "resolved_pwsid": "MI0005980",
    "system_name": "SCOTTVILLE, CITY OF",
    "display_name": "SCOTTVILLE, CITY OF",
    "county": "MASON",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 40,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005990",
    "resolved_pwsid": "MI0005990",
    "system_name": "SEBEWAING LIGHT & WATER",
    "display_name": "SEBEWAING LIGHT & WATER",
    "county": "HURON",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005990",
    "resolved_pwsid": "MI0005990",
    "system_name": "SEBEWAING LIGHT & WATER",
    "display_name": "SEBEWAING LIGHT & WATER",
    "county": "HURON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 9,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005990",
    "resolved_pwsid": "MI0005990",
    "system_name": "SEBEWAING LIGHT & WATER",
    "display_name": "SEBEWAING LIGHT & WATER",
    "county": "HURON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 14,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005991",
    "resolved_pwsid": "MI0005991",
    "system_name": "SENEY TOWNSHIP",
    "display_name": "SENEY TOWNSHIP",
    "county": "SCHOOLCRAFT",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005991",
    "resolved_pwsid": "MI0005991",
    "system_name": "SENEY TOWNSHIP",
    "display_name": "SENEY TOWNSHIP",
    "county": "SCHOOLCRAFT",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005991",
    "resolved_pwsid": "MI0005991",
    "system_name": "SENEY TOWNSHIP",
    "display_name": "SENEY TOWNSHIP",
    "county": "SCHOOLCRAFT",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005991",
    "resolved_pwsid": "MI0005991",
    "system_name": "SENEY TOWNSHIP",
    "display_name": "SENEY TOWNSHIP",
    "county": "SCHOOLCRAFT",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0005993",
    "resolved_pwsid": "MI0005993",
    "system_name": "BROOKDALE APARTMENTS",
    "display_name": "BROOKDALE APARTMENTS",
    "county": "OAKLAND",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005995",
    "resolved_pwsid": "MI0005995",
    "system_name": "SHANTY CREEK - WATARS ASSOCIATION",
    "display_name": "SHANTY CREEK - WATARS ASSOCIATION",
    "county": "ANTRIM",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005995",
    "resolved_pwsid": "MI0005995",
    "system_name": "SHANTY CREEK - WATARS ASSOCIATION",
    "display_name": "SHANTY CREEK - WATARS ASSOCIATION",
    "county": "ANTRIM",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005995",
    "resolved_pwsid": "MI0005995",
    "system_name": "SHANTY CREEK - WATARS ASSOCIATION",
    "display_name": "SHANTY CREEK - WATARS ASSOCIATION",
    "county": "ANTRIM",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005995",
    "resolved_pwsid": "MI0005995",
    "system_name": "SHANTY CREEK - WATARS ASSOCIATION",
    "display_name": "SHANTY CREEK - WATARS ASSOCIATION",
    "county": "ANTRIM",
    "monitoring_end_date": "2021-06-30",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005995",
    "resolved_pwsid": "MI0005995",
    "system_name": "SHANTY CREEK - WATARS ASSOCIATION",
    "display_name": "SHANTY CREEK - WATARS ASSOCIATION",
    "county": "ANTRIM",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005995",
    "resolved_pwsid": "MI0005995",
    "system_name": "SHANTY CREEK - WATARS ASSOCIATION",
    "display_name": "SHANTY CREEK - WATARS ASSOCIATION",
    "county": "ANTRIM",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005995",
    "resolved_pwsid": "MI0005995",
    "system_name": "SHANTY CREEK - WATARS ASSOCIATION",
    "display_name": "SHANTY CREEK - WATARS ASSOCIATION",
    "county": "ANTRIM",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005995",
    "resolved_pwsid": "MI0005995",
    "system_name": "SHANTY CREEK - WATARS ASSOCIATION",
    "display_name": "SHANTY CREEK - WATARS ASSOCIATION",
    "county": "ANTRIM",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0005995",
    "resolved_pwsid": "MI0005995",
    "system_name": "SHANTY CREEK - WATARS ASSOCIATION",
    "display_name": "SHANTY CREEK - WATARS ASSOCIATION",
    "county": "ANTRIM",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0005995",
    "resolved_pwsid": "MI0005995",
    "system_name": "SHANTY CREEK - WATARS ASSOCIATION",
    "display_name": "SHANTY CREEK - WATARS ASSOCIATION",
    "county": "ANTRIM",
    "monitoring_end_date": "2026-06-30",
    "year": 2026,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006000",
    "resolved_pwsid": "MI0006000",
    "system_name": "SHELBY",
    "display_name": "SHELBY",
    "county": "OCEANA",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006000",
    "resolved_pwsid": "MI0006000",
    "system_name": "SHELBY",
    "display_name": "SHELBY",
    "county": "OCEANA",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006000",
    "resolved_pwsid": "MI0006000",
    "system_name": "SHELBY",
    "display_name": "SHELBY",
    "county": "OCEANA",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006000",
    "resolved_pwsid": "MI0006000",
    "system_name": "SHELBY",
    "display_name": "SHELBY",
    "county": "OCEANA",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006000",
    "resolved_pwsid": "MI0006000",
    "system_name": "SHELBY",
    "display_name": "SHELBY",
    "county": "OCEANA",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": 2,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006000",
    "resolved_pwsid": "MI0006000",
    "system_name": "SHELBY",
    "display_name": "SHELBY",
    "county": "OCEANA",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": 2,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006000",
    "resolved_pwsid": "MI0006000",
    "system_name": "SHELBY",
    "display_name": "SHELBY",
    "county": "OCEANA",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 235,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006000",
    "resolved_pwsid": "MI0006000",
    "system_name": "SHELBY",
    "display_name": "SHELBY",
    "county": "OCEANA",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006000",
    "resolved_pwsid": "MI0006000",
    "system_name": "SHELBY",
    "display_name": "SHELBY",
    "county": "OCEANA",
    "monitoring_end_date": "",
    "year": 2024,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 76,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006010",
    "resolved_pwsid": "MI0006010",
    "system_name": "SHELBY TOWNSHIP",
    "display_name": "SHELBY TOWNSHIP",
    "county": "MACOMB",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006010",
    "resolved_pwsid": "MI0006010",
    "system_name": "SHELBY TOWNSHIP",
    "display_name": "SHELBY TOWNSHIP",
    "county": "MACOMB",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006010",
    "resolved_pwsid": "MI0006010",
    "system_name": "SHELBY TOWNSHIP",
    "display_name": "SHELBY TOWNSHIP",
    "county": "MACOMB",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006010",
    "resolved_pwsid": "MI0006010",
    "system_name": "SHELBY TOWNSHIP",
    "display_name": "SHELBY TOWNSHIP",
    "county": "MACOMB",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006010",
    "resolved_pwsid": "MI0006010",
    "system_name": "SHELBY TOWNSHIP",
    "display_name": "SHELBY TOWNSHIP",
    "county": "MACOMB",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006010",
    "resolved_pwsid": "MI0006010",
    "system_name": "SHELBY TOWNSHIP",
    "display_name": "SHELBY TOWNSHIP",
    "county": "MACOMB",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006010",
    "resolved_pwsid": "MI0006010",
    "system_name": "SHELBY TOWNSHIP",
    "display_name": "SHELBY TOWNSHIP",
    "county": "MACOMB",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006010",
    "resolved_pwsid": "MI0006010",
    "system_name": "SHELBY TOWNSHIP",
    "display_name": "SHELBY TOWNSHIP",
    "county": "MACOMB",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0006025",
    "resolved_pwsid": "MI0006025",
    "system_name": "SHELDON DUNES",
    "display_name": "SHELDON DUNES",
    "county": "OTTAWA",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006025",
    "resolved_pwsid": "MI0006025",
    "system_name": "SHELDON DUNES",
    "display_name": "SHELDON DUNES",
    "county": "OTTAWA",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006025",
    "resolved_pwsid": "MI0006025",
    "system_name": "SHELDON DUNES",
    "display_name": "SHELDON DUNES",
    "county": "OTTAWA",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006025",
    "resolved_pwsid": "MI0006025",
    "system_name": "SHELDON DUNES",
    "display_name": "SHELDON DUNES",
    "county": "OTTAWA",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006026",
    "resolved_pwsid": "MI0006026",
    "system_name": "PORT SHELDON TOWNSHIP",
    "display_name": "PORT SHELDON TOWNSHIP",
    "county": "OTTAWA",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006026",
    "resolved_pwsid": "MI0006026",
    "system_name": "PORT SHELDON TOWNSHIP",
    "display_name": "PORT SHELDON TOWNSHIP",
    "county": "OTTAWA",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006026",
    "resolved_pwsid": "MI0006026",
    "system_name": "PORT SHELDON TOWNSHIP",
    "display_name": "PORT SHELDON TOWNSHIP",
    "county": "OTTAWA",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006026",
    "resolved_pwsid": "MI0006026",
    "system_name": "PORT SHELDON TOWNSHIP",
    "display_name": "PORT SHELDON TOWNSHIP",
    "county": "OTTAWA",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006026",
    "resolved_pwsid": "MI0006026",
    "system_name": "PORT SHELDON TOWNSHIP",
    "display_name": "PORT SHELDON TOWNSHIP",
    "county": "OTTAWA",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006026",
    "resolved_pwsid": "MI0006026",
    "system_name": "PORT SHELDON TOWNSHIP",
    "display_name": "PORT SHELDON TOWNSHIP",
    "county": "OTTAWA",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006026",
    "resolved_pwsid": "MI0006026",
    "system_name": "PORT SHELDON TOWNSHIP",
    "display_name": "PORT SHELDON TOWNSHIP",
    "county": "OTTAWA",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006030",
    "resolved_pwsid": "MI0006030",
    "system_name": "SHEPHERD, VILLAGE OF",
    "display_name": "SHEPHERD, VILLAGE OF",
    "county": "ISABELLA",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006030",
    "resolved_pwsid": "MI0006030",
    "system_name": "SHEPHERD, VILLAGE OF",
    "display_name": "SHEPHERD, VILLAGE OF",
    "county": "ISABELLA",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 4,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006030",
    "resolved_pwsid": "MI0006030",
    "system_name": "SHEPHERD, VILLAGE OF",
    "display_name": "SHEPHERD, VILLAGE OF",
    "county": "ISABELLA",
    "monitoring_end_date": "2022-06-30",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006030",
    "resolved_pwsid": "MI0006030",
    "system_name": "SHEPHERD, VILLAGE OF",
    "display_name": "SHEPHERD, VILLAGE OF",
    "county": "ISABELLA",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006030",
    "resolved_pwsid": "MI0006030",
    "system_name": "SHEPHERD, VILLAGE OF",
    "display_name": "SHEPHERD, VILLAGE OF",
    "county": "ISABELLA",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 118,
    "inventory_lead": 0,
    "inventory_gpcl": 32,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 32,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006030",
    "resolved_pwsid": "MI0006030",
    "system_name": "SHEPHERD, VILLAGE OF",
    "display_name": "SHEPHERD, VILLAGE OF",
    "county": "ISABELLA",
    "monitoring_end_date": "",
    "year": 2023,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 3,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006030",
    "resolved_pwsid": "MI0006030",
    "system_name": "SHEPHERD, VILLAGE OF",
    "display_name": "SHEPHERD, VILLAGE OF",
    "county": "ISABELLA",
    "monitoring_end_date": "",
    "year": 2024,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 264,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006040",
    "resolved_pwsid": "MI0006040",
    "system_name": "SHERIDAN",
    "display_name": "SHERIDAN",
    "county": "MONTCALM",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006040",
    "resolved_pwsid": "MI0006040",
    "system_name": "SHERIDAN",
    "display_name": "SHERIDAN",
    "county": "MONTCALM",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006040",
    "resolved_pwsid": "MI0006040",
    "system_name": "SHERIDAN",
    "display_name": "SHERIDAN",
    "county": "MONTCALM",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 11,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006040",
    "resolved_pwsid": "MI0006040",
    "system_name": "SHERIDAN",
    "display_name": "SHERIDAN",
    "county": "MONTCALM",
    "monitoring_end_date": "",
    "year": 2024,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006040",
    "resolved_pwsid": "MI0006040",
    "system_name": "SHERIDAN",
    "display_name": "SHERIDAN",
    "county": "MONTCALM",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 3,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006042",
    "resolved_pwsid": "MI0006042",
    "system_name": "SHERWOOD SHORES CONDOMINIUMS",
    "display_name": "SHERWOOD SHORES CONDOMINIUMS",
    "county": "BERRIEN",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006042",
    "resolved_pwsid": "MI0006042",
    "system_name": "SHERWOOD SHORES CONDOMINIUMS",
    "display_name": "SHERWOOD SHORES CONDOMINIUMS",
    "county": "BERRIEN",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 99,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006042",
    "resolved_pwsid": "MI0006042",
    "system_name": "SHERWOOD SHORES CONDOMINIUMS",
    "display_name": "SHERWOOD SHORES CONDOMINIUMS",
    "county": "BERRIEN",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006042",
    "resolved_pwsid": "MI0006042",
    "system_name": "SHERWOOD SHORES CONDOMINIUMS",
    "display_name": "SHERWOOD SHORES CONDOMINIUMS",
    "county": "BERRIEN",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006042",
    "resolved_pwsid": "MI0006042",
    "system_name": "SHERWOOD SHORES CONDOMINIUMS",
    "display_name": "SHERWOOD SHORES CONDOMINIUMS",
    "county": "BERRIEN",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006042",
    "resolved_pwsid": "MI0006042",
    "system_name": "SHERWOOD SHORES CONDOMINIUMS",
    "display_name": "SHERWOOD SHORES CONDOMINIUMS",
    "county": "BERRIEN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006042",
    "resolved_pwsid": "MI0006042",
    "system_name": "SHERWOOD SHORES CONDOMINIUMS",
    "display_name": "SHERWOOD SHORES CONDOMINIUMS",
    "county": "BERRIEN",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006042",
    "resolved_pwsid": "MI0006042",
    "system_name": "SHERWOOD SHORES CONDOMINIUMS",
    "display_name": "SHERWOOD SHORES CONDOMINIUMS",
    "county": "BERRIEN",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006042",
    "resolved_pwsid": "MI0006042",
    "system_name": "SHERWOOD SHORES CONDOMINIUMS",
    "display_name": "SHERWOOD SHORES CONDOMINIUMS",
    "county": "BERRIEN",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006070",
    "resolved_pwsid": "MI0006070",
    "system_name": "SHOREWOOD HILLS SUBDIVISION",
    "display_name": "SHOREWOOD HILLS SUBDIVISION",
    "county": "OAKLAND",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006070",
    "resolved_pwsid": "MI0006070",
    "system_name": "SHOREWOOD HILLS SUBDIVISION",
    "display_name": "SHOREWOOD HILLS SUBDIVISION",
    "county": "OAKLAND",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006070",
    "resolved_pwsid": "MI0006070",
    "system_name": "SHOREWOOD HILLS SUBDIVISION",
    "display_name": "SHOREWOOD HILLS SUBDIVISION",
    "county": "OAKLAND",
    "monitoring_end_date": "2024-09-30",
    "year": 2024,
    "lead_90th_ppb": 18,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006070",
    "resolved_pwsid": "MI0006070",
    "system_name": "SHOREWOOD HILLS SUBDIVISION",
    "display_name": "SHOREWOOD HILLS SUBDIVISION",
    "county": "OAKLAND",
    "monitoring_end_date": "2025-06-30",
    "year": 2025,
    "lead_90th_ppb": 16,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 13,
    "total_to_identify_or_replace": 13,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0006070",
    "resolved_pwsid": "MI0006070",
    "system_name": "SHOREWOOD HILLS SUBDIVISION",
    "display_name": "SHOREWOOD HILLS SUBDIVISION",
    "county": "OAKLAND",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 13,
    "total_to_identify_or_replace": 13,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0006070",
    "resolved_pwsid": "MI0006070",
    "system_name": "SHOREWOOD HILLS SUBDIVISION",
    "display_name": "SHOREWOOD HILLS SUBDIVISION",
    "county": "OAKLAND",
    "monitoring_end_date": "2026-06-30",
    "year": 2026,
    "lead_90th_ppb": 10,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006071",
    "resolved_pwsid": "MI0006071",
    "system_name": "SILVER LAKE WATER AUTHORITY, INC.",
    "display_name": "SILVER LAKE WATER AUTHORITY, INC.",
    "county": "KENT",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006071",
    "resolved_pwsid": "MI0006071",
    "system_name": "SILVER LAKE WATER AUTHORITY, INC.",
    "display_name": "SILVER LAKE WATER AUTHORITY, INC.",
    "county": "KENT",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006071",
    "resolved_pwsid": "MI0006071",
    "system_name": "SILVER LAKE WATER AUTHORITY, INC.",
    "display_name": "SILVER LAKE WATER AUTHORITY, INC.",
    "county": "KENT",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006071",
    "resolved_pwsid": "MI0006071",
    "system_name": "SILVER LAKE WATER AUTHORITY, INC.",
    "display_name": "SILVER LAKE WATER AUTHORITY, INC.",
    "county": "KENT",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0006072",
    "resolved_pwsid": "MI0006072",
    "system_name": "VICINIA GARDENS",
    "display_name": "VICINIA GARDENS",
    "county": "GENESEE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006072",
    "resolved_pwsid": "MI0006072",
    "system_name": "VICINIA GARDENS",
    "display_name": "VICINIA GARDENS",
    "county": "GENESEE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006072",
    "resolved_pwsid": "MI0006072",
    "system_name": "VICINIA GARDENS",
    "display_name": "VICINIA GARDENS",
    "county": "GENESEE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006073",
    "resolved_pwsid": "MI0006073",
    "system_name": "SIMS-WHITNEY UTILITIES AUTH.",
    "display_name": "SIMS-WHITNEY UTILITIES AUTH.",
    "county": "ARENAC",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 20,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006073",
    "resolved_pwsid": "MI0006073",
    "system_name": "SIMS-WHITNEY UTILITIES AUTH.",
    "display_name": "SIMS-WHITNEY UTILITIES AUTH.",
    "county": "ARENAC",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006073",
    "resolved_pwsid": "MI0006073",
    "system_name": "SIMS-WHITNEY UTILITIES AUTH.",
    "display_name": "SIMS-WHITNEY UTILITIES AUTH.",
    "county": "ARENAC",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006073",
    "resolved_pwsid": "MI0006073",
    "system_name": "SIMS-WHITNEY UTILITIES AUTH.",
    "display_name": "SIMS-WHITNEY UTILITIES AUTH.",
    "county": "ARENAC",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006073",
    "resolved_pwsid": "MI0006073",
    "system_name": "SIMS-WHITNEY UTILITIES AUTH.",
    "display_name": "SIMS-WHITNEY UTILITIES AUTH.",
    "county": "ARENAC",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006073",
    "resolved_pwsid": "MI0006073",
    "system_name": "SIMS-WHITNEY UTILITIES AUTH.",
    "display_name": "SIMS-WHITNEY UTILITIES AUTH.",
    "county": "ARENAC",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006073",
    "resolved_pwsid": "MI0006073",
    "system_name": "SIMS-WHITNEY UTILITIES AUTH.",
    "display_name": "SIMS-WHITNEY UTILITIES AUTH.",
    "county": "ARENAC",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006073",
    "resolved_pwsid": "MI0006073",
    "system_name": "SIMS-WHITNEY UTILITIES AUTH.",
    "display_name": "SIMS-WHITNEY UTILITIES AUTH.",
    "county": "ARENAC",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0006074",
    "resolved_pwsid": "MI0006074",
    "system_name": "SISTERS OF MARY, MOTHER OF EUCHARIST",
    "display_name": "SISTERS OF MARY, MOTHER OF EUCHARIST",
    "county": "WASHTENAW",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006074",
    "resolved_pwsid": "MI0006074",
    "system_name": "SISTERS OF MARY, MOTHER OF EUCHARIST",
    "display_name": "SISTERS OF MARY, MOTHER OF EUCHARIST",
    "county": "WASHTENAW",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006074",
    "resolved_pwsid": "MI0006074",
    "system_name": "SISTERS OF MARY, MOTHER OF EUCHARIST",
    "display_name": "SISTERS OF MARY, MOTHER OF EUCHARIST",
    "county": "WASHTENAW",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006074",
    "resolved_pwsid": "MI0006074",
    "system_name": "SISTERS OF MARY, MOTHER OF EUCHARIST",
    "display_name": "SISTERS OF MARY, MOTHER OF EUCHARIST",
    "county": "WASHTENAW",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0006075",
    "resolved_pwsid": "MI0006075",
    "system_name": "SKANDIA-WEST BRANCH WATER DEPT",
    "display_name": "SKANDIA-WEST BRANCH WATER DEPT",
    "county": "MARQUETTE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006075",
    "resolved_pwsid": "MI0006075",
    "system_name": "SKANDIA-WEST BRANCH WATER DEPT",
    "display_name": "SKANDIA-WEST BRANCH WATER DEPT",
    "county": "MARQUETTE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006075",
    "resolved_pwsid": "MI0006075",
    "system_name": "SKANDIA-WEST BRANCH WATER DEPT",
    "display_name": "SKANDIA-WEST BRANCH WATER DEPT",
    "county": "MARQUETTE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006077",
    "resolved_pwsid": "MI0006077",
    "system_name": "BAVARIAN SOFTWATER VILLAGE",
    "display_name": "BAVARIAN SOFTWATER VILLAGE",
    "county": "OAKLAND",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006077",
    "resolved_pwsid": "MI0006077",
    "system_name": "BAVARIAN SOFTWATER VILLAGE",
    "display_name": "BAVARIAN SOFTWATER VILLAGE",
    "county": "OAKLAND",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006077",
    "resolved_pwsid": "MI0006077",
    "system_name": "BAVARIAN SOFTWATER VILLAGE",
    "display_name": "BAVARIAN SOFTWATER VILLAGE",
    "county": "OAKLAND",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006077",
    "resolved_pwsid": "MI0006077",
    "system_name": "BAVARIAN SOFTWATER VILLAGE",
    "display_name": "BAVARIAN SOFTWATER VILLAGE",
    "county": "OAKLAND",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006077",
    "resolved_pwsid": "MI0006077",
    "system_name": "BAVARIAN SOFTWATER VILLAGE",
    "display_name": "BAVARIAN SOFTWATER VILLAGE",
    "county": "OAKLAND",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006077",
    "resolved_pwsid": "MI0006077",
    "system_name": "BAVARIAN SOFTWATER VILLAGE",
    "display_name": "BAVARIAN SOFTWATER VILLAGE",
    "county": "OAKLAND",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006077",
    "resolved_pwsid": "MI0006077",
    "system_name": "BAVARIAN SOFTWATER VILLAGE",
    "display_name": "BAVARIAN SOFTWATER VILLAGE",
    "county": "OAKLAND",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006077",
    "resolved_pwsid": "MI0006077",
    "system_name": "BAVARIAN SOFTWATER VILLAGE",
    "display_name": "BAVARIAN SOFTWATER VILLAGE",
    "county": "OAKLAND",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0006079",
    "resolved_pwsid": "MI0006079",
    "system_name": "SODUS TOWNSHIP",
    "display_name": "SODUS TOWNSHIP",
    "county": "BERRIEN",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006079",
    "resolved_pwsid": "MI0006079",
    "system_name": "SODUS TOWNSHIP",
    "display_name": "SODUS TOWNSHIP",
    "county": "BERRIEN",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006079",
    "resolved_pwsid": "MI0006079",
    "system_name": "SODUS TOWNSHIP",
    "display_name": "SODUS TOWNSHIP",
    "county": "BERRIEN",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006079",
    "resolved_pwsid": "MI0006079",
    "system_name": "SODUS TOWNSHIP",
    "display_name": "SODUS TOWNSHIP",
    "county": "BERRIEN",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0006080",
    "resolved_pwsid": "MI0006080",
    "system_name": "SOUTH BLOOMFIELD HIGHLANDS",
    "display_name": "SOUTH BLOOMFIELD HIGHLANDS",
    "county": "OAKLAND",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006080",
    "resolved_pwsid": "MI0006080",
    "system_name": "SOUTH BLOOMFIELD HIGHLANDS",
    "display_name": "SOUTH BLOOMFIELD HIGHLANDS",
    "county": "OAKLAND",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 13,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006080",
    "resolved_pwsid": "MI0006080",
    "system_name": "SOUTH BLOOMFIELD HIGHLANDS",
    "display_name": "SOUTH BLOOMFIELD HIGHLANDS",
    "county": "OAKLAND",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 13,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006081",
    "resolved_pwsid": "MI0006081",
    "system_name": "SOMMERSET WATER WORKS, INC.",
    "display_name": "SOMMERSET WATER WORKS, INC.",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006081",
    "resolved_pwsid": "MI0006081",
    "system_name": "SOMMERSET WATER WORKS, INC.",
    "display_name": "SOMMERSET WATER WORKS, INC.",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006081",
    "resolved_pwsid": "MI0006081",
    "system_name": "SOMMERSET WATER WORKS, INC.",
    "display_name": "SOMMERSET WATER WORKS, INC.",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006081",
    "resolved_pwsid": "MI0006081",
    "system_name": "SOMMERSET WATER WORKS, INC.",
    "display_name": "SOMMERSET WATER WORKS, INC.",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006090",
    "resolved_pwsid": "MI0006090",
    "system_name": "STAMBAUGH TOWNSHIP-WEST BRULE",
    "display_name": "STAMBAUGH TOWNSHIP-WEST BRULE",
    "county": "IRON",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006090",
    "resolved_pwsid": "MI0006090",
    "system_name": "STAMBAUGH TOWNSHIP-WEST BRULE",
    "display_name": "STAMBAUGH TOWNSHIP-WEST BRULE",
    "county": "IRON",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006090",
    "resolved_pwsid": "MI0006090",
    "system_name": "STAMBAUGH TOWNSHIP-WEST BRULE",
    "display_name": "STAMBAUGH TOWNSHIP-WEST BRULE",
    "county": "IRON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006090",
    "resolved_pwsid": "MI0006090",
    "system_name": "STAMBAUGH TOWNSHIP-WEST BRULE",
    "display_name": "STAMBAUGH TOWNSHIP-WEST BRULE",
    "county": "IRON",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 260,
    "total_to_identify_or_replace": 260,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0006100",
    "resolved_pwsid": "MI0006100",
    "system_name": "SOUTH HAVEN",
    "display_name": "SOUTH HAVEN",
    "county": "VAN BUREN",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006101",
    "resolved_pwsid": "MI0006101",
    "system_name": "SOUTH HAVEN AREA WATER & SEWER AUTHORITY",
    "display_name": "SOUTH HAVEN AREA WATER & SEWER AUTHORITY",
    "county": "VAN BUREN",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006101",
    "resolved_pwsid": "MI0006101",
    "system_name": "SOUTH HAVEN AREA WATER & SEWER AUTHORITY",
    "display_name": "SOUTH HAVEN AREA WATER & SEWER AUTHORITY",
    "county": "VAN BUREN",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 101,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006101",
    "resolved_pwsid": "MI0006101",
    "system_name": "SOUTH HAVEN AREA WATER & SEWER AUTHORITY",
    "display_name": "SOUTH HAVEN AREA WATER & SEWER AUTHORITY",
    "county": "VAN BUREN",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 677,
    "inventory_lead": 31,
    "inventory_gpcl": 203,
    "inventory_unknown": 1860,
    "total_to_identify_or_replace": 2094,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0006101",
    "resolved_pwsid": "MI0006101",
    "system_name": "SOUTH HAVEN AREA WATER & SEWER AUTHORITY",
    "display_name": "SOUTH HAVEN AREA WATER & SEWER AUTHORITY",
    "county": "VAN BUREN",
    "monitoring_end_date": "",
    "year": 2021,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 59,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006101",
    "resolved_pwsid": "MI0006101",
    "system_name": "SOUTH HAVEN AREA WATER & SEWER AUTHORITY",
    "display_name": "SOUTH HAVEN AREA WATER & SEWER AUTHORITY",
    "county": "VAN BUREN",
    "monitoring_end_date": "",
    "year": 2023,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 45,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006101",
    "resolved_pwsid": "MI0006101",
    "system_name": "SOUTH HAVEN AREA WATER & SEWER AUTHORITY",
    "display_name": "SOUTH HAVEN AREA WATER & SEWER AUTHORITY",
    "county": "VAN BUREN",
    "monitoring_end_date": "",
    "year": 2024,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 69,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006110",
    "resolved_pwsid": "MI0006110",
    "system_name": "SOUTH LYON, CITY OF",
    "display_name": "SOUTH LYON, CITY OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006110",
    "resolved_pwsid": "MI0006110",
    "system_name": "SOUTH LYON, CITY OF",
    "display_name": "SOUTH LYON, CITY OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006110",
    "resolved_pwsid": "MI0006110",
    "system_name": "SOUTH LYON, CITY OF",
    "display_name": "SOUTH LYON, CITY OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006110",
    "resolved_pwsid": "MI0006110",
    "system_name": "SOUTH LYON, CITY OF",
    "display_name": "SOUTH LYON, CITY OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006110",
    "resolved_pwsid": "MI0006110",
    "system_name": "SOUTH LYON, CITY OF",
    "display_name": "SOUTH LYON, CITY OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006110",
    "resolved_pwsid": "MI0006110",
    "system_name": "SOUTH LYON, CITY OF",
    "display_name": "SOUTH LYON, CITY OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006110",
    "resolved_pwsid": "MI0006110",
    "system_name": "SOUTH LYON, CITY OF",
    "display_name": "SOUTH LYON, CITY OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006110",
    "resolved_pwsid": "MI0006110",
    "system_name": "SOUTH LYON, CITY OF",
    "display_name": "SOUTH LYON, CITY OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": 2,
    "inventory_gpcl": 38,
    "inventory_unknown": 457,
    "total_to_identify_or_replace": 497,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0006115",
    "resolved_pwsid": "MI0006115",
    "system_name": "SOUTH POINTE I APARTMENTS",
    "display_name": "SOUTH POINTE I APARTMENTS",
    "county": "CHEBOYGAN",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006115",
    "resolved_pwsid": "MI0006115",
    "system_name": "SOUTH POINTE I APARTMENTS",
    "display_name": "SOUTH POINTE I APARTMENTS",
    "county": "CHEBOYGAN",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006115",
    "resolved_pwsid": "MI0006115",
    "system_name": "SOUTH POINTE I APARTMENTS",
    "display_name": "SOUTH POINTE I APARTMENTS",
    "county": "CHEBOYGAN",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006115",
    "resolved_pwsid": "MI0006115",
    "system_name": "SOUTH POINTE I APARTMENTS",
    "display_name": "SOUTH POINTE I APARTMENTS",
    "county": "CHEBOYGAN",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0006116",
    "resolved_pwsid": "MI0006116",
    "system_name": "SOUTH POINTE II APARTMENTS",
    "display_name": "SOUTH POINTE II APARTMENTS",
    "county": "CHEBOYGAN",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006116",
    "resolved_pwsid": "MI0006116",
    "system_name": "SOUTH POINTE II APARTMENTS",
    "display_name": "SOUTH POINTE II APARTMENTS",
    "county": "CHEBOYGAN",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006116",
    "resolved_pwsid": "MI0006116",
    "system_name": "SOUTH POINTE II APARTMENTS",
    "display_name": "SOUTH POINTE II APARTMENTS",
    "county": "CHEBOYGAN",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006116",
    "resolved_pwsid": "MI0006116",
    "system_name": "SOUTH POINTE II APARTMENTS",
    "display_name": "SOUTH POINTE II APARTMENTS",
    "county": "CHEBOYGAN",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0006117",
    "resolved_pwsid": "MI0006117",
    "system_name": "SOUTH POINTE III APARTMENTS",
    "display_name": "SOUTH POINTE III APARTMENTS",
    "county": "CHEBOYGAN",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006117",
    "resolved_pwsid": "MI0006117",
    "system_name": "SOUTH POINTE III APARTMENTS",
    "display_name": "SOUTH POINTE III APARTMENTS",
    "county": "CHEBOYGAN",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006117",
    "resolved_pwsid": "MI0006117",
    "system_name": "SOUTH POINTE III APARTMENTS",
    "display_name": "SOUTH POINTE III APARTMENTS",
    "county": "CHEBOYGAN",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006117",
    "resolved_pwsid": "MI0006117",
    "system_name": "SOUTH POINTE III APARTMENTS",
    "display_name": "SOUTH POINTE III APARTMENTS",
    "county": "CHEBOYGAN",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0006120",
    "resolved_pwsid": "MI0006120",
    "system_name": "SOUTH RANGE",
    "display_name": "SOUTH RANGE",
    "county": "HOUGHTON",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006120",
    "resolved_pwsid": "MI0006120",
    "system_name": "SOUTH RANGE",
    "display_name": "SOUTH RANGE",
    "county": "HOUGHTON",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006120",
    "resolved_pwsid": "MI0006120",
    "system_name": "SOUTH RANGE",
    "display_name": "SOUTH RANGE",
    "county": "HOUGHTON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006120",
    "resolved_pwsid": "MI0006120",
    "system_name": "SOUTH RANGE",
    "display_name": "SOUTH RANGE",
    "county": "HOUGHTON",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006120",
    "resolved_pwsid": "MI0006120",
    "system_name": "SOUTH RANGE",
    "display_name": "SOUTH RANGE",
    "county": "HOUGHTON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006130",
    "resolved_pwsid": "MI0006130",
    "system_name": "SOUTH ROCKWOOD",
    "display_name": "SOUTH ROCKWOOD",
    "county": "MONROE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006130",
    "resolved_pwsid": "MI0006130",
    "system_name": "SOUTH ROCKWOOD",
    "display_name": "SOUTH ROCKWOOD",
    "county": "MONROE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006130",
    "resolved_pwsid": "MI0006130",
    "system_name": "SOUTH ROCKWOOD",
    "display_name": "SOUTH ROCKWOOD",
    "county": "MONROE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006130",
    "resolved_pwsid": "MI0006130",
    "system_name": "SOUTH ROCKWOOD",
    "display_name": "SOUTH ROCKWOOD",
    "county": "MONROE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006130",
    "resolved_pwsid": "MI0006130",
    "system_name": "SOUTH ROCKWOOD",
    "display_name": "SOUTH ROCKWOOD",
    "county": "MONROE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006130",
    "resolved_pwsid": "MI0006130",
    "system_name": "SOUTH ROCKWOOD",
    "display_name": "SOUTH ROCKWOOD",
    "county": "MONROE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006130",
    "resolved_pwsid": "MI0006130",
    "system_name": "SOUTH ROCKWOOD",
    "display_name": "SOUTH ROCKWOOD",
    "county": "MONROE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006130",
    "resolved_pwsid": "MI0006130",
    "system_name": "SOUTH ROCKWOOD",
    "display_name": "SOUTH ROCKWOOD",
    "county": "MONROE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0006160",
    "resolved_pwsid": "MI0006160",
    "system_name": "SOUTHFIELD",
    "display_name": "SOUTHFIELD",
    "county": "OAKLAND",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006160",
    "resolved_pwsid": "MI0006160",
    "system_name": "SOUTHFIELD",
    "display_name": "SOUTHFIELD",
    "county": "OAKLAND",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006160",
    "resolved_pwsid": "MI0006160",
    "system_name": "SOUTHFIELD",
    "display_name": "SOUTHFIELD",
    "county": "OAKLAND",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006160",
    "resolved_pwsid": "MI0006160",
    "system_name": "SOUTHFIELD",
    "display_name": "SOUTHFIELD",
    "county": "OAKLAND",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006160",
    "resolved_pwsid": "MI0006160",
    "system_name": "SOUTHFIELD",
    "display_name": "SOUTHFIELD",
    "county": "OAKLAND",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006160",
    "resolved_pwsid": "MI0006160",
    "system_name": "SOUTHFIELD",
    "display_name": "SOUTHFIELD",
    "county": "OAKLAND",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006160",
    "resolved_pwsid": "MI0006160",
    "system_name": "SOUTHFIELD",
    "display_name": "SOUTHFIELD",
    "county": "OAKLAND",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 14,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006160",
    "resolved_pwsid": "MI0006160",
    "system_name": "SOUTHFIELD",
    "display_name": "SOUTHFIELD",
    "county": "OAKLAND",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 1,
    "inventory_gpcl": 1,
    "inventory_unknown": 1570,
    "total_to_identify_or_replace": 1572,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0006170",
    "resolved_pwsid": "MI0006170",
    "system_name": "SOUTHGATE",
    "display_name": "SOUTHGATE",
    "county": "WAYNE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006170",
    "resolved_pwsid": "MI0006170",
    "system_name": "SOUTHGATE",
    "display_name": "SOUTHGATE",
    "county": "WAYNE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006170",
    "resolved_pwsid": "MI0006170",
    "system_name": "SOUTHGATE",
    "display_name": "SOUTHGATE",
    "county": "WAYNE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006170",
    "resolved_pwsid": "MI0006170",
    "system_name": "SOUTHGATE",
    "display_name": "SOUTHGATE",
    "county": "WAYNE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": 30,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006170",
    "resolved_pwsid": "MI0006170",
    "system_name": "SOUTHGATE",
    "display_name": "SOUTHGATE",
    "county": "WAYNE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": 5,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006170",
    "resolved_pwsid": "MI0006170",
    "system_name": "SOUTHGATE",
    "display_name": "SOUTHGATE",
    "county": "WAYNE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": 17,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006170",
    "resolved_pwsid": "MI0006170",
    "system_name": "SOUTHGATE",
    "display_name": "SOUTHGATE",
    "county": "WAYNE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": 35,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006170",
    "resolved_pwsid": "MI0006170",
    "system_name": "SOUTHGATE",
    "display_name": "SOUTHGATE",
    "county": "WAYNE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": 29,
    "inventory_lead": 192,
    "inventory_gpcl": 9735,
    "inventory_unknown": 663,
    "total_to_identify_or_replace": 10590,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0006200",
    "resolved_pwsid": "MI0006200",
    "system_name": "SPARTA",
    "display_name": "SPARTA",
    "county": "KENT",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006200",
    "resolved_pwsid": "MI0006200",
    "system_name": "SPARTA",
    "display_name": "SPARTA",
    "county": "KENT",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006200",
    "resolved_pwsid": "MI0006200",
    "system_name": "SPARTA",
    "display_name": "SPARTA",
    "county": "KENT",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 16,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006200",
    "resolved_pwsid": "MI0006200",
    "system_name": "SPARTA",
    "display_name": "SPARTA",
    "county": "KENT",
    "monitoring_end_date": "",
    "year": 2021,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 5,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006200",
    "resolved_pwsid": "MI0006200",
    "system_name": "SPARTA",
    "display_name": "SPARTA",
    "county": "KENT",
    "monitoring_end_date": "",
    "year": 2022,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 21,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006200",
    "resolved_pwsid": "MI0006200",
    "system_name": "SPARTA",
    "display_name": "SPARTA",
    "county": "KENT",
    "monitoring_end_date": "",
    "year": 2024,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 18,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006200",
    "resolved_pwsid": "MI0006200",
    "system_name": "SPARTA",
    "display_name": "SPARTA",
    "county": "KENT",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 24,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006210",
    "resolved_pwsid": "MI0006210",
    "system_name": "SPAULDING TOWNSHIP",
    "display_name": "SPAULDING TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006210",
    "resolved_pwsid": "MI0006210",
    "system_name": "SPAULDING TOWNSHIP",
    "display_name": "SPAULDING TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006210",
    "resolved_pwsid": "MI0006210",
    "system_name": "SPAULDING TOWNSHIP",
    "display_name": "SPAULDING TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006210",
    "resolved_pwsid": "MI0006210",
    "system_name": "SPAULDING TOWNSHIP",
    "display_name": "SPAULDING TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006210",
    "resolved_pwsid": "MI0006210",
    "system_name": "SPAULDING TOWNSHIP",
    "display_name": "SPAULDING TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006210",
    "resolved_pwsid": "MI0006210",
    "system_name": "SPAULDING TOWNSHIP",
    "display_name": "SPAULDING TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006210",
    "resolved_pwsid": "MI0006210",
    "system_name": "SPAULDING TOWNSHIP",
    "display_name": "SPAULDING TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006227",
    "resolved_pwsid": "MI0006227",
    "system_name": "SPRING ARBOR TOWNSHIP",
    "display_name": "SPRING ARBOR TOWNSHIP",
    "county": "JACKSON",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006227",
    "resolved_pwsid": "MI0006227",
    "system_name": "SPRING ARBOR TOWNSHIP",
    "display_name": "SPRING ARBOR TOWNSHIP",
    "county": "JACKSON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006227",
    "resolved_pwsid": "MI0006227",
    "system_name": "SPRING ARBOR TOWNSHIP",
    "display_name": "SPRING ARBOR TOWNSHIP",
    "county": "JACKSON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006227",
    "resolved_pwsid": "MI0006227",
    "system_name": "SPRING ARBOR TOWNSHIP",
    "display_name": "SPRING ARBOR TOWNSHIP",
    "county": "JACKSON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006230",
    "resolved_pwsid": "MI0006230",
    "system_name": "SPRING LAKE",
    "display_name": "SPRING LAKE",
    "county": "OTTAWA",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006230",
    "resolved_pwsid": "MI0006230",
    "system_name": "SPRING LAKE",
    "display_name": "SPRING LAKE",
    "county": "OTTAWA",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006230",
    "resolved_pwsid": "MI0006230",
    "system_name": "SPRING LAKE",
    "display_name": "SPRING LAKE",
    "county": "OTTAWA",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 7,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006230",
    "resolved_pwsid": "MI0006230",
    "system_name": "SPRING LAKE",
    "display_name": "SPRING LAKE",
    "county": "OTTAWA",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 90,
    "inventory_lead": null,
    "inventory_gpcl": 1110,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006230",
    "resolved_pwsid": "MI0006230",
    "system_name": "SPRING LAKE",
    "display_name": "SPRING LAKE",
    "county": "OTTAWA",
    "monitoring_end_date": "",
    "year": 2021,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 4,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006230",
    "resolved_pwsid": "MI0006230",
    "system_name": "SPRING LAKE",
    "display_name": "SPRING LAKE",
    "county": "OTTAWA",
    "monitoring_end_date": "",
    "year": 2023,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 17,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006230",
    "resolved_pwsid": "MI0006230",
    "system_name": "SPRING LAKE",
    "display_name": "SPRING LAKE",
    "county": "OTTAWA",
    "monitoring_end_date": "",
    "year": 2024,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 52,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006232",
    "resolved_pwsid": "MI0006232",
    "system_name": "SPRING LAKE CLUB CONDOMINIUMS",
    "display_name": "SPRING LAKE CLUB CONDOMINIUMS",
    "county": "EMMET",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006232",
    "resolved_pwsid": "MI0006232",
    "system_name": "SPRING LAKE CLUB CONDOMINIUMS",
    "display_name": "SPRING LAKE CLUB CONDOMINIUMS",
    "county": "EMMET",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006232",
    "resolved_pwsid": "MI0006232",
    "system_name": "SPRING LAKE CLUB CONDOMINIUMS",
    "display_name": "SPRING LAKE CLUB CONDOMINIUMS",
    "county": "EMMET",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 11,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006232",
    "resolved_pwsid": "MI0006232",
    "system_name": "SPRING LAKE CLUB CONDOMINIUMS",
    "display_name": "SPRING LAKE CLUB CONDOMINIUMS",
    "county": "EMMET",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006235",
    "resolved_pwsid": "MI0006235",
    "system_name": "SPRING LAKE TOWNSHIP",
    "display_name": "SPRING LAKE TOWNSHIP",
    "county": "OTTAWA",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006235",
    "resolved_pwsid": "MI0006235",
    "system_name": "SPRING LAKE TOWNSHIP",
    "display_name": "SPRING LAKE TOWNSHIP",
    "county": "OTTAWA",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006235",
    "resolved_pwsid": "MI0006235",
    "system_name": "SPRING LAKE TOWNSHIP",
    "display_name": "SPRING LAKE TOWNSHIP",
    "county": "OTTAWA",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006235",
    "resolved_pwsid": "MI0006235",
    "system_name": "SPRING LAKE TOWNSHIP",
    "display_name": "SPRING LAKE TOWNSHIP",
    "county": "OTTAWA",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006240",
    "resolved_pwsid": "MI0006240",
    "system_name": "SPRINGFIELD",
    "display_name": "SPRINGFIELD",
    "county": "CALHOUN",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006240",
    "resolved_pwsid": "MI0006240",
    "system_name": "SPRINGFIELD",
    "display_name": "SPRINGFIELD",
    "county": "CALHOUN",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006240",
    "resolved_pwsid": "MI0006240",
    "system_name": "SPRINGFIELD",
    "display_name": "SPRINGFIELD",
    "county": "CALHOUN",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006240",
    "resolved_pwsid": "MI0006240",
    "system_name": "SPRINGFIELD",
    "display_name": "SPRINGFIELD",
    "county": "CALHOUN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 2,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006240",
    "resolved_pwsid": "MI0006240",
    "system_name": "SPRINGFIELD",
    "display_name": "SPRINGFIELD",
    "county": "CALHOUN",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006240",
    "resolved_pwsid": "MI0006240",
    "system_name": "SPRINGFIELD",
    "display_name": "SPRINGFIELD",
    "county": "CALHOUN",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 15,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006240",
    "resolved_pwsid": "MI0006240",
    "system_name": "SPRINGFIELD",
    "display_name": "SPRINGFIELD",
    "county": "CALHOUN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006240",
    "resolved_pwsid": "MI0006240",
    "system_name": "SPRINGFIELD",
    "display_name": "SPRINGFIELD",
    "county": "CALHOUN",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 13,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 1,
    "total_to_identify_or_replace": 1,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0006243",
    "resolved_pwsid": "MI0006243",
    "system_name": "KINGSTON APARTMENTS",
    "display_name": "KINGSTON APARTMENTS",
    "county": "OAKLAND",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006243",
    "resolved_pwsid": "MI0006243",
    "system_name": "KINGSTON APARTMENTS",
    "display_name": "KINGSTON APARTMENTS",
    "county": "OAKLAND",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006243",
    "resolved_pwsid": "MI0006243",
    "system_name": "KINGSTON APARTMENTS",
    "display_name": "KINGSTON APARTMENTS",
    "county": "OAKLAND",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006243",
    "resolved_pwsid": "MI0006243",
    "system_name": "KINGSTON APARTMENTS",
    "display_name": "KINGSTON APARTMENTS",
    "county": "OAKLAND",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0006250",
    "resolved_pwsid": "MI0006250",
    "system_name": "SPRINGPORT",
    "display_name": "SPRINGPORT",
    "county": "JACKSON",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006250",
    "resolved_pwsid": "MI0006250",
    "system_name": "SPRINGPORT",
    "display_name": "SPRINGPORT",
    "county": "JACKSON",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 9,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006250",
    "resolved_pwsid": "MI0006250",
    "system_name": "SPRINGPORT",
    "display_name": "SPRINGPORT",
    "county": "JACKSON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006250",
    "resolved_pwsid": "MI0006250",
    "system_name": "SPRINGPORT",
    "display_name": "SPRINGPORT",
    "county": "JACKSON",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006250",
    "resolved_pwsid": "MI0006250",
    "system_name": "SPRINGPORT",
    "display_name": "SPRINGPORT",
    "county": "JACKSON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006250",
    "resolved_pwsid": "MI0006250",
    "system_name": "SPRINGPORT",
    "display_name": "SPRINGPORT",
    "county": "JACKSON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006250",
    "resolved_pwsid": "MI0006250",
    "system_name": "SPRINGPORT",
    "display_name": "SPRINGPORT",
    "county": "JACKSON",
    "monitoring_end_date": "2024-06-30",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006250",
    "resolved_pwsid": "MI0006250",
    "system_name": "SPRINGPORT",
    "display_name": "SPRINGPORT",
    "county": "JACKSON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006250",
    "resolved_pwsid": "MI0006250",
    "system_name": "SPRINGPORT",
    "display_name": "SPRINGPORT",
    "county": "JACKSON",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0006250",
    "resolved_pwsid": "MI0006250",
    "system_name": "SPRINGPORT",
    "display_name": "SPRINGPORT",
    "county": "JACKSON",
    "monitoring_end_date": "2026-06-30",
    "year": 2026,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006260",
    "resolved_pwsid": "MI0006260",
    "system_name": "ST. CHARLES, VILLAGE OF",
    "display_name": "ST. CHARLES, VILLAGE OF",
    "county": "SAGINAW",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006260",
    "resolved_pwsid": "MI0006260",
    "system_name": "ST. CHARLES, VILLAGE OF",
    "display_name": "ST. CHARLES, VILLAGE OF",
    "county": "SAGINAW",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006260",
    "resolved_pwsid": "MI0006260",
    "system_name": "ST. CHARLES, VILLAGE OF",
    "display_name": "ST. CHARLES, VILLAGE OF",
    "county": "SAGINAW",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 12,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006260",
    "resolved_pwsid": "MI0006260",
    "system_name": "ST. CHARLES, VILLAGE OF",
    "display_name": "ST. CHARLES, VILLAGE OF",
    "county": "SAGINAW",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006260",
    "resolved_pwsid": "MI0006260",
    "system_name": "ST. CHARLES, VILLAGE OF",
    "display_name": "ST. CHARLES, VILLAGE OF",
    "county": "SAGINAW",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 3,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006260",
    "resolved_pwsid": "MI0006260",
    "system_name": "ST. CHARLES, VILLAGE OF",
    "display_name": "ST. CHARLES, VILLAGE OF",
    "county": "SAGINAW",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": 50,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006260",
    "resolved_pwsid": "MI0006260",
    "system_name": "ST. CHARLES, VILLAGE OF",
    "display_name": "ST. CHARLES, VILLAGE OF",
    "county": "SAGINAW",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 20,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006260",
    "resolved_pwsid": "MI0006260",
    "system_name": "ST. CHARLES, VILLAGE OF",
    "display_name": "ST. CHARLES, VILLAGE OF",
    "county": "SAGINAW",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 6,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006270",
    "resolved_pwsid": "MI0006270",
    "system_name": "ST. CLAIR, CITY OF",
    "display_name": "ST. CLAIR, CITY OF",
    "county": "ST CLAIR",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006270",
    "resolved_pwsid": "MI0006270",
    "system_name": "ST. CLAIR, CITY OF",
    "display_name": "ST. CLAIR, CITY OF",
    "county": "ST CLAIR",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006270",
    "resolved_pwsid": "MI0006270",
    "system_name": "ST. CLAIR, CITY OF",
    "display_name": "ST. CLAIR, CITY OF",
    "county": "ST. CLAIR",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 7,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006270",
    "resolved_pwsid": "MI0006270",
    "system_name": "ST. CLAIR, CITY OF",
    "display_name": "ST. CLAIR, CITY OF",
    "county": "ST CLAIR",
    "monitoring_end_date": "",
    "year": 2024,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 14,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006270",
    "resolved_pwsid": "MI0006270",
    "system_name": "ST. CLAIR, CITY OF",
    "display_name": "ST. CLAIR, CITY OF",
    "county": "ST CLAIR",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 18,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006280",
    "resolved_pwsid": "MI0006280",
    "system_name": "ST. CLAIR SHORES, CITY OF",
    "display_name": "ST. CLAIR SHORES, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006280",
    "resolved_pwsid": "MI0006280",
    "system_name": "ST. CLAIR SHORES, CITY OF",
    "display_name": "ST. CLAIR SHORES, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2019-09-30",
    "year": 2019,
    "lead_90th_ppb": 21,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006280",
    "resolved_pwsid": "MI0006280",
    "system_name": "ST. CLAIR SHORES, CITY OF",
    "display_name": "ST. CLAIR SHORES, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 21,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006280",
    "resolved_pwsid": "MI0006280",
    "system_name": "ST. CLAIR SHORES, CITY OF",
    "display_name": "ST. CLAIR SHORES, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 11,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006280",
    "resolved_pwsid": "MI0006280",
    "system_name": "ST. CLAIR SHORES, CITY OF",
    "display_name": "ST. CLAIR SHORES, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 18,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006280",
    "resolved_pwsid": "MI0006280",
    "system_name": "ST. CLAIR SHORES, CITY OF",
    "display_name": "ST. CLAIR SHORES, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2021-06-30",
    "year": 2021,
    "lead_90th_ppb": 15,
    "above_action_level": true,
    "lines_replaced": 322,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006280",
    "resolved_pwsid": "MI0006280",
    "system_name": "ST. CLAIR SHORES, CITY OF",
    "display_name": "ST. CLAIR SHORES, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 12,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006280",
    "resolved_pwsid": "MI0006280",
    "system_name": "ST. CLAIR SHORES, CITY OF",
    "display_name": "ST. CLAIR SHORES, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": 29,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006280",
    "resolved_pwsid": "MI0006280",
    "system_name": "ST. CLAIR SHORES, CITY OF",
    "display_name": "ST. CLAIR SHORES, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 14,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006280",
    "resolved_pwsid": "MI0006280",
    "system_name": "ST. CLAIR SHORES, CITY OF",
    "display_name": "ST. CLAIR SHORES, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 7,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006280",
    "resolved_pwsid": "MI0006280",
    "system_name": "ST. CLAIR SHORES, CITY OF",
    "display_name": "ST. CLAIR SHORES, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 8,
    "inventory_lead": 12,
    "inventory_gpcl": 0,
    "inventory_unknown": 791,
    "total_to_identify_or_replace": 803,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0006282",
    "resolved_pwsid": "MI0006282",
    "system_name": "ST. CLAIR TOWNSHIP",
    "display_name": "ST. CLAIR TOWNSHIP",
    "county": "ST CLAIR",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 9,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006282",
    "resolved_pwsid": "MI0006282",
    "system_name": "ST. CLAIR TOWNSHIP",
    "display_name": "ST. CLAIR TOWNSHIP",
    "county": "ST CLAIR",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006282",
    "resolved_pwsid": "MI0006282",
    "system_name": "ST. CLAIR TOWNSHIP",
    "display_name": "ST. CLAIR TOWNSHIP",
    "county": "ST. CLAIR",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006284",
    "resolved_pwsid": "MI0006284",
    "system_name": "ST. CLAIR WATER AND SEWER AUTHORITY",
    "display_name": "ST. CLAIR WATER AND SEWER AUTHORITY",
    "county": "ST CLAIR",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006284",
    "resolved_pwsid": "MI0006284",
    "system_name": "ST. CLAIR WATER AND SEWER AUTHORITY",
    "display_name": "ST. CLAIR WATER AND SEWER AUTHORITY",
    "county": "ST CLAIR",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006284",
    "resolved_pwsid": "MI0006284",
    "system_name": "ST. CLAIR WATER AND SEWER AUTHORITY",
    "display_name": "ST. CLAIR WATER AND SEWER AUTHORITY",
    "county": "ST. CLAIR",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006284",
    "resolved_pwsid": "MI0006284",
    "system_name": "ST. CLAIR WATER AND SEWER AUTHORITY",
    "display_name": "ST. CLAIR WATER AND SEWER AUTHORITY",
    "county": "ST CLAIR",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 6,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006290",
    "resolved_pwsid": "MI0006290",
    "system_name": "ST IGNACE",
    "display_name": "ST IGNACE",
    "county": "MACKINAC",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006290",
    "resolved_pwsid": "MI0006290",
    "system_name": "ST IGNACE",
    "display_name": "ST IGNACE",
    "county": "MACKINAC",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006290",
    "resolved_pwsid": "MI0006290",
    "system_name": "ST IGNACE",
    "display_name": "ST IGNACE",
    "county": "MACKINAC",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006290",
    "resolved_pwsid": "MI0006290",
    "system_name": "ST IGNACE",
    "display_name": "ST IGNACE",
    "county": "MACKINAC",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006290",
    "resolved_pwsid": "MI0006290",
    "system_name": "ST IGNACE",
    "display_name": "ST IGNACE",
    "county": "MACKINAC",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006290",
    "resolved_pwsid": "MI0006290",
    "system_name": "ST IGNACE",
    "display_name": "ST IGNACE",
    "county": "MACKINAC",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006290",
    "resolved_pwsid": "MI0006290",
    "system_name": "ST IGNACE",
    "display_name": "ST IGNACE",
    "county": "MACKINAC",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006290",
    "resolved_pwsid": "MI0006290-a",
    "system_name": "ST. IGNACE",
    "display_name": "ST IGNACE",
    "county": "MACKINAC",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 84,
    "inventory_gpcl": 242,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 326,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0006300",
    "resolved_pwsid": "MI0006300",
    "system_name": "ST. JOHNS, CITY OF",
    "display_name": "ST. JOHNS, CITY OF",
    "county": "CLINTON",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006300",
    "resolved_pwsid": "MI0006300",
    "system_name": "ST. JOHNS, CITY OF",
    "display_name": "ST. JOHNS, CITY OF",
    "county": "CLINTON",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 3,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006300",
    "resolved_pwsid": "MI0006300",
    "system_name": "ST. JOHNS, CITY OF",
    "display_name": "ST. JOHNS, CITY OF",
    "county": "CLINTON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 4,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006300",
    "resolved_pwsid": "MI0006300",
    "system_name": "ST. JOHNS, CITY OF",
    "display_name": "ST. JOHNS, CITY OF",
    "county": "CLINTON",
    "monitoring_end_date": "",
    "year": 2022,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 3,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006300",
    "resolved_pwsid": "MI0006300",
    "system_name": "ST. JOHNS, CITY OF",
    "display_name": "ST. JOHNS, CITY OF",
    "county": "CLINTON",
    "monitoring_end_date": "",
    "year": 2023,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 4,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006300",
    "resolved_pwsid": "MI0006300",
    "system_name": "ST. JOHNS, CITY OF",
    "display_name": "ST. JOHNS, CITY OF",
    "county": "CLINTON",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 6,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006310",
    "resolved_pwsid": "MI0006310",
    "system_name": "ST JOSEPH",
    "display_name": "ST JOSEPH",
    "county": "BERRIEN",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006310",
    "resolved_pwsid": "MI0006310",
    "system_name": "ST JOSEPH",
    "display_name": "ST JOSEPH",
    "county": "BERRIEN",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 9,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006310",
    "resolved_pwsid": "MI0006310",
    "system_name": "ST JOSEPH",
    "display_name": "ST JOSEPH",
    "county": "BERRIEN",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 9,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006310",
    "resolved_pwsid": "MI0006310",
    "system_name": "ST JOSEPH",
    "display_name": "ST JOSEPH",
    "county": "BERRIEN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 10,
    "above_action_level": false,
    "lines_replaced": 130,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006310",
    "resolved_pwsid": "MI0006310",
    "system_name": "ST JOSEPH",
    "display_name": "ST JOSEPH",
    "county": "BERRIEN",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 15,
    "above_action_level": true,
    "lines_replaced": 199,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006310",
    "resolved_pwsid": "MI0006310",
    "system_name": "ST JOSEPH",
    "display_name": "ST JOSEPH",
    "county": "BERRIEN",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 12,
    "above_action_level": false,
    "lines_replaced": 222,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006310",
    "resolved_pwsid": "MI0006310",
    "system_name": "ST JOSEPH",
    "display_name": "ST JOSEPH",
    "county": "BERRIEN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": 170,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006310",
    "resolved_pwsid": "MI0006310",
    "system_name": "ST JOSEPH",
    "display_name": "ST JOSEPH",
    "county": "BERRIEN",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": 27,
    "inventory_lead": 1566,
    "inventory_gpcl": 259,
    "inventory_unknown": 361,
    "total_to_identify_or_replace": 2186,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0006320",
    "resolved_pwsid": "MI0006320",
    "system_name": "ST. LOUIS, CITY OF",
    "display_name": "ST. LOUIS, CITY OF",
    "county": "GRATIOT",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006320",
    "resolved_pwsid": "MI0006320",
    "system_name": "ST. LOUIS, CITY OF",
    "display_name": "ST. LOUIS, CITY OF",
    "county": "GRATIOT",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006320",
    "resolved_pwsid": "MI0006320",
    "system_name": "ST. LOUIS, CITY OF",
    "display_name": "ST. LOUIS, CITY OF",
    "county": "GRATIOT",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006320",
    "resolved_pwsid": "MI0006320",
    "system_name": "ST. LOUIS, CITY OF",
    "display_name": "ST. LOUIS, CITY OF",
    "county": "GRATIOT",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 8,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006320",
    "resolved_pwsid": "MI0006320",
    "system_name": "ST. LOUIS, CITY OF",
    "display_name": "ST. LOUIS, CITY OF",
    "county": "GRATIOT",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 19,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006320",
    "resolved_pwsid": "MI0006320",
    "system_name": "ST. LOUIS, CITY OF",
    "display_name": "ST. LOUIS, CITY OF",
    "county": "GRATIOT",
    "monitoring_end_date": "",
    "year": 2022,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 5,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006320",
    "resolved_pwsid": "MI0006320",
    "system_name": "ST. LOUIS, CITY OF",
    "display_name": "ST. LOUIS, CITY OF",
    "county": "GRATIOT",
    "monitoring_end_date": "",
    "year": 2023,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 13,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006320",
    "resolved_pwsid": "MI0006320",
    "system_name": "ST. LOUIS, CITY OF",
    "display_name": "ST. LOUIS, CITY OF",
    "county": "GRATIOT",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 97,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006325",
    "resolved_pwsid": "MI0006325-a",
    "system_name": "ST. LOUIS CENTER",
    "display_name": "ST. LOUIS CENTER",
    "county": "WASHTENAW",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006325",
    "resolved_pwsid": "MI0006325-a",
    "system_name": "ST. LOUIS CENTER",
    "display_name": "ST. LOUIS CENTER",
    "county": "WASHTENAW",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006325",
    "resolved_pwsid": "MI0006325-a",
    "system_name": "ST. LOUIS CENTER",
    "display_name": "ST. LOUIS CENTER",
    "county": "WASHTENAW",
    "monitoring_end_date": "2021-06-30",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006325",
    "resolved_pwsid": "MI0006325-b",
    "system_name": "ST. LOUIS CENTER (DIST NEW)",
    "display_name": "ST. LOUIS CENTER (DIST NEW)",
    "county": "WASHTENAW",
    "monitoring_end_date": "2021-06-30",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006325",
    "resolved_pwsid": "MI0006325-b",
    "system_name": "ST. LOUIS CENTER (DIST NEW)",
    "display_name": "ST. LOUIS CENTER (DIST NEW)",
    "county": "WASHTENAW",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006325",
    "resolved_pwsid": "MI0006325-c",
    "system_name": "ST. LOUIS CENTER (DIST)",
    "display_name": "ST. LOUIS CENTER (DIST)",
    "county": "WASHTENAW",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006325",
    "resolved_pwsid": "MI0006325-e",
    "system_name": "ST. LOUIS CENTER (NEW)",
    "display_name": "ST. LOUIS CENTER (NEW)",
    "county": "WASHTENAW",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006325",
    "resolved_pwsid": "MI0006325-f",
    "system_name": "ST. LOUIS CENTER (DS001)",
    "display_name": "ST. LOUIS CENTER (DS001)",
    "county": "WASHTENAW",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006325",
    "resolved_pwsid": "MI0006325-d",
    "system_name": "ST. LOUIS CENTER (DIST2)",
    "display_name": "ST. LOUIS CENTER (DIST2)",
    "county": "WASHTENAW",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006325",
    "resolved_pwsid": "MI0006325-g",
    "system_name": "ST. LOUIS CENTER (DS002)",
    "display_name": "ST. LOUIS CENTER (DS002)",
    "county": "WASHTENAW",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006350",
    "resolved_pwsid": "MI0006350",
    "system_name": "STANDISH, CITY OF",
    "display_name": "STANDISH, CITY OF",
    "county": "ARENAC",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006350",
    "resolved_pwsid": "MI0006350",
    "system_name": "STANDISH, CITY OF",
    "display_name": "STANDISH, CITY OF",
    "county": "ARENAC",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006350",
    "resolved_pwsid": "MI0006350",
    "system_name": "STANDISH, CITY OF",
    "display_name": "STANDISH, CITY OF",
    "county": "ARENAC",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006350",
    "resolved_pwsid": "MI0006350",
    "system_name": "STANDISH, CITY OF",
    "display_name": "STANDISH, CITY OF",
    "county": "ARENAC",
    "monitoring_end_date": "",
    "year": 2021,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 3,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006350",
    "resolved_pwsid": "MI0006350",
    "system_name": "STANDISH, CITY OF",
    "display_name": "STANDISH, CITY OF",
    "county": "ARENAC",
    "monitoring_end_date": "",
    "year": 2024,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006350",
    "resolved_pwsid": "MI0006350",
    "system_name": "STANDISH, CITY OF",
    "display_name": "STANDISH, CITY OF",
    "county": "ARENAC",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006360",
    "resolved_pwsid": "MI0006360",
    "system_name": "STANTON",
    "display_name": "STANTON",
    "county": "MONTCALM",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006360",
    "resolved_pwsid": "MI0006360",
    "system_name": "STANTON",
    "display_name": "STANTON",
    "county": "MONTCALM",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006360",
    "resolved_pwsid": "MI0006360",
    "system_name": "STANTON",
    "display_name": "STANTON",
    "county": "MONTCALM",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006360",
    "resolved_pwsid": "MI0006360",
    "system_name": "STANTON",
    "display_name": "STANTON",
    "county": "MONTCALM",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 4,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006360",
    "resolved_pwsid": "MI0006360",
    "system_name": "STANTON",
    "display_name": "STANTON",
    "county": "MONTCALM",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 37,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006370",
    "resolved_pwsid": "MI0006370",
    "system_name": "SPSM",
    "display_name": "SPSM",
    "county": "JACKSON",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006370",
    "resolved_pwsid": "MI0006370",
    "system_name": "SPSM",
    "display_name": "SPSM",
    "county": "JACKSON",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006370",
    "resolved_pwsid": "MI0006370",
    "system_name": "SPSM",
    "display_name": "SPSM",
    "county": "JACKSON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006370",
    "resolved_pwsid": "MI0006370",
    "system_name": "SPSM",
    "display_name": "SPSM",
    "county": "JACKSON",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006370",
    "resolved_pwsid": "MI0006370",
    "system_name": "SPSM",
    "display_name": "SPSM",
    "county": "JACKSON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006370",
    "resolved_pwsid": "MI0006370",
    "system_name": "SPSM",
    "display_name": "SPSM",
    "county": "JACKSON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006370",
    "resolved_pwsid": "MI0006370",
    "system_name": "SPSM",
    "display_name": "SPSM",
    "county": "JACKSON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006370",
    "resolved_pwsid": "MI0006370",
    "system_name": "SPSM",
    "display_name": "SPSM",
    "county": "JACKSON",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0006375",
    "resolved_pwsid": "MI0006375",
    "system_name": "MCTI",
    "display_name": "MCTI",
    "county": "BARRY",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006375",
    "resolved_pwsid": "MI0006375",
    "system_name": "MCTI",
    "display_name": "MCTI",
    "county": "BARRY",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006375",
    "resolved_pwsid": "MI0006375",
    "system_name": "MCTI",
    "display_name": "MCTI",
    "county": "BARRY",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006377",
    "resolved_pwsid": "MI0006377",
    "system_name": "MCTI FAMILY HOUSING",
    "display_name": "MCTI FAMILY HOUSING",
    "county": "BARRY",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006377",
    "resolved_pwsid": "MI0006377",
    "system_name": "MCTI FAMILY HOUSING",
    "display_name": "MCTI FAMILY HOUSING",
    "county": "BARRY",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006377",
    "resolved_pwsid": "MI0006377",
    "system_name": "MCTI FAMILY HOUSING",
    "display_name": "MCTI FAMILY HOUSING",
    "county": "BARRY",
    "monitoring_end_date": "2022-06-30",
    "year": 2022,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006377",
    "resolved_pwsid": "MI0006377",
    "system_name": "MCTI FAMILY HOUSING",
    "display_name": "MCTI FAMILY HOUSING",
    "county": "BARRY",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006377",
    "resolved_pwsid": "MI0006377",
    "system_name": "MCTI FAMILY HOUSING",
    "display_name": "MCTI FAMILY HOUSING",
    "county": "BARRY",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006377",
    "resolved_pwsid": "MI0006377-a",
    "system_name": "PINE LAKE APARTMENTS",
    "display_name": "MCTI FAMILY HOUSING",
    "county": "BARRY",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0006380",
    "resolved_pwsid": "MI0006380",
    "system_name": "STEPHENSON",
    "display_name": "STEPHENSON",
    "county": "MENOMINEE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006380",
    "resolved_pwsid": "MI0006380",
    "system_name": "STEPHENSON",
    "display_name": "STEPHENSON",
    "county": "MENOMINEE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006380",
    "resolved_pwsid": "MI0006380",
    "system_name": "STEPHENSON",
    "display_name": "STEPHENSON",
    "county": "MENOMINEE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006385",
    "resolved_pwsid": "MI0006385",
    "system_name": "STERLING HEIGHTS, CITY OF",
    "display_name": "STERLING HEIGHTS, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006385",
    "resolved_pwsid": "MI0006385",
    "system_name": "STERLING HEIGHTS, CITY OF",
    "display_name": "STERLING HEIGHTS, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006385",
    "resolved_pwsid": "MI0006385",
    "system_name": "STERLING HEIGHTS, CITY OF",
    "display_name": "STERLING HEIGHTS, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006385",
    "resolved_pwsid": "MI0006385",
    "system_name": "STERLING HEIGHTS, CITY OF",
    "display_name": "STERLING HEIGHTS, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006385",
    "resolved_pwsid": "MI0006385",
    "system_name": "STERLING HEIGHTS, CITY OF",
    "display_name": "STERLING HEIGHTS, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006385",
    "resolved_pwsid": "MI0006385",
    "system_name": "STERLING HEIGHTS, CITY OF",
    "display_name": "STERLING HEIGHTS, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006385",
    "resolved_pwsid": "MI0006385",
    "system_name": "STERLING HEIGHTS, CITY OF",
    "display_name": "STERLING HEIGHTS, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006385",
    "resolved_pwsid": "MI0006385",
    "system_name": "STERLING HEIGHTS, CITY OF",
    "display_name": "STERLING HEIGHTS, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 1995,
    "total_to_identify_or_replace": 1995,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0006420",
    "resolved_pwsid": "MI0006420",
    "system_name": "STOCKBRIDGE, VILLAGE OF",
    "display_name": "STOCKBRIDGE, VILLAGE OF",
    "county": "INGHAM",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006420",
    "resolved_pwsid": "MI0006420",
    "system_name": "STOCKBRIDGE, VILLAGE OF",
    "display_name": "STOCKBRIDGE, VILLAGE OF",
    "county": "INGHAM",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006420",
    "resolved_pwsid": "MI0006420",
    "system_name": "STOCKBRIDGE, VILLAGE OF",
    "display_name": "STOCKBRIDGE, VILLAGE OF",
    "county": "INGHAM",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006420",
    "resolved_pwsid": "MI0006420",
    "system_name": "STOCKBRIDGE, VILLAGE OF",
    "display_name": "STOCKBRIDGE, VILLAGE OF",
    "county": "INGHAM",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006420",
    "resolved_pwsid": "MI0006420",
    "system_name": "STOCKBRIDGE, VILLAGE OF",
    "display_name": "STOCKBRIDGE, VILLAGE OF",
    "county": "INGHAM",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006420",
    "resolved_pwsid": "MI0006420",
    "system_name": "STOCKBRIDGE, VILLAGE OF",
    "display_name": "STOCKBRIDGE, VILLAGE OF",
    "county": "INGHAM",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006420",
    "resolved_pwsid": "MI0006420",
    "system_name": "STOCKBRIDGE, VILLAGE OF",
    "display_name": "STOCKBRIDGE, VILLAGE OF",
    "county": "INGHAM",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006420",
    "resolved_pwsid": "MI0006420",
    "system_name": "STOCKBRIDGE, VILLAGE OF",
    "display_name": "STOCKBRIDGE, VILLAGE OF",
    "county": "INGHAM",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 354,
    "inventory_gpcl": 4,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 358,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0006423",
    "resolved_pwsid": "MI0006423",
    "system_name": "STONE RIDGE",
    "display_name": "STONE RIDGE",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006423",
    "resolved_pwsid": "MI0006423",
    "system_name": "STONE RIDGE",
    "display_name": "STONE RIDGE",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006423",
    "resolved_pwsid": "MI0006423",
    "system_name": "STONE RIDGE",
    "display_name": "STONE RIDGE",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006423",
    "resolved_pwsid": "MI0006423",
    "system_name": "STONE RIDGE",
    "display_name": "STONE RIDGE",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006428",
    "resolved_pwsid": "MI0006428",
    "system_name": "STONEHEDGE CLUB OWNERS ASSOCIATION, INC.",
    "display_name": "STONEHEDGE CLUB OWNERS ASSOCIATION, INC.",
    "county": "EMMET",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006428",
    "resolved_pwsid": "MI0006428",
    "system_name": "STONEHEDGE CLUB OWNERS ASSOCIATION, INC.",
    "display_name": "STONEHEDGE CLUB OWNERS ASSOCIATION, INC.",
    "county": "EMMET",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006428",
    "resolved_pwsid": "MI0006428",
    "system_name": "STONEHEDGE CLUB OWNERS ASSOCIATION, INC.",
    "display_name": "STONEHEDGE CLUB OWNERS ASSOCIATION, INC.",
    "county": "EMMET",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006428",
    "resolved_pwsid": "MI0006428",
    "system_name": "STONEHEDGE CLUB OWNERS ASSOCIATION, INC.",
    "display_name": "STONEHEDGE CLUB OWNERS ASSOCIATION, INC.",
    "county": "EMMET",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0006431",
    "resolved_pwsid": "MI0006431",
    "system_name": "STONEY CREEK VILLAGE APARTMENTS",
    "display_name": "STONEY CREEK VILLAGE APARTMENTS",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006431",
    "resolved_pwsid": "MI0006431",
    "system_name": "STONEY CREEK VILLAGE APARTMENTS",
    "display_name": "STONEY CREEK VILLAGE APARTMENTS",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006435",
    "resolved_pwsid": "MI0006435",
    "system_name": "BEDFORD MEADOWS",
    "display_name": "BEDFORD MEADOWS",
    "county": "MONROE",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006435",
    "resolved_pwsid": "MI0006435",
    "system_name": "BEDFORD MEADOWS",
    "display_name": "BEDFORD MEADOWS",
    "county": "MONROE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006435",
    "resolved_pwsid": "MI0006435",
    "system_name": "BEDFORD MEADOWS",
    "display_name": "BEDFORD MEADOWS",
    "county": "MONROE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006435",
    "resolved_pwsid": "MI0006435",
    "system_name": "BEDFORD MEADOWS",
    "display_name": "BEDFORD MEADOWS",
    "county": "MONROE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0006440",
    "resolved_pwsid": "MI0006440",
    "system_name": "STURGIS",
    "display_name": "STURGIS",
    "county": "ST JOSEPH",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006440",
    "resolved_pwsid": "MI0006440",
    "system_name": "STURGIS",
    "display_name": "STURGIS",
    "county": "ST JOSEPH",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006440",
    "resolved_pwsid": "MI0006440",
    "system_name": "STURGIS",
    "display_name": "STURGIS",
    "county": "ST JOSEPH",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006440",
    "resolved_pwsid": "MI0006440",
    "system_name": "STURGIS",
    "display_name": "STURGIS",
    "county": "ST. JOSEPH",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 30,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006440",
    "resolved_pwsid": "MI0006440",
    "system_name": "STURGIS",
    "display_name": "STURGIS",
    "county": "ST. JOSEPH",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 110,
    "inventory_lead": 1341,
    "inventory_gpcl": 176,
    "inventory_unknown": 75,
    "total_to_identify_or_replace": 1592,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0006440",
    "resolved_pwsid": "MI0006440",
    "system_name": "STURGIS",
    "display_name": "STURGIS",
    "county": "ST JOSEPH",
    "monitoring_end_date": "",
    "year": 2021,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 69,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006440",
    "resolved_pwsid": "MI0006440",
    "system_name": "STURGIS",
    "display_name": "STURGIS",
    "county": "ST JOSEPH",
    "monitoring_end_date": "",
    "year": 2023,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 45,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006440",
    "resolved_pwsid": "MI0006440",
    "system_name": "STURGIS",
    "display_name": "STURGIS",
    "county": "ST JOSEPH",
    "monitoring_end_date": "",
    "year": 2024,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 51,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006443",
    "resolved_pwsid": "MI0006443-b",
    "system_name": "SUE KAY APARTMENTS",
    "display_name": "SUE KAY APARTMENTS",
    "county": "OAKLAND",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006443",
    "resolved_pwsid": "MI0006443-b",
    "system_name": "SUE KAY APARTMENTS",
    "display_name": "SUE KAY APARTMENTS",
    "county": "OAKLAND",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006443",
    "resolved_pwsid": "MI0006443-a",
    "system_name": "LAKEVIEW APARTMENTS",
    "display_name": "LAKEVIEW APARTMENTS",
    "county": "OAKLAND",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006443",
    "resolved_pwsid": "MI0006443-b",
    "system_name": "SUE KAY APARTMENTS",
    "display_name": "SUE KAY APARTMENTS",
    "county": "OAKLAND",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006443",
    "resolved_pwsid": "MI0006443-a",
    "system_name": "LAKEVIEW APARTMENTS",
    "display_name": "LAKEVIEW APARTMENTS",
    "county": "OAKLAND",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0006446",
    "resolved_pwsid": "MI0006446",
    "system_name": "SUGAR LOAF TOWNHOUSES",
    "display_name": "SUGAR LOAF TOWNHOUSES",
    "county": "LEELANAU",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006446",
    "resolved_pwsid": "MI0006446",
    "system_name": "SUGAR LOAF TOWNHOUSES",
    "display_name": "SUGAR LOAF TOWNHOUSES",
    "county": "LEELANAU",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006446",
    "resolved_pwsid": "MI0006446",
    "system_name": "SUGAR LOAF TOWNHOUSES",
    "display_name": "SUGAR LOAF TOWNHOUSES",
    "county": "LEELANAU",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006446",
    "resolved_pwsid": "MI0006446",
    "system_name": "SUGAR LOAF TOWNHOUSES",
    "display_name": "SUGAR LOAF TOWNHOUSES",
    "county": "LEELANAU",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0006448",
    "resolved_pwsid": "MI0006448",
    "system_name": "SUMMERSET MEADOWS",
    "display_name": "SUMMERSET MEADOWS",
    "county": "KENT",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006448",
    "resolved_pwsid": "MI0006448",
    "system_name": "SUMMERSET MEADOWS",
    "display_name": "SUMMERSET MEADOWS",
    "county": "KENT",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006448",
    "resolved_pwsid": "MI0006448",
    "system_name": "SUMMERSET MEADOWS",
    "display_name": "SUMMERSET MEADOWS",
    "county": "KENT",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006450",
    "resolved_pwsid": "MI0006450",
    "system_name": "SUMMIT TOWNSHIP",
    "display_name": "SUMMIT TOWNSHIP",
    "county": "JACKSON",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006450",
    "resolved_pwsid": "MI0006450",
    "system_name": "SUMMIT TOWNSHIP",
    "display_name": "SUMMIT TOWNSHIP",
    "county": "JACKSON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006450",
    "resolved_pwsid": "MI0006450",
    "system_name": "SUMMIT TOWNSHIP",
    "display_name": "SUMMIT TOWNSHIP",
    "county": "JACKSON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006450",
    "resolved_pwsid": "MI0006450",
    "system_name": "SUMMIT TOWNSHIP",
    "display_name": "SUMMIT TOWNSHIP",
    "county": "JACKSON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006460",
    "resolved_pwsid": "MI0006460",
    "system_name": "SUMPTER TOWNSHIP",
    "display_name": "SUMPTER TOWNSHIP",
    "county": "WAYNE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006460",
    "resolved_pwsid": "MI0006460",
    "system_name": "SUMPTER TOWNSHIP",
    "display_name": "SUMPTER TOWNSHIP",
    "county": "WAYNE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006460",
    "resolved_pwsid": "MI0006460",
    "system_name": "SUMPTER TOWNSHIP",
    "display_name": "SUMPTER TOWNSHIP",
    "county": "WAYNE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006460",
    "resolved_pwsid": "MI0006460",
    "system_name": "SUMPTER TOWNSHIP",
    "display_name": "SUMPTER TOWNSHIP",
    "county": "WAYNE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006460",
    "resolved_pwsid": "MI0006460",
    "system_name": "SUMPTER TOWNSHIP",
    "display_name": "SUMPTER TOWNSHIP",
    "county": "WAYNE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006460",
    "resolved_pwsid": "MI0006460",
    "system_name": "SUMPTER TOWNSHIP",
    "display_name": "SUMPTER TOWNSHIP",
    "county": "WAYNE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006460",
    "resolved_pwsid": "MI0006460",
    "system_name": "SUMPTER TOWNSHIP",
    "display_name": "SUMPTER TOWNSHIP",
    "county": "WAYNE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006460",
    "resolved_pwsid": "MI0006460",
    "system_name": "SUMPTER TOWNSHIP",
    "display_name": "SUMPTER TOWNSHIP",
    "county": "WAYNE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006465",
    "resolved_pwsid": "MI0006465",
    "system_name": "SUN MEADOWS APARTMENTS",
    "display_name": "SUN MEADOWS APARTMENTS",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006465",
    "resolved_pwsid": "MI0006465",
    "system_name": "SUN MEADOWS APARTMENTS",
    "display_name": "SUN MEADOWS APARTMENTS",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006465",
    "resolved_pwsid": "MI0006465",
    "system_name": "SUN MEADOWS APARTMENTS",
    "display_name": "SUN MEADOWS APARTMENTS",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006465",
    "resolved_pwsid": "MI0006465",
    "system_name": "SUN MEADOWS APARTMENTS",
    "display_name": "SUN MEADOWS APARTMENTS",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006470",
    "resolved_pwsid": "MI0006470",
    "system_name": "SUNFIELD, VILLAGE OF",
    "display_name": "SUNFIELD, VILLAGE OF",
    "county": "EATON",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006470",
    "resolved_pwsid": "MI0006470",
    "system_name": "SUNFIELD, VILLAGE OF",
    "display_name": "SUNFIELD, VILLAGE OF",
    "county": "EATON",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006470",
    "resolved_pwsid": "MI0006470",
    "system_name": "SUNFIELD, VILLAGE OF",
    "display_name": "SUNFIELD, VILLAGE OF",
    "county": "EATON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006477",
    "resolved_pwsid": "MI0006477",
    "system_name": "SUNNY CREST YOUTH RANCH",
    "display_name": "SUNNY CREST YOUTH RANCH",
    "county": "EATON",
    "monitoring_end_date": "2018-06-30",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006480",
    "resolved_pwsid": "MI0006480-a",
    "system_name": "SUNNYDALE GARDENS SUBDIVISION",
    "display_name": "SUNNYDALE GARDENS SUBDIVISION",
    "county": "OAKLAND",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006480",
    "resolved_pwsid": "MI0006480-a",
    "system_name": "SUNNYDALE GARDENS SUBDIVISION",
    "display_name": "SUNNYDALE GARDENS SUBDIVISION",
    "county": "OAKLAND",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006480",
    "resolved_pwsid": "MI0006480-a",
    "system_name": "SUNNYDALE GARDENS SUBDIVISION",
    "display_name": "SUNNYDALE GARDENS SUBDIVISION",
    "county": "OAKLAND",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006480",
    "resolved_pwsid": "MI0006480-b",
    "system_name": "SUNNYDALE GARDENS WATER ASSOCIATION",
    "display_name": "SUNNYDALE GARDENS WATER ASSOCIATION",
    "county": "OAKLAND",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006480",
    "resolved_pwsid": "MI0006480-b",
    "system_name": "SUNNYDALE GARDENS WATER ASSOCIATION",
    "display_name": "SUNNYDALE GARDENS WATER ASSOCIATION",
    "county": "OAKLAND",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0006484",
    "resolved_pwsid": "MI0006484",
    "system_name": "SUNSET BEACH ASSOCIATION",
    "display_name": "SUNSET BEACH ASSOCIATION",
    "county": "CHEBOYGAN",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006484",
    "resolved_pwsid": "MI0006484",
    "system_name": "SUNSET BEACH ASSOCIATION",
    "display_name": "SUNSET BEACH ASSOCIATION",
    "county": "CHEBOYGAN",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006484",
    "resolved_pwsid": "MI0006484",
    "system_name": "SUNSET BEACH ASSOCIATION",
    "display_name": "SUNSET BEACH ASSOCIATION",
    "county": "CHEBOYGAN",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006485",
    "resolved_pwsid": "MI0006485",
    "system_name": "SUNSET TORCH ASSOCIATION",
    "display_name": "SUNSET TORCH ASSOCIATION",
    "county": "ANTRIM",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006485",
    "resolved_pwsid": "MI0006485",
    "system_name": "SUNSET TORCH ASSOCIATION",
    "display_name": "SUNSET TORCH ASSOCIATION",
    "county": "ANTRIM",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006485",
    "resolved_pwsid": "MI0006485",
    "system_name": "SUNSET TORCH ASSOCIATION",
    "display_name": "SUNSET TORCH ASSOCIATION",
    "county": "ANTRIM",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006485",
    "resolved_pwsid": "MI0006485",
    "system_name": "SUNSET TORCH ASSOCIATION",
    "display_name": "SUNSET TORCH ASSOCIATION",
    "county": "ANTRIM",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 49,
    "total_to_identify_or_replace": 49,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0006487",
    "resolved_pwsid": "MI0006487",
    "system_name": "NORTH SHORE APARTMENTS",
    "display_name": "NORTH SHORE APARTMENTS",
    "county": "OAKLAND",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006487",
    "resolved_pwsid": "MI0006487",
    "system_name": "NORTH SHORE APARTMENTS",
    "display_name": "NORTH SHORE APARTMENTS",
    "county": "OAKLAND",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006487",
    "resolved_pwsid": "MI0006487",
    "system_name": "NORTH SHORE APARTMENTS",
    "display_name": "NORTH SHORE APARTMENTS",
    "county": "OAKLAND",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006490",
    "resolved_pwsid": "MI0006490-a",
    "system_name": "SUPERIOR TOWNSHIP",
    "display_name": "SUPERIOR TOWNSHIP",
    "county": "WASHTENAW",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006490",
    "resolved_pwsid": "MI0006490-a",
    "system_name": "SUPERIOR TOWNSHIP",
    "display_name": "SUPERIOR TOWNSHIP",
    "county": "WASHTENAW",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006490",
    "resolved_pwsid": "MI0006490-a",
    "system_name": "SUPERIOR TOWNSHIP",
    "display_name": "SUPERIOR TOWNSHIP",
    "county": "WASHTENAW",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006490",
    "resolved_pwsid": "MI0006490-a",
    "system_name": "SUPERIOR TOWNSHIP",
    "display_name": "SUPERIOR TOWNSHIP",
    "county": "WASHTENAW",
    "monitoring_end_date": "2021-06-30",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006490",
    "resolved_pwsid": "MI0006490-e",
    "system_name": "SUPERIOR TOWNSHIP (DIST2)",
    "display_name": "SUPERIOR TOWNSHIP (DIST2)",
    "county": "WASHTENAW",
    "monitoring_end_date": "2021-06-30",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006490",
    "resolved_pwsid": "MI0006490-a",
    "system_name": "SUPERIOR TOWNSHIP",
    "display_name": "SUPERIOR TOWNSHIP",
    "county": "WASHTENAW",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006490",
    "resolved_pwsid": "MI0006490-a",
    "system_name": "SUPERIOR TOWNSHIP",
    "display_name": "SUPERIOR TOWNSHIP",
    "county": "WASHTENAW",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006490",
    "resolved_pwsid": "MI0006490-e",
    "system_name": "SUPERIOR TOWNSHIP (DIST2)",
    "display_name": "SUPERIOR TOWNSHIP (DIST2)",
    "county": "WASHTENAW",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006490",
    "resolved_pwsid": "MI0006490-b",
    "system_name": "SUPERIOR TOWNSHIP (DIST 1)",
    "display_name": "SUPERIOR TOWNSHIP (DIST 1)",
    "county": "WASHTENAW",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006490",
    "resolved_pwsid": "MI0006490-e",
    "system_name": "SUPERIOR TOWNSHIP (DIST2)",
    "display_name": "SUPERIOR TOWNSHIP (DIST2)",
    "county": "WASHTENAW",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006490",
    "resolved_pwsid": "MI0006490-c",
    "system_name": "SUPERIOR TOWNSHIP (DIST 2)",
    "display_name": "SUPERIOR TOWNSHIP (DIST 2)",
    "county": "WASHTENAW",
    "monitoring_end_date": "2024-06-30",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006490",
    "resolved_pwsid": "MI0006490-e",
    "system_name": "SUPERIOR TOWNSHIP (DIST2)",
    "display_name": "SUPERIOR TOWNSHIP (DIST2)",
    "county": "WASHTENAW",
    "monitoring_end_date": "2024-06-30",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006490",
    "resolved_pwsid": "MI0006490-d",
    "system_name": "SUPERIOR TOWNSHIP (DIST)",
    "display_name": "SUPERIOR TOWNSHIP (DIST)",
    "county": "WASHTENAW",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006490",
    "resolved_pwsid": "MI0006490-f",
    "system_name": "SUPERIOR TOWNSHIP (DS001)",
    "display_name": "SUPERIOR TOWNSHIP",
    "county": "WASHTENAW",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0006490",
    "resolved_pwsid": "MI0006490-g",
    "system_name": "SUPERIOR TOWNSHIP (DS002)",
    "display_name": "SUPERIOR TOWNSHIP",
    "county": "WASHTENAW",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0006500",
    "resolved_pwsid": "MI0006500",
    "system_name": "SUTTONS BAY, VILLAGE OF",
    "display_name": "SUTTONS BAY, VILLAGE OF",
    "county": "LEELANAU",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006500",
    "resolved_pwsid": "MI0006500",
    "system_name": "SUTTONS BAY, VILLAGE OF",
    "display_name": "SUTTONS BAY, VILLAGE OF",
    "county": "LEELANAU",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006500",
    "resolved_pwsid": "MI0006500",
    "system_name": "SUTTONS BAY, VILLAGE OF",
    "display_name": "SUTTONS BAY, VILLAGE OF",
    "county": "LEELANAU",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006500",
    "resolved_pwsid": "MI0006500",
    "system_name": "SUTTONS BAY, VILLAGE OF",
    "display_name": "SUTTONS BAY, VILLAGE OF",
    "county": "LEELANAU",
    "monitoring_end_date": "",
    "year": 2022,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 4,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006500",
    "resolved_pwsid": "MI0006500",
    "system_name": "SUTTONS BAY, VILLAGE OF",
    "display_name": "SUTTONS BAY, VILLAGE OF",
    "county": "LEELANAU",
    "monitoring_end_date": "",
    "year": 2023,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006502",
    "resolved_pwsid": "MI0006502",
    "system_name": "SWAN CREEK TOWNSHIP",
    "display_name": "SWAN CREEK TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006502",
    "resolved_pwsid": "MI0006502",
    "system_name": "SWAN CREEK TOWNSHIP",
    "display_name": "SWAN CREEK TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006502",
    "resolved_pwsid": "MI0006502",
    "system_name": "SWAN CREEK TOWNSHIP",
    "display_name": "SWAN CREEK TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006502",
    "resolved_pwsid": "MI0006502",
    "system_name": "SWAN CREEK TOWNSHIP",
    "display_name": "SWAN CREEK TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006502",
    "resolved_pwsid": "MI0006502",
    "system_name": "SWAN CREEK TOWNSHIP",
    "display_name": "SWAN CREEK TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006502",
    "resolved_pwsid": "MI0006502",
    "system_name": "SWAN CREEK TOWNSHIP",
    "display_name": "SWAN CREEK TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006502",
    "resolved_pwsid": "MI0006502",
    "system_name": "SWAN CREEK TOWNSHIP",
    "display_name": "SWAN CREEK TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006505",
    "resolved_pwsid": "MI0006505",
    "system_name": "SWARTZ CREEK, CITY OF",
    "display_name": "SWARTZ CREEK, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006505",
    "resolved_pwsid": "MI0006505",
    "system_name": "SWARTZ CREEK, CITY OF",
    "display_name": "SWARTZ CREEK, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006505",
    "resolved_pwsid": "MI0006505",
    "system_name": "SWARTZ CREEK, CITY OF",
    "display_name": "SWARTZ CREEK, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006505",
    "resolved_pwsid": "MI0006505",
    "system_name": "SWARTZ CREEK, CITY OF",
    "display_name": "SWARTZ CREEK, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006505",
    "resolved_pwsid": "MI0006505",
    "system_name": "SWARTZ CREEK, CITY OF",
    "display_name": "SWARTZ CREEK, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2021-06-30",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006505",
    "resolved_pwsid": "MI0006505",
    "system_name": "SWARTZ CREEK, CITY OF",
    "display_name": "SWARTZ CREEK, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006505",
    "resolved_pwsid": "MI0006505",
    "system_name": "SWARTZ CREEK, CITY OF",
    "display_name": "SWARTZ CREEK, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2022-06-30",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006505",
    "resolved_pwsid": "MI0006505",
    "system_name": "SWARTZ CREEK, CITY OF",
    "display_name": "SWARTZ CREEK, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006505",
    "resolved_pwsid": "MI0006505",
    "system_name": "SWARTZ CREEK, CITY OF",
    "display_name": "SWARTZ CREEK, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006505",
    "resolved_pwsid": "MI0006505",
    "system_name": "SWARTZ CREEK, CITY OF",
    "display_name": "SWARTZ CREEK, CITY OF",
    "county": "GENESEE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0006508",
    "resolved_pwsid": "MI0006508",
    "system_name": "SWIFT LAKE FARMS",
    "display_name": "SWIFT LAKE FARMS",
    "county": "VAN BUREN",
    "monitoring_end_date": "2022-06-30",
    "year": 2022,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006508",
    "resolved_pwsid": "MI0006508",
    "system_name": "SWIFT LAKE FARMS",
    "display_name": "SWIFT LAKE FARMS",
    "county": "VAN BUREN",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 10,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006508",
    "resolved_pwsid": "MI0006508",
    "system_name": "SWIFT LAKE FARMS",
    "display_name": "SWIFT LAKE FARMS",
    "county": "VAN BUREN",
    "monitoring_end_date": "2023-06-30",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006508",
    "resolved_pwsid": "MI0006508",
    "system_name": "SWIFT LAKE FARMS",
    "display_name": "SWIFT LAKE FARMS",
    "county": "VAN BUREN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006508",
    "resolved_pwsid": "MI0006508",
    "system_name": "SWIFT LAKE FARMS",
    "display_name": "SWIFT LAKE FARMS",
    "county": "VAN BUREN",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0006530",
    "resolved_pwsid": "MI0006530",
    "system_name": "SYLVAN LAKE",
    "display_name": "SYLVAN LAKE",
    "county": "OAKLAND",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006530",
    "resolved_pwsid": "MI0006530",
    "system_name": "SYLVAN LAKE",
    "display_name": "SYLVAN LAKE",
    "county": "OAKLAND",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006530",
    "resolved_pwsid": "MI0006530",
    "system_name": "SYLVAN LAKE",
    "display_name": "SYLVAN LAKE",
    "county": "OAKLAND",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006530",
    "resolved_pwsid": "MI0006530",
    "system_name": "SYLVAN LAKE",
    "display_name": "SYLVAN LAKE",
    "county": "OAKLAND",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006530",
    "resolved_pwsid": "MI0006530",
    "system_name": "SYLVAN LAKE",
    "display_name": "SYLVAN LAKE",
    "county": "OAKLAND",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006530",
    "resolved_pwsid": "MI0006530",
    "system_name": "SYLVAN LAKE",
    "display_name": "SYLVAN LAKE",
    "county": "OAKLAND",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006530",
    "resolved_pwsid": "MI0006530",
    "system_name": "SYLVAN LAKE",
    "display_name": "SYLVAN LAKE",
    "county": "OAKLAND",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006530",
    "resolved_pwsid": "MI0006530",
    "system_name": "SYLVAN LAKE",
    "display_name": "SYLVAN LAKE",
    "county": "OAKLAND",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 467,
    "total_to_identify_or_replace": 467,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0006531",
    "resolved_pwsid": "MI0006531",
    "system_name": "SYLVAN TOWNSHIP",
    "display_name": "SYLVAN TOWNSHIP",
    "county": "WASHTENAW",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006531",
    "resolved_pwsid": "MI0006531",
    "system_name": "SYLVAN TOWNSHIP",
    "display_name": "SYLVAN TOWNSHIP",
    "county": "WASHTENAW",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006531",
    "resolved_pwsid": "MI0006531",
    "system_name": "SYLVAN TOWNSHIP",
    "display_name": "SYLVAN TOWNSHIP",
    "county": "WASHTENAW",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006532",
    "resolved_pwsid": "MI0006532",
    "system_name": "TALL OAKS CONDOMINUMS",
    "display_name": "TALL OAKS CONDOMINUMS",
    "county": "MASON",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006532",
    "resolved_pwsid": "MI0006532",
    "system_name": "TALL OAKS CONDOMINUMS",
    "display_name": "TALL OAKS CONDOMINUMS",
    "county": "MASON",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006532",
    "resolved_pwsid": "MI0006532",
    "system_name": "TALL OAKS CONDOMINUMS",
    "display_name": "TALL OAKS CONDOMINUMS",
    "county": "MASON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006532",
    "resolved_pwsid": "MI0006532",
    "system_name": "TALL OAKS CONDOMINUMS",
    "display_name": "TALL OAKS CONDOMINUMS",
    "county": "MASON",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0006537",
    "resolved_pwsid": "MI0006537",
    "system_name": "TANNERY CREEK CONDOMINUM ASSOCIATION",
    "display_name": "TANNERY CREEK CONDOMINUM ASSOCIATION",
    "county": "EMMET",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006537",
    "resolved_pwsid": "MI0006537",
    "system_name": "TANNERY CREEK CONDOMINUM ASSOCIATION",
    "display_name": "TANNERY CREEK CONDOMINUM ASSOCIATION",
    "county": "EMMET",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006537",
    "resolved_pwsid": "MI0006537",
    "system_name": "TANNERY CREEK CONDOMINUM ASSOCIATION",
    "display_name": "TANNERY CREEK CONDOMINUM ASSOCIATION",
    "county": "EMMET",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006537",
    "resolved_pwsid": "MI0006537",
    "system_name": "TANNERY CREEK CONDOMINUM ASSOCIATION",
    "display_name": "TANNERY CREEK CONDOMINUM ASSOCIATION",
    "county": "EMMET",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0006540",
    "resolved_pwsid": "MI0006540",
    "system_name": "TAWAS CITY, CITY OF",
    "display_name": "TAWAS CITY, CITY OF",
    "county": "IOSCO",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006540",
    "resolved_pwsid": "MI0006540",
    "system_name": "TAWAS CITY, CITY OF",
    "display_name": "TAWAS CITY, CITY OF",
    "county": "IOSCO",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006540",
    "resolved_pwsid": "MI0006540",
    "system_name": "TAWAS CITY, CITY OF",
    "display_name": "TAWAS CITY, CITY OF",
    "county": "IOSCO",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006545",
    "resolved_pwsid": "MI0006545",
    "system_name": "TAYLOR",
    "display_name": "TAYLOR",
    "county": "WAYNE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006545",
    "resolved_pwsid": "MI0006545",
    "system_name": "TAYLOR",
    "display_name": "TAYLOR",
    "county": "WAYNE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 11,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006545",
    "resolved_pwsid": "MI0006545",
    "system_name": "TAYLOR",
    "display_name": "TAYLOR",
    "county": "WAYNE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006545",
    "resolved_pwsid": "MI0006545",
    "system_name": "TAYLOR",
    "display_name": "TAYLOR",
    "county": "WAYNE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 11,
    "above_action_level": false,
    "lines_replaced": 7,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006545",
    "resolved_pwsid": "MI0006545",
    "system_name": "TAYLOR",
    "display_name": "TAYLOR",
    "county": "WAYNE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 13,
    "above_action_level": true,
    "lines_replaced": 5,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006545",
    "resolved_pwsid": "MI0006545",
    "system_name": "TAYLOR",
    "display_name": "TAYLOR",
    "county": "WAYNE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": 28,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006545",
    "resolved_pwsid": "MI0006545",
    "system_name": "TAYLOR",
    "display_name": "TAYLOR",
    "county": "WAYNE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 13,
    "above_action_level": true,
    "lines_replaced": 15,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006545",
    "resolved_pwsid": "MI0006545",
    "system_name": "TAYLOR",
    "display_name": "TAYLOR",
    "county": "WAYNE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 16,
    "above_action_level": true,
    "lines_replaced": 27,
    "inventory_lead": 124,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 124,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0006545",
    "resolved_pwsid": "MI0006545",
    "system_name": "TAYLOR",
    "display_name": "TAYLOR",
    "county": "WAYNE",
    "monitoring_end_date": "2026-06-30",
    "year": 2026,
    "lead_90th_ppb": 11,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006552",
    "resolved_pwsid": "MI0006552",
    "system_name": "TAYMOUTH TOWNSHIP",
    "display_name": "TAYMOUTH TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006552",
    "resolved_pwsid": "MI0006552",
    "system_name": "TAYMOUTH TOWNSHIP",
    "display_name": "TAYMOUTH TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006552",
    "resolved_pwsid": "MI0006552",
    "system_name": "TAYMOUTH TOWNSHIP",
    "display_name": "TAYMOUTH TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006552",
    "resolved_pwsid": "MI0006552",
    "system_name": "TAYMOUTH TOWNSHIP",
    "display_name": "TAYMOUTH TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006552",
    "resolved_pwsid": "MI0006552",
    "system_name": "TAYMOUTH TOWNSHIP",
    "display_name": "TAYMOUTH TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006552",
    "resolved_pwsid": "MI0006552",
    "system_name": "TAYMOUTH TOWNSHIP",
    "display_name": "TAYMOUTH TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006552",
    "resolved_pwsid": "MI0006552",
    "system_name": "TAYMOUTH TOWNSHIP",
    "display_name": "TAYMOUTH TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006560",
    "resolved_pwsid": "MI0006560",
    "system_name": "TECUMSEH",
    "display_name": "TECUMSEH",
    "county": "LENAWEE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006560",
    "resolved_pwsid": "MI0006560",
    "system_name": "TECUMSEH",
    "display_name": "TECUMSEH",
    "county": "LENAWEE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006560",
    "resolved_pwsid": "MI0006560",
    "system_name": "TECUMSEH",
    "display_name": "TECUMSEH",
    "county": "LENAWEE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006560",
    "resolved_pwsid": "MI0006560",
    "system_name": "TECUMSEH",
    "display_name": "TECUMSEH",
    "county": "LENAWEE",
    "monitoring_end_date": "",
    "year": 2024,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 2,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006560",
    "resolved_pwsid": "MI0006560",
    "system_name": "TECUMSEH",
    "display_name": "TECUMSEH",
    "county": "LENAWEE",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 8,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006562",
    "resolved_pwsid": "MI0006562",
    "system_name": "TEKONSHA",
    "display_name": "TEKONSHA",
    "county": "CALHOUN",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006562",
    "resolved_pwsid": "MI0006562",
    "system_name": "TEKONSHA",
    "display_name": "TEKONSHA",
    "county": "CALHOUN",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006562",
    "resolved_pwsid": "MI0006562",
    "system_name": "TEKONSHA",
    "display_name": "TEKONSHA",
    "county": "CALHOUN",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006568",
    "resolved_pwsid": "MI0006568",
    "system_name": "MANCELONA AREA WSA - THE CHIEF",
    "display_name": "MANCELONA AREA WSA - THE CHIEF",
    "county": "ANTRIM",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006568",
    "resolved_pwsid": "MI0006568",
    "system_name": "MANCELONA AREA WSA - THE CHIEF",
    "display_name": "MANCELONA AREA WSA - THE CHIEF",
    "county": "ANTRIM",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006568",
    "resolved_pwsid": "MI0006568",
    "system_name": "MANCELONA AREA WSA - THE CHIEF",
    "display_name": "MANCELONA AREA WSA - THE CHIEF",
    "county": "ANTRIM",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006569",
    "resolved_pwsid": "MI0006569",
    "system_name": "THE LIGHTHOUSE-TRAVERSE CITY LLC",
    "display_name": "THE LIGHTHOUSE-TRAVERSE CITY LLC",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006569",
    "resolved_pwsid": "MI0006569",
    "system_name": "THE LIGHTHOUSE-TRAVERSE CITY LLC",
    "display_name": "THE LIGHTHOUSE-TRAVERSE CITY LLC",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006569",
    "resolved_pwsid": "MI0006569",
    "system_name": "THE LIGHTHOUSE-TRAVERSE CITY LLC",
    "display_name": "THE LIGHTHOUSE-TRAVERSE CITY LLC",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006571",
    "resolved_pwsid": "MI0006571",
    "system_name": "THE BLUFFS AT GULL LAKE",
    "display_name": "THE BLUFFS AT GULL LAKE",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006571",
    "resolved_pwsid": "MI0006571",
    "system_name": "THE BLUFFS AT GULL LAKE",
    "display_name": "THE BLUFFS AT GULL LAKE",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0006574",
    "resolved_pwsid": "MI0006574",
    "system_name": "THE SHORES ON CROOKED LAKE",
    "display_name": "THE SHORES ON CROOKED LAKE",
    "county": "EMMET",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006574",
    "resolved_pwsid": "MI0006574",
    "system_name": "THE SHORES ON CROOKED LAKE",
    "display_name": "THE SHORES ON CROOKED LAKE",
    "county": "EMMET",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006574",
    "resolved_pwsid": "MI0006574",
    "system_name": "THE SHORES ON CROOKED LAKE",
    "display_name": "THE SHORES ON CROOKED LAKE",
    "county": "EMMET",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006575",
    "resolved_pwsid": "MI0006575",
    "system_name": "SUGARTREE APARTMENTS",
    "display_name": "SUGARTREE APARTMENTS",
    "county": "GENESEE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006575",
    "resolved_pwsid": "MI0006575",
    "system_name": "SUGARTREE APARTMENTS",
    "display_name": "SUGARTREE APARTMENTS",
    "county": "GENESEE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006575",
    "resolved_pwsid": "MI0006575",
    "system_name": "SUGARTREE APARTMENTS",
    "display_name": "SUGARTREE APARTMENTS",
    "county": "GENESEE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006575",
    "resolved_pwsid": "MI0006575",
    "system_name": "SUGARTREE APARTMENTS",
    "display_name": "SUGARTREE APARTMENTS",
    "county": "GENESEE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 23,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0006575",
    "resolved_pwsid": "MI0006575",
    "system_name": "SUGARTREE APARTMENTS",
    "display_name": "SUGARTREE APARTMENTS",
    "county": "GENESEE",
    "monitoring_end_date": "2026-06-30",
    "year": 2026,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006580",
    "resolved_pwsid": "MI0006580",
    "system_name": "THOMAS TOWNSHIP",
    "display_name": "THOMAS TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006580",
    "resolved_pwsid": "MI0006580",
    "system_name": "THOMAS TOWNSHIP",
    "display_name": "THOMAS TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006580",
    "resolved_pwsid": "MI0006580",
    "system_name": "THOMAS TOWNSHIP",
    "display_name": "THOMAS TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006580",
    "resolved_pwsid": "MI0006580",
    "system_name": "THOMAS TOWNSHIP",
    "display_name": "THOMAS TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006580",
    "resolved_pwsid": "MI0006580",
    "system_name": "THOMAS TOWNSHIP",
    "display_name": "THOMAS TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006580",
    "resolved_pwsid": "MI0006580",
    "system_name": "THOMAS TOWNSHIP",
    "display_name": "THOMAS TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006580",
    "resolved_pwsid": "MI0006580",
    "system_name": "THOMAS TOWNSHIP",
    "display_name": "THOMAS TOWNSHIP",
    "county": "SAGINAW",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006590",
    "resolved_pwsid": "MI0006590",
    "system_name": "THOMPSONVILLE, VILLAGE OF",
    "display_name": "THOMPSONVILLE, VILLAGE OF",
    "county": "BENZIE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006590",
    "resolved_pwsid": "MI0006590",
    "system_name": "THOMPSONVILLE, VILLAGE OF",
    "display_name": "THOMPSONVILLE, VILLAGE OF",
    "county": "BENZIE",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006590",
    "resolved_pwsid": "MI0006590",
    "system_name": "THOMPSONVILLE, VILLAGE OF",
    "display_name": "THOMPSONVILLE, VILLAGE OF",
    "county": "BENZIE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006590",
    "resolved_pwsid": "MI0006590",
    "system_name": "THOMPSONVILLE, VILLAGE OF",
    "display_name": "THOMPSONVILLE, VILLAGE OF",
    "county": "BENZIE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006590",
    "resolved_pwsid": "MI0006590",
    "system_name": "THOMPSONVILLE, VILLAGE OF",
    "display_name": "THOMPSONVILLE, VILLAGE OF",
    "county": "BENZIE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006590",
    "resolved_pwsid": "MI0006590",
    "system_name": "THOMPSONVILLE, VILLAGE OF",
    "display_name": "THOMPSONVILLE, VILLAGE OF",
    "county": "BENZIE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006590",
    "resolved_pwsid": "MI0006590",
    "system_name": "THOMPSONVILLE, VILLAGE OF",
    "display_name": "THOMPSONVILLE, VILLAGE OF",
    "county": "BENZIE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006590",
    "resolved_pwsid": "MI0006590",
    "system_name": "THOMPSONVILLE, VILLAGE OF",
    "display_name": "THOMPSONVILLE, VILLAGE OF",
    "county": "BENZIE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006590",
    "resolved_pwsid": "MI0006590",
    "system_name": "THOMPSONVILLE, VILLAGE OF",
    "display_name": "THOMPSONVILLE, VILLAGE OF",
    "county": "BENZIE",
    "monitoring_end_date": "2026-06-30",
    "year": 2026,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006592",
    "resolved_pwsid": "MI0006592",
    "system_name": "THORN CREEK CONDOMINIUMS",
    "display_name": "THORN CREEK CONDOMINIUMS",
    "county": "LEELANAU",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006592",
    "resolved_pwsid": "MI0006592",
    "system_name": "THORN CREEK CONDOMINIUMS",
    "display_name": "THORN CREEK CONDOMINIUMS",
    "county": "LEELANAU",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006592",
    "resolved_pwsid": "MI0006592",
    "system_name": "THORN CREEK CONDOMINIUMS",
    "display_name": "THORN CREEK CONDOMINIUMS",
    "county": "LEELANAU",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006592",
    "resolved_pwsid": "MI0006592",
    "system_name": "THORN CREEK CONDOMINIUMS",
    "display_name": "THORN CREEK CONDOMINIUMS",
    "county": "LEELANAU",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0006594",
    "resolved_pwsid": "MI0006594",
    "system_name": "THORNTON FARMS",
    "display_name": "THORNTON FARMS",
    "county": "WASHTENAW",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006594",
    "resolved_pwsid": "MI0006594",
    "system_name": "THORNTON FARMS",
    "display_name": "THORNTON FARMS",
    "county": "WASHTENAW",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006594",
    "resolved_pwsid": "MI0006594",
    "system_name": "THORNTON FARMS",
    "display_name": "THORNTON FARMS",
    "county": "WASHTENAW",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006600",
    "resolved_pwsid": "MI0006600",
    "system_name": "THREE OAKS",
    "display_name": "THREE OAKS",
    "county": "BERRIEN",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006600",
    "resolved_pwsid": "MI0006600",
    "system_name": "THREE OAKS",
    "display_name": "THREE OAKS",
    "county": "BERRIEN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 14,
    "above_action_level": true,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006600",
    "resolved_pwsid": "MI0006600",
    "system_name": "THREE OAKS",
    "display_name": "THREE OAKS",
    "county": "BERRIEN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006600",
    "resolved_pwsid": "MI0006600",
    "system_name": "THREE OAKS",
    "display_name": "THREE OAKS",
    "county": "BERRIEN",
    "monitoring_end_date": "",
    "year": 2022,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006600",
    "resolved_pwsid": "MI0006600",
    "system_name": "THREE OAKS",
    "display_name": "THREE OAKS",
    "county": "BERRIEN",
    "monitoring_end_date": "",
    "year": 2023,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006610",
    "resolved_pwsid": "MI0006610",
    "system_name": "THREE RIVERS",
    "display_name": "THREE RIVERS",
    "county": "ST JOSEPH",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006610",
    "resolved_pwsid": "MI0006610",
    "system_name": "THREE RIVERS",
    "display_name": "THREE RIVERS",
    "county": "ST JOSEPH",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006610",
    "resolved_pwsid": "MI0006610",
    "system_name": "THREE RIVERS",
    "display_name": "THREE RIVERS",
    "county": "ST. JOSEPH",
    "monitoring_end_date": "2023-06-30",
    "year": 2023,
    "lead_90th_ppb": 19,
    "above_action_level": true,
    "lines_replaced": 2,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006610",
    "resolved_pwsid": "MI0006610",
    "system_name": "THREE RIVERS",
    "display_name": "THREE RIVERS",
    "county": "ST. JOSEPH",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 16,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006610",
    "resolved_pwsid": "MI0006610",
    "system_name": "THREE RIVERS",
    "display_name": "THREE RIVERS",
    "county": "ST. JOSEPH",
    "monitoring_end_date": "2024-06-30",
    "year": 2024,
    "lead_90th_ppb": 28,
    "above_action_level": true,
    "lines_replaced": 4,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006610",
    "resolved_pwsid": "MI0006610",
    "system_name": "THREE RIVERS",
    "display_name": "THREE RIVERS",
    "county": "ST. JOSEPH",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006610",
    "resolved_pwsid": "MI0006610",
    "system_name": "THREE RIVERS",
    "display_name": "THREE RIVERS",
    "county": "ST. JOSEPH",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 12,
    "above_action_level": false,
    "lines_replaced": 30,
    "inventory_lead": 1420,
    "inventory_gpcl": 83,
    "inventory_unknown": 39,
    "total_to_identify_or_replace": 1542,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0006610",
    "resolved_pwsid": "MI0006610",
    "system_name": "THREE RIVERS",
    "display_name": "THREE RIVERS",
    "county": "ST. JOSEPH",
    "monitoring_end_date": "2026-06-30",
    "year": 2026,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006610",
    "resolved_pwsid": "MI0006610",
    "system_name": "THREE RIVERS",
    "display_name": "THREE RIVERS",
    "county": "ST JOSEPH",
    "monitoring_end_date": "",
    "year": 2022,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006624",
    "resolved_pwsid": "MI0006624",
    "system_name": "TILLICUM FARMS",
    "display_name": "TILLICUM FARMS",
    "county": "KENT",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006624",
    "resolved_pwsid": "MI0006624",
    "system_name": "TILLICUM FARMS",
    "display_name": "TILLICUM FARMS",
    "county": "KENT",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006624",
    "resolved_pwsid": "MI0006624",
    "system_name": "TILLICUM FARMS",
    "display_name": "TILLICUM FARMS",
    "county": "KENT",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006624",
    "resolved_pwsid": "MI0006624",
    "system_name": "TILLICUM FARMS",
    "display_name": "TILLICUM FARMS",
    "county": "KENT",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006625",
    "resolved_pwsid": "MI0006625",
    "system_name": "ELMWOOD TWP - TIMBERLEE",
    "display_name": "ELMWOOD TWP - TIMBERLEE",
    "county": "LEELANAU",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006625",
    "resolved_pwsid": "MI0006625",
    "system_name": "ELMWOOD TWP - TIMBERLEE",
    "display_name": "ELMWOOD TWP - TIMBERLEE",
    "county": "LEELANAU",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006625",
    "resolved_pwsid": "MI0006625",
    "system_name": "ELMWOOD TWP - TIMBERLEE",
    "display_name": "ELMWOOD TWP - TIMBERLEE",
    "county": "LEELANAU",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006627",
    "resolved_pwsid": "MI0006627",
    "system_name": "BEECHWOOD HILLS - TIMBER RIDGE",
    "display_name": "BEECHWOOD HILLS - TIMBER RIDGE",
    "county": "BERRIEN",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006627",
    "resolved_pwsid": "MI0006627",
    "system_name": "BEECHWOOD HILLS - TIMBER RIDGE",
    "display_name": "BEECHWOOD HILLS - TIMBER RIDGE",
    "county": "BERRIEN",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006627",
    "resolved_pwsid": "MI0006627",
    "system_name": "BEECHWOOD HILLS - TIMBER RIDGE",
    "display_name": "BEECHWOOD HILLS - TIMBER RIDGE",
    "county": "BERRIEN",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006630",
    "resolved_pwsid": "MI0006630",
    "system_name": "CRYSTAL FALLS TWP - TOWNLINE",
    "display_name": "CRYSTAL FALLS TWP - TOWNLINE",
    "county": "IRON",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 13,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006630",
    "resolved_pwsid": "MI0006630",
    "system_name": "CRYSTAL FALLS TWP - TOWNLINE",
    "display_name": "CRYSTAL FALLS TWP - TOWNLINE",
    "county": "IRON",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006630",
    "resolved_pwsid": "MI0006630",
    "system_name": "CRYSTAL FALLS TWP - TOWNLINE",
    "display_name": "CRYSTAL FALLS TWP - TOWNLINE",
    "county": "IRON",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006630",
    "resolved_pwsid": "MI0006630",
    "system_name": "CRYSTAL FALLS TWP - TOWNLINE",
    "display_name": "CRYSTAL FALLS TWP - TOWNLINE",
    "county": "IRON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006630",
    "resolved_pwsid": "MI0006630",
    "system_name": "CRYSTAL FALLS TWP - TOWNLINE",
    "display_name": "CRYSTAL FALLS TWP - TOWNLINE",
    "county": "IRON",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006630",
    "resolved_pwsid": "MI0006630",
    "system_name": "CRYSTAL FALLS TWP - TOWNLINE",
    "display_name": "CRYSTAL FALLS TWP - TOWNLINE",
    "county": "IRON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006630",
    "resolved_pwsid": "MI0006630",
    "system_name": "CRYSTAL FALLS TWP - TOWNLINE",
    "display_name": "CRYSTAL FALLS TWP - TOWNLINE",
    "county": "IRON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 9,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006630",
    "resolved_pwsid": "MI0006630",
    "system_name": "CRYSTAL FALLS TWP - TOWNLINE",
    "display_name": "CRYSTAL FALLS TWP - TOWNLINE",
    "county": "IRON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": 2,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006630",
    "resolved_pwsid": "MI0006630",
    "system_name": "CRYSTAL FALLS TWP - TOWNLINE",
    "display_name": "CRYSTAL FALLS TWP - TOWNLINE",
    "county": "IRON",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": 21,
    "inventory_gpcl": 0,
    "inventory_unknown": 217,
    "total_to_identify_or_replace": 238,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0006631",
    "resolved_pwsid": "MI0006631",
    "system_name": "MILL STREET 1 LDHA",
    "display_name": "MILL STREET 1 LDHA",
    "county": "EMMET",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006631",
    "resolved_pwsid": "MI0006631",
    "system_name": "MILL STREET 1 LDHA",
    "display_name": "MILL STREET 1 LDHA",
    "county": "EMMET",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006631",
    "resolved_pwsid": "MI0006631",
    "system_name": "MILL STREET 1 LDHA",
    "display_name": "MILL STREET 1 LDHA",
    "county": "EMMET",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006640",
    "resolved_pwsid": "MI0006640-b",
    "system_name": "TRAVERSE CITY, CITY OF",
    "display_name": "TRAVERSE CITY, CITY OF",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006640",
    "resolved_pwsid": "MI0006640-a",
    "system_name": "TRAVERSE CITY",
    "display_name": "TRAVERSE CITY",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006640",
    "resolved_pwsid": "MI0006640-b",
    "system_name": "TRAVERSE CITY, CITY OF",
    "display_name": "TRAVERSE CITY, CITY OF",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006640",
    "resolved_pwsid": "MI0006640-a",
    "system_name": "TRAVERSE CITY",
    "display_name": "TRAVERSE CITY",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": 26,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006640",
    "resolved_pwsid": "MI0006640-a",
    "system_name": "TRAVERSE CITY",
    "display_name": "TRAVERSE CITY",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": 223,
    "inventory_lead": 2,
    "inventory_gpcl": 350,
    "inventory_unknown": 1239,
    "total_to_identify_or_replace": 1591,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0006640",
    "resolved_pwsid": "MI0006640",
    "system_name": "TRAVERSE CITY, CITY OF",
    "display_name": "TRAVERSE CITY, CITY OF",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "",
    "year": 2021,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 21,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006640",
    "resolved_pwsid": "MI0006640",
    "system_name": "TRAVERSE CITY, CITY OF",
    "display_name": "TRAVERSE CITY, CITY OF",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "",
    "year": 2023,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 125,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006640",
    "resolved_pwsid": "MI0006640",
    "system_name": "TRAVERSE CITY, CITY OF",
    "display_name": "TRAVERSE CITY, CITY OF",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "",
    "year": 2024,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 217,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006647",
    "resolved_pwsid": "MI0006647",
    "system_name": "TREETOPS RESORT (TREETOPS NORTH)",
    "display_name": "TREETOPS RESORT (TREETOPS NORTH)",
    "county": "OTSEGO",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006647",
    "resolved_pwsid": "MI0006647",
    "system_name": "TREETOPS RESORT (TREETOPS NORTH)",
    "display_name": "TREETOPS RESORT (TREETOPS NORTH)",
    "county": "OTSEGO",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006647",
    "resolved_pwsid": "MI0006647",
    "system_name": "TREETOPS RESORT (TREETOPS NORTH)",
    "display_name": "TREETOPS RESORT (TREETOPS NORTH)",
    "county": "OTSEGO",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 15,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006650",
    "resolved_pwsid": "MI0006650",
    "system_name": "TRENTON",
    "display_name": "TRENTON",
    "county": "WAYNE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006650",
    "resolved_pwsid": "MI0006650",
    "system_name": "TRENTON",
    "display_name": "TRENTON",
    "county": "WAYNE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006650",
    "resolved_pwsid": "MI0006650",
    "system_name": "TRENTON",
    "display_name": "TRENTON",
    "county": "WAYNE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 11,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006650",
    "resolved_pwsid": "MI0006650",
    "system_name": "TRENTON",
    "display_name": "TRENTON",
    "county": "WAYNE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": 10,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006650",
    "resolved_pwsid": "MI0006650",
    "system_name": "TRENTON",
    "display_name": "TRENTON",
    "county": "WAYNE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": 14,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006650",
    "resolved_pwsid": "MI0006650",
    "system_name": "TRENTON",
    "display_name": "TRENTON",
    "county": "WAYNE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 9,
    "above_action_level": false,
    "lines_replaced": 9,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006650",
    "resolved_pwsid": "MI0006650",
    "system_name": "TRENTON",
    "display_name": "TRENTON",
    "county": "WAYNE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": 3,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006650",
    "resolved_pwsid": "MI0006650",
    "system_name": "TRENTON",
    "display_name": "TRENTON",
    "county": "WAYNE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": 20,
    "inventory_lead": 155,
    "inventory_gpcl": 4,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 159,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006680",
    "resolved_pwsid": "MI0006680",
    "system_name": "INTERIOR TOWNSHIP",
    "display_name": "INTERIOR TOWNSHIP",
    "county": "ONTONAGON",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006680",
    "resolved_pwsid": "MI0006680",
    "system_name": "INTERIOR TOWNSHIP",
    "display_name": "INTERIOR TOWNSHIP",
    "county": "ONTONAGON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006680",
    "resolved_pwsid": "MI0006680",
    "system_name": "INTERIOR TOWNSHIP",
    "display_name": "INTERIOR TOWNSHIP",
    "county": "ONTONAGON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006682",
    "resolved_pwsid": "MI0006682",
    "system_name": "TROUT CREEK CONDOMINIUMS",
    "display_name": "TROUT CREEK CONDOMINIUMS",
    "county": "EMMET",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 10,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006682",
    "resolved_pwsid": "MI0006682",
    "system_name": "TROUT CREEK CONDOMINIUMS",
    "display_name": "TROUT CREEK CONDOMINIUMS",
    "county": "EMMET",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006682",
    "resolved_pwsid": "MI0006682",
    "system_name": "TROUT CREEK CONDOMINIUMS",
    "display_name": "TROUT CREEK CONDOMINIUMS",
    "county": "EMMET",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006690",
    "resolved_pwsid": "MI0006690",
    "system_name": "TROY",
    "display_name": "TROY",
    "county": "OAKLAND",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006690",
    "resolved_pwsid": "MI0006690",
    "system_name": "TROY",
    "display_name": "TROY",
    "county": "OAKLAND",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006690",
    "resolved_pwsid": "MI0006690",
    "system_name": "TROY",
    "display_name": "TROY",
    "county": "OAKLAND",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006690",
    "resolved_pwsid": "MI0006690",
    "system_name": "TROY",
    "display_name": "TROY",
    "county": "OAKLAND",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006690",
    "resolved_pwsid": "MI0006690",
    "system_name": "TROY",
    "display_name": "TROY",
    "county": "OAKLAND",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006690",
    "resolved_pwsid": "MI0006690",
    "system_name": "TROY",
    "display_name": "TROY",
    "county": "OAKLAND",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006690",
    "resolved_pwsid": "MI0006690",
    "system_name": "TROY",
    "display_name": "TROY",
    "county": "OAKLAND",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006690",
    "resolved_pwsid": "MI0006690",
    "system_name": "TROY",
    "display_name": "TROY",
    "county": "OAKLAND",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0006693",
    "resolved_pwsid": "MI0006693",
    "system_name": "TULLYMORE CLUBHOUSE AND CAMELOT VILLAGE",
    "display_name": "TULLYMORE CLUBHOUSE AND CAMELOT VILLAGE",
    "county": "MECOSTA",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006693",
    "resolved_pwsid": "MI0006693",
    "system_name": "TULLYMORE CLUBHOUSE AND CAMELOT VILLAGE",
    "display_name": "TULLYMORE CLUBHOUSE AND CAMELOT VILLAGE",
    "county": "MECOSTA",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006693",
    "resolved_pwsid": "MI0006693",
    "system_name": "TULLYMORE CLUBHOUSE AND CAMELOT VILLAGE",
    "display_name": "TULLYMORE CLUBHOUSE AND CAMELOT VILLAGE",
    "county": "MECOSTA",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006696",
    "resolved_pwsid": "MI0006696",
    "system_name": "TWIN LAKES SUBDIVISION",
    "display_name": "TWIN LAKES SUBDIVISION",
    "county": "OAKLAND",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006696",
    "resolved_pwsid": "MI0006696",
    "system_name": "TWIN LAKES SUBDIVISION",
    "display_name": "TWIN LAKES SUBDIVISION",
    "county": "OAKLAND",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006696",
    "resolved_pwsid": "MI0006696",
    "system_name": "TWIN LAKES SUBDIVISION",
    "display_name": "TWIN LAKES SUBDIVISION",
    "county": "OAKLAND",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006696",
    "resolved_pwsid": "MI0006696",
    "system_name": "TWIN LAKES SUBDIVISION",
    "display_name": "TWIN LAKES SUBDIVISION",
    "county": "OAKLAND",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006696",
    "resolved_pwsid": "MI0006696",
    "system_name": "TWIN LAKES SUBDIVISION",
    "display_name": "TWIN LAKES SUBDIVISION",
    "county": "OAKLAND",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006696",
    "resolved_pwsid": "MI0006696",
    "system_name": "TWIN LAKES SUBDIVISION",
    "display_name": "TWIN LAKES SUBDIVISION",
    "county": "OAKLAND",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006696",
    "resolved_pwsid": "MI0006696",
    "system_name": "TWIN LAKES SUBDIVISION",
    "display_name": "TWIN LAKES SUBDIVISION",
    "county": "OAKLAND",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006696",
    "resolved_pwsid": "MI0006696",
    "system_name": "TWIN LAKES SUBDIVISION",
    "display_name": "TWIN LAKES SUBDIVISION",
    "county": "OAKLAND",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0006710",
    "resolved_pwsid": "MI0006710",
    "system_name": "UBLY, VILLAGE OF",
    "display_name": "UBLY, VILLAGE OF",
    "county": "HURON",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006710",
    "resolved_pwsid": "MI0006710",
    "system_name": "UBLY, VILLAGE OF",
    "display_name": "UBLY, VILLAGE OF",
    "county": "HURON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006710",
    "resolved_pwsid": "MI0006710",
    "system_name": "UBLY, VILLAGE OF",
    "display_name": "UBLY, VILLAGE OF",
    "county": "HURON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006720",
    "resolved_pwsid": "MI0006720",
    "system_name": "UNION CITY",
    "display_name": "UNION CITY",
    "county": "BRANCH",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006720",
    "resolved_pwsid": "MI0006720",
    "system_name": "UNION CITY",
    "display_name": "UNION CITY",
    "county": "BRANCH",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006720",
    "resolved_pwsid": "MI0006720",
    "system_name": "UNION CITY",
    "display_name": "UNION CITY",
    "county": "BRANCH",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 11,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006720",
    "resolved_pwsid": "MI0006720",
    "system_name": "UNION CITY",
    "display_name": "UNION CITY",
    "county": "BRANCH",
    "monitoring_end_date": "",
    "year": 2022,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 5,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006720",
    "resolved_pwsid": "MI0006720",
    "system_name": "UNION CITY",
    "display_name": "UNION CITY",
    "county": "BRANCH",
    "monitoring_end_date": "",
    "year": 2023,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 4,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006725",
    "resolved_pwsid": "MI0006725",
    "system_name": "UNION TOWNSHIP",
    "display_name": "UNION TOWNSHIP",
    "county": "ISABELLA",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006725",
    "resolved_pwsid": "MI0006725",
    "system_name": "UNION TOWNSHIP",
    "display_name": "UNION TOWNSHIP",
    "county": "ISABELLA",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006725",
    "resolved_pwsid": "MI0006725",
    "system_name": "UNION TOWNSHIP",
    "display_name": "UNION TOWNSHIP",
    "county": "ISABELLA",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006725",
    "resolved_pwsid": "MI0006725",
    "system_name": "UNION TOWNSHIP",
    "display_name": "UNION TOWNSHIP",
    "county": "ISABELLA",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006730",
    "resolved_pwsid": "MI0006730",
    "system_name": "UNIONVILLE, VILLAGE OF",
    "display_name": "UNIONVILLE, VILLAGE OF",
    "county": "TUSCOLA",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006730",
    "resolved_pwsid": "MI0006730",
    "system_name": "UNIONVILLE, VILLAGE OF",
    "display_name": "UNIONVILLE, VILLAGE OF",
    "county": "TUSCOLA",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006730",
    "resolved_pwsid": "MI0006730",
    "system_name": "UNIONVILLE, VILLAGE OF",
    "display_name": "UNIONVILLE, VILLAGE OF",
    "county": "TUSCOLA",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006760",
    "resolved_pwsid": "MI0006760",
    "system_name": "UTICA, CITY OF",
    "display_name": "UTICA, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006760",
    "resolved_pwsid": "MI0006760",
    "system_name": "UTICA, CITY OF",
    "display_name": "UTICA, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006760",
    "resolved_pwsid": "MI0006760",
    "system_name": "UTICA, CITY OF",
    "display_name": "UTICA, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006760",
    "resolved_pwsid": "MI0006760",
    "system_name": "UTICA, CITY OF",
    "display_name": "UTICA, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 11,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006760",
    "resolved_pwsid": "MI0006760",
    "system_name": "UTICA, CITY OF",
    "display_name": "UTICA, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006760",
    "resolved_pwsid": "MI0006760",
    "system_name": "UTICA, CITY OF",
    "display_name": "UTICA, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006760",
    "resolved_pwsid": "MI0006760",
    "system_name": "UTICA, CITY OF",
    "display_name": "UTICA, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006760",
    "resolved_pwsid": "MI0006760",
    "system_name": "UTICA, CITY OF",
    "display_name": "UTICA, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 94,
    "inventory_lead": 6,
    "inventory_gpcl": 99,
    "inventory_unknown": 1312,
    "total_to_identify_or_replace": 1417,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0006763",
    "resolved_pwsid": "MI0006763",
    "system_name": "VALLEY SIDE APARTMENTS",
    "display_name": "VALLEY SIDE APARTMENTS",
    "county": "MANISTEE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006763",
    "resolved_pwsid": "MI0006763",
    "system_name": "VALLEY SIDE APARTMENTS",
    "display_name": "VALLEY SIDE APARTMENTS",
    "county": "MANISTEE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006763",
    "resolved_pwsid": "MI0006763",
    "system_name": "VALLEY SIDE APARTMENTS",
    "display_name": "VALLEY SIDE APARTMENTS",
    "county": "MANISTEE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006765",
    "resolved_pwsid": "MI0006765",
    "system_name": "VALLEYWOOD COVE CONDOMINIUM ASSOCIATION",
    "display_name": "VALLEYWOOD COVE CONDOMINIUM ASSOCIATION",
    "county": "MANISTEE",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006765",
    "resolved_pwsid": "MI0006765",
    "system_name": "VALLEYWOOD COVE CONDOMINIUM ASSOCIATION",
    "display_name": "VALLEYWOOD COVE CONDOMINIUM ASSOCIATION",
    "county": "MANISTEE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006765",
    "resolved_pwsid": "MI0006765",
    "system_name": "VALLEYWOOD COVE CONDOMINIUM ASSOCIATION",
    "display_name": "VALLEYWOOD COVE CONDOMINIUM ASSOCIATION",
    "county": "MANISTEE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006765",
    "resolved_pwsid": "MI0006765",
    "system_name": "VALLEYWOOD COVE CONDOMINIUM ASSOCIATION",
    "display_name": "VALLEYWOOD COVE CONDOMINIUM ASSOCIATION",
    "county": "MANISTEE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0006770",
    "resolved_pwsid": "MI0006770",
    "system_name": "VAN BUREN TOWNSHIP",
    "display_name": "VAN BUREN TOWNSHIP",
    "county": "WAYNE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006770",
    "resolved_pwsid": "MI0006770",
    "system_name": "VAN BUREN TOWNSHIP",
    "display_name": "VAN BUREN TOWNSHIP",
    "county": "WAYNE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006770",
    "resolved_pwsid": "MI0006770",
    "system_name": "VAN BUREN TOWNSHIP",
    "display_name": "VAN BUREN TOWNSHIP",
    "county": "WAYNE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006770",
    "resolved_pwsid": "MI0006770",
    "system_name": "VAN BUREN TOWNSHIP",
    "display_name": "VAN BUREN TOWNSHIP",
    "county": "WAYNE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006770",
    "resolved_pwsid": "MI0006770",
    "system_name": "VAN BUREN TOWNSHIP",
    "display_name": "VAN BUREN TOWNSHIP",
    "county": "WAYNE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006770",
    "resolved_pwsid": "MI0006770",
    "system_name": "VAN BUREN TOWNSHIP",
    "display_name": "VAN BUREN TOWNSHIP",
    "county": "WAYNE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006770",
    "resolved_pwsid": "MI0006770",
    "system_name": "VAN BUREN TOWNSHIP",
    "display_name": "VAN BUREN TOWNSHIP",
    "county": "WAYNE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006770",
    "resolved_pwsid": "MI0006770",
    "system_name": "VAN BUREN TOWNSHIP",
    "display_name": "VAN BUREN TOWNSHIP",
    "county": "WAYNE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 24,
    "total_to_identify_or_replace": 24,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0006773",
    "resolved_pwsid": "MI0006773",
    "system_name": "HORSELL MANOR",
    "display_name": "HORSELL MANOR",
    "county": "OTSEGO",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006773",
    "resolved_pwsid": "MI0006773",
    "system_name": "HORSELL MANOR",
    "display_name": "HORSELL MANOR",
    "county": "OTSEGO",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006773",
    "resolved_pwsid": "MI0006773",
    "system_name": "HORSELL MANOR",
    "display_name": "HORSELL MANOR",
    "county": "OTSEGO",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006773",
    "resolved_pwsid": "MI0006773",
    "system_name": "HORSELL MANOR",
    "display_name": "HORSELL MANOR",
    "county": "OTSEGO",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0006780",
    "resolved_pwsid": "MI0006780",
    "system_name": "VASSAR, CITY OF",
    "display_name": "VASSAR, CITY OF",
    "county": "TUSCOLA",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006780",
    "resolved_pwsid": "MI0006780",
    "system_name": "VASSAR, CITY OF",
    "display_name": "VASSAR, CITY OF",
    "county": "TUSCOLA",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006780",
    "resolved_pwsid": "MI0006780",
    "system_name": "VASSAR, CITY OF",
    "display_name": "VASSAR, CITY OF",
    "county": "TUSCOLA",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006780",
    "resolved_pwsid": "MI0006780",
    "system_name": "VASSAR, CITY OF",
    "display_name": "VASSAR, CITY OF",
    "county": "TUSCOLA",
    "monitoring_end_date": "",
    "year": 2024,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 4,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006780",
    "resolved_pwsid": "MI0006780",
    "system_name": "VASSAR, CITY OF",
    "display_name": "VASSAR, CITY OF",
    "county": "TUSCOLA",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 4,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006790",
    "resolved_pwsid": "MI0006790",
    "system_name": "VERMONTVILLE, VILLAGE OF",
    "display_name": "VERMONTVILLE, VILLAGE OF",
    "county": "EATON",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006790",
    "resolved_pwsid": "MI0006790",
    "system_name": "VERMONTVILLE, VILLAGE OF",
    "display_name": "VERMONTVILLE, VILLAGE OF",
    "county": "EATON",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006790",
    "resolved_pwsid": "MI0006790",
    "system_name": "VERMONTVILLE, VILLAGE OF",
    "display_name": "VERMONTVILLE, VILLAGE OF",
    "county": "EATON",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006790",
    "resolved_pwsid": "MI0006790",
    "system_name": "VERMONTVILLE, VILLAGE OF",
    "display_name": "VERMONTVILLE, VILLAGE OF",
    "county": "EATON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006790",
    "resolved_pwsid": "MI0006790",
    "system_name": "VERMONTVILLE, VILLAGE OF",
    "display_name": "VERMONTVILLE, VILLAGE OF",
    "county": "EATON",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006790",
    "resolved_pwsid": "MI0006790",
    "system_name": "VERMONTVILLE, VILLAGE OF",
    "display_name": "VERMONTVILLE, VILLAGE OF",
    "county": "EATON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006790",
    "resolved_pwsid": "MI0006790",
    "system_name": "VERMONTVILLE, VILLAGE OF",
    "display_name": "VERMONTVILLE, VILLAGE OF",
    "county": "EATON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006790",
    "resolved_pwsid": "MI0006790",
    "system_name": "VERMONTVILLE, VILLAGE OF",
    "display_name": "VERMONTVILLE, VILLAGE OF",
    "county": "EATON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006790",
    "resolved_pwsid": "MI0006790",
    "system_name": "VERMONTVILLE, VILLAGE OF",
    "display_name": "VERMONTVILLE, VILLAGE OF",
    "county": "EATON",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0006790",
    "resolved_pwsid": "MI0006790",
    "system_name": "VERMONTVILLE, VILLAGE OF",
    "display_name": "VERMONTVILLE, VILLAGE OF",
    "county": "EATON",
    "monitoring_end_date": "2026-06-30",
    "year": 2026,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006792",
    "resolved_pwsid": "MI0006792",
    "system_name": "V F W NATIONAL HOME",
    "display_name": "V F W NATIONAL HOME",
    "county": "INGHAM",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006792",
    "resolved_pwsid": "MI0006792",
    "system_name": "V F W NATIONAL HOME",
    "display_name": "V F W NATIONAL HOME",
    "county": "INGHAM",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006792",
    "resolved_pwsid": "MI0006792",
    "system_name": "V F W NATIONAL HOME",
    "display_name": "V F W NATIONAL HOME",
    "county": "INGHAM",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006792",
    "resolved_pwsid": "MI0006792",
    "system_name": "V F W NATIONAL HOME",
    "display_name": "V F W NATIONAL HOME",
    "county": "INGHAM",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006792",
    "resolved_pwsid": "MI0006792",
    "system_name": "V F W NATIONAL HOME",
    "display_name": "V F W NATIONAL HOME",
    "county": "INGHAM",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006792",
    "resolved_pwsid": "MI0006792",
    "system_name": "V F W NATIONAL HOME",
    "display_name": "V F W NATIONAL HOME",
    "county": "INGHAM",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006792",
    "resolved_pwsid": "MI0006792",
    "system_name": "V F W NATIONAL HOME",
    "display_name": "V F W NATIONAL HOME",
    "county": "INGHAM",
    "monitoring_end_date": "2024-06-30",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006792",
    "resolved_pwsid": "MI0006792",
    "system_name": "V F W NATIONAL HOME",
    "display_name": "V F W NATIONAL HOME",
    "county": "INGHAM",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006792",
    "resolved_pwsid": "MI0006792",
    "system_name": "V F W NATIONAL HOME",
    "display_name": "V F W NATIONAL HOME",
    "county": "INGHAM",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0006800",
    "resolved_pwsid": "MI0006800",
    "system_name": "VICKSBURG",
    "display_name": "VICKSBURG",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006800",
    "resolved_pwsid": "MI0006800",
    "system_name": "VICKSBURG",
    "display_name": "VICKSBURG",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006800",
    "resolved_pwsid": "MI0006800",
    "system_name": "VICKSBURG",
    "display_name": "VICKSBURG",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 13,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006800",
    "resolved_pwsid": "MI0006800",
    "system_name": "VICKSBURG",
    "display_name": "VICKSBURG",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": 58,
    "inventory_lead": 272,
    "inventory_gpcl": 74,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 346,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0006800",
    "resolved_pwsid": "MI0006800",
    "system_name": "VICKSBURG",
    "display_name": "VICKSBURG",
    "county": "KALAMAZOO",
    "monitoring_end_date": "",
    "year": 2021,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 59,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006800",
    "resolved_pwsid": "MI0006800",
    "system_name": "VICKSBURG",
    "display_name": "VICKSBURG",
    "county": "KALAMAZOO",
    "monitoring_end_date": "",
    "year": 2023,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006800",
    "resolved_pwsid": "MI0006800",
    "system_name": "VICKSBURG",
    "display_name": "VICKSBURG",
    "county": "KALAMAZOO",
    "monitoring_end_date": "",
    "year": 2024,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 8,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006803",
    "resolved_pwsid": "MI0006803",
    "system_name": "VILLA NOUVA ASSOCIATION",
    "display_name": "VILLA NOUVA ASSOCIATION",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006803",
    "resolved_pwsid": "MI0006803",
    "system_name": "VILLA NOUVA ASSOCIATION",
    "display_name": "VILLA NOUVA ASSOCIATION",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006803",
    "resolved_pwsid": "MI0006803",
    "system_name": "VILLA NOUVA ASSOCIATION",
    "display_name": "VILLA NOUVA ASSOCIATION",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006820",
    "resolved_pwsid": "MI0006820",
    "system_name": "WOODLAND CENTER CORRECTIONAL FACILITY",
    "display_name": "WOODLAND CENTER CORRECTIONAL FACILITY",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006820",
    "resolved_pwsid": "MI0006820",
    "system_name": "WOODLAND CENTER CORRECTIONAL FACILITY",
    "display_name": "WOODLAND CENTER CORRECTIONAL FACILITY",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 15,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006820",
    "resolved_pwsid": "MI0006820",
    "system_name": "WOODLAND CENTER CORRECTIONAL FACILITY",
    "display_name": "WOODLAND CENTER CORRECTIONAL FACILITY",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006820",
    "resolved_pwsid": "MI0006820",
    "system_name": "WOODLAND CENTER CORRECTIONAL FACILITY",
    "display_name": "WOODLAND CENTER CORRECTIONAL FACILITY",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006830",
    "resolved_pwsid": "MI0006830",
    "system_name": "WAKEFIELD",
    "display_name": "WAKEFIELD",
    "county": "GOGEBIC",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006830",
    "resolved_pwsid": "MI0006830",
    "system_name": "WAKEFIELD",
    "display_name": "WAKEFIELD",
    "county": "GOGEBIC",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006830",
    "resolved_pwsid": "MI0006830",
    "system_name": "WAKEFIELD",
    "display_name": "WAKEFIELD",
    "county": "GOGEBIC",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006830",
    "resolved_pwsid": "MI0006830",
    "system_name": "WAKEFIELD",
    "display_name": "WAKEFIELD",
    "county": "GOGEBIC",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 17,
    "inventory_gpcl": 2,
    "inventory_unknown": 3,
    "total_to_identify_or_replace": 22,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0006830",
    "resolved_pwsid": "MI0006830",
    "system_name": "WAKEFIELD",
    "display_name": "WAKEFIELD",
    "county": "GOGEBIC",
    "monitoring_end_date": "",
    "year": 2024,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 14,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006850",
    "resolved_pwsid": "MI0006850",
    "system_name": "WALDRON",
    "display_name": "WALDRON",
    "county": "HILLSDALE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006850",
    "resolved_pwsid": "MI0006850",
    "system_name": "WALDRON",
    "display_name": "WALDRON",
    "county": "HILLSDALE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006850",
    "resolved_pwsid": "MI0006850",
    "system_name": "WALDRON",
    "display_name": "WALDRON",
    "county": "HILLSDALE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006875",
    "resolved_pwsid": "MI0006875",
    "system_name": "WALLED LAKE, CITY OF",
    "display_name": "WALLED LAKE, CITY OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006875",
    "resolved_pwsid": "MI0006875",
    "system_name": "WALLED LAKE, CITY OF",
    "display_name": "WALLED LAKE, CITY OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006875",
    "resolved_pwsid": "MI0006875",
    "system_name": "WALLED LAKE, CITY OF",
    "display_name": "WALLED LAKE, CITY OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006875",
    "resolved_pwsid": "MI0006875",
    "system_name": "WALLED LAKE, CITY OF",
    "display_name": "WALLED LAKE, CITY OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006875",
    "resolved_pwsid": "MI0006875",
    "system_name": "WALLED LAKE, CITY OF",
    "display_name": "WALLED LAKE, CITY OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006875",
    "resolved_pwsid": "MI0006875",
    "system_name": "WALLED LAKE, CITY OF",
    "display_name": "WALLED LAKE, CITY OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006875",
    "resolved_pwsid": "MI0006875",
    "system_name": "WALLED LAKE, CITY OF",
    "display_name": "WALLED LAKE, CITY OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006875",
    "resolved_pwsid": "MI0006875",
    "system_name": "WALLED LAKE, CITY OF",
    "display_name": "WALLED LAKE, CITY OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0006880",
    "resolved_pwsid": "MI0006880",
    "system_name": "WALLOON LAKE WATER SYSTEM",
    "display_name": "WALLOON LAKE WATER SYSTEM",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006880",
    "resolved_pwsid": "MI0006880",
    "system_name": "WALLOON LAKE WATER SYSTEM",
    "display_name": "WALLOON LAKE WATER SYSTEM",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006880",
    "resolved_pwsid": "MI0006880",
    "system_name": "WALLOON LAKE WATER SYSTEM",
    "display_name": "WALLOON LAKE WATER SYSTEM",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 9,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006880",
    "resolved_pwsid": "MI0006880",
    "system_name": "WALLOON LAKE WATER SYSTEM",
    "display_name": "WALLOON LAKE WATER SYSTEM",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006885",
    "resolved_pwsid": "MI0006885",
    "system_name": "WALNUT LANE APARTMENTS",
    "display_name": "WALNUT LANE APARTMENTS",
    "county": "ALLEGAN",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006885",
    "resolved_pwsid": "MI0006885",
    "system_name": "WALNUT LANE APARTMENTS",
    "display_name": "WALNUT LANE APARTMENTS",
    "county": "ALLEGAN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006885",
    "resolved_pwsid": "MI0006885",
    "system_name": "WALNUT LANE APARTMENTS",
    "display_name": "WALNUT LANE APARTMENTS",
    "county": "ALLEGAN",
    "monitoring_end_date": "2024-09-30",
    "year": 2024,
    "lead_90th_ppb": 16,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006885",
    "resolved_pwsid": "MI0006885",
    "system_name": "WALNUT LANE APARTMENTS",
    "display_name": "WALNUT LANE APARTMENTS",
    "county": "ALLEGAN",
    "monitoring_end_date": "2025-06-30",
    "year": 2025,
    "lead_90th_ppb": 14,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0006885",
    "resolved_pwsid": "MI0006885",
    "system_name": "WALNUT LANE APARTMENTS",
    "display_name": "WALNUT LANE APARTMENTS",
    "county": "ALLEGAN",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0006885",
    "resolved_pwsid": "MI0006885",
    "system_name": "WALNUT LANE APARTMENTS",
    "display_name": "WALNUT LANE APARTMENTS",
    "county": "ALLEGAN",
    "monitoring_end_date": "2026-06-30",
    "year": 2026,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006900",
    "resolved_pwsid": "MI0006900",
    "system_name": "WARREN, CITY OF",
    "display_name": "WARREN, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006900",
    "resolved_pwsid": "MI0006900",
    "system_name": "WARREN, CITY OF",
    "display_name": "WARREN, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 12,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006900",
    "resolved_pwsid": "MI0006900",
    "system_name": "WARREN, CITY OF",
    "display_name": "WARREN, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 11,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006900",
    "resolved_pwsid": "MI0006900",
    "system_name": "WARREN, CITY OF",
    "display_name": "WARREN, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": 99,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006900",
    "resolved_pwsid": "MI0006900",
    "system_name": "WARREN, CITY OF",
    "display_name": "WARREN, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 11,
    "above_action_level": false,
    "lines_replaced": 99,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006900",
    "resolved_pwsid": "MI0006900",
    "system_name": "WARREN, CITY OF",
    "display_name": "WARREN, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": 65,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006900",
    "resolved_pwsid": "MI0006900",
    "system_name": "WARREN, CITY OF",
    "display_name": "WARREN, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 14,
    "above_action_level": true,
    "lines_replaced": 69,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006900",
    "resolved_pwsid": "MI0006900",
    "system_name": "WARREN, CITY OF",
    "display_name": "WARREN, CITY OF",
    "county": "MACOMB",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": 56,
    "inventory_lead": 5,
    "inventory_gpcl": 33,
    "inventory_unknown": 15573,
    "total_to_identify_or_replace": 15611,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0006901",
    "resolved_pwsid": "MI0006901",
    "system_name": "CLEAN WATER ASSOCIATION, INC.",
    "display_name": "CLEAN WATER ASSOCIATION, INC.",
    "county": "LAKE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006901",
    "resolved_pwsid": "MI0006901",
    "system_name": "CLEAN WATER ASSOCIATION, INC.",
    "display_name": "CLEAN WATER ASSOCIATION, INC.",
    "county": "LAKE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006901",
    "resolved_pwsid": "MI0006901",
    "system_name": "CLEAN WATER ASSOCIATION, INC.",
    "display_name": "CLEAN WATER ASSOCIATION, INC.",
    "county": "LAKE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006905",
    "resolved_pwsid": "MI0006905",
    "system_name": "WASHINGTON TOWNSHIP",
    "display_name": "WASHINGTON TOWNSHIP",
    "county": "MACOMB",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006905",
    "resolved_pwsid": "MI0006905",
    "system_name": "WASHINGTON TOWNSHIP",
    "display_name": "WASHINGTON TOWNSHIP",
    "county": "MACOMB",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006905",
    "resolved_pwsid": "MI0006905",
    "system_name": "WASHINGTON TOWNSHIP",
    "display_name": "WASHINGTON TOWNSHIP",
    "county": "MACOMB",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006905",
    "resolved_pwsid": "MI0006905",
    "system_name": "WASHINGTON TOWNSHIP",
    "display_name": "WASHINGTON TOWNSHIP",
    "county": "MACOMB",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006905",
    "resolved_pwsid": "MI0006905",
    "system_name": "WASHINGTON TOWNSHIP",
    "display_name": "WASHINGTON TOWNSHIP",
    "county": "MACOMB",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006905",
    "resolved_pwsid": "MI0006905",
    "system_name": "WASHINGTON TOWNSHIP",
    "display_name": "WASHINGTON TOWNSHIP",
    "county": "MACOMB",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006905",
    "resolved_pwsid": "MI0006905",
    "system_name": "WASHINGTON TOWNSHIP",
    "display_name": "WASHINGTON TOWNSHIP",
    "county": "MACOMB",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006905",
    "resolved_pwsid": "MI0006905",
    "system_name": "WASHINGTON TOWNSHIP",
    "display_name": "WASHINGTON TOWNSHIP",
    "county": "MACOMB",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0006910",
    "resolved_pwsid": "MI0006910",
    "system_name": "WATERFORD TOWNSHIP",
    "display_name": "WATERFORD TOWNSHIP",
    "county": "OAKLAND",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006910",
    "resolved_pwsid": "MI0006910",
    "system_name": "WATERFORD TOWNSHIP",
    "display_name": "WATERFORD TOWNSHIP",
    "county": "OAKLAND",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006910",
    "resolved_pwsid": "MI0006910",
    "system_name": "WATERFORD TOWNSHIP",
    "display_name": "WATERFORD TOWNSHIP",
    "county": "OAKLAND",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006910",
    "resolved_pwsid": "MI0006910",
    "system_name": "WATERFORD TOWNSHIP",
    "display_name": "WATERFORD TOWNSHIP",
    "county": "OAKLAND",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006910",
    "resolved_pwsid": "MI0006910",
    "system_name": "WATERFORD TOWNSHIP",
    "display_name": "WATERFORD TOWNSHIP",
    "county": "OAKLAND",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006910",
    "resolved_pwsid": "MI0006910",
    "system_name": "WATERFORD TOWNSHIP",
    "display_name": "WATERFORD TOWNSHIP",
    "county": "OAKLAND",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006910",
    "resolved_pwsid": "MI0006910",
    "system_name": "WATERFORD TOWNSHIP",
    "display_name": "WATERFORD TOWNSHIP",
    "county": "OAKLAND",
    "monitoring_end_date": "2024-06-30",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 2,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006910",
    "resolved_pwsid": "MI0006910",
    "system_name": "WATERFORD TOWNSHIP",
    "display_name": "WATERFORD TOWNSHIP",
    "county": "OAKLAND",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006910",
    "resolved_pwsid": "MI0006910",
    "system_name": "WATERFORD TOWNSHIP",
    "display_name": "WATERFORD TOWNSHIP",
    "county": "OAKLAND",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 1,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 1,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0006920",
    "resolved_pwsid": "MI0006920",
    "system_name": "WATERSMEET TOWNSHIP",
    "display_name": "WATERSMEET TOWNSHIP",
    "county": "GOGEBIC",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006920",
    "resolved_pwsid": "MI0006920",
    "system_name": "WATERSMEET TOWNSHIP",
    "display_name": "WATERSMEET TOWNSHIP",
    "county": "GOGEBIC",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006920",
    "resolved_pwsid": "MI0006920",
    "system_name": "WATERSMEET TOWNSHIP",
    "display_name": "WATERSMEET TOWNSHIP",
    "county": "GOGEBIC",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006920",
    "resolved_pwsid": "MI0006920",
    "system_name": "WATERSMEET TOWNSHIP",
    "display_name": "WATERSMEET TOWNSHIP",
    "county": "GOGEBIC",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 9,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": 0,
    "inventory_gpcl": 31,
    "inventory_unknown": 127,
    "total_to_identify_or_replace": 158,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0006920",
    "resolved_pwsid": "MI0006920",
    "system_name": "WATERSMEET TOWNSHIP",
    "display_name": "WATERSMEET TOWNSHIP",
    "county": "GOGEBIC",
    "monitoring_end_date": "",
    "year": 2024,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006930",
    "resolved_pwsid": "MI0006930",
    "system_name": "WATERVLIET",
    "display_name": "WATERVLIET",
    "county": "BERRIEN",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006930",
    "resolved_pwsid": "MI0006930",
    "system_name": "WATERVLIET",
    "display_name": "WATERVLIET",
    "county": "BERRIEN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 61,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006930",
    "resolved_pwsid": "MI0006930",
    "system_name": "WATERVLIET",
    "display_name": "WATERVLIET",
    "county": "BERRIEN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 6,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006930",
    "resolved_pwsid": "MI0006930",
    "system_name": "WATERVLIET",
    "display_name": "WATERVLIET",
    "county": "BERRIEN",
    "monitoring_end_date": "",
    "year": 2022,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 3,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006930",
    "resolved_pwsid": "MI0006930",
    "system_name": "WATERVLIET",
    "display_name": "WATERVLIET",
    "county": "BERRIEN",
    "monitoring_end_date": "",
    "year": 2023,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 6,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006930",
    "resolved_pwsid": "MI0006930",
    "system_name": "WATERVLIET",
    "display_name": "WATERVLIET",
    "county": "BERRIEN",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 6,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006935",
    "resolved_pwsid": "MI0006935",
    "system_name": "LAKEWOOD TERRACE ASSOCIATION",
    "display_name": "LAKEWOOD TERRACE ASSOCIATION",
    "county": "ANTRIM",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006935",
    "resolved_pwsid": "MI0006935",
    "system_name": "LAKEWOOD TERRACE ASSOCIATION",
    "display_name": "LAKEWOOD TERRACE ASSOCIATION",
    "county": "ANTRIM",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006935",
    "resolved_pwsid": "MI0006935",
    "system_name": "LAKEWOOD TERRACE ASSOCIATION",
    "display_name": "LAKEWOOD TERRACE ASSOCIATION",
    "county": "ANTRIM",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006935",
    "resolved_pwsid": "MI0006935",
    "system_name": "LAKEWOOD TERRACE ASSOCIATION",
    "display_name": "LAKEWOOD TERRACE ASSOCIATION",
    "county": "ANTRIM",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0006940",
    "resolved_pwsid": "MI0006940",
    "system_name": "WAYLAND",
    "display_name": "WAYLAND",
    "county": "ALLEGAN",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006940",
    "resolved_pwsid": "MI0006940",
    "system_name": "WAYLAND",
    "display_name": "WAYLAND",
    "county": "ALLEGAN",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006940",
    "resolved_pwsid": "MI0006940",
    "system_name": "WAYLAND",
    "display_name": "WAYLAND",
    "county": "ALLEGAN",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006940",
    "resolved_pwsid": "MI0006940",
    "system_name": "WAYLAND",
    "display_name": "WAYLAND",
    "county": "ALLEGAN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006940",
    "resolved_pwsid": "MI0006940",
    "system_name": "WAYLAND",
    "display_name": "WAYLAND",
    "county": "ALLEGAN",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 5,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006940",
    "resolved_pwsid": "MI0006940",
    "system_name": "WAYLAND",
    "display_name": "WAYLAND",
    "county": "ALLEGAN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 69,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006940",
    "resolved_pwsid": "MI0006940",
    "system_name": "WAYLAND",
    "display_name": "WAYLAND",
    "county": "ALLEGAN",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 5,
    "inventory_lead": 206,
    "inventory_gpcl": 399,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 605,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0006950",
    "resolved_pwsid": "MI0006950",
    "system_name": "WAYNE",
    "display_name": "WAYNE",
    "county": "WAYNE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006950",
    "resolved_pwsid": "MI0006950",
    "system_name": "WAYNE",
    "display_name": "WAYNE",
    "county": "WAYNE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 14,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006950",
    "resolved_pwsid": "MI0006950",
    "system_name": "WAYNE",
    "display_name": "WAYNE",
    "county": "WAYNE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 12,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006950",
    "resolved_pwsid": "MI0006950",
    "system_name": "WAYNE",
    "display_name": "WAYNE",
    "county": "WAYNE",
    "monitoring_end_date": "2021-09-30",
    "year": 2021,
    "lead_90th_ppb": 16,
    "above_action_level": true,
    "lines_replaced": 43,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006950",
    "resolved_pwsid": "MI0006950",
    "system_name": "WAYNE",
    "display_name": "WAYNE",
    "county": "WAYNE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 16,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006950",
    "resolved_pwsid": "MI0006950",
    "system_name": "WAYNE",
    "display_name": "WAYNE",
    "county": "WAYNE",
    "monitoring_end_date": "2022-06-30",
    "year": 2022,
    "lead_90th_ppb": 15,
    "above_action_level": true,
    "lines_replaced": 44,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006950",
    "resolved_pwsid": "MI0006950",
    "system_name": "WAYNE",
    "display_name": "WAYNE",
    "county": "WAYNE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 15,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006950",
    "resolved_pwsid": "MI0006950",
    "system_name": "WAYNE",
    "display_name": "WAYNE",
    "county": "WAYNE",
    "monitoring_end_date": "2023-06-30",
    "year": 2023,
    "lead_90th_ppb": 16,
    "above_action_level": true,
    "lines_replaced": 153,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006950",
    "resolved_pwsid": "MI0006950",
    "system_name": "WAYNE",
    "display_name": "WAYNE",
    "county": "WAYNE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 14,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006950",
    "resolved_pwsid": "MI0006950",
    "system_name": "WAYNE",
    "display_name": "WAYNE",
    "county": "WAYNE",
    "monitoring_end_date": "2024-06-30",
    "year": 2024,
    "lead_90th_ppb": 13,
    "above_action_level": true,
    "lines_replaced": 399,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006950",
    "resolved_pwsid": "MI0006950",
    "system_name": "WAYNE",
    "display_name": "WAYNE",
    "county": "WAYNE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 13,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006950",
    "resolved_pwsid": "MI0006950",
    "system_name": "WAYNE",
    "display_name": "WAYNE",
    "county": "WAYNE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": 529,
    "inventory_lead": 112,
    "inventory_gpcl": 182,
    "inventory_unknown": 4117,
    "total_to_identify_or_replace": 4411,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0006950",
    "resolved_pwsid": "MI0006950",
    "system_name": "WAYNE",
    "display_name": "WAYNE",
    "county": "WAYNE",
    "monitoring_end_date": "2026-06-30",
    "year": 2026,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006960",
    "resolved_pwsid": "MI0006960",
    "system_name": "WEBBER TOWNSHIP",
    "display_name": "WEBBER TOWNSHIP",
    "county": "LAKE",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006960",
    "resolved_pwsid": "MI0006960",
    "system_name": "WEBBER TOWNSHIP",
    "display_name": "WEBBER TOWNSHIP",
    "county": "LAKE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006960",
    "resolved_pwsid": "MI0006960",
    "system_name": "WEBBER TOWNSHIP",
    "display_name": "WEBBER TOWNSHIP",
    "county": "LAKE",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006960",
    "resolved_pwsid": "MI0006960",
    "system_name": "WEBBER TOWNSHIP",
    "display_name": "WEBBER TOWNSHIP",
    "county": "LAKE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006960",
    "resolved_pwsid": "MI0006960",
    "system_name": "WEBBER TOWNSHIP",
    "display_name": "WEBBER TOWNSHIP",
    "county": "LAKE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006960",
    "resolved_pwsid": "MI0006960",
    "system_name": "WEBBER TOWNSHIP",
    "display_name": "WEBBER TOWNSHIP",
    "county": "LAKE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006970",
    "resolved_pwsid": "MI0006970",
    "system_name": "WEBBERVILLE, VILLAGE OF",
    "display_name": "WEBBERVILLE, VILLAGE OF",
    "county": "INGHAM",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006970",
    "resolved_pwsid": "MI0006970",
    "system_name": "WEBBERVILLE, VILLAGE OF",
    "display_name": "WEBBERVILLE, VILLAGE OF",
    "county": "INGHAM",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006970",
    "resolved_pwsid": "MI0006970",
    "system_name": "WEBBERVILLE, VILLAGE OF",
    "display_name": "WEBBERVILLE, VILLAGE OF",
    "county": "INGHAM",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 3,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006970",
    "resolved_pwsid": "MI0006970",
    "system_name": "WEBBERVILLE, VILLAGE OF",
    "display_name": "WEBBERVILLE, VILLAGE OF",
    "county": "INGHAM",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 1,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006971",
    "resolved_pwsid": "MI0006971",
    "system_name": "WEDGEWOOD GOLFSIDE CONDO ASSOC",
    "display_name": "WEDGEWOOD GOLFSIDE CONDO ASSOC",
    "county": "LAPEER",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006971",
    "resolved_pwsid": "MI0006971",
    "system_name": "WEDGEWOOD GOLFSIDE CONDO ASSOC",
    "display_name": "WEDGEWOOD GOLFSIDE CONDO ASSOC",
    "county": "LAPEER",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006971",
    "resolved_pwsid": "MI0006971",
    "system_name": "WEDGEWOOD GOLFSIDE CONDO ASSOC",
    "display_name": "WEDGEWOOD GOLFSIDE CONDO ASSOC",
    "county": "LAPEER",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006971",
    "resolved_pwsid": "MI0006971",
    "system_name": "WEDGEWOOD GOLFSIDE CONDO ASSOC",
    "display_name": "WEDGEWOOD GOLFSIDE CONDO ASSOC",
    "county": "LAPEER",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0006975",
    "resolved_pwsid": "MI0006975",
    "system_name": "WEST BLOOMFIELD TOWNSHIP",
    "display_name": "WEST BLOOMFIELD TOWNSHIP",
    "county": "OAKLAND",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006975",
    "resolved_pwsid": "MI0006975",
    "system_name": "WEST BLOOMFIELD TOWNSHIP",
    "display_name": "WEST BLOOMFIELD TOWNSHIP",
    "county": "OAKLAND",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006975",
    "resolved_pwsid": "MI0006975",
    "system_name": "WEST BLOOMFIELD TOWNSHIP",
    "display_name": "WEST BLOOMFIELD TOWNSHIP",
    "county": "OAKLAND",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006975",
    "resolved_pwsid": "MI0006975",
    "system_name": "WEST BLOOMFIELD TOWNSHIP",
    "display_name": "WEST BLOOMFIELD TOWNSHIP",
    "county": "OAKLAND",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006975",
    "resolved_pwsid": "MI0006975",
    "system_name": "WEST BLOOMFIELD TOWNSHIP",
    "display_name": "WEST BLOOMFIELD TOWNSHIP",
    "county": "OAKLAND",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006975",
    "resolved_pwsid": "MI0006975",
    "system_name": "WEST BLOOMFIELD TOWNSHIP",
    "display_name": "WEST BLOOMFIELD TOWNSHIP",
    "county": "OAKLAND",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 3,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006975",
    "resolved_pwsid": "MI0006975",
    "system_name": "WEST BLOOMFIELD TOWNSHIP",
    "display_name": "WEST BLOOMFIELD TOWNSHIP",
    "county": "OAKLAND",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0006975",
    "resolved_pwsid": "MI0006975",
    "system_name": "WEST BLOOMFIELD TOWNSHIP",
    "display_name": "WEST BLOOMFIELD TOWNSHIP",
    "county": "OAKLAND",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 454,
    "total_to_identify_or_replace": 454,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0007010",
    "resolved_pwsid": "MI0007010",
    "system_name": "WEST BRANCH, CITY OF",
    "display_name": "WEST BRANCH, CITY OF",
    "county": "OGEMAW",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007010",
    "resolved_pwsid": "MI0007010",
    "system_name": "WEST BRANCH, CITY OF",
    "display_name": "WEST BRANCH, CITY OF",
    "county": "OGEMAW",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007010",
    "resolved_pwsid": "MI0007010",
    "system_name": "WEST BRANCH, CITY OF",
    "display_name": "WEST BRANCH, CITY OF",
    "county": "OGEMAW",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 59,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007010",
    "resolved_pwsid": "MI0007010",
    "system_name": "WEST BRANCH, CITY OF",
    "display_name": "WEST BRANCH, CITY OF",
    "county": "OGEMAW",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": 11,
    "inventory_lead": 2,
    "inventory_gpcl": 29,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 31,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0007010",
    "resolved_pwsid": "MI0007010",
    "system_name": "WEST BRANCH, CITY OF",
    "display_name": "WEST BRANCH, CITY OF",
    "county": "OGEMAW",
    "monitoring_end_date": "",
    "year": 2023,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 95,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007010",
    "resolved_pwsid": "MI0007010",
    "system_name": "WEST BRANCH, CITY OF",
    "display_name": "WEST BRANCH, CITY OF",
    "county": "OGEMAW",
    "monitoring_end_date": "",
    "year": 2024,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 6,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007012",
    "resolved_pwsid": "MI0007012",
    "system_name": "WEST BRANCH TOWNSHIP",
    "display_name": "WEST BRANCH TOWNSHIP",
    "county": "OGEMAW",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007012",
    "resolved_pwsid": "MI0007012",
    "system_name": "WEST BRANCH TOWNSHIP",
    "display_name": "WEST BRANCH TOWNSHIP",
    "county": "OGEMAW",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007012",
    "resolved_pwsid": "MI0007012",
    "system_name": "WEST BRANCH TOWNSHIP",
    "display_name": "WEST BRANCH TOWNSHIP",
    "county": "OGEMAW",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007012",
    "resolved_pwsid": "MI0007012",
    "system_name": "WEST BRANCH TOWNSHIP",
    "display_name": "WEST BRANCH TOWNSHIP",
    "county": "OGEMAW",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0007015",
    "resolved_pwsid": "MI0007015-b",
    "system_name": "WEST COURT RANCHES",
    "display_name": "WEST COURT RANCHES",
    "county": "GENESEE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007015",
    "resolved_pwsid": "MI0007015-b",
    "system_name": "WEST COURT RANCHES",
    "display_name": "WEST COURT RANCHES",
    "county": "GENESEE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007015",
    "resolved_pwsid": "MI0007015-a",
    "system_name": "MIDTOWN FLATS, LLC",
    "display_name": "MIDTOWN FLATS, LLC",
    "county": "GENESEE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 10,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007035",
    "resolved_pwsid": "MI0007035",
    "system_name": "WESTBROOK APARTMENTS",
    "display_name": "WESTBROOK APARTMENTS",
    "county": "WASHTENAW",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007035",
    "resolved_pwsid": "MI0007035",
    "system_name": "WESTBROOK APARTMENTS",
    "display_name": "WESTBROOK APARTMENTS",
    "county": "WASHTENAW",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007035",
    "resolved_pwsid": "MI0007035",
    "system_name": "WESTBROOK APARTMENTS",
    "display_name": "WESTBROOK APARTMENTS",
    "county": "WASHTENAW",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007035",
    "resolved_pwsid": "MI0007035",
    "system_name": "WESTBROOK APARTMENTS",
    "display_name": "WESTBROOK APARTMENTS",
    "county": "WASHTENAW",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007040",
    "resolved_pwsid": "MI0007040",
    "system_name": "WESTLAND",
    "display_name": "WESTLAND",
    "county": "WAYNE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007040",
    "resolved_pwsid": "MI0007040",
    "system_name": "WESTLAND",
    "display_name": "WESTLAND",
    "county": "WAYNE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007040",
    "resolved_pwsid": "MI0007040",
    "system_name": "WESTLAND",
    "display_name": "WESTLAND",
    "county": "WAYNE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007040",
    "resolved_pwsid": "MI0007040",
    "system_name": "WESTLAND",
    "display_name": "WESTLAND",
    "county": "WAYNE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": 7,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007040",
    "resolved_pwsid": "MI0007040",
    "system_name": "WESTLAND",
    "display_name": "WESTLAND",
    "county": "WAYNE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007040",
    "resolved_pwsid": "MI0007040",
    "system_name": "WESTLAND",
    "display_name": "WESTLAND",
    "county": "WAYNE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 2,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007040",
    "resolved_pwsid": "MI0007040",
    "system_name": "WESTLAND",
    "display_name": "WESTLAND",
    "county": "WAYNE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 2,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007040",
    "resolved_pwsid": "MI0007040",
    "system_name": "WESTLAND",
    "display_name": "WESTLAND",
    "county": "WAYNE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 2,
    "inventory_lead": 0,
    "inventory_gpcl": 166,
    "inventory_unknown": 13193,
    "total_to_identify_or_replace": 13359,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0007050",
    "resolved_pwsid": "MI0007050",
    "system_name": "WESTPHALIA, VILLAGE OF",
    "display_name": "WESTPHALIA, VILLAGE OF",
    "county": "CLINTON",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007050",
    "resolved_pwsid": "MI0007050",
    "system_name": "WESTPHALIA, VILLAGE OF",
    "display_name": "WESTPHALIA, VILLAGE OF",
    "county": "CLINTON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007050",
    "resolved_pwsid": "MI0007050",
    "system_name": "WESTPHALIA, VILLAGE OF",
    "display_name": "WESTPHALIA, VILLAGE OF",
    "county": "CLINTON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007057",
    "resolved_pwsid": "MI0007057",
    "system_name": "WEST TRAVERSE TOWNSHIP",
    "display_name": "WEST TRAVERSE TOWNSHIP",
    "county": "EMMET",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007057",
    "resolved_pwsid": "MI0007057",
    "system_name": "WEST TRAVERSE TOWNSHIP",
    "display_name": "WEST TRAVERSE TOWNSHIP",
    "county": "EMMET",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007057",
    "resolved_pwsid": "MI0007057",
    "system_name": "WEST TRAVERSE TOWNSHIP",
    "display_name": "WEST TRAVERSE TOWNSHIP",
    "county": "EMMET",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007060",
    "resolved_pwsid": "MI0007060",
    "system_name": "WHITE CLOUD",
    "display_name": "WHITE CLOUD",
    "county": "NEWAYGO",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007060",
    "resolved_pwsid": "MI0007060",
    "system_name": "WHITE CLOUD",
    "display_name": "WHITE CLOUD",
    "county": "NEWAYGO",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 4,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007060",
    "resolved_pwsid": "MI0007060",
    "system_name": "WHITE CLOUD",
    "display_name": "WHITE CLOUD",
    "county": "NEWAYGO",
    "monitoring_end_date": "2022-06-30",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007060",
    "resolved_pwsid": "MI0007060",
    "system_name": "WHITE CLOUD",
    "display_name": "WHITE CLOUD",
    "county": "NEWAYGO",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007060",
    "resolved_pwsid": "MI0007060",
    "system_name": "WHITE CLOUD",
    "display_name": "WHITE CLOUD",
    "county": "NEWAYGO",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 312,
    "inventory_gpcl": 20,
    "inventory_unknown": 5,
    "total_to_identify_or_replace": 337,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0007060",
    "resolved_pwsid": "MI0007060",
    "system_name": "WHITE CLOUD",
    "display_name": "WHITE CLOUD",
    "county": "NEWAYGO",
    "monitoring_end_date": "",
    "year": 2023,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 2,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007061",
    "resolved_pwsid": "MI0007061",
    "system_name": "WHITE EAGLE SUBDIVISION",
    "display_name": "WHITE EAGLE SUBDIVISION",
    "county": "OAKLAND",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007061",
    "resolved_pwsid": "MI0007061",
    "system_name": "WHITE EAGLE SUBDIVISION",
    "display_name": "WHITE EAGLE SUBDIVISION",
    "county": "OAKLAND",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007061",
    "resolved_pwsid": "MI0007061",
    "system_name": "WHITE EAGLE SUBDIVISION",
    "display_name": "WHITE EAGLE SUBDIVISION",
    "county": "OAKLAND",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007062",
    "resolved_pwsid": "MI0007062",
    "system_name": "WHITE DEER VILLAGE",
    "display_name": "WHITE DEER VILLAGE",
    "county": "ROSCOMMON",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007062",
    "resolved_pwsid": "MI0007062",
    "system_name": "WHITE DEER VILLAGE",
    "display_name": "WHITE DEER VILLAGE",
    "county": "ROSCOMMON",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007062",
    "resolved_pwsid": "MI0007062",
    "system_name": "WHITE DEER VILLAGE",
    "display_name": "WHITE DEER VILLAGE",
    "county": "ROSCOMMON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007063",
    "resolved_pwsid": "MI0007063",
    "system_name": "WHITEFORD TOWNSHIP",
    "display_name": "WHITEFORD TOWNSHIP",
    "county": "MONROE",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007063",
    "resolved_pwsid": "MI0007063",
    "system_name": "WHITEFORD TOWNSHIP",
    "display_name": "WHITEFORD TOWNSHIP",
    "county": "MONROE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007063",
    "resolved_pwsid": "MI0007063",
    "system_name": "WHITEFORD TOWNSHIP",
    "display_name": "WHITEFORD TOWNSHIP",
    "county": "MONROE",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007063",
    "resolved_pwsid": "MI0007063",
    "system_name": "WHITEFORD TOWNSHIP",
    "display_name": "WHITEFORD TOWNSHIP",
    "county": "MONROE",
    "monitoring_end_date": "2021-06-30",
    "year": 2021,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007063",
    "resolved_pwsid": "MI0007063",
    "system_name": "WHITEFORD TOWNSHIP",
    "display_name": "WHITEFORD TOWNSHIP",
    "county": "MONROE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007063",
    "resolved_pwsid": "MI0007063",
    "system_name": "WHITEFORD TOWNSHIP",
    "display_name": "WHITEFORD TOWNSHIP",
    "county": "MONROE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007063",
    "resolved_pwsid": "MI0007063",
    "system_name": "WHITEFORD TOWNSHIP",
    "display_name": "WHITEFORD TOWNSHIP",
    "county": "MONROE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007063",
    "resolved_pwsid": "MI0007063",
    "system_name": "WHITEFORD TOWNSHIP",
    "display_name": "WHITEFORD TOWNSHIP",
    "county": "MONROE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0007064",
    "resolved_pwsid": "MI0007064",
    "system_name": "WHITE LAKE ASSISTED LIVING CENTER",
    "display_name": "WHITE LAKE ASSISTED LIVING CENTER",
    "county": "MUSKEGON",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007064",
    "resolved_pwsid": "MI0007064",
    "system_name": "WHITE LAKE ASSISTED LIVING CENTER",
    "display_name": "WHITE LAKE ASSISTED LIVING CENTER",
    "county": "MUSKEGON",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007064",
    "resolved_pwsid": "MI0007064",
    "system_name": "WHITE LAKE ASSISTED LIVING CENTER",
    "display_name": "WHITE LAKE ASSISTED LIVING CENTER",
    "county": "MUSKEGON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007065",
    "resolved_pwsid": "MI0007065-a",
    "system_name": "WHITE LAKE TOWNSHIP",
    "display_name": "WHITE LAKE TOWNSHIP",
    "county": "OAKLAND",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007065",
    "resolved_pwsid": "MI0007065-b",
    "system_name": "WHITE LAKE TOWNSHIP (ASPEN MEADOWS)",
    "display_name": "WHITE LAKE TOWNSHIP (ASPEN MEADOWS)",
    "county": "OAKLAND",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007065",
    "resolved_pwsid": "MI0007065-e",
    "system_name": "WHITE LAKE TOWNSHIP (VILLAGE ACRES)",
    "display_name": "WHITE LAKE TOWNSHIP (VILLAGE ACRES)",
    "county": "OAKLAND",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 21,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007065",
    "resolved_pwsid": "MI0007065-e",
    "system_name": "WHITE LAKE TOWNSHIP (VILLAGE ACRES)",
    "display_name": "WHITE LAKE TOWNSHIP (VILLAGE ACRES)",
    "county": "OAKLAND",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007065",
    "resolved_pwsid": "MI0007065-b",
    "system_name": "WHITE LAKE TOWNSHIP (ASPEN MEADOWS)",
    "display_name": "WHITE LAKE TOWNSHIP (ASPEN MEADOWS)",
    "county": "OAKLAND",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007065",
    "resolved_pwsid": "MI0007065-e",
    "system_name": "WHITE LAKE TOWNSHIP (VILLAGE ACRES)",
    "display_name": "WHITE LAKE TOWNSHIP (VILLAGE ACRES)",
    "county": "OAKLAND",
    "monitoring_end_date": "2021-06-30",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007065",
    "resolved_pwsid": "MI0007065-b",
    "system_name": "WHITE LAKE TOWNSHIP (ASPEN MEADOWS)",
    "display_name": "WHITE LAKE TOWNSHIP (ASPEN MEADOWS)",
    "county": "OAKLAND",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007065",
    "resolved_pwsid": "MI0007065-b",
    "system_name": "WHITE LAKE TOWNSHIP (ASPEN MEADOWS)",
    "display_name": "WHITE LAKE TOWNSHIP (ASPEN MEADOWS)",
    "county": "OAKLAND",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 10,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007065",
    "resolved_pwsid": "MI0007065-e",
    "system_name": "WHITE LAKE TOWNSHIP (VILLAGE ACRES)",
    "display_name": "WHITE LAKE TOWNSHIP (VILLAGE ACRES)",
    "county": "OAKLAND",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007065",
    "resolved_pwsid": "MI0007065-b",
    "system_name": "WHITE LAKE TOWNSHIP (ASPEN MEADOWS)",
    "display_name": "WHITE LAKE TOWNSHIP (ASPEN MEADOWS)",
    "county": "OAKLAND",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007065",
    "resolved_pwsid": "MI0007065-e",
    "system_name": "WHITE LAKE TOWNSHIP (VILLAGE ACRES)",
    "display_name": "WHITE LAKE TOWNSHIP (VILLAGE ACRES)",
    "county": "OAKLAND",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007065",
    "resolved_pwsid": "MI0007065-b",
    "system_name": "WHITE LAKE TOWNSHIP (ASPEN MEADOWS)",
    "display_name": "WHITE LAKE TOWNSHIP (ASPEN MEADOWS)",
    "county": "OAKLAND",
    "monitoring_end_date": "2024-06-30",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007065",
    "resolved_pwsid": "MI0007065-c",
    "system_name": "WHITE LAKE TOWNSHIP (DIST1)",
    "display_name": "WHITE LAKE TOWNSHIP (DIST1)",
    "county": "OAKLAND",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007065",
    "resolved_pwsid": "MI0007065-d",
    "system_name": "WHITE LAKE TOWNSHIP (DIST2)",
    "display_name": "WHITE LAKE TOWNSHIP (DIST2)",
    "county": "OAKLAND",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007065",
    "resolved_pwsid": "MI0007065-f",
    "system_name": "WHITE LAKE TOWNSHIP (DS001)",
    "display_name": "WHITE LAKE TOWNSHIP",
    "county": "OAKLAND",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0007065",
    "resolved_pwsid": "MI0007065-g",
    "system_name": "WHITE LAKE TOWNSHIP (DS002)",
    "display_name": "WHITE LAKE TOWNSHIP",
    "county": "OAKLAND",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0007067",
    "resolved_pwsid": "MI0007067",
    "system_name": "WHITE OAKS CONDOMINIUMS",
    "display_name": "WHITE OAKS CONDOMINIUMS",
    "county": "BERRIEN",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007067",
    "resolved_pwsid": "MI0007067",
    "system_name": "WHITE OAKS CONDOMINIUMS",
    "display_name": "WHITE OAKS CONDOMINIUMS",
    "county": "BERRIEN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007067",
    "resolved_pwsid": "MI0007067",
    "system_name": "WHITE OAKS CONDOMINIUMS",
    "display_name": "WHITE OAKS CONDOMINIUMS",
    "county": "BERRIEN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007070",
    "resolved_pwsid": "MI0007070",
    "system_name": "WHITE PIGEON",
    "display_name": "WHITE PIGEON",
    "county": "ST JOSEPH",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007070",
    "resolved_pwsid": "MI0007070",
    "system_name": "WHITE PIGEON",
    "display_name": "WHITE PIGEON",
    "county": "ST JOSEPH",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007070",
    "resolved_pwsid": "MI0007070",
    "system_name": "WHITE PIGEON",
    "display_name": "WHITE PIGEON",
    "county": "ST JOSEPH",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 86,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007070",
    "resolved_pwsid": "MI0007070",
    "system_name": "WHITE PIGEON",
    "display_name": "WHITE PIGEON",
    "county": "ST. JOSEPH",
    "monitoring_end_date": "2022-06-30",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 2,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007070",
    "resolved_pwsid": "MI0007070",
    "system_name": "WHITE PIGEON",
    "display_name": "WHITE PIGEON",
    "county": "ST. JOSEPH",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007070",
    "resolved_pwsid": "MI0007070",
    "system_name": "WHITE PIGEON",
    "display_name": "WHITE PIGEON",
    "county": "ST. JOSEPH",
    "monitoring_end_date": "2023-06-30",
    "year": 2023,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": 5,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007070",
    "resolved_pwsid": "MI0007070",
    "system_name": "WHITE PIGEON",
    "display_name": "WHITE PIGEON",
    "county": "ST. JOSEPH",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007070",
    "resolved_pwsid": "MI0007070",
    "system_name": "WHITE PIGEON",
    "display_name": "WHITE PIGEON",
    "county": "ST. JOSEPH",
    "monitoring_end_date": "2024-06-30",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 5,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007070",
    "resolved_pwsid": "MI0007070",
    "system_name": "WHITE PIGEON",
    "display_name": "WHITE PIGEON",
    "county": "ST JOSEPH",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 92,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007085",
    "resolved_pwsid": "MI0007085",
    "system_name": "T.J. WHITE PINE MANOR APARTMENTS",
    "display_name": "T.J. WHITE PINE MANOR APARTMENTS",
    "county": "MECOSTA",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007085",
    "resolved_pwsid": "MI0007085",
    "system_name": "T.J. WHITE PINE MANOR APARTMENTS",
    "display_name": "T.J. WHITE PINE MANOR APARTMENTS",
    "county": "MECOSTA",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007085",
    "resolved_pwsid": "MI0007085",
    "system_name": "T.J. WHITE PINE MANOR APARTMENTS",
    "display_name": "T.J. WHITE PINE MANOR APARTMENTS",
    "county": "MECOSTA",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007099",
    "resolved_pwsid": "MI0007099",
    "system_name": "VILLAGE AT EAGLE GARDENS",
    "display_name": "VILLAGE AT EAGLE GARDENS",
    "county": "WASHTENAW",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007099",
    "resolved_pwsid": "MI0007099",
    "system_name": "VILLAGE AT EAGLE GARDENS",
    "display_name": "VILLAGE AT EAGLE GARDENS",
    "county": "WASHTENAW",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007099",
    "resolved_pwsid": "MI0007099",
    "system_name": "VILLAGE AT EAGLE GARDENS",
    "display_name": "VILLAGE AT EAGLE GARDENS",
    "county": "WASHTENAW",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007099",
    "resolved_pwsid": "MI0007099",
    "system_name": "VILLAGE AT EAGLE GARDENS",
    "display_name": "VILLAGE AT EAGLE GARDENS",
    "county": "WASHTENAW",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007100",
    "resolved_pwsid": "MI0007100",
    "system_name": "WHITEHALL",
    "display_name": "WHITEHALL",
    "county": "MUSKEGON",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007100",
    "resolved_pwsid": "MI0007100",
    "system_name": "WHITEHALL",
    "display_name": "WHITEHALL",
    "county": "MUSKEGON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007100",
    "resolved_pwsid": "MI0007100",
    "system_name": "WHITEHALL",
    "display_name": "WHITEHALL",
    "county": "MUSKEGON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 26,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007100",
    "resolved_pwsid": "MI0007100",
    "system_name": "WHITEHALL",
    "display_name": "WHITEHALL",
    "county": "MUSKEGON",
    "monitoring_end_date": "",
    "year": 2021,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 8,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007100",
    "resolved_pwsid": "MI0007100",
    "system_name": "WHITEHALL",
    "display_name": "WHITEHALL",
    "county": "MUSKEGON",
    "monitoring_end_date": "",
    "year": 2022,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 31,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007100",
    "resolved_pwsid": "MI0007100",
    "system_name": "WHITEHALL",
    "display_name": "WHITEHALL",
    "county": "MUSKEGON",
    "monitoring_end_date": "",
    "year": 2024,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 31,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007100",
    "resolved_pwsid": "MI0007100",
    "system_name": "WHITEHALL",
    "display_name": "WHITEHALL",
    "county": "MUSKEGON",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 27,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007101",
    "resolved_pwsid": "MI0007101",
    "system_name": "WHITMORE LAKE APARTMENTS",
    "display_name": "WHITMORE LAKE APARTMENTS",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007101",
    "resolved_pwsid": "MI0007101",
    "system_name": "WHITMORE LAKE APARTMENTS",
    "display_name": "WHITMORE LAKE APARTMENTS",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007101",
    "resolved_pwsid": "MI0007101",
    "system_name": "WHITMORE LAKE APARTMENTS",
    "display_name": "WHITMORE LAKE APARTMENTS",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007103",
    "resolved_pwsid": "MI0007103",
    "system_name": "HOMESTEAD/CRYSTAL RIVER WATER CO",
    "display_name": "HOMESTEAD/CRYSTAL RIVER WATER CO",
    "county": "LEELANAU",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007103",
    "resolved_pwsid": "MI0007103",
    "system_name": "HOMESTEAD/CRYSTAL RIVER WATER CO",
    "display_name": "HOMESTEAD/CRYSTAL RIVER WATER CO",
    "county": "LEELANAU",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007103",
    "resolved_pwsid": "MI0007103",
    "system_name": "HOMESTEAD/CRYSTAL RIVER WATER CO",
    "display_name": "HOMESTEAD/CRYSTAL RIVER WATER CO",
    "county": "LEELANAU",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007104",
    "resolved_pwsid": "MI0007104",
    "system_name": "WHITTEMORE SQUARE APARTMENTS",
    "display_name": "WHITTEMORE SQUARE APARTMENTS",
    "county": "IOSCO",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007104",
    "resolved_pwsid": "MI0007104",
    "system_name": "WHITTEMORE SQUARE APARTMENTS",
    "display_name": "WHITTEMORE SQUARE APARTMENTS",
    "county": "IOSCO",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007104",
    "resolved_pwsid": "MI0007104",
    "system_name": "WHITTEMORE SQUARE APARTMENTS",
    "display_name": "WHITTEMORE SQUARE APARTMENTS",
    "county": "IOSCO",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007105",
    "resolved_pwsid": "MI0007105",
    "system_name": "WILDWOOD ON WALLOON ASSOCIATION",
    "display_name": "WILDWOOD ON WALLOON ASSOCIATION",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007105",
    "resolved_pwsid": "MI0007105",
    "system_name": "WILDWOOD ON WALLOON ASSOCIATION",
    "display_name": "WILDWOOD ON WALLOON ASSOCIATION",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007105",
    "resolved_pwsid": "MI0007105",
    "system_name": "WILDWOOD ON WALLOON ASSOCIATION",
    "display_name": "WILDWOOD ON WALLOON ASSOCIATION",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007105",
    "resolved_pwsid": "MI0007105",
    "system_name": "WILDWOOD ON WALLOON ASSOCIATION",
    "display_name": "WILDWOOD ON WALLOON ASSOCIATION",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007105",
    "resolved_pwsid": "MI0007105",
    "system_name": "WILDWOOD ON WALLOON ASSOCIATION",
    "display_name": "WILDWOOD ON WALLOON ASSOCIATION",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 14,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007105",
    "resolved_pwsid": "MI0007105",
    "system_name": "WILDWOOD ON WALLOON ASSOCIATION",
    "display_name": "WILDWOOD ON WALLOON ASSOCIATION",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007105",
    "resolved_pwsid": "MI0007105",
    "system_name": "WILDWOOD ON WALLOON ASSOCIATION",
    "display_name": "WILDWOOD ON WALLOON ASSOCIATION",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 10,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007105",
    "resolved_pwsid": "MI0007105",
    "system_name": "WILDWOOD ON WALLOON ASSOCIATION",
    "display_name": "WILDWOOD ON WALLOON ASSOCIATION",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 10,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007120",
    "resolved_pwsid": "MI0007120",
    "system_name": "WILLIAMSTON, CITY OF",
    "display_name": "WILLIAMSTON, CITY OF",
    "county": "INGHAM",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007120",
    "resolved_pwsid": "MI0007120",
    "system_name": "WILLIAMSTON, CITY OF",
    "display_name": "WILLIAMSTON, CITY OF",
    "county": "INGHAM",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007120",
    "resolved_pwsid": "MI0007120",
    "system_name": "WILLIAMSTON, CITY OF",
    "display_name": "WILLIAMSTON, CITY OF",
    "county": "INGHAM",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007120",
    "resolved_pwsid": "MI0007120",
    "system_name": "WILLIAMSTON, CITY OF",
    "display_name": "WILLIAMSTON, CITY OF",
    "county": "INGHAM",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 3,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007120",
    "resolved_pwsid": "MI0007120",
    "system_name": "WILLIAMSTON, CITY OF",
    "display_name": "WILLIAMSTON, CITY OF",
    "county": "INGHAM",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": 2,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007120",
    "resolved_pwsid": "MI0007120",
    "system_name": "WILLIAMSTON, CITY OF",
    "display_name": "WILLIAMSTON, CITY OF",
    "county": "INGHAM",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007120",
    "resolved_pwsid": "MI0007120",
    "system_name": "WILLIAMSTON, CITY OF",
    "display_name": "WILLIAMSTON, CITY OF",
    "county": "INGHAM",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007120",
    "resolved_pwsid": "MI0007120",
    "system_name": "WILLIAMSTON, CITY OF",
    "display_name": "WILLIAMSTON, CITY OF",
    "county": "INGHAM",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0007125",
    "resolved_pwsid": "MI0007125",
    "system_name": "WILLIAMS TOWNSHIP",
    "display_name": "WILLIAMS TOWNSHIP",
    "county": "BAY",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007125",
    "resolved_pwsid": "MI0007125",
    "system_name": "WILLIAMS TOWNSHIP",
    "display_name": "WILLIAMS TOWNSHIP",
    "county": "BAY",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007125",
    "resolved_pwsid": "MI0007125",
    "system_name": "WILLIAMS TOWNSHIP",
    "display_name": "WILLIAMS TOWNSHIP",
    "county": "BAY",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007125",
    "resolved_pwsid": "MI0007125",
    "system_name": "WILLIAMS TOWNSHIP",
    "display_name": "WILLIAMS TOWNSHIP",
    "county": "BAY",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007125",
    "resolved_pwsid": "MI0007125",
    "system_name": "WILLIAMS TOWNSHIP",
    "display_name": "WILLIAMS TOWNSHIP",
    "county": "BAY",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007125",
    "resolved_pwsid": "MI0007125",
    "system_name": "WILLIAMS TOWNSHIP",
    "display_name": "WILLIAMS TOWNSHIP",
    "county": "BAY",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007125",
    "resolved_pwsid": "MI0007125",
    "system_name": "WILLIAMS TOWNSHIP",
    "display_name": "WILLIAMS TOWNSHIP",
    "county": "BAY",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007126",
    "resolved_pwsid": "MI0007126",
    "system_name": "WINDJAMMER COVE CONDOMINIUMS",
    "display_name": "WINDJAMMER COVE CONDOMINIUMS",
    "county": "EMMET",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007126",
    "resolved_pwsid": "MI0007126-a",
    "system_name": "WINDJAMMER COVE COMMUNITY SYSTEM BOARD",
    "display_name": "WINDJAMMER COVE CONDOMINIUMS",
    "county": "EMMET",
    "monitoring_end_date": "2025-06-30",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0007130",
    "resolved_pwsid": "MI0007130",
    "system_name": "WINDWARD OWNERS ASSOCIATION",
    "display_name": "WINDWARD OWNERS ASSOCIATION",
    "county": "EMMET",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 12,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007130",
    "resolved_pwsid": "MI0007130",
    "system_name": "WINDWARD OWNERS ASSOCIATION",
    "display_name": "WINDWARD OWNERS ASSOCIATION",
    "county": "EMMET",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007130",
    "resolved_pwsid": "MI0007130",
    "system_name": "WINDWARD OWNERS ASSOCIATION",
    "display_name": "WINDWARD OWNERS ASSOCIATION",
    "county": "EMMET",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007134",
    "resolved_pwsid": "MI0007134",
    "system_name": "WISNER AREA WATER SYSTEM",
    "display_name": "WISNER AREA WATER SYSTEM",
    "county": "TUSCOLA",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007134",
    "resolved_pwsid": "MI0007134",
    "system_name": "WISNER AREA WATER SYSTEM",
    "display_name": "WISNER AREA WATER SYSTEM",
    "county": "TUSCOLA",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007134",
    "resolved_pwsid": "MI0007134",
    "system_name": "WISNER AREA WATER SYSTEM",
    "display_name": "WISNER AREA WATER SYSTEM",
    "county": "TUSCOLA",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007134",
    "resolved_pwsid": "MI0007134",
    "system_name": "WISNER AREA WATER SYSTEM",
    "display_name": "WISNER AREA WATER SYSTEM",
    "county": "TUSCOLA",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007134",
    "resolved_pwsid": "MI0007134",
    "system_name": "WISNER AREA WATER SYSTEM",
    "display_name": "WISNER AREA WATER SYSTEM",
    "county": "TUSCOLA",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007134",
    "resolved_pwsid": "MI0007134",
    "system_name": "WISNER AREA WATER SYSTEM",
    "display_name": "WISNER AREA WATER SYSTEM",
    "county": "TUSCOLA",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007134",
    "resolved_pwsid": "MI0007134",
    "system_name": "WISNER AREA WATER SYSTEM",
    "display_name": "WISNER AREA WATER SYSTEM",
    "county": "TUSCOLA",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007135",
    "resolved_pwsid": "MI0007135",
    "system_name": "WIXOM, CITY OF",
    "display_name": "WIXOM, CITY OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007135",
    "resolved_pwsid": "MI0007135",
    "system_name": "WIXOM, CITY OF",
    "display_name": "WIXOM, CITY OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007135",
    "resolved_pwsid": "MI0007135",
    "system_name": "WIXOM, CITY OF",
    "display_name": "WIXOM, CITY OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007135",
    "resolved_pwsid": "MI0007135",
    "system_name": "WIXOM, CITY OF",
    "display_name": "WIXOM, CITY OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007135",
    "resolved_pwsid": "MI0007135",
    "system_name": "WIXOM, CITY OF",
    "display_name": "WIXOM, CITY OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007135",
    "resolved_pwsid": "MI0007135",
    "system_name": "WIXOM, CITY OF",
    "display_name": "WIXOM, CITY OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007135",
    "resolved_pwsid": "MI0007135",
    "system_name": "WIXOM, CITY OF",
    "display_name": "WIXOM, CITY OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007135",
    "resolved_pwsid": "MI0007135",
    "system_name": "WIXOM, CITY OF",
    "display_name": "WIXOM, CITY OF",
    "county": "OAKLAND",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 4,
    "inventory_unknown": 224,
    "total_to_identify_or_replace": 228,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0007160",
    "resolved_pwsid": "MI0007160",
    "system_name": "WOODBINE SUBDIVISION",
    "display_name": "WOODBINE SUBDIVISION",
    "county": "OAKLAND",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007160",
    "resolved_pwsid": "MI0007160",
    "system_name": "WOODBINE SUBDIVISION",
    "display_name": "WOODBINE SUBDIVISION",
    "county": "OAKLAND",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007160",
    "resolved_pwsid": "MI0007160",
    "system_name": "WOODBINE SUBDIVISION",
    "display_name": "WOODBINE SUBDIVISION",
    "county": "OAKLAND",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007180",
    "resolved_pwsid": "MI0007180",
    "system_name": "WOODHAVEN",
    "display_name": "WOODHAVEN",
    "county": "WAYNE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007180",
    "resolved_pwsid": "MI0007180",
    "system_name": "WOODHAVEN",
    "display_name": "WOODHAVEN",
    "county": "WAYNE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007180",
    "resolved_pwsid": "MI0007180",
    "system_name": "WOODHAVEN",
    "display_name": "WOODHAVEN",
    "county": "WAYNE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007180",
    "resolved_pwsid": "MI0007180",
    "system_name": "WOODHAVEN",
    "display_name": "WOODHAVEN",
    "county": "WAYNE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007180",
    "resolved_pwsid": "MI0007180",
    "system_name": "WOODHAVEN",
    "display_name": "WOODHAVEN",
    "county": "WAYNE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007180",
    "resolved_pwsid": "MI0007180",
    "system_name": "WOODHAVEN",
    "display_name": "WOODHAVEN",
    "county": "WAYNE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007180",
    "resolved_pwsid": "MI0007180",
    "system_name": "WOODHAVEN",
    "display_name": "WOODHAVEN",
    "county": "WAYNE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007180",
    "resolved_pwsid": "MI0007180",
    "system_name": "WOODHAVEN",
    "display_name": "WOODHAVEN",
    "county": "WAYNE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0007182",
    "resolved_pwsid": "MI0007182",
    "system_name": "WOODLAND PARK APARTMENTS",
    "display_name": "WOODLAND PARK APARTMENTS",
    "county": "BARRY",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007182",
    "resolved_pwsid": "MI0007182",
    "system_name": "WOODLAND PARK APARTMENTS",
    "display_name": "WOODLAND PARK APARTMENTS",
    "county": "BARRY",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007182",
    "resolved_pwsid": "MI0007182",
    "system_name": "WOODLAND PARK APARTMENTS",
    "display_name": "WOODLAND PARK APARTMENTS",
    "county": "BARRY",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007185",
    "resolved_pwsid": "MI0007185-a",
    "system_name": "WOODRUFF LAKE CO-OP APARTMENTS",
    "display_name": "WOODRUFF LAKE CO-OP APARTMENTS",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007185",
    "resolved_pwsid": "MI0007185-a",
    "system_name": "WOODRUFF LAKE CO-OP APARTMENTS",
    "display_name": "WOODRUFF LAKE CO-OP APARTMENTS",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007185",
    "resolved_pwsid": "MI0007185-b",
    "system_name": "WOODRUFF LAKE CONDOMINIUMS",
    "display_name": "WOODRUFF LAKE CONDOMINIUMS",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007185",
    "resolved_pwsid": "MI0007185-b",
    "system_name": "WOODRUFF LAKE CONDOMINIUMS",
    "display_name": "WOODRUFF LAKE CONDOMINIUMS",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007185",
    "resolved_pwsid": "MI0007185-c",
    "system_name": "WOODRUFF LAKE CONDOMINIUMS (DIST)",
    "display_name": "WOODRUFF LAKE CONDOMINIUMS (DIST)",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007185",
    "resolved_pwsid": "MI0007185-d",
    "system_name": "WOODRUFF LAKE CONDOMINIUMS (DIST2)",
    "display_name": "WOODRUFF LAKE CONDOMINIUMS (DIST2)",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007185",
    "resolved_pwsid": "MI0007185-f",
    "system_name": "WOODRUFF LAKE COOPERATIVE (DS002)",
    "display_name": "WOODRUFF LAKE COOPERATIVE (DS002)",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007185",
    "resolved_pwsid": "MI0007185-e",
    "system_name": "WOODRUFF LAKE COOPERATIVE (DS001)",
    "display_name": "WOODRUFF LAKE CONDOMINIUMS",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007186",
    "resolved_pwsid": "MI0007186",
    "system_name": "WOODS OF LOCHAVEN",
    "display_name": "WOODS OF LOCHAVEN",
    "county": "HILLSDALE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007186",
    "resolved_pwsid": "MI0007186",
    "system_name": "WOODS OF LOCHAVEN",
    "display_name": "WOODS OF LOCHAVEN",
    "county": "HILLSDALE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0007210",
    "resolved_pwsid": "MI0007210",
    "system_name": "WYANDOTTE",
    "display_name": "WYANDOTTE",
    "county": "WAYNE",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007210",
    "resolved_pwsid": "MI0007210",
    "system_name": "WYANDOTTE",
    "display_name": "WYANDOTTE",
    "county": "WAYNE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 9,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007210",
    "resolved_pwsid": "MI0007210",
    "system_name": "WYANDOTTE",
    "display_name": "WYANDOTTE",
    "county": "WAYNE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 12,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007210",
    "resolved_pwsid": "MI0007210",
    "system_name": "WYANDOTTE",
    "display_name": "WYANDOTTE",
    "county": "WAYNE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 12,
    "above_action_level": false,
    "lines_replaced": 30,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007210",
    "resolved_pwsid": "MI0007210",
    "system_name": "WYANDOTTE",
    "display_name": "WYANDOTTE",
    "county": "WAYNE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 11,
    "above_action_level": false,
    "lines_replaced": 53,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007210",
    "resolved_pwsid": "MI0007210",
    "system_name": "WYANDOTTE",
    "display_name": "WYANDOTTE",
    "county": "WAYNE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": 27,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007210",
    "resolved_pwsid": "MI0007210",
    "system_name": "WYANDOTTE",
    "display_name": "WYANDOTTE",
    "county": "WAYNE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 10,
    "above_action_level": false,
    "lines_replaced": 75,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007210",
    "resolved_pwsid": "MI0007210",
    "system_name": "WYANDOTTE",
    "display_name": "WYANDOTTE",
    "county": "WAYNE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": 47,
    "inventory_lead": 241,
    "inventory_gpcl": 11,
    "inventory_unknown": 9439,
    "total_to_identify_or_replace": 9691,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0007217",
    "resolved_pwsid": "MI0007217",
    "system_name": "WYNSTONE SUBDIVISION",
    "display_name": "WYNSTONE SUBDIVISION",
    "county": "OAKLAND",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007217",
    "resolved_pwsid": "MI0007217",
    "system_name": "WYNSTONE SUBDIVISION",
    "display_name": "WYNSTONE SUBDIVISION",
    "county": "OAKLAND",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007217",
    "resolved_pwsid": "MI0007217",
    "system_name": "WYNSTONE SUBDIVISION",
    "display_name": "WYNSTONE SUBDIVISION",
    "county": "OAKLAND",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007217",
    "resolved_pwsid": "MI0007217",
    "system_name": "WYNSTONE SUBDIVISION",
    "display_name": "WYNSTONE SUBDIVISION",
    "county": "OAKLAND",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007217",
    "resolved_pwsid": "MI0007217",
    "system_name": "WYNSTONE SUBDIVISION",
    "display_name": "WYNSTONE SUBDIVISION",
    "county": "OAKLAND",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0007220",
    "resolved_pwsid": "MI0007220",
    "system_name": "WYOMING",
    "display_name": "WYOMING",
    "county": "KENT",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007220",
    "resolved_pwsid": "MI0007220",
    "system_name": "WYOMING",
    "display_name": "WYOMING",
    "county": "KENT",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007220",
    "resolved_pwsid": "MI0007220",
    "system_name": "WYOMING",
    "display_name": "WYOMING",
    "county": "KENT",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007220",
    "resolved_pwsid": "MI0007220",
    "system_name": "WYOMING",
    "display_name": "WYOMING",
    "county": "KENT",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": 2,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007220",
    "resolved_pwsid": "MI0007220",
    "system_name": "WYOMING",
    "display_name": "WYOMING",
    "county": "KENT",
    "monitoring_end_date": "",
    "year": 2021,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 2,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007230",
    "resolved_pwsid": "MI0007230",
    "system_name": "YALE, CITY OF",
    "display_name": "YALE, CITY OF",
    "county": "ST CLAIR",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007230",
    "resolved_pwsid": "MI0007230",
    "system_name": "YALE, CITY OF",
    "display_name": "YALE, CITY OF",
    "county": "ST CLAIR",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007230",
    "resolved_pwsid": "MI0007230",
    "system_name": "YALE, CITY OF",
    "display_name": "YALE, CITY OF",
    "county": "ST. CLAIR",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007230",
    "resolved_pwsid": "MI0007230",
    "system_name": "YALE, CITY OF",
    "display_name": "YALE, CITY OF",
    "county": "ST. CLAIR",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 2,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 38,
    "total_to_identify_or_replace": 38,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007231",
    "resolved_pwsid": "MI0007231",
    "system_name": "YANKEE SPRINGS TOWNSHIP",
    "display_name": "YANKEE SPRINGS TOWNSHIP",
    "county": "BARRY",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007231",
    "resolved_pwsid": "MI0007231",
    "system_name": "YANKEE SPRINGS TOWNSHIP",
    "display_name": "YANKEE SPRINGS TOWNSHIP",
    "county": "BARRY",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007231",
    "resolved_pwsid": "MI0007231",
    "system_name": "YANKEE SPRINGS TOWNSHIP",
    "display_name": "YANKEE SPRINGS TOWNSHIP",
    "county": "BARRY",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007233",
    "resolved_pwsid": "MI0007233",
    "system_name": "IDLEWILD GARDEN HOUSING",
    "display_name": "IDLEWILD GARDEN HOUSING",
    "county": "LAKE",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007233",
    "resolved_pwsid": "MI0007233",
    "system_name": "IDLEWILD GARDEN HOUSING",
    "display_name": "IDLEWILD GARDEN HOUSING",
    "county": "LAKE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007233",
    "resolved_pwsid": "MI0007233",
    "system_name": "IDLEWILD GARDEN HOUSING",
    "display_name": "IDLEWILD GARDEN HOUSING",
    "county": "LAKE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007233",
    "resolved_pwsid": "MI0007233",
    "system_name": "IDLEWILD GARDEN HOUSING",
    "display_name": "IDLEWILD GARDEN HOUSING",
    "county": "LAKE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0007235",
    "resolved_pwsid": "MI0007235",
    "system_name": "YODER APARTMENTS",
    "display_name": "YODER APARTMENTS",
    "county": "MIDLAND",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007235",
    "resolved_pwsid": "MI0007235",
    "system_name": "YODER APARTMENTS",
    "display_name": "YODER APARTMENTS",
    "county": "MIDLAND",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007235",
    "resolved_pwsid": "MI0007235",
    "system_name": "YODER APARTMENTS",
    "display_name": "YODER APARTMENTS",
    "county": "MIDLAND",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007235",
    "resolved_pwsid": "MI0007235",
    "system_name": "YODER APARTMENTS",
    "display_name": "YODER APARTMENTS",
    "county": "MIDLAND",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007240",
    "resolved_pwsid": "MI0007240",
    "system_name": "YORK CONDOMINIUMS",
    "display_name": "YORK CONDOMINIUMS",
    "county": "LEELANAU",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007240",
    "resolved_pwsid": "MI0007240",
    "system_name": "YORK CONDOMINIUMS",
    "display_name": "YORK CONDOMINIUMS",
    "county": "LEELANAU",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007240",
    "resolved_pwsid": "MI0007240",
    "system_name": "YORK CONDOMINIUMS",
    "display_name": "YORK CONDOMINIUMS",
    "county": "LEELANAU",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007260",
    "resolved_pwsid": "MI0007260",
    "system_name": "YPSILANTI COMMUNITY UTILITY AUTHORITY",
    "display_name": "YPSILANTI COMMUNITY UTILITY AUTHORITY",
    "county": "WASHTENAW",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007260",
    "resolved_pwsid": "MI0007260",
    "system_name": "YPSILANTI COMMUNITY UTILITY AUTHORITY",
    "display_name": "YPSILANTI COMMUNITY UTILITY AUTHORITY",
    "county": "WASHTENAW",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 9,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007260",
    "resolved_pwsid": "MI0007260",
    "system_name": "YPSILANTI COMMUNITY UTILITY AUTHORITY",
    "display_name": "YPSILANTI COMMUNITY UTILITY AUTHORITY",
    "county": "WASHTENAW",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007260",
    "resolved_pwsid": "MI0007260",
    "system_name": "YPSILANTI COMMUNITY UTILITY AUTHORITY",
    "display_name": "YPSILANTI COMMUNITY UTILITY AUTHORITY",
    "county": "WASHTENAW",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 9,
    "above_action_level": false,
    "lines_replaced": 20,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007260",
    "resolved_pwsid": "MI0007260",
    "system_name": "YPSILANTI COMMUNITY UTILITY AUTHORITY",
    "display_name": "YPSILANTI COMMUNITY UTILITY AUTHORITY",
    "county": "WASHTENAW",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": 67,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007260",
    "resolved_pwsid": "MI0007260",
    "system_name": "YPSILANTI COMMUNITY UTILITY AUTHORITY",
    "display_name": "YPSILANTI COMMUNITY UTILITY AUTHORITY",
    "county": "WASHTENAW",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": 18,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007260",
    "resolved_pwsid": "MI0007260",
    "system_name": "YPSILANTI COMMUNITY UTILITY AUTHORITY",
    "display_name": "YPSILANTI COMMUNITY UTILITY AUTHORITY",
    "county": "WASHTENAW",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": 22,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007260",
    "resolved_pwsid": "MI0007260",
    "system_name": "YPSILANTI COMMUNITY UTILITY AUTHORITY",
    "display_name": "YPSILANTI COMMUNITY UTILITY AUTHORITY",
    "county": "WASHTENAW",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": 49,
    "inventory_lead": 155,
    "inventory_gpcl": 364,
    "inventory_unknown": 758,
    "total_to_identify_or_replace": 1277,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0007270",
    "resolved_pwsid": "MI0007270",
    "system_name": "ZEELAND BOARD OF PUBLIC WORKS",
    "display_name": "ZEELAND BOARD OF PUBLIC WORKS",
    "county": "OTTAWA",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007270",
    "resolved_pwsid": "MI0007270",
    "system_name": "ZEELAND BOARD OF PUBLIC WORKS",
    "display_name": "ZEELAND BOARD OF PUBLIC WORKS",
    "county": "OTTAWA",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007270",
    "resolved_pwsid": "MI0007270",
    "system_name": "ZEELAND BOARD OF PUBLIC WORKS",
    "display_name": "ZEELAND BOARD OF PUBLIC WORKS",
    "county": "OTTAWA",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 138,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007270",
    "resolved_pwsid": "MI0007270",
    "system_name": "ZEELAND BOARD OF PUBLIC WORKS",
    "display_name": "ZEELAND BOARD OF PUBLIC WORKS",
    "county": "OTTAWA",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": 108,
    "inventory_lead": 31,
    "inventory_gpcl": 269,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 300,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0007270",
    "resolved_pwsid": "MI0007270",
    "system_name": "ZEELAND BOARD OF PUBLIC WORKS",
    "display_name": "ZEELAND BOARD OF PUBLIC WORKS",
    "county": "OTTAWA",
    "monitoring_end_date": "",
    "year": 2021,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 81,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007270",
    "resolved_pwsid": "MI0007270",
    "system_name": "ZEELAND BOARD OF PUBLIC WORKS",
    "display_name": "ZEELAND BOARD OF PUBLIC WORKS",
    "county": "OTTAWA",
    "monitoring_end_date": "",
    "year": 2023,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 246,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007270",
    "resolved_pwsid": "MI0007270",
    "system_name": "ZEELAND BOARD OF PUBLIC WORKS",
    "display_name": "ZEELAND BOARD OF PUBLIC WORKS",
    "county": "OTTAWA",
    "monitoring_end_date": "",
    "year": 2024,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 133,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007280",
    "resolved_pwsid": "MI0007280",
    "system_name": "ZILWAUKEE, CITY OF",
    "display_name": "ZILWAUKEE, CITY OF",
    "county": "SAGINAW",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007280",
    "resolved_pwsid": "MI0007280",
    "system_name": "ZILWAUKEE, CITY OF",
    "display_name": "ZILWAUKEE, CITY OF",
    "county": "SAGINAW",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007280",
    "resolved_pwsid": "MI0007280",
    "system_name": "ZILWAUKEE, CITY OF",
    "display_name": "ZILWAUKEE, CITY OF",
    "county": "SAGINAW",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007280",
    "resolved_pwsid": "MI0007280",
    "system_name": "ZILWAUKEE, CITY OF",
    "display_name": "ZILWAUKEE, CITY OF",
    "county": "SAGINAW",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007280",
    "resolved_pwsid": "MI0007280",
    "system_name": "ZILWAUKEE, CITY OF",
    "display_name": "ZILWAUKEE, CITY OF",
    "county": "SAGINAW",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007280",
    "resolved_pwsid": "MI0007280",
    "system_name": "ZILWAUKEE, CITY OF",
    "display_name": "ZILWAUKEE, CITY OF",
    "county": "SAGINAW",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007280",
    "resolved_pwsid": "MI0007280",
    "system_name": "ZILWAUKEE, CITY OF",
    "display_name": "ZILWAUKEE, CITY OF",
    "county": "SAGINAW",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007285",
    "resolved_pwsid": "MI0007285",
    "system_name": "EAGLE POINTE CONDOMINIUMS",
    "display_name": "EAGLE POINTE CONDOMINIUMS",
    "county": "INGHAM",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007285",
    "resolved_pwsid": "MI0007285",
    "system_name": "EAGLE POINTE CONDOMINIUMS",
    "display_name": "EAGLE POINTE CONDOMINIUMS",
    "county": "INGHAM",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007285",
    "resolved_pwsid": "MI0007285",
    "system_name": "EAGLE POINTE CONDOMINIUMS",
    "display_name": "EAGLE POINTE CONDOMINIUMS",
    "county": "INGHAM",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0007285",
    "resolved_pwsid": "MI0007285",
    "system_name": "EAGLE POINTE CONDOMINIUMS",
    "display_name": "EAGLE POINTE CONDOMINIUMS",
    "county": "INGHAM",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040001",
    "resolved_pwsid": "MI0040001",
    "system_name": "LINCOLN ESTATES",
    "display_name": "LINCOLN ESTATES",
    "county": "ALCONA",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040001",
    "resolved_pwsid": "MI0040001",
    "system_name": "LINCOLN ESTATES",
    "display_name": "LINCOLN ESTATES",
    "county": "ALCONA",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040001",
    "resolved_pwsid": "MI0040001",
    "system_name": "LINCOLN ESTATES",
    "display_name": "LINCOLN ESTATES",
    "county": "ALCONA",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040001",
    "resolved_pwsid": "MI0040001",
    "system_name": "LINCOLN ESTATES",
    "display_name": "LINCOLN ESTATES",
    "county": "ALCONA",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0040002",
    "resolved_pwsid": "MI0040002",
    "system_name": "ALLEGAN MOBILE ESTATES",
    "display_name": "ALLEGAN MOBILE ESTATES",
    "county": "ALLEGAN",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040002",
    "resolved_pwsid": "MI0040002",
    "system_name": "ALLEGAN MOBILE ESTATES",
    "display_name": "ALLEGAN MOBILE ESTATES",
    "county": "ALLEGAN",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040002",
    "resolved_pwsid": "MI0040002",
    "system_name": "ALLEGAN MOBILE ESTATES",
    "display_name": "ALLEGAN MOBILE ESTATES",
    "county": "ALLEGAN",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040003",
    "resolved_pwsid": "MI0040003",
    "system_name": "ANDREWS MOBILE HOME PARK",
    "display_name": "ANDREWS MOBILE HOME PARK",
    "county": "ALLEGAN",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040003",
    "resolved_pwsid": "MI0040003",
    "system_name": "ANDREWS MOBILE HOME PARK",
    "display_name": "ANDREWS MOBILE HOME PARK",
    "county": "ALLEGAN",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040004",
    "resolved_pwsid": "MI0040004",
    "system_name": "COUNTRY MEADOWS",
    "display_name": "COUNTRY MEADOWS",
    "county": "ALLEGAN",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040004",
    "resolved_pwsid": "MI0040004",
    "system_name": "COUNTRY MEADOWS",
    "display_name": "COUNTRY MEADOWS",
    "county": "ALLEGAN",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040004",
    "resolved_pwsid": "MI0040004",
    "system_name": "COUNTRY MEADOWS",
    "display_name": "COUNTRY MEADOWS",
    "county": "ALLEGAN",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040004",
    "resolved_pwsid": "MI0040004",
    "system_name": "COUNTRY MEADOWS",
    "display_name": "COUNTRY MEADOWS",
    "county": "ALLEGAN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040005",
    "resolved_pwsid": "MI0040005",
    "system_name": "BASELINE MOBILE HOME PARK",
    "display_name": "BASELINE MOBILE HOME PARK",
    "county": "ALLEGAN",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040005",
    "resolved_pwsid": "MI0040005",
    "system_name": "BASELINE MOBILE HOME PARK",
    "display_name": "BASELINE MOBILE HOME PARK",
    "county": "ALLEGAN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040005",
    "resolved_pwsid": "MI0040005",
    "system_name": "BASELINE MOBILE HOME PARK",
    "display_name": "BASELINE MOBILE HOME PARK",
    "county": "ALLEGAN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040006",
    "resolved_pwsid": "MI0040006",
    "system_name": "COUNTRY ACRES MOBILE HOME PARK",
    "display_name": "COUNTRY ACRES MOBILE HOME PARK",
    "county": "ALLEGAN",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040006",
    "resolved_pwsid": "MI0040006",
    "system_name": "COUNTRY ACRES MOBILE HOME PARK",
    "display_name": "COUNTRY ACRES MOBILE HOME PARK",
    "county": "ALLEGAN",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040006",
    "resolved_pwsid": "MI0040006",
    "system_name": "COUNTRY ACRES MOBILE HOME PARK",
    "display_name": "COUNTRY ACRES MOBILE HOME PARK",
    "county": "ALLEGAN",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040007",
    "resolved_pwsid": "MI0040007",
    "system_name": "TOPAZ MOBILE HOME PARK",
    "display_name": "TOPAZ MOBILE HOME PARK",
    "county": "ALLEGAN",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040007",
    "resolved_pwsid": "MI0040007",
    "system_name": "TOPAZ MOBILE HOME PARK",
    "display_name": "TOPAZ MOBILE HOME PARK",
    "county": "ALLEGAN",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040007",
    "resolved_pwsid": "MI0040007",
    "system_name": "TOPAZ MOBILE HOME PARK",
    "display_name": "TOPAZ MOBILE HOME PARK",
    "county": "ALLEGAN",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040008",
    "resolved_pwsid": "MI0040008",
    "system_name": "DOGWOOD MANOR MOBILE HOME PARK",
    "display_name": "DOGWOOD MANOR MOBILE HOME PARK",
    "county": "ALLEGAN",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040008",
    "resolved_pwsid": "MI0040008",
    "system_name": "DOGWOOD MANOR MOBILE HOME PARK",
    "display_name": "DOGWOOD MANOR MOBILE HOME PARK",
    "county": "ALLEGAN",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040008",
    "resolved_pwsid": "MI0040008",
    "system_name": "DOGWOOD MANOR MOBILE HOME PARK",
    "display_name": "DOGWOOD MANOR MOBILE HOME PARK",
    "county": "ALLEGAN",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040011",
    "resolved_pwsid": "MI0040011",
    "system_name": "GUN RIVER MOBILE ESTATES",
    "display_name": "GUN RIVER MOBILE ESTATES",
    "county": "ALLEGAN",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040011",
    "resolved_pwsid": "MI0040011",
    "system_name": "GUN RIVER MOBILE ESTATES",
    "display_name": "GUN RIVER MOBILE ESTATES",
    "county": "ALLEGAN",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040011",
    "resolved_pwsid": "MI0040011",
    "system_name": "GUN RIVER MOBILE ESTATES",
    "display_name": "GUN RIVER MOBILE ESTATES",
    "county": "ALLEGAN",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040011",
    "resolved_pwsid": "MI0040011",
    "system_name": "GUN RIVER MOBILE ESTATES",
    "display_name": "GUN RIVER MOBILE ESTATES",
    "county": "ALLEGAN",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040013",
    "resolved_pwsid": "MI0040013",
    "system_name": "SAPPHIRE ESTATES MOBILE HOME PARK",
    "display_name": "SAPPHIRE ESTATES MOBILE HOME PARK",
    "county": "ALLEGAN",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040013",
    "resolved_pwsid": "MI0040013",
    "system_name": "SAPPHIRE ESTATES MOBILE HOME PARK",
    "display_name": "SAPPHIRE ESTATES MOBILE HOME PARK",
    "county": "ALLEGAN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040013",
    "resolved_pwsid": "MI0040013",
    "system_name": "SAPPHIRE ESTATES MOBILE HOME PARK",
    "display_name": "SAPPHIRE ESTATES MOBILE HOME PARK",
    "county": "ALLEGAN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040014",
    "resolved_pwsid": "MI0040014",
    "system_name": "HOMECREST VILLA MOBILE HOME PARK",
    "display_name": "HOMECREST VILLA MOBILE HOME PARK",
    "county": "ALLEGAN",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040014",
    "resolved_pwsid": "MI0040014",
    "system_name": "HOMECREST VILLA MOBILE HOME PARK",
    "display_name": "HOMECREST VILLA MOBILE HOME PARK",
    "county": "ALLEGAN",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040014",
    "resolved_pwsid": "MI0040014",
    "system_name": "HOMECREST VILLA MOBILE HOME PARK",
    "display_name": "HOMECREST VILLA MOBILE HOME PARK",
    "county": "ALLEGAN",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040015",
    "resolved_pwsid": "MI0040015",
    "system_name": "INDIAN ACRES MOBILE HOME PARK",
    "display_name": "INDIAN ACRES MOBILE HOME PARK",
    "county": "ALLEGAN",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040015",
    "resolved_pwsid": "MI0040015",
    "system_name": "INDIAN ACRES MOBILE HOME PARK",
    "display_name": "INDIAN ACRES MOBILE HOME PARK",
    "county": "ALLEGAN",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040015",
    "resolved_pwsid": "MI0040015",
    "system_name": "INDIAN ACRES MOBILE HOME PARK",
    "display_name": "INDIAN ACRES MOBILE HOME PARK",
    "county": "ALLEGAN",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040016",
    "resolved_pwsid": "MI0040016",
    "system_name": "JOHNSONS MOBILE VILLAGE",
    "display_name": "JOHNSONS MOBILE VILLAGE",
    "county": "ALLEGAN",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040016",
    "resolved_pwsid": "MI0040016",
    "system_name": "JOHNSONS MOBILE VILLAGE",
    "display_name": "JOHNSONS MOBILE VILLAGE",
    "county": "ALLEGAN",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040016",
    "resolved_pwsid": "MI0040016",
    "system_name": "JOHNSONS MOBILE VILLAGE",
    "display_name": "JOHNSONS MOBILE VILLAGE",
    "county": "ALLEGAN",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040018",
    "resolved_pwsid": "MI0040018",
    "system_name": "LAKESIDE PARK MHP",
    "display_name": "LAKESIDE PARK MHP",
    "county": "ALLEGAN",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040018",
    "resolved_pwsid": "MI0040018",
    "system_name": "LAKESIDE PARK MHP",
    "display_name": "LAKESIDE PARK MHP",
    "county": "ALLEGAN",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040020",
    "resolved_pwsid": "MI0040020",
    "system_name": "MAPLE GROVE ESTATES",
    "display_name": "MAPLE GROVE ESTATES",
    "county": "ALLEGAN",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040020",
    "resolved_pwsid": "MI0040020",
    "system_name": "MAPLE GROVE ESTATES",
    "display_name": "MAPLE GROVE ESTATES",
    "county": "ALLEGAN",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040020",
    "resolved_pwsid": "MI0040020",
    "system_name": "MAPLE GROVE ESTATES",
    "display_name": "MAPLE GROVE ESTATES",
    "county": "ALLEGAN",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040020",
    "resolved_pwsid": "MI0040020",
    "system_name": "MAPLE GROVE ESTATES",
    "display_name": "MAPLE GROVE ESTATES",
    "county": "ALLEGAN",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040021",
    "resolved_pwsid": "MI0040021",
    "system_name": "RABBIT RIVER ESTATES",
    "display_name": "RABBIT RIVER ESTATES",
    "county": "ALLEGAN",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040021",
    "resolved_pwsid": "MI0040021",
    "system_name": "RABBIT RIVER ESTATES",
    "display_name": "RABBIT RIVER ESTATES",
    "county": "ALLEGAN",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040021",
    "resolved_pwsid": "MI0040021",
    "system_name": "RABBIT RIVER ESTATES",
    "display_name": "RABBIT RIVER ESTATES",
    "county": "ALLEGAN",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040021",
    "resolved_pwsid": "MI0040021",
    "system_name": "RABBIT RIVER ESTATES",
    "display_name": "RABBIT RIVER ESTATES",
    "county": "ALLEGAN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040023",
    "resolved_pwsid": "MI0040023-b",
    "system_name": "RIVERVIEW MOBILE HOME PARK",
    "display_name": "RIVERVIEW MOBILE HOME PARK",
    "county": "ALLEGAN",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040023",
    "resolved_pwsid": "MI0040023-b",
    "system_name": "RIVERVIEW MOBILE HOME PARK",
    "display_name": "RIVERVIEW MOBILE HOME PARK",
    "county": "ALLEGAN",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040023",
    "resolved_pwsid": "MI0040023-a",
    "system_name": "AMBER ESTATES MOBILE HOME PARK",
    "display_name": "AMBER ESTATES MOBILE HOME PARK",
    "county": "ALLEGAN",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040023",
    "resolved_pwsid": "MI0040023-a",
    "system_name": "AMBER ESTATES MOBILE HOME PARK",
    "display_name": "AMBER ESTATES MOBILE HOME PARK",
    "county": "ALLEGAN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040024",
    "resolved_pwsid": "MI0040024",
    "system_name": "SELKIRK LAKE MOBILE HOME PARK",
    "display_name": "SELKIRK LAKE MOBILE HOME PARK",
    "county": "ALLEGAN",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040024",
    "resolved_pwsid": "MI0040024",
    "system_name": "SELKIRK LAKE MOBILE HOME PARK",
    "display_name": "SELKIRK LAKE MOBILE HOME PARK",
    "county": "ALLEGAN",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040024",
    "resolved_pwsid": "MI0040024",
    "system_name": "SELKIRK LAKE MOBILE HOME PARK",
    "display_name": "SELKIRK LAKE MOBILE HOME PARK",
    "county": "ALLEGAN",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040024",
    "resolved_pwsid": "MI0040024",
    "system_name": "SELKIRK LAKE MOBILE HOME PARK",
    "display_name": "SELKIRK LAKE MOBILE HOME PARK",
    "county": "ALLEGAN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040025",
    "resolved_pwsid": "MI0040025-b",
    "system_name": "SHADY ACRES MOBILE VILLAGE",
    "display_name": "SHADY ACRES MOBILE VILLAGE",
    "county": "ALLEGAN",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040025",
    "resolved_pwsid": "MI0040025-b",
    "system_name": "SHADY ACRES MOBILE VILLAGE",
    "display_name": "SHADY ACRES MOBILE VILLAGE",
    "county": "ALLEGAN",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040025",
    "resolved_pwsid": "MI0040025-a",
    "system_name": "SHADY ACRES COMMUNITY, LLC",
    "display_name": "SHADY ACRES COMMUNITY, LLC",
    "county": "ALLEGAN",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040025",
    "resolved_pwsid": "MI0040025-b",
    "system_name": "SHADY ACRES MOBILE VILLAGE",
    "display_name": "SHADY ACRES MOBILE VILLAGE",
    "county": "ALLEGAN",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040026",
    "resolved_pwsid": "MI0040026",
    "system_name": "SHANGRAI-LA VILLAGE",
    "display_name": "SHANGRAI-LA VILLAGE",
    "county": "ALLEGAN",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040026",
    "resolved_pwsid": "MI0040026",
    "system_name": "SHANGRAI-LA VILLAGE",
    "display_name": "SHANGRAI-LA VILLAGE",
    "county": "ALLEGAN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040026",
    "resolved_pwsid": "MI0040026",
    "system_name": "SHANGRAI-LA VILLAGE",
    "display_name": "SHANGRAI-LA VILLAGE",
    "county": "ALLEGAN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040027",
    "resolved_pwsid": "MI0040027",
    "system_name": "SWAN LAKE MOBILE ESTATES",
    "display_name": "SWAN LAKE MOBILE ESTATES",
    "county": "ALLEGAN",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040027",
    "resolved_pwsid": "MI0040027",
    "system_name": "SWAN LAKE MOBILE ESTATES",
    "display_name": "SWAN LAKE MOBILE ESTATES",
    "county": "ALLEGAN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040027",
    "resolved_pwsid": "MI0040027",
    "system_name": "SWAN LAKE MOBILE ESTATES",
    "display_name": "SWAN LAKE MOBILE ESTATES",
    "county": "ALLEGAN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040028",
    "resolved_pwsid": "MI0040028",
    "system_name": "VILLAGE EAST ESTATES",
    "display_name": "VILLAGE EAST ESTATES",
    "county": "ALLEGAN",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040028",
    "resolved_pwsid": "MI0040028",
    "system_name": "VILLAGE EAST ESTATES",
    "display_name": "VILLAGE EAST ESTATES",
    "county": "ALLEGAN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040028",
    "resolved_pwsid": "MI0040028",
    "system_name": "VILLAGE EAST ESTATES",
    "display_name": "VILLAGE EAST ESTATES",
    "county": "ALLEGAN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040029",
    "resolved_pwsid": "MI0040029",
    "system_name": "GUN RIVER ESTATES WEST",
    "display_name": "GUN RIVER ESTATES WEST",
    "county": "ALLEGAN",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 19,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040029",
    "resolved_pwsid": "MI0040029",
    "system_name": "GUN RIVER ESTATES WEST",
    "display_name": "GUN RIVER ESTATES WEST",
    "county": "ALLEGAN",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040029",
    "resolved_pwsid": "MI0040029",
    "system_name": "GUN RIVER ESTATES WEST",
    "display_name": "GUN RIVER ESTATES WEST",
    "county": "ALLEGAN",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040029",
    "resolved_pwsid": "MI0040029",
    "system_name": "GUN RIVER ESTATES WEST",
    "display_name": "GUN RIVER ESTATES WEST",
    "county": "ALLEGAN",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040029",
    "resolved_pwsid": "MI0040029",
    "system_name": "GUN RIVER ESTATES WEST",
    "display_name": "GUN RIVER ESTATES WEST",
    "county": "ALLEGAN",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040030",
    "resolved_pwsid": "MI0040030",
    "system_name": "RIVERSIDE ESTATES",
    "display_name": "RIVERSIDE ESTATES",
    "county": "ALLEGAN",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040030",
    "resolved_pwsid": "MI0040030",
    "system_name": "RIVERSIDE ESTATES",
    "display_name": "RIVERSIDE ESTATES",
    "county": "ALLEGAN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040030",
    "resolved_pwsid": "MI0040030",
    "system_name": "RIVERSIDE ESTATES",
    "display_name": "RIVERSIDE ESTATES",
    "county": "ALLEGAN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040034",
    "resolved_pwsid": "MI0040034",
    "system_name": "LAKESHORE ESTATES MHP",
    "display_name": "LAKESHORE ESTATES MHP",
    "county": "ALPENA",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040034",
    "resolved_pwsid": "MI0040034",
    "system_name": "LAKESHORE ESTATES MHP",
    "display_name": "LAKESHORE ESTATES MHP",
    "county": "ALPENA",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040034",
    "resolved_pwsid": "MI0040034",
    "system_name": "LAKESHORE ESTATES MHP",
    "display_name": "LAKESHORE ESTATES MHP",
    "county": "ALPENA",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040039",
    "resolved_pwsid": "MI0040039",
    "system_name": "NORTHERN COUNTRY ESTATES",
    "display_name": "NORTHERN COUNTRY ESTATES",
    "county": "ARENAC",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040039",
    "resolved_pwsid": "MI0040039",
    "system_name": "NORTHERN COUNTRY ESTATES",
    "display_name": "NORTHERN COUNTRY ESTATES",
    "county": "ARENAC",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040039",
    "resolved_pwsid": "MI0040039",
    "system_name": "NORTHERN COUNTRY ESTATES",
    "display_name": "NORTHERN COUNTRY ESTATES",
    "county": "ARENAC",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040041",
    "resolved_pwsid": "MI0040041",
    "system_name": "BALTIMORE TERRACE",
    "display_name": "BALTIMORE TERRACE",
    "county": "BARRY",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040041",
    "resolved_pwsid": "MI0040041",
    "system_name": "BALTIMORE TERRACE",
    "display_name": "BALTIMORE TERRACE",
    "county": "BARRY",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040041",
    "resolved_pwsid": "MI0040041",
    "system_name": "BALTIMORE TERRACE",
    "display_name": "BALTIMORE TERRACE",
    "county": "BARRY",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040042",
    "resolved_pwsid": "MI0040042",
    "system_name": "BARRY'S RESORT",
    "display_name": "BARRY'S RESORT",
    "county": "BARRY",
    "monitoring_end_date": "2015-12-31",
    "year": 2015,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040042",
    "resolved_pwsid": "MI0040042",
    "system_name": "BARRY'S RESORT",
    "display_name": "BARRY'S RESORT",
    "county": "BARRY",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040042",
    "resolved_pwsid": "MI0040042",
    "system_name": "BARRY'S RESORT",
    "display_name": "BARRY'S RESORT",
    "county": "BARRY",
    "monitoring_end_date": "2020-09-30",
    "year": 2020,
    "lead_90th_ppb": 21,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040042",
    "resolved_pwsid": "MI0040042",
    "system_name": "BARRY'S RESORT",
    "display_name": "BARRY'S RESORT",
    "county": "BARRY",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 21,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040042",
    "resolved_pwsid": "MI0040042",
    "system_name": "BARRY'S RESORT",
    "display_name": "BARRY'S RESORT",
    "county": "BARRY",
    "monitoring_end_date": "2021-06-30",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040042",
    "resolved_pwsid": "MI0040042",
    "system_name": "BARRY'S RESORT",
    "display_name": "BARRY'S RESORT",
    "county": "BARRY",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040042",
    "resolved_pwsid": "MI0040042",
    "system_name": "BARRY'S RESORT",
    "display_name": "BARRY'S RESORT",
    "county": "BARRY",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040044",
    "resolved_pwsid": "MI0040044",
    "system_name": "GUN LAKE MOBILE HOME COMMUNITY",
    "display_name": "GUN LAKE MOBILE HOME COMMUNITY",
    "county": "BARRY",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040044",
    "resolved_pwsid": "MI0040044",
    "system_name": "GUN LAKE MOBILE HOME COMMUNITY",
    "display_name": "GUN LAKE MOBILE HOME COMMUNITY",
    "county": "BARRY",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040044",
    "resolved_pwsid": "MI0040044",
    "system_name": "GUN LAKE MOBILE HOME COMMUNITY",
    "display_name": "GUN LAKE MOBILE HOME COMMUNITY",
    "county": "BARRY",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040045",
    "resolved_pwsid": "MI0040045",
    "system_name": "DUNLOPS ORCHARD PARK",
    "display_name": "DUNLOPS ORCHARD PARK",
    "county": "BARRY",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040045",
    "resolved_pwsid": "MI0040045",
    "system_name": "DUNLOPS ORCHARD PARK",
    "display_name": "DUNLOPS ORCHARD PARK",
    "county": "BARRY",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040045",
    "resolved_pwsid": "MI0040045",
    "system_name": "DUNLOPS ORCHARD PARK",
    "display_name": "DUNLOPS ORCHARD PARK",
    "county": "BARRY",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040045",
    "resolved_pwsid": "MI0040045",
    "system_name": "DUNLOPS ORCHARD PARK",
    "display_name": "DUNLOPS ORCHARD PARK",
    "county": "BARRY",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0040046",
    "resolved_pwsid": "MI0040046",
    "system_name": "GUERNSEY LAKE MOBILE HOME COMMUNITY",
    "display_name": "GUERNSEY LAKE MOBILE HOME COMMUNITY",
    "county": "BARRY",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040046",
    "resolved_pwsid": "MI0040046",
    "system_name": "GUERNSEY LAKE MOBILE HOME COMMUNITY",
    "display_name": "GUERNSEY LAKE MOBILE HOME COMMUNITY",
    "county": "BARRY",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040046",
    "resolved_pwsid": "MI0040046",
    "system_name": "GUERNSEY LAKE MOBILE HOME COMMUNITY",
    "display_name": "GUERNSEY LAKE MOBILE HOME COMMUNITY",
    "county": "BARRY",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040046",
    "resolved_pwsid": "MI0040046",
    "system_name": "GUERNSEY LAKE MOBILE HOME COMMUNITY",
    "display_name": "GUERNSEY LAKE MOBILE HOME COMMUNITY",
    "county": "BARRY",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0040047",
    "resolved_pwsid": "MI0040047",
    "system_name": "THORNAPPLE LAKE ESTATES",
    "display_name": "THORNAPPLE LAKE ESTATES",
    "county": "BARRY",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040047",
    "resolved_pwsid": "MI0040047",
    "system_name": "THORNAPPLE LAKE ESTATES",
    "display_name": "THORNAPPLE LAKE ESTATES",
    "county": "BARRY",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040047",
    "resolved_pwsid": "MI0040047",
    "system_name": "THORNAPPLE LAKE ESTATES",
    "display_name": "THORNAPPLE LAKE ESTATES",
    "county": "BARRY",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040051",
    "resolved_pwsid": "MI0040051",
    "system_name": "BUENA VISTA ESTATES",
    "display_name": "BUENA VISTA ESTATES",
    "county": "BENZIE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040051",
    "resolved_pwsid": "MI0040051",
    "system_name": "BUENA VISTA ESTATES",
    "display_name": "BUENA VISTA ESTATES",
    "county": "BENZIE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040051",
    "resolved_pwsid": "MI0040051",
    "system_name": "BUENA VISTA ESTATES",
    "display_name": "BUENA VISTA ESTATES",
    "county": "BENZIE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040057",
    "resolved_pwsid": "MI0040057",
    "system_name": "HILLS HAVEN MOBILE HOME PARK",
    "display_name": "HILLS HAVEN MOBILE HOME PARK",
    "county": "BERRIEN",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040057",
    "resolved_pwsid": "MI0040057",
    "system_name": "HILLS HAVEN MOBILE HOME PARK",
    "display_name": "HILLS HAVEN MOBILE HOME PARK",
    "county": "BERRIEN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040057",
    "resolved_pwsid": "MI0040057",
    "system_name": "HILLS HAVEN MOBILE HOME PARK",
    "display_name": "HILLS HAVEN MOBILE HOME PARK",
    "county": "BERRIEN",
    "monitoring_end_date": "2022-06-30",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040057",
    "resolved_pwsid": "MI0040057",
    "system_name": "HILLS HAVEN MOBILE HOME PARK",
    "display_name": "HILLS HAVEN MOBILE HOME PARK",
    "county": "BERRIEN",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040057",
    "resolved_pwsid": "MI0040057",
    "system_name": "HILLS HAVEN MOBILE HOME PARK",
    "display_name": "HILLS HAVEN MOBILE HOME PARK",
    "county": "BERRIEN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040057",
    "resolved_pwsid": "MI0040057",
    "system_name": "HILLS HAVEN MOBILE HOME PARK",
    "display_name": "HILLS HAVEN MOBILE HOME PARK",
    "county": "BERRIEN",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0040060",
    "resolved_pwsid": "MI0040060-a",
    "system_name": "COUNTRY ACRES",
    "display_name": "COUNTRY ACRES",
    "county": "BERRIEN",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040060",
    "resolved_pwsid": "MI0040060-b",
    "system_name": "SOUTHTOWN MHP",
    "display_name": "SOUTHTOWN MHP",
    "county": "BERRIEN",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040060",
    "resolved_pwsid": "MI0040060-b",
    "system_name": "SOUTHTOWN MHP",
    "display_name": "SOUTHTOWN MHP",
    "county": "BERRIEN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040060",
    "resolved_pwsid": "MI0040060-b",
    "system_name": "SOUTHTOWN MHP",
    "display_name": "SOUTHTOWN MHP",
    "county": "BERRIEN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040061",
    "resolved_pwsid": "MI0040061",
    "system_name": "MEADOW STREAMS ESTATES",
    "display_name": "MEADOW STREAMS ESTATES",
    "county": "BERRIEN",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040061",
    "resolved_pwsid": "MI0040061",
    "system_name": "MEADOW STREAMS ESTATES",
    "display_name": "MEADOW STREAMS ESTATES",
    "county": "BERRIEN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040061",
    "resolved_pwsid": "MI0040061",
    "system_name": "MEADOW STREAMS ESTATES",
    "display_name": "MEADOW STREAMS ESTATES",
    "county": "BERRIEN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040062",
    "resolved_pwsid": "MI0040062",
    "system_name": "PAW PAW LAKE MH PARK",
    "display_name": "PAW PAW LAKE MH PARK",
    "county": "BERRIEN",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040062",
    "resolved_pwsid": "MI0040062",
    "system_name": "PAW PAW LAKE MH PARK",
    "display_name": "PAW PAW LAKE MH PARK",
    "county": "BERRIEN",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040062",
    "resolved_pwsid": "MI0040062",
    "system_name": "PAW PAW LAKE MH PARK",
    "display_name": "PAW PAW LAKE MH PARK",
    "county": "BERRIEN",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040065",
    "resolved_pwsid": "MI0040065",
    "system_name": "RIVERSIDE ESTATES",
    "display_name": "RIVERSIDE ESTATES",
    "county": "BERRIEN",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040065",
    "resolved_pwsid": "MI0040065",
    "system_name": "RIVERSIDE ESTATES",
    "display_name": "RIVERSIDE ESTATES",
    "county": "BERRIEN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040065",
    "resolved_pwsid": "MI0040065",
    "system_name": "RIVERSIDE ESTATES",
    "display_name": "RIVERSIDE ESTATES",
    "county": "BERRIEN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040067",
    "resolved_pwsid": "MI0040067",
    "system_name": "ONTARIO PLACE",
    "display_name": "ONTARIO PLACE",
    "county": "BERRIEN",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040067",
    "resolved_pwsid": "MI0040067",
    "system_name": "ONTARIO PLACE",
    "display_name": "ONTARIO PLACE",
    "county": "BERRIEN",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040067",
    "resolved_pwsid": "MI0040067",
    "system_name": "ONTARIO PLACE",
    "display_name": "ONTARIO PLACE",
    "county": "BERRIEN",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040068",
    "resolved_pwsid": "MI0040068",
    "system_name": "CAMBRIDGE VILLAGE",
    "display_name": "CAMBRIDGE VILLAGE",
    "county": "BRANCH",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040068",
    "resolved_pwsid": "MI0040068",
    "system_name": "CAMBRIDGE VILLAGE",
    "display_name": "CAMBRIDGE VILLAGE",
    "county": "BRANCH",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040068",
    "resolved_pwsid": "MI0040068",
    "system_name": "CAMBRIDGE VILLAGE",
    "display_name": "CAMBRIDGE VILLAGE",
    "county": "BRANCH",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040068",
    "resolved_pwsid": "MI0040068",
    "system_name": "CAMBRIDGE VILLAGE",
    "display_name": "CAMBRIDGE VILLAGE",
    "county": "BRANCH",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040069",
    "resolved_pwsid": "MI0040069",
    "system_name": "GRAND VILLAGE MOBILE HOME PARK",
    "display_name": "GRAND VILLAGE MOBILE HOME PARK",
    "county": "BRANCH",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040069",
    "resolved_pwsid": "MI0040069",
    "system_name": "GRAND VILLAGE MOBILE HOME PARK",
    "display_name": "GRAND VILLAGE MOBILE HOME PARK",
    "county": "BRANCH",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040069",
    "resolved_pwsid": "MI0040069",
    "system_name": "GRAND VILLAGE MOBILE HOME PARK",
    "display_name": "GRAND VILLAGE MOBILE HOME PARK",
    "county": "BRANCH",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040070",
    "resolved_pwsid": "MI0040070",
    "system_name": "COUNTRYSIDE MOBILE COURT",
    "display_name": "COUNTRYSIDE MOBILE COURT",
    "county": "BRANCH",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040070",
    "resolved_pwsid": "MI0040070",
    "system_name": "COUNTRYSIDE MOBILE COURT",
    "display_name": "COUNTRYSIDE MOBILE COURT",
    "county": "BRANCH",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040070",
    "resolved_pwsid": "MI0040070",
    "system_name": "COUNTRYSIDE MOBILE COURT",
    "display_name": "COUNTRYSIDE MOBILE COURT",
    "county": "BRANCH",
    "monitoring_end_date": "2024-06-30",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040070",
    "resolved_pwsid": "MI0040070",
    "system_name": "COUNTRYSIDE MOBILE COURT",
    "display_name": "COUNTRYSIDE MOBILE COURT",
    "county": "BRANCH",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040070",
    "resolved_pwsid": "MI0040070",
    "system_name": "COUNTRYSIDE MOBILE COURT",
    "display_name": "COUNTRYSIDE MOBILE COURT",
    "county": "BRANCH",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0040071",
    "resolved_pwsid": "MI0040071",
    "system_name": "MARBLE LAKE RESORT & MARINA",
    "display_name": "MARBLE LAKE RESORT & MARINA",
    "county": "BRANCH",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040071",
    "resolved_pwsid": "MI0040071",
    "system_name": "MARBLE LAKE RESORT & MARINA",
    "display_name": "MARBLE LAKE RESORT & MARINA",
    "county": "BRANCH",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040071",
    "resolved_pwsid": "MI0040071",
    "system_name": "MARBLE LAKE RESORT & MARINA",
    "display_name": "MARBLE LAKE RESORT & MARINA",
    "county": "BRANCH",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040071",
    "resolved_pwsid": "MI0040071",
    "system_name": "MARBLE LAKE RESORT & MARINA",
    "display_name": "MARBLE LAKE RESORT & MARINA",
    "county": "BRANCH",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040074",
    "resolved_pwsid": "MI0040074",
    "system_name": "AVRA ESTATES",
    "display_name": "AVRA ESTATES",
    "county": "BRANCH",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040074",
    "resolved_pwsid": "MI0040074",
    "system_name": "AVRA ESTATES",
    "display_name": "AVRA ESTATES",
    "county": "BRANCH",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040074",
    "resolved_pwsid": "MI0040074",
    "system_name": "AVRA ESTATES",
    "display_name": "AVRA ESTATES",
    "county": "BRANCH",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040075",
    "resolved_pwsid": "MI0040075",
    "system_name": "LAKECREST MOBILE COURT",
    "display_name": "LAKECREST MOBILE COURT",
    "county": "BRANCH",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040075",
    "resolved_pwsid": "MI0040075",
    "system_name": "LAKECREST MOBILE COURT",
    "display_name": "LAKECREST MOBILE COURT",
    "county": "BRANCH",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040075",
    "resolved_pwsid": "MI0040075",
    "system_name": "LAKECREST MOBILE COURT",
    "display_name": "LAKECREST MOBILE COURT",
    "county": "BRANCH",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040076",
    "resolved_pwsid": "MI0040076",
    "system_name": "SOMERSET MOBILE HOME PARK",
    "display_name": "SOMERSET MOBILE HOME PARK",
    "county": "BRANCH",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040076",
    "resolved_pwsid": "MI0040076",
    "system_name": "SOMERSET MOBILE HOME PARK",
    "display_name": "SOMERSET MOBILE HOME PARK",
    "county": "BRANCH",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040076",
    "resolved_pwsid": "MI0040076",
    "system_name": "SOMERSET MOBILE HOME PARK",
    "display_name": "SOMERSET MOBILE HOME PARK",
    "county": "BRANCH",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040076",
    "resolved_pwsid": "MI0040076",
    "system_name": "SOMERSET MOBILE HOME PARK",
    "display_name": "SOMERSET MOBILE HOME PARK",
    "county": "BRANCH",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040079",
    "resolved_pwsid": "MI0040079-a",
    "system_name": "CREEK VALLEY MOBILE HOME PARK",
    "display_name": "CREEK VALLEY MOBILE HOME PARK",
    "county": "CALHOUN",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040079",
    "resolved_pwsid": "MI0040079-a",
    "system_name": "CREEK VALLEY MOBILE HOME PARK",
    "display_name": "CREEK VALLEY MOBILE HOME PARK",
    "county": "CALHOUN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040079",
    "resolved_pwsid": "MI0040079-b",
    "system_name": "NP CREEK VALLEY SOUTH",
    "display_name": "NP CREEK VALLEY SOUTH",
    "county": "CALHOUN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040080",
    "resolved_pwsid": "MI0040080",
    "system_name": "BEDFORD HILLS",
    "display_name": "BEDFORD HILLS",
    "county": "CALHOUN",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040080",
    "resolved_pwsid": "MI0040080",
    "system_name": "BEDFORD HILLS",
    "display_name": "BEDFORD HILLS",
    "county": "CALHOUN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040080",
    "resolved_pwsid": "MI0040080",
    "system_name": "BEDFORD HILLS",
    "display_name": "BEDFORD HILLS",
    "county": "CALHOUN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040081",
    "resolved_pwsid": "MI0040081",
    "system_name": "BELLEVUE MOBILE HOME PARK",
    "display_name": "BELLEVUE MOBILE HOME PARK",
    "county": "CALHOUN",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040081",
    "resolved_pwsid": "MI0040081",
    "system_name": "BELLEVUE MOBILE HOME PARK",
    "display_name": "BELLEVUE MOBILE HOME PARK",
    "county": "CALHOUN",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040081",
    "resolved_pwsid": "MI0040081",
    "system_name": "BELLEVUE MOBILE HOME PARK",
    "display_name": "BELLEVUE MOBILE HOME PARK",
    "county": "CALHOUN",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040081",
    "resolved_pwsid": "MI0040081",
    "system_name": "BELLEVUE MOBILE HOME PARK",
    "display_name": "BELLEVUE MOBILE HOME PARK",
    "county": "CALHOUN",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040081",
    "resolved_pwsid": "MI0040081",
    "system_name": "BELLEVUE MOBILE HOME PARK",
    "display_name": "BELLEVUE MOBILE HOME PARK",
    "county": "CALHOUN",
    "monitoring_end_date": "2026-06-30",
    "year": 2026,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040082",
    "resolved_pwsid": "MI0040082",
    "system_name": "BIRCHWOOD ESTATES",
    "display_name": "BIRCHWOOD ESTATES",
    "county": "CALHOUN",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040082",
    "resolved_pwsid": "MI0040082",
    "system_name": "BIRCHWOOD ESTATES",
    "display_name": "BIRCHWOOD ESTATES",
    "county": "CALHOUN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040082",
    "resolved_pwsid": "MI0040082",
    "system_name": "BIRCHWOOD ESTATES",
    "display_name": "BIRCHWOOD ESTATES",
    "county": "CALHOUN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 9,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040084",
    "resolved_pwsid": "MI0040084",
    "system_name": "HICKORY HILLS",
    "display_name": "HICKORY HILLS",
    "county": "CALHOUN",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040084",
    "resolved_pwsid": "MI0040084",
    "system_name": "HICKORY HILLS",
    "display_name": "HICKORY HILLS",
    "county": "CALHOUN",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040084",
    "resolved_pwsid": "MI0040084",
    "system_name": "HICKORY HILLS",
    "display_name": "HICKORY HILLS",
    "county": "CALHOUN",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040086",
    "resolved_pwsid": "MI0040086",
    "system_name": "PHOENIX MOBILE HOME COURT",
    "display_name": "PHOENIX MOBILE HOME COURT",
    "county": "CALHOUN",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040086",
    "resolved_pwsid": "MI0040086",
    "system_name": "PHOENIX MOBILE HOME COURT",
    "display_name": "PHOENIX MOBILE HOME COURT",
    "county": "CALHOUN",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040086",
    "resolved_pwsid": "MI0040086",
    "system_name": "PHOENIX MOBILE HOME COURT",
    "display_name": "PHOENIX MOBILE HOME COURT",
    "county": "CALHOUN",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040090",
    "resolved_pwsid": "MI0040090",
    "system_name": "TWIN PINES MOBILE HOME PARK",
    "display_name": "TWIN PINES MOBILE HOME PARK",
    "county": "CALHOUN",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040090",
    "resolved_pwsid": "MI0040090",
    "system_name": "TWIN PINES MOBILE HOME PARK",
    "display_name": "TWIN PINES MOBILE HOME PARK",
    "county": "CALHOUN",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040090",
    "resolved_pwsid": "MI0040090",
    "system_name": "TWIN PINES MOBILE HOME PARK",
    "display_name": "TWIN PINES MOBILE HOME PARK",
    "county": "CALHOUN",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040091",
    "resolved_pwsid": "MI0040091",
    "system_name": "MY PLACE AT TWIN VALLEY",
    "display_name": "MY PLACE AT TWIN VALLEY",
    "county": "CALHOUN",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040091",
    "resolved_pwsid": "MI0040091",
    "system_name": "MY PLACE AT TWIN VALLEY",
    "display_name": "MY PLACE AT TWIN VALLEY",
    "county": "CALHOUN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040091",
    "resolved_pwsid": "MI0040091",
    "system_name": "MY PLACE AT TWIN VALLEY",
    "display_name": "MY PLACE AT TWIN VALLEY",
    "county": "CALHOUN",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040091",
    "resolved_pwsid": "MI0040091",
    "system_name": "MY PLACE AT TWIN VALLEY",
    "display_name": "MY PLACE AT TWIN VALLEY",
    "county": "CALHOUN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040092",
    "resolved_pwsid": "MI0040092",
    "system_name": "BARRON LAKE/ROSEBUSH",
    "display_name": "BARRON LAKE/ROSEBUSH",
    "county": "CASS",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040092",
    "resolved_pwsid": "MI0040092",
    "system_name": "BARRON LAKE/ROSEBUSH",
    "display_name": "BARRON LAKE/ROSEBUSH",
    "county": "CASS",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040092",
    "resolved_pwsid": "MI0040092",
    "system_name": "BARRON LAKE/ROSEBUSH",
    "display_name": "BARRON LAKE/ROSEBUSH",
    "county": "CASS",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040093",
    "resolved_pwsid": "MI0040093",
    "system_name": "C & M MOBILE HOME COURT",
    "display_name": "C & M MOBILE HOME COURT",
    "county": "CASS",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040093",
    "resolved_pwsid": "MI0040093",
    "system_name": "C & M MOBILE HOME COURT",
    "display_name": "C & M MOBILE HOME COURT",
    "county": "CASS",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040093",
    "resolved_pwsid": "MI0040093",
    "system_name": "C & M MOBILE HOME COURT",
    "display_name": "C & M MOBILE HOME COURT",
    "county": "CASS",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040094",
    "resolved_pwsid": "MI0040094",
    "system_name": "COLONIAL ACRES",
    "display_name": "COLONIAL ACRES",
    "county": "CASS",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040094",
    "resolved_pwsid": "MI0040094",
    "system_name": "COLONIAL ACRES",
    "display_name": "COLONIAL ACRES",
    "county": "CASS",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040094",
    "resolved_pwsid": "MI0040094",
    "system_name": "COLONIAL ACRES",
    "display_name": "COLONIAL ACRES",
    "county": "CASS",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040098",
    "resolved_pwsid": "MI0040098",
    "system_name": "LINDEN MOBILE HOME PARK",
    "display_name": "LINDEN MOBILE HOME PARK",
    "county": "CASS",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040098",
    "resolved_pwsid": "MI0040098",
    "system_name": "LINDEN MOBILE HOME PARK",
    "display_name": "LINDEN MOBILE HOME PARK",
    "county": "CASS",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040098",
    "resolved_pwsid": "MI0040098",
    "system_name": "LINDEN MOBILE HOME PARK",
    "display_name": "LINDEN MOBILE HOME PARK",
    "county": "CASS",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040100",
    "resolved_pwsid": "MI0040100",
    "system_name": "MARLIN VILLAGE MOBILE HOME PARK",
    "display_name": "MARLIN VILLAGE MOBILE HOME PARK",
    "county": "CASS",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040100",
    "resolved_pwsid": "MI0040100",
    "system_name": "MARLIN VILLAGE MOBILE HOME PARK",
    "display_name": "MARLIN VILLAGE MOBILE HOME PARK",
    "county": "CASS",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040100",
    "resolved_pwsid": "MI0040100",
    "system_name": "MARLIN VILLAGE MOBILE HOME PARK",
    "display_name": "MARLIN VILLAGE MOBILE HOME PARK",
    "county": "CASS",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040101",
    "resolved_pwsid": "MI0040101",
    "system_name": "MILLS TRAILER COURT",
    "display_name": "MILLS TRAILER COURT",
    "county": "CASS",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040101",
    "resolved_pwsid": "MI0040101",
    "system_name": "MILLS TRAILER COURT",
    "display_name": "MILLS TRAILER COURT",
    "county": "CASS",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040103",
    "resolved_pwsid": "MI0040103",
    "system_name": "EAGLE LAKE ESTATES MHP",
    "display_name": "EAGLE LAKE ESTATES MHP",
    "county": "CASS",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040103",
    "resolved_pwsid": "MI0040103",
    "system_name": "EAGLE LAKE ESTATES MHP",
    "display_name": "EAGLE LAKE ESTATES MHP",
    "county": "CASS",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040103",
    "resolved_pwsid": "MI0040103",
    "system_name": "EAGLE LAKE ESTATES MHP",
    "display_name": "EAGLE LAKE ESTATES MHP",
    "county": "CASS",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040104",
    "resolved_pwsid": "MI0040104",
    "system_name": "RUSTIC ACRES PARK",
    "display_name": "RUSTIC ACRES PARK",
    "county": "CASS",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040104",
    "resolved_pwsid": "MI0040104",
    "system_name": "RUSTIC ACRES PARK",
    "display_name": "RUSTIC ACRES PARK",
    "county": "CASS",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040104",
    "resolved_pwsid": "MI0040104",
    "system_name": "RUSTIC ACRES PARK",
    "display_name": "RUSTIC ACRES PARK",
    "county": "CASS",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040105",
    "resolved_pwsid": "MI0040105",
    "system_name": "WHITE PINES MOBILE HOME PARK",
    "display_name": "WHITE PINES MOBILE HOME PARK",
    "county": "CASS",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040105",
    "resolved_pwsid": "MI0040105",
    "system_name": "WHITE PINES MOBILE HOME PARK",
    "display_name": "WHITE PINES MOBILE HOME PARK",
    "county": "CASS",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040105",
    "resolved_pwsid": "MI0040105",
    "system_name": "WHITE PINES MOBILE HOME PARK",
    "display_name": "WHITE PINES MOBILE HOME PARK",
    "county": "CASS",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040106",
    "resolved_pwsid": "MI0040106",
    "system_name": "LAKE MICHIGAN HEIGHTS",
    "display_name": "LAKE MICHIGAN HEIGHTS",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040106",
    "resolved_pwsid": "MI0040106",
    "system_name": "LAKE MICHIGAN HEIGHTS",
    "display_name": "LAKE MICHIGAN HEIGHTS",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040106",
    "resolved_pwsid": "MI0040106",
    "system_name": "LAKE MICHIGAN HEIGHTS",
    "display_name": "LAKE MICHIGAN HEIGHTS",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040106",
    "resolved_pwsid": "MI0040106",
    "system_name": "LAKE MICHIGAN HEIGHTS",
    "display_name": "LAKE MICHIGAN HEIGHTS",
    "county": "CHARLEVOIX",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 87,
    "total_to_identify_or_replace": 87,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0040108",
    "resolved_pwsid": "MI0040108",
    "system_name": "INDIAN RIVER MHP",
    "display_name": "INDIAN RIVER MHP",
    "county": "CHEBOYGAN",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040108",
    "resolved_pwsid": "MI0040108",
    "system_name": "INDIAN RIVER MHP",
    "display_name": "INDIAN RIVER MHP",
    "county": "CHEBOYGAN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040108",
    "resolved_pwsid": "MI0040108",
    "system_name": "INDIAN RIVER MHP",
    "display_name": "INDIAN RIVER MHP",
    "county": "CHEBOYGAN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040110",
    "resolved_pwsid": "MI0040110",
    "system_name": "TOWN AND COUNTRY MHP",
    "display_name": "TOWN AND COUNTRY MHP",
    "county": "CHEBOYGAN",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040110",
    "resolved_pwsid": "MI0040110",
    "system_name": "TOWN AND COUNTRY MHP",
    "display_name": "TOWN AND COUNTRY MHP",
    "county": "CHEBOYGAN",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040110",
    "resolved_pwsid": "MI0040110",
    "system_name": "TOWN AND COUNTRY MHP",
    "display_name": "TOWN AND COUNTRY MHP",
    "county": "CHEBOYGAN",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040110",
    "resolved_pwsid": "MI0040110",
    "system_name": "TOWN AND COUNTRY MHP",
    "display_name": "TOWN AND COUNTRY MHP",
    "county": "CHEBOYGAN",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0040116",
    "resolved_pwsid": "MI0040116",
    "system_name": "DUTCH HILLS",
    "display_name": "DUTCH HILLS",
    "county": "CLINTON",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040116",
    "resolved_pwsid": "MI0040116",
    "system_name": "DUTCH HILLS",
    "display_name": "DUTCH HILLS",
    "county": "CLINTON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040116",
    "resolved_pwsid": "MI0040116",
    "system_name": "DUTCH HILLS",
    "display_name": "DUTCH HILLS",
    "county": "CLINTON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040119",
    "resolved_pwsid": "MI0040119",
    "system_name": "CREEKSIDE MEADOWS OF ST. JOHNS",
    "display_name": "CREEKSIDE MEADOWS OF ST. JOHNS",
    "county": "CLINTON",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040119",
    "resolved_pwsid": "MI0040119",
    "system_name": "CREEKSIDE MEADOWS OF ST. JOHNS",
    "display_name": "CREEKSIDE MEADOWS OF ST. JOHNS",
    "county": "CLINTON",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040119",
    "resolved_pwsid": "MI0040119",
    "system_name": "CREEKSIDE MEADOWS OF ST. JOHNS",
    "display_name": "CREEKSIDE MEADOWS OF ST. JOHNS",
    "county": "CLINTON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040121",
    "resolved_pwsid": "MI0040121",
    "system_name": "TIMBERLY VILLAGE MHP",
    "display_name": "TIMBERLY VILLAGE MHP",
    "county": "CRAWFORD",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040121",
    "resolved_pwsid": "MI0040121",
    "system_name": "TIMBERLY VILLAGE MHP",
    "display_name": "TIMBERLY VILLAGE MHP",
    "county": "CRAWFORD",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040122",
    "resolved_pwsid": "MI0040122",
    "system_name": "HI-WAY MOBILE HAVEN",
    "display_name": "HI-WAY MOBILE HAVEN",
    "county": "EATON",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040122",
    "resolved_pwsid": "MI0040122",
    "system_name": "HI-WAY MOBILE HAVEN",
    "display_name": "HI-WAY MOBILE HAVEN",
    "county": "EATON",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040122",
    "resolved_pwsid": "MI0040122",
    "system_name": "HI-WAY MOBILE HAVEN",
    "display_name": "HI-WAY MOBILE HAVEN",
    "county": "EATON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040123",
    "resolved_pwsid": "MI0040123",
    "system_name": "MAPLE KNOLL",
    "display_name": "MAPLE KNOLL",
    "county": "EATON",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 44,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040123",
    "resolved_pwsid": "MI0040123",
    "system_name": "MAPLE KNOLL",
    "display_name": "MAPLE KNOLL",
    "county": "EATON",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040123",
    "resolved_pwsid": "MI0040123",
    "system_name": "MAPLE KNOLL",
    "display_name": "MAPLE KNOLL",
    "county": "EATON",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040123",
    "resolved_pwsid": "MI0040123",
    "system_name": "MAPLE KNOLL",
    "display_name": "MAPLE KNOLL",
    "county": "EATON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040123",
    "resolved_pwsid": "MI0040123",
    "system_name": "MAPLE KNOLL",
    "display_name": "MAPLE KNOLL",
    "county": "EATON",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040124",
    "resolved_pwsid": "MI0040124",
    "system_name": "WINDSOR ESTATES",
    "display_name": "WINDSOR ESTATES",
    "county": "EATON",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040124",
    "resolved_pwsid": "MI0040124",
    "system_name": "WINDSOR ESTATES",
    "display_name": "WINDSOR ESTATES",
    "county": "EATON",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 9,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040124",
    "resolved_pwsid": "MI0040124",
    "system_name": "WINDSOR ESTATES",
    "display_name": "WINDSOR ESTATES",
    "county": "EATON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040125",
    "resolved_pwsid": "MI0040125",
    "system_name": "CHALET ESTATES MOBILE HOME PARK",
    "display_name": "CHALET ESTATES MOBILE HOME PARK",
    "county": "EMMET",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040125",
    "resolved_pwsid": "MI0040125",
    "system_name": "CHALET ESTATES MOBILE HOME PARK",
    "display_name": "CHALET ESTATES MOBILE HOME PARK",
    "county": "EMMET",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040125",
    "resolved_pwsid": "MI0040125",
    "system_name": "CHALET ESTATES MOBILE HOME PARK",
    "display_name": "CHALET ESTATES MOBILE HOME PARK",
    "county": "EMMET",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040126",
    "resolved_pwsid": "MI0040126",
    "system_name": "CONWAY COMMONS MOBILE HOME PARK",
    "display_name": "CONWAY COMMONS MOBILE HOME PARK",
    "county": "EMMET",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040126",
    "resolved_pwsid": "MI0040126",
    "system_name": "CONWAY COMMONS MOBILE HOME PARK",
    "display_name": "CONWAY COMMONS MOBILE HOME PARK",
    "county": "EMMET",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040126",
    "resolved_pwsid": "MI0040126",
    "system_name": "CONWAY COMMONS MOBILE HOME PARK",
    "display_name": "CONWAY COMMONS MOBILE HOME PARK",
    "county": "EMMET",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040128",
    "resolved_pwsid": "MI0040128",
    "system_name": "BAY SHORE ESTATES",
    "display_name": "BAY SHORE ESTATES",
    "county": "EMMET",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 15,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040128",
    "resolved_pwsid": "MI0040128",
    "system_name": "BAY SHORE ESTATES",
    "display_name": "BAY SHORE ESTATES",
    "county": "EMMET",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040128",
    "resolved_pwsid": "MI0040128",
    "system_name": "BAY SHORE ESTATES",
    "display_name": "BAY SHORE ESTATES",
    "county": "EMMET",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040129",
    "resolved_pwsid": "MI0040129",
    "system_name": "ALANSON ESTATES MOBILE HOME PARK",
    "display_name": "ALANSON ESTATES MOBILE HOME PARK",
    "county": "EMMET",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040129",
    "resolved_pwsid": "MI0040129",
    "system_name": "ALANSON ESTATES MOBILE HOME PARK",
    "display_name": "ALANSON ESTATES MOBILE HOME PARK",
    "county": "EMMET",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040129",
    "resolved_pwsid": "MI0040129",
    "system_name": "ALANSON ESTATES MOBILE HOME PARK",
    "display_name": "ALANSON ESTATES MOBILE HOME PARK",
    "county": "EMMET",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040131",
    "resolved_pwsid": "MI0040131",
    "system_name": "TRADEWINDS MOBILE HOME PARK",
    "display_name": "TRADEWINDS MOBILE HOME PARK",
    "county": "GENESEE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040131",
    "resolved_pwsid": "MI0040131",
    "system_name": "TRADEWINDS MOBILE HOME PARK",
    "display_name": "TRADEWINDS MOBILE HOME PARK",
    "county": "GENESEE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040131",
    "resolved_pwsid": "MI0040131",
    "system_name": "TRADEWINDS MOBILE HOME PARK",
    "display_name": "TRADEWINDS MOBILE HOME PARK",
    "county": "GENESEE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040138",
    "resolved_pwsid": "MI0040138",
    "system_name": "GUNTHER MOBILE HOME COURT INC",
    "display_name": "GUNTHER MOBILE HOME COURT INC",
    "county": "GENESEE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040138",
    "resolved_pwsid": "MI0040138",
    "system_name": "GUNTHER MOBILE HOME COURT INC",
    "display_name": "GUNTHER MOBILE HOME COURT INC",
    "county": "GENESEE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040138",
    "resolved_pwsid": "MI0040138",
    "system_name": "GUNTHER MOBILE HOME COURT INC",
    "display_name": "GUNTHER MOBILE HOME COURT INC",
    "county": "GENESEE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040140",
    "resolved_pwsid": "MI0040140",
    "system_name": "MY PLACE AT HERITAGE ESTATES",
    "display_name": "MY PLACE AT HERITAGE ESTATES",
    "county": "GENESEE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040140",
    "resolved_pwsid": "MI0040140",
    "system_name": "MY PLACE AT HERITAGE ESTATES",
    "display_name": "MY PLACE AT HERITAGE ESTATES",
    "county": "GENESEE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040140",
    "resolved_pwsid": "MI0040140",
    "system_name": "MY PLACE AT HERITAGE ESTATES",
    "display_name": "MY PLACE AT HERITAGE ESTATES",
    "county": "GENESEE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040144",
    "resolved_pwsid": "MI0040144",
    "system_name": "FENTON LAKEFRONT COMMUNITY LLC",
    "display_name": "FENTON LAKEFRONT COMMUNITY LLC",
    "county": "GENESEE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040144",
    "resolved_pwsid": "MI0040144",
    "system_name": "FENTON LAKEFRONT COMMUNITY LLC",
    "display_name": "FENTON LAKEFRONT COMMUNITY LLC",
    "county": "GENESEE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040144",
    "resolved_pwsid": "MI0040144",
    "system_name": "FENTON LAKEFRONT COMMUNITY LLC",
    "display_name": "FENTON LAKEFRONT COMMUNITY LLC",
    "county": "GENESEE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040144",
    "resolved_pwsid": "MI0040144-a",
    "system_name": "PONEMAH LAKESIDE RETREAT, LLC",
    "display_name": "PONEMAH LAKESIDE RETREAT, LLC",
    "county": "GENESEE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040145",
    "resolved_pwsid": "MI0040145",
    "system_name": "LINDEN PLACE MOBILE HOME PARK",
    "display_name": "LINDEN PLACE MOBILE HOME PARK",
    "county": "GENESEE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040145",
    "resolved_pwsid": "MI0040145",
    "system_name": "LINDEN PLACE MOBILE HOME PARK",
    "display_name": "LINDEN PLACE MOBILE HOME PARK",
    "county": "GENESEE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040145",
    "resolved_pwsid": "MI0040145",
    "system_name": "LINDEN PLACE MOBILE HOME PARK",
    "display_name": "LINDEN PLACE MOBILE HOME PARK",
    "county": "GENESEE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040151",
    "resolved_pwsid": "MI0040151",
    "system_name": "LOON LAKE MOBILE HOME PARK",
    "display_name": "LOON LAKE MOBILE HOME PARK",
    "county": "GENESEE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040151",
    "resolved_pwsid": "MI0040151",
    "system_name": "LOON LAKE MOBILE HOME PARK",
    "display_name": "LOON LAKE MOBILE HOME PARK",
    "county": "GENESEE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040151",
    "resolved_pwsid": "MI0040151",
    "system_name": "LOON LAKE MOBILE HOME PARK",
    "display_name": "LOON LAKE MOBILE HOME PARK",
    "county": "GENESEE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040152",
    "resolved_pwsid": "MI0040152",
    "system_name": "MONTROSE TRAILER PARK",
    "display_name": "MONTROSE TRAILER PARK",
    "county": "GENESEE",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040152",
    "resolved_pwsid": "MI0040152",
    "system_name": "MONTROSE TRAILER PARK",
    "display_name": "MONTROSE TRAILER PARK",
    "county": "GENESEE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 12,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040152",
    "resolved_pwsid": "MI0040152",
    "system_name": "MONTROSE TRAILER PARK",
    "display_name": "MONTROSE TRAILER PARK",
    "county": "GENESEE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040152",
    "resolved_pwsid": "MI0040152",
    "system_name": "MONTROSE TRAILER PARK",
    "display_name": "MONTROSE TRAILER PARK",
    "county": "GENESEE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040154",
    "resolved_pwsid": "MI0040154",
    "system_name": "NORTH DORT MANOR LTD",
    "display_name": "NORTH DORT MANOR LTD",
    "county": "GENESEE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040154",
    "resolved_pwsid": "MI0040154",
    "system_name": "NORTH DORT MANOR LTD",
    "display_name": "NORTH DORT MANOR LTD",
    "county": "GENESEE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040154",
    "resolved_pwsid": "MI0040154",
    "system_name": "NORTH DORT MANOR LTD",
    "display_name": "NORTH DORT MANOR LTD",
    "county": "GENESEE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040155",
    "resolved_pwsid": "MI0040155",
    "system_name": "NORTH MORRIS ESTATES",
    "display_name": "NORTH MORRIS ESTATES",
    "county": "GENESEE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040155",
    "resolved_pwsid": "MI0040155",
    "system_name": "NORTH MORRIS ESTATES",
    "display_name": "NORTH MORRIS ESTATES",
    "county": "GENESEE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040155",
    "resolved_pwsid": "MI0040155",
    "system_name": "NORTH MORRIS ESTATES",
    "display_name": "NORTH MORRIS ESTATES",
    "county": "GENESEE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040155",
    "resolved_pwsid": "MI0040155",
    "system_name": "NORTH MORRIS ESTATES",
    "display_name": "NORTH MORRIS ESTATES",
    "county": "GENESEE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": 596,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040156",
    "resolved_pwsid": "MI0040156",
    "system_name": "OLD ORCHARD ESTATES",
    "display_name": "OLD ORCHARD ESTATES",
    "county": "GENESEE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040156",
    "resolved_pwsid": "MI0040156",
    "system_name": "OLD ORCHARD ESTATES",
    "display_name": "OLD ORCHARD ESTATES",
    "county": "GENESEE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040156",
    "resolved_pwsid": "MI0040156",
    "system_name": "OLD ORCHARD ESTATES",
    "display_name": "OLD ORCHARD ESTATES",
    "county": "GENESEE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040158",
    "resolved_pwsid": "MI0040158",
    "system_name": "LAKE FENTON MOBILE HOME PARK",
    "display_name": "LAKE FENTON MOBILE HOME PARK",
    "county": "GENESEE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040158",
    "resolved_pwsid": "MI0040158",
    "system_name": "LAKE FENTON MOBILE HOME PARK",
    "display_name": "LAKE FENTON MOBILE HOME PARK",
    "county": "GENESEE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040158",
    "resolved_pwsid": "MI0040158",
    "system_name": "LAKE FENTON MOBILE HOME PARK",
    "display_name": "LAKE FENTON MOBILE HOME PARK",
    "county": "GENESEE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040162",
    "resolved_pwsid": "MI0040162",
    "system_name": "WESTHAVEN MOBILE HOME PARK, LLC",
    "display_name": "WESTHAVEN MOBILE HOME PARK, LLC",
    "county": "GENESEE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040162",
    "resolved_pwsid": "MI0040162",
    "system_name": "WESTHAVEN MOBILE HOME PARK, LLC",
    "display_name": "WESTHAVEN MOBILE HOME PARK, LLC",
    "county": "GENESEE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040162",
    "resolved_pwsid": "MI0040162",
    "system_name": "WESTHAVEN MOBILE HOME PARK, LLC",
    "display_name": "WESTHAVEN MOBILE HOME PARK, LLC",
    "county": "GENESEE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040164",
    "resolved_pwsid": "MI0040164",
    "system_name": "SWARTZ CREEK MEADOWS",
    "display_name": "SWARTZ CREEK MEADOWS",
    "county": "GENESEE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040164",
    "resolved_pwsid": "MI0040164",
    "system_name": "SWARTZ CREEK MEADOWS",
    "display_name": "SWARTZ CREEK MEADOWS",
    "county": "GENESEE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040164",
    "resolved_pwsid": "MI0040164",
    "system_name": "SWARTZ CREEK MEADOWS",
    "display_name": "SWARTZ CREEK MEADOWS",
    "county": "GENESEE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040166",
    "resolved_pwsid": "MI0040166",
    "system_name": "KEY COURT MOBILE HOME PARK",
    "display_name": "KEY COURT MOBILE HOME PARK",
    "county": "GLADWIN",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040166",
    "resolved_pwsid": "MI0040166",
    "system_name": "KEY COURT MOBILE HOME PARK",
    "display_name": "KEY COURT MOBILE HOME PARK",
    "county": "GLADWIN",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040166",
    "resolved_pwsid": "MI0040166",
    "system_name": "KEY COURT MOBILE HOME PARK",
    "display_name": "KEY COURT MOBILE HOME PARK",
    "county": "GLADWIN",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040166",
    "resolved_pwsid": "MI0040166",
    "system_name": "KEY COURT MOBILE HOME PARK",
    "display_name": "KEY COURT MOBILE HOME PARK",
    "county": "GLADWIN",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0040167",
    "resolved_pwsid": "MI0040167",
    "system_name": "PLEASANT BEACH MOBILE HOME RESORT",
    "display_name": "PLEASANT BEACH MOBILE HOME RESORT",
    "county": "GLADWIN",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040167",
    "resolved_pwsid": "MI0040167",
    "system_name": "PLEASANT BEACH MOBILE HOME RESORT",
    "display_name": "PLEASANT BEACH MOBILE HOME RESORT",
    "county": "GLADWIN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040167",
    "resolved_pwsid": "MI0040167",
    "system_name": "PLEASANT BEACH MOBILE HOME RESORT",
    "display_name": "PLEASANT BEACH MOBILE HOME RESORT",
    "county": "GLADWIN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040168",
    "resolved_pwsid": "MI0040168-c",
    "system_name": "SECORD MOBILE HOME PARK",
    "display_name": "SECORD MOBILE HOME PARK",
    "county": "GLADWIN",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040168",
    "resolved_pwsid": "MI0040168-c",
    "system_name": "SECORD MOBILE HOME PARK",
    "display_name": "SECORD MOBILE HOME PARK",
    "county": "GLADWIN",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040168",
    "resolved_pwsid": "MI0040168-a",
    "system_name": "RIVERVIEW GLADWIN",
    "display_name": "RIVERVIEW GLADWIN",
    "county": "GLADWIN",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040168",
    "resolved_pwsid": "MI0040168-b",
    "system_name": "SECORD LAKE MHP",
    "display_name": "SECORD LAKE MHP",
    "county": "GLADWIN",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040169",
    "resolved_pwsid": "MI0040169",
    "system_name": "LAKESHORE VILLAGE",
    "display_name": "LAKESHORE VILLAGE",
    "county": "GLADWIN",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040169",
    "resolved_pwsid": "MI0040169",
    "system_name": "LAKESHORE VILLAGE",
    "display_name": "LAKESHORE VILLAGE",
    "county": "GLADWIN",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040169",
    "resolved_pwsid": "MI0040169",
    "system_name": "LAKESHORE VILLAGE",
    "display_name": "LAKESHORE VILLAGE",
    "county": "GLADWIN",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040169",
    "resolved_pwsid": "MI0040169",
    "system_name": "LAKESHORE VILLAGE",
    "display_name": "LAKESHORE VILLAGE",
    "county": "GLADWIN",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0040171",
    "resolved_pwsid": "MI0040171",
    "system_name": "KINGS COURT MOBILE HOME PARK",
    "display_name": "KINGS COURT MOBILE HOME PARK",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040171",
    "resolved_pwsid": "MI0040171",
    "system_name": "KINGS COURT MOBILE HOME PARK",
    "display_name": "KINGS COURT MOBILE HOME PARK",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040171",
    "resolved_pwsid": "MI0040171",
    "system_name": "KINGS COURT MOBILE HOME PARK",
    "display_name": "KINGS COURT MOBILE HOME PARK",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040172",
    "resolved_pwsid": "MI0040172",
    "system_name": "MEADOWLANE MOBILE HOME PARK",
    "display_name": "MEADOWLANE MOBILE HOME PARK",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040172",
    "resolved_pwsid": "MI0040172",
    "system_name": "MEADOWLANE MOBILE HOME PARK",
    "display_name": "MEADOWLANE MOBILE HOME PARK",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040172",
    "resolved_pwsid": "MI0040172",
    "system_name": "MEADOWLANE MOBILE HOME PARK",
    "display_name": "MEADOWLANE MOBILE HOME PARK",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040172",
    "resolved_pwsid": "MI0040172",
    "system_name": "MEADOWLANE MOBILE HOME PARK",
    "display_name": "MEADOWLANE MOBILE HOME PARK",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040174",
    "resolved_pwsid": "MI0040174-a",
    "system_name": "CHERRYLAND MOBILE HOME PARK",
    "display_name": "CHERRYLAND MOBILE HOME PARK",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040174",
    "resolved_pwsid": "MI0040174-a",
    "system_name": "CHERRYLAND MOBILE HOME PARK",
    "display_name": "CHERRYLAND MOBILE HOME PARK",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040174",
    "resolved_pwsid": "MI0040174-b",
    "system_name": "GARFIELD OAKS",
    "display_name": "GARFIELD OAKS",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040174",
    "resolved_pwsid": "MI0040174-b",
    "system_name": "GARFIELD OAKS",
    "display_name": "GARFIELD OAKS",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040174",
    "resolved_pwsid": "MI0040174-b",
    "system_name": "GARFIELD OAKS",
    "display_name": "GARFIELD OAKS",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2022-06-30",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040174",
    "resolved_pwsid": "MI0040174-b",
    "system_name": "GARFIELD OAKS",
    "display_name": "GARFIELD OAKS",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040174",
    "resolved_pwsid": "MI0040174-b",
    "system_name": "GARFIELD OAKS",
    "display_name": "GARFIELD OAKS",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2023-06-30",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040174",
    "resolved_pwsid": "MI0040174-b",
    "system_name": "GARFIELD OAKS",
    "display_name": "GARFIELD OAKS",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040175",
    "resolved_pwsid": "MI0040175",
    "system_name": "SILVER LAKE VIEW MOBILE HOME PARK",
    "display_name": "SILVER LAKE VIEW MOBILE HOME PARK",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040175",
    "resolved_pwsid": "MI0040175",
    "system_name": "SILVER LAKE VIEW MOBILE HOME PARK",
    "display_name": "SILVER LAKE VIEW MOBILE HOME PARK",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040175",
    "resolved_pwsid": "MI0040175",
    "system_name": "SILVER LAKE VIEW MOBILE HOME PARK",
    "display_name": "SILVER LAKE VIEW MOBILE HOME PARK",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040176",
    "resolved_pwsid": "MI0040176",
    "system_name": "SILVER SHORES MOBILE HOME PARK",
    "display_name": "SILVER SHORES MOBILE HOME PARK",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040176",
    "resolved_pwsid": "MI0040176",
    "system_name": "SILVER SHORES MOBILE HOME PARK",
    "display_name": "SILVER SHORES MOBILE HOME PARK",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040176",
    "resolved_pwsid": "MI0040176",
    "system_name": "SILVER SHORES MOBILE HOME PARK",
    "display_name": "SILVER SHORES MOBILE HOME PARK",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040176",
    "resolved_pwsid": "MI0040176",
    "system_name": "SILVER SHORES MOBILE HOME PARK",
    "display_name": "SILVER SHORES MOBILE HOME PARK",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0040177",
    "resolved_pwsid": "MI0040177",
    "system_name": "SUBURBAN ESTATES MHP",
    "display_name": "SUBURBAN ESTATES MHP",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040177",
    "resolved_pwsid": "MI0040177",
    "system_name": "SUBURBAN ESTATES MHP",
    "display_name": "SUBURBAN ESTATES MHP",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040177",
    "resolved_pwsid": "MI0040177",
    "system_name": "SUBURBAN ESTATES MHP",
    "display_name": "SUBURBAN ESTATES MHP",
    "county": "GRAND TRAVERSE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040180",
    "resolved_pwsid": "MI0040180",
    "system_name": "HILLSIDE ACRES",
    "display_name": "HILLSIDE ACRES",
    "county": "HILLSDALE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040180",
    "resolved_pwsid": "MI0040180",
    "system_name": "HILLSIDE ACRES",
    "display_name": "HILLSIDE ACRES",
    "county": "HILLSDALE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040180",
    "resolved_pwsid": "MI0040180",
    "system_name": "HILLSIDE ACRES",
    "display_name": "HILLSIDE ACRES",
    "county": "HILLSDALE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040180",
    "resolved_pwsid": "MI0040180",
    "system_name": "HILLSIDE ACRES",
    "display_name": "HILLSIDE ACRES",
    "county": "HILLSDALE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040181",
    "resolved_pwsid": "MI0040181",
    "system_name": "KYCA COMMUNITY",
    "display_name": "KYCA COMMUNITY",
    "county": "HILLSDALE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040181",
    "resolved_pwsid": "MI0040181",
    "system_name": "KYCA COMMUNITY",
    "display_name": "KYCA COMMUNITY",
    "county": "HILLSDALE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040181",
    "resolved_pwsid": "MI0040181",
    "system_name": "KYCA COMMUNITY",
    "display_name": "KYCA COMMUNITY",
    "county": "HILLSDALE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040181",
    "resolved_pwsid": "MI0040181-a",
    "system_name": "STATE ROAD COUNTRY LIVING MHC",
    "display_name": "STATE ROAD COUNTRY LIVING MHC",
    "county": "HILLSDALE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040183",
    "resolved_pwsid": "MI0040183-b",
    "system_name": "RILEY'S MOBILE HOME PARK",
    "display_name": "RILEY'S MOBILE HOME PARK",
    "county": "HILLSDALE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040183",
    "resolved_pwsid": "MI0040183-b",
    "system_name": "RILEY'S MOBILE HOME PARK",
    "display_name": "RILEY'S MOBILE HOME PARK",
    "county": "HILLSDALE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040183",
    "resolved_pwsid": "MI0040183-a",
    "system_name": "CREEKSIDE MHC",
    "display_name": "CREEKSIDE MHC",
    "county": "HILLSDALE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040183",
    "resolved_pwsid": "MI0040183-b",
    "system_name": "RILEY'S MOBILE HOME PARK",
    "display_name": "RILEY'S MOBILE HOME PARK",
    "county": "HILLSDALE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040184",
    "resolved_pwsid": "MI0040184",
    "system_name": "SOMERSET CENTRE ESTATES",
    "display_name": "SOMERSET CENTRE ESTATES",
    "county": "HILLSDALE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040184",
    "resolved_pwsid": "MI0040184",
    "system_name": "SOMERSET CENTRE ESTATES",
    "display_name": "SOMERSET CENTRE ESTATES",
    "county": "HILLSDALE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040184",
    "resolved_pwsid": "MI0040184",
    "system_name": "SOMERSET CENTRE ESTATES",
    "display_name": "SOMERSET CENTRE ESTATES",
    "county": "HILLSDALE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040187",
    "resolved_pwsid": "MI0040187",
    "system_name": "SUMMER WOOD ESTATES",
    "display_name": "SUMMER WOOD ESTATES",
    "county": "HURON",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040187",
    "resolved_pwsid": "MI0040187",
    "system_name": "SUMMER WOOD ESTATES",
    "display_name": "SUMMER WOOD ESTATES",
    "county": "HURON",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 11,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040187",
    "resolved_pwsid": "MI0040187",
    "system_name": "SUMMER WOOD ESTATES",
    "display_name": "SUMMER WOOD ESTATES",
    "county": "HURON",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040187",
    "resolved_pwsid": "MI0040187",
    "system_name": "SUMMER WOOD ESTATES",
    "display_name": "SUMMER WOOD ESTATES",
    "county": "HURON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040190",
    "resolved_pwsid": "MI0040190-b",
    "system_name": "BAYSIDE ESTATES",
    "display_name": "BAYSIDE ESTATES",
    "county": "HURON",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040190",
    "resolved_pwsid": "MI0040190-b",
    "system_name": "BAYSIDE ESTATES",
    "display_name": "BAYSIDE ESTATES",
    "county": "HURON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040190",
    "resolved_pwsid": "MI0040190-a",
    "system_name": "BAYSIDE (DBA CONTINENTAL MHP)",
    "display_name": "BAYSIDE (DBA CONTINENTAL MHP)",
    "county": "HURON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040190",
    "resolved_pwsid": "MI0040190-c",
    "system_name": "CONTINENTAL MHP",
    "display_name": "CONTINENTAL MHP",
    "county": "HURON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040191",
    "resolved_pwsid": "MI0040191-a",
    "system_name": "CLARKSON-RIVERVIEW COURT",
    "display_name": "CLARKSON-RIVERVIEW COURT",
    "county": "HURON",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040191",
    "resolved_pwsid": "MI0040191-a",
    "system_name": "CLARKSON-RIVERVIEW COURT",
    "display_name": "CLARKSON-RIVERVIEW COURT",
    "county": "HURON",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040191",
    "resolved_pwsid": "MI0040191-a",
    "system_name": "CLARKSON-RIVERVIEW COURT",
    "display_name": "CLARKSON-RIVERVIEW COURT",
    "county": "HURON",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040191",
    "resolved_pwsid": "MI0040191-b",
    "system_name": "RIVERVIEW ESTATES",
    "display_name": "RIVERVIEW ESTATES",
    "county": "HURON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040193",
    "resolved_pwsid": "MI0040193",
    "system_name": "COUNTRY MANOR M H P",
    "display_name": "COUNTRY MANOR M H P",
    "county": "INGHAM",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040193",
    "resolved_pwsid": "MI0040193",
    "system_name": "COUNTRY MANOR M H P",
    "display_name": "COUNTRY MANOR M H P",
    "county": "INGHAM",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040193",
    "resolved_pwsid": "MI0040193",
    "system_name": "COUNTRY MANOR M H P",
    "display_name": "COUNTRY MANOR M H P",
    "county": "INGHAM",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040194",
    "resolved_pwsid": "MI0040194",
    "system_name": "HAMLIN MOBILE HOME PARK",
    "display_name": "HAMLIN MOBILE HOME PARK",
    "county": "INGHAM",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040194",
    "resolved_pwsid": "MI0040194",
    "system_name": "HAMLIN MOBILE HOME PARK",
    "display_name": "HAMLIN MOBILE HOME PARK",
    "county": "INGHAM",
    "monitoring_end_date": "2020-09-30",
    "year": 2020,
    "lead_90th_ppb": 16,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040194",
    "resolved_pwsid": "MI0040194",
    "system_name": "HAMLIN MOBILE HOME PARK",
    "display_name": "HAMLIN MOBILE HOME PARK",
    "county": "INGHAM",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 16,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040194",
    "resolved_pwsid": "MI0040194",
    "system_name": "HAMLIN MOBILE HOME PARK",
    "display_name": "HAMLIN MOBILE HOME PARK",
    "county": "INGHAM",
    "monitoring_end_date": "2021-06-30",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040194",
    "resolved_pwsid": "MI0040194",
    "system_name": "HAMLIN MOBILE HOME PARK",
    "display_name": "HAMLIN MOBILE HOME PARK",
    "county": "INGHAM",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040194",
    "resolved_pwsid": "MI0040194",
    "system_name": "HAMLIN MOBILE HOME PARK",
    "display_name": "HAMLIN MOBILE HOME PARK",
    "county": "INGHAM",
    "monitoring_end_date": "2022-06-30",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040194",
    "resolved_pwsid": "MI0040194",
    "system_name": "HAMLIN MOBILE HOME PARK",
    "display_name": "HAMLIN MOBILE HOME PARK",
    "county": "INGHAM",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040194",
    "resolved_pwsid": "MI0040194",
    "system_name": "HAMLIN MOBILE HOME PARK",
    "display_name": "HAMLIN MOBILE HOME PARK",
    "county": "INGHAM",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040197",
    "resolved_pwsid": "MI0040197",
    "system_name": "MASON MANOR",
    "display_name": "MASON MANOR",
    "county": "INGHAM",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040197",
    "resolved_pwsid": "MI0040197",
    "system_name": "MASON MANOR",
    "display_name": "MASON MANOR",
    "county": "INGHAM",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040197",
    "resolved_pwsid": "MI0040197",
    "system_name": "MASON MANOR",
    "display_name": "MASON MANOR",
    "county": "INGHAM",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040197",
    "resolved_pwsid": "MI0040197",
    "system_name": "MASON MANOR",
    "display_name": "MASON MANOR",
    "county": "INGHAM",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040197",
    "resolved_pwsid": "MI0040197",
    "system_name": "MASON MANOR",
    "display_name": "MASON MANOR",
    "county": "INGHAM",
    "monitoring_end_date": "2026-06-30",
    "year": 2026,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040199",
    "resolved_pwsid": "MI0040199",
    "system_name": "STONEGATE MOBILE HOME COMMUNITY",
    "display_name": "STONEGATE MOBILE HOME COMMUNITY",
    "county": "INGHAM",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040199",
    "resolved_pwsid": "MI0040199",
    "system_name": "STONEGATE MOBILE HOME COMMUNITY",
    "display_name": "STONEGATE MOBILE HOME COMMUNITY",
    "county": "INGHAM",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040199",
    "resolved_pwsid": "MI0040199",
    "system_name": "STONEGATE MOBILE HOME COMMUNITY",
    "display_name": "STONEGATE MOBILE HOME COMMUNITY",
    "county": "INGHAM",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040200",
    "resolved_pwsid": "MI0040200-b",
    "system_name": "SUNSET MOBILE HOME PARK",
    "display_name": "SUNSET MOBILE HOME PARK",
    "county": "INGHAM",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040200",
    "resolved_pwsid": "MI0040200-b",
    "system_name": "SUNSET MOBILE HOME PARK",
    "display_name": "SUNSET MOBILE HOME PARK",
    "county": "INGHAM",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040200",
    "resolved_pwsid": "MI0040200-a",
    "system_name": "MASON MOBILE, LLC",
    "display_name": "MASON MOBILE, LLC",
    "county": "INGHAM",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040200",
    "resolved_pwsid": "MI0040200-b",
    "system_name": "SUNSET MOBILE HOME PARK",
    "display_name": "SUNSET MOBILE HOME PARK",
    "county": "INGHAM",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040200",
    "resolved_pwsid": "MI0040200-a",
    "system_name": "MASON MOBILE, LLC",
    "display_name": "MASON MOBILE, LLC",
    "county": "INGHAM",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040202",
    "resolved_pwsid": "MI0040202",
    "system_name": "WILLOW VILLAGE",
    "display_name": "WILLOW VILLAGE",
    "county": "INGHAM",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040202",
    "resolved_pwsid": "MI0040202",
    "system_name": "WILLOW VILLAGE",
    "display_name": "WILLOW VILLAGE",
    "county": "INGHAM",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040202",
    "resolved_pwsid": "MI0040202",
    "system_name": "WILLOW VILLAGE",
    "display_name": "WILLOW VILLAGE",
    "county": "INGHAM",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040202",
    "resolved_pwsid": "MI0040202",
    "system_name": "WILLOW VILLAGE",
    "display_name": "WILLOW VILLAGE",
    "county": "INGHAM",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040203",
    "resolved_pwsid": "MI0040203",
    "system_name": "WINDMILL PARK",
    "display_name": "WINDMILL PARK",
    "county": "INGHAM",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040203",
    "resolved_pwsid": "MI0040203",
    "system_name": "WINDMILL PARK",
    "display_name": "WINDMILL PARK",
    "county": "INGHAM",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040203",
    "resolved_pwsid": "MI0040203",
    "system_name": "WINDMILL PARK",
    "display_name": "WINDMILL PARK",
    "county": "INGHAM",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040206",
    "resolved_pwsid": "MI0040206",
    "system_name": "EVERGREEN MOBILE HOME COMMUNITY",
    "display_name": "EVERGREEN MOBILE HOME COMMUNITY",
    "county": "IONIA",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040206",
    "resolved_pwsid": "MI0040206",
    "system_name": "EVERGREEN MOBILE HOME COMMUNITY",
    "display_name": "EVERGREEN MOBILE HOME COMMUNITY",
    "county": "IONIA",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040206",
    "resolved_pwsid": "MI0040206",
    "system_name": "EVERGREEN MOBILE HOME COMMUNITY",
    "display_name": "EVERGREEN MOBILE HOME COMMUNITY",
    "county": "IONIA",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040208",
    "resolved_pwsid": "MI0040208",
    "system_name": "HIDDEN VALLEY",
    "display_name": "HIDDEN VALLEY",
    "county": "IONIA",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040208",
    "resolved_pwsid": "MI0040208",
    "system_name": "HIDDEN VALLEY",
    "display_name": "HIDDEN VALLEY",
    "county": "IONIA",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040208",
    "resolved_pwsid": "MI0040208",
    "system_name": "HIDDEN VALLEY",
    "display_name": "HIDDEN VALLEY",
    "county": "IONIA",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040209",
    "resolved_pwsid": "MI0040209",
    "system_name": "LONG LAKE MOBILE HOME ESTATES",
    "display_name": "LONG LAKE MOBILE HOME ESTATES",
    "county": "IONIA",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040209",
    "resolved_pwsid": "MI0040209",
    "system_name": "LONG LAKE MOBILE HOME ESTATES",
    "display_name": "LONG LAKE MOBILE HOME ESTATES",
    "county": "IONIA",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040209",
    "resolved_pwsid": "MI0040209",
    "system_name": "LONG LAKE MOBILE HOME ESTATES",
    "display_name": "LONG LAKE MOBILE HOME ESTATES",
    "county": "IONIA",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040210",
    "resolved_pwsid": "MI0040210",
    "system_name": "PINE VIEW MOBILE HOME PARK",
    "display_name": "PINE VIEW MOBILE HOME PARK",
    "county": "IONIA",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040210",
    "resolved_pwsid": "MI0040210",
    "system_name": "PINE VIEW MOBILE HOME PARK",
    "display_name": "PINE VIEW MOBILE HOME PARK",
    "county": "IONIA",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040210",
    "resolved_pwsid": "MI0040210",
    "system_name": "PINE VIEW MOBILE HOME PARK",
    "display_name": "PINE VIEW MOBILE HOME PARK",
    "county": "IONIA",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040212",
    "resolved_pwsid": "MI0040212",
    "system_name": "NORTHERN PINES",
    "display_name": "NORTHERN PINES",
    "county": "IOSCO",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040212",
    "resolved_pwsid": "MI0040212",
    "system_name": "NORTHERN PINES",
    "display_name": "NORTHERN PINES",
    "county": "IOSCO",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040212",
    "resolved_pwsid": "MI0040212",
    "system_name": "NORTHERN PINES",
    "display_name": "NORTHERN PINES",
    "county": "IOSCO",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 18,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040212",
    "resolved_pwsid": "MI0040212",
    "system_name": "NORTHERN PINES",
    "display_name": "NORTHERN PINES",
    "county": "IOSCO",
    "monitoring_end_date": "2024-06-30",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040212",
    "resolved_pwsid": "MI0040212",
    "system_name": "NORTHERN PINES",
    "display_name": "NORTHERN PINES",
    "county": "IOSCO",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040212",
    "resolved_pwsid": "MI0040212",
    "system_name": "NORTHERN PINES",
    "display_name": "NORTHERN PINES",
    "county": "IOSCO",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040212",
    "resolved_pwsid": "MI0040212",
    "system_name": "NORTHERN PINES",
    "display_name": "NORTHERN PINES",
    "county": "IOSCO",
    "monitoring_end_date": "2026-06-30",
    "year": 2026,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040213",
    "resolved_pwsid": "MI0040213",
    "system_name": "WHISPERING WOODS-WHITE PINE RIDGE OSCOD",
    "display_name": "WHISPERING WOODS-WHITE PINE RIDGE OSCOD",
    "county": "IOSCO",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040213",
    "resolved_pwsid": "MI0040213",
    "system_name": "WHISPERING WOODS-WHITE PINE RIDGE OSCOD",
    "display_name": "WHISPERING WOODS-WHITE PINE RIDGE OSCOD",
    "county": "IOSCO",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040216",
    "resolved_pwsid": "MI0040216-a",
    "system_name": "ALEXANDERS MOBILE VILLAGE",
    "display_name": "ALEXANDERS MOBILE VILLAGE",
    "county": "ISABELLA",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040216",
    "resolved_pwsid": "MI0040216-a",
    "system_name": "ALEXANDERS MOBILE VILLAGE",
    "display_name": "ALEXANDERS MOBILE VILLAGE",
    "county": "ISABELLA",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040216",
    "resolved_pwsid": "MI0040216-b",
    "system_name": "MAPLE LEAF VILLAGE",
    "display_name": "MAPLE LEAF VILLAGE",
    "county": "ISABELLA",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040217",
    "resolved_pwsid": "MI0040217",
    "system_name": "MAPLEVIEW ESTATES",
    "display_name": "MAPLEVIEW ESTATES",
    "county": "ISABELLA",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040217",
    "resolved_pwsid": "MI0040217",
    "system_name": "MAPLEVIEW ESTATES",
    "display_name": "MAPLEVIEW ESTATES",
    "county": "ISABELLA",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040217",
    "resolved_pwsid": "MI0040217",
    "system_name": "MAPLEVIEW ESTATES",
    "display_name": "MAPLEVIEW ESTATES",
    "county": "ISABELLA",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040218",
    "resolved_pwsid": "MI0040218",
    "system_name": "BROOMFIELD VALLEY",
    "display_name": "BROOMFIELD VALLEY",
    "county": "ISABELLA",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040218",
    "resolved_pwsid": "MI0040218",
    "system_name": "BROOMFIELD VALLEY",
    "display_name": "BROOMFIELD VALLEY",
    "county": "ISABELLA",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040218",
    "resolved_pwsid": "MI0040218",
    "system_name": "BROOMFIELD VALLEY",
    "display_name": "BROOMFIELD VALLEY",
    "county": "ISABELLA",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040219",
    "resolved_pwsid": "MI0040219",
    "system_name": "MAPLEVIEW ESTATES EAST",
    "display_name": "MAPLEVIEW ESTATES EAST",
    "county": "ISABELLA",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040219",
    "resolved_pwsid": "MI0040219",
    "system_name": "MAPLEVIEW ESTATES EAST",
    "display_name": "MAPLEVIEW ESTATES EAST",
    "county": "ISABELLA",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040219",
    "resolved_pwsid": "MI0040219",
    "system_name": "MAPLEVIEW ESTATES EAST",
    "display_name": "MAPLEVIEW ESTATES EAST",
    "county": "ISABELLA",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040220",
    "resolved_pwsid": "MI0040220",
    "system_name": "COUNTRY PLACE",
    "display_name": "COUNTRY PLACE",
    "county": "ISABELLA",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040220",
    "resolved_pwsid": "MI0040220",
    "system_name": "COUNTRY PLACE",
    "display_name": "COUNTRY PLACE",
    "county": "ISABELLA",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040220",
    "resolved_pwsid": "MI0040220",
    "system_name": "COUNTRY PLACE",
    "display_name": "COUNTRY PLACE",
    "county": "ISABELLA",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040222",
    "resolved_pwsid": "MI0040222",
    "system_name": "OAKVIEW MOBILE ESTATES",
    "display_name": "OAKVIEW MOBILE ESTATES",
    "county": "ISABELLA",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040222",
    "resolved_pwsid": "MI0040222",
    "system_name": "OAKVIEW MOBILE ESTATES",
    "display_name": "OAKVIEW MOBILE ESTATES",
    "county": "ISABELLA",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040222",
    "resolved_pwsid": "MI0040222",
    "system_name": "OAKVIEW MOBILE ESTATES",
    "display_name": "OAKVIEW MOBILE ESTATES",
    "county": "ISABELLA",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040223",
    "resolved_pwsid": "MI0040223",
    "system_name": "ARBOR VILLAGE",
    "display_name": "ARBOR VILLAGE",
    "county": "JACKSON",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040223",
    "resolved_pwsid": "MI0040223",
    "system_name": "ARBOR VILLAGE",
    "display_name": "ARBOR VILLAGE",
    "county": "JACKSON",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040223",
    "resolved_pwsid": "MI0040223",
    "system_name": "ARBOR VILLAGE",
    "display_name": "ARBOR VILLAGE",
    "county": "JACKSON",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040223",
    "resolved_pwsid": "MI0040223",
    "system_name": "ARBOR VILLAGE",
    "display_name": "ARBOR VILLAGE",
    "county": "JACKSON",
    "monitoring_end_date": "2021-06-30",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040223",
    "resolved_pwsid": "MI0040223",
    "system_name": "ARBOR VILLAGE",
    "display_name": "ARBOR VILLAGE",
    "county": "JACKSON",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040223",
    "resolved_pwsid": "MI0040223",
    "system_name": "ARBOR VILLAGE",
    "display_name": "ARBOR VILLAGE",
    "county": "JACKSON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040223",
    "resolved_pwsid": "MI0040223",
    "system_name": "ARBOR VILLAGE",
    "display_name": "ARBOR VILLAGE",
    "county": "JACKSON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040223",
    "resolved_pwsid": "MI0040223",
    "system_name": "ARBOR VILLAGE",
    "display_name": "ARBOR VILLAGE",
    "county": "JACKSON",
    "monitoring_end_date": "2023-06-30",
    "year": 2023,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040223",
    "resolved_pwsid": "MI0040223",
    "system_name": "ARBOR VILLAGE",
    "display_name": "ARBOR VILLAGE",
    "county": "JACKSON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040223",
    "resolved_pwsid": "MI0040223",
    "system_name": "ARBOR VILLAGE",
    "display_name": "ARBOR VILLAGE",
    "county": "JACKSON",
    "monitoring_end_date": "2024-06-30",
    "year": 2024,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040223",
    "resolved_pwsid": "MI0040223",
    "system_name": "ARBOR VILLAGE",
    "display_name": "ARBOR VILLAGE",
    "county": "JACKSON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040223",
    "resolved_pwsid": "MI0040223",
    "system_name": "ARBOR VILLAGE",
    "display_name": "ARBOR VILLAGE",
    "county": "JACKSON",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040223",
    "resolved_pwsid": "MI0040223",
    "system_name": "ARBOR VILLAGE",
    "display_name": "ARBOR VILLAGE",
    "county": "JACKSON",
    "monitoring_end_date": "2026-06-30",
    "year": 2026,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040225",
    "resolved_pwsid": "MI0040225",
    "system_name": "COACHMANS COVE",
    "display_name": "COACHMANS COVE",
    "county": "JACKSON",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040225",
    "resolved_pwsid": "MI0040225",
    "system_name": "COACHMANS COVE",
    "display_name": "COACHMANS COVE",
    "county": "JACKSON",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040225",
    "resolved_pwsid": "MI0040225",
    "system_name": "COACHMANS COVE",
    "display_name": "COACHMANS COVE",
    "county": "JACKSON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040226",
    "resolved_pwsid": "MI0040226-a",
    "system_name": "COFFMANS TRAILER PARK",
    "display_name": "COFFMANS TRAILER PARK",
    "county": "JACKSON",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040226",
    "resolved_pwsid": "MI0040226-a",
    "system_name": "COFFMANS TRAILER PARK",
    "display_name": "COFFMANS TRAILER PARK",
    "county": "JACKSON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040226",
    "resolved_pwsid": "MI0040226-b",
    "system_name": "MICHIGAN AVENUE ESTATES",
    "display_name": "MICHIGAN AVENUE ESTATES",
    "county": "JACKSON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040227",
    "resolved_pwsid": "MI0040227",
    "system_name": "LILLY BANK LANE",
    "display_name": "LILLY BANK LANE",
    "county": "JACKSON",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040227",
    "resolved_pwsid": "MI0040227",
    "system_name": "LILLY BANK LANE",
    "display_name": "LILLY BANK LANE",
    "county": "JACKSON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040227",
    "resolved_pwsid": "MI0040227",
    "system_name": "LILLY BANK LANE",
    "display_name": "LILLY BANK LANE",
    "county": "JACKSON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040230",
    "resolved_pwsid": "MI0040230",
    "system_name": "SPRING VALLEY ESTATES",
    "display_name": "SPRING VALLEY ESTATES",
    "county": "JACKSON",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040230",
    "resolved_pwsid": "MI0040230",
    "system_name": "SPRING VALLEY ESTATES",
    "display_name": "SPRING VALLEY ESTATES",
    "county": "JACKSON",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040230",
    "resolved_pwsid": "MI0040230",
    "system_name": "SPRING VALLEY ESTATES",
    "display_name": "SPRING VALLEY ESTATES",
    "county": "JACKSON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040230",
    "resolved_pwsid": "MI0040230",
    "system_name": "SPRING VALLEY ESTATES",
    "display_name": "SPRING VALLEY ESTATES",
    "county": "JACKSON",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 33,
    "total_to_identify_or_replace": 33,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0040231",
    "resolved_pwsid": "MI0040231",
    "system_name": "HILLANLAKE VILLAGE",
    "display_name": "HILLANLAKE VILLAGE",
    "county": "JACKSON",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040231",
    "resolved_pwsid": "MI0040231",
    "system_name": "HILLANLAKE VILLAGE",
    "display_name": "HILLANLAKE VILLAGE",
    "county": "JACKSON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040231",
    "resolved_pwsid": "MI0040231",
    "system_name": "HILLANLAKE VILLAGE",
    "display_name": "HILLANLAKE VILLAGE",
    "county": "JACKSON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040233",
    "resolved_pwsid": "MI0040233",
    "system_name": "INDIAN VILLAGE",
    "display_name": "INDIAN VILLAGE",
    "county": "JACKSON",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040233",
    "resolved_pwsid": "MI0040233",
    "system_name": "INDIAN VILLAGE",
    "display_name": "INDIAN VILLAGE",
    "county": "JACKSON",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040233",
    "resolved_pwsid": "MI0040233",
    "system_name": "INDIAN VILLAGE",
    "display_name": "INDIAN VILLAGE",
    "county": "JACKSON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040240",
    "resolved_pwsid": "MI0040240-b",
    "system_name": "PLEASANT LAKE MOBILE HOME COURT",
    "display_name": "PLEASANT LAKE MOBILE HOME COURT",
    "county": "JACKSON",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040240",
    "resolved_pwsid": "MI0040240-b",
    "system_name": "PLEASANT LAKE MOBILE HOME COURT",
    "display_name": "PLEASANT LAKE MOBILE HOME COURT",
    "county": "JACKSON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040240",
    "resolved_pwsid": "MI0040240-a",
    "system_name": "MY PLACE AT PLEASANT LAKE",
    "display_name": "MY PLACE AT PLEASANT LAKE",
    "county": "JACKSON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040240",
    "resolved_pwsid": "MI0040240-b",
    "system_name": "PLEASANT LAKE MOBILE HOME COURT",
    "display_name": "PLEASANT LAKE MOBILE HOME COURT",
    "county": "JACKSON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040241",
    "resolved_pwsid": "MI0040241-a",
    "system_name": "CATTAIL ESTATES",
    "display_name": "CATTAIL ESTATES",
    "county": "JACKSON",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040241",
    "resolved_pwsid": "MI0040241-a",
    "system_name": "CATTAIL ESTATES",
    "display_name": "CATTAIL ESTATES",
    "county": "JACKSON",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040241",
    "resolved_pwsid": "MI0040241-a",
    "system_name": "CATTAIL ESTATES",
    "display_name": "CATTAIL ESTATES",
    "county": "JACKSON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040241",
    "resolved_pwsid": "MI0040241-b",
    "system_name": "MY PLACE AT CATTAIL ESTATES",
    "display_name": "MY PLACE AT CATTAIL ESTATES",
    "county": "JACKSON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040242",
    "resolved_pwsid": "MI0040242",
    "system_name": "SHERMAN OAKS",
    "display_name": "SHERMAN OAKS",
    "county": "JACKSON",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040242",
    "resolved_pwsid": "MI0040242",
    "system_name": "SHERMAN OAKS",
    "display_name": "SHERMAN OAKS",
    "county": "JACKSON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040242",
    "resolved_pwsid": "MI0040242",
    "system_name": "SHERMAN OAKS",
    "display_name": "SHERMAN OAKS",
    "county": "JACKSON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040246",
    "resolved_pwsid": "MI0040246",
    "system_name": "ANDREWS ESTATES",
    "display_name": "ANDREWS ESTATES",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040246",
    "resolved_pwsid": "MI0040246",
    "system_name": "ANDREWS ESTATES",
    "display_name": "ANDREWS ESTATES",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040246",
    "resolved_pwsid": "MI0040246",
    "system_name": "ANDREWS ESTATES",
    "display_name": "ANDREWS ESTATES",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040247",
    "resolved_pwsid": "MI0040247-a",
    "system_name": "BOERMAN MOBILE VILLAGE",
    "display_name": "BOERMAN MOBILE VILLAGE",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040247",
    "resolved_pwsid": "MI0040247-a",
    "system_name": "BOERMAN MOBILE VILLAGE",
    "display_name": "BOERMAN MOBILE VILLAGE",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040247",
    "resolved_pwsid": "MI0040247-b",
    "system_name": "MORROW CROSSING MHC",
    "display_name": "MORROW CROSSING MHC",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040248",
    "resolved_pwsid": "MI0040248",
    "system_name": "CLIMAX MOBILE HOME PARK",
    "display_name": "CLIMAX MOBILE HOME PARK",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040248",
    "resolved_pwsid": "MI0040248",
    "system_name": "CLIMAX MOBILE HOME PARK",
    "display_name": "CLIMAX MOBILE HOME PARK",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040248",
    "resolved_pwsid": "MI0040248",
    "system_name": "CLIMAX MOBILE HOME PARK",
    "display_name": "CLIMAX MOBILE HOME PARK",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040250",
    "resolved_pwsid": "MI0040250",
    "system_name": "EVERGREEN PARK",
    "display_name": "EVERGREEN PARK",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040250",
    "resolved_pwsid": "MI0040250",
    "system_name": "EVERGREEN PARK",
    "display_name": "EVERGREEN PARK",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040250",
    "resolved_pwsid": "MI0040250",
    "system_name": "EVERGREEN PARK",
    "display_name": "EVERGREEN PARK",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040253",
    "resolved_pwsid": "MI0040253",
    "system_name": "PORTAGE TERRACE",
    "display_name": "PORTAGE TERRACE",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040253",
    "resolved_pwsid": "MI0040253",
    "system_name": "PORTAGE TERRACE",
    "display_name": "PORTAGE TERRACE",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040253",
    "resolved_pwsid": "MI0040253",
    "system_name": "PORTAGE TERRACE",
    "display_name": "PORTAGE TERRACE",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040253",
    "resolved_pwsid": "MI0040253",
    "system_name": "PORTAGE TERRACE",
    "display_name": "PORTAGE TERRACE",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040255",
    "resolved_pwsid": "MI0040255",
    "system_name": "ROYAL ESTATES",
    "display_name": "ROYAL ESTATES",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040255",
    "resolved_pwsid": "MI0040255",
    "system_name": "ROYAL ESTATES",
    "display_name": "ROYAL ESTATES",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040255",
    "resolved_pwsid": "MI0040255",
    "system_name": "ROYAL ESTATES",
    "display_name": "ROYAL ESTATES",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040256",
    "resolved_pwsid": "MI0040256",
    "system_name": "SUGARLOAF MOBILE HOME PARK",
    "display_name": "SUGARLOAF MOBILE HOME PARK",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040256",
    "resolved_pwsid": "MI0040256",
    "system_name": "SUGARLOAF MOBILE HOME PARK",
    "display_name": "SUGARLOAF MOBILE HOME PARK",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040256",
    "resolved_pwsid": "MI0040256",
    "system_name": "SUGARLOAF MOBILE HOME PARK",
    "display_name": "SUGARLOAF MOBILE HOME PARK",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040259",
    "resolved_pwsid": "MI0040259",
    "system_name": "ALGOMA ESTATES",
    "display_name": "ALGOMA ESTATES",
    "county": "KENT",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040259",
    "resolved_pwsid": "MI0040259",
    "system_name": "ALGOMA ESTATES",
    "display_name": "ALGOMA ESTATES",
    "county": "KENT",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040259",
    "resolved_pwsid": "MI0040259",
    "system_name": "ALGOMA ESTATES",
    "display_name": "ALGOMA ESTATES",
    "county": "KENT",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040259",
    "resolved_pwsid": "MI0040259",
    "system_name": "ALGOMA ESTATES",
    "display_name": "ALGOMA ESTATES",
    "county": "KENT",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0040264",
    "resolved_pwsid": "MI0040264",
    "system_name": "KENT CITY MOBILE HOME PARK",
    "display_name": "KENT CITY MOBILE HOME PARK",
    "county": "KENT",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040264",
    "resolved_pwsid": "MI0040264",
    "system_name": "KENT CITY MOBILE HOME PARK",
    "display_name": "KENT CITY MOBILE HOME PARK",
    "county": "KENT",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040264",
    "resolved_pwsid": "MI0040264",
    "system_name": "KENT CITY MOBILE HOME PARK",
    "display_name": "KENT CITY MOBILE HOME PARK",
    "county": "KENT",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040266",
    "resolved_pwsid": "MI0040266",
    "system_name": "OAKFIELD MOBILE HOME PARK",
    "display_name": "OAKFIELD MOBILE HOME PARK",
    "county": "KENT",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040266",
    "resolved_pwsid": "MI0040266",
    "system_name": "OAKFIELD MOBILE HOME PARK",
    "display_name": "OAKFIELD MOBILE HOME PARK",
    "county": "KENT",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040266",
    "resolved_pwsid": "MI0040266",
    "system_name": "OAKFIELD MOBILE HOME PARK",
    "display_name": "OAKFIELD MOBILE HOME PARK",
    "county": "KENT",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040266",
    "resolved_pwsid": "MI0040266",
    "system_name": "OAKFIELD MOBILE HOME PARK",
    "display_name": "OAKFIELD MOBILE HOME PARK",
    "county": "KENT",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0040273",
    "resolved_pwsid": "MI0040273",
    "system_name": "GREEN ACRES MOBILE HOME PARK",
    "display_name": "GREEN ACRES MOBILE HOME PARK",
    "county": "KENT",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 9,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040273",
    "resolved_pwsid": "MI0040273",
    "system_name": "GREEN ACRES MOBILE HOME PARK",
    "display_name": "GREEN ACRES MOBILE HOME PARK",
    "county": "KENT",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040273",
    "resolved_pwsid": "MI0040273",
    "system_name": "GREEN ACRES MOBILE HOME PARK",
    "display_name": "GREEN ACRES MOBILE HOME PARK",
    "county": "KENT",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040273",
    "resolved_pwsid": "MI0040273",
    "system_name": "GREEN ACRES MOBILE HOME PARK",
    "display_name": "GREEN ACRES MOBILE HOME PARK",
    "county": "KENT",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040273",
    "resolved_pwsid": "MI0040273",
    "system_name": "GREEN ACRES MOBILE HOME PARK",
    "display_name": "GREEN ACRES MOBILE HOME PARK",
    "county": "KENT",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040276",
    "resolved_pwsid": "MI0040276",
    "system_name": "KEY HEIGHTS MOBILE VILLAGE",
    "display_name": "KEY HEIGHTS MOBILE VILLAGE",
    "county": "KENT",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040276",
    "resolved_pwsid": "MI0040276",
    "system_name": "KEY HEIGHTS MOBILE VILLAGE",
    "display_name": "KEY HEIGHTS MOBILE VILLAGE",
    "county": "KENT",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040276",
    "resolved_pwsid": "MI0040276",
    "system_name": "KEY HEIGHTS MOBILE VILLAGE",
    "display_name": "KEY HEIGHTS MOBILE VILLAGE",
    "county": "KENT",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040277",
    "resolved_pwsid": "MI0040277",
    "system_name": "LA-E-MA MOBILE HOME PARK",
    "display_name": "LA-E-MA MOBILE HOME PARK",
    "county": "KENT",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040277",
    "resolved_pwsid": "MI0040277",
    "system_name": "LA-E-MA MOBILE HOME PARK",
    "display_name": "LA-E-MA MOBILE HOME PARK",
    "county": "KENT",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040277",
    "resolved_pwsid": "MI0040277",
    "system_name": "LA-E-MA MOBILE HOME PARK",
    "display_name": "LA-E-MA MOBILE HOME PARK",
    "county": "KENT",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040279",
    "resolved_pwsid": "MI0040279",
    "system_name": "LEISURE VILLAGE",
    "display_name": "LEISURE VILLAGE",
    "county": "KENT",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040279",
    "resolved_pwsid": "MI0040279",
    "system_name": "LEISURE VILLAGE",
    "display_name": "LEISURE VILLAGE",
    "county": "KENT",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040279",
    "resolved_pwsid": "MI0040279",
    "system_name": "LEISURE VILLAGE",
    "display_name": "LEISURE VILLAGE",
    "county": "KENT",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040284",
    "resolved_pwsid": "MI0040284",
    "system_name": "PARKWOOD GREEN",
    "display_name": "PARKWOOD GREEN",
    "county": "KENT",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040284",
    "resolved_pwsid": "MI0040284",
    "system_name": "PARKWOOD GREEN",
    "display_name": "PARKWOOD GREEN",
    "county": "KENT",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040284",
    "resolved_pwsid": "MI0040284",
    "system_name": "PARKWOOD GREEN",
    "display_name": "PARKWOOD GREEN",
    "county": "KENT",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040288",
    "resolved_pwsid": "MI0040288",
    "system_name": "RIVERVIEW MOBILE VILLAGE",
    "display_name": "RIVERVIEW MOBILE VILLAGE",
    "county": "KENT",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040288",
    "resolved_pwsid": "MI0040288",
    "system_name": "RIVERVIEW MOBILE VILLAGE",
    "display_name": "RIVERVIEW MOBILE VILLAGE",
    "county": "KENT",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040288",
    "resolved_pwsid": "MI0040288",
    "system_name": "RIVERVIEW MOBILE VILLAGE",
    "display_name": "RIVERVIEW MOBILE VILLAGE",
    "county": "KENT",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040291",
    "resolved_pwsid": "MI0040291",
    "system_name": "SPRING VALLEY MOBILE HOME PARK",
    "display_name": "SPRING VALLEY MOBILE HOME PARK",
    "county": "KENT",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040292",
    "resolved_pwsid": "MI0040292",
    "system_name": "LAKESIDE MOBILE HOME COMMUNITY",
    "display_name": "LAKESIDE MOBILE HOME COMMUNITY",
    "county": "KENT",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040292",
    "resolved_pwsid": "MI0040292",
    "system_name": "LAKESIDE MOBILE HOME COMMUNITY",
    "display_name": "LAKESIDE MOBILE HOME COMMUNITY",
    "county": "KENT",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040292",
    "resolved_pwsid": "MI0040292",
    "system_name": "LAKESIDE MOBILE HOME COMMUNITY",
    "display_name": "LAKESIDE MOBILE HOME COMMUNITY",
    "county": "KENT",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040293",
    "resolved_pwsid": "MI0040293",
    "system_name": "WELLERS TRAILER PARK",
    "display_name": "WELLERS TRAILER PARK",
    "county": "KENT",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040293",
    "resolved_pwsid": "MI0040293",
    "system_name": "WELLERS TRAILER PARK",
    "display_name": "WELLERS TRAILER PARK",
    "county": "KENT",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040293",
    "resolved_pwsid": "MI0040293",
    "system_name": "WELLERS TRAILER PARK",
    "display_name": "WELLERS TRAILER PARK",
    "county": "KENT",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040294",
    "resolved_pwsid": "MI0040294",
    "system_name": "WHITE CREEK COUNTRY ESTATES",
    "display_name": "WHITE CREEK COUNTRY ESTATES",
    "county": "KENT",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040294",
    "resolved_pwsid": "MI0040294",
    "system_name": "WHITE CREEK COUNTRY ESTATES",
    "display_name": "WHITE CREEK COUNTRY ESTATES",
    "county": "KENT",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040294",
    "resolved_pwsid": "MI0040294",
    "system_name": "WHITE CREEK COUNTRY ESTATES",
    "display_name": "WHITE CREEK COUNTRY ESTATES",
    "county": "KENT",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040294",
    "resolved_pwsid": "MI0040294",
    "system_name": "WHITE CREEK COUNTRY ESTATES",
    "display_name": "WHITE CREEK COUNTRY ESTATES",
    "county": "KENT",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040296",
    "resolved_pwsid": "MI0040296",
    "system_name": "WOODLAND ESTATES",
    "display_name": "WOODLAND ESTATES",
    "county": "KENT",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040296",
    "resolved_pwsid": "MI0040296",
    "system_name": "WOODLAND ESTATES",
    "display_name": "WOODLAND ESTATES",
    "county": "KENT",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040296",
    "resolved_pwsid": "MI0040296",
    "system_name": "WOODLAND ESTATES",
    "display_name": "WOODLAND ESTATES",
    "county": "KENT",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040299",
    "resolved_pwsid": "MI0040299-b",
    "system_name": "IDEAL VILLA MOBILE HOME COMMUNITY",
    "display_name": "IDEAL VILLA MOBILE HOME COMMUNITY",
    "county": "LAPEER",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040299",
    "resolved_pwsid": "MI0040299-b",
    "system_name": "IDEAL VILLA MOBILE HOME COMMUNITY",
    "display_name": "IDEAL VILLA MOBILE HOME COMMUNITY",
    "county": "LAPEER",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040299",
    "resolved_pwsid": "MI0040299-a",
    "system_name": "IDEAL VILLA MANUFACTURED HOME COMMUNITY",
    "display_name": "IDEAL VILLA MANUFACTURED HOME COMMUNITY",
    "county": "LAPEER",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 10,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040302",
    "resolved_pwsid": "MI0040302",
    "system_name": "FIRST POINT MOBILE COURT",
    "display_name": "FIRST POINT MOBILE COURT",
    "county": "LEELANAU",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040302",
    "resolved_pwsid": "MI0040302",
    "system_name": "FIRST POINT MOBILE COURT",
    "display_name": "FIRST POINT MOBILE COURT",
    "county": "LEELANAU",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040302",
    "resolved_pwsid": "MI0040302",
    "system_name": "FIRST POINT MOBILE COURT",
    "display_name": "FIRST POINT MOBILE COURT",
    "county": "LEELANAU",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040302",
    "resolved_pwsid": "MI0040302",
    "system_name": "FIRST POINT MOBILE COURT",
    "display_name": "FIRST POINT MOBILE COURT",
    "county": "LEELANAU",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0040305",
    "resolved_pwsid": "MI0040305",
    "system_name": "CLINTON ESTATES",
    "display_name": "CLINTON ESTATES",
    "county": "LENAWEE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040305",
    "resolved_pwsid": "MI0040305",
    "system_name": "CLINTON ESTATES",
    "display_name": "CLINTON ESTATES",
    "county": "LENAWEE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040305",
    "resolved_pwsid": "MI0040305",
    "system_name": "CLINTON ESTATES",
    "display_name": "CLINTON ESTATES",
    "county": "LENAWEE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040305",
    "resolved_pwsid": "MI0040305",
    "system_name": "CLINTON ESTATES",
    "display_name": "CLINTON ESTATES",
    "county": "LENAWEE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0040306",
    "resolved_pwsid": "MI0040306",
    "system_name": "COUNTRY VILLA ESTATES",
    "display_name": "COUNTRY VILLA ESTATES",
    "county": "LENAWEE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040306",
    "resolved_pwsid": "MI0040306",
    "system_name": "COUNTRY VILLA ESTATES",
    "display_name": "COUNTRY VILLA ESTATES",
    "county": "LENAWEE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040306",
    "resolved_pwsid": "MI0040306",
    "system_name": "COUNTRY VILLA ESTATES",
    "display_name": "COUNTRY VILLA ESTATES",
    "county": "LENAWEE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040307",
    "resolved_pwsid": "MI0040307",
    "system_name": "ROUND LAKE ESTATES",
    "display_name": "ROUND LAKE ESTATES",
    "county": "LENAWEE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040307",
    "resolved_pwsid": "MI0040307",
    "system_name": "ROUND LAKE ESTATES",
    "display_name": "ROUND LAKE ESTATES",
    "county": "LENAWEE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040307",
    "resolved_pwsid": "MI0040307",
    "system_name": "ROUND LAKE ESTATES",
    "display_name": "ROUND LAKE ESTATES",
    "county": "LENAWEE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040308",
    "resolved_pwsid": "MI0040308",
    "system_name": "LEE VILLA MOBILE HOME PARK",
    "display_name": "LEE VILLA MOBILE HOME PARK",
    "county": "LENAWEE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040308",
    "resolved_pwsid": "MI0040308",
    "system_name": "LEE VILLA MOBILE HOME PARK",
    "display_name": "LEE VILLA MOBILE HOME PARK",
    "county": "LENAWEE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040308",
    "resolved_pwsid": "MI0040308",
    "system_name": "LEE VILLA MOBILE HOME PARK",
    "display_name": "LEE VILLA MOBILE HOME PARK",
    "county": "LENAWEE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040308",
    "resolved_pwsid": "MI0040308",
    "system_name": "LEE VILLA MOBILE HOME PARK",
    "display_name": "LEE VILLA MOBILE HOME PARK",
    "county": "LENAWEE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040309",
    "resolved_pwsid": "MI0040309",
    "system_name": "RAISIN VALLEY ESTATES",
    "display_name": "RAISIN VALLEY ESTATES",
    "county": "LENAWEE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040309",
    "resolved_pwsid": "MI0040309",
    "system_name": "RAISIN VALLEY ESTATES",
    "display_name": "RAISIN VALLEY ESTATES",
    "county": "LENAWEE",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 12,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040310",
    "resolved_pwsid": "MI0040310-b",
    "system_name": "ROBIN HOOD MOBILE COURT",
    "display_name": "ROBIN HOOD MOBILE COURT",
    "county": "LENAWEE",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040310",
    "resolved_pwsid": "MI0040310-a",
    "system_name": "PARK VIEW COURT",
    "display_name": "PARK VIEW COURT",
    "county": "LENAWEE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040310",
    "resolved_pwsid": "MI0040310-b",
    "system_name": "ROBIN HOOD MOBILE COURT",
    "display_name": "ROBIN HOOD MOBILE COURT",
    "county": "LENAWEE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040310",
    "resolved_pwsid": "MI0040310-a",
    "system_name": "PARK VIEW COURT",
    "display_name": "PARK VIEW COURT",
    "county": "LENAWEE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040310",
    "resolved_pwsid": "MI0040310-a",
    "system_name": "PARK VIEW COURT",
    "display_name": "PARK VIEW COURT",
    "county": "LENAWEE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0040311",
    "resolved_pwsid": "MI0040311",
    "system_name": "LEFFINGWELL ESTATES",
    "display_name": "LEFFINGWELL ESTATES",
    "county": "LENAWEE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040311",
    "resolved_pwsid": "MI0040311",
    "system_name": "LEFFINGWELL ESTATES",
    "display_name": "LEFFINGWELL ESTATES",
    "county": "LENAWEE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040311",
    "resolved_pwsid": "MI0040311",
    "system_name": "LEFFINGWELL ESTATES",
    "display_name": "LEFFINGWELL ESTATES",
    "county": "LENAWEE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040311",
    "resolved_pwsid": "MI0040311",
    "system_name": "LEFFINGWELL ESTATES",
    "display_name": "LEFFINGWELL ESTATES",
    "county": "LENAWEE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040313",
    "resolved_pwsid": "MI0040313-b",
    "system_name": "SUNSET MOBILE HOME PARK",
    "display_name": "SUNSET MOBILE HOME PARK",
    "county": "LENAWEE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040313",
    "resolved_pwsid": "MI0040313-b",
    "system_name": "SUNSET MOBILE HOME PARK",
    "display_name": "SUNSET MOBILE HOME PARK",
    "county": "LENAWEE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040313",
    "resolved_pwsid": "MI0040313-a",
    "system_name": "SUNSET MHP",
    "display_name": "SUNSET MHP",
    "county": "LENAWEE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040314",
    "resolved_pwsid": "MI0040314",
    "system_name": "SYLVAN GLEN ESTATES",
    "display_name": "SYLVAN GLEN ESTATES",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040314",
    "resolved_pwsid": "MI0040314",
    "system_name": "SYLVAN GLEN ESTATES",
    "display_name": "SYLVAN GLEN ESTATES",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040314",
    "resolved_pwsid": "MI0040314",
    "system_name": "SYLVAN GLEN ESTATES",
    "display_name": "SYLVAN GLEN ESTATES",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040314",
    "resolved_pwsid": "MI0040314",
    "system_name": "SYLVAN GLEN ESTATES",
    "display_name": "SYLVAN GLEN ESTATES",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040314",
    "resolved_pwsid": "MI0040314",
    "system_name": "SYLVAN GLEN ESTATES",
    "display_name": "SYLVAN GLEN ESTATES",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040316",
    "resolved_pwsid": "MI0040316",
    "system_name": "FAIRLANE ESTATES",
    "display_name": "FAIRLANE ESTATES",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040316",
    "resolved_pwsid": "MI0040316",
    "system_name": "FAIRLANE ESTATES",
    "display_name": "FAIRLANE ESTATES",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040316",
    "resolved_pwsid": "MI0040316",
    "system_name": "FAIRLANE ESTATES",
    "display_name": "FAIRLANE ESTATES",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040317",
    "resolved_pwsid": "MI0040317",
    "system_name": "HAMBURG HILLS ESTATES",
    "display_name": "HAMBURG HILLS ESTATES",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040317",
    "resolved_pwsid": "MI0040317",
    "system_name": "HAMBURG HILLS ESTATES",
    "display_name": "HAMBURG HILLS ESTATES",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040317",
    "resolved_pwsid": "MI0040317",
    "system_name": "HAMBURG HILLS ESTATES",
    "display_name": "HAMBURG HILLS ESTATES",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040318",
    "resolved_pwsid": "MI0040318",
    "system_name": "FAIRLAWN MEADOWS",
    "display_name": "FAIRLAWN MEADOWS",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040318",
    "resolved_pwsid": "MI0040318",
    "system_name": "FAIRLAWN MEADOWS",
    "display_name": "FAIRLAWN MEADOWS",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040318",
    "resolved_pwsid": "MI0040318",
    "system_name": "FAIRLAWN MEADOWS",
    "display_name": "FAIRLAWN MEADOWS",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040318",
    "resolved_pwsid": "MI0040318",
    "system_name": "FAIRLAWN MEADOWS",
    "display_name": "FAIRLAWN MEADOWS",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040319",
    "resolved_pwsid": "MI0040319",
    "system_name": "ALAN'S PARK - FOWLERVILLE",
    "display_name": "ALAN'S PARK - FOWLERVILLE",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2016-06-30",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040319",
    "resolved_pwsid": "MI0040319",
    "system_name": "ALAN'S PARK - FOWLERVILLE",
    "display_name": "ALAN'S PARK - FOWLERVILLE",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040319",
    "resolved_pwsid": "MI0040319",
    "system_name": "ALAN'S PARK - FOWLERVILLE",
    "display_name": "ALAN'S PARK - FOWLERVILLE",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040319",
    "resolved_pwsid": "MI0040319",
    "system_name": "ALAN'S PARK - FOWLERVILLE",
    "display_name": "ALAN'S PARK - FOWLERVILLE",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040319",
    "resolved_pwsid": "MI0040319",
    "system_name": "ALAN'S PARK - FOWLERVILLE",
    "display_name": "ALAN'S PARK - FOWLERVILLE",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0040322",
    "resolved_pwsid": "MI0040322",
    "system_name": "SILVER LAKE MOBILE HOME PARK",
    "display_name": "SILVER LAKE MOBILE HOME PARK",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040322",
    "resolved_pwsid": "MI0040322",
    "system_name": "SILVER LAKE MOBILE HOME PARK",
    "display_name": "SILVER LAKE MOBILE HOME PARK",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040322",
    "resolved_pwsid": "MI0040322",
    "system_name": "SILVER LAKE MOBILE HOME PARK",
    "display_name": "SILVER LAKE MOBILE HOME PARK",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040323",
    "resolved_pwsid": "MI0040323",
    "system_name": "STARLIGHT MOBILE HOME PARK",
    "display_name": "STARLIGHT MOBILE HOME PARK",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040323",
    "resolved_pwsid": "MI0040323",
    "system_name": "STARLIGHT MOBILE HOME PARK",
    "display_name": "STARLIGHT MOBILE HOME PARK",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040323",
    "resolved_pwsid": "MI0040323",
    "system_name": "STARLIGHT MOBILE HOME PARK",
    "display_name": "STARLIGHT MOBILE HOME PARK",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040323",
    "resolved_pwsid": "MI0040323",
    "system_name": "STARLIGHT MOBILE HOME PARK",
    "display_name": "STARLIGHT MOBILE HOME PARK",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040325",
    "resolved_pwsid": "MI0040325",
    "system_name": "UNIVERSITY MOBILE ESTATES #2",
    "display_name": "UNIVERSITY MOBILE ESTATES #2",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040325",
    "resolved_pwsid": "MI0040325",
    "system_name": "UNIVERSITY MOBILE ESTATES #2",
    "display_name": "UNIVERSITY MOBILE ESTATES #2",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040325",
    "resolved_pwsid": "MI0040325",
    "system_name": "UNIVERSITY MOBILE ESTATES #2",
    "display_name": "UNIVERSITY MOBILE ESTATES #2",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040326",
    "resolved_pwsid": "MI0040326",
    "system_name": "WOODLAND PARK AND SALES",
    "display_name": "WOODLAND PARK AND SALES",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040326",
    "resolved_pwsid": "MI0040326",
    "system_name": "WOODLAND PARK AND SALES",
    "display_name": "WOODLAND PARK AND SALES",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040326",
    "resolved_pwsid": "MI0040326",
    "system_name": "WOODLAND PARK AND SALES",
    "display_name": "WOODLAND PARK AND SALES",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040326",
    "resolved_pwsid": "MI0040326",
    "system_name": "WOODLAND PARK AND SALES",
    "display_name": "WOODLAND PARK AND SALES",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040327",
    "resolved_pwsid": "MI0040327",
    "system_name": "SPRINGBROOK ESTATES MHC",
    "display_name": "SPRINGBROOK ESTATES MHC",
    "county": "MACOMB",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040327",
    "resolved_pwsid": "MI0040327",
    "system_name": "SPRINGBROOK ESTATES MHC",
    "display_name": "SPRINGBROOK ESTATES MHC",
    "county": "MACOMB",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040327",
    "resolved_pwsid": "MI0040327",
    "system_name": "SPRINGBROOK ESTATES MHC",
    "display_name": "SPRINGBROOK ESTATES MHC",
    "county": "MACOMB",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040327",
    "resolved_pwsid": "MI0040327",
    "system_name": "SPRINGBROOK ESTATES MHC",
    "display_name": "SPRINGBROOK ESTATES MHC",
    "county": "MACOMB",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040327",
    "resolved_pwsid": "MI0040327",
    "system_name": "SPRINGBROOK ESTATES MHC",
    "display_name": "SPRINGBROOK ESTATES MHC",
    "county": "MACOMB",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040327",
    "resolved_pwsid": "MI0040327",
    "system_name": "SPRINGBROOK ESTATES MHC",
    "display_name": "SPRINGBROOK ESTATES MHC",
    "county": "MACOMB",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040327",
    "resolved_pwsid": "MI0040327",
    "system_name": "SPRINGBROOK ESTATES MHC",
    "display_name": "SPRINGBROOK ESTATES MHC",
    "county": "MACOMB",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040327",
    "resolved_pwsid": "MI0040327",
    "system_name": "SPRINGBROOK ESTATES MHC",
    "display_name": "SPRINGBROOK ESTATES MHC",
    "county": "MACOMB",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040330",
    "resolved_pwsid": "MI0040330",
    "system_name": "WASHINGTON MHP",
    "display_name": "WASHINGTON MHP",
    "county": "MACOMB",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040330",
    "resolved_pwsid": "MI0040330",
    "system_name": "WASHINGTON MHP",
    "display_name": "WASHINGTON MHP",
    "county": "MACOMB",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040330",
    "resolved_pwsid": "MI0040330",
    "system_name": "WASHINGTON MHP",
    "display_name": "WASHINGTON MHP",
    "county": "MACOMB",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040330",
    "resolved_pwsid": "MI0040330",
    "system_name": "WASHINGTON MHP",
    "display_name": "WASHINGTON MHP",
    "county": "MACOMB",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040332",
    "resolved_pwsid": "MI0040332",
    "system_name": "MANISTEE FOREST PINES ESTATES",
    "display_name": "MANISTEE FOREST PINES ESTATES",
    "county": "MASON",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040332",
    "resolved_pwsid": "MI0040332",
    "system_name": "MANISTEE FOREST PINES ESTATES",
    "display_name": "MANISTEE FOREST PINES ESTATES",
    "county": "MASON",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040332",
    "resolved_pwsid": "MI0040332",
    "system_name": "MANISTEE FOREST PINES ESTATES",
    "display_name": "MANISTEE FOREST PINES ESTATES",
    "county": "MASON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040333",
    "resolved_pwsid": "MI0040333",
    "system_name": "HERITAGE HILLS MOBILE HOME VILLAGE",
    "display_name": "HERITAGE HILLS MOBILE HOME VILLAGE",
    "county": "MASON",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040333",
    "resolved_pwsid": "MI0040333",
    "system_name": "HERITAGE HILLS MOBILE HOME VILLAGE",
    "display_name": "HERITAGE HILLS MOBILE HOME VILLAGE",
    "county": "MASON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040333",
    "resolved_pwsid": "MI0040333",
    "system_name": "HERITAGE HILLS MOBILE HOME VILLAGE",
    "display_name": "HERITAGE HILLS MOBILE HOME VILLAGE",
    "county": "MASON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040335",
    "resolved_pwsid": "MI0040335",
    "system_name": "HOLIDAY VILLAGE MOBILE HOME PARK",
    "display_name": "HOLIDAY VILLAGE MOBILE HOME PARK",
    "county": "MASON",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040335",
    "resolved_pwsid": "MI0040335",
    "system_name": "HOLIDAY VILLAGE MOBILE HOME PARK",
    "display_name": "HOLIDAY VILLAGE MOBILE HOME PARK",
    "county": "MASON",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040335",
    "resolved_pwsid": "MI0040335",
    "system_name": "HOLIDAY VILLAGE MOBILE HOME PARK",
    "display_name": "HOLIDAY VILLAGE MOBILE HOME PARK",
    "county": "MASON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040337",
    "resolved_pwsid": "MI0040337",
    "system_name": "TAMARAC VILLAGE",
    "display_name": "TAMARAC VILLAGE",
    "county": "MASON",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040337",
    "resolved_pwsid": "MI0040337",
    "system_name": "TAMARAC VILLAGE",
    "display_name": "TAMARAC VILLAGE",
    "county": "MASON",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040337",
    "resolved_pwsid": "MI0040337",
    "system_name": "TAMARAC VILLAGE",
    "display_name": "TAMARAC VILLAGE",
    "county": "MASON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040337",
    "resolved_pwsid": "MI0040337",
    "system_name": "TAMARAC VILLAGE",
    "display_name": "TAMARAC VILLAGE",
    "county": "MASON",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0040339",
    "resolved_pwsid": "MI0040339",
    "system_name": "CIRCLE DRIVE MOBILE HOME PARK",
    "display_name": "CIRCLE DRIVE MOBILE HOME PARK",
    "county": "MECOSTA",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040339",
    "resolved_pwsid": "MI0040339",
    "system_name": "CIRCLE DRIVE MOBILE HOME PARK",
    "display_name": "CIRCLE DRIVE MOBILE HOME PARK",
    "county": "MECOSTA",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040339",
    "resolved_pwsid": "MI0040339",
    "system_name": "CIRCLE DRIVE MOBILE HOME PARK",
    "display_name": "CIRCLE DRIVE MOBILE HOME PARK",
    "county": "MECOSTA",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040340",
    "resolved_pwsid": "MI0040340",
    "system_name": "PARKS PLACE ESTATES",
    "display_name": "PARKS PLACE ESTATES",
    "county": "MECOSTA",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040340",
    "resolved_pwsid": "MI0040340",
    "system_name": "PARKS PLACE ESTATES",
    "display_name": "PARKS PLACE ESTATES",
    "county": "MECOSTA",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040340",
    "resolved_pwsid": "MI0040340",
    "system_name": "PARKS PLACE ESTATES",
    "display_name": "PARKS PLACE ESTATES",
    "county": "MECOSTA",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040342",
    "resolved_pwsid": "MI0040342",
    "system_name": "HUNTERS CREEK ESTATES",
    "display_name": "HUNTERS CREEK ESTATES",
    "county": "MECOSTA",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040342",
    "resolved_pwsid": "MI0040342",
    "system_name": "HUNTERS CREEK ESTATES",
    "display_name": "HUNTERS CREEK ESTATES",
    "county": "MECOSTA",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040342",
    "resolved_pwsid": "MI0040342",
    "system_name": "HUNTERS CREEK ESTATES",
    "display_name": "HUNTERS CREEK ESTATES",
    "county": "MECOSTA",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040343",
    "resolved_pwsid": "MI0040343",
    "system_name": "HAVEN VIEW MOBILE COURT",
    "display_name": "HAVEN VIEW MOBILE COURT",
    "county": "MECOSTA",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040343",
    "resolved_pwsid": "MI0040343",
    "system_name": "HAVEN VIEW MOBILE COURT",
    "display_name": "HAVEN VIEW MOBILE COURT",
    "county": "MECOSTA",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040343",
    "resolved_pwsid": "MI0040343",
    "system_name": "HAVEN VIEW MOBILE COURT",
    "display_name": "HAVEN VIEW MOBILE COURT",
    "county": "MECOSTA",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040343",
    "resolved_pwsid": "MI0040343",
    "system_name": "HAVEN VIEW MOBILE COURT",
    "display_name": "HAVEN VIEW MOBILE COURT",
    "county": "MECOSTA",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040344",
    "resolved_pwsid": "MI0040344",
    "system_name": "HOLIDAY TERRACE",
    "display_name": "HOLIDAY TERRACE",
    "county": "MECOSTA",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040344",
    "resolved_pwsid": "MI0040344",
    "system_name": "HOLIDAY TERRACE",
    "display_name": "HOLIDAY TERRACE",
    "county": "MECOSTA",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 14,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040344",
    "resolved_pwsid": "MI0040344",
    "system_name": "HOLIDAY TERRACE",
    "display_name": "HOLIDAY TERRACE",
    "county": "MECOSTA",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040345",
    "resolved_pwsid": "MI0040345-a",
    "system_name": "COUNTRY ACRES",
    "display_name": "COUNTRY ACRES",
    "county": "MIDLAND",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040345",
    "resolved_pwsid": "MI0040345-b",
    "system_name": "RUMBAUGH ESTATES LLC",
    "display_name": "RUMBAUGH ESTATES LLC",
    "county": "MIDLAND",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040345",
    "resolved_pwsid": "MI0040345-b",
    "system_name": "RUMBAUGH ESTATES LLC",
    "display_name": "RUMBAUGH ESTATES LLC",
    "county": "MIDLAND",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040345",
    "resolved_pwsid": "MI0040345-b",
    "system_name": "RUMBAUGH ESTATES LLC",
    "display_name": "RUMBAUGH ESTATES LLC",
    "county": "MIDLAND",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040346",
    "resolved_pwsid": "MI0040346",
    "system_name": "COUNTRYSIDE MOBILE HOME PARK",
    "display_name": "COUNTRYSIDE MOBILE HOME PARK",
    "county": "MIDLAND",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040346",
    "resolved_pwsid": "MI0040346",
    "system_name": "COUNTRYSIDE MOBILE HOME PARK",
    "display_name": "COUNTRYSIDE MOBILE HOME PARK",
    "county": "MIDLAND",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040347",
    "resolved_pwsid": "MI0040347",
    "system_name": "WHISPERING PINES HOUSING COMMUNITY",
    "display_name": "WHISPERING PINES HOUSING COMMUNITY",
    "county": "MIDLAND",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040347",
    "resolved_pwsid": "MI0040347",
    "system_name": "WHISPERING PINES HOUSING COMMUNITY",
    "display_name": "WHISPERING PINES HOUSING COMMUNITY",
    "county": "MIDLAND",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040347",
    "resolved_pwsid": "MI0040347",
    "system_name": "WHISPERING PINES HOUSING COMMUNITY",
    "display_name": "WHISPERING PINES HOUSING COMMUNITY",
    "county": "MIDLAND",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040351",
    "resolved_pwsid": "MI0040351",
    "system_name": "SHERIDAN ESTATES",
    "display_name": "SHERIDAN ESTATES",
    "county": "MONTCALM",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040351",
    "resolved_pwsid": "MI0040351",
    "system_name": "SHERIDAN ESTATES",
    "display_name": "SHERIDAN ESTATES",
    "county": "MONTCALM",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040351",
    "resolved_pwsid": "MI0040351",
    "system_name": "SHERIDAN ESTATES",
    "display_name": "SHERIDAN ESTATES",
    "county": "MONTCALM",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040352",
    "resolved_pwsid": "MI0040352",
    "system_name": "GREENBRIER ESTATES",
    "display_name": "GREENBRIER ESTATES",
    "county": "MONTCALM",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040352",
    "resolved_pwsid": "MI0040352",
    "system_name": "GREENBRIER ESTATES",
    "display_name": "GREENBRIER ESTATES",
    "county": "MONTCALM",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040352",
    "resolved_pwsid": "MI0040352",
    "system_name": "GREENBRIER ESTATES",
    "display_name": "GREENBRIER ESTATES",
    "county": "MONTCALM",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040355",
    "resolved_pwsid": "MI0040355",
    "system_name": "APPLE CARR VILLAGE",
    "display_name": "APPLE CARR VILLAGE",
    "county": "MUSKEGON",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040355",
    "resolved_pwsid": "MI0040355",
    "system_name": "APPLE CARR VILLAGE",
    "display_name": "APPLE CARR VILLAGE",
    "county": "MUSKEGON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040355",
    "resolved_pwsid": "MI0040355",
    "system_name": "APPLE CARR VILLAGE",
    "display_name": "APPLE CARR VILLAGE",
    "county": "MUSKEGON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040356",
    "resolved_pwsid": "MI0040356",
    "system_name": "ARLINGTON WOODS",
    "display_name": "ARLINGTON WOODS",
    "county": "MUSKEGON",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040356",
    "resolved_pwsid": "MI0040356",
    "system_name": "ARLINGTON WOODS",
    "display_name": "ARLINGTON WOODS",
    "county": "MUSKEGON",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040356",
    "resolved_pwsid": "MI0040356",
    "system_name": "ARLINGTON WOODS",
    "display_name": "ARLINGTON WOODS",
    "county": "MUSKEGON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040357",
    "resolved_pwsid": "MI0040357",
    "system_name": "CRYSTAL DOWNS MOBILE VILLAGE",
    "display_name": "CRYSTAL DOWNS MOBILE VILLAGE",
    "county": "MUSKEGON",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040357",
    "resolved_pwsid": "MI0040357",
    "system_name": "CRYSTAL DOWNS MOBILE VILLAGE",
    "display_name": "CRYSTAL DOWNS MOBILE VILLAGE",
    "county": "MUSKEGON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040357",
    "resolved_pwsid": "MI0040357",
    "system_name": "CRYSTAL DOWNS MOBILE VILLAGE",
    "display_name": "CRYSTAL DOWNS MOBILE VILLAGE",
    "county": "MUSKEGON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040359",
    "resolved_pwsid": "MI0040359",
    "system_name": "EDGEWOOD MOBILE HOME PARK",
    "display_name": "EDGEWOOD MOBILE HOME PARK",
    "county": "MUSKEGON",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040359",
    "resolved_pwsid": "MI0040359",
    "system_name": "EDGEWOOD MOBILE HOME PARK",
    "display_name": "EDGEWOOD MOBILE HOME PARK",
    "county": "MUSKEGON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040359",
    "resolved_pwsid": "MI0040359",
    "system_name": "EDGEWOOD MOBILE HOME PARK",
    "display_name": "EDGEWOOD MOBILE HOME PARK",
    "county": "MUSKEGON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040361",
    "resolved_pwsid": "MI0040361",
    "system_name": "MAPLE ISLAND ESTATES",
    "display_name": "MAPLE ISLAND ESTATES",
    "county": "MUSKEGON",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040361",
    "resolved_pwsid": "MI0040361",
    "system_name": "MAPLE ISLAND ESTATES",
    "display_name": "MAPLE ISLAND ESTATES",
    "county": "MUSKEGON",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040361",
    "resolved_pwsid": "MI0040361",
    "system_name": "MAPLE ISLAND ESTATES",
    "display_name": "MAPLE ISLAND ESTATES",
    "county": "MUSKEGON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040361",
    "resolved_pwsid": "MI0040361",
    "system_name": "MAPLE ISLAND ESTATES",
    "display_name": "MAPLE ISLAND ESTATES",
    "county": "MUSKEGON",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0040363",
    "resolved_pwsid": "MI0040363",
    "system_name": "TIMBERLINE ESTATES",
    "display_name": "TIMBERLINE ESTATES",
    "county": "MUSKEGON",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040363",
    "resolved_pwsid": "MI0040363",
    "system_name": "TIMBERLINE ESTATES",
    "display_name": "TIMBERLINE ESTATES",
    "county": "MUSKEGON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040363",
    "resolved_pwsid": "MI0040363",
    "system_name": "TIMBERLINE ESTATES",
    "display_name": "TIMBERLINE ESTATES",
    "county": "MUSKEGON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040368",
    "resolved_pwsid": "MI0040368",
    "system_name": "LAKE FOREST PARK",
    "display_name": "LAKE FOREST PARK",
    "county": "NEWAYGO",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040368",
    "resolved_pwsid": "MI0040368",
    "system_name": "LAKE FOREST PARK",
    "display_name": "LAKE FOREST PARK",
    "county": "NEWAYGO",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040368",
    "resolved_pwsid": "MI0040368",
    "system_name": "LAKE FOREST PARK",
    "display_name": "LAKE FOREST PARK",
    "county": "NEWAYGO",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040369",
    "resolved_pwsid": "MI0040369-a",
    "system_name": "FOUR SEASONS TRAILER PARK",
    "display_name": "FOUR SEASONS TRAILER PARK",
    "county": "NEWAYGO",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040369",
    "resolved_pwsid": "MI0040369-a",
    "system_name": "FOUR SEASONS TRAILER PARK",
    "display_name": "FOUR SEASONS TRAILER PARK",
    "county": "NEWAYGO",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040369",
    "resolved_pwsid": "MI0040369-b",
    "system_name": "HARDY PARK",
    "display_name": "HARDY PARK",
    "county": "NEWAYGO",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040369",
    "resolved_pwsid": "MI0040369",
    "system_name": "FOUR SEASONS TRAILER PARK",
    "display_name": "FOUR SEASONS TRAILER PARK",
    "county": "NEWAYGO",
    "monitoring_end_date": "",
    "year": 2025,
    "lead_90th_ppb": null,
    "above_action_level": false,
    "lines_replaced": 23,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040370",
    "resolved_pwsid": "MI0040370",
    "system_name": "HESS LAKE RV AND MOBILE HOME PARK",
    "display_name": "HESS LAKE RV AND MOBILE HOME PARK",
    "county": "NEWAYGO",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040370",
    "resolved_pwsid": "MI0040370",
    "system_name": "HESS LAKE RV AND MOBILE HOME PARK",
    "display_name": "HESS LAKE RV AND MOBILE HOME PARK",
    "county": "NEWAYGO",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040370",
    "resolved_pwsid": "MI0040370",
    "system_name": "HESS LAKE RV AND MOBILE HOME PARK",
    "display_name": "HESS LAKE RV AND MOBILE HOME PARK",
    "county": "NEWAYGO",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 49,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040370",
    "resolved_pwsid": "MI0040370",
    "system_name": "HESS LAKE RV AND MOBILE HOME PARK",
    "display_name": "HESS LAKE RV AND MOBILE HOME PARK",
    "county": "NEWAYGO",
    "monitoring_end_date": "2024-06-30",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040370",
    "resolved_pwsid": "MI0040370",
    "system_name": "HESS LAKE RV AND MOBILE HOME PARK",
    "display_name": "HESS LAKE RV AND MOBILE HOME PARK",
    "county": "NEWAYGO",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040370",
    "resolved_pwsid": "MI0040370",
    "system_name": "HESS LAKE RV AND MOBILE HOME PARK",
    "display_name": "HESS LAKE RV AND MOBILE HOME PARK",
    "county": "NEWAYGO",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040375",
    "resolved_pwsid": "MI0040375",
    "system_name": "CEDARBROOK ESTATES",
    "display_name": "CEDARBROOK ESTATES",
    "county": "OAKLAND",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040375",
    "resolved_pwsid": "MI0040375",
    "system_name": "CEDARBROOK ESTATES",
    "display_name": "CEDARBROOK ESTATES",
    "county": "OAKLAND",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040375",
    "resolved_pwsid": "MI0040375",
    "system_name": "CEDARBROOK ESTATES",
    "display_name": "CEDARBROOK ESTATES",
    "county": "OAKLAND",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040376",
    "resolved_pwsid": "MI0040376",
    "system_name": "CHILDS LAKE ESTATES MHC",
    "display_name": "CHILDS LAKE ESTATES MHC",
    "county": "OAKLAND",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040376",
    "resolved_pwsid": "MI0040376",
    "system_name": "CHILDS LAKE ESTATES MHC",
    "display_name": "CHILDS LAKE ESTATES MHC",
    "county": "OAKLAND",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040376",
    "resolved_pwsid": "MI0040376",
    "system_name": "CHILDS LAKE ESTATES MHC",
    "display_name": "CHILDS LAKE ESTATES MHC",
    "county": "OAKLAND",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040377",
    "resolved_pwsid": "MI0040377",
    "system_name": "CLARKSTON LAKE ESTATES",
    "display_name": "CLARKSTON LAKE ESTATES",
    "county": "OAKLAND",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040377",
    "resolved_pwsid": "MI0040377",
    "system_name": "CLARKSTON LAKE ESTATES",
    "display_name": "CLARKSTON LAKE ESTATES",
    "county": "OAKLAND",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040377",
    "resolved_pwsid": "MI0040377",
    "system_name": "CLARKSTON LAKE ESTATES",
    "display_name": "CLARKSTON LAKE ESTATES",
    "county": "OAKLAND",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040379",
    "resolved_pwsid": "MI0040379",
    "system_name": "COLLEGE HEIGHTS MOBILE HOME PARK",
    "display_name": "COLLEGE HEIGHTS MOBILE HOME PARK",
    "county": "OAKLAND",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040379",
    "resolved_pwsid": "MI0040379",
    "system_name": "COLLEGE HEIGHTS MOBILE HOME PARK",
    "display_name": "COLLEGE HEIGHTS MOBILE HOME PARK",
    "county": "OAKLAND",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040379",
    "resolved_pwsid": "MI0040379",
    "system_name": "COLLEGE HEIGHTS MOBILE HOME PARK",
    "display_name": "COLLEGE HEIGHTS MOBILE HOME PARK",
    "county": "OAKLAND",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040381",
    "resolved_pwsid": "MI0040381",
    "system_name": "COUNTRY ESTATES MHP",
    "display_name": "COUNTRY ESTATES MHP",
    "county": "OAKLAND",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040381",
    "resolved_pwsid": "MI0040381",
    "system_name": "COUNTRY ESTATES MHP",
    "display_name": "COUNTRY ESTATES MHP",
    "county": "OAKLAND",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040382",
    "resolved_pwsid": "MI0040382",
    "system_name": "CRANBERRY LAKE MHC",
    "display_name": "CRANBERRY LAKE MHC",
    "county": "OAKLAND",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040382",
    "resolved_pwsid": "MI0040382",
    "system_name": "CRANBERRY LAKE MHC",
    "display_name": "CRANBERRY LAKE MHC",
    "county": "OAKLAND",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040382",
    "resolved_pwsid": "MI0040382",
    "system_name": "CRANBERRY LAKE MHC",
    "display_name": "CRANBERRY LAKE MHC",
    "county": "OAKLAND",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040384",
    "resolved_pwsid": "MI0040384",
    "system_name": "GROVELAND MANOR",
    "display_name": "GROVELAND MANOR",
    "county": "OAKLAND",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040384",
    "resolved_pwsid": "MI0040384",
    "system_name": "GROVELAND MANOR",
    "display_name": "GROVELAND MANOR",
    "county": "OAKLAND",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040384",
    "resolved_pwsid": "MI0040384",
    "system_name": "GROVELAND MANOR",
    "display_name": "GROVELAND MANOR",
    "county": "OAKLAND",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 9,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040386",
    "resolved_pwsid": "MI0040386",
    "system_name": "HIDDEN LAKE ESTATES",
    "display_name": "HIDDEN LAKE ESTATES",
    "county": "OAKLAND",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040386",
    "resolved_pwsid": "MI0040386",
    "system_name": "HIDDEN LAKE ESTATES",
    "display_name": "HIDDEN LAKE ESTATES",
    "county": "OAKLAND",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040386",
    "resolved_pwsid": "MI0040386",
    "system_name": "HIDDEN LAKE ESTATES",
    "display_name": "HIDDEN LAKE ESTATES",
    "county": "OAKLAND",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040387",
    "resolved_pwsid": "MI0040387",
    "system_name": "HIGHLAND GREENS ESTATES",
    "display_name": "HIGHLAND GREENS ESTATES",
    "county": "OAKLAND",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040387",
    "resolved_pwsid": "MI0040387",
    "system_name": "HIGHLAND GREENS ESTATES",
    "display_name": "HIGHLAND GREENS ESTATES",
    "county": "OAKLAND",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040387",
    "resolved_pwsid": "MI0040387",
    "system_name": "HIGHLAND GREENS ESTATES",
    "display_name": "HIGHLAND GREENS ESTATES",
    "county": "OAKLAND",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040388",
    "resolved_pwsid": "MI0040388",
    "system_name": "HIGHLAND HILLS OF HIGHLAND MHC",
    "display_name": "HIGHLAND HILLS OF HIGHLAND MHC",
    "county": "OAKLAND",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040388",
    "resolved_pwsid": "MI0040388",
    "system_name": "HIGHLAND HILLS OF HIGHLAND MHC",
    "display_name": "HIGHLAND HILLS OF HIGHLAND MHC",
    "county": "OAKLAND",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040388",
    "resolved_pwsid": "MI0040388",
    "system_name": "HIGHLAND HILLS OF HIGHLAND MHC",
    "display_name": "HIGHLAND HILLS OF HIGHLAND MHC",
    "county": "OAKLAND",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040391",
    "resolved_pwsid": "MI0040391",
    "system_name": "OAK HILL ESTATES MHC",
    "display_name": "OAK HILL ESTATES MHC",
    "county": "OAKLAND",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040391",
    "resolved_pwsid": "MI0040391",
    "system_name": "OAK HILL ESTATES MHC",
    "display_name": "OAK HILL ESTATES MHC",
    "county": "OAKLAND",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040391",
    "resolved_pwsid": "MI0040391",
    "system_name": "OAK HILL ESTATES MHC",
    "display_name": "OAK HILL ESTATES MHC",
    "county": "OAKLAND",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040397",
    "resolved_pwsid": "MI0040397",
    "system_name": "SPRINGROVE MHC",
    "display_name": "SPRINGROVE MHC",
    "county": "OAKLAND",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 10,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040397",
    "resolved_pwsid": "MI0040397",
    "system_name": "SPRINGROVE MHC",
    "display_name": "SPRINGROVE MHC",
    "county": "OAKLAND",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040397",
    "resolved_pwsid": "MI0040397",
    "system_name": "SPRINGROVE MHC",
    "display_name": "SPRINGROVE MHC",
    "county": "OAKLAND",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040399",
    "resolved_pwsid": "MI0040399-a",
    "system_name": "ORION LAKE ESTATES  MHC",
    "display_name": "ORION LAKE ESTATES  MHC",
    "county": "OAKLAND",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040399",
    "resolved_pwsid": "MI0040399-a",
    "system_name": "ORION LAKE ESTATES  MHC",
    "display_name": "ORION LAKE ESTATES  MHC",
    "county": "OAKLAND",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040399",
    "resolved_pwsid": "MI0040399-b",
    "system_name": "ORION LAKE ESTATES MHC",
    "display_name": "ORION LAKE ESTATES MHC",
    "county": "OAKLAND",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040399",
    "resolved_pwsid": "MI0040399-b",
    "system_name": "ORION LAKE ESTATES MHC",
    "display_name": "ORION LAKE ESTATES MHC",
    "county": "OAKLAND",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040404",
    "resolved_pwsid": "MI0040404-a",
    "system_name": "WOODLANDS ESTATES MHC",
    "display_name": "WOODLANDS ESTATES MHC",
    "county": "OAKLAND",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040404",
    "resolved_pwsid": "MI0040404-a",
    "system_name": "WOODLANDS ESTATES MHC",
    "display_name": "WOODLANDS ESTATES MHC",
    "county": "OAKLAND",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040404",
    "resolved_pwsid": "MI0040404-b",
    "system_name": "WOODLANDS MHC",
    "display_name": "WOODLANDS MHC",
    "county": "OAKLAND",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040404",
    "resolved_pwsid": "MI0040404-b",
    "system_name": "WOODLANDS MHC",
    "display_name": "WOODLANDS MHC",
    "county": "OAKLAND",
    "monitoring_end_date": "2022-06-30",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040404",
    "resolved_pwsid": "MI0040404-b",
    "system_name": "WOODLANDS MHC",
    "display_name": "WOODLANDS MHC",
    "county": "OAKLAND",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040404",
    "resolved_pwsid": "MI0040404-b",
    "system_name": "WOODLANDS MHC",
    "display_name": "WOODLANDS MHC",
    "county": "OAKLAND",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0040405",
    "resolved_pwsid": "MI0040405",
    "system_name": "GREENLAWN MOBILE HOME COURT",
    "display_name": "GREENLAWN MOBILE HOME COURT",
    "county": "OCEANA",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040405",
    "resolved_pwsid": "MI0040405",
    "system_name": "GREENLAWN MOBILE HOME COURT",
    "display_name": "GREENLAWN MOBILE HOME COURT",
    "county": "OCEANA",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040405",
    "resolved_pwsid": "MI0040405",
    "system_name": "GREENLAWN MOBILE HOME COURT",
    "display_name": "GREENLAWN MOBILE HOME COURT",
    "county": "OCEANA",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040406",
    "resolved_pwsid": "MI0040406",
    "system_name": "HYLANDER VALLEY",
    "display_name": "HYLANDER VALLEY",
    "county": "OCEANA",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040406",
    "resolved_pwsid": "MI0040406",
    "system_name": "HYLANDER VALLEY",
    "display_name": "HYLANDER VALLEY",
    "county": "OCEANA",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040406",
    "resolved_pwsid": "MI0040406",
    "system_name": "HYLANDER VALLEY",
    "display_name": "HYLANDER VALLEY",
    "county": "OCEANA",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040406",
    "resolved_pwsid": "MI0040406",
    "system_name": "HYLANDER VALLEY",
    "display_name": "HYLANDER VALLEY",
    "county": "OCEANA",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040408",
    "resolved_pwsid": "MI0040408",
    "system_name": "COUNTRY VILLAGE ESTATES MHP",
    "display_name": "COUNTRY VILLAGE ESTATES MHP",
    "county": "OGEMAW",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040408",
    "resolved_pwsid": "MI0040408",
    "system_name": "COUNTRY VILLAGE ESTATES MHP",
    "display_name": "COUNTRY VILLAGE ESTATES MHP",
    "county": "OGEMAW",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040410",
    "resolved_pwsid": "MI0040410",
    "system_name": "TWIN PINES MOBILE HOME PARK",
    "display_name": "TWIN PINES MOBILE HOME PARK",
    "county": "OGEMAW",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 10,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040410",
    "resolved_pwsid": "MI0040410",
    "system_name": "TWIN PINES MOBILE HOME PARK",
    "display_name": "TWIN PINES MOBILE HOME PARK",
    "county": "OGEMAW",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040410",
    "resolved_pwsid": "MI0040410",
    "system_name": "TWIN PINES MOBILE HOME PARK",
    "display_name": "TWIN PINES MOBILE HOME PARK",
    "county": "OGEMAW",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040414",
    "resolved_pwsid": "MI0040414",
    "system_name": "NOTTINGHAM FOREST MHP",
    "display_name": "NOTTINGHAM FOREST MHP",
    "county": "OTSEGO",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040414",
    "resolved_pwsid": "MI0040414",
    "system_name": "NOTTINGHAM FOREST MHP",
    "display_name": "NOTTINGHAM FOREST MHP",
    "county": "OTSEGO",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040414",
    "resolved_pwsid": "MI0040414",
    "system_name": "NOTTINGHAM FOREST MHP",
    "display_name": "NOTTINGHAM FOREST MHP",
    "county": "OTSEGO",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040416",
    "resolved_pwsid": "MI0040416",
    "system_name": "SUNSET ESTATES GAYLORD",
    "display_name": "SUNSET ESTATES GAYLORD",
    "county": "OTSEGO",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040416",
    "resolved_pwsid": "MI0040416",
    "system_name": "SUNSET ESTATES GAYLORD",
    "display_name": "SUNSET ESTATES GAYLORD",
    "county": "OTSEGO",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040416",
    "resolved_pwsid": "MI0040416",
    "system_name": "SUNSET ESTATES GAYLORD",
    "display_name": "SUNSET ESTATES GAYLORD",
    "county": "OTSEGO",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040417",
    "resolved_pwsid": "MI0040417",
    "system_name": "CROCKERY MOBILE HOME PARK",
    "display_name": "CROCKERY MOBILE HOME PARK",
    "county": "OTTAWA",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040417",
    "resolved_pwsid": "MI0040417",
    "system_name": "CROCKERY MOBILE HOME PARK",
    "display_name": "CROCKERY MOBILE HOME PARK",
    "county": "OTTAWA",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040417",
    "resolved_pwsid": "MI0040417",
    "system_name": "CROCKERY MOBILE HOME PARK",
    "display_name": "CROCKERY MOBILE HOME PARK",
    "county": "OTTAWA",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040418",
    "resolved_pwsid": "MI0040418",
    "system_name": "COUNTRY VILLAGE",
    "display_name": "COUNTRY VILLAGE",
    "county": "OTTAWA",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040418",
    "resolved_pwsid": "MI0040418",
    "system_name": "COUNTRY VILLAGE",
    "display_name": "COUNTRY VILLAGE",
    "county": "OTTAWA",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040418",
    "resolved_pwsid": "MI0040418",
    "system_name": "COUNTRY VILLAGE",
    "display_name": "COUNTRY VILLAGE",
    "county": "OTTAWA",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040418",
    "resolved_pwsid": "MI0040418",
    "system_name": "COUNTRY VILLAGE",
    "display_name": "COUNTRY VILLAGE",
    "county": "OTTAWA",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040419",
    "resolved_pwsid": "MI0040419",
    "system_name": "GRAND COUNTRY",
    "display_name": "GRAND COUNTRY",
    "county": "OTTAWA",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040419",
    "resolved_pwsid": "MI0040419",
    "system_name": "GRAND COUNTRY",
    "display_name": "GRAND COUNTRY",
    "county": "OTTAWA",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040419",
    "resolved_pwsid": "MI0040419",
    "system_name": "GRAND COUNTRY",
    "display_name": "GRAND COUNTRY",
    "county": "OTTAWA",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040419",
    "resolved_pwsid": "MI0040419",
    "system_name": "GRAND COUNTRY",
    "display_name": "GRAND COUNTRY",
    "county": "OTTAWA",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040425",
    "resolved_pwsid": "MI0040425",
    "system_name": "CRICKLEWOOD COURT",
    "display_name": "CRICKLEWOOD COURT",
    "county": "OTTAWA",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040425",
    "resolved_pwsid": "MI0040425",
    "system_name": "CRICKLEWOOD COURT",
    "display_name": "CRICKLEWOOD COURT",
    "county": "OTTAWA",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040425",
    "resolved_pwsid": "MI0040425",
    "system_name": "CRICKLEWOOD COURT",
    "display_name": "CRICKLEWOOD COURT",
    "county": "OTTAWA",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040426",
    "resolved_pwsid": "MI0040426",
    "system_name": "TALLMADGE MEADOWS",
    "display_name": "TALLMADGE MEADOWS",
    "county": "OTTAWA",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040426",
    "resolved_pwsid": "MI0040426",
    "system_name": "TALLMADGE MEADOWS",
    "display_name": "TALLMADGE MEADOWS",
    "county": "OTTAWA",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040426",
    "resolved_pwsid": "MI0040426",
    "system_name": "TALLMADGE MEADOWS",
    "display_name": "TALLMADGE MEADOWS",
    "county": "OTTAWA",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040431",
    "resolved_pwsid": "MI0040431",
    "system_name": "LAKEVIEW TRAILER PARK",
    "display_name": "LAKEVIEW TRAILER PARK",
    "county": "ROSCOMMON",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040431",
    "resolved_pwsid": "MI0040431",
    "system_name": "LAKEVIEW TRAILER PARK",
    "display_name": "LAKEVIEW TRAILER PARK",
    "county": "ROSCOMMON",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040431",
    "resolved_pwsid": "MI0040431",
    "system_name": "LAKEVIEW TRAILER PARK",
    "display_name": "LAKEVIEW TRAILER PARK",
    "county": "ROSCOMMON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040432",
    "resolved_pwsid": "MI0040432",
    "system_name": "NORTH SHORE TRAILER PARK",
    "display_name": "NORTH SHORE TRAILER PARK",
    "county": "ROSCOMMON",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040432",
    "resolved_pwsid": "MI0040432",
    "system_name": "NORTH SHORE TRAILER PARK",
    "display_name": "NORTH SHORE TRAILER PARK",
    "county": "ROSCOMMON",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040432",
    "resolved_pwsid": "MI0040432",
    "system_name": "NORTH SHORE TRAILER PARK",
    "display_name": "NORTH SHORE TRAILER PARK",
    "county": "ROSCOMMON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040435",
    "resolved_pwsid": "MI0040435",
    "system_name": "WHISPERING OAKS MHP",
    "display_name": "WHISPERING OAKS MHP",
    "county": "ROSCOMMON",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040435",
    "resolved_pwsid": "MI0040435",
    "system_name": "WHISPERING OAKS MHP",
    "display_name": "WHISPERING OAKS MHP",
    "county": "ROSCOMMON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040435",
    "resolved_pwsid": "MI0040435",
    "system_name": "WHISPERING OAKS MHP",
    "display_name": "WHISPERING OAKS MHP",
    "county": "ROSCOMMON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040438",
    "resolved_pwsid": "MI0040438",
    "system_name": "FREELAND MOBILE HOME PARK",
    "display_name": "FREELAND MOBILE HOME PARK",
    "county": "SAGINAW",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040438",
    "resolved_pwsid": "MI0040438",
    "system_name": "FREELAND MOBILE HOME PARK",
    "display_name": "FREELAND MOBILE HOME PARK",
    "county": "SAGINAW",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040438",
    "resolved_pwsid": "MI0040438",
    "system_name": "FREELAND MOBILE HOME PARK",
    "display_name": "FREELAND MOBILE HOME PARK",
    "county": "SAGINAW",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040441",
    "resolved_pwsid": "MI0040441-b",
    "system_name": "PARKWOOD VILLAGE",
    "display_name": "PARKWOOD VILLAGE",
    "county": "SAGINAW",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040441",
    "resolved_pwsid": "MI0040441-b",
    "system_name": "PARKWOOD VILLAGE",
    "display_name": "PARKWOOD VILLAGE",
    "county": "SAGINAW",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040441",
    "resolved_pwsid": "MI0040441-a",
    "system_name": "PARKWOOD",
    "display_name": "PARKWOOD",
    "county": "SAGINAW",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040443",
    "resolved_pwsid": "MI0040443",
    "system_name": "STODDARD MOBILE HOME COURT",
    "display_name": "STODDARD MOBILE HOME COURT",
    "county": "SAGINAW",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040443",
    "resolved_pwsid": "MI0040443",
    "system_name": "STODDARD MOBILE HOME COURT",
    "display_name": "STODDARD MOBILE HOME COURT",
    "county": "SAGINAW",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040443",
    "resolved_pwsid": "MI0040443",
    "system_name": "STODDARD MOBILE HOME COURT",
    "display_name": "STODDARD MOBILE HOME COURT",
    "county": "SAGINAW",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040446",
    "resolved_pwsid": "MI0040446",
    "system_name": "PINE TERRACE ESTATES",
    "display_name": "PINE TERRACE ESTATES",
    "county": "SANILAC",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040446",
    "resolved_pwsid": "MI0040446",
    "system_name": "PINE TERRACE ESTATES",
    "display_name": "PINE TERRACE ESTATES",
    "county": "SANILAC",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040446",
    "resolved_pwsid": "MI0040446",
    "system_name": "PINE TERRACE ESTATES",
    "display_name": "PINE TERRACE ESTATES",
    "county": "SANILAC",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040447",
    "resolved_pwsid": "MI0040447",
    "system_name": "SANDPIPER ESTATES",
    "display_name": "SANDPIPER ESTATES",
    "county": "SANILAC",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040447",
    "resolved_pwsid": "MI0040447",
    "system_name": "SANDPIPER ESTATES",
    "display_name": "SANDPIPER ESTATES",
    "county": "SANILAC",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040447",
    "resolved_pwsid": "MI0040447",
    "system_name": "SANDPIPER ESTATES",
    "display_name": "SANDPIPER ESTATES",
    "county": "SANILAC",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040448",
    "resolved_pwsid": "MI0040448",
    "system_name": "HURON BAY RESORT",
    "display_name": "HURON BAY RESORT",
    "county": "SANILAC",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 14,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040448",
    "resolved_pwsid": "MI0040448",
    "system_name": "HURON BAY RESORT",
    "display_name": "HURON BAY RESORT",
    "county": "SANILAC",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040448",
    "resolved_pwsid": "MI0040448",
    "system_name": "HURON BAY RESORT",
    "display_name": "HURON BAY RESORT",
    "county": "SANILAC",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040449",
    "resolved_pwsid": "MI0040449",
    "system_name": "SUNSET MOBILE HOME PARK",
    "display_name": "SUNSET MOBILE HOME PARK",
    "county": "SANILAC",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040449",
    "resolved_pwsid": "MI0040449",
    "system_name": "SUNSET MOBILE HOME PARK",
    "display_name": "SUNSET MOBILE HOME PARK",
    "county": "SANILAC",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040449",
    "resolved_pwsid": "MI0040449",
    "system_name": "SUNSET MOBILE HOME PARK",
    "display_name": "SUNSET MOBILE HOME PARK",
    "county": "SANILAC",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040450",
    "resolved_pwsid": "MI0040450",
    "system_name": "COUNTRYSIDE VILLAGE",
    "display_name": "COUNTRYSIDE VILLAGE",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040450",
    "resolved_pwsid": "MI0040450",
    "system_name": "COUNTRYSIDE VILLAGE",
    "display_name": "COUNTRYSIDE VILLAGE",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040450",
    "resolved_pwsid": "MI0040450",
    "system_name": "COUNTRYSIDE VILLAGE",
    "display_name": "COUNTRYSIDE VILLAGE",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040451",
    "resolved_pwsid": "MI0040451",
    "system_name": "LAKEVIEW ESTATES",
    "display_name": "LAKEVIEW ESTATES",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040451",
    "resolved_pwsid": "MI0040451",
    "system_name": "LAKEVIEW ESTATES",
    "display_name": "LAKEVIEW ESTATES",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040451",
    "resolved_pwsid": "MI0040451",
    "system_name": "LAKEVIEW ESTATES",
    "display_name": "LAKEVIEW ESTATES",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040452",
    "resolved_pwsid": "MI0040452",
    "system_name": "MOON LAKE ESTATES",
    "display_name": "MOON LAKE ESTATES",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040452",
    "resolved_pwsid": "MI0040452",
    "system_name": "MOON LAKE ESTATES",
    "display_name": "MOON LAKE ESTATES",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040452",
    "resolved_pwsid": "MI0040452",
    "system_name": "MOON LAKE ESTATES",
    "display_name": "MOON LAKE ESTATES",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040452",
    "resolved_pwsid": "MI0040452",
    "system_name": "MOON LAKE ESTATES",
    "display_name": "MOON LAKE ESTATES",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040453",
    "resolved_pwsid": "MI0040453",
    "system_name": "NORTHWOODS COMMUNITY",
    "display_name": "NORTHWOODS COMMUNITY",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040453",
    "resolved_pwsid": "MI0040453",
    "system_name": "NORTHWOODS COMMUNITY",
    "display_name": "NORTHWOODS COMMUNITY",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040453",
    "resolved_pwsid": "MI0040453",
    "system_name": "NORTHWOODS COMMUNITY",
    "display_name": "NORTHWOODS COMMUNITY",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040454",
    "resolved_pwsid": "MI0040454-b",
    "system_name": "PLEASANT VALLEY TRAILER PARK",
    "display_name": "PLEASANT VALLEY TRAILER PARK",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040454",
    "resolved_pwsid": "MI0040454-b",
    "system_name": "PLEASANT VALLEY TRAILER PARK",
    "display_name": "PLEASANT VALLEY TRAILER PARK",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040454",
    "resolved_pwsid": "MI0040454-a",
    "system_name": "EVERGREEN PLEASANT VALLEY TRAILER PARK",
    "display_name": "EVERGREEN PLEASANT VALLEY TRAILER PARK",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040455",
    "resolved_pwsid": "MI0040455",
    "system_name": "WOODS AND FIELDS COMMUNITIES WEST",
    "display_name": "WOODS AND FIELDS COMMUNITIES WEST",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040455",
    "resolved_pwsid": "MI0040455",
    "system_name": "WOODS AND FIELDS COMMUNITIES WEST",
    "display_name": "WOODS AND FIELDS COMMUNITIES WEST",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040455",
    "resolved_pwsid": "MI0040455",
    "system_name": "WOODS AND FIELDS COMMUNITIES WEST",
    "display_name": "WOODS AND FIELDS COMMUNITIES WEST",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040455",
    "resolved_pwsid": "MI0040455",
    "system_name": "WOODS AND FIELDS COMMUNITIES WEST",
    "display_name": "WOODS AND FIELDS COMMUNITIES WEST",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 135,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0040455",
    "resolved_pwsid": "MI0040455",
    "system_name": "WOODS AND FIELDS COMMUNITIES WEST",
    "display_name": "WOODS AND FIELDS COMMUNITIES WEST",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2026-06-30",
    "year": 2026,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040456",
    "resolved_pwsid": "MI0040456",
    "system_name": "QUIET COVE TRAILER PARK",
    "display_name": "QUIET COVE TRAILER PARK",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040456",
    "resolved_pwsid": "MI0040456",
    "system_name": "QUIET COVE TRAILER PARK",
    "display_name": "QUIET COVE TRAILER PARK",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040456",
    "resolved_pwsid": "MI0040456",
    "system_name": "QUIET COVE TRAILER PARK",
    "display_name": "QUIET COVE TRAILER PARK",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040457",
    "resolved_pwsid": "MI0040457",
    "system_name": "COUNTRY MANOR",
    "display_name": "COUNTRY MANOR",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040457",
    "resolved_pwsid": "MI0040457",
    "system_name": "COUNTRY MANOR",
    "display_name": "COUNTRY MANOR",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040457",
    "resolved_pwsid": "MI0040457",
    "system_name": "COUNTRY MANOR",
    "display_name": "COUNTRY MANOR",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040457",
    "resolved_pwsid": "MI0040457",
    "system_name": "COUNTRY MANOR",
    "display_name": "COUNTRY MANOR",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0040458",
    "resolved_pwsid": "MI0040458",
    "system_name": "ALAN'S PARK - DURAND",
    "display_name": "ALAN'S PARK - DURAND",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040458",
    "resolved_pwsid": "MI0040458",
    "system_name": "ALAN'S PARK - DURAND",
    "display_name": "ALAN'S PARK - DURAND",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040458",
    "resolved_pwsid": "MI0040458",
    "system_name": "ALAN'S PARK - DURAND",
    "display_name": "ALAN'S PARK - DURAND",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040464",
    "resolved_pwsid": "MI0040464",
    "system_name": "PINEWOOD ON THE LAKE MHP",
    "display_name": "PINEWOOD ON THE LAKE MHP",
    "county": "ST CLAIR",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040464",
    "resolved_pwsid": "MI0040464",
    "system_name": "PINEWOOD ON THE LAKE MHP",
    "display_name": "PINEWOOD ON THE LAKE MHP",
    "county": "ST CLAIR",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040464",
    "resolved_pwsid": "MI0040464",
    "system_name": "PINEWOOD ON THE LAKE MHP",
    "display_name": "PINEWOOD ON THE LAKE MHP",
    "county": "ST. CLAIR",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040464",
    "resolved_pwsid": "MI0040464",
    "system_name": "PINEWOOD ON THE LAKE MHP",
    "display_name": "PINEWOOD ON THE LAKE MHP",
    "county": "ST. CLAIR",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0040466",
    "resolved_pwsid": "MI0040466",
    "system_name": "SUNRISE MHP",
    "display_name": "SUNRISE MHP",
    "county": "ST CLAIR",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040466",
    "resolved_pwsid": "MI0040466",
    "system_name": "SUNRISE MHP",
    "display_name": "SUNRISE MHP",
    "county": "ST CLAIR",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040466",
    "resolved_pwsid": "MI0040466",
    "system_name": "SUNRISE MHP",
    "display_name": "SUNRISE MHP",
    "county": "ST. CLAIR",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040469",
    "resolved_pwsid": "MI0040469",
    "system_name": "HICKORY LANE MOBILE HOME PARK",
    "display_name": "HICKORY LANE MOBILE HOME PARK",
    "county": "ST JOSEPH",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040469",
    "resolved_pwsid": "MI0040469",
    "system_name": "HICKORY LANE MOBILE HOME PARK",
    "display_name": "HICKORY LANE MOBILE HOME PARK",
    "county": "ST JOSEPH",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040469",
    "resolved_pwsid": "MI0040469",
    "system_name": "HICKORY LANE MOBILE HOME PARK",
    "display_name": "HICKORY LANE MOBILE HOME PARK",
    "county": "ST. JOSEPH",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040470",
    "resolved_pwsid": "MI0040470",
    "system_name": "MEMORY LANE MOBILE HOME PARK",
    "display_name": "MEMORY LANE MOBILE HOME PARK",
    "county": "ST JOSEPH",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040470",
    "resolved_pwsid": "MI0040470",
    "system_name": "MEMORY LANE MOBILE HOME PARK",
    "display_name": "MEMORY LANE MOBILE HOME PARK",
    "county": "ST. JOSEPH",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040470",
    "resolved_pwsid": "MI0040470",
    "system_name": "MEMORY LANE MOBILE HOME PARK",
    "display_name": "MEMORY LANE MOBILE HOME PARK",
    "county": "ST. JOSEPH",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040471",
    "resolved_pwsid": "MI0040471",
    "system_name": "KLINES RESORT",
    "display_name": "KLINES RESORT",
    "county": "ST JOSEPH",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040471",
    "resolved_pwsid": "MI0040471",
    "system_name": "KLINES RESORT",
    "display_name": "KLINES RESORT",
    "county": "ST JOSEPH",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040471",
    "resolved_pwsid": "MI0040471",
    "system_name": "KLINES RESORT",
    "display_name": "KLINES RESORT",
    "county": "ST. JOSEPH",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040472",
    "resolved_pwsid": "MI0040472",
    "system_name": "MICHIANA MOBILE HOME PARK",
    "display_name": "MICHIANA MOBILE HOME PARK",
    "county": "ST JOSEPH",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040472",
    "resolved_pwsid": "MI0040472",
    "system_name": "MICHIANA MOBILE HOME PARK",
    "display_name": "MICHIANA MOBILE HOME PARK",
    "county": "ST JOSEPH",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040472",
    "resolved_pwsid": "MI0040472",
    "system_name": "MICHIANA MOBILE HOME PARK",
    "display_name": "MICHIANA MOBILE HOME PARK",
    "county": "ST. JOSEPH",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040474",
    "resolved_pwsid": "MI0040474",
    "system_name": "SWEET LAKE MOBILE HOME PARK",
    "display_name": "SWEET LAKE MOBILE HOME PARK",
    "county": "ST JOSEPH",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040474",
    "resolved_pwsid": "MI0040474",
    "system_name": "SWEET LAKE MOBILE HOME PARK",
    "display_name": "SWEET LAKE MOBILE HOME PARK",
    "county": "ST JOSEPH",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040474",
    "resolved_pwsid": "MI0040474",
    "system_name": "SWEET LAKE MOBILE HOME PARK",
    "display_name": "SWEET LAKE MOBILE HOME PARK",
    "county": "ST. JOSEPH",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040476",
    "resolved_pwsid": "MI0040476",
    "system_name": "GOLDEN POND ESTATES",
    "display_name": "GOLDEN POND ESTATES",
    "county": "ST JOSEPH",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040476",
    "resolved_pwsid": "MI0040476",
    "system_name": "GOLDEN POND ESTATES",
    "display_name": "GOLDEN POND ESTATES",
    "county": "ST JOSEPH",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040476",
    "resolved_pwsid": "MI0040476",
    "system_name": "GOLDEN POND ESTATES",
    "display_name": "GOLDEN POND ESTATES",
    "county": "ST. JOSEPH",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040477",
    "resolved_pwsid": "MI0040477",
    "system_name": "WASHBURN LAKE VILLAGE MHP",
    "display_name": "WASHBURN LAKE VILLAGE MHP",
    "county": "ST JOSEPH",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040477",
    "resolved_pwsid": "MI0040477",
    "system_name": "WASHBURN LAKE VILLAGE MHP",
    "display_name": "WASHBURN LAKE VILLAGE MHP",
    "county": "ST JOSEPH",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040477",
    "resolved_pwsid": "MI0040477",
    "system_name": "WASHBURN LAKE VILLAGE MHP",
    "display_name": "WASHBURN LAKE VILLAGE MHP",
    "county": "ST JOSEPH",
    "monitoring_end_date": "2022-09-30",
    "year": 2022,
    "lead_90th_ppb": 267,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040477",
    "resolved_pwsid": "MI0040477",
    "system_name": "WASHBURN LAKE VILLAGE MHP",
    "display_name": "WASHBURN LAKE VILLAGE MHP",
    "county": "ST. JOSEPH",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 267,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040477",
    "resolved_pwsid": "MI0040477",
    "system_name": "WASHBURN LAKE VILLAGE MHP",
    "display_name": "WASHBURN LAKE VILLAGE MHP",
    "county": "ST. JOSEPH",
    "monitoring_end_date": "2023-06-30",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040477",
    "resolved_pwsid": "MI0040477",
    "system_name": "WASHBURN LAKE VILLAGE MHP",
    "display_name": "WASHBURN LAKE VILLAGE MHP",
    "county": "ST. JOSEPH",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040479",
    "resolved_pwsid": "MI0040479",
    "system_name": "PEBBLE CREEK MOBILE HOME PARK",
    "display_name": "PEBBLE CREEK MOBILE HOME PARK",
    "county": "TUSCOLA",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040480",
    "resolved_pwsid": "MI0040480",
    "system_name": "WOOD VALLEY",
    "display_name": "WOOD VALLEY",
    "county": "TUSCOLA",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040480",
    "resolved_pwsid": "MI0040480",
    "system_name": "WOOD VALLEY",
    "display_name": "WOOD VALLEY",
    "county": "TUSCOLA",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040480",
    "resolved_pwsid": "MI0040480",
    "system_name": "WOOD VALLEY",
    "display_name": "WOOD VALLEY",
    "county": "TUSCOLA",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040481",
    "resolved_pwsid": "MI0040481",
    "system_name": "PINE CREST MOBILE HOME PARK",
    "display_name": "PINE CREST MOBILE HOME PARK",
    "county": "TUSCOLA",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040481",
    "resolved_pwsid": "MI0040481",
    "system_name": "PINE CREST MOBILE HOME PARK",
    "display_name": "PINE CREST MOBILE HOME PARK",
    "county": "TUSCOLA",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040481",
    "resolved_pwsid": "MI0040481",
    "system_name": "PINE CREST MOBILE HOME PARK",
    "display_name": "PINE CREST MOBILE HOME PARK",
    "county": "TUSCOLA",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040481",
    "resolved_pwsid": "MI0040481",
    "system_name": "PINE CREST MOBILE HOME PARK",
    "display_name": "PINE CREST MOBILE HOME PARK",
    "county": "TUSCOLA",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0040482",
    "resolved_pwsid": "MI0040482-b",
    "system_name": "RIVERVIEW PARK",
    "display_name": "RIVERVIEW PARK",
    "county": "TUSCOLA",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040482",
    "resolved_pwsid": "MI0040482-b",
    "system_name": "RIVERVIEW PARK",
    "display_name": "RIVERVIEW PARK",
    "county": "TUSCOLA",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040482",
    "resolved_pwsid": "MI0040482-a",
    "system_name": "CARO RIVERVIEW MHP LLC",
    "display_name": "CARO RIVERVIEW MHP LLC",
    "county": "TUSCOLA",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040484",
    "resolved_pwsid": "MI0040484",
    "system_name": "EVERGREEN ESTATES",
    "display_name": "EVERGREEN ESTATES",
    "county": "TUSCOLA",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040484",
    "resolved_pwsid": "MI0040484",
    "system_name": "EVERGREEN ESTATES",
    "display_name": "EVERGREEN ESTATES",
    "county": "TUSCOLA",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040484",
    "resolved_pwsid": "MI0040484",
    "system_name": "EVERGREEN ESTATES",
    "display_name": "EVERGREEN ESTATES",
    "county": "TUSCOLA",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040488",
    "resolved_pwsid": "MI0040488",
    "system_name": "COUNTRY HOLIDAY ESTATES",
    "display_name": "COUNTRY HOLIDAY ESTATES",
    "county": "VAN BUREN",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040488",
    "resolved_pwsid": "MI0040488",
    "system_name": "COUNTRY HOLIDAY ESTATES",
    "display_name": "COUNTRY HOLIDAY ESTATES",
    "county": "VAN BUREN",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040488",
    "resolved_pwsid": "MI0040488",
    "system_name": "COUNTRY HOLIDAY ESTATES",
    "display_name": "COUNTRY HOLIDAY ESTATES",
    "county": "VAN BUREN",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040490",
    "resolved_pwsid": "MI0040490",
    "system_name": "PROSPECT MANOR MHC",
    "display_name": "PROSPECT MANOR MHC",
    "county": "VAN BUREN",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040490",
    "resolved_pwsid": "MI0040490",
    "system_name": "PROSPECT MANOR MHC",
    "display_name": "PROSPECT MANOR MHC",
    "county": "VAN BUREN",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040490",
    "resolved_pwsid": "MI0040490",
    "system_name": "PROSPECT MANOR MHC",
    "display_name": "PROSPECT MANOR MHC",
    "county": "VAN BUREN",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040491",
    "resolved_pwsid": "MI0040491",
    "system_name": "PORT OF CALL - WEST",
    "display_name": "PORT OF CALL - WEST",
    "county": "VAN BUREN",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040491",
    "resolved_pwsid": "MI0040491",
    "system_name": "PORT OF CALL - WEST",
    "display_name": "PORT OF CALL - WEST",
    "county": "VAN BUREN",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040491",
    "resolved_pwsid": "MI0040491",
    "system_name": "PORT OF CALL - WEST",
    "display_name": "PORT OF CALL - WEST",
    "county": "VAN BUREN",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040491",
    "resolved_pwsid": "MI0040491",
    "system_name": "PORT OF CALL - WEST",
    "display_name": "PORT OF CALL - WEST",
    "county": "VAN BUREN",
    "monitoring_end_date": "2021-06-30",
    "year": 2021,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040491",
    "resolved_pwsid": "MI0040491",
    "system_name": "PORT OF CALL - WEST",
    "display_name": "PORT OF CALL - WEST",
    "county": "VAN BUREN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040491",
    "resolved_pwsid": "MI0040491",
    "system_name": "PORT OF CALL - WEST",
    "display_name": "PORT OF CALL - WEST",
    "county": "VAN BUREN",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040491",
    "resolved_pwsid": "MI0040491",
    "system_name": "PORT OF CALL - WEST",
    "display_name": "PORT OF CALL - WEST",
    "county": "VAN BUREN",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040491",
    "resolved_pwsid": "MI0040491",
    "system_name": "PORT OF CALL - WEST",
    "display_name": "PORT OF CALL - WEST",
    "county": "VAN BUREN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040491",
    "resolved_pwsid": "MI0040491",
    "system_name": "PORT OF CALL - WEST",
    "display_name": "PORT OF CALL - WEST",
    "county": "VAN BUREN",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040494",
    "resolved_pwsid": "MI0040494",
    "system_name": "PHELPS MOBILE HOME VILLA",
    "display_name": "PHELPS MOBILE HOME VILLA",
    "county": "VAN BUREN",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040494",
    "resolved_pwsid": "MI0040494",
    "system_name": "PHELPS MOBILE HOME VILLA",
    "display_name": "PHELPS MOBILE HOME VILLA",
    "county": "VAN BUREN",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040494",
    "resolved_pwsid": "MI0040494",
    "system_name": "PHELPS MOBILE HOME VILLA",
    "display_name": "PHELPS MOBILE HOME VILLA",
    "county": "VAN BUREN",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040494",
    "resolved_pwsid": "MI0040494",
    "system_name": "PHELPS MOBILE HOME VILLA",
    "display_name": "PHELPS MOBILE HOME VILLA",
    "county": "VAN BUREN",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040495",
    "resolved_pwsid": "MI0040495",
    "system_name": "RUSH LAKE MHP/CAMPGROUND",
    "display_name": "RUSH LAKE MHP/CAMPGROUND",
    "county": "VAN BUREN",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040495",
    "resolved_pwsid": "MI0040495",
    "system_name": "RUSH LAKE MHP/CAMPGROUND",
    "display_name": "RUSH LAKE MHP/CAMPGROUND",
    "county": "VAN BUREN",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040495",
    "resolved_pwsid": "MI0040495",
    "system_name": "RUSH LAKE MHP/CAMPGROUND",
    "display_name": "RUSH LAKE MHP/CAMPGROUND",
    "county": "VAN BUREN",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040495",
    "resolved_pwsid": "MI0040495",
    "system_name": "RUSH LAKE MHP/CAMPGROUND",
    "display_name": "RUSH LAKE MHP/CAMPGROUND",
    "county": "VAN BUREN",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040496",
    "resolved_pwsid": "MI0040496",
    "system_name": "SHADY BROOK MOBILE HOME PARK",
    "display_name": "SHADY BROOK MOBILE HOME PARK",
    "county": "VAN BUREN",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040496",
    "resolved_pwsid": "MI0040496",
    "system_name": "SHADY BROOK MOBILE HOME PARK",
    "display_name": "SHADY BROOK MOBILE HOME PARK",
    "county": "VAN BUREN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040496",
    "resolved_pwsid": "MI0040496",
    "system_name": "SHADY BROOK MOBILE HOME PARK",
    "display_name": "SHADY BROOK MOBILE HOME PARK",
    "county": "VAN BUREN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040497",
    "resolved_pwsid": "MI0040497",
    "system_name": "THREE MILE LAKE TRAILER PARK",
    "display_name": "THREE MILE LAKE TRAILER PARK",
    "county": "VAN BUREN",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040497",
    "resolved_pwsid": "MI0040497",
    "system_name": "THREE MILE LAKE TRAILER PARK",
    "display_name": "THREE MILE LAKE TRAILER PARK",
    "county": "VAN BUREN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040497",
    "resolved_pwsid": "MI0040497",
    "system_name": "THREE MILE LAKE TRAILER PARK",
    "display_name": "THREE MILE LAKE TRAILER PARK",
    "county": "VAN BUREN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040498",
    "resolved_pwsid": "MI0040498",
    "system_name": "VIKING RIVER MOBILE HOME PARK",
    "display_name": "VIKING RIVER MOBILE HOME PARK",
    "county": "VAN BUREN",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040498",
    "resolved_pwsid": "MI0040498",
    "system_name": "VIKING RIVER MOBILE HOME PARK",
    "display_name": "VIKING RIVER MOBILE HOME PARK",
    "county": "VAN BUREN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040498",
    "resolved_pwsid": "MI0040498",
    "system_name": "VIKING RIVER MOBILE HOME PARK",
    "display_name": "VIKING RIVER MOBILE HOME PARK",
    "county": "VAN BUREN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040500",
    "resolved_pwsid": "MI0040500",
    "system_name": "WHISPERING PINES ESTATES",
    "display_name": "WHISPERING PINES ESTATES",
    "county": "VAN BUREN",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040500",
    "resolved_pwsid": "MI0040500",
    "system_name": "WHISPERING PINES ESTATES",
    "display_name": "WHISPERING PINES ESTATES",
    "county": "VAN BUREN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040500",
    "resolved_pwsid": "MI0040500",
    "system_name": "WHISPERING PINES ESTATES",
    "display_name": "WHISPERING PINES ESTATES",
    "county": "VAN BUREN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040501",
    "resolved_pwsid": "MI0040501",
    "system_name": "WOLF LAKE MOBILE HOME PARK",
    "display_name": "WOLF LAKE MOBILE HOME PARK",
    "county": "VAN BUREN",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040501",
    "resolved_pwsid": "MI0040501",
    "system_name": "WOLF LAKE MOBILE HOME PARK",
    "display_name": "WOLF LAKE MOBILE HOME PARK",
    "county": "VAN BUREN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040501",
    "resolved_pwsid": "MI0040501",
    "system_name": "WOLF LAKE MOBILE HOME PARK",
    "display_name": "WOLF LAKE MOBILE HOME PARK",
    "county": "VAN BUREN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040501",
    "resolved_pwsid": "MI0040501-a",
    "system_name": "WOLF LAKE ESTATES",
    "display_name": "WOLF LAKE ESTATES",
    "county": "VAN BUREN",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040503",
    "resolved_pwsid": "MI0040503",
    "system_name": "ORCHARD GROVE",
    "display_name": "ORCHARD GROVE",
    "county": "WASHTENAW",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040503",
    "resolved_pwsid": "MI0040503",
    "system_name": "ORCHARD GROVE",
    "display_name": "ORCHARD GROVE",
    "county": "WASHTENAW",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040503",
    "resolved_pwsid": "MI0040503",
    "system_name": "ORCHARD GROVE",
    "display_name": "ORCHARD GROVE",
    "county": "WASHTENAW",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040504",
    "resolved_pwsid": "MI0040504-a",
    "system_name": "PLEASANT LAKE MOBILE HOME PARK",
    "display_name": "PLEASANT LAKE MOBILE HOME PARK",
    "county": "WASHTENAW",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040504",
    "resolved_pwsid": "MI0040504-a",
    "system_name": "PLEASANT LAKE MOBILE HOME PARK",
    "display_name": "PLEASANT LAKE MOBILE HOME PARK",
    "county": "WASHTENAW",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040504",
    "resolved_pwsid": "MI0040504-b",
    "system_name": "PLEASANT LAKE PARK LLC",
    "display_name": "PLEASANT LAKE PARK LLC",
    "county": "WASHTENAW",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040504",
    "resolved_pwsid": "MI0040504-b",
    "system_name": "PLEASANT LAKE PARK LLC",
    "display_name": "PLEASANT LAKE PARK LLC",
    "county": "WASHTENAW",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040504",
    "resolved_pwsid": "MI0040504-b",
    "system_name": "PLEASANT LAKE PARK LLC",
    "display_name": "PLEASANT LAKE PARK LLC",
    "county": "WASHTENAW",
    "monitoring_end_date": "2026-06-30",
    "year": 2026,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040515",
    "resolved_pwsid": "MI0040515",
    "system_name": "RIVERSBEND MOBILE HOME PARK",
    "display_name": "RIVERSBEND MOBILE HOME PARK",
    "county": "DICKINSON",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040515",
    "resolved_pwsid": "MI0040515",
    "system_name": "RIVERSBEND MOBILE HOME PARK",
    "display_name": "RIVERSBEND MOBILE HOME PARK",
    "county": "DICKINSON",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040515",
    "resolved_pwsid": "MI0040515",
    "system_name": "RIVERSBEND MOBILE HOME PARK",
    "display_name": "RIVERSBEND MOBILE HOME PARK",
    "county": "DICKINSON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 13,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040516",
    "resolved_pwsid": "MI0040516",
    "system_name": "WHITE BIRCH MOBILE HOME VILLAGE",
    "display_name": "WHITE BIRCH MOBILE HOME VILLAGE",
    "county": "DICKINSON",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040516",
    "resolved_pwsid": "MI0040516",
    "system_name": "WHITE BIRCH MOBILE HOME VILLAGE",
    "display_name": "WHITE BIRCH MOBILE HOME VILLAGE",
    "county": "DICKINSON",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040516",
    "resolved_pwsid": "MI0040516",
    "system_name": "WHITE BIRCH MOBILE HOME VILLAGE",
    "display_name": "WHITE BIRCH MOBILE HOME VILLAGE",
    "county": "DICKINSON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040516",
    "resolved_pwsid": "MI0040516",
    "system_name": "WHITE BIRCH MOBILE HOME VILLAGE",
    "display_name": "WHITE BIRCH MOBILE HOME VILLAGE",
    "county": "DICKINSON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040519",
    "resolved_pwsid": "MI0040519",
    "system_name": "SILVER CREEK ESTATES MOBILE HOME COURT",
    "display_name": "SILVER CREEK ESTATES MOBILE HOME COURT",
    "county": "MARQUETTE",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040519",
    "resolved_pwsid": "MI0040519",
    "system_name": "SILVER CREEK ESTATES MOBILE HOME COURT",
    "display_name": "SILVER CREEK ESTATES MOBILE HOME COURT",
    "county": "MARQUETTE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040519",
    "resolved_pwsid": "MI0040519",
    "system_name": "SILVER CREEK ESTATES MOBILE HOME COURT",
    "display_name": "SILVER CREEK ESTATES MOBILE HOME COURT",
    "county": "MARQUETTE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 15,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040520",
    "resolved_pwsid": "MI0040520-a",
    "system_name": "553 MOBILE ESTATES",
    "display_name": "553 MOBILE ESTATES",
    "county": "MARQUETTE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040520",
    "resolved_pwsid": "MI0040520-a",
    "system_name": "553 MOBILE ESTATES",
    "display_name": "553 MOBILE ESTATES",
    "county": "MARQUETTE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040520",
    "resolved_pwsid": "MI0040520-b",
    "system_name": "HWY M553 MOBILE ESTATES",
    "display_name": "HWY M553 MOBILE ESTATES",
    "county": "MARQUETTE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040525",
    "resolved_pwsid": "MI0040525",
    "system_name": "PINE ACRES MOBILE HOME PARK",
    "display_name": "PINE ACRES MOBILE HOME PARK",
    "county": "MARQUETTE",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040525",
    "resolved_pwsid": "MI0040525",
    "system_name": "PINE ACRES MOBILE HOME PARK",
    "display_name": "PINE ACRES MOBILE HOME PARK",
    "county": "MARQUETTE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040525",
    "resolved_pwsid": "MI0040525",
    "system_name": "PINE ACRES MOBILE HOME PARK",
    "display_name": "PINE ACRES MOBILE HOME PARK",
    "county": "MARQUETTE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040525",
    "resolved_pwsid": "MI0040525",
    "system_name": "PINE ACRES MOBILE HOME PARK",
    "display_name": "PINE ACRES MOBILE HOME PARK",
    "county": "MARQUETTE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0040554",
    "resolved_pwsid": "MI0040554",
    "system_name": "BEAN CREEK RESORT",
    "display_name": "BEAN CREEK RESORT",
    "county": "LENAWEE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040554",
    "resolved_pwsid": "MI0040554",
    "system_name": "BEAN CREEK RESORT",
    "display_name": "BEAN CREEK RESORT",
    "county": "LENAWEE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040554",
    "resolved_pwsid": "MI0040554",
    "system_name": "BEAN CREEK RESORT",
    "display_name": "BEAN CREEK RESORT",
    "county": "LENAWEE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040561",
    "resolved_pwsid": "MI0040561",
    "system_name": "WHITE BIRCH ESTATES",
    "display_name": "WHITE BIRCH ESTATES",
    "county": "OSCEOLA",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040561",
    "resolved_pwsid": "MI0040561",
    "system_name": "WHITE BIRCH ESTATES",
    "display_name": "WHITE BIRCH ESTATES",
    "county": "OSCEOLA",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040561",
    "resolved_pwsid": "MI0040561",
    "system_name": "WHITE BIRCH ESTATES",
    "display_name": "WHITE BIRCH ESTATES",
    "county": "OSCEOLA",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040563",
    "resolved_pwsid": "MI0040563",
    "system_name": "DUMONT CREEK ESTATES",
    "display_name": "DUMONT CREEK ESTATES",
    "county": "ALLEGAN",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040563",
    "resolved_pwsid": "MI0040563",
    "system_name": "DUMONT CREEK ESTATES",
    "display_name": "DUMONT CREEK ESTATES",
    "county": "ALLEGAN",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040563",
    "resolved_pwsid": "MI0040563",
    "system_name": "DUMONT CREEK ESTATES",
    "display_name": "DUMONT CREEK ESTATES",
    "county": "ALLEGAN",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040564",
    "resolved_pwsid": "MI0040564",
    "system_name": "WOODCREEK MOBILE ESTATES",
    "display_name": "WOODCREEK MOBILE ESTATES",
    "county": "IONIA",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040566",
    "resolved_pwsid": "MI0040566",
    "system_name": "GLENWOOD ESTATES",
    "display_name": "GLENWOOD ESTATES",
    "county": "KENT",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040566",
    "resolved_pwsid": "MI0040566",
    "system_name": "GLENWOOD ESTATES",
    "display_name": "GLENWOOD ESTATES",
    "county": "KENT",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040566",
    "resolved_pwsid": "MI0040566",
    "system_name": "GLENWOOD ESTATES",
    "display_name": "GLENWOOD ESTATES",
    "county": "KENT",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040566",
    "resolved_pwsid": "MI0040566",
    "system_name": "GLENWOOD ESTATES",
    "display_name": "GLENWOOD ESTATES",
    "county": "KENT",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040571",
    "resolved_pwsid": "MI0040571",
    "system_name": "MISTY MEADOWS MOBILE HOME PARK",
    "display_name": "MISTY MEADOWS MOBILE HOME PARK",
    "county": "HURON",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040571",
    "resolved_pwsid": "MI0040571",
    "system_name": "MISTY MEADOWS MOBILE HOME PARK",
    "display_name": "MISTY MEADOWS MOBILE HOME PARK",
    "county": "HURON",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040571",
    "resolved_pwsid": "MI0040571",
    "system_name": "MISTY MEADOWS MOBILE HOME PARK",
    "display_name": "MISTY MEADOWS MOBILE HOME PARK",
    "county": "HURON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040571",
    "resolved_pwsid": "MI0040571",
    "system_name": "MISTY MEADOWS MOBILE HOME PARK",
    "display_name": "MISTY MEADOWS MOBILE HOME PARK",
    "county": "HURON",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0040574",
    "resolved_pwsid": "MI0040574",
    "system_name": "TIMBER COUNTRY MOBILE HOME PARK",
    "display_name": "TIMBER COUNTRY MOBILE HOME PARK",
    "county": "GRATIOT",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040574",
    "resolved_pwsid": "MI0040574",
    "system_name": "TIMBER COUNTRY MOBILE HOME PARK",
    "display_name": "TIMBER COUNTRY MOBILE HOME PARK",
    "county": "GRATIOT",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040574",
    "resolved_pwsid": "MI0040574",
    "system_name": "TIMBER COUNTRY MOBILE HOME PARK",
    "display_name": "TIMBER COUNTRY MOBILE HOME PARK",
    "county": "GRATIOT",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040575",
    "resolved_pwsid": "MI0040575",
    "system_name": "SASHABAW MEADOWS MHP",
    "display_name": "SASHABAW MEADOWS MHP",
    "county": "OAKLAND",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040575",
    "resolved_pwsid": "MI0040575",
    "system_name": "SASHABAW MEADOWS MHP",
    "display_name": "SASHABAW MEADOWS MHP",
    "county": "OAKLAND",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040575",
    "resolved_pwsid": "MI0040575",
    "system_name": "SASHABAW MEADOWS MHP",
    "display_name": "SASHABAW MEADOWS MHP",
    "county": "OAKLAND",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040576",
    "resolved_pwsid": "MI0040576",
    "system_name": "WHISPERING PINES",
    "display_name": "WHISPERING PINES",
    "county": "KENT",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040576",
    "resolved_pwsid": "MI0040576",
    "system_name": "WHISPERING PINES",
    "display_name": "WHISPERING PINES",
    "county": "KENT",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040576",
    "resolved_pwsid": "MI0040576",
    "system_name": "WHISPERING PINES",
    "display_name": "WHISPERING PINES",
    "county": "KENT",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040577",
    "resolved_pwsid": "MI0040577",
    "system_name": "PINE ISLAND LAKE REC PARK",
    "display_name": "PINE ISLAND LAKE REC PARK",
    "county": "MUSKEGON",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040577",
    "resolved_pwsid": "MI0040577",
    "system_name": "PINE ISLAND LAKE REC PARK",
    "display_name": "PINE ISLAND LAKE REC PARK",
    "county": "MUSKEGON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040577",
    "resolved_pwsid": "MI0040577",
    "system_name": "PINE ISLAND LAKE REC PARK",
    "display_name": "PINE ISLAND LAKE REC PARK",
    "county": "MUSKEGON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040580",
    "resolved_pwsid": "MI0040580",
    "system_name": "KAMP VILLA RV PARK",
    "display_name": "KAMP VILLA RV PARK",
    "county": "MANISTEE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 10,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040580",
    "resolved_pwsid": "MI0040580",
    "system_name": "KAMP VILLA RV PARK",
    "display_name": "KAMP VILLA RV PARK",
    "county": "MANISTEE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040580",
    "resolved_pwsid": "MI0040580",
    "system_name": "KAMP VILLA RV PARK",
    "display_name": "KAMP VILLA RV PARK",
    "county": "MANISTEE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040585",
    "resolved_pwsid": "MI0040585",
    "system_name": "YANKEE SPRINGS MEADOWS",
    "display_name": "YANKEE SPRINGS MEADOWS",
    "county": "BARRY",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040585",
    "resolved_pwsid": "MI0040585",
    "system_name": "YANKEE SPRINGS MEADOWS",
    "display_name": "YANKEE SPRINGS MEADOWS",
    "county": "BARRY",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040585",
    "resolved_pwsid": "MI0040585",
    "system_name": "YANKEE SPRINGS MEADOWS",
    "display_name": "YANKEE SPRINGS MEADOWS",
    "county": "BARRY",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040586",
    "resolved_pwsid": "MI0040586",
    "system_name": "LINCOLN PINES",
    "display_name": "LINCOLN PINES",
    "county": "KENT",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040586",
    "resolved_pwsid": "MI0040586",
    "system_name": "LINCOLN PINES",
    "display_name": "LINCOLN PINES",
    "county": "KENT",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040586",
    "resolved_pwsid": "MI0040586",
    "system_name": "LINCOLN PINES",
    "display_name": "LINCOLN PINES",
    "county": "KENT",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040586",
    "resolved_pwsid": "MI0040586",
    "system_name": "LINCOLN PINES",
    "display_name": "LINCOLN PINES",
    "county": "KENT",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040586",
    "resolved_pwsid": "MI0040586",
    "system_name": "LINCOLN PINES",
    "display_name": "LINCOLN PINES",
    "county": "KENT",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040586",
    "resolved_pwsid": "MI0040586",
    "system_name": "LINCOLN PINES",
    "display_name": "LINCOLN PINES",
    "county": "KENT",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040586",
    "resolved_pwsid": "MI0040586",
    "system_name": "LINCOLN PINES",
    "display_name": "LINCOLN PINES",
    "county": "KENT",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0040586",
    "resolved_pwsid": "MI0040586",
    "system_name": "LINCOLN PINES",
    "display_name": "LINCOLN PINES",
    "county": "KENT",
    "monitoring_end_date": "2026-06-30",
    "year": 2026,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040587",
    "resolved_pwsid": "MI0040587-a",
    "system_name": "EVERGREEN VILLAGE MH PARK",
    "display_name": "EVERGREEN VILLAGE MH PARK",
    "county": "NEWAYGO",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040587",
    "resolved_pwsid": "MI0040587-a",
    "system_name": "EVERGREEN VILLAGE MH PARK",
    "display_name": "EVERGREEN VILLAGE MH PARK",
    "county": "NEWAYGO",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040587",
    "resolved_pwsid": "MI0040587-b",
    "system_name": "HESPERIA MHP LLC",
    "display_name": "HESPERIA MHP LLC",
    "county": "NEWAYGO",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040591",
    "resolved_pwsid": "MI0040591",
    "system_name": "COUNTRY HILL PINES",
    "display_name": "COUNTRY HILL PINES",
    "county": "SANILAC",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040591",
    "resolved_pwsid": "MI0040591",
    "system_name": "COUNTRY HILL PINES",
    "display_name": "COUNTRY HILL PINES",
    "county": "SANILAC",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040591",
    "resolved_pwsid": "MI0040591",
    "system_name": "COUNTRY HILL PINES",
    "display_name": "COUNTRY HILL PINES",
    "county": "SANILAC",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040591",
    "resolved_pwsid": "MI0040591",
    "system_name": "COUNTRY HILL PINES",
    "display_name": "COUNTRY HILL PINES",
    "county": "SANILAC",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0040592",
    "resolved_pwsid": "MI0040592",
    "system_name": "SANDHILL ESTATES",
    "display_name": "SANDHILL ESTATES",
    "county": "LAPEER",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040592",
    "resolved_pwsid": "MI0040592",
    "system_name": "SANDHILL ESTATES",
    "display_name": "SANDHILL ESTATES",
    "county": "LAPEER",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040592",
    "resolved_pwsid": "MI0040592",
    "system_name": "SANDHILL ESTATES",
    "display_name": "SANDHILL ESTATES",
    "county": "LAPEER",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040592",
    "resolved_pwsid": "MI0040592",
    "system_name": "SANDHILL ESTATES",
    "display_name": "SANDHILL ESTATES",
    "county": "LAPEER",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0040594",
    "resolved_pwsid": "MI0040594",
    "system_name": "NORTHFIELD ESTATES",
    "display_name": "NORTHFIELD ESTATES",
    "county": "WASHTENAW",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040594",
    "resolved_pwsid": "MI0040594",
    "system_name": "NORTHFIELD ESTATES",
    "display_name": "NORTHFIELD ESTATES",
    "county": "WASHTENAW",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040594",
    "resolved_pwsid": "MI0040594",
    "system_name": "NORTHFIELD ESTATES",
    "display_name": "NORTHFIELD ESTATES",
    "county": "WASHTENAW",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040594",
    "resolved_pwsid": "MI0040594",
    "system_name": "NORTHFIELD ESTATES",
    "display_name": "NORTHFIELD ESTATES",
    "county": "WASHTENAW",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040598",
    "resolved_pwsid": "MI0040598-b",
    "system_name": "SIMMONS MOBILE HOME PARK",
    "display_name": "SIMMONS MOBILE HOME PARK",
    "county": "CASS",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040598",
    "resolved_pwsid": "MI0040598-b",
    "system_name": "SIMMONS MOBILE HOME PARK",
    "display_name": "SIMMONS MOBILE HOME PARK",
    "county": "CASS",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040598",
    "resolved_pwsid": "MI0040598-a",
    "system_name": "COUNTRY VIEW MOBILE HOME COMMUNITY",
    "display_name": "COUNTRY VIEW MOBILE HOME COMMUNITY",
    "county": "CASS",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040599",
    "resolved_pwsid": "MI0040599",
    "system_name": "CADGEWITH FARMS",
    "display_name": "CADGEWITH FARMS",
    "county": "CLINTON",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040599",
    "resolved_pwsid": "MI0040599",
    "system_name": "CADGEWITH FARMS",
    "display_name": "CADGEWITH FARMS",
    "county": "CLINTON",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040599",
    "resolved_pwsid": "MI0040599",
    "system_name": "CADGEWITH FARMS",
    "display_name": "CADGEWITH FARMS",
    "county": "CLINTON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040600",
    "resolved_pwsid": "MI0040600",
    "system_name": "EGELCRAFT MOBILE HOME PARK",
    "display_name": "EGELCRAFT MOBILE HOME PARK",
    "county": "MUSKEGON",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040600",
    "resolved_pwsid": "MI0040600",
    "system_name": "EGELCRAFT MOBILE HOME PARK",
    "display_name": "EGELCRAFT MOBILE HOME PARK",
    "county": "MUSKEGON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040600",
    "resolved_pwsid": "MI0040600",
    "system_name": "EGELCRAFT MOBILE HOME PARK",
    "display_name": "EGELCRAFT MOBILE HOME PARK",
    "county": "MUSKEGON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040601",
    "resolved_pwsid": "MI0040601",
    "system_name": "PINE RIDGE MOBILE HOME COMMUNITY",
    "display_name": "PINE RIDGE MOBILE HOME COMMUNITY",
    "county": "GENESEE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040601",
    "resolved_pwsid": "MI0040601",
    "system_name": "PINE RIDGE MOBILE HOME COMMUNITY",
    "display_name": "PINE RIDGE MOBILE HOME COMMUNITY",
    "county": "GENESEE",
    "monitoring_end_date": "2019-06-30",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040601",
    "resolved_pwsid": "MI0040601",
    "system_name": "PINE RIDGE MOBILE HOME COMMUNITY",
    "display_name": "PINE RIDGE MOBILE HOME COMMUNITY",
    "county": "GENESEE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040601",
    "resolved_pwsid": "MI0040601",
    "system_name": "PINE RIDGE MOBILE HOME COMMUNITY",
    "display_name": "PINE RIDGE MOBILE HOME COMMUNITY",
    "county": "GENESEE",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040601",
    "resolved_pwsid": "MI0040601",
    "system_name": "PINE RIDGE MOBILE HOME COMMUNITY",
    "display_name": "PINE RIDGE MOBILE HOME COMMUNITY",
    "county": "GENESEE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040601",
    "resolved_pwsid": "MI0040601",
    "system_name": "PINE RIDGE MOBILE HOME COMMUNITY",
    "display_name": "PINE RIDGE MOBILE HOME COMMUNITY",
    "county": "GENESEE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040603",
    "resolved_pwsid": "MI0040603",
    "system_name": "PINE RIDGE COMMUNITY, INC.",
    "display_name": "PINE RIDGE COMMUNITY, INC.",
    "county": "ALLEGAN",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040603",
    "resolved_pwsid": "MI0040603",
    "system_name": "PINE RIDGE COMMUNITY, INC.",
    "display_name": "PINE RIDGE COMMUNITY, INC.",
    "county": "ALLEGAN",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040603",
    "resolved_pwsid": "MI0040603",
    "system_name": "PINE RIDGE COMMUNITY, INC.",
    "display_name": "PINE RIDGE COMMUNITY, INC.",
    "county": "ALLEGAN",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040606",
    "resolved_pwsid": "MI0040606",
    "system_name": "MITCHELL BROTHERS MOBILE HOME PARK",
    "display_name": "MITCHELL BROTHERS MOBILE HOME PARK",
    "county": "VAN BUREN",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040606",
    "resolved_pwsid": "MI0040606",
    "system_name": "MITCHELL BROTHERS MOBILE HOME PARK",
    "display_name": "MITCHELL BROTHERS MOBILE HOME PARK",
    "county": "VAN BUREN",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040606",
    "resolved_pwsid": "MI0040606",
    "system_name": "MITCHELL BROTHERS MOBILE HOME PARK",
    "display_name": "MITCHELL BROTHERS MOBILE HOME PARK",
    "county": "VAN BUREN",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040606",
    "resolved_pwsid": "MI0040606",
    "system_name": "MITCHELL BROTHERS MOBILE HOME PARK",
    "display_name": "MITCHELL BROTHERS MOBILE HOME PARK",
    "county": "VAN BUREN",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040606",
    "resolved_pwsid": "MI0040606",
    "system_name": "MITCHELL BROTHERS MOBILE HOME PARK",
    "display_name": "MITCHELL BROTHERS MOBILE HOME PARK",
    "county": "VAN BUREN",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0040607",
    "resolved_pwsid": "MI0040607",
    "system_name": "EAST BAY MOBILE HOME PARK",
    "display_name": "EAST BAY MOBILE HOME PARK",
    "county": "GENESEE",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040607",
    "resolved_pwsid": "MI0040607",
    "system_name": "EAST BAY MOBILE HOME PARK",
    "display_name": "EAST BAY MOBILE HOME PARK",
    "county": "GENESEE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040607",
    "resolved_pwsid": "MI0040607",
    "system_name": "EAST BAY MOBILE HOME PARK",
    "display_name": "EAST BAY MOBILE HOME PARK",
    "county": "GENESEE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040607",
    "resolved_pwsid": "MI0040607",
    "system_name": "EAST BAY MOBILE HOME PARK",
    "display_name": "EAST BAY MOBILE HOME PARK",
    "county": "GENESEE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040609",
    "resolved_pwsid": "MI0040609-a",
    "system_name": "PINE HAVEN ESTATES",
    "display_name": "PINE HAVEN ESTATES",
    "county": "IONIA",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040609",
    "resolved_pwsid": "MI0040609-a",
    "system_name": "PINE HAVEN ESTATES",
    "display_name": "PINE HAVEN ESTATES",
    "county": "IONIA",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040609",
    "resolved_pwsid": "MI0040609-a",
    "system_name": "PINE HAVEN ESTATES",
    "display_name": "PINE HAVEN ESTATES",
    "county": "IONIA",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040609",
    "resolved_pwsid": "MI0040609-b",
    "system_name": "PINE HAVEN ESTATES MHC",
    "display_name": "PINE HAVEN ESTATES MHC",
    "county": "IONIA",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040612",
    "resolved_pwsid": "MI0040612",
    "system_name": "MEADOW LAKE ESTATES MHC",
    "display_name": "MEADOW LAKE ESTATES MHC",
    "county": "OAKLAND",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040612",
    "resolved_pwsid": "MI0040612",
    "system_name": "MEADOW LAKE ESTATES MHC",
    "display_name": "MEADOW LAKE ESTATES MHC",
    "county": "OAKLAND",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 12,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040612",
    "resolved_pwsid": "MI0040612",
    "system_name": "MEADOW LAKE ESTATES MHC",
    "display_name": "MEADOW LAKE ESTATES MHC",
    "county": "OAKLAND",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040612",
    "resolved_pwsid": "MI0040612",
    "system_name": "MEADOW LAKE ESTATES MHC",
    "display_name": "MEADOW LAKE ESTATES MHC",
    "county": "OAKLAND",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0040614",
    "resolved_pwsid": "MI0040614",
    "system_name": "WEST OLIVE ESTATES",
    "display_name": "WEST OLIVE ESTATES",
    "county": "OTTAWA",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040614",
    "resolved_pwsid": "MI0040614",
    "system_name": "WEST OLIVE ESTATES",
    "display_name": "WEST OLIVE ESTATES",
    "county": "OTTAWA",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040614",
    "resolved_pwsid": "MI0040614",
    "system_name": "WEST OLIVE ESTATES",
    "display_name": "WEST OLIVE ESTATES",
    "county": "OTTAWA",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040615",
    "resolved_pwsid": "MI0040615-a",
    "system_name": "BUEL HILL MOBILE HOME PARK",
    "display_name": "BUEL HILL MOBILE HOME PARK",
    "county": "SANILAC",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040615",
    "resolved_pwsid": "MI0040615-a",
    "system_name": "BUEL HILL MOBILE HOME PARK",
    "display_name": "BUEL HILL MOBILE HOME PARK",
    "county": "SANILAC",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040615",
    "resolved_pwsid": "MI0040615-b",
    "system_name": "EAGLES LANDING ESTATES",
    "display_name": "EAGLES LANDING ESTATES",
    "county": "SANILAC",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040615",
    "resolved_pwsid": "MI0040615-b",
    "system_name": "EAGLES LANDING ESTATES",
    "display_name": "EAGLES LANDING ESTATES",
    "county": "SANILAC",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040615",
    "resolved_pwsid": "MI0040615-c",
    "system_name": "BUEL HILL ESTATES (DBA EAGLES LANDING)",
    "display_name": "EAGLES LANDING ESTATES",
    "county": "SANILAC",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 9,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0040616",
    "resolved_pwsid": "MI0040616-b",
    "system_name": "NORTH BAY HARBOR CLUB MHP",
    "display_name": "NORTH BAY HARBOR CLUB MHP",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040616",
    "resolved_pwsid": "MI0040616-b",
    "system_name": "NORTH BAY HARBOR CLUB MHP",
    "display_name": "NORTH BAY HARBOR CLUB MHP",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040616",
    "resolved_pwsid": "MI0040616-a",
    "system_name": "NORTH BAY HARBOR CLUB",
    "display_name": "NORTH BAY HARBOR CLUB",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040616",
    "resolved_pwsid": "MI0040616-b",
    "system_name": "NORTH BAY HARBOR CLUB MHP",
    "display_name": "NORTH BAY HARBOR CLUB MHP",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040616",
    "resolved_pwsid": "MI0040616-a",
    "system_name": "NORTH BAY HARBOR CLUB",
    "display_name": "NORTH BAY HARBOR CLUB",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040617",
    "resolved_pwsid": "MI0040617",
    "system_name": "CANTERBURY ESTATES MHP",
    "display_name": "CANTERBURY ESTATES MHP",
    "county": "IONIA",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040617",
    "resolved_pwsid": "MI0040617",
    "system_name": "CANTERBURY ESTATES MHP",
    "display_name": "CANTERBURY ESTATES MHP",
    "county": "IONIA",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040617",
    "resolved_pwsid": "MI0040617",
    "system_name": "CANTERBURY ESTATES MHP",
    "display_name": "CANTERBURY ESTATES MHP",
    "county": "IONIA",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040619",
    "resolved_pwsid": "MI0040619",
    "system_name": "CEDARFIELD MOBILE HOME PARK",
    "display_name": "CEDARFIELD MOBILE HOME PARK",
    "county": "KENT",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040619",
    "resolved_pwsid": "MI0040619",
    "system_name": "CEDARFIELD MOBILE HOME PARK",
    "display_name": "CEDARFIELD MOBILE HOME PARK",
    "county": "KENT",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040619",
    "resolved_pwsid": "MI0040619",
    "system_name": "CEDARFIELD MOBILE HOME PARK",
    "display_name": "CEDARFIELD MOBILE HOME PARK",
    "county": "KENT",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040620",
    "resolved_pwsid": "MI0040620",
    "system_name": "HARTWICK PINES ESTATES",
    "display_name": "HARTWICK PINES ESTATES",
    "county": "CRAWFORD",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040620",
    "resolved_pwsid": "MI0040620",
    "system_name": "HARTWICK PINES ESTATES",
    "display_name": "HARTWICK PINES ESTATES",
    "county": "CRAWFORD",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040620",
    "resolved_pwsid": "MI0040620",
    "system_name": "HARTWICK PINES ESTATES",
    "display_name": "HARTWICK PINES ESTATES",
    "county": "CRAWFORD",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040620",
    "resolved_pwsid": "MI0040620",
    "system_name": "HARTWICK PINES ESTATES",
    "display_name": "HARTWICK PINES ESTATES",
    "county": "CRAWFORD",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0040637",
    "resolved_pwsid": "MI0040637",
    "system_name": "NESEN'S COUNTRYSIDE ACRES",
    "display_name": "NESEN'S COUNTRYSIDE ACRES",
    "county": "GRATIOT",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040637",
    "resolved_pwsid": "MI0040637",
    "system_name": "NESEN'S COUNTRYSIDE ACRES",
    "display_name": "NESEN'S COUNTRYSIDE ACRES",
    "county": "GRATIOT",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040637",
    "resolved_pwsid": "MI0040637",
    "system_name": "NESEN'S COUNTRYSIDE ACRES",
    "display_name": "NESEN'S COUNTRYSIDE ACRES",
    "county": "GRATIOT",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040639",
    "resolved_pwsid": "MI0040639",
    "system_name": "WOODS AND FIELDS COMMUNITIES EAST",
    "display_name": "WOODS AND FIELDS COMMUNITIES EAST",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040639",
    "resolved_pwsid": "MI0040639",
    "system_name": "WOODS AND FIELDS COMMUNITIES EAST",
    "display_name": "WOODS AND FIELDS COMMUNITIES EAST",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040639",
    "resolved_pwsid": "MI0040639",
    "system_name": "WOODS AND FIELDS COMMUNITIES EAST",
    "display_name": "WOODS AND FIELDS COMMUNITIES EAST",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040639",
    "resolved_pwsid": "MI0040639",
    "system_name": "WOODS AND FIELDS COMMUNITIES EAST",
    "display_name": "WOODS AND FIELDS COMMUNITIES EAST",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0040640",
    "resolved_pwsid": "MI0040640",
    "system_name": "THE PINES",
    "display_name": "THE PINES",
    "county": "MONTCALM",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040640",
    "resolved_pwsid": "MI0040640",
    "system_name": "THE PINES",
    "display_name": "THE PINES",
    "county": "MONTCALM",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040640",
    "resolved_pwsid": "MI0040640",
    "system_name": "THE PINES",
    "display_name": "THE PINES",
    "county": "MONTCALM",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040643",
    "resolved_pwsid": "MI0040643",
    "system_name": "MORRICE MEADOWS",
    "display_name": "MORRICE MEADOWS",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040643",
    "resolved_pwsid": "MI0040643",
    "system_name": "MORRICE MEADOWS",
    "display_name": "MORRICE MEADOWS",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040643",
    "resolved_pwsid": "MI0040643",
    "system_name": "MORRICE MEADOWS",
    "display_name": "MORRICE MEADOWS",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040643",
    "resolved_pwsid": "MI0040643",
    "system_name": "MORRICE MEADOWS",
    "display_name": "MORRICE MEADOWS",
    "county": "SHIAWASSEE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0040644",
    "resolved_pwsid": "MI0040644",
    "system_name": "DEERFIELD PINES MOBILE HOME PARK",
    "display_name": "DEERFIELD PINES MOBILE HOME PARK",
    "county": "LAPEER",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040644",
    "resolved_pwsid": "MI0040644",
    "system_name": "DEERFIELD PINES MOBILE HOME PARK",
    "display_name": "DEERFIELD PINES MOBILE HOME PARK",
    "county": "LAPEER",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040644",
    "resolved_pwsid": "MI0040644",
    "system_name": "DEERFIELD PINES MOBILE HOME PARK",
    "display_name": "DEERFIELD PINES MOBILE HOME PARK",
    "county": "LAPEER",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040644",
    "resolved_pwsid": "MI0040644",
    "system_name": "DEERFIELD PINES MOBILE HOME PARK",
    "display_name": "DEERFIELD PINES MOBILE HOME PARK",
    "county": "LAPEER",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0040647",
    "resolved_pwsid": "MI0040647",
    "system_name": "ORCHARD COVE",
    "display_name": "ORCHARD COVE",
    "county": "GENESEE",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040647",
    "resolved_pwsid": "MI0040647",
    "system_name": "ORCHARD COVE",
    "display_name": "ORCHARD COVE",
    "county": "GENESEE",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040647",
    "resolved_pwsid": "MI0040647",
    "system_name": "ORCHARD COVE",
    "display_name": "ORCHARD COVE",
    "county": "GENESEE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040647",
    "resolved_pwsid": "MI0040647",
    "system_name": "ORCHARD COVE",
    "display_name": "ORCHARD COVE",
    "county": "GENESEE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0040649",
    "resolved_pwsid": "MI0040649",
    "system_name": "COVENTRY WOODS MHC",
    "display_name": "COVENTRY WOODS MHC",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040649",
    "resolved_pwsid": "MI0040649",
    "system_name": "COVENTRY WOODS MHC",
    "display_name": "COVENTRY WOODS MHC",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2019-09-30",
    "year": 2019,
    "lead_90th_ppb": 39,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040649",
    "resolved_pwsid": "MI0040649",
    "system_name": "COVENTRY WOODS MHC",
    "display_name": "COVENTRY WOODS MHC",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 39,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040649",
    "resolved_pwsid": "MI0040649",
    "system_name": "COVENTRY WOODS MHC",
    "display_name": "COVENTRY WOODS MHC",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040649",
    "resolved_pwsid": "MI0040649",
    "system_name": "COVENTRY WOODS MHC",
    "display_name": "COVENTRY WOODS MHC",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040649",
    "resolved_pwsid": "MI0040649",
    "system_name": "COVENTRY WOODS MHC",
    "display_name": "COVENTRY WOODS MHC",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040649",
    "resolved_pwsid": "MI0040649",
    "system_name": "COVENTRY WOODS MHC",
    "display_name": "COVENTRY WOODS MHC",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040649",
    "resolved_pwsid": "MI0040649",
    "system_name": "COVENTRY WOODS MHC",
    "display_name": "COVENTRY WOODS MHC",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040649",
    "resolved_pwsid": "MI0040649",
    "system_name": "COVENTRY WOODS MHC",
    "display_name": "COVENTRY WOODS MHC",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040649",
    "resolved_pwsid": "MI0040649",
    "system_name": "COVENTRY WOODS MHC",
    "display_name": "COVENTRY WOODS MHC",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0040649",
    "resolved_pwsid": "MI0040649",
    "system_name": "COVENTRY WOODS MHC",
    "display_name": "COVENTRY WOODS MHC",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2026-06-30",
    "year": 2026,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040650",
    "resolved_pwsid": "MI0040650",
    "system_name": "WEST PINE ISLAND",
    "display_name": "WEST PINE ISLAND",
    "county": "MUSKEGON",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040650",
    "resolved_pwsid": "MI0040650",
    "system_name": "WEST PINE ISLAND",
    "display_name": "WEST PINE ISLAND",
    "county": "MUSKEGON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040650",
    "resolved_pwsid": "MI0040650",
    "system_name": "WEST PINE ISLAND",
    "display_name": "WEST PINE ISLAND",
    "county": "MUSKEGON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040653",
    "resolved_pwsid": "MI0040653",
    "system_name": "SUNSET SHORES",
    "display_name": "SUNSET SHORES",
    "county": "MECOSTA",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040653",
    "resolved_pwsid": "MI0040653",
    "system_name": "SUNSET SHORES",
    "display_name": "SUNSET SHORES",
    "county": "MECOSTA",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040653",
    "resolved_pwsid": "MI0040653",
    "system_name": "SUNSET SHORES",
    "display_name": "SUNSET SHORES",
    "county": "MECOSTA",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040654",
    "resolved_pwsid": "MI0040654",
    "system_name": "HARTLAND MEADOWS",
    "display_name": "HARTLAND MEADOWS",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040654",
    "resolved_pwsid": "MI0040654",
    "system_name": "HARTLAND MEADOWS",
    "display_name": "HARTLAND MEADOWS",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040654",
    "resolved_pwsid": "MI0040654",
    "system_name": "HARTLAND MEADOWS",
    "display_name": "HARTLAND MEADOWS",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040654",
    "resolved_pwsid": "MI0040654",
    "system_name": "HARTLAND MEADOWS",
    "display_name": "HARTLAND MEADOWS",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040654",
    "resolved_pwsid": "MI0040654",
    "system_name": "HARTLAND MEADOWS",
    "display_name": "HARTLAND MEADOWS",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0040655",
    "resolved_pwsid": "MI0040655-a",
    "system_name": "CREEK VALLEY NORTH",
    "display_name": "CREEK VALLEY NORTH",
    "county": "CALHOUN",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040655",
    "resolved_pwsid": "MI0040655-a",
    "system_name": "CREEK VALLEY NORTH",
    "display_name": "CREEK VALLEY NORTH",
    "county": "CALHOUN",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040655",
    "resolved_pwsid": "MI0040655-a",
    "system_name": "CREEK VALLEY NORTH",
    "display_name": "CREEK VALLEY NORTH",
    "county": "CALHOUN",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040655",
    "resolved_pwsid": "MI0040655-b",
    "system_name": "NP CREEK VALLEY NORTH",
    "display_name": "NP CREEK VALLEY NORTH",
    "county": "CALHOUN",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040655",
    "resolved_pwsid": "MI0040655-b",
    "system_name": "NP CREEK VALLEY NORTH",
    "display_name": "NP CREEK VALLEY NORTH",
    "county": "CALHOUN",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0040656",
    "resolved_pwsid": "MI0040656",
    "system_name": "COUNTRY MANOR",
    "display_name": "COUNTRY MANOR",
    "county": "MECOSTA",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040656",
    "resolved_pwsid": "MI0040656",
    "system_name": "COUNTRY MANOR",
    "display_name": "COUNTRY MANOR",
    "county": "MECOSTA",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040656",
    "resolved_pwsid": "MI0040656",
    "system_name": "COUNTRY MANOR",
    "display_name": "COUNTRY MANOR",
    "county": "MECOSTA",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040656",
    "resolved_pwsid": "MI0040656",
    "system_name": "COUNTRY MANOR",
    "display_name": "COUNTRY MANOR",
    "county": "MECOSTA",
    "monitoring_end_date": "2024-09-30",
    "year": 2024,
    "lead_90th_ppb": 19,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040656",
    "resolved_pwsid": "MI0040656",
    "system_name": "COUNTRY MANOR",
    "display_name": "COUNTRY MANOR",
    "county": "MECOSTA",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 19,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040656",
    "resolved_pwsid": "MI0040656",
    "system_name": "COUNTRY MANOR",
    "display_name": "COUNTRY MANOR",
    "county": "MECOSTA",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0040657",
    "resolved_pwsid": "MI0040657",
    "system_name": "NORTHVILLE CROSSING",
    "display_name": "NORTHVILLE CROSSING",
    "county": "WASHTENAW",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040657",
    "resolved_pwsid": "MI0040657",
    "system_name": "NORTHVILLE CROSSING",
    "display_name": "NORTHVILLE CROSSING",
    "county": "WASHTENAW",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040657",
    "resolved_pwsid": "MI0040657",
    "system_name": "NORTHVILLE CROSSING",
    "display_name": "NORTHVILLE CROSSING",
    "county": "WASHTENAW",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040658",
    "resolved_pwsid": "MI0040658",
    "system_name": "TYRONE WOODS",
    "display_name": "TYRONE WOODS",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040658",
    "resolved_pwsid": "MI0040658",
    "system_name": "TYRONE WOODS",
    "display_name": "TYRONE WOODS",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 13,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040658",
    "resolved_pwsid": "MI0040658",
    "system_name": "TYRONE WOODS",
    "display_name": "TYRONE WOODS",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040658",
    "resolved_pwsid": "MI0040658",
    "system_name": "TYRONE WOODS",
    "display_name": "TYRONE WOODS",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040660",
    "resolved_pwsid": "MI0040660",
    "system_name": "HUNTERS GLEN",
    "display_name": "HUNTERS GLEN",
    "county": "ALLEGAN",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040660",
    "resolved_pwsid": "MI0040660",
    "system_name": "HUNTERS GLEN",
    "display_name": "HUNTERS GLEN",
    "county": "ALLEGAN",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040660",
    "resolved_pwsid": "MI0040660",
    "system_name": "HUNTERS GLEN",
    "display_name": "HUNTERS GLEN",
    "county": "ALLEGAN",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040660",
    "resolved_pwsid": "MI0040660",
    "system_name": "HUNTERS GLEN",
    "display_name": "HUNTERS GLEN",
    "county": "ALLEGAN",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0040662",
    "resolved_pwsid": "MI0040662",
    "system_name": "SUNSET RIDGE MHC",
    "display_name": "SUNSET RIDGE MHC",
    "county": "IONIA",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040662",
    "resolved_pwsid": "MI0040662",
    "system_name": "SUNSET RIDGE MHC",
    "display_name": "SUNSET RIDGE MHC",
    "county": "IONIA",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040662",
    "resolved_pwsid": "MI0040662",
    "system_name": "SUNSET RIDGE MHC",
    "display_name": "SUNSET RIDGE MHC",
    "county": "IONIA",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040662",
    "resolved_pwsid": "MI0040662",
    "system_name": "SUNSET RIDGE MHC",
    "display_name": "SUNSET RIDGE MHC",
    "county": "IONIA",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040663",
    "resolved_pwsid": "MI0040663",
    "system_name": "RIVER RIDGE - SALINE",
    "display_name": "RIVER RIDGE - SALINE",
    "county": "WASHTENAW",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040663",
    "resolved_pwsid": "MI0040663",
    "system_name": "RIVER RIDGE - SALINE",
    "display_name": "RIVER RIDGE - SALINE",
    "county": "WASHTENAW",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040663",
    "resolved_pwsid": "MI0040663",
    "system_name": "RIVER RIDGE - SALINE",
    "display_name": "RIVER RIDGE - SALINE",
    "county": "WASHTENAW",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040664",
    "resolved_pwsid": "MI0040664",
    "system_name": "APPLE GROVE ESTATES",
    "display_name": "APPLE GROVE ESTATES",
    "county": "KENT",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040664",
    "resolved_pwsid": "MI0040664",
    "system_name": "APPLE GROVE ESTATES",
    "display_name": "APPLE GROVE ESTATES",
    "county": "KENT",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040664",
    "resolved_pwsid": "MI0040664",
    "system_name": "APPLE GROVE ESTATES",
    "display_name": "APPLE GROVE ESTATES",
    "county": "KENT",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040665",
    "resolved_pwsid": "MI0040665",
    "system_name": "HOLLY HILLS MHC",
    "display_name": "HOLLY HILLS MHC",
    "county": "OAKLAND",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040665",
    "resolved_pwsid": "MI0040665",
    "system_name": "HOLLY HILLS MHC",
    "display_name": "HOLLY HILLS MHC",
    "county": "OAKLAND",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040665",
    "resolved_pwsid": "MI0040665",
    "system_name": "HOLLY HILLS MHC",
    "display_name": "HOLLY HILLS MHC",
    "county": "OAKLAND",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 9,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040665",
    "resolved_pwsid": "MI0040665",
    "system_name": "HOLLY HILLS MHC",
    "display_name": "HOLLY HILLS MHC",
    "county": "OAKLAND",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 7,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0040668",
    "resolved_pwsid": "MI0040668",
    "system_name": "APPLEWOOD",
    "display_name": "APPLEWOOD",
    "county": "VAN BUREN",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040668",
    "resolved_pwsid": "MI0040668",
    "system_name": "APPLEWOOD",
    "display_name": "APPLEWOOD",
    "county": "VAN BUREN",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040668",
    "resolved_pwsid": "MI0040668",
    "system_name": "APPLEWOOD",
    "display_name": "APPLEWOOD",
    "county": "VAN BUREN",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040669",
    "resolved_pwsid": "MI0040669",
    "system_name": "WOODLAND RIDGE",
    "display_name": "WOODLAND RIDGE",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040669",
    "resolved_pwsid": "MI0040669",
    "system_name": "WOODLAND RIDGE",
    "display_name": "WOODLAND RIDGE",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040669",
    "resolved_pwsid": "MI0040669",
    "system_name": "WOODLAND RIDGE",
    "display_name": "WOODLAND RIDGE",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040669",
    "resolved_pwsid": "MI0040669",
    "system_name": "WOODLAND RIDGE",
    "display_name": "WOODLAND RIDGE",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040670",
    "resolved_pwsid": "MI0040670",
    "system_name": "PINE LAKES MANUFACTURED HOMES",
    "display_name": "PINE LAKES MANUFACTURED HOMES",
    "county": "LAPEER",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040670",
    "resolved_pwsid": "MI0040670",
    "system_name": "PINE LAKES MANUFACTURED HOMES",
    "display_name": "PINE LAKES MANUFACTURED HOMES",
    "county": "LAPEER",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040670",
    "resolved_pwsid": "MI0040670",
    "system_name": "PINE LAKES MANUFACTURED HOMES",
    "display_name": "PINE LAKES MANUFACTURED HOMES",
    "county": "LAPEER",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 9,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040670",
    "resolved_pwsid": "MI0040670",
    "system_name": "PINE LAKES MANUFACTURED HOMES",
    "display_name": "PINE LAKES MANUFACTURED HOMES",
    "county": "LAPEER",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 10,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0040671",
    "resolved_pwsid": "MI0040671",
    "system_name": "RIDGEWOOD MOBILE HOME PARK INC",
    "display_name": "RIDGEWOOD MOBILE HOME PARK INC",
    "county": "OAKLAND",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040671",
    "resolved_pwsid": "MI0040671",
    "system_name": "RIDGEWOOD MOBILE HOME PARK INC",
    "display_name": "RIDGEWOOD MOBILE HOME PARK INC",
    "county": "OAKLAND",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040671",
    "resolved_pwsid": "MI0040671",
    "system_name": "RIDGEWOOD MOBILE HOME PARK INC",
    "display_name": "RIDGEWOOD MOBILE HOME PARK INC",
    "county": "OAKLAND",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040671",
    "resolved_pwsid": "MI0040671",
    "system_name": "RIDGEWOOD MOBILE HOME PARK INC",
    "display_name": "RIDGEWOOD MOBILE HOME PARK INC",
    "county": "OAKLAND",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0040672",
    "resolved_pwsid": "MI0040672-b",
    "system_name": "RIVER RIDGE",
    "display_name": "RIVER RIDGE",
    "county": "LAPEER",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040672",
    "resolved_pwsid": "MI0040672-a",
    "system_name": "PINE RIVER RIDGE",
    "display_name": "PINE RIVER RIDGE",
    "county": "LAPEER",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040672",
    "resolved_pwsid": "MI0040672-b",
    "system_name": "RIVER RIDGE",
    "display_name": "RIVER RIDGE",
    "county": "LAPEER",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040672",
    "resolved_pwsid": "MI0040672-a",
    "system_name": "PINE RIVER RIDGE",
    "display_name": "PINE RIVER RIDGE",
    "county": "LAPEER",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040672",
    "resolved_pwsid": "MI0040672-a",
    "system_name": "PINE RIVER RIDGE",
    "display_name": "PINE RIVER RIDGE",
    "county": "LAPEER",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0040673",
    "resolved_pwsid": "MI0040673",
    "system_name": "WATERS EDGE MH COMMUNITY",
    "display_name": "WATERS EDGE MH COMMUNITY",
    "county": "LENAWEE",
    "monitoring_end_date": "2017-06-30",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040673",
    "resolved_pwsid": "MI0040673",
    "system_name": "WATERS EDGE MH COMMUNITY",
    "display_name": "WATERS EDGE MH COMMUNITY",
    "county": "LENAWEE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040673",
    "resolved_pwsid": "MI0040673",
    "system_name": "WATERS EDGE MH COMMUNITY",
    "display_name": "WATERS EDGE MH COMMUNITY",
    "county": "LENAWEE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040673",
    "resolved_pwsid": "MI0040673",
    "system_name": "WATERS EDGE MH COMMUNITY",
    "display_name": "WATERS EDGE MH COMMUNITY",
    "county": "LENAWEE",
    "monitoring_end_date": "2022-06-30",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040673",
    "resolved_pwsid": "MI0040673",
    "system_name": "WATERS EDGE MH COMMUNITY",
    "display_name": "WATERS EDGE MH COMMUNITY",
    "county": "LENAWEE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040673",
    "resolved_pwsid": "MI0040673",
    "system_name": "WATERS EDGE MH COMMUNITY",
    "display_name": "WATERS EDGE MH COMMUNITY",
    "county": "LENAWEE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0040675",
    "resolved_pwsid": "MI0040675",
    "system_name": "CAPITAL CROSSINGS",
    "display_name": "CAPITAL CROSSINGS",
    "county": "CLINTON",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040675",
    "resolved_pwsid": "MI0040675",
    "system_name": "CAPITAL CROSSINGS",
    "display_name": "CAPITAL CROSSINGS",
    "county": "CLINTON",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040675",
    "resolved_pwsid": "MI0040675",
    "system_name": "CAPITAL CROSSINGS",
    "display_name": "CAPITAL CROSSINGS",
    "county": "CLINTON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 12,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040678",
    "resolved_pwsid": "MI0040678",
    "system_name": "OAKS OF ROCKFORD",
    "display_name": "OAKS OF ROCKFORD",
    "county": "KENT",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040678",
    "resolved_pwsid": "MI0040678",
    "system_name": "OAKS OF ROCKFORD",
    "display_name": "OAKS OF ROCKFORD",
    "county": "KENT",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040678",
    "resolved_pwsid": "MI0040678",
    "system_name": "OAKS OF ROCKFORD",
    "display_name": "OAKS OF ROCKFORD",
    "county": "KENT",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040678",
    "resolved_pwsid": "MI0040678",
    "system_name": "OAKS OF ROCKFORD",
    "display_name": "OAKS OF ROCKFORD",
    "county": "KENT",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040679",
    "resolved_pwsid": "MI0040679",
    "system_name": "CIDERMILL CROSSINGS",
    "display_name": "CIDERMILL CROSSINGS",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040679",
    "resolved_pwsid": "MI0040679",
    "system_name": "CIDERMILL CROSSINGS",
    "display_name": "CIDERMILL CROSSINGS",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040679",
    "resolved_pwsid": "MI0040679",
    "system_name": "CIDERMILL CROSSINGS",
    "display_name": "CIDERMILL CROSSINGS",
    "county": "LIVINGSTON",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040680",
    "resolved_pwsid": "MI0040680",
    "system_name": "HEARTHSIDE GROVE MOTOR COACH RESORT",
    "display_name": "HEARTHSIDE GROVE MOTOR COACH RESORT",
    "county": "EMMET",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040680",
    "resolved_pwsid": "MI0040680",
    "system_name": "HEARTHSIDE GROVE MOTOR COACH RESORT",
    "display_name": "HEARTHSIDE GROVE MOTOR COACH RESORT",
    "county": "EMMET",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040680",
    "resolved_pwsid": "MI0040680",
    "system_name": "HEARTHSIDE GROVE MOTOR COACH RESORT",
    "display_name": "HEARTHSIDE GROVE MOTOR COACH RESORT",
    "county": "EMMET",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040681",
    "resolved_pwsid": "MI0040681",
    "system_name": "ALTO MEADOWS",
    "display_name": "ALTO MEADOWS",
    "county": "KENT",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040681",
    "resolved_pwsid": "MI0040681",
    "system_name": "ALTO MEADOWS",
    "display_name": "ALTO MEADOWS",
    "county": "KENT",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040681",
    "resolved_pwsid": "MI0040681",
    "system_name": "ALTO MEADOWS",
    "display_name": "ALTO MEADOWS",
    "county": "KENT",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040681",
    "resolved_pwsid": "MI0040681",
    "system_name": "ALTO MEADOWS",
    "display_name": "ALTO MEADOWS",
    "county": "KENT",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040682",
    "resolved_pwsid": "MI0040682",
    "system_name": "HIDDEN CREEK ESTATES",
    "display_name": "HIDDEN CREEK ESTATES",
    "county": "ALLEGAN",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040682",
    "resolved_pwsid": "MI0040682",
    "system_name": "HIDDEN CREEK ESTATES",
    "display_name": "HIDDEN CREEK ESTATES",
    "county": "ALLEGAN",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0040682",
    "resolved_pwsid": "MI0040682",
    "system_name": "HIDDEN CREEK ESTATES",
    "display_name": "HIDDEN CREEK ESTATES",
    "county": "ALLEGAN",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0060085",
    "resolved_pwsid": "MI0060085-b",
    "system_name": "ALAMO NURSING HOME",
    "display_name": "ALAMO NURSING HOME",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0060085",
    "resolved_pwsid": "MI0060085-b",
    "system_name": "ALAMO NURSING HOME",
    "display_name": "ALAMO NURSING HOME",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0060085",
    "resolved_pwsid": "MI0060085-a",
    "system_name": "ALAMO COVE NURSING HOME",
    "display_name": "ALAMO COVE NURSING HOME",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0060238",
    "resolved_pwsid": "MI0060238",
    "system_name": "NORTH WOODS NURSING CENTER",
    "display_name": "NORTH WOODS NURSING CENTER",
    "county": "CLARE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0060238",
    "resolved_pwsid": "MI0060238",
    "system_name": "NORTH WOODS NURSING CENTER",
    "display_name": "NORTH WOODS NURSING CENTER",
    "county": "CLARE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0060238",
    "resolved_pwsid": "MI0060238",
    "system_name": "NORTH WOODS NURSING CENTER",
    "display_name": "NORTH WOODS NURSING CENTER",
    "county": "CLARE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0060238",
    "resolved_pwsid": "MI0060238",
    "system_name": "NORTH WOODS NURSING CENTER",
    "display_name": "NORTH WOODS NURSING CENTER",
    "county": "CLARE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0060238",
    "resolved_pwsid": "MI0060238",
    "system_name": "NORTH WOODS NURSING CENTER",
    "display_name": "NORTH WOODS NURSING CENTER",
    "county": "CLARE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0060425",
    "resolved_pwsid": "MI0060425",
    "system_name": "THORNAPPLE MANOR",
    "display_name": "THORNAPPLE MANOR",
    "county": "BARRY",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0060425",
    "resolved_pwsid": "MI0060425",
    "system_name": "THORNAPPLE MANOR",
    "display_name": "THORNAPPLE MANOR",
    "county": "BARRY",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0060425",
    "resolved_pwsid": "MI0060425",
    "system_name": "THORNAPPLE MANOR",
    "display_name": "THORNAPPLE MANOR",
    "county": "BARRY",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0060425",
    "resolved_pwsid": "MI0060425",
    "system_name": "THORNAPPLE MANOR",
    "display_name": "THORNAPPLE MANOR",
    "county": "BARRY",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0060425",
    "resolved_pwsid": "MI0060425",
    "system_name": "THORNAPPLE MANOR",
    "display_name": "THORNAPPLE MANOR",
    "county": "BARRY",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0060640",
    "resolved_pwsid": "MI0060640-b",
    "system_name": "LAKELAND MEDICAL CENTER-BERRIEN CNTR",
    "display_name": "LAKELAND MEDICAL CENTER-BERRIEN CNTR",
    "county": "BERRIEN",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0060640",
    "resolved_pwsid": "MI0060640-b",
    "system_name": "LAKELAND MEDICAL CENTER-BERRIEN CNTR",
    "display_name": "LAKELAND MEDICAL CENTER-BERRIEN CNTR",
    "county": "BERRIEN",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0060640",
    "resolved_pwsid": "MI0060640-a",
    "system_name": "COREWELL HEALTH-BERRIEN CNTR",
    "display_name": "COREWELL HEALTH-BERRIEN CNTR",
    "county": "BERRIEN",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0060640",
    "resolved_pwsid": "MI0060640-b",
    "system_name": "LAKELAND MEDICAL CENTER-BERRIEN CNTR",
    "display_name": "LAKELAND MEDICAL CENTER-BERRIEN CNTR",
    "county": "BERRIEN",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0060640",
    "resolved_pwsid": "MI0060640-a",
    "system_name": "COREWELL HEALTH-BERRIEN CNTR",
    "display_name": "COREWELL HEALTH-BERRIEN CNTR",
    "county": "BERRIEN",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 130,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0060640",
    "resolved_pwsid": "MI0060640-a",
    "system_name": "COREWELL HEALTH-BERRIEN CNTR",
    "display_name": "COREWELL HEALTH-BERRIEN CNTR",
    "county": "BERRIEN",
    "monitoring_end_date": "2026-06-30",
    "year": 2026,
    "lead_90th_ppb": 18,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0060675",
    "resolved_pwsid": "MI0060675",
    "system_name": "MEADOW WOODS N/R CENTER",
    "display_name": "MEADOW WOODS N/R CENTER",
    "county": "VAN BUREN",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 11,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0060675",
    "resolved_pwsid": "MI0060675",
    "system_name": "MEADOW WOODS N/R CENTER",
    "display_name": "MEADOW WOODS N/R CENTER",
    "county": "VAN BUREN",
    "monitoring_end_date": "2020-09-30",
    "year": 2020,
    "lead_90th_ppb": 147,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0060675",
    "resolved_pwsid": "MI0060675",
    "system_name": "MEADOW WOODS N/R CENTER",
    "display_name": "MEADOW WOODS N/R CENTER",
    "county": "VAN BUREN",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 147,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0060675",
    "resolved_pwsid": "MI0060675",
    "system_name": "MEADOW WOODS N/R CENTER",
    "display_name": "MEADOW WOODS N/R CENTER",
    "county": "VAN BUREN",
    "monitoring_end_date": "2021-06-30",
    "year": 2021,
    "lead_90th_ppb": 92,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0060675",
    "resolved_pwsid": "MI0060675",
    "system_name": "MEADOW WOODS N/R CENTER",
    "display_name": "MEADOW WOODS N/R CENTER",
    "county": "VAN BUREN",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 15,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0060675",
    "resolved_pwsid": "MI0060675",
    "system_name": "MEADOW WOODS N/R CENTER",
    "display_name": "MEADOW WOODS N/R CENTER",
    "county": "VAN BUREN",
    "monitoring_end_date": "2022-06-30",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0060675",
    "resolved_pwsid": "MI0060675",
    "system_name": "MEADOW WOODS N/R CENTER",
    "display_name": "MEADOW WOODS N/R CENTER",
    "county": "VAN BUREN",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0060675",
    "resolved_pwsid": "MI0060675",
    "system_name": "MEADOW WOODS N/R CENTER",
    "display_name": "MEADOW WOODS N/R CENTER",
    "county": "VAN BUREN",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0060695",
    "resolved_pwsid": "MI0060695",
    "system_name": "PLAINWELL PINES H C F",
    "display_name": "PLAINWELL PINES H C F",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0060695",
    "resolved_pwsid": "MI0060695",
    "system_name": "PLAINWELL PINES H C F",
    "display_name": "PLAINWELL PINES H C F",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0060695",
    "resolved_pwsid": "MI0060695",
    "system_name": "PLAINWELL PINES H C F",
    "display_name": "PLAINWELL PINES H C F",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0060695",
    "resolved_pwsid": "MI0060695",
    "system_name": "PLAINWELL PINES H C F",
    "display_name": "PLAINWELL PINES H C F",
    "county": "KALAMAZOO",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0060792",
    "resolved_pwsid": "MI0060792",
    "system_name": "VILLA AT GREEN LAKE ESTATES",
    "display_name": "VILLA AT GREEN LAKE ESTATES",
    "county": "OAKLAND",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0060792",
    "resolved_pwsid": "MI0060792",
    "system_name": "VILLA AT GREEN LAKE ESTATES",
    "display_name": "VILLA AT GREEN LAKE ESTATES",
    "county": "OAKLAND",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0060792",
    "resolved_pwsid": "MI0060792",
    "system_name": "VILLA AT GREEN LAKE ESTATES",
    "display_name": "VILLA AT GREEN LAKE ESTATES",
    "county": "OAKLAND",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0060792",
    "resolved_pwsid": "MI0060792",
    "system_name": "VILLA AT GREEN LAKE ESTATES",
    "display_name": "VILLA AT GREEN LAKE ESTATES",
    "county": "OAKLAND",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 29,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0060792",
    "resolved_pwsid": "MI0060792",
    "system_name": "VILLA AT GREEN LAKE ESTATES",
    "display_name": "VILLA AT GREEN LAKE ESTATES",
    "county": "OAKLAND",
    "monitoring_end_date": "2026-06-30",
    "year": 2026,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0060937",
    "resolved_pwsid": "MI0060937",
    "system_name": "THE LAURELS OF FULTON",
    "display_name": "THE LAURELS OF FULTON",
    "county": "GRATIOT",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0060937",
    "resolved_pwsid": "MI0060937",
    "system_name": "THE LAURELS OF FULTON",
    "display_name": "THE LAURELS OF FULTON",
    "county": "GRATIOT",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0060937",
    "resolved_pwsid": "MI0060937",
    "system_name": "THE LAURELS OF FULTON",
    "display_name": "THE LAURELS OF FULTON",
    "county": "GRATIOT",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0061700",
    "resolved_pwsid": "MI0061700",
    "system_name": "CURRY HOUSE ASSISTED LIVING CENTER",
    "display_name": "CURRY HOUSE ASSISTED LIVING CENTER",
    "county": "WEXFORD",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0061700",
    "resolved_pwsid": "MI0061700",
    "system_name": "CURRY HOUSE ASSISTED LIVING CENTER",
    "display_name": "CURRY HOUSE ASSISTED LIVING CENTER",
    "county": "WEXFORD",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0061700",
    "resolved_pwsid": "MI0061700",
    "system_name": "CURRY HOUSE ASSISTED LIVING CENTER",
    "display_name": "CURRY HOUSE ASSISTED LIVING CENTER",
    "county": "WEXFORD",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0062653",
    "resolved_pwsid": "MI0062653",
    "system_name": "GLADWIN NURSING AND REHABILITATION COMMU",
    "display_name": "GLADWIN NURSING AND REHABILITATION COMMU",
    "county": "GLADWIN",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0062653",
    "resolved_pwsid": "MI0062653",
    "system_name": "GLADWIN NURSING AND REHABILITATION COMMU",
    "display_name": "GLADWIN NURSING AND REHABILITATION COMMU",
    "county": "GLADWIN",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0062653",
    "resolved_pwsid": "MI0062653",
    "system_name": "GLADWIN NURSING AND REHABILITATION COMMU",
    "display_name": "GLADWIN NURSING AND REHABILITATION COMMU",
    "county": "GLADWIN",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0062658",
    "resolved_pwsid": "MI0062658-a",
    "system_name": "METRON OF LAMONT",
    "display_name": "METRON OF LAMONT",
    "county": "OTTAWA",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0062658",
    "resolved_pwsid": "MI0062658-a",
    "system_name": "METRON OF LAMONT",
    "display_name": "METRON OF LAMONT",
    "county": "OTTAWA",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0062658",
    "resolved_pwsid": "MI0062658-b",
    "system_name": "MISSION POINT HEALTHCARE",
    "display_name": "MISSION POINT HEALTHCARE",
    "county": "OTTAWA",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0062658",
    "resolved_pwsid": "MI0062658-b",
    "system_name": "MISSION POINT HEALTHCARE",
    "display_name": "MISSION POINT HEALTHCARE",
    "county": "OTTAWA",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0062658",
    "resolved_pwsid": "MI0062658-c",
    "system_name": "INTERSECT HEALTHCARE",
    "display_name": "MISSION POINT HEALTHCARE",
    "county": "OTTAWA",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0062841",
    "resolved_pwsid": "MI0062841",
    "system_name": "MEDILODGE OF STERLING",
    "display_name": "MEDILODGE OF STERLING",
    "county": "ARENAC",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0062841",
    "resolved_pwsid": "MI0062841",
    "system_name": "MEDILODGE OF STERLING",
    "display_name": "MEDILODGE OF STERLING",
    "county": "ARENAC",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0062841",
    "resolved_pwsid": "MI0062841",
    "system_name": "MEDILODGE OF STERLING",
    "display_name": "MEDILODGE OF STERLING",
    "county": "ARENAC",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 161,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0062841",
    "resolved_pwsid": "MI0062841",
    "system_name": "MEDILODGE OF STERLING",
    "display_name": "MEDILODGE OF STERLING",
    "county": "ARENAC",
    "monitoring_end_date": "2021-06-30",
    "year": 2021,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0062841",
    "resolved_pwsid": "MI0062841",
    "system_name": "MEDILODGE OF STERLING",
    "display_name": "MEDILODGE OF STERLING",
    "county": "ARENAC",
    "monitoring_end_date": "2022-06-30",
    "year": 2022,
    "lead_90th_ppb": 16,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0062841",
    "resolved_pwsid": "MI0062841",
    "system_name": "MEDILODGE OF STERLING",
    "display_name": "MEDILODGE OF STERLING",
    "county": "ARENAC",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0062841",
    "resolved_pwsid": "MI0062841",
    "system_name": "MEDILODGE OF STERLING",
    "display_name": "MEDILODGE OF STERLING",
    "county": "ARENAC",
    "monitoring_end_date": "2023-06-30",
    "year": 2023,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0062841",
    "resolved_pwsid": "MI0062841",
    "system_name": "MEDILODGE OF STERLING",
    "display_name": "MEDILODGE OF STERLING",
    "county": "ARENAC",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 11,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0062841",
    "resolved_pwsid": "MI0062841",
    "system_name": "MEDILODGE OF STERLING",
    "display_name": "MEDILODGE OF STERLING",
    "county": "ARENAC",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0062841",
    "resolved_pwsid": "MI0062841",
    "system_name": "MEDILODGE OF STERLING",
    "display_name": "MEDILODGE OF STERLING",
    "county": "ARENAC",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 888,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0062841",
    "resolved_pwsid": "MI0062841",
    "system_name": "MEDILODGE OF STERLING",
    "display_name": "MEDILODGE OF STERLING",
    "county": "ARENAC",
    "monitoring_end_date": "2026-06-30",
    "year": 2026,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0062942",
    "resolved_pwsid": "MI0062942",
    "system_name": "HALE CREEK MANOR",
    "display_name": "HALE CREEK MANOR",
    "county": "IOSCO",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0062942",
    "resolved_pwsid": "MI0062942",
    "system_name": "HALE CREEK MANOR",
    "display_name": "HALE CREEK MANOR",
    "county": "IOSCO",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0062942",
    "resolved_pwsid": "MI0062942",
    "system_name": "HALE CREEK MANOR",
    "display_name": "HALE CREEK MANOR",
    "county": "IOSCO",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0062942",
    "resolved_pwsid": "MI0062942",
    "system_name": "HALE CREEK MANOR",
    "display_name": "HALE CREEK MANOR",
    "county": "IOSCO",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0062955",
    "resolved_pwsid": "MI0062955-a",
    "system_name": "HEARTLAND HEALTH CARE CENTER",
    "display_name": "HEARTLAND HEALTH CARE CENTER",
    "county": "GENESEE",
    "monitoring_end_date": "2021-06-30",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0062955",
    "resolved_pwsid": "MI0062955-a",
    "system_name": "HEARTLAND HEALTH CARE CENTER",
    "display_name": "HEARTLAND HEALTH CARE CENTER",
    "county": "GENESEE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0062955",
    "resolved_pwsid": "MI0062955-a",
    "system_name": "HEARTLAND HEALTH CARE CENTER",
    "display_name": "HEARTLAND HEALTH CARE CENTER",
    "county": "GENESEE",
    "monitoring_end_date": "2022-06-30",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0062955",
    "resolved_pwsid": "MI0062955-a",
    "system_name": "HEARTLAND HEALTH CARE CENTER",
    "display_name": "HEARTLAND HEALTH CARE CENTER",
    "county": "GENESEE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0062955",
    "resolved_pwsid": "MI0062955-a",
    "system_name": "HEARTLAND HEALTH CARE CENTER",
    "display_name": "HEARTLAND HEALTH CARE CENTER",
    "county": "GENESEE",
    "monitoring_end_date": "2023-06-30",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0062955",
    "resolved_pwsid": "MI0062955-a",
    "system_name": "HEARTLAND HEALTH CARE CENTER",
    "display_name": "HEARTLAND HEALTH CARE CENTER",
    "county": "GENESEE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0062955",
    "resolved_pwsid": "MI0062955-b",
    "system_name": "MAJESTIC CARE OF FLUSHING",
    "display_name": "MAJESTIC CARE OF FLUSHING",
    "county": "GENESEE",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0062955",
    "resolved_pwsid": "MI0062955-b",
    "system_name": "MAJESTIC CARE OF FLUSHING",
    "display_name": "MAJESTIC CARE OF FLUSHING",
    "county": "GENESEE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0063476",
    "resolved_pwsid": "MI0063476",
    "system_name": "JAMIESON NURSING HOME",
    "display_name": "JAMIESON NURSING HOME",
    "county": "ALCONA",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0063476",
    "resolved_pwsid": "MI0063476",
    "system_name": "JAMIESON NURSING HOME",
    "display_name": "JAMIESON NURSING HOME",
    "county": "ALCONA",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0063476",
    "resolved_pwsid": "MI0063476",
    "system_name": "JAMIESON NURSING HOME",
    "display_name": "JAMIESON NURSING HOME",
    "county": "ALCONA",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0063477",
    "resolved_pwsid": "MI0063477",
    "system_name": "DIMONDALE HEALTH CARE CENTER",
    "display_name": "DIMONDALE HEALTH CARE CENTER",
    "county": "EATON",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 8,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0063477",
    "resolved_pwsid": "MI0063477",
    "system_name": "DIMONDALE HEALTH CARE CENTER",
    "display_name": "DIMONDALE HEALTH CARE CENTER",
    "county": "EATON",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 9,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0063477",
    "resolved_pwsid": "MI0063477",
    "system_name": "DIMONDALE HEALTH CARE CENTER",
    "display_name": "DIMONDALE HEALTH CARE CENTER",
    "county": "EATON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0063477",
    "resolved_pwsid": "MI0063477",
    "system_name": "DIMONDALE HEALTH CARE CENTER",
    "display_name": "DIMONDALE HEALTH CARE CENTER",
    "county": "EATON",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0063635",
    "resolved_pwsid": "MI0063635",
    "system_name": "KING NURSING & REHABILITATION COMMUNITY",
    "display_name": "KING NURSING & REHABILITATION COMMUNITY",
    "county": "ROSCOMMON",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0063635",
    "resolved_pwsid": "MI0063635",
    "system_name": "KING NURSING & REHABILITATION COMMUNITY",
    "display_name": "KING NURSING & REHABILITATION COMMUNITY",
    "county": "ROSCOMMON",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0063635",
    "resolved_pwsid": "MI0063635",
    "system_name": "KING NURSING & REHABILITATION COMMUNITY",
    "display_name": "KING NURSING & REHABILITATION COMMUNITY",
    "county": "ROSCOMMON",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0063635",
    "resolved_pwsid": "MI0063635",
    "system_name": "KING NURSING & REHABILITATION COMMUNITY",
    "display_name": "KING NURSING & REHABILITATION COMMUNITY",
    "county": "ROSCOMMON",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0063865",
    "resolved_pwsid": "MI0063865",
    "system_name": "LINCOLN HAVEN NURSING & REHABILITATION",
    "display_name": "LINCOLN HAVEN NURSING & REHABILITATION",
    "county": "ALCONA",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 10,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0063865",
    "resolved_pwsid": "MI0063865",
    "system_name": "LINCOLN HAVEN NURSING & REHABILITATION",
    "display_name": "LINCOLN HAVEN NURSING & REHABILITATION",
    "county": "ALCONA",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0063865",
    "resolved_pwsid": "MI0063865",
    "system_name": "LINCOLN HAVEN NURSING & REHABILITATION",
    "display_name": "LINCOLN HAVEN NURSING & REHABILITATION",
    "county": "ALCONA",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0063865",
    "resolved_pwsid": "MI0063865",
    "system_name": "LINCOLN HAVEN NURSING & REHABILITATION",
    "display_name": "LINCOLN HAVEN NURSING & REHABILITATION",
    "county": "ALCONA",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0064067",
    "resolved_pwsid": "MI0064067",
    "system_name": "MAPLE VALLEY NURSING HOME",
    "display_name": "MAPLE VALLEY NURSING HOME",
    "county": "LEELANAU",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0064067",
    "resolved_pwsid": "MI0064067",
    "system_name": "MAPLE VALLEY NURSING HOME",
    "display_name": "MAPLE VALLEY NURSING HOME",
    "county": "LEELANAU",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0064067",
    "resolved_pwsid": "MI0064067",
    "system_name": "MAPLE VALLEY NURSING HOME",
    "display_name": "MAPLE VALLEY NURSING HOME",
    "county": "LEELANAU",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0064067",
    "resolved_pwsid": "MI0064067",
    "system_name": "MAPLE VALLEY NURSING HOME",
    "display_name": "MAPLE VALLEY NURSING HOME",
    "county": "LEELANAU",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0064067",
    "resolved_pwsid": "MI0064067",
    "system_name": "MAPLE VALLEY NURSING HOME",
    "display_name": "MAPLE VALLEY NURSING HOME",
    "county": "LEELANAU",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0064067",
    "resolved_pwsid": "MI0064067",
    "system_name": "MAPLE VALLEY NURSING HOME",
    "display_name": "MAPLE VALLEY NURSING HOME",
    "county": "LEELANAU",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0064067",
    "resolved_pwsid": "MI0064067",
    "system_name": "MAPLE VALLEY NURSING HOME",
    "display_name": "MAPLE VALLEY NURSING HOME",
    "county": "LEELANAU",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0064070",
    "resolved_pwsid": "MI0064070",
    "system_name": "MAPLEVIEW NURSING HOME",
    "display_name": "MAPLEVIEW NURSING HOME",
    "county": "GRATIOT",
    "monitoring_end_date": "2022-06-30",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0064070",
    "resolved_pwsid": "MI0064070",
    "system_name": "MAPLEVIEW NURSING HOME",
    "display_name": "MAPLEVIEW NURSING HOME",
    "county": "GRATIOT",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0064070",
    "resolved_pwsid": "MI0064070",
    "system_name": "MAPLEVIEW NURSING HOME",
    "display_name": "MAPLEVIEW NURSING HOME",
    "county": "GRATIOT",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0064213",
    "resolved_pwsid": "MI0064213",
    "system_name": "MEADOWBROOK MED CARE FACILITY",
    "display_name": "MEADOWBROOK MED CARE FACILITY",
    "county": "ANTRIM",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0064213",
    "resolved_pwsid": "MI0064213",
    "system_name": "MEADOWBROOK MED CARE FACILITY",
    "display_name": "MEADOWBROOK MED CARE FACILITY",
    "county": "ANTRIM",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0064213",
    "resolved_pwsid": "MI0064213",
    "system_name": "MEADOWBROOK MED CARE FACILITY",
    "display_name": "MEADOWBROOK MED CARE FACILITY",
    "county": "ANTRIM",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0064934",
    "resolved_pwsid": "MI0064934",
    "system_name": "THE VILLA AT ROSE CITY",
    "display_name": "THE VILLA AT ROSE CITY",
    "county": "OGEMAW",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0064934",
    "resolved_pwsid": "MI0064934",
    "system_name": "THE VILLA AT ROSE CITY",
    "display_name": "THE VILLA AT ROSE CITY",
    "county": "OGEMAW",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0064934",
    "resolved_pwsid": "MI0064934",
    "system_name": "THE VILLA AT ROSE CITY",
    "display_name": "THE VILLA AT ROSE CITY",
    "county": "OGEMAW",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0064934",
    "resolved_pwsid": "MI0064934",
    "system_name": "THE VILLA AT ROSE CITY",
    "display_name": "THE VILLA AT ROSE CITY",
    "county": "OGEMAW",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0066355",
    "resolved_pwsid": "MI0066355",
    "system_name": "ARGENTINE CARE CENTER",
    "display_name": "ARGENTINE CARE CENTER",
    "county": "GENESEE",
    "monitoring_end_date": "2017-12-31",
    "year": 2017,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0066355",
    "resolved_pwsid": "MI0066355",
    "system_name": "ARGENTINE CARE CENTER",
    "display_name": "ARGENTINE CARE CENTER",
    "county": "GENESEE",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0066355",
    "resolved_pwsid": "MI0066355",
    "system_name": "ARGENTINE CARE CENTER",
    "display_name": "ARGENTINE CARE CENTER",
    "county": "GENESEE",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 9,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0066355",
    "resolved_pwsid": "MI0066355",
    "system_name": "ARGENTINE CARE CENTER",
    "display_name": "ARGENTINE CARE CENTER",
    "county": "GENESEE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0066355",
    "resolved_pwsid": "MI0066355",
    "system_name": "ARGENTINE CARE CENTER",
    "display_name": "ARGENTINE CARE CENTER",
    "county": "GENESEE",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0066355",
    "resolved_pwsid": "MI0066355",
    "system_name": "ARGENTINE CARE CENTER",
    "display_name": "ARGENTINE CARE CENTER",
    "county": "GENESEE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 4,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 2,
    "total_to_identify_or_replace": 2,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0066695",
    "resolved_pwsid": "MI0066695-b",
    "system_name": "THE PINES OF GOODRICH (DIST1)",
    "display_name": "THE PINES OF GOODRICH (DIST1)",
    "county": "GENESEE",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0066695",
    "resolved_pwsid": "MI0066695-c",
    "system_name": "THE PINES OF GOODRICH (DIST2)",
    "display_name": "THE PINES OF GOODRICH (DIST2)",
    "county": "GENESEE",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0066695",
    "resolved_pwsid": "MI0066695-d",
    "system_name": "THE PINES OF GOODRICH (DISTRIBUTION 1)",
    "display_name": "THE PINES OF GOODRICH (DISTRIBUTION 1)",
    "county": "GENESEE",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0066695",
    "resolved_pwsid": "MI0066695-e",
    "system_name": "THE PINES OF GOODRICH (DISTRIBUTION 2)",
    "display_name": "THE PINES OF GOODRICH (DISTRIBUTION 2)",
    "county": "GENESEE",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0066695",
    "resolved_pwsid": "MI0066695-b",
    "system_name": "THE PINES OF GOODRICH (DIST1)",
    "display_name": "THE PINES OF GOODRICH (DIST1)",
    "county": "GENESEE",
    "monitoring_end_date": "2021-06-30",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0066695",
    "resolved_pwsid": "MI0066695-c",
    "system_name": "THE PINES OF GOODRICH (DIST2)",
    "display_name": "THE PINES OF GOODRICH (DIST2)",
    "county": "GENESEE",
    "monitoring_end_date": "2021-06-30",
    "year": 2021,
    "lead_90th_ppb": 1,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0066695",
    "resolved_pwsid": "MI0066695-a",
    "system_name": "THE PINES OF GOODRICH",
    "display_name": "THE PINES OF GOODRICH",
    "county": "GENESEE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0066695",
    "resolved_pwsid": "MI0066695-b",
    "system_name": "THE PINES OF GOODRICH (DIST1)",
    "display_name": "THE PINES OF GOODRICH (DIST1)",
    "county": "GENESEE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0066695",
    "resolved_pwsid": "MI0066695-c",
    "system_name": "THE PINES OF GOODRICH (DIST2)",
    "display_name": "THE PINES OF GOODRICH (DIST2)",
    "county": "GENESEE",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0066695",
    "resolved_pwsid": "MI0066695-a",
    "system_name": "THE PINES OF GOODRICH",
    "display_name": "THE PINES OF GOODRICH",
    "county": "GENESEE",
    "monitoring_end_date": "2024-06-30",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0066695",
    "resolved_pwsid": "MI0066695-f",
    "system_name": "THE PINES OF GOODRICH (DS001)",
    "display_name": "THE PINES OF GOODRICH",
    "county": "GENESEE",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0066695",
    "resolved_pwsid": "MI0066695-a",
    "system_name": "THE PINES OF GOODRICH",
    "display_name": "THE PINES OF GOODRICH",
    "county": "GENESEE",
    "monitoring_end_date": "2026-06-30",
    "year": 2026,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0066700",
    "resolved_pwsid": "MI0066700",
    "system_name": "THE PORCHES",
    "display_name": "THE PORCHES",
    "county": "OTSEGO",
    "monitoring_end_date": "2020-06-30",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0066700",
    "resolved_pwsid": "MI0066700",
    "system_name": "THE PORCHES",
    "display_name": "THE PORCHES",
    "county": "OTSEGO",
    "monitoring_end_date": "2020-12-31",
    "year": 2020,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0066700",
    "resolved_pwsid": "MI0066700",
    "system_name": "THE PORCHES",
    "display_name": "THE PORCHES",
    "county": "OTSEGO",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0066700",
    "resolved_pwsid": "MI0066700",
    "system_name": "THE PORCHES",
    "display_name": "THE PORCHES",
    "county": "OTSEGO",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0066700",
    "resolved_pwsid": "MI0066700",
    "system_name": "THE PORCHES",
    "display_name": "THE PORCHES",
    "county": "OTSEGO",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0066700",
    "resolved_pwsid": "MI0066700",
    "system_name": "THE PORCHES",
    "display_name": "THE PORCHES",
    "county": "OTSEGO",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0067020",
    "resolved_pwsid": "MI0067020",
    "system_name": "WEST HICKORY HAVEN",
    "display_name": "WEST HICKORY HAVEN",
    "county": "OAKLAND",
    "monitoring_end_date": "2016-12-31",
    "year": 2016,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0067020",
    "resolved_pwsid": "MI0067020",
    "system_name": "WEST HICKORY HAVEN",
    "display_name": "WEST HICKORY HAVEN",
    "county": "OAKLAND",
    "monitoring_end_date": "2019-12-31",
    "year": 2019,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0067020",
    "resolved_pwsid": "MI0067020",
    "system_name": "WEST HICKORY HAVEN",
    "display_name": "WEST HICKORY HAVEN",
    "county": "OAKLAND",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0067020",
    "resolved_pwsid": "MI0067020",
    "system_name": "WEST HICKORY HAVEN",
    "display_name": "WEST HICKORY HAVEN",
    "county": "OAKLAND",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0067101",
    "resolved_pwsid": "MI0067101",
    "system_name": "REGENCY AT WHITMORE LAKE",
    "display_name": "REGENCY AT WHITMORE LAKE",
    "county": "WASHTENAW",
    "monitoring_end_date": "2018-12-31",
    "year": 2018,
    "lead_90th_ppb": 6,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0067101",
    "resolved_pwsid": "MI0067101",
    "system_name": "REGENCY AT WHITMORE LAKE",
    "display_name": "REGENCY AT WHITMORE LAKE",
    "county": "WASHTENAW",
    "monitoring_end_date": "2021-12-31",
    "year": 2021,
    "lead_90th_ppb": 3,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0067101",
    "resolved_pwsid": "MI0067101",
    "system_name": "REGENCY AT WHITMORE LAKE",
    "display_name": "REGENCY AT WHITMORE LAKE",
    "county": "WASHTENAW",
    "monitoring_end_date": "2024-12-31",
    "year": 2024,
    "lead_90th_ppb": 5,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0067101",
    "resolved_pwsid": "MI0067101",
    "system_name": "REGENCY AT WHITMORE LAKE",
    "display_name": "REGENCY AT WHITMORE LAKE",
    "county": "WASHTENAW",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0070016",
    "resolved_pwsid": "MI0070016",
    "system_name": "COREWELL HEALTH GR FULLER",
    "display_name": "COREWELL HEALTH GR FULLER",
    "county": "KENT",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0070016",
    "resolved_pwsid": "MI0070016",
    "system_name": "COREWELL HEALTH GR FULLER",
    "display_name": "COREWELL HEALTH GR FULLER",
    "county": "KENT",
    "monitoring_end_date": "2023-06-30",
    "year": 2023,
    "lead_90th_ppb": 2,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0070016",
    "resolved_pwsid": "MI0070016",
    "system_name": "COREWELL HEALTH GR FULLER",
    "display_name": "COREWELL HEALTH GR FULLER",
    "county": "KENT",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 17,
    "above_action_level": true,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0070017",
    "resolved_pwsid": "MI0070017",
    "system_name": "COREWELLHEALTH GR KALAMAZOO",
    "display_name": "COREWELLHEALTH GR KALAMAZOO",
    "county": "KENT",
    "monitoring_end_date": "2022-12-31",
    "year": 2022,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0070017",
    "resolved_pwsid": "MI0070017",
    "system_name": "COREWELLHEALTH GR KALAMAZOO",
    "display_name": "COREWELLHEALTH GR KALAMAZOO",
    "county": "KENT",
    "monitoring_end_date": "2023-06-30",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0070017",
    "resolved_pwsid": "MI0070017",
    "system_name": "COREWELLHEALTH GR KALAMAZOO",
    "display_name": "COREWELLHEALTH GR KALAMAZOO",
    "county": "KENT",
    "monitoring_end_date": "2023-12-31",
    "year": 2023,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0070017",
    "resolved_pwsid": "MI0070017",
    "system_name": "COREWELLHEALTH GR KALAMAZOO",
    "display_name": "COREWELLHEALTH GR KALAMAZOO",
    "county": "KENT",
    "monitoring_end_date": "2024-06-30",
    "year": 2024,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  },
  {
    "base_pwsid": "MI0070017",
    "resolved_pwsid": "MI0070017",
    "system_name": "COREWELLHEALTH GR KALAMAZOO",
    "display_name": "COREWELLHEALTH GR KALAMAZOO",
    "county": "KENT",
    "monitoring_end_date": "2025-12-31",
    "year": 2025,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": 0,
    "inventory_gpcl": 0,
    "inventory_unknown": 0,
    "total_to_identify_or_replace": 0,
    "inventory_complete_flag": true
  },
  {
    "base_pwsid": "MI0070017",
    "resolved_pwsid": "MI0070017",
    "system_name": "COREWELLHEALTH GR KALAMAZOO",
    "display_name": "COREWELLHEALTH GR KALAMAZOO",
    "county": "KENT",
    "monitoring_end_date": "2026-06-30",
    "year": 2026,
    "lead_90th_ppb": 0,
    "above_action_level": false,
    "lines_replaced": null,
    "inventory_lead": null,
    "inventory_gpcl": null,
    "inventory_unknown": null,
    "total_to_identify_or_replace": null,
    "inventory_complete_flag": false
  }
];

export default mergedData;